webpackJsonp([0],{

/***/ "+CTv":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, no-var, prefer-rest-params, wrap-iife, no-use-before-define, no-underscore-dangle, no-param-reassign, prefer-template, quotes, comma-dangle, prefer-arrow-callback, consistent-return, one-var, one-var-declaration-per-line, no-else-return, max-len */

// LineHighlighter
//
// Handles single- and multi-line selection and highlight for blob views.
//
__webpack_require__("IqsO");

//
// ### Example Markup
//
//   <div id="blob-content-holder">
//     <div class="file-content">
//       <div class="line-numbers">
//         <a href="#L1" id="L1" data-line-number="1">1</a>
//         <a href="#L2" id="L2" data-line-number="2">2</a>
//         <a href="#L3" id="L3" data-line-number="3">3</a>
//         <a href="#L4" id="L4" data-line-number="4">4</a>
//         <a href="#L5" id="L5" data-line-number="5">5</a>
//       </div>
//       <pre class="code highlight">
//         <code>
//           <span id="LC1" class="line">...</span>
//           <span id="LC2" class="line">...</span>
//           <span id="LC3" class="line">...</span>
//           <span id="LC4" class="line">...</span>
//           <span id="LC5" class="line">...</span>
//         </code>
//       </pre>
//     </div>
//   </div>
//
(function () {
  var bind = function bind(fn, me) {
    return function () {
      return fn.apply(me, arguments);
    };
  };

  this.LineHighlighter = function () {
    // CSS class applied to highlighted lines
    LineHighlighter.prototype.highlightClass = 'hll';

    // Internal copy of location.hash so we're not dependent on `location` in tests
    LineHighlighter.prototype._hash = '';

    function LineHighlighter(hash) {
      var range;
      if (hash == null) {
        // Initialize a LineHighlighter object
        //
        // hash - String URL hash for dependency injection in tests
        hash = location.hash;
      }
      this.setHash = bind(this.setHash, this);
      this.highlightLine = bind(this.highlightLine, this);
      this.clickHandler = bind(this.clickHandler, this);
      this._hash = hash;
      this.bindEvents();
      if (hash !== '') {
        range = this.hashToRange(hash);
        if (range[0]) {
          this.highlightRange(range);
          $.scrollTo("#L" + range[0], {
            // Scroll to the first highlighted line on initial load
            // Offset -50 for the sticky top bar, and another -100 for some context
            offset: -150
          });
        }
      }
    }

    LineHighlighter.prototype.bindEvents = function () {
      $('#blob-content-holder').on('click', 'a[data-line-number]', this.clickHandler);
    };

    LineHighlighter.prototype.clickHandler = function (event) {
      var current, lineNumber, range;
      event.preventDefault();
      this.clearHighlight();
      lineNumber = $(event.target).closest('a').data('line-number');
      current = this.hashToRange(this._hash);
      if (!(current[0] && event.shiftKey)) {
        // If there's no current selection, or there is but Shift wasn't held,
        // treat this like a single-line selection.
        this.setHash(lineNumber);
        return this.highlightLine(lineNumber);
      } else if (event.shiftKey) {
        if (lineNumber < current[0]) {
          range = [lineNumber, current[0]];
        } else {
          range = [current[0], lineNumber];
        }
        this.setHash(range[0], range[1]);
        return this.highlightRange(range);
      }
    };

    LineHighlighter.prototype.clearHighlight = function () {
      return $("." + this.highlightClass).removeClass(this.highlightClass);
      // Unhighlight previously highlighted lines
    };

    // Convert a URL hash String into line numbers
    //
    // hash - Hash String
    //
    // Examples:
    //
    //   hashToRange('#L5')    # => [5, null]
    //   hashToRange('#L5-15') # => [5, 15]
    //   hashToRange('#foo')   # => [null, null]
    //
    // Returns an Array
    LineHighlighter.prototype.hashToRange = function (hash) {
      var first, last, matches;
      // ?L(\d+)(?:-(\d+))?$/)
      matches = hash.match(/^#?L(\d+)(?:-(\d+))?$/);
      if (matches && matches.length) {
        first = parseInt(matches[1], 10);
        last = matches[2] ? parseInt(matches[2], 10) : null;
        return [first, last];
      } else {
        return [null, null];
      }
    };

    // Highlight a single line
    //
    // lineNumber - Line number to highlight
    LineHighlighter.prototype.highlightLine = function (lineNumber) {
      return $("#LC" + lineNumber).addClass(this.highlightClass);
    };

    // Highlight all lines within a range
    //
    // range - Array containing the starting and ending line numbers
    LineHighlighter.prototype.highlightRange = function (range) {
      var i, lineNumber, ref, ref1, results;
      if (range[1]) {
        results = [];
        for (lineNumber = i = ref = range[0], ref1 = range[1]; ref <= ref1 ? i <= ref1 : i >= ref1; lineNumber = ref <= ref1 ? i += 1 : i -= 1) {
          results.push(this.highlightLine(lineNumber));
        }
        return results;
      } else {
        return this.highlightLine(range[0]);
      }
    };

    // Set the URL hash string
    LineHighlighter.prototype.setHash = function (firstLineNumber, lastLineNumber) {
      var hash;
      if (lastLineNumber) {
        hash = "#L" + firstLineNumber + "-" + lastLineNumber;
      } else {
        hash = "#L" + firstLineNumber;
      }
      this._hash = hash;
      return this.__setLocationHash__(hash);
    };

    // Make the actual hash change in the browser
    //
    // This method is stubbed in tests.
    LineHighlighter.prototype.__setLocationHash__ = function (value) {
      return history.pushState({
        url: value
        // We're using pushState instead of assigning location.hash directly to
        // prevent the page from scrolling on the hashchange event
      }, document.title, value);
    };

    return LineHighlighter;
  }();
}).call(window);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "+Y/g":
/***/ (function(module, exports) {

/* eslint-disable func-names, space-before-function-paren, wrap-iife, no-param-reassign, quotes, prefer-template, no-var, one-var, no-unused-vars, one-var-declaration-per-line, no-void, consistent-return, no-empty, max-len */

window.Autosave = function () {
  function Autosave(field, key) {
    this.field = field;
    if (key.join != null) {
      key = key.join("/");
    }
    this.key = "autosave/" + key;
    this.field.data("autosave", this);
    this.restore();
    this.field.on("input", function (_this) {
      return function () {
        return _this.save();
      };
    }(this));
  }

  Autosave.prototype.restore = function () {
    var e, text;
    if (window.localStorage == null) {
      return;
    }
    try {
      text = window.localStorage.getItem(this.key);
    } catch (error) {
      e = error;
      return;
    }
    if ((text != null ? text.length : void 0) > 0) {
      this.field.val(text);
    }
    return this.field.trigger("input");
  };

  Autosave.prototype.save = function () {
    var text;
    if (window.localStorage == null) {
      return;
    }
    text = this.field.val();
    if ((text != null ? text.length : void 0) > 0) {
      try {
        return window.localStorage.setItem(this.key, text);
      } catch (error) {}
    } else {
      return this.reset();
    }
  };

  Autosave.prototype.reset = function () {
    if (window.localStorage == null) {
      return;
    }
    try {
      return window.localStorage.removeItem(this.key);
    } catch (error) {}
  };

  return Autosave;
}();

/***/ }),

/***/ "+dQH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("2ub6");
/* eslint-disable */



var Keyboard = function Keyboard() {
  var currentKey;
  var currentFocus;
  var isUpArrow = false;
  var isDownArrow = false;
  var removeHighlight = function removeHighlight(list) {
    var itemElements = Array.prototype.slice.call(list.list.querySelectorAll('li:not(.divider)'), 0);
    var listItems = [];
    for (var i = 0; i < itemElements.length; i++) {
      var listItem = itemElements[i];
      listItem.classList.remove(__WEBPACK_IMPORTED_MODULE_0__constants__["b" /* ACTIVE_CLASS */]);

      if (listItem.style.display !== 'none') {
        listItems.push(listItem);
      }
    }
    return listItems;
  };

  var setMenuForArrows = function setMenuForArrows(list) {
    var listItems = removeHighlight(list);
    if (list.currentIndex > 0) {
      if (!listItems[list.currentIndex - 1]) {
        list.currentIndex = list.currentIndex - 1;
      }

      if (listItems[list.currentIndex - 1]) {
        var el = listItems[list.currentIndex - 1];
        var filterDropdownEl = el.closest('.filter-dropdown');
        el.classList.add(__WEBPACK_IMPORTED_MODULE_0__constants__["b" /* ACTIVE_CLASS */]);

        if (filterDropdownEl) {
          var filterDropdownBottom = filterDropdownEl.offsetHeight;
          var elOffsetTop = el.offsetTop - 30;

          if (elOffsetTop > filterDropdownBottom) {
            filterDropdownEl.scrollTop = elOffsetTop - filterDropdownBottom;
          }
        }
      }
    }
  };

  var mousedown = function mousedown(e) {
    var list = e.detail.hook.list;
    removeHighlight(list);
    list.show();
    list.currentIndex = 0;
    isUpArrow = false;
    isDownArrow = false;
  };
  var selectItem = function selectItem(list) {
    var listItems = removeHighlight(list);
    var currentItem = listItems[list.currentIndex - 1];
    var listEvent = new CustomEvent('click.dl', {
      detail: {
        list: list,
        selected: currentItem,
        data: currentItem.dataset
      }
    });
    list.list.dispatchEvent(listEvent);
    list.hide();
  };

  var keydown = function keydown(e) {
    var typedOn = e.target;
    var list = e.detail.hook.list;
    var currentIndex = list.currentIndex;
    isUpArrow = false;
    isDownArrow = false;

    if (e.detail.which) {
      currentKey = e.detail.which;
      if (currentKey === 13) {
        selectItem(e.detail.hook.list);
        return;
      }
      if (currentKey === 38) {
        isUpArrow = true;
      }
      if (currentKey === 40) {
        isDownArrow = true;
      }
    } else if (e.detail.key) {
      currentKey = e.detail.key;
      if (currentKey === 'Enter') {
        selectItem(e.detail.hook.list);
        return;
      }
      if (currentKey === 'ArrowUp') {
        isUpArrow = true;
      }
      if (currentKey === 'ArrowDown') {
        isDownArrow = true;
      }
    }
    if (isUpArrow) {
      currentIndex--;
    }
    if (isDownArrow) {
      currentIndex++;
    }
    if (currentIndex < 0) {
      currentIndex = 0;
    }
    list.currentIndex = currentIndex;
    setMenuForArrows(e.detail.hook.list);
  };

  document.addEventListener('mousedown.dl', mousedown);
  document.addEventListener('keydown.dl', keydown);
};

/* harmony default export */ __webpack_exports__["a"] = (Keyboard);

/***/ }),

/***/ "+n1k":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, wrap-iife, no-var, no-underscore-dangle, prefer-arrow-callback, max-len, one-var, one-var-declaration-per-line, no-unused-vars, object-shorthand, comma-dangle, no-else-return, no-self-compare, consistent-return, no-param-reassign, no-shadow */
/* global Issuable */
/* global ListMilestone */

(function () {
  this.MilestoneSelect = function () {
    function MilestoneSelect(currentProject, els) {
      var _this, $els;
      if (currentProject != null) {
        _this = this;
        this.currentProject = JSON.parse(currentProject);
      }

      $els = $(els);

      if (!els) {
        $els = $('.js-milestone-select');
      }

      $els.each(function (i, dropdown) {
        var $block, $dropdown, $loading, $selectbox, $sidebarCollapsedValue, $value, abilityName, collapsedSidebarLabelTemplate, defaultLabel, issuableId, issueUpdateURL, milestoneLinkNoneTemplate, milestoneLinkTemplate, milestonesUrl, projectId, selectedMilestone, showAny, showNo, showUpcoming, showStarted, useId, showMenuAbove;
        $dropdown = $(dropdown);
        projectId = $dropdown.data('project-id');
        milestonesUrl = $dropdown.data('milestones');
        issueUpdateURL = $dropdown.data('issueUpdate');
        selectedMilestone = $dropdown.data('selected');
        showNo = $dropdown.data('show-no');
        showAny = $dropdown.data('show-any');
        showMenuAbove = $dropdown.data('showMenuAbove');
        showUpcoming = $dropdown.data('show-upcoming');
        showStarted = $dropdown.data('show-started');
        useId = $dropdown.data('use-id');
        defaultLabel = $dropdown.data('default-label');
        issuableId = $dropdown.data('issuable-id');
        abilityName = $dropdown.data('ability-name');
        $selectbox = $dropdown.closest('.selectbox');
        $block = $selectbox.closest('.block');
        $sidebarCollapsedValue = $block.find('.sidebar-collapsed-icon');
        $value = $block.find('.value');
        $loading = $block.find('.block-loading').fadeOut();
        if (issueUpdateURL) {
          milestoneLinkTemplate = _.template('<a href="/<%- full_path %>/milestones/<%- iid %>" class="bold has-tooltip" data-container="body" title="<%- remaining %>"><%- title %></a>');
          milestoneLinkNoneTemplate = '<span class="no-value">None</span>';
          collapsedSidebarLabelTemplate = _.template('<span class="has-tooltip" data-container="body" title="<%- remaining %>" data-placement="left"> <%- title %> </span>');
        }
        return $dropdown.glDropdown({
          showMenuAbove: showMenuAbove,
          data: function data(term, callback) {
            return $.ajax({
              url: milestonesUrl
            }).done(function (data) {
              var extraOptions = [];
              if (showAny) {
                extraOptions.push({
                  id: 0,
                  name: '',
                  title: 'Any Milestone'
                });
              }
              if (showNo) {
                extraOptions.push({
                  id: -1,
                  name: 'No Milestone',
                  title: 'No Milestone'
                });
              }
              if (showUpcoming) {
                extraOptions.push({
                  id: -2,
                  name: '#upcoming',
                  title: 'Upcoming'
                });
              }
              if (showStarted) {
                extraOptions.push({
                  id: -3,
                  name: '#started',
                  title: 'Started'
                });
              }
              if (extraOptions.length) {
                extraOptions.push('divider');
              }

              callback(extraOptions.concat(data));
              if (showMenuAbove) {
                $dropdown.data('glDropdown').positionMenuAbove();
              }
            });
          },
          filterable: true,
          search: {
            fields: ['title']
          },
          selectable: true,
          toggleLabel: function toggleLabel(selected, el, e) {
            if (selected && 'id' in selected && $(el).hasClass('is-active')) {
              return selected.title;
            } else {
              return defaultLabel;
            }
          },
          defaultLabel: defaultLabel,
          fieldName: $dropdown.data('field-name'),
          text: function text(milestone) {
            return _.escape(milestone.title);
          },
          id: function id(milestone) {
            if (!useId && !$dropdown.is('.js-issuable-form-dropdown')) {
              return milestone.name;
            } else {
              return milestone.id;
            }
          },
          isSelected: function isSelected(milestone) {
            return milestone.name === selectedMilestone;
          },
          hidden: function hidden() {
            $selectbox.hide();
            // display:block overrides the hide-collapse rule
            return $value.css('display', '');
          },
          vue: $dropdown.hasClass('js-issue-board-sidebar'),
          clicked: function clicked(selected, $el, e) {
            var data, isIssueIndex, isMRIndex, page, boardsStore;
            page = $('body').data('page');
            isIssueIndex = page === 'projects:issues:index';
            isMRIndex = page === page && page === 'projects:merge_requests:index';
            if ($dropdown.hasClass('js-filter-bulk-update') || $dropdown.hasClass('js-issuable-form-dropdown')) {
              e.preventDefault();
              return;
            }

            if ($dropdown.closest('.add-issues-modal').length) {
              boardsStore = gl.issueBoards.ModalStore.store.filter;
            }

            if (boardsStore) {
              boardsStore[$dropdown.data('field-name')] = selected.name;
              e.preventDefault();
            } else if ($dropdown.hasClass('js-filter-submit') && (isIssueIndex || isMRIndex)) {
              if (selected.name != null) {
                selectedMilestone = selected.name;
              } else {
                selectedMilestone = '';
              }
              return Issuable.filterResults($dropdown.closest('form'));
            } else if ($dropdown.hasClass('js-filter-submit')) {
              return $dropdown.closest('form').submit();
            } else if ($dropdown.hasClass('js-issue-board-sidebar')) {
              if (selected.id !== -1) {
                gl.issueBoards.boardStoreIssueSet('milestone', new ListMilestone({
                  id: selected.id,
                  title: selected.name
                }));
              } else {
                gl.issueBoards.boardStoreIssueDelete('milestone');
              }

              $dropdown.trigger('loading.gl.dropdown');
              $loading.removeClass('hidden').fadeIn();

              gl.issueBoards.BoardsStore.detail.issue.update($dropdown.attr('data-issue-update')).then(function () {
                $dropdown.trigger('loaded.gl.dropdown');
                $loading.fadeOut();
              });
            } else {
              selected = $selectbox.find('input[type="hidden"]').val();
              data = {};
              data[abilityName] = {};
              data[abilityName].milestone_id = selected != null ? selected : null;
              $loading.removeClass('hidden').fadeIn();
              $dropdown.trigger('loading.gl.dropdown');
              return $.ajax({
                type: 'PUT',
                url: issueUpdateURL,
                data: data
              }).done(function (data) {
                $dropdown.trigger('loaded.gl.dropdown');
                $loading.fadeOut();
                $selectbox.hide();
                $value.css('display', '');
                if (data.milestone != null) {
                  data.milestone.full_path = _this.currentProject.full_path;
                  data.milestone.remaining = gl.utils.timeFor(data.milestone.due_date);
                  $value.html(milestoneLinkTemplate(data.milestone));
                  return $sidebarCollapsedValue.find('span').html(collapsedSidebarLabelTemplate(data.milestone));
                } else {
                  $value.html(milestoneLinkNoneTemplate);
                  return $sidebarCollapsedValue.find('span').text('No');
                }
              });
            }
          }
        });
      });
    }

    return MilestoneSelect;
  }();
}).call(window);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "+y4v":
/***/ (function(module, exports) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CreateBranchDropdown = function () {
  function CreateBranchDropdown(el, targetBranchDropdown) {
    _classCallCheck(this, CreateBranchDropdown);

    this.targetBranchDropdown = targetBranchDropdown;
    this.el = el;
    this.dropdownBack = this.el.closest('.dropdown').querySelector('.dropdown-menu-back');
    this.cancelButton = this.el.querySelector('.js-cancel-branch-btn');
    this.newBranchField = this.el.querySelector('#new_branch_name');
    this.newBranchCreateButton = this.el.querySelector('.js-new-branch-btn');

    this.newBranchCreateButton.setAttribute('disabled', '');

    this.addBindings();
    this.cleanupWrapper = this.cleanup.bind(this);
    document.addEventListener('beforeunload', this.cleanupWrapper);
  }

  _createClass(CreateBranchDropdown, [{
    key: 'cleanup',
    value: function cleanup() {
      this.cleanBindings();
      document.removeEventListener('beforeunload', this.cleanupWrapper);
    }
  }, {
    key: 'cleanBindings',
    value: function cleanBindings() {
      this.newBranchField.removeEventListener('keyup', this.enableBranchCreateButtonWrapper);
      this.newBranchField.removeEventListener('change', this.enableBranchCreateButtonWrapper);
      this.newBranchField.removeEventListener('keydown', this.handleNewBranchKeydownWrapper);
      this.dropdownBack.removeEventListener('click', this.resetFormWrapper);
      this.cancelButton.removeEventListener('click', this.handleCancelClickWrapper);
      this.newBranchCreateButton.removeEventListener('click', this.createBranchWrapper);
    }
  }, {
    key: 'addBindings',
    value: function addBindings() {
      this.enableBranchCreateButtonWrapper = this.enableBranchCreateButton.bind(this);
      this.handleNewBranchKeydownWrapper = this.handleNewBranchKeydown.bind(this);
      this.resetFormWrapper = this.resetForm.bind(this);
      this.handleCancelClickWrapper = this.handleCancelClick.bind(this);
      this.createBranchWrapper = this.createBranch.bind(this);

      this.newBranchField.addEventListener('keyup', this.enableBranchCreateButtonWrapper);
      this.newBranchField.addEventListener('change', this.enableBranchCreateButtonWrapper);
      this.newBranchField.addEventListener('keydown', this.handleNewBranchKeydownWrapper);
      this.dropdownBack.addEventListener('click', this.resetFormWrapper);
      this.cancelButton.addEventListener('click', this.handleCancelClickWrapper);
      this.newBranchCreateButton.addEventListener('click', this.createBranchWrapper);
    }
  }, {
    key: 'handleCancelClick',
    value: function handleCancelClick(e) {
      e.preventDefault();
      e.stopPropagation();

      this.resetForm();
      this.dropdownBack.click();
    }
  }, {
    key: 'handleNewBranchKeydown',
    value: function handleNewBranchKeydown(e) {
      var keyCode = e.which;
      var ENTER_KEYCODE = 13;
      if (keyCode === ENTER_KEYCODE) {
        this.createBranch(e);
      }
    }
  }, {
    key: 'enableBranchCreateButton',
    value: function enableBranchCreateButton() {
      if (this.newBranchField.value !== '') {
        this.newBranchCreateButton.removeAttribute('disabled');
      } else {
        this.newBranchCreateButton.setAttribute('disabled', '');
      }
    }
  }, {
    key: 'resetForm',
    value: function resetForm() {
      this.newBranchField.value = '';
      this.enableBranchCreateButtonWrapper();
    }
  }, {
    key: 'createBranch',
    value: function createBranch(e) {
      e.preventDefault();

      if (this.newBranchCreateButton.getAttribute('disabled') === '') {
        return;
      }
      var newBranchName = this.newBranchField.value;
      this.targetBranchDropdown.setNewBranch(newBranchName);
      this.resetForm();
    }
  }]);

  return CreateBranchDropdown;
}();

window.gl = window.gl || {};
gl.CreateBranchDropdown = CreateBranchDropdown;

/***/ }),

/***/ "/3Gu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shortcuts_dashboard_navigation__ = __webpack_require__("vckv");
/* eslint-disable func-names, space-before-function-paren, max-len, no-var, one-var, no-restricted-syntax, vars-on-top, no-use-before-define, no-param-reassign, new-cap, no-underscore-dangle, wrap-iife, prefer-arrow-callback, consistent-return, no-return-assign */
/* global Mousetrap */
/* global Shortcuts */


__webpack_require__("Sl/F");

(function () {
  var extend = function extend(child, parent) {
    for (var key in parent) {
      if (hasProp.call(parent, key)) child[key] = parent[key];
    }function ctor() {
      this.constructor = child;
    }ctor.prototype = parent.prototype;child.prototype = new ctor();child.__super__ = parent.prototype;return child;
  },
      hasProp = {}.hasOwnProperty;

  this.ShortcutsNavigation = function (superClass) {
    extend(ShortcutsNavigation, superClass);

    function ShortcutsNavigation() {
      ShortcutsNavigation.__super__.constructor.call(this);
      Mousetrap.bind('g p', function () {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-project');
      });
      Mousetrap.bind('g e', function () {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-project-activity');
      });
      Mousetrap.bind('g f', function () {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-tree');
      });
      Mousetrap.bind('g c', function () {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-commits');
      });
      Mousetrap.bind('g j', function () {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-builds');
      });
      Mousetrap.bind('g n', function () {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-network');
      });
      Mousetrap.bind('g d', function () {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-repository-charts');
      });
      Mousetrap.bind('g i', function () {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-issues');
      });
      Mousetrap.bind('g b', function () {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-issue-boards');
      });
      Mousetrap.bind('g m', function () {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-merge_requests');
      });
      Mousetrap.bind('g t', function () {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-todos');
      });
      Mousetrap.bind('g w', function () {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-wiki');
      });
      Mousetrap.bind('g s', function () {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-snippets');
      });
      Mousetrap.bind('i', function () {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-new-issue');
      });
      this.enabledHelp.push('.hidden-shortcut.project');
    }

    return ShortcutsNavigation;
  }(Shortcuts);
}).call(window);

/***/ }),

/***/ "/YCK":
/***/ (function(module, exports, __webpack_require__) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* global Mousetrap */
/* global Shortcuts */

__webpack_require__("Sl/F");

var defaults = {
  skipResetBindings: false,
  fileBlobPermalinkUrl: null
};

var ShortcutsBlob = function (_Shortcuts) {
  _inherits(ShortcutsBlob, _Shortcuts);

  function ShortcutsBlob(opts) {
    _classCallCheck(this, ShortcutsBlob);

    var options = Object.assign({}, defaults, opts);

    var _this = _possibleConstructorReturn(this, (ShortcutsBlob.__proto__ || Object.getPrototypeOf(ShortcutsBlob)).call(this, options.skipResetBindings));

    _this.options = options;

    Mousetrap.bind('y', _this.moveToFilePermalink.bind(_this));
    return _this;
  }

  _createClass(ShortcutsBlob, [{
    key: 'moveToFilePermalink',
    value: function moveToFilePermalink() {
      if (this.options.fileBlobPermalinkUrl) {
        var hash = gl.utils.getLocationHash();
        var hashUrlString = hash ? '#' + hash : '';
        gl.utils.visitUrl('' + this.options.fileBlobPermalinkUrl + hashUrlString);
      }
    }
  }]);

  return ShortcutsBlob;
}(Shortcuts);

module.exports = ShortcutsBlob;

/***/ }),

/***/ "0/gX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emojis_digests_json__ = __webpack_require__("fA9n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emojis_digests_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_emojis_digests_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_emojis_aliases_json__ = __webpack_require__("owyH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_emojis_aliases_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_emojis_aliases_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__behaviors_gl_emoji__ = __webpack_require__("fSxH");
/* eslint-disable func-names, space-before-function-paren, no-template-curly-in-string, comma-dangle, object-shorthand, quotes, dot-notation, no-else-return, one-var, no-var, no-underscore-dangle, one-var-declaration-per-line, no-param-reassign, no-useless-escape, prefer-template, consistent-return, wrap-iife, prefer-arrow-callback, camelcase, no-unused-vars, no-useless-return, vars-on-top, max-len */





// Creates the variables for setting up GFM auto-completion
window.gl = window.gl || {};

function sanitize(str) {
  return str.replace(/<(?:.|\n)*?>/gm, '');
}

window.gl.GfmAutoComplete = {
  dataSources: {},
  defaultLoadingData: ['loading'],
  cachedData: {},
  isLoadingData: {},
  atTypeMap: {
    ':': 'emojis',
    '@': 'members',
    '#': 'issues',
    '!': 'mergeRequests',
    '~': 'labels',
    '%': 'milestones',
    '/': 'commands'
  },
  // Emoji
  Emoji: {
    templateFunction: function templateFunction(name) {
      return '<li>\n        ' + name + ' ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__behaviors_gl_emoji__["a" /* glEmojiTag */])(name) + '\n      </li>\n      ';
    }
  },
  // Team Members
  Members: {
    template: '<li>${avatarTag} ${username} <small>${title}</small></li>'
  },
  Labels: {
    template: '<li><span class="dropdown-label-box" style="background: ${color}"></span> ${title}</li>'
  },
  // Issues and MergeRequests
  Issues: {
    template: '<li><small>${id}</small> ${title}</li>'
  },
  // Milestones
  Milestones: {
    template: '<li>${title}</li>'
  },
  Loading: {
    template: '<li style="pointer-events: none;"><i class="fa fa-refresh fa-spin"></i> Loading...</li>'
  },
  DefaultOptions: {
    sorter: function sorter(query, items, searchKey) {
      this.setting.highlightFirst = this.setting.alwaysHighlightFirst || query.length > 0;
      if (gl.GfmAutoComplete.isLoading(items)) {
        this.setting.highlightFirst = false;
        return items;
      }
      return $.fn.atwho["default"].callbacks.sorter(query, items, searchKey);
    },
    filter: function filter(query, data, searchKey) {
      if (gl.GfmAutoComplete.isLoading(data)) {
        gl.GfmAutoComplete.fetchData(this.$inputor, this.at);
        return data;
      } else {
        return $.fn.atwho["default"].callbacks.filter(query, data, searchKey);
      }
    },
    beforeInsert: function beforeInsert(value) {
      if (value && !this.setting.skipSpecialCharacterTest) {
        var withoutAt = value.substring(1);
        if (withoutAt && /[^\w\d]/.test(withoutAt)) value = value.charAt() + '"' + withoutAt + '"';
      }
      return value;
    },
    matcher: function matcher(flag, subtext) {
      // The below is taken from At.js source
      // Tweaked to commands to start without a space only if char before is a non-word character
      // https://github.com/ichord/At.js
      var _a, _y, regexp, match, atSymbolsWithBar, atSymbolsWithoutBar;
      atSymbolsWithBar = Object.keys(this.app.controllers).join('|');
      atSymbolsWithoutBar = Object.keys(this.app.controllers).join('');
      subtext = subtext.split(/\s+/g).pop();
      flag = flag.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");

      _a = decodeURI("%C3%80");
      _y = decodeURI("%C3%BF");

      regexp = new RegExp("^(?:\\B|[^a-zA-Z0-9_" + atSymbolsWithoutBar + "]|\\s)" + flag + "(?!" + atSymbolsWithBar + ")((?:[A-Za-z" + _a + "-" + _y + "0-9_\'\.\+\-]|[^\\x00-\\x7a])*)$", 'gi');

      match = regexp.exec(subtext);

      if (match) {
        return match[1];
      } else {
        return null;
      }
    }
  },
  setup: function setup(input) {
    // Add GFM auto-completion to all input fields, that accept GFM input.
    this.input = input || $('.js-gfm-input');
    this.setupLifecycle();
  },
  setupLifecycle: function setupLifecycle() {
    var _this = this;

    this.input.each(function (i, input) {
      var $input = $(input);
      $input.off('focus.setupAtWho').on('focus.setupAtWho', _this.setupAtWho.bind(_this, $input));
      // This triggers at.js again
      // Needed for slash commands with suffixes (ex: /label ~)
      $input.on('inserted-commands.atwho', $input.trigger.bind($input, 'keyup'));
    });
  },

  setupAtWho: function setupAtWho($input) {
    // Emoji
    $input.atwho({
      at: ':',
      displayTpl: function (value) {
        return value && value.name ? this.Emoji.templateFunction(value.name) : this.Loading.template;
      }.bind(this),
      insertTpl: ':${name}:',
      skipSpecialCharacterTest: true,
      data: this.defaultLoadingData,
      callbacks: {
        sorter: this.DefaultOptions.sorter,
        beforeInsert: this.DefaultOptions.beforeInsert,
        filter: this.DefaultOptions.filter
      }
    });
    // Team Members
    $input.atwho({
      at: '@',
      displayTpl: function (value) {
        return value.username != null ? this.Members.template : this.Loading.template;
      }.bind(this),
      insertTpl: '${atwho-at}${username}',
      searchKey: 'search',
      alwaysHighlightFirst: true,
      skipSpecialCharacterTest: true,
      data: this.defaultLoadingData,
      callbacks: {
        sorter: this.DefaultOptions.sorter,
        filter: this.DefaultOptions.filter,
        beforeInsert: this.DefaultOptions.beforeInsert,
        matcher: this.DefaultOptions.matcher,
        beforeSave: function beforeSave(members) {
          return $.map(members, function (m) {
            var title = '';
            if (m.username == null) {
              return m;
            }
            title = m.name;
            if (m.count) {
              title += " (" + m.count + ")";
            }

            var autoCompleteAvatar = m.avatar_url || m.username.charAt(0).toUpperCase();
            var imgAvatar = '<img src="' + m.avatar_url + '" alt="' + m.username + '" class="avatar avatar-inline center s26"/>';
            var txtAvatar = '<div class="avatar center avatar-inline s26">' + autoCompleteAvatar + '</div>';

            return {
              username: m.username,
              avatarTag: autoCompleteAvatar.length === 1 ? txtAvatar : imgAvatar,
              title: sanitize(title),
              search: sanitize(m.username + " " + m.name)
            };
          });
        }
      }
    });
    $input.atwho({
      at: '#',
      alias: 'issues',
      searchKey: 'search',
      displayTpl: function (value) {
        return value.title != null ? this.Issues.template : this.Loading.template;
      }.bind(this),
      data: this.defaultLoadingData,
      insertTpl: '${atwho-at}${id}',
      callbacks: {
        sorter: this.DefaultOptions.sorter,
        filter: this.DefaultOptions.filter,
        beforeInsert: this.DefaultOptions.beforeInsert,
        matcher: this.DefaultOptions.matcher,
        beforeSave: function beforeSave(issues) {
          return $.map(issues, function (i) {
            if (i.title == null) {
              return i;
            }
            return {
              id: i.iid,
              title: sanitize(i.title),
              search: i.iid + " " + i.title
            };
          });
        }
      }
    });
    $input.atwho({
      at: '%',
      alias: 'milestones',
      searchKey: 'search',
      insertTpl: '${atwho-at}${title}',
      displayTpl: function (value) {
        return value.title != null ? this.Milestones.template : this.Loading.template;
      }.bind(this),
      data: this.defaultLoadingData,
      callbacks: {
        matcher: this.DefaultOptions.matcher,
        sorter: this.DefaultOptions.sorter,
        beforeInsert: this.DefaultOptions.beforeInsert,
        filter: this.DefaultOptions.filter,
        beforeSave: function beforeSave(milestones) {
          return $.map(milestones, function (m) {
            if (m.title == null) {
              return m;
            }
            return {
              id: m.iid,
              title: sanitize(m.title),
              search: "" + m.title
            };
          });
        }
      }
    });
    $input.atwho({
      at: '!',
      alias: 'mergerequests',
      searchKey: 'search',
      displayTpl: function (value) {
        return value.title != null ? this.Issues.template : this.Loading.template;
      }.bind(this),
      data: this.defaultLoadingData,
      insertTpl: '${atwho-at}${id}',
      callbacks: {
        sorter: this.DefaultOptions.sorter,
        filter: this.DefaultOptions.filter,
        beforeInsert: this.DefaultOptions.beforeInsert,
        matcher: this.DefaultOptions.matcher,
        beforeSave: function beforeSave(merges) {
          return $.map(merges, function (m) {
            if (m.title == null) {
              return m;
            }
            return {
              id: m.iid,
              title: sanitize(m.title),
              search: m.iid + " " + m.title
            };
          });
        }
      }
    });
    $input.atwho({
      at: '~',
      alias: 'labels',
      searchKey: 'search',
      data: this.defaultLoadingData,
      displayTpl: function (value) {
        return this.isLoading(value) ? this.Loading.template : this.Labels.template;
      }.bind(this),
      insertTpl: '${atwho-at}${title}',
      callbacks: {
        matcher: this.DefaultOptions.matcher,
        beforeInsert: this.DefaultOptions.beforeInsert,
        filter: this.DefaultOptions.filter,
        sorter: this.DefaultOptions.sorter,
        beforeSave: function beforeSave(merges) {
          if (gl.GfmAutoComplete.isLoading(merges)) return merges;
          var sanitizeLabelTitle;
          sanitizeLabelTitle = function sanitizeLabelTitle(title) {
            if (/[\w\?&]+\s+[\w\?&]+/g.test(title)) {
              return "\"" + sanitize(title) + "\"";
            } else {
              return sanitize(title);
            }
          };
          return $.map(merges, function (m) {
            return {
              title: sanitize(m.title),
              color: m.color,
              search: "" + m.title
            };
          });
        }
      }
    });
    // We don't instantiate the slash commands autocomplete for note and issue/MR edit forms
    $input.filter('[data-supports-slash-commands="true"]').atwho({
      at: '/',
      alias: 'commands',
      searchKey: 'search',
      skipSpecialCharacterTest: true,
      data: this.defaultLoadingData,
      displayTpl: function (value) {
        if (this.isLoading(value)) return this.Loading.template;
        var tpl = '<li>/${name}';
        if (value.aliases.length > 0) {
          tpl += ' <small>(or /<%- aliases.join(", /") %>)</small>';
        }
        if (value.params.length > 0) {
          tpl += ' <small><%- params.join(" ") %></small>';
        }
        if (value.description !== '') {
          tpl += '<small class="description"><i><%- description %></i></small>';
        }
        tpl += '</li>';
        return _.template(tpl)(value);
      }.bind(this),
      insertTpl: function insertTpl(value) {
        var tpl = "/${name} ";
        var reference_prefix = null;
        if (value.params.length > 0) {
          reference_prefix = value.params[0][0];
          if (/^[@%~]/.test(reference_prefix)) {
            tpl += '<%- reference_prefix %>';
          }
        }
        return _.template(tpl)({ reference_prefix: reference_prefix });
      },
      suffix: '',
      callbacks: {
        sorter: this.DefaultOptions.sorter,
        filter: this.DefaultOptions.filter,
        beforeInsert: this.DefaultOptions.beforeInsert,
        beforeSave: function beforeSave(commands) {
          if (gl.GfmAutoComplete.isLoading(commands)) return commands;
          return $.map(commands, function (c) {
            var search = c.name;
            if (c.aliases.length > 0) {
              search = search + " " + c.aliases.join(" ");
            }
            return {
              name: c.name,
              aliases: c.aliases,
              params: c.params,
              description: c.description,
              search: search
            };
          });
        },
        matcher: function matcher(flag, subtext, should_startWithSpace, acceptSpaceBar) {
          var regexp = /(?:^|\n)\/([A-Za-z_]*)$/gi;
          var match = regexp.exec(subtext);
          if (match) {
            return match[1];
          } else {
            return null;
          }
        }
      }
    });
    return;
  },
  fetchData: function fetchData($input, at) {
    var _this2 = this;

    if (this.isLoadingData[at]) return;
    this.isLoadingData[at] = true;
    if (this.cachedData[at]) {
      this.loadData($input, at, this.cachedData[at]);
    } else if (this.atTypeMap[at] === 'emojis') {
      this.loadData($input, at, Object.keys(__WEBPACK_IMPORTED_MODULE_0_emojis_digests_json___default.a).concat(Object.keys(__WEBPACK_IMPORTED_MODULE_1_emojis_aliases_json___default.a)));
    } else {
      $.getJSON(this.dataSources[this.atTypeMap[at]], function (data) {
        _this2.loadData($input, at, data);
      }).fail(function () {
        _this2.isLoadingData[at] = false;
      });
    }
  },
  loadData: function loadData($input, at, data) {
    this.isLoadingData[at] = false;
    this.cachedData[at] = data;
    $input.atwho('load', at, data);
    // This trigger at.js again
    // otherwise we would be stuck with loading until the user types
    return $input.trigger('keyup');
  },
  isLoading: function isLoading(data) {
    var dataToInspect = data;
    if (data && data.length > 0) {
      dataToInspect = data[0];
    }

    var loadingState = this.defaultLoadingData[0];
    return dataToInspect && (dataToInspect === loadingState || dataToInspect.name === loadingState);
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("lwLq")))

/***/ }),

/***/ "0esH":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, wrap-iife, no-new */
/* global ImageFile */

(function () {
  this.CommitFile = function () {
    function CommitFile(file) {
      if ($('.image', file).length) {
        new gl.ImageFile(file);
      }
    }

    return CommitFile;
  }();
}).call(window);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "18ib":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ProtectedTagDropdown = function () {
  /**
   * @param {Object} options containing
   *                         `$dropdown` target element
   *                          `onSelect` event callback
   * $dropdown must be an element created using `dropdown_tag()` rails helper
   */
  function ProtectedTagDropdown(options) {
    _classCallCheck(this, ProtectedTagDropdown);

    this.onSelect = options.onSelect;
    this.$dropdown = options.$dropdown;
    this.$dropdownContainer = this.$dropdown.parent();
    this.$dropdownFooter = this.$dropdownContainer.find('.dropdown-footer');
    this.$protectedTag = this.$dropdownContainer.find('.create-new-protected-tag');

    this.buildDropdown();
    this.bindEvents();

    // Hide footer
    this.toggleFooter(true);
  }

  _createClass(ProtectedTagDropdown, [{
    key: 'buildDropdown',
    value: function buildDropdown() {
      var _this = this;

      this.$dropdown.glDropdown({
        data: this.getProtectedTags.bind(this),
        filterable: true,
        remote: false,
        search: {
          fields: ['title']
        },
        selectable: true,
        toggleLabel: function toggleLabel(selected) {
          return selected && 'id' in selected ? selected.title : 'Protected Tag';
        },

        fieldName: 'protected_tag[name]',
        text: function text(protectedTag) {
          return _.escape(protectedTag.title);
        },
        id: function id(protectedTag) {
          return _.escape(protectedTag.id);
        },

        onFilter: this.toggleCreateNewButton.bind(this),
        clicked: function clicked(item, $el, e) {
          e.preventDefault();
          _this.onSelect();
        }
      });
    }
  }, {
    key: 'bindEvents',
    value: function bindEvents() {
      this.$protectedTag.on('click', this.onClickCreateWildcard.bind(this));
    }
  }, {
    key: 'onClickCreateWildcard',
    value: function onClickCreateWildcard(e) {
      this.$dropdown.data('glDropdown').remote.execute();
      this.$dropdown.data('glDropdown').selectRowAtIndex();
      e.preventDefault();
    }
  }, {
    key: 'getProtectedTags',
    value: function getProtectedTags(term, callback) {
      if (this.selectedTag) {
        callback(gon.open_tags.concat(this.selectedTag));
      } else {
        callback(gon.open_tags);
      }
    }
  }, {
    key: 'toggleCreateNewButton',
    value: function toggleCreateNewButton(tagName) {
      if (tagName) {
        this.selectedTag = {
          title: tagName,
          id: tagName,
          text: tagName
        };

        this.$dropdownContainer.find('.create-new-protected-tag code').text(tagName);
      }

      this.toggleFooter(!tagName);
    }
  }, {
    key: 'toggleFooter',
    value: function toggleFooter(toggleState) {
      this.$dropdownFooter.toggleClass('hidden', toggleState);
    }
  }]);

  return ProtectedTagDropdown;
}();

/* harmony default export */ __webpack_exports__["a"] = (ProtectedTagDropdown);

/***/ }),

/***/ "1uaA":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {// The MIT License (MIT)
//
// Copyright (c) 2014 GitHub, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.
// TaskList Behavior
//
/*= provides tasklist:enabled */
/*= provides tasklist:disabled */
/*= provides tasklist:change */
/*= provides tasklist:changed */
//
//
// Enables Task List update behavior.
//
// ### Example Markup
//
//   <div class="js-task-list-container">
//     <ul class="task-list">
//       <li class="task-list-item">
//         <input type="checkbox" class="js-task-list-item-checkbox" disabled />
//         text
//       </li>
//     </ul>
//     <form>
//       <textarea class="js-task-list-field">- [ ] text</textarea>
//     </form>
//   </div>
//
// ### Specification
//
// TaskLists MUST be contained in a `(div).js-task-list-container`.
//
// TaskList Items SHOULD be an a list (`UL`/`OL`) element.
//
// Task list items MUST match `(input).task-list-item-checkbox` and MUST be
// `disabled` by default.
//
// TaskLists MUST have a `(textarea).js-task-list-field` form element whose
// `value` attribute is the source (Markdown) to be udpated. The source MUST
// follow the syntax guidelines.
//
// TaskList updates trigger `tasklist:change` events. If the change is
// successful, `tasklist:changed` is fired. The change can be canceled.
//
// jQuery is required.
//
// ### Methods
//
// `.taskList('enable')` or `.taskList()`
//
// Enables TaskList updates for the container.
//
// `.taskList('disable')`
//
// Disables TaskList updates for the container.
//
//# ### Events
//
// `tasklist:enabled`
//
// Fired when the TaskList is enabled.
//
// * **Synchronicity** Sync
// * **Bubbles** Yes
// * **Cancelable** No
// * **Target** `.js-task-list-container`
//
// `tasklist:disabled`
//
// Fired when the TaskList is disabled.
//
// * **Synchronicity** Sync
// * **Bubbles** Yes
// * **Cancelable** No
// * **Target** `.js-task-list-container`
//
// `tasklist:change`
//
// Fired before the TaskList item change takes affect.
//
// * **Synchronicity** Sync
// * **Bubbles** Yes
// * **Cancelable** Yes
// * **Target** `.js-task-list-field`
//
// `tasklist:changed`
//
// Fired once the TaskList item change has taken affect.
//
// * **Synchronicity** Sync
// * **Bubbles** Yes
// * **Cancelable** No
// * **Target** `.js-task-list-field`
//
// ### NOTE
//
// Task list checkboxes are rendered as disabled by default because rendered
// user content is cached without regard for the viewer.
(function() {
  var codeFencesPattern, complete, completePattern, disableTaskList, disableTaskLists, enableTaskList, enableTaskLists, escapePattern, incomplete, incompletePattern, itemPattern, itemsInParasPattern, updateTaskList, updateTaskListItem,
    indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

  incomplete = "[ ]";

  complete = "[x]";

  // Escapes the String for regular expression matching.
  escapePattern = function(str) {
    return str.replace(/([\[\]])/g, "\\$1").replace(/\s/, "\\s").replace("x", "[xX]");
  };

  incompletePattern = RegExp("" + (escapePattern(incomplete))); // escape square brackets
 // match all white space
  completePattern = RegExp("" + (escapePattern(complete))); // match all cases

  // Pattern used to identify all task list items.
  // Useful when you need iterate over all items.
  itemPattern = RegExp("^(?:\\s*(?:>\\s*)*(?:[-+*]|(?:\\d+\\.)))\\s*(" + (escapePattern(complete)) + "|" + (escapePattern(incomplete)) + ")\\s+(?!\\(.*?\\))(?=(?:\\[.*?\\]\\s*(?:\\[.*?\\]|\\(.*?\\))\\s*)*(?:[^\\[]|$))");

  // prefix, consisting of
  // optional leading whitespace
  // zero or more blockquotes
  // list item indicator
  // optional whitespace prefix
  // checkbox
  // is followed by whitespace
  // is not part of a [foo](url) link
  // and is followed by zero or more links
  // and either a non-link or the end of the string
  // Used to filter out code fences from the source for comparison only.
  // http://rubular.com/r/x5EwZVrloI
  // Modified slightly due to issues with JS
  codeFencesPattern = /^`{3}(?:\s*\w+)?[\S\s].*[\S\s]^`{3}$/mg;

  // ```
  // followed by optional language
  // whitespace
  // code
  // whitespace
  // ```
  // Used to filter out potential mismatches (items not in lists).
  // http://rubular.com/r/OInl6CiePy
  itemsInParasPattern = RegExp("^(" + (escapePattern(complete)) + "|" + (escapePattern(incomplete)) + ").+$", "g");

  // Given the source text, updates the appropriate task list item to match the
  // given checked value.
  //
  // Returns the updated String text.
  updateTaskListItem = function(source, itemIndex, checked) {
    var clean, index, line, result;
    clean = source.replace(/\r/g, '').replace(codeFencesPattern, '').replace(itemsInParasPattern, '').split("\n");
    index = 0;
    result = (function() {
      var i, len, ref, results;
      ref = source.split("\n");
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        line = ref[i];
        if (indexOf.call(clean, line) >= 0 && line.match(itemPattern)) {
          index += 1;
          if (index === itemIndex) {
            line = checked ? line.replace(incompletePattern, complete) : line.replace(completePattern, incomplete);
          }
        }
        results.push(line);
      }
      return results;
    })();
    return result.join("\n");
  };

  // Updates the $field value to reflect the state of $item.
  // Triggers the `tasklist:change` event before the value has changed, and fires
  // a `tasklist:changed` event once the value has changed.
  updateTaskList = function($item) {
    var $container, $field, checked, event, index;
    $container = $item.closest('.js-task-list-container');
    $field = $container.find('.js-task-list-field');
    index = 1 + $container.find('.task-list-item-checkbox').index($item);
    checked = $item.prop('checked');
    event = $.Event('tasklist:change');
    $field.trigger(event, [index, checked]);
    if (!event.isDefaultPrevented()) {
      $field.val(updateTaskListItem($field.val(), index, checked));
      $field.trigger('change');
      return $field.trigger('tasklist:changed', [index, checked]);
    }
  };

  // When the task list item checkbox is updated, submit the change
  $(document).on('change', '.task-list-item-checkbox', function() {
    return updateTaskList($(this));
  });

  // Enables TaskList item changes.
  enableTaskList = function($container) {
    if ($container.find('.js-task-list-field').length > 0) {
      $container.find('.task-list-item').addClass('enabled').find('.task-list-item-checkbox').attr('disabled', null);
      return $container.addClass('is-task-list-enabled').trigger('tasklist:enabled');
    }
  };

  // Enables a collection of TaskList containers.
  enableTaskLists = function($containers) {
    var container, i, len, results;
    results = [];
    for (i = 0, len = $containers.length; i < len; i++) {
      container = $containers[i];
      results.push(enableTaskList($(container)));
    }
    return results;
  };

  // Disable TaskList item changes.
  disableTaskList = function($container) {
    $container.find('.task-list-item').removeClass('enabled').find('.task-list-item-checkbox').attr('disabled', 'disabled');
    return $container.removeClass('is-task-list-enabled').trigger('tasklist:disabled');
  };

  // Disables a collection of TaskList containers.
  disableTaskLists = function($containers) {
    var container, i, len, results;
    results = [];
    for (i = 0, len = $containers.length; i < len; i++) {
      container = $containers[i];
      results.push(disableTaskList($(container)));
    }
    return results;
  };

  $.fn.taskList = function(method) {
    var $container, methods;
    $container = $(this).closest('.js-task-list-container');
    methods = {
      enable: enableTaskLists,
      disable: disableTaskLists
    };
    return methods[method || 'enable']($container);
  };

}).call(this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "25vu":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, no-var, object-shorthand, comma-dangle, prefer-arrow-callback */

// MarkdownPreview
//
// Handles toggling the "Write" and "Preview" tab clicks, rendering the preview,
// and showing a warning when more than `x` users are referenced.
//
(function () {
  var lastTextareaPreviewed;
  var lastTextareaHeight = null;
  var markdownPreview;
  var previewButtonSelector;
  var writeButtonSelector;

  window.MarkdownPreview = function () {
    function MarkdownPreview() {}

    // Minimum number of users referenced before triggering a warning
    MarkdownPreview.prototype.referenceThreshold = 10;

    MarkdownPreview.prototype.ajaxCache = {};

    MarkdownPreview.prototype.showPreview = function ($form) {
      var mdText;
      var preview = $form.find('.js-md-preview');
      if (preview.hasClass('md-preview-loading')) {
        return;
      }
      mdText = $form.find('textarea.markdown-area').val();

      if (mdText.trim().length === 0) {
        preview.text('Nothing to preview.');
        this.hideReferencedUsers($form);
      } else {
        preview.addClass('md-preview-loading').text('Loading...');
        this.fetchMarkdownPreview(mdText, function (response) {
          preview.removeClass('md-preview-loading').html(response.body);
          preview.renderGFM();
          this.renderReferencedUsers(response.references.users, $form);
        }.bind(this));
      }
    };

    MarkdownPreview.prototype.fetchMarkdownPreview = function (text, success) {
      if (!window.preview_markdown_path) {
        return;
      }
      if (text === this.ajaxCache.text) {
        success(this.ajaxCache.response);
        return;
      }
      $.ajax({
        type: 'POST',
        url: window.preview_markdown_path,
        data: {
          text: text
        },
        dataType: 'json',
        success: function (response) {
          this.ajaxCache = {
            text: text,
            response: response
          };
          success(response);
        }.bind(this)
      });
    };

    MarkdownPreview.prototype.hideReferencedUsers = function ($form) {
      $form.find('.referenced-users').hide();
    };

    MarkdownPreview.prototype.renderReferencedUsers = function (users, $form) {
      var referencedUsers;
      referencedUsers = $form.find('.referenced-users');
      if (referencedUsers.length) {
        if (users.length >= this.referenceThreshold) {
          referencedUsers.show();
          referencedUsers.find('.js-referenced-users-count').text(users.length);
        } else {
          referencedUsers.hide();
        }
      }
    };

    return MarkdownPreview;
  }();

  markdownPreview = new window.MarkdownPreview();

  previewButtonSelector = '.js-md-preview-button';

  writeButtonSelector = '.js-md-write-button';

  lastTextareaPreviewed = null;

  $.fn.setupMarkdownPreview = function () {
    var $form = $(this);
    $form.find('textarea.markdown-area').on('input', function () {
      markdownPreview.hideReferencedUsers($form);
    });
  };

  $(document).on('markdown-preview:show', function (e, $form) {
    if (!$form) {
      return;
    }

    lastTextareaPreviewed = $form.find('textarea.markdown-area');
    lastTextareaHeight = lastTextareaPreviewed.height();

    // toggle tabs
    $form.find(writeButtonSelector).parent().removeClass('active');
    $form.find(previewButtonSelector).parent().addClass('active');

    // toggle content
    $form.find('.md-write-holder').hide();
    $form.find('.md-preview-holder').show();
    markdownPreview.showPreview($form);
  });

  $(document).on('markdown-preview:hide', function (e, $form) {
    if (!$form) {
      return;
    }
    lastTextareaPreviewed = null;

    if (lastTextareaHeight) {
      $form.find('textarea.markdown-area').height(lastTextareaHeight);
    }

    // toggle tabs
    $form.find(writeButtonSelector).parent().addClass('active');
    $form.find(previewButtonSelector).parent().removeClass('active');

    // toggle content
    $form.find('.md-write-holder').show();
    $form.find('textarea.markdown-area').focus();
    $form.find('.md-preview-holder').hide();
  });

  $(document).on('markdown-preview:toggle', function (e, keyboardEvent) {
    var $target;
    $target = $(keyboardEvent.target);
    if ($target.is('textarea.markdown-area')) {
      $(document).triggerHandler('markdown-preview:show', [$target.closest('form')]);
      keyboardEvent.preventDefault();
    } else if (lastTextareaPreviewed) {
      $target = lastTextareaPreviewed;
      $(document).triggerHandler('markdown-preview:hide', [$target.closest('form')]);
      keyboardEvent.preventDefault();
    }
  });

  $(document).on('click', previewButtonSelector, function (e) {
    var $form;
    e.preventDefault();
    $form = $(this).closest('form');
    $(document).triggerHandler('markdown-preview:show', [$form]);
  });

  $(document).on('click', writeButtonSelector, function (e) {
    var $form;
    e.preventDefault();
    $form = $(this).closest('form');
    $(document).triggerHandler('markdown-preview:hide', [$form]);
  });
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "2iOG":
/***/ (function(module, exports) {

/* eslint-disable func-names, space-before-function-paren, wrap-iife, no-var, no-param-reassign, no-cond-assign, one-var, one-var-declaration-per-line, no-void, guard-for-in, no-restricted-syntax, prefer-template, quotes, max-len */
(function () {
  (function (w) {
    var base;
    if (w.gl == null) {
      w.gl = {};
    }
    if ((base = w.gl).utils == null) {
      base.utils = {};
    }
    // Returns an array containing the value(s) of the
    // of the key passed as an argument
    w.gl.utils.getParameterValues = function (sParam) {
      var i, sPageURL, sParameterName, sURLVariables, values;
      sPageURL = decodeURIComponent(window.location.search.substring(1));
      sURLVariables = sPageURL.split('&');
      sParameterName = void 0;
      values = [];
      i = 0;
      while (i < sURLVariables.length) {
        sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] === sParam) {
          values.push(sParameterName[1].replace(/\+/g, ' '));
        }
        i += 1;
      }
      return values;
    };
    // @param {Object} params - url keys and value to merge
    // @param {String} url
    w.gl.utils.mergeUrlParams = function (params, url) {
      var lastChar, newUrl, paramName, paramValue, pattern;
      newUrl = decodeURIComponent(url);
      for (paramName in params) {
        paramValue = params[paramName];
        pattern = new RegExp("\\b(" + paramName + "=).*?(&|$)");
        if (paramValue == null) {
          newUrl = newUrl.replace(pattern, '');
        } else if (url.search(pattern) !== -1) {
          newUrl = newUrl.replace(pattern, "$1" + paramValue + "$2");
        } else {
          newUrl = "" + newUrl + (newUrl.indexOf('?') > 0 ? '&' : '?') + paramName + "=" + paramValue;
        }
      }
      // Remove a trailing ampersand
      lastChar = newUrl[newUrl.length - 1];
      if (lastChar === '&') {
        newUrl = newUrl.slice(0, -1);
      }
      return newUrl;
    };
    // removes parameter query string from url. returns the modified url
    w.gl.utils.removeParamQueryString = function (url, param) {
      var urlVariables, variables;
      url = decodeURIComponent(url);
      urlVariables = url.split('&');
      return function () {
        var j, len, results;
        results = [];
        for (j = 0, len = urlVariables.length; j < len; j += 1) {
          variables = urlVariables[j];
          if (variables.indexOf(param) === -1) {
            results.push(variables);
          }
        }
        return results;
      }().join('&');
    };
    w.gl.utils.removeParams = function (params) {
      var url = new URL(window.location.href);
      params.forEach(function (param) {
        url.search = w.gl.utils.removeParamQueryString(url.search, param);
      });
      return url.href;
    };
    w.gl.utils.getLocationHash = function (url) {
      var hashIndex;
      if (typeof url === 'undefined') {
        // Note: We can't use window.location.hash here because it's
        // not consistent across browsers - Firefox will pre-decode it
        url = window.location.href;
      }
      hashIndex = url.indexOf('#');
      return hashIndex === -1 ? null : url.substring(hashIndex + 1);
    };

    w.gl.utils.refreshCurrentPage = function () {
      return gl.utils.visitUrl(document.location.href);
    };

    w.gl.utils.visitUrl = function (url) {
      document.location.href = url;
    };
  })(window);
}).call(window);

/***/ }),

/***/ "2lN2":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * This class overrides the browser's validation error bubbles, displaying custom
 * error messages for invalid fields instead. To begin validating any form, add the
 * class `gl-show-field-errors` to the form element, and ensure error messages are
 * declared in each inputs' `title` attribute. If no title is declared for an invalid
 * field the user attempts to submit, "This field is required." will be shown by default.
 *
 * Opt not to validate certain fields by adding the class `gl-field-error-ignore` to the input.
 *
 * Set a custom error anchor for error message to be injected after with the
 * class `gl-field-error-anchor`
 *
 * Examples:
 *
 * Basic:
 *
 * <form class='gl-show-field-errors'>
 *  <input type='text' name='username' title='Username is required.'/>
 * </form>
 *
 * Ignore specific inputs (e.g. UsernameValidator):
 *
 * <form class='gl-show-field-errors'>
 *   <div class="form-group>
 *     <input type='text' class='gl-field-errors-ignore' pattern='[a-zA-Z0-9-_]+'/>
 *   </div>
 *   <div class="form-group">
 *      <input type='text' name='username' title='Username is required.'/>
 *    </div>
 * </form>
 *
 * Custom Error Anchor (allows error message to be injected after specified element):
 *
 * <form class='gl-show-field-errors'>
 *  <div class="form-group gl-field-error-anchor">
 *    <input type='text' name='username' title='Username is required.'/>
 *    // Error message typically injected here
 *  </div>
 *  // Error message now injected here
 * </form>
 *
 */

/**
 * Regex Patterns in use:
 *
 * Only alphanumeric: : "[a-zA-Z0-9]+"
 * No special characters : "[a-zA-Z0-9-_]+",
 *
 */

var errorMessageClass = 'gl-field-error';
var inputErrorClass = 'gl-field-error-outline';
var errorAnchorSelector = '.gl-field-error-anchor';
var ignoreInputSelector = '.gl-field-error-ignore';

var GlFieldError = function () {
  function GlFieldError(_ref) {
    var input = _ref.input,
        formErrors = _ref.formErrors;

    _classCallCheck(this, GlFieldError);

    this.inputElement = $(input);
    this.inputDomElement = this.inputElement.get(0);
    this.form = formErrors;
    this.errorMessage = this.inputElement.attr('title') || 'This field is required.';
    this.fieldErrorElement = $('<p class=\'' + errorMessageClass + ' hide\'>' + this.errorMessage + '</p>');

    this.state = {
      valid: false,
      empty: true
    };

    this.initFieldValidation();
  }

  _createClass(GlFieldError, [{
    key: 'initFieldValidation',
    value: function initFieldValidation() {
      var customErrorAnchor = this.inputElement.parents(errorAnchorSelector);
      var errorAnchor = customErrorAnchor.length ? customErrorAnchor : this.inputElement;

      // hidden when injected into DOM
      errorAnchor.after(this.fieldErrorElement);
      this.inputElement.off('invalid').on('invalid', this.handleInvalidSubmit.bind(this));
      this.scopedSiblings = this.safelySelectSiblings();
    }
  }, {
    key: 'safelySelectSiblings',
    value: function safelySelectSiblings() {
      // Apply `ignoreSelector` in markup to siblings whose visibility should not be toggled
      var unignoredSiblings = this.inputElement.siblings('p:not(' + ignoreInputSelector + ')');
      var parentContainer = this.inputElement.parent('.form-group');

      // Only select siblings when they're scoped within a form-group with one input
      var safelyScoped = parentContainer.length && parentContainer.find('input').length === 1;

      return safelyScoped ? unignoredSiblings : this.fieldErrorElement;
    }
  }, {
    key: 'renderValidity',
    value: function renderValidity() {
      this.renderClear();

      if (this.state.valid) {
        this.renderValid();
      } else if (this.state.empty) {
        this.renderEmpty();
      } else if (!this.state.valid) {
        this.renderInvalid();
      }
    }
  }, {
    key: 'handleInvalidSubmit',
    value: function handleInvalidSubmit(event) {
      event.preventDefault();
      var currentValue = this.accessCurrentValue();
      this.state.valid = false;
      this.state.empty = currentValue === '';

      this.renderValidity();
      this.form.focusOnFirstInvalid.apply(this.form);
      // For UX, wait til after first invalid submission to check each keyup
      this.inputElement.off('keyup.fieldValidator').on('keyup.fieldValidator', this.updateValidity.bind(this));
    }

    /* Get or set current input value */

  }, {
    key: 'accessCurrentValue',
    value: function accessCurrentValue(newVal) {
      return newVal ? this.inputElement.val(newVal) : this.inputElement.val();
    }
  }, {
    key: 'getInputValidity',
    value: function getInputValidity() {
      return this.inputDomElement.validity.valid;
    }
  }, {
    key: 'updateValidity',
    value: function updateValidity() {
      var inputVal = this.accessCurrentValue();
      this.state.empty = !inputVal.length;
      this.state.valid = this.getInputValidity();
      this.renderValidity();
    }
  }, {
    key: 'renderValid',
    value: function renderValid() {
      return this.renderClear();
    }
  }, {
    key: 'renderEmpty',
    value: function renderEmpty() {
      return this.renderInvalid();
    }
  }, {
    key: 'renderInvalid',
    value: function renderInvalid() {
      this.inputElement.addClass(inputErrorClass);
      this.scopedSiblings.hide();
      return this.fieldErrorElement.show();
    }
  }, {
    key: 'renderClear',
    value: function renderClear() {
      var inputVal = this.accessCurrentValue();
      if (!inputVal.split(' ').length) {
        var trimmedInput = inputVal.trim();
        this.accessCurrentValue(trimmedInput);
      }
      this.inputElement.removeClass(inputErrorClass);
      this.scopedSiblings.hide();
      this.fieldErrorElement.hide();
    }
  }]);

  return GlFieldError;
}();

window.gl = window.gl || {};
window.gl.GlFieldError = GlFieldError;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "2nfG":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AjaxLoadingSpinner = function () {
  function AjaxLoadingSpinner() {
    _classCallCheck(this, AjaxLoadingSpinner);
  }

  _createClass(AjaxLoadingSpinner, null, [{
    key: 'init',
    value: function init() {
      var $elements = $('.js-ajax-loading-spinner');

      $elements.on('ajax:beforeSend', AjaxLoadingSpinner.ajaxBeforeSend);
      $elements.on('ajax:complete', AjaxLoadingSpinner.ajaxComplete);
    }
  }, {
    key: 'ajaxBeforeSend',
    value: function ajaxBeforeSend(e) {
      e.target.setAttribute('disabled', '');
      var iconElement = e.target.querySelector('i');
      // get first fa- icon
      var originalIcon = iconElement.className.match(/(fa-)([^\s]+)/g).first();
      iconElement.dataset.icon = originalIcon;
      AjaxLoadingSpinner.toggleLoadingIcon(iconElement);
      $(e.target).off('ajax:beforeSend', AjaxLoadingSpinner.ajaxBeforeSend);
    }
  }, {
    key: 'ajaxComplete',
    value: function ajaxComplete(e) {
      e.target.removeAttribute('disabled');
      var iconElement = e.target.querySelector('i');
      AjaxLoadingSpinner.toggleLoadingIcon(iconElement);
      $(e.target).off('ajax:complete', AjaxLoadingSpinner.ajaxComplete);
    }
  }, {
    key: 'toggleLoadingIcon',
    value: function toggleLoadingIcon(iconElement) {
      var classList = iconElement.classList;
      classList.toggle(iconElement.dataset.icon);
      classList.toggle('fa-spinner');
      classList.toggle('fa-spin');
    }
  }]);

  return AjaxLoadingSpinner;
}();

window.gl = window.gl || {};
gl.AjaxLoadingSpinner = AjaxLoadingSpinner;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "2ub6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DATA_TRIGGER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DATA_DROPDOWN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SELECTED_CLASS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ACTIVE_CLASS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return IGNORE_CLASS; });
var DATA_TRIGGER = 'data-dropdown-trigger';
var DATA_DROPDOWN = 'data-dropdown';
var SELECTED_CLASS = 'droplab-item-selected';
var ACTIVE_CLASS = 'droplab-item-active';
var IGNORE_CLASS = 'droplab-item-ignore';



/***/ }),

/***/ "2xbY":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, wrap-iife, one-var, no-var, one-var-declaration-per-line, no-unused-vars, no-else-return, prefer-arrow-callback, camelcase, quotes, comma-dangle, max-len */

window.Admin = function () {
  function Admin() {
    var modal, showBlacklistType;
    $('input#user_force_random_password').on('change', function (elem) {
      var elems;
      elems = $('#user_password, #user_password_confirmation');
      if ($(this).attr('checked')) {
        return elems.val('').attr('disabled', true);
      } else {
        return elems.removeAttr('disabled');
      }
    });
    $('body').on('click', '.js-toggle-colors-link', function (e) {
      e.preventDefault();
      return $('.js-toggle-colors-container').toggle();
    });
    $('.log-tabs a').click(function (e) {
      e.preventDefault();
      return $(this).tab('show');
    });
    $('.log-bottom').click(function (e) {
      var visible_log;
      e.preventDefault();
      visible_log = $(".file-content:visible");
      return visible_log.animate({
        scrollTop: visible_log.find('ol').height()
      }, "fast");
    });
    modal = $('.change-owner-holder');
    $('.change-owner-link').bind("click", function (e) {
      e.preventDefault();
      $(this).hide();
      return modal.show();
    });
    $('.change-owner-cancel-link').bind("click", function (e) {
      e.preventDefault();
      modal.hide();
      return $('.change-owner-link').show();
    });
    $('li.project_member').bind('ajax:success', function () {
      return gl.utils.refreshCurrentPage();
    });
    $('li.group_member').bind('ajax:success', function () {
      return gl.utils.refreshCurrentPage();
    });
    showBlacklistType = function showBlacklistType() {
      if ($("input[name='blacklist_type']:checked").val() === 'file') {
        $('.blacklist-file').show();
        return $('.blacklist-raw').hide();
      } else {
        $('.blacklist-file').hide();
        return $('.blacklist-raw').show();
      }
    };
    $("input[name='blacklist_type']").click(showBlacklistType);
    showBlacklistType();
  }

  return Admin;
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "378X":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* eslint-disable func-names, space-before-function-paren, one-var, no-var, prefer-rest-params, wrap-iife, quotes, max-len, one-var-declaration-per-line, vars-on-top, prefer-arrow-callback, consistent-return, comma-dangle, object-shorthand, no-shadow, no-unused-vars, no-else-return, no-self-compare, prefer-template, no-unused-expressions, no-lonely-if, yoda, prefer-spread, no-void, camelcase, no-param-reassign */
/* global Issuable */
/* global ListUser */

(function () {
  var bind = function bind(fn, me) {
    return function () {
      return fn.apply(me, arguments);
    };
  },
      slice = [].slice;

  this.UsersSelect = function () {
    function UsersSelect(currentUser, els) {
      var $els;
      this.users = bind(this.users, this);
      this.user = bind(this.user, this);
      this.usersPath = "/autocomplete/users.json";
      this.userPath = "/autocomplete/users/:id.json";
      if (currentUser != null) {
        if ((typeof currentUser === "undefined" ? "undefined" : _typeof(currentUser)) === 'object') {
          this.currentUser = currentUser;
        } else {
          this.currentUser = JSON.parse(currentUser);
        }
      }

      $els = $(els);

      if (!els) {
        $els = $('.js-user-search');
      }

      $els.each(function (_this) {
        return function (i, dropdown) {
          var options = {};
          var $block, $collapsedSidebar, $dropdown, $loading, $selectbox, $value, abilityName, assignTo, assigneeTemplate, collapsedAssigneeTemplate, defaultLabel, firstUser, issueURL, selectedId, showAnyUser, showNullUser, showMenuAbove;
          $dropdown = $(dropdown);
          options.projectId = $dropdown.data('project-id');
          options.showCurrentUser = $dropdown.data('current-user');
          options.todoFilter = $dropdown.data('todo-filter');
          options.todoStateFilter = $dropdown.data('todo-state-filter');
          showNullUser = $dropdown.data('null-user');
          showMenuAbove = $dropdown.data('showMenuAbove');
          showAnyUser = $dropdown.data('any-user');
          firstUser = $dropdown.data('first-user');
          options.authorId = $dropdown.data('author-id');
          selectedId = $dropdown.data('selected');
          defaultLabel = $dropdown.data('default-label');
          issueURL = $dropdown.data('issueUpdate');
          $selectbox = $dropdown.closest('.selectbox');
          $block = $selectbox.closest('.block');
          abilityName = $dropdown.data('ability-name');
          $value = $block.find('.value');
          $collapsedSidebar = $block.find('.sidebar-collapsed-user');
          $loading = $block.find('.block-loading').fadeOut();

          var updateIssueBoardsIssue = function updateIssueBoardsIssue() {
            $loading.removeClass('hidden').fadeIn();
            gl.issueBoards.BoardsStore.detail.issue.update($dropdown.attr('data-issue-update')).then(function () {
              $loading.fadeOut();
            });
          };

          $('.assign-to-me-link').on('click', function (e) {
            e.preventDefault();
            $(e.currentTarget).hide();
            var $input = $("input[name=\"" + $dropdown.data('field-name') + "\"]");
            $input.val(gon.current_user_id);
            selectedId = $input.val();
            $dropdown.find('.dropdown-toggle-text').text(gon.current_user_fullname).removeClass('is-default');
          });

          $block.on('click', '.js-assign-yourself', function (e) {
            e.preventDefault();

            if ($dropdown.hasClass('js-issue-board-sidebar')) {
              gl.issueBoards.boardStoreIssueSet('assignee', new ListUser({
                id: _this.currentUser.id,
                username: _this.currentUser.username,
                name: _this.currentUser.name,
                avatar_url: _this.currentUser.avatar_url
              }));

              updateIssueBoardsIssue();
            } else {
              return assignTo(_this.currentUser.id);
            }
          });
          assignTo = function assignTo(selected) {
            var data;
            data = {};
            data[abilityName] = {};
            data[abilityName].assignee_id = selected != null ? selected : null;
            $loading.removeClass('hidden').fadeIn();
            $dropdown.trigger('loading.gl.dropdown');
            return $.ajax({
              type: 'PUT',
              dataType: 'json',
              url: issueURL,
              data: data
            }).done(function (data) {
              var user;
              $dropdown.trigger('loaded.gl.dropdown');
              $loading.fadeOut();
              $selectbox.hide();
              if (data.assignee) {
                user = {
                  name: data.assignee.name,
                  username: data.assignee.username,
                  avatar: data.assignee.avatar_url
                };
              } else {
                user = {
                  name: 'Unassigned',
                  username: '',
                  avatar: ''
                };
              }
              $value.html(assigneeTemplate(user));
              $collapsedSidebar.attr('title', user.name).tooltip('fixTitle');
              return $collapsedSidebar.html(collapsedAssigneeTemplate(user));
            });
          };
          collapsedAssigneeTemplate = _.template('<% if( avatar ) { %> <a class="author_link" href="/<%- username %>"> <img width="24" class="avatar avatar-inline s24" alt="" src="<%- avatar %>"> </a> <% } else { %> <i class="fa fa-user"></i> <% } %>');
          assigneeTemplate = _.template('<% if (username) { %> <a class="author_link bold" href="/<%- username %>"> <% if( avatar ) { %> <img width="32" class="avatar avatar-inline s32" alt="" src="<%- avatar %>"> <% } %> <span class="author"><%- name %></span> <span class="username"> @<%- username %> </span> </a> <% } else { %> <span class="no-value assign-yourself"> No assignee - <a href="#" class="js-assign-yourself"> assign yourself </a> </span> <% } %>');
          return $dropdown.glDropdown({
            showMenuAbove: showMenuAbove,
            data: function data(term, callback) {
              var isAuthorFilter;
              isAuthorFilter = $('.js-author-search');
              return _this.users(term, options, function (users) {
                var anyUser, index, j, len, name, obj, showDivider;
                if (term.length === 0) {
                  showDivider = 0;
                  if (firstUser) {
                    // Move current user to the front of the list
                    for (index = j = 0, len = users.length; j < len; index = j += 1) {
                      obj = users[index];
                      if (obj.username === firstUser) {
                        users.splice(index, 1);
                        users.unshift(obj);
                        break;
                      }
                    }
                  }
                  if (showNullUser) {
                    showDivider += 1;
                    users.unshift({
                      beforeDivider: true,
                      name: 'Unassigned',
                      id: 0
                    });
                  }
                  if (showAnyUser) {
                    showDivider += 1;
                    name = showAnyUser;
                    if (name === true) {
                      name = 'Any User';
                    }
                    anyUser = {
                      beforeDivider: true,
                      name: name,
                      id: null
                    };
                    users.unshift(anyUser);
                  }
                }
                if (showDivider) {
                  users.splice(showDivider, 0, "divider");
                }

                callback(users);
                if (showMenuAbove) {
                  $dropdown.data('glDropdown').positionMenuAbove();
                }
              });
            },
            filterable: true,
            filterRemote: true,
            search: {
              fields: ['name', 'username']
            },
            selectable: true,
            fieldName: $dropdown.data('field-name'),
            toggleLabel: function toggleLabel(selected, el) {
              if (selected && 'id' in selected && $(el).hasClass('is-active')) {
                if (selected.text) {
                  return selected.text;
                } else {
                  return selected.name;
                }
              } else {
                return defaultLabel;
              }
            },
            defaultLabel: defaultLabel,
            inputId: 'issue_assignee_id',
            hidden: function hidden(e) {
              $selectbox.hide();
              // display:block overrides the hide-collapse rule
              return $value.css('display', '');
            },
            vue: $dropdown.hasClass('js-issue-board-sidebar'),
            clicked: function clicked(user, $el, e) {
              var isIssueIndex, isMRIndex, page, selected;
              page = $('body').data('page');
              isIssueIndex = page === 'projects:issues:index';
              isMRIndex = page === page && page === 'projects:merge_requests:index';
              if ($dropdown.hasClass('js-filter-bulk-update') || $dropdown.hasClass('js-issuable-form-dropdown')) {
                e.preventDefault();
                selectedId = user.id;
                if (selectedId === gon.current_user_id) {
                  $('.assign-to-me-link').hide();
                } else {
                  $('.assign-to-me-link').show();
                }
                return;
              }
              if ($el.closest('.add-issues-modal').length) {
                gl.issueBoards.ModalStore.store.filter[$dropdown.data('field-name')] = user.id;
              } else if ($dropdown.hasClass('js-filter-submit') && (isIssueIndex || isMRIndex)) {
                selectedId = user.id;
                return Issuable.filterResults($dropdown.closest('form'));
              } else if ($dropdown.hasClass('js-filter-submit')) {
                return $dropdown.closest('form').submit();
              } else if ($dropdown.hasClass('js-issue-board-sidebar')) {
                if (user.id) {
                  gl.issueBoards.boardStoreIssueSet('assignee', new ListUser({
                    id: user.id,
                    username: user.username,
                    name: user.name,
                    avatar_url: user.avatar_url
                  }));
                } else {
                  gl.issueBoards.boardStoreIssueDelete('assignee');
                }

                updateIssueBoardsIssue();
              } else {
                selected = $dropdown.closest('.selectbox').find("input[name='" + $dropdown.data('field-name') + "']").val();
                return assignTo(selected);
              }
            },
            id: function id(user) {
              return user.id;
            },
            opened: function opened(e) {
              var $el = $(e.currentTarget);
              $el.find('.is-active').removeClass('is-active');
              $el.find("li[data-user-id=\"" + selectedId + "\"] .dropdown-menu-user-link").addClass('is-active');
            },
            renderRow: function renderRow(user) {
              var avatar, img, listClosingTags, listWithName, listWithUserName, selected, username;
              username = user.username ? "@" + user.username : "";
              avatar = user.avatar_url ? user.avatar_url : false;
              selected = user.id === parseInt(selectedId, 10) ? "is-active" : "";
              img = "";
              if (user.beforeDivider != null) {
                "<li> <a href='#' class='" + selected + "'> " + user.name + " </a> </li>";
              } else {
                if (avatar) {
                  img = "<img src='" + avatar + "' class='avatar avatar-inline' width='30' />";
                }
              }
              // split into three parts so we can remove the username section if nessesary
              listWithName = "<li data-user-id=" + user.id + "> <a href='#' class='dropdown-menu-user-link " + selected + "'> " + img + " <strong class='dropdown-menu-user-full-name'> " + user.name + " </strong>";
              listWithUserName = "<span class='dropdown-menu-user-username'> " + username + " </span>";
              listClosingTags = "</a> </li>";
              if (username === '') {
                listWithUserName = '';
              }
              return listWithName + listWithUserName + listClosingTags;
            }
          });
        };
      }(this));
      $('.ajax-users-select').each(function (_this) {
        return function (i, select) {
          var firstUser, showAnyUser, showEmailUser, showNullUser;
          var options = {};
          options.skipLdap = $(select).hasClass('skip_ldap');
          options.projectId = $(select).data('project-id');
          options.groupId = $(select).data('group-id');
          options.showCurrentUser = $(select).data('current-user');
          options.pushCodeToProtectedBranches = $(select).data('push-code-to-protected-branches');
          options.authorId = $(select).data('author-id');
          options.skipUsers = $(select).data('skip-users');
          showNullUser = $(select).data('null-user');
          showAnyUser = $(select).data('any-user');
          showEmailUser = $(select).data('email-user');
          firstUser = $(select).data('first-user');
          return $(select).select2({
            placeholder: "Search for a user",
            multiple: $(select).hasClass('multiselect'),
            minimumInputLength: 0,
            query: function query(_query) {
              return _this.users(_query.term, options, function (users) {
                var anyUser, data, emailUser, index, j, len, name, nullUser, obj, ref;
                data = {
                  results: users
                };
                if (_query.term.length === 0) {
                  if (firstUser) {
                    // Move current user to the front of the list
                    ref = data.results;
                    for (index = j = 0, len = ref.length; j < len; index = j += 1) {
                      obj = ref[index];
                      if (obj.username === firstUser) {
                        data.results.splice(index, 1);
                        data.results.unshift(obj);
                        break;
                      }
                    }
                  }
                  if (showNullUser) {
                    nullUser = {
                      name: 'Unassigned',
                      id: 0
                    };
                    data.results.unshift(nullUser);
                  }
                  if (showAnyUser) {
                    name = showAnyUser;
                    if (name === true) {
                      name = 'Any User';
                    }
                    anyUser = {
                      name: name,
                      id: null
                    };
                    data.results.unshift(anyUser);
                  }
                }
                if (showEmailUser && data.results.length === 0 && _query.term.match(/^[^@]+@[^@]+$/)) {
                  var trimmed = _query.term.trim();
                  emailUser = {
                    name: "Invite \"" + _query.term + "\"",
                    username: trimmed,
                    id: trimmed
                  };
                  data.results.unshift(emailUser);
                }
                return _query.callback(data);
              });
            },
            initSelection: function initSelection() {
              var args;
              args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
              return _this.initSelection.apply(_this, args);
            },
            formatResult: function formatResult() {
              var args;
              args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
              return _this.formatResult.apply(_this, args);
            },
            formatSelection: function formatSelection() {
              var args;
              args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
              return _this.formatSelection.apply(_this, args);
            },
            dropdownCssClass: "ajax-users-dropdown",
            // we do not want to escape markup since we are displaying html in results
            escapeMarkup: function escapeMarkup(m) {
              return m;
            }
          });
        };
      }(this));
    }

    UsersSelect.prototype.initSelection = function (element, callback) {
      var id, nullUser;
      id = $(element).val();
      if (id === "0") {
        nullUser = {
          name: 'Unassigned'
        };
        return callback(nullUser);
      } else if (id !== "") {
        return this.user(id, callback);
      }
    };

    UsersSelect.prototype.formatResult = function (user) {
      var avatar;
      if (user.avatar_url) {
        avatar = user.avatar_url;
      } else {
        avatar = gon.default_avatar_url;
      }
      return "<div class='user-result " + (!user.username ? 'no-username' : void 0) + "'> <div class='user-image'><img class='avatar s24' src='" + avatar + "'></div> <div class='user-name'>" + user.name + "</div> <div class='user-username'>" + (user.username || "") + "</div> </div>";
    };

    UsersSelect.prototype.formatSelection = function (user) {
      return user.name;
    };

    UsersSelect.prototype.user = function (user_id, callback) {
      if (!/^\d+$/.test(user_id)) {
        return false;
      }

      var url;
      url = this.buildUrl(this.userPath);
      url = url.replace(':id', user_id);
      return $.ajax({
        url: url,
        dataType: "json"
      }).done(function (user) {
        return callback(user);
      });
    };

    // Return users list. Filtered by query
    // Only active users retrieved
    UsersSelect.prototype.users = function (query, options, callback) {
      var url;
      url = this.buildUrl(this.usersPath);
      return $.ajax({
        url: url,
        data: {
          search: query,
          per_page: 20,
          active: true,
          project_id: options.projectId || null,
          group_id: options.groupId || null,
          skip_ldap: options.skipLdap || null,
          todo_filter: options.todoFilter || null,
          todo_state_filter: options.todoStateFilter || null,
          current_user: options.showCurrentUser || null,
          push_code_to_protected_branches: options.pushCodeToProtectedBranches || null,
          author_id: options.authorId || null,
          skip_users: options.skipUsers || null
        },
        dataType: "json"
      }).done(function (users) {
        return callback(users);
      });
    };

    UsersSelect.prototype.buildUrl = function (url) {
      if (gon.relative_url_root != null) {
        url = gon.relative_url_root.replace(/\/$/, '') + url;
      }
      return url;
    };

    return UsersSelect;
  }();
}).call(window);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "38m2":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable class-methods-use-this, object-shorthand, no-unused-vars, no-use-before-define, no-new, max-len, no-restricted-syntax, guard-for-in, no-continue */

__webpack_require__("RsTm");

var gfmRules = {
  // The filters referenced in lib/banzai/pipeline/gfm_pipeline.rb convert
  // GitLab Flavored Markdown (GFM) to HTML.
  // These handlers consequently convert that same HTML to GFM to be copied to the clipboard.
  // Every filter in lib/banzai/pipeline/gfm_pipeline.rb that generates HTML
  // from GFM should have a handler here, in reverse order.
  // The GFM-to-HTML-to-GFM cycle is tested in spec/features/copy_as_gfm_spec.rb.
  InlineDiffFilter: {
    'span.idiff.addition': function spanIdiffAddition(el, text) {
      return '{+' + text + '+}';
    },
    'span.idiff.deletion': function spanIdiffDeletion(el, text) {
      return '{-' + text + '-}';
    }
  },
  TaskListFilter: {
    'input[type=checkbox].task-list-item-checkbox': function inputTypeCheckboxTaskListItemCheckbox(el, text) {
      return '[' + (el.checked ? 'x' : ' ') + ']';
    }
  },
  ReferenceFilter: {
    '.tooltip': function tooltip(el, text) {
      return '';
    },
    'a.gfm:not([data-link=true])': function aGfmNotDataLinkTrue(el, text) {
      return el.dataset.original || text;
    }
  },
  AutolinkFilter: {
    'a': function a(el, text) {
      // Fallback on the regular MarkdownFilter's `a` handler.
      if (text !== el.getAttribute('href')) return false;

      return text;
    }
  },
  TableOfContentsFilter: {
    'ul.section-nav': function ulSectionNav(el, text) {
      return '[[_TOC_]]';
    }
  },
  EmojiFilter: {
    'img.emoji': function imgEmoji(el, text) {
      return el.getAttribute('alt');
    },
    'gl-emoji': function glEmoji(el, text) {
      return ':' + el.getAttribute('data-name') + ':';
    }
  },
  ImageLinkFilter: {
    'a.no-attachment-icon': function aNoAttachmentIcon(el, text) {
      return text;
    }
  },
  VideoLinkFilter: {
    '.video-container': function videoContainer(el, text) {
      var videoEl = el.querySelector('video');
      if (!videoEl) return false;

      return CopyAsGFM.nodeToGFM(videoEl);
    },
    'video': function video(el, text) {
      return '![' + el.dataset.title + '](' + el.getAttribute('src') + ')';
    }
  },
  MathFilter: {
    'pre.code.math[data-math-style=display]': function preCodeMathDataMathStyleDisplay(el, text) {
      return '```math\n' + text.trim() + '\n```';
    },
    'code.code.math[data-math-style=inline]': function codeCodeMathDataMathStyleInline(el, text) {
      return '$`' + text + '`$';
    },
    'span.katex-display span.katex-mathml': function spanKatexDisplaySpanKatexMathml(el, text) {
      var mathAnnotation = el.querySelector('annotation[encoding="application/x-tex"]');
      if (!mathAnnotation) return false;

      return '```math\n' + CopyAsGFM.nodeToGFM(mathAnnotation) + '\n```';
    },
    'span.katex-mathml': function spanKatexMathml(el, text) {
      var mathAnnotation = el.querySelector('annotation[encoding="application/x-tex"]');
      if (!mathAnnotation) return false;

      return '$`' + CopyAsGFM.nodeToGFM(mathAnnotation) + '`$';
    },
    'span.katex-html': function spanKatexHtml(el, text) {
      // We don't want to include the content of this element in the copied text.
      return '';
    },
    'annotation[encoding="application/x-tex"]': function annotationEncodingApplicationXTex(el, text) {
      return text.trim();
    }
  },
  SanitizationFilter: {
    'a[name]:not([href]):empty': function aNameNotHrefEmpty(el, text) {
      return el.outerHTML;
    },
    'dl': function dl(el, text) {
      var lines = text.trim().split('\n');
      // Add two spaces to the front of subsequent list items lines,
      // or leave the line entirely blank.
      lines = lines.map(function (l) {
        var line = l.trim();
        if (line.length === 0) return '';

        return '  ' + line;
      });

      return '<dl>\n' + lines.join('\n') + '\n</dl>';
    },
    'sub, dt, dd, kbd, q, samp, var, ruby, rt, rp, abbr, summary, details': function subDtDdKbdQSampVarRubyRtRpAbbrSummaryDetails(el, text) {
      var tag = el.nodeName.toLowerCase();
      return '<' + tag + '>' + text + '</' + tag + '>';
    }
  },
  SyntaxHighlightFilter: {
    'pre.code.highlight': function preCodeHighlight(el, t) {
      var text = t.trimRight();

      var lang = el.getAttribute('lang');
      if (!lang || lang === 'plaintext') {
        lang = '';
      }

      // Prefixes lines with 4 spaces if the code contains triple backticks
      if (lang === '' && text.match(/^```/gm)) {
        return text.split('\n').map(function (l) {
          var line = l.trim();
          if (line.length === 0) return '';

          return '    ' + line;
        }).join('\n');
      }

      return '```' + lang + '\n' + text + '\n```';
    },
    'pre > code': function preCode(el, text) {
      // Don't wrap code blocks in ``
      return text;
    }
  },
  MarkdownFilter: {
    'br': function br(el, text) {
      // Two spaces at the end of a line are turned into a BR
      return '  ';
    },
    'code': function code(el, text) {
      var backtickCount = 1;
      var backtickMatch = text.match(/`+/);
      if (backtickMatch) {
        backtickCount = backtickMatch[0].length + 1;
      }

      var backticks = Array(backtickCount + 1).join('`');
      var spaceOrNoSpace = backtickCount > 1 ? ' ' : '';

      return backticks + spaceOrNoSpace + text.trim() + spaceOrNoSpace + backticks;
    },
    'blockquote': function blockquote(el, text) {
      return text.trim().split('\n').map(function (s) {
        return ('> ' + s).trim();
      }).join('\n');
    },
    'img': function img(el, text) {
      return '![' + el.getAttribute('alt') + '](' + el.getAttribute('src') + ')';
    },
    'a.anchor': function aAnchor(el, text) {
      // Don't render a Markdown link for the anchor link inside a heading
      return text;
    },
    'a': function a(el, text) {
      return '[' + text + '](' + el.getAttribute('href') + ')';
    },
    'li': function li(el, text) {
      var lines = text.trim().split('\n');
      var firstLine = '- ' + lines.shift();
      // Add four spaces to the front of subsequent list items lines,
      // or leave the line entirely blank.
      var nextLines = lines.map(function (s) {
        if (s.trim().length === 0) return '';

        return '    ' + s;
      });

      return firstLine + '\n' + nextLines.join('\n');
    },
    'ul': function ul(el, text) {
      return text;
    },
    'ol': function ol(el, text) {
      // LIs get a `- ` prefix by default, which we replace by `1. ` for ordered lists.
      return text.replace(/^- /mg, '1. ');
    },
    'h1': function h1(el, text) {
      return '# ' + text.trim();
    },
    'h2': function h2(el, text) {
      return '## ' + text.trim();
    },
    'h3': function h3(el, text) {
      return '### ' + text.trim();
    },
    'h4': function h4(el, text) {
      return '#### ' + text.trim();
    },
    'h5': function h5(el, text) {
      return '##### ' + text.trim();
    },
    'h6': function h6(el, text) {
      return '###### ' + text.trim();
    },
    'strong': function strong(el, text) {
      return '**' + text + '**';
    },
    'em': function em(el, text) {
      return '_' + text + '_';
    },
    'del': function del(el, text) {
      return '~~' + text + '~~';
    },
    'sup': function sup(el, text) {
      return '^' + text;
    },
    'hr': function hr(el, text) {
      return '-----';
    },
    'table': function table(el, text) {
      var theadEl = el.querySelector('thead');
      var tbodyEl = el.querySelector('tbody');
      if (!theadEl || !tbodyEl) return false;

      var theadText = CopyAsGFM.nodeToGFM(theadEl);
      var tbodyText = CopyAsGFM.nodeToGFM(tbodyEl);

      return theadText + tbodyText;
    },
    'thead': function thead(el, text) {
      var cells = _.map(el.querySelectorAll('th'), function (cell) {
        var chars = CopyAsGFM.nodeToGFM(cell).trim().length + 2;

        var before = '';
        var after = '';
        switch (cell.style.textAlign) {
          case 'center':
            before = ':';
            after = ':';
            chars -= 2;
            break;
          case 'right':
            after = ':';
            chars -= 1;
            break;
          default:
            break;
        }

        chars = Math.max(chars, 3);

        var middle = Array(chars + 1).join('-');

        return before + middle + after;
      });

      return text + '|' + cells.join('|') + '|';
    },
    'tr': function tr(el, text) {
      var cells = _.map(el.querySelectorAll('td, th'), function (cell) {
        return CopyAsGFM.nodeToGFM(cell).trim();
      });
      return '| ' + cells.join(' | ') + ' |';
    }
  }
};

var CopyAsGFM = function () {
  function CopyAsGFM() {
    var _this = this;

    _classCallCheck(this, CopyAsGFM);

    $(document).on('copy', '.md, .wiki', function (e) {
      _this.copyAsGFM(e, CopyAsGFM.transformGFMSelection);
    });
    $(document).on('copy', 'pre.code.highlight, .diff-content .line_content', function (e) {
      _this.copyAsGFM(e, CopyAsGFM.transformCodeSelection);
    });
    $(document).on('paste', '.js-gfm-input', this.pasteGFM.bind(this));
  }

  _createClass(CopyAsGFM, [{
    key: 'copyAsGFM',
    value: function copyAsGFM(e, transformer) {
      var clipboardData = e.originalEvent.clipboardData;
      if (!clipboardData) return;

      var documentFragment = window.gl.utils.getSelectedFragment();
      if (!documentFragment) return;

      var el = transformer(documentFragment.cloneNode(true));
      if (!el) return;

      e.preventDefault();
      e.stopPropagation();

      clipboardData.setData('text/plain', el.textContent);
      clipboardData.setData('text/x-gfm', CopyAsGFM.nodeToGFM(el));
    }
  }, {
    key: 'pasteGFM',
    value: function pasteGFM(e) {
      var clipboardData = e.originalEvent.clipboardData;
      if (!clipboardData) return;

      var gfm = clipboardData.getData('text/x-gfm');
      if (!gfm) return;

      e.preventDefault();

      window.gl.utils.insertText(e.target, gfm);
    }
  }], [{
    key: 'transformGFMSelection',
    value: function transformGFMSelection(documentFragment) {
      // If the documentFragment contains more than just Markdown, don't copy as GFM.
      if (documentFragment.querySelector('.md, .wiki')) return null;

      return documentFragment;
    }
  }, {
    key: 'transformCodeSelection',
    value: function transformCodeSelection(documentFragment) {
      var lineEls = documentFragment.querySelectorAll('.line');

      var codeEl = void 0;
      if (lineEls.length > 1) {
        codeEl = document.createElement('pre');
        codeEl.className = 'code highlight';

        var lang = lineEls[0].getAttribute('lang');
        if (lang) {
          codeEl.setAttribute('lang', lang);
        }
      } else {
        codeEl = document.createElement('code');
      }

      if (lineEls.length > 0) {
        for (var i = 0; i < lineEls.length; i += 1) {
          var lineEl = lineEls[i];
          codeEl.appendChild(lineEl);
          codeEl.appendChild(document.createTextNode('\n'));
        }
      } else {
        codeEl.appendChild(documentFragment);
      }

      return codeEl;
    }
  }, {
    key: 'nodeToGFM',
    value: function nodeToGFM(node) {
      if (node.nodeType === Node.COMMENT_NODE) {
        return '';
      }

      if (node.nodeType === Node.TEXT_NODE) {
        return node.textContent;
      }

      var text = this.innerGFM(node);

      if (node.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
        return text;
      }

      for (var filter in gfmRules) {
        var rules = gfmRules[filter];

        for (var selector in rules) {
          var func = rules[selector];

          if (!window.gl.utils.nodeMatchesSelector(node, selector)) continue;

          var result = func(node, text);
          if (result === false) continue;

          return result;
        }
      }

      return text;
    }
  }, {
    key: 'innerGFM',
    value: function innerGFM(parentNode) {
      var nodes = parentNode.childNodes;

      var clonedParentNode = parentNode.cloneNode(true);
      var clonedNodes = Array.prototype.slice.call(clonedParentNode.childNodes, 0);

      for (var i = 0; i < nodes.length; i += 1) {
        var node = nodes[i];
        var clonedNode = clonedNodes[i];

        var text = this.nodeToGFM(node);

        // `clonedNode.replaceWith(text)` is not yet widely supported
        clonedNode.parentNode.replaceChild(document.createTextNode(text), clonedNode);
      }

      return clonedParentNode.innerText || clonedParentNode.textContent;
    }
  }]);

  return CopyAsGFM;
}();

window.gl = window.gl || {};
window.gl.CopyAsGFM = CopyAsGFM;

new CopyAsGFM();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "3Yvy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filterable_list__ = __webpack_require__("whmF");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



/**
 * Makes search request for groups when user types a value in the search input.
 * Updates the html content of the page with the received one.
 */

var GroupsList = function GroupsList() {
  _classCallCheck(this, GroupsList);

  var form = document.querySelector('form#group-filter-form');
  var filter = document.querySelector('.js-groups-list-filter');
  var holder = document.querySelector('.js-groups-list-holder');

  if (form && filter && holder) {
    var list = new __WEBPACK_IMPORTED_MODULE_0__filterable_list__["a" /* default */](form, filter, holder);
    list.initSearch();
  }
};

/* harmony default export */ __webpack_exports__["default"] = (GroupsList);

/***/ }),

/***/ "3uF6":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* global Flash */
__webpack_require__("1uaA");

var TaskList = function () {
  function TaskList() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, TaskList);

    this.selector = options.selector;
    this.dataType = options.dataType;
    this.fieldName = options.fieldName;
    this.onSuccess = options.onSuccess || function () {};
    this.onError = function showFlash(response) {
      var errorMessages = '';

      if (response.responseJSON) {
        errorMessages = response.responseJSON.errors.join(' ');
      }

      return new Flash(errorMessages || 'Update failed', 'alert');
    };

    this.init();
  }

  _createClass(TaskList, [{
    key: 'init',
    value: function init() {
      // Prevent duplicate event bindings
      this.disable();
      $(this.selector + ' .js-task-list-container').taskList('enable');
      $(document).on('tasklist:changed', this.selector + ' .js-task-list-container', this.update.bind(this));
    }
  }, {
    key: 'disable',
    value: function disable() {
      $(this.selector + ' .js-task-list-container').taskList('disable');
      $(document).off('tasklist:changed', this.selector + ' .js-task-list-container');
    }
  }, {
    key: 'update',
    value: function update(e) {
      var $target = $(e.target);
      var patchData = {};
      patchData[this.dataType] = _defineProperty({}, this.fieldName, $target.val());
      return $.ajax({
        type: 'PATCH',
        url: $target.data('update-url') || $('form.js-issuable-update').attr('action'),
        data: patchData,
        success: this.onSuccess,
        error: this.onError
      });
    }
  }]);

  return TaskList;
}();

window.gl = window.gl || {};
window.gl.TaskList = TaskList;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "4PsW":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, wrap-iife, no-unused-vars, one-var, no-var, one-var-declaration-per-line, prefer-arrow-callback, no-new, max-len */
/* global Flash */

(function () {
  this.Star = function () {
    function Star() {
      $('.project-home-panel .toggle-star').on('ajax:success', function (e, data, status, xhr) {
        var $starIcon, $starSpan, $this, toggleStar;
        $this = $(this);
        $starSpan = $this.find('span');
        $starIcon = $this.find('i');
        toggleStar = function toggleStar(isStarred) {
          $this.parent().find('.star-count').text(data.star_count);
          if (isStarred) {
            $starSpan.removeClass('starred').text('Star');
            $starIcon.removeClass('fa-star').addClass('fa-star-o');
          } else {
            $starSpan.addClass('starred').text('Unstar');
            $starIcon.removeClass('fa-star-o').addClass('fa-star');
          }
        };
        toggleStar($starSpan.hasClass('starred'));
      }).on('ajax:error', function (e, xhr, status, error) {
        new Flash('Star toggle failed. Try again later.', 'alert');
      });
    }

    return Star;
  }();
}).call(window);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "4UWX":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable class-methods-use-this */
(function () {
  window.gl = window.gl || {};

  var Members = function () {
    function Members() {
      _classCallCheck(this, Members);

      this.addListeners();
      this.initGLDropdown();
    }

    _createClass(Members, [{
      key: 'addListeners',
      value: function addListeners() {
        $('.project_member, .group_member').off('ajax:success').on('ajax:success', this.removeRow);
        $('.js-member-update-control').off('change').on('change', this.formSubmit.bind(this));
        $('.js-edit-member-form').off('ajax:success').on('ajax:success', this.formSuccess.bind(this));
        gl.utils.disableButtonIfEmptyField('#user_ids', 'input[name=commit]', 'change');
      }
    }, {
      key: 'initGLDropdown',
      value: function initGLDropdown() {
        var _this = this;

        $('.js-member-permissions-dropdown').each(function (i, btn) {
          var $btn = $(btn);

          $btn.glDropdown({
            selectable: true,
            isSelectable: function isSelectable(selected, $el) {
              return !$el.hasClass('is-active');
            },

            fieldName: $btn.data('field-name'),
            id: function id(selected, $el) {
              return $el.data('id');
            },
            toggleLabel: function toggleLabel(selected, $el) {
              return $el.text();
            },

            clicked: function clicked(selected, $link) {
              _this.formSubmit(null, $link);
            }
          });
        });
      }
    }, {
      key: 'removeRow',
      value: function removeRow(e) {
        var $target = $(e.target);

        if ($target.hasClass('btn-remove')) {
          $target.closest('.member').fadeOut(function fadeOutMemberRow() {
            $(this).remove();
          });
        }
      }
    }, {
      key: 'formSubmit',
      value: function formSubmit(e) {
        var $el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

        var $this = e ? $(e.currentTarget) : $el;

        var _getMemberListItems = this.getMemberListItems($this),
            $toggle = _getMemberListItems.$toggle,
            $dateInput = _getMemberListItems.$dateInput;

        $this.closest('form').trigger('submit.rails');

        $toggle.disable();
        $dateInput.disable();
      }
    }, {
      key: 'formSuccess',
      value: function formSuccess(e) {
        var _getMemberListItems2 = this.getMemberListItems($(e.currentTarget).closest('.member')),
            $toggle = _getMemberListItems2.$toggle,
            $dateInput = _getMemberListItems2.$dateInput;

        $toggle.enable();
        $dateInput.enable();
      }
    }, {
      key: 'getMemberListItems',
      value: function getMemberListItems($el) {
        var $memberListItem = $el.is('.member') ? $el : $('#' + $el.data('el-id'));

        return {
          $memberListItem: $memberListItem,
          $toggle: $memberListItem.find('.dropdown-menu-toggle'),
          $dateInput: $memberListItem.find('.js-access-expiration-date')
        };
      }
    }]);

    return Members;
  }();

  gl.Members = Members;
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "4f1f":
/***/ (function(module, exports) {

/**
 * adds a pause and unpause method to Mousetrap
 * this allows you to enable or disable keyboard shortcuts
 * without having to reset Mousetrap and rebind everything
 */
/* global Mousetrap:true */
Mousetrap = (function(Mousetrap) {
    var self = Mousetrap,
        _originalStopCallback = self.stopCallback,
        enabled = true;

    self.stopCallback = function(e, element, combo) {
        if (!enabled) {
            return true;
        }

        return _originalStopCallback(e, element, combo);
    };

    self.pause = function() {
        enabled = false;
    };

    self.unpause = function() {
        enabled = true;
    };

    return self;
}) (Mousetrap);


/***/ }),

/***/ "51yH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__autosize__ = __webpack_require__("UQvG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bind_in_out__ = __webpack_require__("Vhgc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__details_behavior__ = __webpack_require__("i4oR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__details_behavior___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__details_behavior__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__gl_emoji__ = __webpack_require__("fSxH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__quick_submit__ = __webpack_require__("AzRg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__requires_input__ = __webpack_require__("FXmX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__toggler_behavior__ = __webpack_require__("vkML");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__toggler_behavior___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__toggler_behavior__);








__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__gl_emoji__["b" /* installGlEmojiElement */])();

/***/ }),

/***/ "6JIX":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {function UsagePing() {
  var usageDataUrl = $('.usage-data').data('endpoint');

  $.ajax({
    type: 'GET',
    url: usageDataUrl,
    dataType: 'html',
    success: function success(html) {
      $('.usage-data').html(html);
    }
  });
}

window.gl = window.gl || {};
window.gl.UsagePing = UsagePing;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "6cNp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable no-new */
/* global Flash */

/**
 * In each pipelines table we have a mini pipeline graph for each pipeline.
 *
 * When we click in a pipeline stage, we need to make an API call to get the
 * builds list to render in a dropdown.
 *
 * The container should be the table element.
 *
 * The stage icon clicked needs to have the following HTML structure:
 * <div class="dropdown">
 *   <button class="dropdown js-builds-dropdown-button" data-toggle="dropdown"></button>
 *   <div class="js-builds-dropdown-container dropdown-menu"></div>
 * </div>
 */

var MiniPipelineGraph = function () {
  function MiniPipelineGraph() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, MiniPipelineGraph);

    this.container = opts.container || '';
    this.dropdownListSelector = '.js-builds-dropdown-container';
    this.getBuildsList = this.getBuildsList.bind(this);
  }

  /**
   * Adds the event listener when the dropdown is opened.
   * All dropdown events are fired at the .dropdown-menu's parent element.
   */


  _createClass(MiniPipelineGraph, [{
    key: 'bindEvents',
    value: function bindEvents() {
      $(document).off('shown.bs.dropdown', this.container).on('shown.bs.dropdown', this.container, this.getBuildsList);
    }

    /**
     * When the user right clicks or cmd/ctrl + click in the job name
     * the dropdown should not be closed and the link should open in another tab,
     * so we stop propagation of the click event inside the dropdown.
     *
     * Since this component is rendered multiple times per page we need to guarantee we only
     * target the click event of this component.
     */

  }, {
    key: 'stopDropdownClickPropagation',
    value: function stopDropdownClickPropagation() {
      $(document).on('click', this.container + ' .js-builds-dropdown-list a.mini-pipeline-graph-dropdown-item', function (e) {
        e.stopPropagation();
      });
    }

    /**
     * For the clicked stage, renders the given data in the dropdown list.
     *
     * @param  {HTMLElement} stageContainer
     * @param  {Object} data
     */

  }, {
    key: 'renderBuildsList',
    value: function renderBuildsList(stageContainer, data) {
      var dropdownContainer = stageContainer.parentElement.querySelector(this.dropdownListSelector + ' .js-builds-dropdown-list');

      dropdownContainer.innerHTML = data;
    }

    /**
     * For the clicked stage, gets the list of builds.
     *
     * All dropdown events have a relatedTarget property,
     * whose value is the toggling anchor element.
     *
     * @param  {Object} e bootstrap dropdown event
     * @return {Promise}
     */

  }, {
    key: 'getBuildsList',
    value: function getBuildsList(e) {
      var _this = this;

      var button = e.relatedTarget;
      var endpoint = button.dataset.stageEndpoint;

      return $.ajax({
        dataType: 'json',
        type: 'GET',
        url: endpoint,
        beforeSend: function beforeSend() {
          _this.renderBuildsList(button, '');
          _this.toggleLoading(button);
        },
        success: function success(data) {
          _this.toggleLoading(button);
          _this.renderBuildsList(button, data.html);
          _this.stopDropdownClickPropagation();
        },
        error: function error() {
          _this.toggleLoading(button);
          new Flash('An error occurred while fetching the builds.', 'alert');
        }
      });
    }

    /**
     * Toggles the visibility of the loading icon.
     *
     * @param  {HTMLElement} stageContainer
     * @return {type}
     */

  }, {
    key: 'toggleLoading',
    value: function toggleLoading(stageContainer) {
      stageContainer.parentElement.querySelector(this.dropdownListSelector + ' .js-builds-dropdown-loading').classList.toggle('hidden');
    }
  }]);

  return MiniPipelineGraph;
}();

/* harmony default export */ __webpack_exports__["a"] = (MiniPipelineGraph);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("lwLq")))

/***/ }),

/***/ "6sPP":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  var Subscription = function () {
    function Subscription(containerElm) {
      _classCallCheck(this, Subscription);

      this.containerElm = containerElm;

      var subscribeButton = containerElm.querySelector('.js-subscribe-button');
      if (subscribeButton) {
        // remove class so we don't bind twice
        subscribeButton.classList.remove('js-subscribe-button');
        subscribeButton.addEventListener('click', this.toggleSubscription.bind(this));
      }
    }

    _createClass(Subscription, [{
      key: 'toggleSubscription',
      value: function toggleSubscription(event) {
        var button = event.currentTarget;
        var buttonSpan = button.querySelector('span');
        if (!buttonSpan || button.classList.contains('disabled')) {
          return;
        }
        button.classList.add('disabled');

        var isSubscribed = buttonSpan.innerHTML.trim().toLowerCase() !== 'subscribe';
        var toggleActionUrl = this.containerElm.dataset.url;

        $.post(toggleActionUrl, function () {
          button.classList.remove('disabled');

          // hack to allow this to work with the issue boards Vue object
          if (document.querySelector('html').classList.contains('issue-boards-page')) {
            gl.issueBoards.boardStoreIssueSet('subscribed', !gl.issueBoards.BoardsStore.detail.issue.subscribed);
          } else {
            buttonSpan.innerHTML = isSubscribed ? 'Subscribe' : 'Unsubscribe';
          }
        });
      }
    }], [{
      key: 'bindAll',
      value: function bindAll(selector) {
        [].forEach.call(document.querySelectorAll(selector), function (elm) {
          return new Subscription(elm);
        });
      }
    }]);

    return Subscription;
  }();

  window.gl = window.gl || {};
  window.gl.Subscription = Subscription;
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "722W":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, wrap-iife, no-use-before-define, camelcase, quotes, object-shorthand, no-shadow, no-unused-vars, comma-dangle, no-var, prefer-template, no-underscore-dangle, consistent-return, one-var, one-var-declaration-per-line, default-case, prefer-arrow-callback, max-len */
/* global Flash */
/* global Sortable */

(function () {
  this.Milestone = function () {
    Milestone.updateIssue = function (li, issue_url, data) {
      return $.ajax({
        type: "PUT",
        url: issue_url,
        data: data,
        success: function success(_data) {
          return Milestone.successCallback(_data, li);
        },
        error: function error(data) {
          return new Flash("Issue update failed", 'alert');
        },
        dataType: "json"
      });
    };

    Milestone.sortIssues = function (data) {
      var sort_issues_url;
      sort_issues_url = location.href + "/sort_issues";
      return $.ajax({
        type: "PUT",
        url: sort_issues_url,
        data: data,
        success: function success(_data) {
          return Milestone.successCallback(_data);
        },
        error: function error() {
          return new Flash("Issues update failed", 'alert');
        },
        dataType: "json"
      });
    };

    Milestone.sortMergeRequests = function (data) {
      var sort_mr_url;
      sort_mr_url = location.href + "/sort_merge_requests";
      return $.ajax({
        type: "PUT",
        url: sort_mr_url,
        data: data,
        success: function success(_data) {
          return Milestone.successCallback(_data);
        },
        error: function error(data) {
          return new Flash("Issue update failed", 'alert');
        },
        dataType: "json"
      });
    };

    Milestone.updateMergeRequest = function (li, merge_request_url, data) {
      return $.ajax({
        type: "PUT",
        url: merge_request_url,
        data: data,
        success: function success(_data) {
          return Milestone.successCallback(_data, li);
        },
        error: function error(data) {
          return new Flash("Issue update failed", 'alert');
        },
        dataType: "json"
      });
    };

    Milestone.successCallback = function (data, element) {
      var img_tag;
      if (data.assignee) {
        img_tag = $('<img/>');
        img_tag.attr('src', data.assignee.avatar_url);
        img_tag.addClass('avatar s16');
        $(element).find('.assignee-icon img').replaceWith(img_tag);
      } else {
        $(element).find('.assignee-icon').empty();
      }
    };

    function Milestone() {
      var oldMouseStart;
      this.bindIssuesSorting();
      this.bindMergeRequestSorting();
      this.bindTabsSwitching();
    }

    Milestone.prototype.bindIssuesSorting = function () {
      $('#issues-list-unassigned, #issues-list-ongoing, #issues-list-closed').each(function (i, el) {
        this.createSortable(el, {
          group: 'issue-list',
          listEls: $('.issues-sortable-list'),
          fieldName: 'issue',
          sortCallback: Milestone.sortIssues,
          updateCallback: Milestone.updateIssue
        });
      }.bind(this));
    };

    Milestone.prototype.bindTabsSwitching = function () {
      return $('a[data-toggle="tab"]').on('show.bs.tab', function (e) {
        var currentTabClass, previousTabClass;
        currentTabClass = $(e.target).data('show');
        previousTabClass = $(e.relatedTarget).data('show');
        $(previousTabClass).hide();
        $(currentTabClass).removeClass('hidden');
        return $(currentTabClass).show();
      });
    };

    Milestone.prototype.bindMergeRequestSorting = function () {
      $("#merge_requests-list-unassigned, #merge_requests-list-ongoing, #merge_requests-list-closed").each(function (i, el) {
        this.createSortable(el, {
          group: 'merge-request-list',
          listEls: $(".merge_requests-sortable-list:not(#merge_requests-list-merged)"),
          fieldName: 'merge_request',
          sortCallback: Milestone.sortMergeRequests,
          updateCallback: Milestone.updateMergeRequest
        });
      }.bind(this));
    };

    Milestone.prototype.createSortable = function (el, opts) {
      return Sortable.create(el, {
        group: opts.group,
        filter: '.is-disabled',
        forceFallback: true,
        onStart: function onStart(e) {
          opts.listEls.css('min-height', e.item.offsetHeight);
        },
        onEnd: function onEnd() {
          opts.listEls.css("min-height", "0px");
        },
        onUpdate: function onUpdate(e) {
          var ids = this.toArray(),
              data;

          if (ids.length) {
            data = ids.map(function (id) {
              return 'sortable_' + opts.fieldName + '[]=' + id;
            }).join('&');

            opts.sortCallback(data);
          }
        },
        onAdd: function onAdd(e) {
          var data, issuableId, issuableUrl, newState;
          newState = e.to.dataset.state;
          issuableUrl = e.item.dataset.url;
          data = function () {
            switch (newState) {
              case 'ongoing':
                return opts.fieldName + '[assignee_id]=' + gon.current_user_id;
              case 'unassigned':
                return opts.fieldName + '[assignee_id]=';
              case 'closed':
                return opts.fieldName + '[state_event]=close';
            }
          }();
          if (e.from.dataset.state === 'closed') {
            data += '&' + opts.fieldName + '[state_event]=reopen';
          }

          opts.updateCallback(e.item, issuableUrl, data);
          this.options.onUpdate.call(this, e);
        }
      });
    };

    return Milestone;
  }();
}).call(window);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "7bfy":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, wrap-iife, no-var, quotes, object-shorthand, no-unused-vars, no-shadow, one-var, one-var-declaration-per-line, comma-dangle, max-len */
(function () {
  this.SubscriptionSelect = function () {
    function SubscriptionSelect() {
      $('.js-subscription-event').each(function (i, el) {
        var fieldName;
        fieldName = $(el).data("field-name");
        return $(el).glDropdown({
          selectable: true,
          fieldName: fieldName,
          toggleLabel: function (_this) {
            return function (selected, el, instance) {
              var $item, label;
              label = 'Subscription';
              $item = instance.dropdown.find('.is-active');
              if ($item.length) {
                label = $item.text();
              }
              return label;
            };
          }(this),
          clicked: function clicked(item, $el, e) {
            return e.preventDefault();
          },
          id: function id(obj, el) {
            return $(el).data("id");
          }
        });
      });
    }

    return SubscriptionSelect;
  }();
}).call(window);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "7cT8":
/***/ (function(module, exports) {

/* eslint-disable func-names, space-before-function-paren, wrap-iife */

(function () {
  this.ProjectShow = function () {
    function ProjectShow() {}

    return ProjectShow;
  }();
}).call(window);

// I kept class for future

/***/ }),

/***/ "7h5G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__drop_down__ = __webpack_require__("8Fqv");
/* eslint-disable */



var Hook = function Hook(trigger, list, plugins, config) {
  this.trigger = trigger;
  this.list = new __WEBPACK_IMPORTED_MODULE_0__drop_down__["a" /* default */](list);
  this.type = 'Hook';
  this.event = 'click';
  this.plugins = plugins || [];
  this.config = config || {};
  this.id = trigger.id;
};

Object.assign(Hook.prototype, {

  addEvents: function addEvents() {},

  constructor: Hook
});

/* harmony default export */ __webpack_exports__["a"] = (Hook);

/***/ }),

/***/ "8Fqv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__("MoEV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__("2ub6");
var _Object$assign;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable */




var DropDown = function DropDown(list) {
  this.currentIndex = 0;
  this.hidden = true;
  this.list = typeof list === 'string' ? document.querySelector(list) : list;
  this.items = [];

  this.eventWrapper = {};

  this.getItems();
  this.initTemplateString();
  this.addEvents();

  this.initialState = list.innerHTML;
};

Object.assign(DropDown.prototype, (_Object$assign = {
  getItems: function getItems() {
    this.items = [].slice.call(this.list.querySelectorAll('li'));
    return this.items;
  },

  initTemplateString: function initTemplateString() {
    var items = this.items || this.getItems();

    var templateString = '';
    if (items.length > 0) templateString = items[items.length - 1].outerHTML;
    this.templateString = templateString;

    return this.templateString;
  },

  clickEvent: function clickEvent(e) {
    if (e.target.tagName === 'UL') return;
    if (e.target.classList.contains(__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* IGNORE_CLASS */])) return;

    var selected = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].closest(e.target, 'LI');
    if (!selected) return;

    this.addSelectedClass(selected);

    e.preventDefault();
    this.hide();

    var listEvent = new CustomEvent('click.dl', {
      detail: {
        list: this,
        selected: selected,
        data: e.target.dataset
      }
    });
    this.list.dispatchEvent(listEvent);
  },

  addSelectedClass: function addSelectedClass(selected) {
    this.removeSelectedClasses();
    selected.classList.add(__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* SELECTED_CLASS */]);
  },

  removeSelectedClasses: function removeSelectedClasses() {
    var items = this.items || this.getItems();

    items.forEach(function (item) {
      return item.classList.remove(__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* SELECTED_CLASS */]);
    });
  },

  addEvents: function addEvents() {
    this.eventWrapper.clickEvent = this.clickEvent.bind(this);
    this.list.addEventListener('click', this.eventWrapper.clickEvent);
  },

  toggle: function toggle() {
    this.hidden ? this.show() : this.hide();
  },

  setData: function setData(data) {
    this.data = data;
    this.render(data);
  },

  addData: function addData(data) {
    this.data = (this.data || []).concat(data);
    this.render(this.data);
  },

  render: function render(data) {
    var children = data ? data.map(this.renderChildren.bind(this)) : [];
    var renderableList = this.list.querySelector('ul[data-dynamic]') || this.list;

    renderableList.innerHTML = children.join('');
  },

  renderChildren: function renderChildren(data) {
    var html = __WEBPACK_IMPORTED_MODULE_0__utils__["a" /* default */].t(this.templateString, data);
    var template = document.createElement('div');

    template.innerHTML = html;
    this.setImagesSrc(template);
    template.firstChild.style.display = data.droplab_hidden ? 'none' : 'block';

    return template.firstChild.outerHTML;
  },

  setImagesSrc: function setImagesSrc(template) {
    var images = [].slice.call(template.querySelectorAll('img[data-src]'));

    images.forEach(function (image) {
      image.src = image.getAttribute('data-src');
      image.removeAttribute('data-src');
    });
  },

  show: function show() {
    if (!this.hidden) return;
    this.list.style.display = 'block';
    this.currentIndex = 0;
    this.hidden = false;
  },

  hide: function hide() {
    if (this.hidden) return;
    this.list.style.display = 'none';
    this.currentIndex = 0;
    this.hidden = true;
  }

}, _defineProperty(_Object$assign, 'toggle', function toggle() {
  this.hidden ? this.show() : this.hide();
}), _defineProperty(_Object$assign, 'destroy', function destroy() {
  this.hide();
  this.list.removeEventListener('click', this.eventWrapper.clickEvent);
}), _Object$assign));

/* harmony default export */ __webpack_exports__["a"] = (DropDown);

/***/ }),

/***/ "9ZE/":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, prefer-arrow-callback, no-var, quotes, no-else-return, object-shorthand, comma-dangle, max-len */

$(function () {
  var previewPath;
  $('input#broadcast_message_color').on('input', function () {
    var previewColor;
    previewColor = $(this).val();
    return $('div.broadcast-message-preview').css('background-color', previewColor);
  });
  $('input#broadcast_message_font').on('input', function () {
    var previewColor;
    previewColor = $(this).val();
    return $('div.broadcast-message-preview').css('color', previewColor);
  });
  previewPath = $('textarea#broadcast_message_message').data('preview-path');
  return $('textarea#broadcast_message_message').on('input', function () {
    var message;
    message = $(this).val();
    if (message === '') {
      return $('.js-broadcast-message-preview').text("Your message here");
    } else {
      return $.ajax({
        url: previewPath,
        type: "POST",
        data: {
          broadcast_message: {
            message: message
          }
        }
      });
    }
  });
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "9eM+":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.8.3
//     http://underscorejs.org
//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.

(function() {

  // Baseline setup
  // --------------

  // Establish the root object, `window` in the browser, or `exports` on the server.
  var root = this;

  // Save the previous value of the `_` variable.
  var previousUnderscore = root._;

  // Save bytes in the minified (but not gzipped) version:
  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;

  // Create quick reference variables for speed access to core prototypes.
  var
    push             = ArrayProto.push,
    slice            = ArrayProto.slice,
    toString         = ObjProto.toString,
    hasOwnProperty   = ObjProto.hasOwnProperty;

  // All **ECMAScript 5** native function implementations that we hope to use
  // are declared here.
  var
    nativeIsArray      = Array.isArray,
    nativeKeys         = Object.keys,
    nativeBind         = FuncProto.bind,
    nativeCreate       = Object.create;

  // Naked function reference for surrogate-prototype-swapping.
  var Ctor = function(){};

  // Create a safe reference to the Underscore object for use below.
  var _ = function(obj) {
    if (obj instanceof _) return obj;
    if (!(this instanceof _)) return new _(obj);
    this._wrapped = obj;
  };

  // Export the Underscore object for **Node.js**, with
  // backwards-compatibility for the old `require()` API. If we're in
  // the browser, add `_` as a global object.
  if (true) {
    if (typeof module !== 'undefined' && module.exports) {
      exports = module.exports = _;
    }
    exports._ = _;
  } else {
    root._ = _;
  }

  // Current version.
  _.VERSION = '1.8.3';

  // Internal function that returns an efficient (for current engines) version
  // of the passed-in callback, to be repeatedly applied in other Underscore
  // functions.
  var optimizeCb = function(func, context, argCount) {
    if (context === void 0) return func;
    switch (argCount == null ? 3 : argCount) {
      case 1: return function(value) {
        return func.call(context, value);
      };
      case 2: return function(value, other) {
        return func.call(context, value, other);
      };
      case 3: return function(value, index, collection) {
        return func.call(context, value, index, collection);
      };
      case 4: return function(accumulator, value, index, collection) {
        return func.call(context, accumulator, value, index, collection);
      };
    }
    return function() {
      return func.apply(context, arguments);
    };
  };

  // A mostly-internal function to generate callbacks that can be applied
  // to each element in a collection, returning the desired result — either
  // identity, an arbitrary callback, a property matcher, or a property accessor.
  var cb = function(value, context, argCount) {
    if (value == null) return _.identity;
    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
    if (_.isObject(value)) return _.matcher(value);
    return _.property(value);
  };
  _.iteratee = function(value, context) {
    return cb(value, context, Infinity);
  };

  // An internal function for creating assigner functions.
  var createAssigner = function(keysFunc, undefinedOnly) {
    return function(obj) {
      var length = arguments.length;
      if (length < 2 || obj == null) return obj;
      for (var index = 1; index < length; index++) {
        var source = arguments[index],
            keys = keysFunc(source),
            l = keys.length;
        for (var i = 0; i < l; i++) {
          var key = keys[i];
          if (!undefinedOnly || obj[key] === void 0) obj[key] = source[key];
        }
      }
      return obj;
    };
  };

  // An internal function for creating a new object that inherits from another.
  var baseCreate = function(prototype) {
    if (!_.isObject(prototype)) return {};
    if (nativeCreate) return nativeCreate(prototype);
    Ctor.prototype = prototype;
    var result = new Ctor;
    Ctor.prototype = null;
    return result;
  };

  var property = function(key) {
    return function(obj) {
      return obj == null ? void 0 : obj[key];
    };
  };

  // Helper for collection methods to determine whether a collection
  // should be iterated as an array or as an object
  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
  var getLength = property('length');
  var isArrayLike = function(collection) {
    var length = getLength(collection);
    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
  };

  // Collection Functions
  // --------------------

  // The cornerstone, an `each` implementation, aka `forEach`.
  // Handles raw objects in addition to array-likes. Treats all
  // sparse array-likes as if they were dense.
  _.each = _.forEach = function(obj, iteratee, context) {
    iteratee = optimizeCb(iteratee, context);
    var i, length;
    if (isArrayLike(obj)) {
      for (i = 0, length = obj.length; i < length; i++) {
        iteratee(obj[i], i, obj);
      }
    } else {
      var keys = _.keys(obj);
      for (i = 0, length = keys.length; i < length; i++) {
        iteratee(obj[keys[i]], keys[i], obj);
      }
    }
    return obj;
  };

  // Return the results of applying the iteratee to each element.
  _.map = _.collect = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length,
        results = Array(length);
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      results[index] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  };

  // Create a reducing function iterating left or right.
  function createReduce(dir) {
    // Optimized iterator function as using arguments.length
    // in the main function will deoptimize the, see #1991.
    function iterator(obj, iteratee, memo, keys, index, length) {
      for (; index >= 0 && index < length; index += dir) {
        var currentKey = keys ? keys[index] : index;
        memo = iteratee(memo, obj[currentKey], currentKey, obj);
      }
      return memo;
    }

    return function(obj, iteratee, memo, context) {
      iteratee = optimizeCb(iteratee, context, 4);
      var keys = !isArrayLike(obj) && _.keys(obj),
          length = (keys || obj).length,
          index = dir > 0 ? 0 : length - 1;
      // Determine the initial value if none is provided.
      if (arguments.length < 3) {
        memo = obj[keys ? keys[index] : index];
        index += dir;
      }
      return iterator(obj, iteratee, memo, keys, index, length);
    };
  }

  // **Reduce** builds up a single result from a list of values, aka `inject`,
  // or `foldl`.
  _.reduce = _.foldl = _.inject = createReduce(1);

  // The right-associative version of reduce, also known as `foldr`.
  _.reduceRight = _.foldr = createReduce(-1);

  // Return the first value which passes a truth test. Aliased as `detect`.
  _.find = _.detect = function(obj, predicate, context) {
    var key;
    if (isArrayLike(obj)) {
      key = _.findIndex(obj, predicate, context);
    } else {
      key = _.findKey(obj, predicate, context);
    }
    if (key !== void 0 && key !== -1) return obj[key];
  };

  // Return all the elements that pass a truth test.
  // Aliased as `select`.
  _.filter = _.select = function(obj, predicate, context) {
    var results = [];
    predicate = cb(predicate, context);
    _.each(obj, function(value, index, list) {
      if (predicate(value, index, list)) results.push(value);
    });
    return results;
  };

  // Return all the elements for which a truth test fails.
  _.reject = function(obj, predicate, context) {
    return _.filter(obj, _.negate(cb(predicate)), context);
  };

  // Determine whether all of the elements match a truth test.
  // Aliased as `all`.
  _.every = _.all = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }
    return true;
  };

  // Determine if at least one element in the object matches a truth test.
  // Aliased as `any`.
  _.some = _.any = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (predicate(obj[currentKey], currentKey, obj)) return true;
    }
    return false;
  };

  // Determine if the array or object contains a given item (using `===`).
  // Aliased as `includes` and `include`.
  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
    if (!isArrayLike(obj)) obj = _.values(obj);
    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
    return _.indexOf(obj, item, fromIndex) >= 0;
  };

  // Invoke a method (with arguments) on every item in a collection.
  _.invoke = function(obj, method) {
    var args = slice.call(arguments, 2);
    var isFunc = _.isFunction(method);
    return _.map(obj, function(value) {
      var func = isFunc ? method : value[method];
      return func == null ? func : func.apply(value, args);
    });
  };

  // Convenience version of a common use case of `map`: fetching a property.
  _.pluck = function(obj, key) {
    return _.map(obj, _.property(key));
  };

  // Convenience version of a common use case of `filter`: selecting only objects
  // containing specific `key:value` pairs.
  _.where = function(obj, attrs) {
    return _.filter(obj, _.matcher(attrs));
  };

  // Convenience version of a common use case of `find`: getting the first object
  // containing specific `key:value` pairs.
  _.findWhere = function(obj, attrs) {
    return _.find(obj, _.matcher(attrs));
  };

  // Return the maximum element (or element-based computation).
  _.max = function(obj, iteratee, context) {
    var result = -Infinity, lastComputed = -Infinity,
        value, computed;
    if (iteratee == null && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value > result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index, list) {
        computed = iteratee(value, index, list);
        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
          result = value;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Return the minimum element (or element-based computation).
  _.min = function(obj, iteratee, context) {
    var result = Infinity, lastComputed = Infinity,
        value, computed;
    if (iteratee == null && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value < result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index, list) {
        computed = iteratee(value, index, list);
        if (computed < lastComputed || computed === Infinity && result === Infinity) {
          result = value;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Shuffle a collection, using the modern version of the
  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
  _.shuffle = function(obj) {
    var set = isArrayLike(obj) ? obj : _.values(obj);
    var length = set.length;
    var shuffled = Array(length);
    for (var index = 0, rand; index < length; index++) {
      rand = _.random(0, index);
      if (rand !== index) shuffled[index] = shuffled[rand];
      shuffled[rand] = set[index];
    }
    return shuffled;
  };

  // Sample **n** random values from a collection.
  // If **n** is not specified, returns a single random element.
  // The internal `guard` argument allows it to work with `map`.
  _.sample = function(obj, n, guard) {
    if (n == null || guard) {
      if (!isArrayLike(obj)) obj = _.values(obj);
      return obj[_.random(obj.length - 1)];
    }
    return _.shuffle(obj).slice(0, Math.max(0, n));
  };

  // Sort the object's values by a criterion produced by an iteratee.
  _.sortBy = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    return _.pluck(_.map(obj, function(value, index, list) {
      return {
        value: value,
        index: index,
        criteria: iteratee(value, index, list)
      };
    }).sort(function(left, right) {
      var a = left.criteria;
      var b = right.criteria;
      if (a !== b) {
        if (a > b || a === void 0) return 1;
        if (a < b || b === void 0) return -1;
      }
      return left.index - right.index;
    }), 'value');
  };

  // An internal function used for aggregate "group by" operations.
  var group = function(behavior) {
    return function(obj, iteratee, context) {
      var result = {};
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index) {
        var key = iteratee(value, index, obj);
        behavior(result, value, key);
      });
      return result;
    };
  };

  // Groups the object's values by a criterion. Pass either a string attribute
  // to group by, or a function that returns the criterion.
  _.groupBy = group(function(result, value, key) {
    if (_.has(result, key)) result[key].push(value); else result[key] = [value];
  });

  // Indexes the object's values by a criterion, similar to `groupBy`, but for
  // when you know that your index values will be unique.
  _.indexBy = group(function(result, value, key) {
    result[key] = value;
  });

  // Counts instances of an object that group by a certain criterion. Pass
  // either a string attribute to count by, or a function that returns the
  // criterion.
  _.countBy = group(function(result, value, key) {
    if (_.has(result, key)) result[key]++; else result[key] = 1;
  });

  // Safely create a real, live array from anything iterable.
  _.toArray = function(obj) {
    if (!obj) return [];
    if (_.isArray(obj)) return slice.call(obj);
    if (isArrayLike(obj)) return _.map(obj, _.identity);
    return _.values(obj);
  };

  // Return the number of elements in an object.
  _.size = function(obj) {
    if (obj == null) return 0;
    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
  };

  // Split a collection into two arrays: one whose elements all satisfy the given
  // predicate, and one whose elements all do not satisfy the predicate.
  _.partition = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var pass = [], fail = [];
    _.each(obj, function(value, key, obj) {
      (predicate(value, key, obj) ? pass : fail).push(value);
    });
    return [pass, fail];
  };

  // Array Functions
  // ---------------

  // Get the first element of an array. Passing **n** will return the first N
  // values in the array. Aliased as `head` and `take`. The **guard** check
  // allows it to work with `_.map`.
  _.first = _.head = _.take = function(array, n, guard) {
    if (array == null) return void 0;
    if (n == null || guard) return array[0];
    return _.initial(array, array.length - n);
  };

  // Returns everything but the last entry of the array. Especially useful on
  // the arguments object. Passing **n** will return all the values in
  // the array, excluding the last N.
  _.initial = function(array, n, guard) {
    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
  };

  // Get the last element of an array. Passing **n** will return the last N
  // values in the array.
  _.last = function(array, n, guard) {
    if (array == null) return void 0;
    if (n == null || guard) return array[array.length - 1];
    return _.rest(array, Math.max(0, array.length - n));
  };

  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
  // Especially useful on the arguments object. Passing an **n** will return
  // the rest N values in the array.
  _.rest = _.tail = _.drop = function(array, n, guard) {
    return slice.call(array, n == null || guard ? 1 : n);
  };

  // Trim out all falsy values from an array.
  _.compact = function(array) {
    return _.filter(array, _.identity);
  };

  // Internal implementation of a recursive `flatten` function.
  var flatten = function(input, shallow, strict, startIndex) {
    var output = [], idx = 0;
    for (var i = startIndex || 0, length = getLength(input); i < length; i++) {
      var value = input[i];
      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
        //flatten current level of array or arguments object
        if (!shallow) value = flatten(value, shallow, strict);
        var j = 0, len = value.length;
        output.length += len;
        while (j < len) {
          output[idx++] = value[j++];
        }
      } else if (!strict) {
        output[idx++] = value;
      }
    }
    return output;
  };

  // Flatten out an array, either recursively (by default), or just one level.
  _.flatten = function(array, shallow) {
    return flatten(array, shallow, false);
  };

  // Return a version of the array that does not contain the specified value(s).
  _.without = function(array) {
    return _.difference(array, slice.call(arguments, 1));
  };

  // Produce a duplicate-free version of the array. If the array has already
  // been sorted, you have the option of using a faster algorithm.
  // Aliased as `unique`.
  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
    if (!_.isBoolean(isSorted)) {
      context = iteratee;
      iteratee = isSorted;
      isSorted = false;
    }
    if (iteratee != null) iteratee = cb(iteratee, context);
    var result = [];
    var seen = [];
    for (var i = 0, length = getLength(array); i < length; i++) {
      var value = array[i],
          computed = iteratee ? iteratee(value, i, array) : value;
      if (isSorted) {
        if (!i || seen !== computed) result.push(value);
        seen = computed;
      } else if (iteratee) {
        if (!_.contains(seen, computed)) {
          seen.push(computed);
          result.push(value);
        }
      } else if (!_.contains(result, value)) {
        result.push(value);
      }
    }
    return result;
  };

  // Produce an array that contains the union: each distinct element from all of
  // the passed-in arrays.
  _.union = function() {
    return _.uniq(flatten(arguments, true, true));
  };

  // Produce an array that contains every item shared between all the
  // passed-in arrays.
  _.intersection = function(array) {
    var result = [];
    var argsLength = arguments.length;
    for (var i = 0, length = getLength(array); i < length; i++) {
      var item = array[i];
      if (_.contains(result, item)) continue;
      for (var j = 1; j < argsLength; j++) {
        if (!_.contains(arguments[j], item)) break;
      }
      if (j === argsLength) result.push(item);
    }
    return result;
  };

  // Take the difference between one array and a number of other arrays.
  // Only the elements present in just the first array will remain.
  _.difference = function(array) {
    var rest = flatten(arguments, true, true, 1);
    return _.filter(array, function(value){
      return !_.contains(rest, value);
    });
  };

  // Zip together multiple lists into a single array -- elements that share
  // an index go together.
  _.zip = function() {
    return _.unzip(arguments);
  };

  // Complement of _.zip. Unzip accepts an array of arrays and groups
  // each array's elements on shared indices
  _.unzip = function(array) {
    var length = array && _.max(array, getLength).length || 0;
    var result = Array(length);

    for (var index = 0; index < length; index++) {
      result[index] = _.pluck(array, index);
    }
    return result;
  };

  // Converts lists into objects. Pass either a single array of `[key, value]`
  // pairs, or two parallel arrays of the same length -- one of keys, and one of
  // the corresponding values.
  _.object = function(list, values) {
    var result = {};
    for (var i = 0, length = getLength(list); i < length; i++) {
      if (values) {
        result[list[i]] = values[i];
      } else {
        result[list[i][0]] = list[i][1];
      }
    }
    return result;
  };

  // Generator function to create the findIndex and findLastIndex functions
  function createPredicateIndexFinder(dir) {
    return function(array, predicate, context) {
      predicate = cb(predicate, context);
      var length = getLength(array);
      var index = dir > 0 ? 0 : length - 1;
      for (; index >= 0 && index < length; index += dir) {
        if (predicate(array[index], index, array)) return index;
      }
      return -1;
    };
  }

  // Returns the first index on an array-like that passes a predicate test
  _.findIndex = createPredicateIndexFinder(1);
  _.findLastIndex = createPredicateIndexFinder(-1);

  // Use a comparator function to figure out the smallest index at which
  // an object should be inserted so as to maintain order. Uses binary search.
  _.sortedIndex = function(array, obj, iteratee, context) {
    iteratee = cb(iteratee, context, 1);
    var value = iteratee(obj);
    var low = 0, high = getLength(array);
    while (low < high) {
      var mid = Math.floor((low + high) / 2);
      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
    }
    return low;
  };

  // Generator function to create the indexOf and lastIndexOf functions
  function createIndexFinder(dir, predicateFind, sortedIndex) {
    return function(array, item, idx) {
      var i = 0, length = getLength(array);
      if (typeof idx == 'number') {
        if (dir > 0) {
            i = idx >= 0 ? idx : Math.max(idx + length, i);
        } else {
            length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
        }
      } else if (sortedIndex && idx && length) {
        idx = sortedIndex(array, item);
        return array[idx] === item ? idx : -1;
      }
      if (item !== item) {
        idx = predicateFind(slice.call(array, i, length), _.isNaN);
        return idx >= 0 ? idx + i : -1;
      }
      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
        if (array[idx] === item) return idx;
      }
      return -1;
    };
  }

  // Return the position of the first occurrence of an item in an array,
  // or -1 if the item is not included in the array.
  // If the array is large and already in sort order, pass `true`
  // for **isSorted** to use binary search.
  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);

  // Generate an integer Array containing an arithmetic progression. A port of
  // the native Python `range()` function. See
  // [the Python documentation](http://docs.python.org/library/functions.html#range).
  _.range = function(start, stop, step) {
    if (stop == null) {
      stop = start || 0;
      start = 0;
    }
    step = step || 1;

    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);

    for (var idx = 0; idx < length; idx++, start += step) {
      range[idx] = start;
    }

    return range;
  };

  // Function (ahem) Functions
  // ------------------

  // Determines whether to execute a function as a constructor
  // or a normal function with the provided arguments
  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
    var self = baseCreate(sourceFunc.prototype);
    var result = sourceFunc.apply(self, args);
    if (_.isObject(result)) return result;
    return self;
  };

  // Create a function bound to a given object (assigning `this`, and arguments,
  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
  // available.
  _.bind = function(func, context) {
    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
    var args = slice.call(arguments, 2);
    var bound = function() {
      return executeBound(func, bound, context, this, args.concat(slice.call(arguments)));
    };
    return bound;
  };

  // Partially apply a function by creating a version that has had some of its
  // arguments pre-filled, without changing its dynamic `this` context. _ acts
  // as a placeholder, allowing any combination of arguments to be pre-filled.
  _.partial = function(func) {
    var boundArgs = slice.call(arguments, 1);
    var bound = function() {
      var position = 0, length = boundArgs.length;
      var args = Array(length);
      for (var i = 0; i < length; i++) {
        args[i] = boundArgs[i] === _ ? arguments[position++] : boundArgs[i];
      }
      while (position < arguments.length) args.push(arguments[position++]);
      return executeBound(func, bound, this, this, args);
    };
    return bound;
  };

  // Bind a number of an object's methods to that object. Remaining arguments
  // are the method names to be bound. Useful for ensuring that all callbacks
  // defined on an object belong to it.
  _.bindAll = function(obj) {
    var i, length = arguments.length, key;
    if (length <= 1) throw new Error('bindAll must be passed function names');
    for (i = 1; i < length; i++) {
      key = arguments[i];
      obj[key] = _.bind(obj[key], obj);
    }
    return obj;
  };

  // Memoize an expensive function by storing its results.
  _.memoize = function(func, hasher) {
    var memoize = function(key) {
      var cache = memoize.cache;
      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
      if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
      return cache[address];
    };
    memoize.cache = {};
    return memoize;
  };

  // Delays a function for the given number of milliseconds, and then calls
  // it with the arguments supplied.
  _.delay = function(func, wait) {
    var args = slice.call(arguments, 2);
    return setTimeout(function(){
      return func.apply(null, args);
    }, wait);
  };

  // Defers a function, scheduling it to run after the current call stack has
  // cleared.
  _.defer = _.partial(_.delay, _, 1);

  // Returns a function, that, when invoked, will only be triggered at most once
  // during a given window of time. Normally, the throttled function will run
  // as much as it can, without ever going more than once per `wait` duration;
  // but if you'd like to disable the execution on the leading edge, pass
  // `{leading: false}`. To disable execution on the trailing edge, ditto.
  _.throttle = function(func, wait, options) {
    var context, args, result;
    var timeout = null;
    var previous = 0;
    if (!options) options = {};
    var later = function() {
      previous = options.leading === false ? 0 : _.now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };
    return function() {
      var now = _.now();
      if (!previous && options.leading === false) previous = now;
      var remaining = wait - (now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = now;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };
  };

  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  _.debounce = function(func, wait, immediate) {
    var timeout, args, context, timestamp, result;

    var later = function() {
      var last = _.now() - timestamp;

      if (last < wait && last >= 0) {
        timeout = setTimeout(later, wait - last);
      } else {
        timeout = null;
        if (!immediate) {
          result = func.apply(context, args);
          if (!timeout) context = args = null;
        }
      }
    };

    return function() {
      context = this;
      args = arguments;
      timestamp = _.now();
      var callNow = immediate && !timeout;
      if (!timeout) timeout = setTimeout(later, wait);
      if (callNow) {
        result = func.apply(context, args);
        context = args = null;
      }

      return result;
    };
  };

  // Returns the first function passed as an argument to the second,
  // allowing you to adjust arguments, run code before and after, and
  // conditionally execute the original function.
  _.wrap = function(func, wrapper) {
    return _.partial(wrapper, func);
  };

  // Returns a negated version of the passed-in predicate.
  _.negate = function(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    };
  };

  // Returns a function that is the composition of a list of functions, each
  // consuming the return value of the function that follows.
  _.compose = function() {
    var args = arguments;
    var start = args.length - 1;
    return function() {
      var i = start;
      var result = args[start].apply(this, arguments);
      while (i--) result = args[i].call(this, result);
      return result;
    };
  };

  // Returns a function that will only be executed on and after the Nth call.
  _.after = function(times, func) {
    return function() {
      if (--times < 1) {
        return func.apply(this, arguments);
      }
    };
  };

  // Returns a function that will only be executed up to (but not including) the Nth call.
  _.before = function(times, func) {
    var memo;
    return function() {
      if (--times > 0) {
        memo = func.apply(this, arguments);
      }
      if (times <= 1) func = null;
      return memo;
    };
  };

  // Returns a function that will be executed at most one time, no matter how
  // often you call it. Useful for lazy initialization.
  _.once = _.partial(_.before, 2);

  // Object Functions
  // ----------------

  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
                      'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];

  function collectNonEnumProps(obj, keys) {
    var nonEnumIdx = nonEnumerableProps.length;
    var constructor = obj.constructor;
    var proto = (_.isFunction(constructor) && constructor.prototype) || ObjProto;

    // Constructor is a special case.
    var prop = 'constructor';
    if (_.has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);

    while (nonEnumIdx--) {
      prop = nonEnumerableProps[nonEnumIdx];
      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
        keys.push(prop);
      }
    }
  }

  // Retrieve the names of an object's own properties.
  // Delegates to **ECMAScript 5**'s native `Object.keys`
  _.keys = function(obj) {
    if (!_.isObject(obj)) return [];
    if (nativeKeys) return nativeKeys(obj);
    var keys = [];
    for (var key in obj) if (_.has(obj, key)) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve all the property names of an object.
  _.allKeys = function(obj) {
    if (!_.isObject(obj)) return [];
    var keys = [];
    for (var key in obj) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve the values of an object's properties.
  _.values = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var values = Array(length);
    for (var i = 0; i < length; i++) {
      values[i] = obj[keys[i]];
    }
    return values;
  };

  // Returns the results of applying the iteratee to each element of the object
  // In contrast to _.map it returns an object
  _.mapObject = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys =  _.keys(obj),
          length = keys.length,
          results = {},
          currentKey;
      for (var index = 0; index < length; index++) {
        currentKey = keys[index];
        results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
      }
      return results;
  };

  // Convert an object into a list of `[key, value]` pairs.
  _.pairs = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var pairs = Array(length);
    for (var i = 0; i < length; i++) {
      pairs[i] = [keys[i], obj[keys[i]]];
    }
    return pairs;
  };

  // Invert the keys and values of an object. The values must be serializable.
  _.invert = function(obj) {
    var result = {};
    var keys = _.keys(obj);
    for (var i = 0, length = keys.length; i < length; i++) {
      result[obj[keys[i]]] = keys[i];
    }
    return result;
  };

  // Return a sorted list of the function names available on the object.
  // Aliased as `methods`
  _.functions = _.methods = function(obj) {
    var names = [];
    for (var key in obj) {
      if (_.isFunction(obj[key])) names.push(key);
    }
    return names.sort();
  };

  // Extend a given object with all the properties in passed-in object(s).
  _.extend = createAssigner(_.allKeys);

  // Assigns a given object with all the own properties in the passed-in object(s)
  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
  _.extendOwn = _.assign = createAssigner(_.keys);

  // Returns the first key on an object that passes a predicate test
  _.findKey = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = _.keys(obj), key;
    for (var i = 0, length = keys.length; i < length; i++) {
      key = keys[i];
      if (predicate(obj[key], key, obj)) return key;
    }
  };

  // Return a copy of the object only containing the whitelisted properties.
  _.pick = function(object, oiteratee, context) {
    var result = {}, obj = object, iteratee, keys;
    if (obj == null) return result;
    if (_.isFunction(oiteratee)) {
      keys = _.allKeys(obj);
      iteratee = optimizeCb(oiteratee, context);
    } else {
      keys = flatten(arguments, false, false, 1);
      iteratee = function(value, key, obj) { return key in obj; };
      obj = Object(obj);
    }
    for (var i = 0, length = keys.length; i < length; i++) {
      var key = keys[i];
      var value = obj[key];
      if (iteratee(value, key, obj)) result[key] = value;
    }
    return result;
  };

   // Return a copy of the object without the blacklisted properties.
  _.omit = function(obj, iteratee, context) {
    if (_.isFunction(iteratee)) {
      iteratee = _.negate(iteratee);
    } else {
      var keys = _.map(flatten(arguments, false, false, 1), String);
      iteratee = function(value, key) {
        return !_.contains(keys, key);
      };
    }
    return _.pick(obj, iteratee, context);
  };

  // Fill in a given object with default properties.
  _.defaults = createAssigner(_.allKeys, true);

  // Creates an object that inherits from the given prototype object.
  // If additional properties are provided then they will be added to the
  // created object.
  _.create = function(prototype, props) {
    var result = baseCreate(prototype);
    if (props) _.extendOwn(result, props);
    return result;
  };

  // Create a (shallow-cloned) duplicate of an object.
  _.clone = function(obj) {
    if (!_.isObject(obj)) return obj;
    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
  };

  // Invokes interceptor with the obj, and then returns obj.
  // The primary purpose of this method is to "tap into" a method chain, in
  // order to perform operations on intermediate results within the chain.
  _.tap = function(obj, interceptor) {
    interceptor(obj);
    return obj;
  };

  // Returns whether an object has a given set of `key:value` pairs.
  _.isMatch = function(object, attrs) {
    var keys = _.keys(attrs), length = keys.length;
    if (object == null) return !length;
    var obj = Object(object);
    for (var i = 0; i < length; i++) {
      var key = keys[i];
      if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }
    return true;
  };


  // Internal recursive comparison function for `isEqual`.
  var eq = function(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // A strict comparison is necessary because `null == undefined`.
    if (a == null || b == null) return a === b;
    // Unwrap any wrapped objects.
    if (a instanceof _) a = a._wrapped;
    if (b instanceof _) b = b._wrapped;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch (className) {
      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
      case '[object RegExp]':
      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
      case '[object String]':
        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
        // equivalent to `new String("5")`.
        return '' + a === '' + b;
      case '[object Number]':
        // `NaN`s are equivalent, but non-reflexive.
        // Object(NaN) is equivalent to NaN
        if (+a !== +a) return +b !== +b;
        // An `egal` comparison is performed for other numeric values.
        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
      case '[object Date]':
      case '[object Boolean]':
        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
        // millisecond representations. Note that invalid dates with millisecond representations
        // of `NaN` are not equivalent.
        return +a === +b;
    }

    var areArrays = className === '[object Array]';
    if (!areArrays) {
      if (typeof a != 'object' || typeof b != 'object') return false;

      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
      // from different frames are.
      var aCtor = a.constructor, bCtor = b.constructor;
      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
                               _.isFunction(bCtor) && bCtor instanceof bCtor)
                          && ('constructor' in a && 'constructor' in b)) {
        return false;
      }
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
      // Linear search. Performance is inversely proportional to the number of
      // unique nested structures.
      if (aStack[length] === a) return bStack[length] === b;
    }

    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);

    // Recursively compare objects and arrays.
    if (areArrays) {
      // Compare array lengths to determine if a deep comparison is necessary.
      length = a.length;
      if (length !== b.length) return false;
      // Deep compare the contents, ignoring non-numeric properties.
      while (length--) {
        if (!eq(a[length], b[length], aStack, bStack)) return false;
      }
    } else {
      // Deep compare objects.
      var keys = _.keys(a), key;
      length = keys.length;
      // Ensure that both objects contain the same number of properties before comparing deep equality.
      if (_.keys(b).length !== length) return false;
      while (length--) {
        // Deep compare each member
        key = keys[length];
        if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
      }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
  };

  // Perform a deep comparison to check if two objects are equal.
  _.isEqual = function(a, b) {
    return eq(a, b);
  };

  // Is a given array, string, or object empty?
  // An "empty" object has no enumerable own-properties.
  _.isEmpty = function(obj) {
    if (obj == null) return true;
    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
    return _.keys(obj).length === 0;
  };

  // Is a given value a DOM element?
  _.isElement = function(obj) {
    return !!(obj && obj.nodeType === 1);
  };

  // Is a given value an array?
  // Delegates to ECMA5's native Array.isArray
  _.isArray = nativeIsArray || function(obj) {
    return toString.call(obj) === '[object Array]';
  };

  // Is a given variable an object?
  _.isObject = function(obj) {
    var type = typeof obj;
    return type === 'function' || type === 'object' && !!obj;
  };

  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError.
  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function(name) {
    _['is' + name] = function(obj) {
      return toString.call(obj) === '[object ' + name + ']';
    };
  });

  // Define a fallback version of the method in browsers (ahem, IE < 9), where
  // there isn't any inspectable "Arguments" type.
  if (!_.isArguments(arguments)) {
    _.isArguments = function(obj) {
      return _.has(obj, 'callee');
    };
  }

  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
  // IE 11 (#1621), and in Safari 8 (#1929).
  if (typeof /./ != 'function' && typeof Int8Array != 'object') {
    _.isFunction = function(obj) {
      return typeof obj == 'function' || false;
    };
  }

  // Is a given object a finite number?
  _.isFinite = function(obj) {
    return isFinite(obj) && !isNaN(parseFloat(obj));
  };

  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
  _.isNaN = function(obj) {
    return _.isNumber(obj) && obj !== +obj;
  };

  // Is a given value a boolean?
  _.isBoolean = function(obj) {
    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
  };

  // Is a given value equal to null?
  _.isNull = function(obj) {
    return obj === null;
  };

  // Is a given variable undefined?
  _.isUndefined = function(obj) {
    return obj === void 0;
  };

  // Shortcut function for checking if an object has a given property directly
  // on itself (in other words, not on a prototype).
  _.has = function(obj, key) {
    return obj != null && hasOwnProperty.call(obj, key);
  };

  // Utility Functions
  // -----------------

  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
  // previous owner. Returns a reference to the Underscore object.
  _.noConflict = function() {
    root._ = previousUnderscore;
    return this;
  };

  // Keep the identity function around for default iteratees.
  _.identity = function(value) {
    return value;
  };

  // Predicate-generating functions. Often useful outside of Underscore.
  _.constant = function(value) {
    return function() {
      return value;
    };
  };

  _.noop = function(){};

  _.property = property;

  // Generates a function for a given object that returns a given property.
  _.propertyOf = function(obj) {
    return obj == null ? function(){} : function(key) {
      return obj[key];
    };
  };

  // Returns a predicate for checking whether an object has a given set of
  // `key:value` pairs.
  _.matcher = _.matches = function(attrs) {
    attrs = _.extendOwn({}, attrs);
    return function(obj) {
      return _.isMatch(obj, attrs);
    };
  };

  // Run a function **n** times.
  _.times = function(n, iteratee, context) {
    var accum = Array(Math.max(0, n));
    iteratee = optimizeCb(iteratee, context, 1);
    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
    return accum;
  };

  // Return a random integer between min and max (inclusive).
  _.random = function(min, max) {
    if (max == null) {
      max = min;
      min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
  };

  // A (possibly faster) way to get the current timestamp as an integer.
  _.now = Date.now || function() {
    return new Date().getTime();
  };

   // List of HTML entities for escaping.
  var escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
  };
  var unescapeMap = _.invert(escapeMap);

  // Functions for escaping and unescaping strings to/from HTML interpolation.
  var createEscaper = function(map) {
    var escaper = function(match) {
      return map[match];
    };
    // Regexes for identifying a key that needs to be escaped
    var source = '(?:' + _.keys(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function(string) {
      string = string == null ? '' : '' + string;
      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
  };
  _.escape = createEscaper(escapeMap);
  _.unescape = createEscaper(unescapeMap);

  // If the value of the named `property` is a function then invoke it with the
  // `object` as context; otherwise, return it.
  _.result = function(object, property, fallback) {
    var value = object == null ? void 0 : object[property];
    if (value === void 0) {
      value = fallback;
    }
    return _.isFunction(value) ? value.call(object) : value;
  };

  // Generate a unique integer id (unique within the entire client session).
  // Useful for temporary DOM ids.
  var idCounter = 0;
  _.uniqueId = function(prefix) {
    var id = ++idCounter + '';
    return prefix ? prefix + id : id;
  };

  // By default, Underscore uses ERB-style template delimiters, change the
  // following template settings to use alternative delimiters.
  _.templateSettings = {
    evaluate    : /<%([\s\S]+?)%>/g,
    interpolate : /<%=([\s\S]+?)%>/g,
    escape      : /<%-([\s\S]+?)%>/g
  };

  // When customizing `templateSettings`, if you don't want to define an
  // interpolation, evaluation or escaping regex, we need one that is
  // guaranteed not to match.
  var noMatch = /(.)^/;

  // Certain characters need to be escaped so that they can be put into a
  // string literal.
  var escapes = {
    "'":      "'",
    '\\':     '\\',
    '\r':     'r',
    '\n':     'n',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  var escaper = /\\|'|\r|\n|\u2028|\u2029/g;

  var escapeChar = function(match) {
    return '\\' + escapes[match];
  };

  // JavaScript micro-templating, similar to John Resig's implementation.
  // Underscore templating handles arbitrary delimiters, preserves whitespace,
  // and correctly escapes quotes within interpolated code.
  // NB: `oldSettings` only exists for backwards compatibility.
  _.template = function(text, settings, oldSettings) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = _.defaults({}, settings, _.templateSettings);

    // Combine delimiters into one regular expression via alternation.
    var matcher = RegExp([
      (settings.escape || noMatch).source,
      (settings.interpolate || noMatch).source,
      (settings.evaluate || noMatch).source
    ].join('|') + '|$', 'g');

    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
      source += text.slice(index, offset).replace(escaper, escapeChar);
      index = offset + match.length;

      if (escape) {
        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
      } else if (interpolate) {
        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
      } else if (evaluate) {
        source += "';\n" + evaluate + "\n__p+='";
      }

      // Adobe VMs need the match returned to produce the correct offest.
      return match;
    });
    source += "';\n";

    // If a variable is not specified, place data values in local scope.
    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';

    source = "var __t,__p='',__j=Array.prototype.join," +
      "print=function(){__p+=__j.call(arguments,'');};\n" +
      source + 'return __p;\n';

    try {
      var render = new Function(settings.variable || 'obj', '_', source);
    } catch (e) {
      e.source = source;
      throw e;
    }

    var template = function(data) {
      return render.call(this, data, _);
    };

    // Provide the compiled source as a convenience for precompilation.
    var argument = settings.variable || 'obj';
    template.source = 'function(' + argument + '){\n' + source + '}';

    return template;
  };

  // Add a "chain" function. Start chaining a wrapped Underscore object.
  _.chain = function(obj) {
    var instance = _(obj);
    instance._chain = true;
    return instance;
  };

  // OOP
  // ---------------
  // If Underscore is called as a function, it returns a wrapped object that
  // can be used OO-style. This wrapper holds altered versions of all the
  // underscore functions. Wrapped objects may be chained.

  // Helper function to continue chaining intermediate results.
  var result = function(instance, obj) {
    return instance._chain ? _(obj).chain() : obj;
  };

  // Add your own custom functions to the Underscore object.
  _.mixin = function(obj) {
    _.each(_.functions(obj), function(name) {
      var func = _[name] = obj[name];
      _.prototype[name] = function() {
        var args = [this._wrapped];
        push.apply(args, arguments);
        return result(this, func.apply(_, args));
      };
    });
  };

  // Add all of the Underscore functions to the wrapper object.
  _.mixin(_);

  // Add all mutator Array functions to the wrapper.
  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      var obj = this._wrapped;
      method.apply(obj, arguments);
      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
      return result(this, obj);
    };
  });

  // Add all accessor Array functions to the wrapper.
  _.each(['concat', 'join', 'slice'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      return result(this, method.apply(this._wrapped, arguments));
    };
  });

  // Extracts the result from a wrapped and chained object.
  _.prototype.value = function() {
    return this._wrapped;
  };

  // Provide unwrapping proxy for some methods used in engine operations
  // such as arithmetic and JSON stringification.
  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;

  _.prototype.toString = function() {
    return '' + this._wrapped;
  };

  // AMD registration happens at the end for compatibility with AMD loaders
  // that may not enforce next-turn semantics on modules. Even though general
  // practice for AMD registration is to be anonymous, underscore registers
  // as a named module because, like jQuery, it is a base library that is
  // popular enough to be bundled in a third party lib, but not be part of
  // an AMD load request. Those cases could generate an error when an
  // anonymous define() is called outside of a loader request.
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
}.call(this));


/***/ }),

/***/ "A+3H":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, wrap-iife, no-var, no-param-reassign, no-cond-assign, quotes, one-var, one-var-declaration-per-line, operator-assignment, no-else-return, prefer-template, prefer-arrow-callback, no-empty, max-len, consistent-return, no-unused-vars, no-return-assign, max-len */

__webpack_require__("xxp0");

(function () {
  (function (w) {
    var base;
    if (w.gl == null) {
      w.gl = {};
    }
    if ((base = w.gl).text == null) {
      base.text = {};
    }
    gl.text.addDelimiter = function (text) {
      return text ? text.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : text;
    };
    gl.text.highCountTrim = function (count) {
      return count > 99 ? '99+' : count;
    };
    gl.text.randomString = function () {
      return Math.random().toString(36).substring(7);
    };
    gl.text.replaceRange = function (s, start, end, substitute) {
      return s.substring(0, start) + substitute + s.substring(end);
    };
    gl.text.getTextWidth = function (text, font) {
      /**
      * Uses canvas.measureText to compute and return the width of the given text of given font in pixels.
      *
      * @param {String} text The text to be rendered.
      * @param {String} font The css font descriptor that text is to be rendered with (e.g. "bold 14px verdana").
      *
      * @see http://stackoverflow.com/questions/118241/calculate-text-width-with-javascript/21015393#21015393
      */
      // re-use canvas object for better performance
      var canvas = gl.text.getTextWidth.canvas || (gl.text.getTextWidth.canvas = document.createElement('canvas'));
      var context = canvas.getContext('2d');
      context.font = font;
      return context.measureText(text).width;
    };
    gl.text.selectedText = function (text, textarea) {
      return text.substring(textarea.selectionStart, textarea.selectionEnd);
    };
    gl.text.lineBefore = function (text, textarea) {
      var split;
      split = text.substring(0, textarea.selectionStart).trim().split('\n');
      return split[split.length - 1];
    };
    gl.text.lineAfter = function (text, textarea) {
      return text.substring(textarea.selectionEnd).trim().split('\n')[0];
    };
    gl.text.blockTagText = function (text, textArea, blockTag, selected) {
      var lineAfter, lineBefore;
      lineBefore = this.lineBefore(text, textArea);
      lineAfter = this.lineAfter(text, textArea);
      if (lineBefore === blockTag && lineAfter === blockTag) {
        // To remove the block tag we have to select the line before & after
        if (blockTag != null) {
          textArea.selectionStart = textArea.selectionStart - (blockTag.length + 1);
          textArea.selectionEnd = textArea.selectionEnd + (blockTag.length + 1);
        }
        return selected;
      } else {
        return blockTag + "\n" + selected + "\n" + blockTag;
      }
    };
    gl.text.insertText = function (textArea, text, tag, blockTag, selected, wrap) {
      var insertText, inserted, selectedSplit, startChar, removedLastNewLine, removedFirstNewLine, currentLineEmpty, lastNewLine;
      removedLastNewLine = false;
      removedFirstNewLine = false;
      currentLineEmpty = false;

      // Remove the first newline
      if (selected.indexOf('\n') === 0) {
        removedFirstNewLine = true;
        selected = selected.replace(/\n+/, '');
      }

      // Remove the last newline
      if (textArea.selectionEnd - textArea.selectionStart > selected.replace(/\n$/, '').length) {
        removedLastNewLine = true;
        selected = selected.replace(/\n$/, '');
      }

      selectedSplit = selected.split('\n');

      if (!wrap) {
        lastNewLine = textArea.value.substr(0, textArea.selectionStart).lastIndexOf('\n');

        // Check whether the current line is empty or consists only of spaces(=handle as empty)
        if (/^\s*$/.test(textArea.value.substring(lastNewLine, textArea.selectionStart))) {
          currentLineEmpty = true;
        }
      }

      startChar = !wrap && !currentLineEmpty && textArea.selectionStart > 0 ? '\n' : '';

      if (selectedSplit.length > 1 && (!wrap || blockTag != null)) {
        if (blockTag != null) {
          insertText = this.blockTagText(text, textArea, blockTag, selected);
        } else {
          insertText = selectedSplit.map(function (val) {
            if (val.indexOf(tag) === 0) {
              return "" + val.replace(tag, '');
            } else {
              return "" + tag + val;
            }
          }).join('\n');
        }
      } else {
        insertText = "" + startChar + tag + selected + (wrap ? tag : ' ');
      }

      if (removedFirstNewLine) {
        insertText = '\n' + insertText;
      }

      if (removedLastNewLine) {
        insertText += '\n';
      }

      if (document.queryCommandSupported('insertText')) {
        inserted = document.execCommand('insertText', false, insertText);
      }
      if (!inserted) {
        try {
          document.execCommand("ms-beginUndoUnit");
        } catch (error) {}
        textArea.value = this.replaceRange(text, textArea.selectionStart, textArea.selectionEnd, insertText);
        try {
          document.execCommand("ms-endUndoUnit");
        } catch (error) {}
      }
      return this.moveCursor(textArea, tag, wrap, removedLastNewLine);
    };
    gl.text.moveCursor = function (textArea, tag, wrapped, removedLastNewLine) {
      var pos;
      if (!textArea.setSelectionRange) {
        return;
      }
      if (textArea.selectionStart === textArea.selectionEnd) {
        if (wrapped) {
          pos = textArea.selectionStart - tag.length;
        } else {
          pos = textArea.selectionStart;
        }

        if (removedLastNewLine) {
          pos -= 1;
        }

        return textArea.setSelectionRange(pos, pos);
      }
    };
    gl.text.updateText = function (textArea, tag, blockTag, wrap) {
      var $textArea, selected, text;
      $textArea = $(textArea);
      textArea = $textArea.get(0);
      text = $textArea.val();
      selected = this.selectedText(text, textArea);
      $textArea.focus();
      return this.insertText(textArea, text, tag, blockTag, selected, wrap);
    };
    gl.text.init = function (form) {
      var self;
      self = this;
      return $('.js-md', form).off('click').on('click', function () {
        var $this;
        $this = $(this);
        return self.updateText($this.closest('.md-area').find('textarea'), $this.data('md-tag'), $this.data('md-block'), !$this.data('md-prepend'));
      });
    };
    gl.text.removeListeners = function (form) {
      return $('.js-md', form).off();
    };
    gl.text.humanize = function (string) {
      return string.charAt(0).toUpperCase() + string.replace(/_/g, ' ').slice(1);
    };
    gl.text.pluralize = function (str, count) {
      return str + (count > 1 || count === 0 ? 's' : '');
    };
    gl.text.truncate = function (string, maxLength) {
      return string.substr(0, maxLength - 3) + '...';
    };
    gl.text.dasherize = function (str) {
      return str.replace(/[_\s]+/g, '-');
    };
    gl.text.slugify = function (str) {
      return str.trim().toLowerCase().latinise();
    };
  })(window);
}).call(window);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "AzRg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__commons_bootstrap__ = __webpack_require__("jBf/");


// Quick Submit behavior
//
// When a child field of a form with a `js-quick-submit` class receives a
// "Meta+Enter" (Mac) or "Ctrl+Enter" (Linux/Windows) key combination, the form
// is submitted.
//
// ### Example Markup
//
//   <form action="/foo" class="js-quick-submit">
//     <input type="text" />
//     <textarea></textarea>
//     <input type="submit" value="Submit" />
//   </form>
//

function isMac() {
  return navigator.userAgent.match(/Macintosh/);
}

function keyCodeIs(e, keyCode) {
  if (e.originalEvent && e.originalEvent.repeat || e.repeat) {
    return false;
  }
  return e.keyCode === keyCode;
}

$(document).on('keydown.quick_submit', '.js-quick-submit', function (e) {
  // Enter
  if (!keyCodeIs(e, 13)) {
    return;
  }

  var onlyMeta = e.metaKey && !e.altKey && !e.ctrlKey && !e.shiftKey;
  var onlyCtrl = e.ctrlKey && !e.altKey && !e.metaKey && !e.shiftKey;
  if (!onlyMeta && !onlyCtrl) {
    return;
  }

  e.preventDefault();
  var $form = $(e.target).closest('form');
  var $submitButton = $form.find('input[type=submit], button[type=submit]');

  if (!$submitButton.attr('disabled')) {
    $submitButton.disable();
    $form.submit();
  }
});

// If the user tabs to a submit button on a `js-quick-submit` form, display a
// tooltip to let them know they could've used the hotkey
$(document).on('keyup.quick_submit', '.js-quick-submit input[type=submit], .js-quick-submit button[type=submit]', function displayTooltip(e) {
  // Tab
  if (!keyCodeIs(e, 9)) {
    return;
  }

  var $this = $(this);
  var title = isMac() ? 'You can also press &#8984;-Enter' : 'You can also press Ctrl-Enter';

  $this.tooltip({
    container: 'body',
    html: 'true',
    placement: 'auto top',
    title: title,
    trigger: 'manual'
  });
  $this.tooltip('show').one('blur', function () {
    return $this.tooltip('hide');
  });
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("lwLq")))

/***/ }),

/***/ "BInT":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, prefer-arrow-callback, no-var */

$(document).on('todo:toggle', function (e, count) {
  var $todoPendingCount = $('.todos-count');
  $todoPendingCount.text(gl.text.highCountTrim(count));
  $todoPendingCount.toggleClass('hidden', count === 0);
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "BO5O":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, consistent-return, no-var, no-else-return, prefer-arrow-callback, max-len */

// Render Gitlab flavoured Markdown
//
// Delegates to syntax highlight and render math
//
(function () {
  $.fn.renderGFM = function () {
    this.find('.js-syntax-highlight').syntaxHighlight();
    this.find('.js-render-math').renderMath();
    return this;
  };

  $(document).on('ready load', function () {
    return $('body').renderGFM();
  });
}).call(window);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "CH+5":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, no-var, prefer-rest-params, wrap-iife, max-len, one-var, one-var-declaration-per-line, quotes, prefer-template, newline-per-chained-call, comma-dangle, new-cap, no-else-return, consistent-return */
/* global FilesCommentButton */
/* global notes */

var $commentButtonTemplate = void 0;
var bind = function bind(fn, me) {
  return function () {
    return fn.apply(me, arguments);
  };
};

window.FilesCommentButton = function () {
  var COMMENT_BUTTON_CLASS, EMPTY_CELL_CLASS, LINE_COLUMN_CLASSES, LINE_CONTENT_CLASS, LINE_HOLDER_CLASS, LINE_NUMBER_CLASS, OLD_LINE_CLASS, TEXT_FILE_SELECTOR, UNFOLDABLE_LINE_CLASS;

  COMMENT_BUTTON_CLASS = '.add-diff-note';

  LINE_HOLDER_CLASS = '.line_holder';

  LINE_NUMBER_CLASS = 'diff-line-num';

  LINE_CONTENT_CLASS = 'line_content';

  UNFOLDABLE_LINE_CLASS = 'js-unfold';

  EMPTY_CELL_CLASS = 'empty-cell';

  OLD_LINE_CLASS = 'old_line';

  LINE_COLUMN_CLASSES = "." + LINE_NUMBER_CLASS + ", .line_content";

  TEXT_FILE_SELECTOR = '.text-file';

  function FilesCommentButton(filesContainerElement) {
    this.render = bind(this.render, this);
    this.hideButton = bind(this.hideButton, this);
    this.isParallelView = notes.isParallelView();
    filesContainerElement.on('mouseover', LINE_COLUMN_CLASSES, this.render).on('mouseleave', LINE_COLUMN_CLASSES, this.hideButton);
  }

  FilesCommentButton.prototype.render = function (e) {
    var $currentTarget, buttonParentElement, lineContentElement, textFileElement, $button;
    $currentTarget = $(e.currentTarget);

    if ($currentTarget.hasClass('js-no-comment-btn')) return;

    lineContentElement = this.getLineContent($currentTarget);
    buttonParentElement = this.getButtonParent($currentTarget);

    if (!this.validateButtonParent(buttonParentElement) || !this.validateLineContent(lineContentElement)) return;

    $button = $(COMMENT_BUTTON_CLASS, buttonParentElement);
    buttonParentElement.addClass('is-over').nextUntil('.' + LINE_CONTENT_CLASS).addClass('is-over');

    if ($button.length) {
      return;
    }

    textFileElement = this.getTextFileElement($currentTarget);
    buttonParentElement.append(this.buildButton({
      discussionID: lineContentElement.attr('data-discussion-id'),
      lineType: lineContentElement.attr('data-line-type'),

      noteableType: textFileElement.attr('data-noteable-type'),
      noteableID: textFileElement.attr('data-noteable-id'),
      commitID: textFileElement.attr('data-commit-id'),
      noteType: lineContentElement.attr('data-note-type'),

      // LegacyDiffNote
      lineCode: lineContentElement.attr('data-line-code'),

      // DiffNote
      position: lineContentElement.attr('data-position')
    }));
  };

  FilesCommentButton.prototype.hideButton = function (e) {
    var $currentTarget = $(e.currentTarget);
    var buttonParentElement = this.getButtonParent($currentTarget);

    buttonParentElement.removeClass('is-over').nextUntil('.' + LINE_CONTENT_CLASS).removeClass('is-over');
  };

  FilesCommentButton.prototype.buildButton = function (buttonAttributes) {
    return $commentButtonTemplate.clone().attr({
      'data-discussion-id': buttonAttributes.discussionID,
      'data-line-type': buttonAttributes.lineType,

      'data-noteable-type': buttonAttributes.noteableType,
      'data-noteable-id': buttonAttributes.noteableID,
      'data-commit-id': buttonAttributes.commitID,
      'data-note-type': buttonAttributes.noteType,

      // LegacyDiffNote
      'data-line-code': buttonAttributes.lineCode,

      // DiffNote
      'data-position': buttonAttributes.position
    });
  };

  FilesCommentButton.prototype.getTextFileElement = function (hoveredElement) {
    return hoveredElement.closest(TEXT_FILE_SELECTOR);
  };

  FilesCommentButton.prototype.getLineContent = function (hoveredElement) {
    if (hoveredElement.hasClass(LINE_CONTENT_CLASS)) {
      return hoveredElement;
    }
    if (!this.isParallelView) {
      return $(hoveredElement).closest(LINE_HOLDER_CLASS).find("." + LINE_CONTENT_CLASS);
    } else {
      return $(hoveredElement).next("." + LINE_CONTENT_CLASS);
    }
  };

  FilesCommentButton.prototype.getButtonParent = function (hoveredElement) {
    if (!this.isParallelView) {
      if (hoveredElement.hasClass(OLD_LINE_CLASS)) {
        return hoveredElement;
      }
      return hoveredElement.parent().find("." + OLD_LINE_CLASS);
    } else {
      if (hoveredElement.hasClass(LINE_NUMBER_CLASS)) {
        return hoveredElement;
      }
      return $(hoveredElement).prev("." + LINE_NUMBER_CLASS);
    }
  };

  FilesCommentButton.prototype.validateButtonParent = function (buttonParentElement) {
    return !buttonParentElement.hasClass(EMPTY_CELL_CLASS) && !buttonParentElement.hasClass(UNFOLDABLE_LINE_CLASS);
  };

  FilesCommentButton.prototype.validateLineContent = function (lineContentElement) {
    return lineContentElement.attr('data-note-type') && lineContentElement.attr('data-note-type') !== '';
  };

  return FilesCommentButton;
}();

$.fn.filesCommentButton = function () {
  $commentButtonTemplate = $('<button name="button" type="submit" class="add-diff-note js-add-diff-note-button" title="Add a comment to this line"><i class="fa fa-comment-o"></i></button>');

  if (!(this && this.parent().data('can-create-note') != null)) {
    return;
  }
  return this.each(function () {
    if (!$.data(this, 'filesCommentButton')) {
      return $.data(this, 'filesCommentButton', new FilesCommentButton($(this)));
    }
  });
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "CPat":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getUnicodeSupportMap; });
/* unused harmony export generateUnicodeSupportMap */
var unicodeSupportTestMap = {
  // man, student (emojione does not have any of these yet), http://emojipedia.org/emoji-zwj-sequences/
  // occupationZwj: '\u{1F468}\u{200D}\u{1F393}',
  // woman, biking (emojione does not have any of these yet), http://emojipedia.org/emoji-zwj-sequences/
  // sexZwj: '\u{1F6B4}\u{200D}\u{2640}',
  // family_mwgb
  // Windows 8.1, Firefox 51.0.1 does not support `family_`, `kiss_`, `couple_`
  personZwj: '\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66',
  // horse_racing_tone5
  // Special case that is not supported on macOS 10.12 even though `skinToneModifier` succeeds
  horseRacing: '\uD83C\uDFC7\uD83C\uDFFF',
  // US flag, http://emojipedia.org/flags/
  flag: '\uD83C\uDDFA\uD83C\uDDF8',
  // http://emojipedia.org/modifiers/
  skinToneModifier: [
  // spy_tone5
  '\uD83D\uDD75\uD83C\uDFFF',
  // person_with_ball_tone5
  '\u26F9\uD83C\uDFFF',
  // angel_tone5
  '\uD83D\uDC7C\uD83C\uDFFF'],
  // rofl, http://emojipedia.org/unicode-9.0/
  '9.0': '\uD83E\uDD23',
  // metal, http://emojipedia.org/unicode-8.0/
  '8.0': '\uD83E\uDD18',
  // spy, http://emojipedia.org/unicode-7.0/
  '7.0': '\uD83D\uDD75',
  // expressionless, http://emojipedia.org/unicode-6.1/
  6.1: '\uD83D\uDE11',
  // japanese_goblin, http://emojipedia.org/unicode-6.0/
  '6.0': '\uD83D\uDC7A',
  // sailboat, http://emojipedia.org/unicode-5.2/
  5.2: '\u26F5',
  // mahjong, http://emojipedia.org/unicode-5.1/
  5.1: '\uD83C\uDC04',
  // gear, http://emojipedia.org/unicode-4.1/
  4.1: '\u2699',
  // zap, http://emojipedia.org/unicode-4.0/
  '4.0': '\u26A1',
  // recycle, http://emojipedia.org/unicode-3.2/
  3.2: '\u267B',
  // information_source, http://emojipedia.org/unicode-3.0/
  '3.0': '\u2139',
  // heart, http://emojipedia.org/unicode-1.1/
  1.1: '\u2764'
};

function checkPixelInImageDataArray(pixelOffset, imageDataArray) {
  // `4 *` because RGBA
  var indexOffset = 4 * pixelOffset;
  var hasColor = imageDataArray[indexOffset + 0] || imageDataArray[indexOffset + 1] || imageDataArray[indexOffset + 2];
  var isVisible = imageDataArray[indexOffset + 3];
  // Check for some sort of color other than black
  if (hasColor && isVisible) {
    return true;
  }
  return false;
}

var chromeMatches = navigator.userAgent.match(/Chrom(?:e|ium)\/([0-9]+)\./);
var isChrome = chromeMatches && chromeMatches.length > 0;
var chromeVersion = chromeMatches && chromeMatches[1] && parseInt(chromeMatches[1], 10);

// We use 16px because mobile Safari (iOS 9.3) doesn't properly scale emojis :/
// See 32px, https://i.imgur.com/htY6Zym.png
// See 16px, https://i.imgur.com/FPPsIF8.png
var fontSize = 16;
function generateUnicodeSupportMap(testMap) {
  var testMapKeys = Object.keys(testMap);
  var numTestEntries = testMapKeys.reduce(function (list, testKey) {
    return list.concat(testMap[testKey]);
  }, []).length;

  var canvas = document.createElement('canvas');
  (window.gl || window).testEmojiUnicodeSupportMapCanvas = canvas;
  var ctx = canvas.getContext('2d');
  canvas.width = 2 * fontSize;
  canvas.height = numTestEntries * fontSize;
  ctx.fillStyle = '#000000';
  ctx.textBaseline = 'middle';
  ctx.font = fontSize + 'px "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"';
  // Write each emoji to the canvas vertically
  var writeIndex = 0;
  testMapKeys.forEach(function (testKey) {
    var testEntry = testMap[testKey];
    [].concat(testEntry).forEach(function (emojiUnicode) {
      ctx.fillText(emojiUnicode, 0, writeIndex * fontSize + fontSize / 2);
      writeIndex += 1;
    });
  });

  // Read from the canvas
  var resultMap = {};
  var readIndex = 0;
  testMapKeys.forEach(function (testKey) {
    var testEntry = testMap[testKey];
    // This needs to be a `reduce` instead of `every` because we need to
    // keep the `readIndex` in sync from the writes by running all entries
    var isTestSatisfied = [].concat(testEntry).reduce(function (isSatisfied) {
      // Sample along the vertical-middle for a couple of characters
      var imageData = ctx.getImageData(0, readIndex * fontSize + fontSize / 2, 2 * fontSize, 1).data;

      var isValidEmoji = false;
      for (var currentPixel = 0; currentPixel < 64; currentPixel += 1) {
        var isLookingAtFirstChar = currentPixel < fontSize;
        var isLookingAtSecondChar = currentPixel >= fontSize + fontSize / 2;
        // Check for the emoji somewhere along the row
        if (isLookingAtFirstChar && checkPixelInImageDataArray(currentPixel, imageData)) {
          isValidEmoji = true;

          // Check to see that nothing is rendered next to the first character
          // to ensure that the ZWJ sequence rendered as one piece
        } else if (isLookingAtSecondChar && checkPixelInImageDataArray(currentPixel, imageData)) {
          isValidEmoji = false;
          break;
        }
      }

      readIndex += 1;
      return isSatisfied && isValidEmoji;
    }, true);

    resultMap[testKey] = isTestSatisfied;
  });

  resultMap.meta = {
    isChrome: isChrome,
    chromeVersion: chromeVersion
  };

  return resultMap;
}

function getUnicodeSupportMap() {
  var unicodeSupportMap = void 0;
  var userAgentFromCache = window.localStorage.getItem('gl-emoji-user-agent');
  try {
    unicodeSupportMap = JSON.parse(window.localStorage.getItem('gl-emoji-unicode-support-map'));
  } catch (err) {
    // swallow
  }
  if (!unicodeSupportMap || userAgentFromCache !== navigator.userAgent) {
    unicodeSupportMap = generateUnicodeSupportMap(unicodeSupportTestMap);
    window.localStorage.setItem('gl-emoji-user-agent', navigator.userAgent);
    window.localStorage.setItem('gl-emoji-unicode-support-map', JSON.stringify(unicodeSupportMap));
  }

  return unicodeSupportMap;
}



/***/ }),

/***/ "ChLi":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, wrap-iife, no-var, quotes, object-shorthand, no-unused-vars, no-shadow, one-var, one-var-declaration-per-line, comma-dangle, max-len */
(function () {
  this.IssueStatusSelect = function () {
    function IssueStatusSelect() {
      $('.js-issue-status').each(function (i, el) {
        var fieldName;
        fieldName = $(el).data("field-name");
        return $(el).glDropdown({
          selectable: true,
          fieldName: fieldName,
          toggleLabel: function (_this) {
            return function (selected, el, instance) {
              var $item, label;
              label = 'Author';
              $item = instance.dropdown.find('.is-active');
              if ($item.length) {
                label = $item.text();
              }
              return label;
            };
          }(this),
          clicked: function clicked(item, $el, e) {
            return e.preventDefault();
          },
          id: function id(obj, el) {
            return $(el).data("id");
          }
        });
      });
    }

    return IssueStatusSelect;
  }();
}).call(window);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "Cvli":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Group = function () {
  function Group() {
    _classCallCheck(this, Group);

    this.groupPath = $('#group_path');
    this.groupName = $('#group_name');
    this.updateHandler = this.update.bind(this);
    this.resetHandler = this.reset.bind(this);
    if (this.groupName.val() === '') {
      this.groupPath.on('keyup', this.updateHandler);
      this.groupName.on('keydown', this.resetHandler);
    }
  }

  _createClass(Group, [{
    key: 'update',
    value: function update() {
      this.groupName.val(this.groupPath.val());
    }
  }, {
    key: 'reset',
    value: function reset() {
      this.groupPath.off('keyup', this.updateHandler);
      this.groupName.off('keydown', this.resetHandler);
    }
  }]);

  return Group;
}();

/* harmony default export */ __webpack_exports__["default"] = (Group);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("lwLq")))

/***/ }),

/***/ "E+6d":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable max-len, space-before-function-paren, no-underscore-dangle, consistent-return, comma-dangle, no-unused-vars, dot-notation, no-new, no-return-assign, camelcase, no-param-reassign, class-methods-use-this */

/*
UserTabs

Handles persisting and restoring the current tab selection and lazily-loading
content on the Users#show page.

### Example Markup

   <ul class="nav-links">
     <li class="activity-tab active">
       <a data-action="activity" data-target="#activity" data-toggle="tab" href="/u/username">
         Activity
       </a>
     </li>
     <li class="groups-tab">
       <a data-action="groups" data-target="#groups" data-toggle="tab" href="/u/username/groups">
         Groups
       </a>
     </li>
     <li class="contributed-tab">
       <a data-action="contributed" data-target="#contributed" data-toggle="tab" href="/u/username/contributed">
         Contributed projects
       </a>
     </li>
     <li class="projects-tab">
       <a data-action="projects" data-target="#projects" data-toggle="tab" href="/u/username/projects">
         Personal projects
       </a>
     </li>
    <li class="snippets-tab">
       <a data-action="snippets" data-target="#snippets" data-toggle="tab" href="/u/username/snippets">
       </a>
     </li>
   </ul>

   <div class="tab-content">
     <div class="tab-pane" id="activity">
       Activity Content
     </div>
     <div class="tab-pane" id="groups">
       Groups Content
     </div>
     <div class="tab-pane" id="contributed">
       Contributed projects content
     </div>
     <div class="tab-pane" id="projects">
      Projects content
     </div>
     <div class="tab-pane" id="snippets">
       Snippets content
     </div>
  </div>

   <div class="loading-status">
     <div class="loading">
      Loading Animation
     </div>
   </div>
*/
(function (global) {
  var UserTabs = function () {
    function UserTabs(_ref) {
      var _this = this;

      var defaultAction = _ref.defaultAction,
          action = _ref.action,
          parentEl = _ref.parentEl;

      _classCallCheck(this, UserTabs);

      this.loaded = {};
      this.defaultAction = defaultAction || 'activity';
      this.action = action || this.defaultAction;
      this.$parentEl = $(parentEl) || $(document);
      this._location = window.location;
      this.$parentEl.find('.nav-links a').each(function (i, navLink) {
        _this.loaded[$(navLink).attr('data-action')] = false;
      });
      this.actions = Object.keys(this.loaded);
      this.bindEvents();

      if (this.action === 'show') {
        this.action = this.defaultAction;
      }

      this.activateTab(this.action);
    }

    _createClass(UserTabs, [{
      key: 'bindEvents',
      value: function bindEvents() {
        var _this2 = this;

        this.changeProjectsPageWrapper = this.changeProjectsPage.bind(this);

        this.$parentEl.off('shown.bs.tab', '.nav-links a[data-toggle="tab"]').on('shown.bs.tab', '.nav-links a[data-toggle="tab"]', function (event) {
          return _this2.tabShown(event);
        });

        this.$parentEl.on('click', '.gl-pagination a', this.changeProjectsPageWrapper);
      }
    }, {
      key: 'changeProjectsPage',
      value: function changeProjectsPage(e) {
        e.preventDefault();

        $('.tab-pane.active').empty();
        this.loadTab($(e.target).attr('href'), this.getCurrentAction());
      }
    }, {
      key: 'tabShown',
      value: function tabShown(event) {
        var $target = $(event.target);
        var action = $target.data('action');
        var source = $target.attr('href');
        this.setTab(source, action);
        return this.setCurrentAction(source, action);
      }
    }, {
      key: 'activateTab',
      value: function activateTab(action) {
        return this.$parentEl.find('.nav-links .js-' + action + '-tab a').tab('show');
      }
    }, {
      key: 'setTab',
      value: function setTab(source, action) {
        if (this.loaded[action]) {
          return;
        }
        if (action === 'activity') {
          this.loadActivities(source);
        }

        var loadableActions = ['groups', 'contributed', 'projects', 'snippets'];
        if (loadableActions.indexOf(action) > -1) {
          return this.loadTab(source, action);
        }
      }
    }, {
      key: 'loadTab',
      value: function loadTab(source, action) {
        var _this3 = this;

        return $.ajax({
          beforeSend: function beforeSend() {
            return _this3.toggleLoading(true);
          },
          complete: function complete() {
            return _this3.toggleLoading(false);
          },
          dataType: 'json',
          type: 'GET',
          url: source,
          success: function success(data) {
            var tabSelector = 'div#' + action;
            _this3.$parentEl.find(tabSelector).html(data.html);
            _this3.loaded[action] = true;
            return gl.utils.localTimeAgo($('.js-timeago', tabSelector));
          }
        });
      }
    }, {
      key: 'loadActivities',
      value: function loadActivities(source) {
        if (this.loaded['activity']) {
          return;
        }
        var $calendarWrap = this.$parentEl.find('.user-calendar');
        $calendarWrap.load($calendarWrap.data('href'));
        new gl.Activities();
        return this.loaded['activity'] = true;
      }
    }, {
      key: 'toggleLoading',
      value: function toggleLoading(status) {
        return this.$parentEl.find('.loading-status .loading').toggle(status);
      }
    }, {
      key: 'setCurrentAction',
      value: function setCurrentAction(source, action) {
        var new_state = source;
        new_state = new_state.replace(/\/+$/, '');
        new_state += this._location.search + this._location.hash;
        history.replaceState({
          url: new_state
        }, document.title, new_state);
        return new_state;
      }
    }, {
      key: 'getCurrentAction',
      value: function getCurrentAction() {
        return this.$parentEl.find('.nav-links .active a').data('action');
      }
    }]);

    return UserTabs;
  }();

  global.UserTabs = UserTabs;
})(window.gl || (window.gl = {}));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "EKdV":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, wrap-iife, no-var, no-use-before-define, prefer-arrow-callback, no-else-return, consistent-return, prefer-template, quotes, one-var, one-var-declaration-per-line, no-unused-vars, no-return-assign, comma-dangle, quote-props, no-unused-expressions, no-sequences, object-shorthand, max-len */
(function () {
  gl.ImageFile = function () {
    var prepareFrames;

    // Width where images must fits in, for 2-up this gets divided by 2
    ImageFile.availWidth = 900;

    ImageFile.viewModes = ['two-up', 'swipe'];

    function ImageFile(file) {
      this.file = file;
      this.requestImageInfo($('.two-up.view .frame.deleted img', this.file), function (_this) {
        // Determine if old and new file has same dimensions, if not show 'two-up' view
        return function (deletedWidth, deletedHeight) {
          return _this.requestImageInfo($('.two-up.view .frame.added img', _this.file), function (width, height) {
            if (width === deletedWidth && height === deletedHeight) {
              return _this.initViewModes();
            } else {
              return _this.initView('two-up');
            }
          });
        };
      }(this));
    }

    ImageFile.prototype.initViewModes = function () {
      var viewMode;
      viewMode = ImageFile.viewModes[0];
      $('.view-modes', this.file).removeClass('hide');
      $('.view-modes-menu', this.file).on('click', 'li', function (_this) {
        return function (event) {
          if (!$(event.currentTarget).hasClass('active')) {
            return _this.activateViewMode(event.currentTarget.className);
          }
        };
      }(this));
      return this.activateViewMode(viewMode);
    };

    ImageFile.prototype.activateViewMode = function (viewMode) {
      $('.view-modes-menu li', this.file).removeClass('active').filter("." + viewMode).addClass('active');
      return $(".view:visible:not(." + viewMode + ")", this.file).fadeOut(200, function (_this) {
        return function () {
          $(".view." + viewMode, _this.file).fadeIn(200);
          return _this.initView(viewMode);
        };
      }(this));
    };

    ImageFile.prototype.initView = function (viewMode) {
      return this.views[viewMode].call(this);
    };

    ImageFile.prototype.initDraggable = function ($el, padding, callback) {
      var dragging = false;
      var $body = $('body');
      var $offsetEl = $el.parent();

      $el.off('mousedown').on('mousedown', function () {
        dragging = true;
        $body.css('user-select', 'none');
      });

      $body.off('mouseup').off('mousemove').on('mouseup', function () {
        dragging = false;
        $body.css('user-select', '');
      }).on('mousemove', function (e) {
        var left;
        if (!dragging) return;

        left = e.pageX - ($offsetEl.offset().left + padding);

        callback(e, left);
      });
    };

    prepareFrames = function prepareFrames(view) {
      var maxHeight, maxWidth;
      maxWidth = 0;
      maxHeight = 0;
      $('.frame', view).each(function (_this) {
        return function (index, frame) {
          var height, width;
          width = $(frame).width();
          height = $(frame).height();
          maxWidth = width > maxWidth ? width : maxWidth;
          return maxHeight = height > maxHeight ? height : maxHeight;
        };
      }(this)).css({
        width: maxWidth,
        height: maxHeight
      });
      return [maxWidth, maxHeight];
    };

    ImageFile.prototype.views = {
      'two-up': function twoUp() {
        return $('.two-up.view .wrap', this.file).each(function (_this) {
          return function (index, wrap) {
            $('img', wrap).each(function () {
              var currentWidth;
              currentWidth = $(this).width();
              if (currentWidth > ImageFile.availWidth / 2) {
                return $(this).width(ImageFile.availWidth / 2);
              }
            });
            return _this.requestImageInfo($('img', wrap), function (width, height) {
              $('.image-info .meta-width', wrap).text(width + "px");
              $('.image-info .meta-height', wrap).text(height + "px");
              return $('.image-info', wrap).removeClass('hide');
            });
          };
        }(this));
      },
      'swipe': function swipe() {
        var maxHeight, maxWidth;
        maxWidth = 0;
        maxHeight = 0;
        return $('.swipe.view', this.file).each(function (_this) {
          return function (index, view) {
            var $swipeWrap, $swipeBar, $swipeFrame, wrapPadding, ref;
            ref = prepareFrames(view), maxWidth = ref[0], maxHeight = ref[1];
            $swipeFrame = $('.swipe-frame', view);
            $swipeWrap = $('.swipe-wrap', view);
            $swipeBar = $('.swipe-bar', view);

            $swipeFrame.css({
              width: maxWidth + 16,
              height: maxHeight + 28
            });
            $swipeWrap.css({
              width: maxWidth + 1,
              height: maxHeight + 2
            });
            $swipeBar.css({
              left: 0
            });

            wrapPadding = parseInt($swipeWrap.css('right').replace('px', ''), 10);

            _this.initDraggable($swipeBar, wrapPadding, function (e, left) {
              if (left > 0 && left < $swipeFrame.width() - wrapPadding * 2) {
                $swipeWrap.width(maxWidth + 1 - left);
                $swipeBar.css('left', left);
              }
            });
          };
        }(this));
      },
      'onion-skin': function onionSkin() {
        var dragTrackWidth, maxHeight, maxWidth;
        maxWidth = 0;
        maxHeight = 0;
        dragTrackWidth = $('.drag-track', this.file).width() - $('.dragger', this.file).width();
        return $('.onion-skin.view', this.file).each(function (_this) {
          return function (index, view) {
            var $frame,
                $track,
                $dragger,
                $frameAdded,
                framePadding,
                ref,
                dragging = false;
            ref = prepareFrames(view), maxWidth = ref[0], maxHeight = ref[1];
            $frame = $('.onion-skin-frame', view);
            $frameAdded = $('.frame.added', view);
            $track = $('.drag-track', view);
            $dragger = $('.dragger', $track);

            $frame.css({
              width: maxWidth + 16,
              height: maxHeight + 28
            });
            $('.swipe-wrap', view).css({
              width: maxWidth + 1,
              height: maxHeight + 2
            });
            $dragger.css({
              left: dragTrackWidth
            });

            framePadding = parseInt($frameAdded.css('right').replace('px', ''), 10);

            _this.initDraggable($dragger, framePadding, function (e, left) {
              var opacity = left / dragTrackWidth;

              if (opacity >= 0 && opacity <= 1) {
                $dragger.css('left', left);
                $frameAdded.css('opacity', opacity);
              }
            });
          };
        }(this));
      }
    };

    ImageFile.prototype.requestImageInfo = function (img, callback) {
      var domImg;
      domImg = img.get(0);
      if (domImg) {
        if (domImg.complete) {
          return callback.call(this, domImg.naturalWidth, domImg.naturalHeight);
        } else {
          return img.on('load', function (_this) {
            return function () {
              return callback.call(_this, domImg.naturalWidth, domImg.naturalHeight);
            };
          }(this));
        }
      }
    };

    return ImageFile;
  }();
}).call(window);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "EQHa":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
* Instances of SmartInterval extend the functionality of `setInterval`, make it configurable
* and controllable by a public API.
*
* */

(function () {
  var SmartInterval = function () {
    /**
      * @param { function } opts.callback Function to be called on each iteration (required)
      * @param { milliseconds } opts.startingInterval `currentInterval` is set to this initially
      * @param { milliseconds } opts.maxInterval `currentInterval` will be incremented to this
      * @param { milliseconds } opts.hiddenInterval `currentInterval` is set to this
      *                         when the page is hidden
      * @param { integer } opts.incrementByFactorOf `currentInterval` is incremented by this factor
      * @param { boolean } opts.lazyStart Configure if timer is initialized on
      *                    instantiation or lazily
      * @param { boolean } opts.immediateExecution Configure if callback should
      *                    be executed before the first interval.
      */
    function SmartInterval() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      _classCallCheck(this, SmartInterval);

      this.cfg = {
        callback: opts.callback,
        startingInterval: opts.startingInterval,
        maxInterval: opts.maxInterval,
        hiddenInterval: opts.hiddenInterval,
        incrementByFactorOf: opts.incrementByFactorOf,
        lazyStart: opts.lazyStart,
        immediateExecution: opts.immediateExecution
      };

      this.state = {
        intervalId: null,
        currentInterval: this.cfg.startingInterval,
        pageVisibility: 'visible'
      };

      this.initInterval();
    }
    /* public */

    _createClass(SmartInterval, [{
      key: 'start',
      value: function start() {
        var _this = this;

        var cfg = this.cfg;
        var state = this.state;

        if (cfg.immediateExecution) {
          cfg.immediateExecution = false;
          cfg.callback();
        }

        state.intervalId = window.setInterval(function () {
          cfg.callback();

          if (_this.getCurrentInterval() === cfg.maxInterval) {
            return;
          }

          _this.incrementInterval();
          _this.resume();
        }, this.getCurrentInterval());
      }

      // cancel the existing timer, setting the currentInterval back to startingInterval

    }, {
      key: 'cancel',
      value: function cancel() {
        this.setCurrentInterval(this.cfg.startingInterval);
        this.stopTimer();
      }
    }, {
      key: 'onVisibilityHidden',
      value: function onVisibilityHidden() {
        if (this.cfg.hiddenInterval) {
          this.setCurrentInterval(this.cfg.hiddenInterval);
          this.resume();
        } else {
          this.cancel();
        }
      }

      // start a timer, using the existing interval

    }, {
      key: 'resume',
      value: function resume() {
        this.stopTimer(); // stop exsiting timer, in case timer was not previously stopped
        this.start();
      }
    }, {
      key: 'onVisibilityVisible',
      value: function onVisibilityVisible() {
        this.cancel();
        this.start();
      }
    }, {
      key: 'destroy',
      value: function destroy() {
        this.cancel();
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
        $(document).off('visibilitychange').off('beforeunload');
      }

      /* private */

    }, {
      key: 'initInterval',
      value: function initInterval() {
        var cfg = this.cfg;

        if (!cfg.lazyStart) {
          this.start();
        }

        this.initVisibilityChangeHandling();
        this.initPageUnloadHandling();
      }
    }, {
      key: 'initVisibilityChangeHandling',
      value: function initVisibilityChangeHandling() {
        // cancel interval when tab no longer shown (prevents cached pages from polling)
        document.addEventListener('visibilitychange', this.handleVisibilityChange.bind(this));
      }
    }, {
      key: 'initPageUnloadHandling',
      value: function initPageUnloadHandling() {
        var _this2 = this;

        // TODO: Consider refactoring in light of turbolinks removal.
        // prevent interval continuing after page change, when kept in cache by Turbolinks
        $(document).on('beforeunload', function () {
          return _this2.cancel();
        });
      }
    }, {
      key: 'handleVisibilityChange',
      value: function handleVisibilityChange(e) {
        this.state.pageVisibility = e.target.visibilityState;
        var intervalAction = this.isPageVisible() ? this.onVisibilityVisible : this.onVisibilityHidden;

        intervalAction.apply(this);
      }
    }, {
      key: 'getCurrentInterval',
      value: function getCurrentInterval() {
        return this.state.currentInterval;
      }
    }, {
      key: 'setCurrentInterval',
      value: function setCurrentInterval(newInterval) {
        this.state.currentInterval = newInterval;
      }
    }, {
      key: 'incrementInterval',
      value: function incrementInterval() {
        var cfg = this.cfg;
        var currentInterval = this.getCurrentInterval();
        if (cfg.hiddenInterval && !this.isPageVisible()) return;
        var nextInterval = currentInterval * cfg.incrementByFactorOf;

        if (nextInterval > cfg.maxInterval) {
          nextInterval = cfg.maxInterval;
        }

        this.setCurrentInterval(nextInterval);
      }
    }, {
      key: 'isPageVisible',
      value: function isPageVisible() {
        return this.state.pageVisibility === 'visible';
      }
    }, {
      key: 'stopTimer',
      value: function stopTimer() {
        var state = this.state;

        state.intervalId = window.clearInterval(state.intervalId);
      }
    }]);

    return SmartInterval;
  }();

  gl.SmartInterval = SmartInterval;
})(window.gl || (window.gl = {}));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "EuaS":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, no-var, one-var, prefer-rest-params, max-len, vars-on-top, wrap-iife, consistent-return, comma-dangle, one-var-declaration-per-line, quotes, no-return-assign, prefer-arrow-callback, prefer-template, no-shadow, no-else-return, max-len, object-shorthand */
(function () {
  var bind = function bind(fn, me) {
    return function () {
      return fn.apply(me, arguments);
    };
  },
      indexOf = [].indexOf || function (item) {
    for (var i = 0, l = this.length; i < l; i += 1) {
      if (i in this && this[i] === item) return i;
    }return -1;
  };

  this.NewBranchForm = function () {
    function NewBranchForm(form, availableRefs) {
      this.validate = bind(this.validate, this);
      this.branchNameError = form.find('.js-branch-name-error');
      this.name = form.find('.js-branch-name');
      this.ref = form.find('#ref');
      this.setupAvailableRefs(availableRefs);
      this.setupRestrictions();
      this.addBinding();
      this.init();
    }

    NewBranchForm.prototype.addBinding = function () {
      return this.name.on('blur', this.validate);
    };

    NewBranchForm.prototype.init = function () {
      if (this.name.length && this.name.val().length > 0) {
        return this.name.trigger('blur');
      }
    };

    NewBranchForm.prototype.setupAvailableRefs = function (availableRefs) {
      var $branchSelect = $('.js-branch-select');

      $branchSelect.glDropdown({
        data: availableRefs,
        filterable: true,
        filterByText: true,
        remote: false,
        fieldName: $branchSelect.data('field-name'),
        selectable: true,
        isSelectable: function isSelectable(branch, $el) {
          return !$el.hasClass('is-active');
        },
        text: function text(branch) {
          return branch;
        },
        id: function id(branch) {
          return branch;
        },
        toggleLabel: function toggleLabel(branch) {
          if (branch) {
            return branch;
          }
        }
      });
    };

    NewBranchForm.prototype.setupRestrictions = function () {
      var endsWith, invalid, single, startsWith;
      startsWith = {
        pattern: /^(\/|\.)/g,
        prefix: "can't start with",
        conjunction: "or"
      };
      endsWith = {
        pattern: /(\/|\.|\.lock)$/g,
        prefix: "can't end in",
        conjunction: "or"
      };
      invalid = {
        pattern: /(\s|~|\^|:|\?|\*|\[|\\|\.\.|@\{|\/{2,}){1}/g,
        prefix: "can't contain",
        conjunction: ", "
      };
      single = {
        pattern: /^@+$/g,
        prefix: "can't be",
        conjunction: "or"
      };
      return this.restrictions = [startsWith, invalid, endsWith, single];
    };

    NewBranchForm.prototype.validate = function () {
      var errorMessage, errors, formatter, unique, validator;
      this.branchNameError.empty();
      unique = function unique(values, value) {
        if (indexOf.call(values, value) === -1) {
          values.push(value);
        }
        return values;
      };
      formatter = function formatter(values, restriction) {
        var formatted;
        formatted = values.map(function (value) {
          switch (false) {
            case !/\s/.test(value):
              return 'spaces';
            case !/\/{2,}/g.test(value):
              return 'consecutive slashes';
            default:
              return "'" + value + "'";
          }
        });
        return restriction.prefix + " " + formatted.join(restriction.conjunction);
      };
      validator = function (_this) {
        return function (errors, restriction) {
          var matched;
          matched = _this.name.val().match(restriction.pattern);
          if (matched) {
            return errors.concat(formatter(matched.reduce(unique, []), restriction));
          } else {
            return errors;
          }
        };
      }(this);
      errors = this.restrictions.reduce(validator, []);
      if (errors.length > 0) {
        errorMessage = $("<span/>").text(errors.join(', '));
        return this.branchNameError.append(errorMessage);
      }
    };

    return NewBranchForm;
  }();
}).call(window);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "FCUV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__protected_tag_create__ = __webpack_require__("Uou4");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ProtectedTagCreate", function() { return __WEBPACK_IMPORTED_MODULE_0__protected_tag_create__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__protected_tag_edit_list__ = __webpack_require__("y/LJ");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ProtectedTagEditList", function() { return __WEBPACK_IMPORTED_MODULE_1__protected_tag_edit_list__["a"]; });



/***/ }),

/***/ "FHk+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__("yoQO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* eslint-disable func-names, space-before-function-paren, wrap-iife, no-new, comma-dangle, quotes, prefer-arrow-callback, consistent-return, one-var, no-var, one-var-declaration-per-line, no-underscore-dangle, max-len */
/* global UsersSelect */
/* global bp */



(function () {
  this.IssuableContext = function () {
    function IssuableContext(currentUser) {
      this.initParticipants();
      new UsersSelect(currentUser);
      $('select.select2').select2({
        width: 'resolve',
        dropdownAutoWidth: true
      });
      $(".issuable-sidebar .inline-update").on("change", "select", function () {
        return $(this).submit();
      });
      $(".issuable-sidebar .inline-update").on("change", ".js-assignee", function () {
        return $(this).submit();
      });
      $(document).off('click', '.issuable-sidebar .dropdown-content a').on('click', '.issuable-sidebar .dropdown-content a', function (e) {
        return e.preventDefault();
      });
      $(document).off('click', '.edit-link').on('click', '.edit-link', function (e) {
        var $block, $selectbox;
        e.preventDefault();
        $block = $(this).parents('.block');
        $selectbox = $block.find('.selectbox');
        if ($selectbox.is(':visible')) {
          $selectbox.hide();
          $block.find('.value').show();
        } else {
          $selectbox.show();
          $block.find('.value').hide();
        }
        if ($selectbox.is(':visible')) {
          return setTimeout(function () {
            return $block.find('.dropdown-menu-toggle').trigger('click');
          }, 0);
        }
      });
      window.addEventListener('beforeunload', function () {
        // collapsed_gutter cookie hides the sidebar
        var bpBreakpoint = bp.getBreakpointSize();
        if (bpBreakpoint === 'xs' || bpBreakpoint === 'sm') {
          __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set('collapsed_gutter', true);
        }
      });
      $(".right-sidebar").niceScroll();
    }

    IssuableContext.prototype.initParticipants = function () {
      var _this;
      _this = this;
      $(document).on("click", ".js-participants-more", this.toggleHiddenParticipants);
      return $(".js-participants-author").each(function (i) {
        if (i >= _this.PARTICIPANTS_ROW_COUNT) {
          return $(this).addClass("js-participants-hidden").hide();
        }
      });
    };

    IssuableContext.prototype.toggleHiddenParticipants = function (e) {
      var currentText, lessText, originalText;
      e.preventDefault();
      currentText = $(this).text().trim();
      lessText = $(this).data("less-text");
      originalText = $(this).data("original-text");
      if (currentText === originalText) {
        $(this).text(lessText);
      } else {
        $(this).text(originalText);
      }
      return $(".js-participants-hidden").toggle();
    };

    return IssuableContext;
  }();
}).call(window);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("lwLq")))

/***/ }),

/***/ "FXmX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__commons_bootstrap__ = __webpack_require__("jBf/");


// Requires Input behavior
//
// When called on a form with input fields with the `required` attribute, the
// form's submit button will be disabled until all required fields have values.
//
// ### Example Markup
//
//   <form class="js-requires-input">
//     <input type="text" required="required">
//     <input type="submit" value="Submit">
//   </form>
//

$.fn.requiresInput = function requiresInput() {
  var $form = $(this);
  var $button = $('button[type=submit], input[type=submit]', $form);
  var fieldSelector = 'input[required=required], select[required=required], textarea[required=required]';

  function requireInput() {
    // Collect the input values of *all* required fields
    var values = _.map($(fieldSelector, $form), function (field) {
      return field.value;
    });

    // Disable the button if any required fields are empty
    if (values.length && _.any(values, _.isEmpty)) {
      $button.disable();
    } else {
      $button.enable();
    }
  }

  // Set initial button state
  requireInput();
  $form.on('change input', fieldSelector, requireInput);
};

// Hide or Show the help block when creating a new project
// based on the option selected
function hideOrShowHelpBlock(form) {
  var selected = $('.js-select-namespace option:selected');
  if (selected.length && selected.data('options-parent') === 'groups') {
    form.find('.help-block').hide();
  } else if (selected.length) {
    form.find('.help-block').show();
  }
}

$(function () {
  var $form = $('form.js-requires-input');
  $form.requiresInput();
  hideOrShowHelpBlock($form);
  $('.select2.js-select-namespace').change(function () {
    return hideOrShowHelpBlock($form);
  });
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("lwLq")))

/***/ }),

/***/ "G2NG":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, no-var, prefer-rest-params, wrap-iife, no-unused-vars, one-var, no-underscore-dangle, prefer-template, no-else-return, prefer-arrow-callback, max-len */

(function () {
  var bind = function bind(fn, me) {
    return function () {
      return fn.apply(me, arguments);
    };
  };

  this.ProjectNew = function () {
    function ProjectNew() {
      this.toggleSettings = bind(this.toggleSettings, this);
      this.$selects = $('.features select');
      this.$repoSelects = this.$selects.filter('.js-repo-select');

      $('.project-edit-container').on('ajax:before', function (_this) {
        return function () {
          $('.project-edit-container').hide();
          return $('.save-project-loader').show();
        };
      }(this));

      this.initVisibilitySelect();

      this.toggleSettings();
      this.toggleSettingsOnclick();
      this.toggleRepoVisibility();
    }

    ProjectNew.prototype.initVisibilitySelect = function () {
      var visibilityContainer = document.querySelector('.js-visibility-select');
      if (!visibilityContainer) return;
      var visibilitySelect = new gl.VisibilitySelect(visibilityContainer);
      visibilitySelect.init();
    };

    ProjectNew.prototype.toggleSettings = function () {
      var self = this;

      this.$selects.each(function () {
        var $select = $(this);
        var className = $select.data('field').replace(/_/g, '-').replace('access-level', 'feature');
        self._showOrHide($select, '.' + className);
      });
    };

    ProjectNew.prototype.toggleSettingsOnclick = function () {
      this.$selects.on('change', this.toggleSettings);
    };

    ProjectNew.prototype._showOrHide = function (checkElement, container) {
      var $container = $(container);

      if ($(checkElement).val() !== '0') {
        return $container.show();
      } else {
        return $container.hide();
      }
    };

    ProjectNew.prototype.toggleRepoVisibility = function () {
      var $repoAccessLevel = $('.js-repo-access-level select');
      var containerRegistry = document.querySelectorAll('.js-container-registry')[0];
      var containerRegistryCheckbox = document.getElementById('project_container_registry_enabled');

      this.$repoSelects.find("option[value='" + $repoAccessLevel.val() + "']").nextAll().hide();

      $repoAccessLevel.off('change').on('change', function () {
        var selectedVal = parseInt($repoAccessLevel.val(), 10);

        this.$repoSelects.each(function () {
          var $this = $(this);
          var repoSelectVal = parseInt($this.val(), 10);

          $this.find('option').show();

          if (selectedVal < repoSelectVal) {
            $this.val(selectedVal);
          }

          $this.find("option[value='" + selectedVal + "']").nextAll().hide();
        });

        if (selectedVal) {
          this.$repoSelects.removeClass('disabled');

          if (containerRegistry) {
            containerRegistry.style.display = '';
          }
        } else {
          this.$repoSelects.addClass('disabled');

          if (containerRegistry) {
            containerRegistry.style.display = 'none';
            containerRegistryCheckbox.checked = false;
          }
        }
      }.bind(this));
    };

    return ProjectNew;
  }();
}).call(window);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "GCD9":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, no-var, prefer-rest-params, wrap-iife, one-var, vars-on-top, one-var-declaration-per-line, comma-dangle, object-shorthand, no-else-return, prefer-template, quotes, prefer-arrow-callback, no-param-reassign, no-cond-assign, max-len */
/* global Api */

(function () {
  var bind = function bind(fn, me) {
    return function () {
      return fn.apply(me, arguments);
    };
  };

  window.NamespaceSelect = function () {
    function NamespaceSelect(opts) {
      this.onSelectItem = bind(this.onSelectItem, this);
      var fieldName, showAny;
      this.dropdown = opts.dropdown;
      showAny = true;
      fieldName = 'namespace_id';
      if (this.dropdown.attr('data-field-name')) {
        fieldName = this.dropdown.data('fieldName');
      }
      if (this.dropdown.attr('data-show-any')) {
        showAny = this.dropdown.data('showAny');
      }
      this.dropdown.glDropdown({
        filterable: true,
        selectable: true,
        filterRemote: true,
        search: {
          fields: ['path']
        },
        fieldName: fieldName,
        toggleLabel: function toggleLabel(selected) {
          if (selected.id == null) {
            return selected.text;
          } else {
            return selected.kind + ": " + selected.full_path;
          }
        },
        data: function data(term, dataCallback) {
          return Api.namespaces(term, function (namespaces) {
            var anyNamespace;
            if (showAny) {
              anyNamespace = {
                text: 'Any namespace',
                id: null
              };
              namespaces.unshift(anyNamespace);
              namespaces.splice(1, 0, 'divider');
            }
            return dataCallback(namespaces);
          });
        },
        text: function text(namespace) {
          if (namespace.id == null) {
            return namespace.text;
          } else {
            return namespace.kind + ": " + namespace.full_path;
          }
        },
        renderRow: this.renderRow,
        clicked: this.onSelectItem
      });
    }

    NamespaceSelect.prototype.onSelectItem = function (item, el, e) {
      return e.preventDefault();
    };

    return NamespaceSelect;
  }();

  window.NamespaceSelects = function () {
    function NamespaceSelects(opts) {
      var ref;
      if (opts == null) {
        opts = {};
      }
      this.$dropdowns = (ref = opts.$dropdowns) != null ? ref : $('.js-namespace-select');
      this.$dropdowns.each(function (i, dropdown) {
        var $dropdown;
        $dropdown = $(dropdown);
        return new window.NamespaceSelect({
          dropdown: $dropdown
        });
      });
    }

    return NamespaceSelects;
  }();
}).call(window);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "GEo8":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable comma-dangle, class-methods-use-this, max-len, space-before-function-paren, arrow-parens, no-param-reassign */

__webpack_require__("2lN2");

var customValidationFlag = 'gl-field-error-ignore';

var GlFieldErrors = function () {
  function GlFieldErrors(form) {
    _classCallCheck(this, GlFieldErrors);

    this.form = $(form);
    this.state = {
      inputs: [],
      valid: false
    };
    this.initValidators();
  }

  _createClass(GlFieldErrors, [{
    key: 'initValidators',
    value: function initValidators() {
      var _this = this;

      // register selectors here as needed
      var validateSelectors = [':text', ':password', '[type=email]'].map(function (selector) {
        return 'input' + selector;
      }).join(',');

      this.state.inputs = this.form.find(validateSelectors).toArray().filter(function (input) {
        return !input.classList.contains(customValidationFlag);
      }).map(function (input) {
        return new window.gl.GlFieldError({ input: input, formErrors: _this });
      });

      this.form.on('submit', this.catchInvalidFormSubmit);
    }

    /* Neccessary to prevent intercept and override invalid form submit
     * because Safari & iOS quietly allow form submission when form is invalid
     * and prevents disabling of invalid submit button by application.js */

  }, {
    key: 'catchInvalidFormSubmit',
    value: function catchInvalidFormSubmit(event) {
      if (!event.currentTarget.checkValidity()) {
        event.preventDefault();
        event.stopPropagation();
      }
    }
  }, {
    key: 'focusOnFirstInvalid',
    value: function focusOnFirstInvalid() {
      var firstInvalid = this.state.inputs.filter(function (input) {
        return !input.inputDomElement.validity.valid;
      })[0];
      firstInvalid.inputElement.focus();
    }
  }]);

  return GlFieldErrors;
}();

window.gl = window.gl || {};
window.gl.GlFieldErrors = GlFieldErrors;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "HuIY":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, no-var, prefer-rest-params, wrap-iife, one-var, one-var-declaration-per-line, newline-per-chained-call, comma-dangle, consistent-return, prefer-arrow-callback, max-len */
(function () {
  var bind = function bind(fn, me) {
    return function () {
      return fn.apply(me, arguments);
    };
  };

  this.NotificationsForm = function () {
    function NotificationsForm() {
      this.toggleCheckbox = bind(this.toggleCheckbox, this);
      this.removeEventListeners();
      this.initEventListeners();
    }

    NotificationsForm.prototype.removeEventListeners = function () {
      return $(document).off('change', '.js-custom-notification-event');
    };

    NotificationsForm.prototype.initEventListeners = function () {
      return $(document).on('change', '.js-custom-notification-event', this.toggleCheckbox);
    };

    NotificationsForm.prototype.toggleCheckbox = function (e) {
      var $checkbox, $parent;
      $checkbox = $(e.currentTarget);
      $parent = $checkbox.closest('.checkbox');
      return this.saveEvent($checkbox, $parent);
    };

    NotificationsForm.prototype.showCheckboxLoadingSpinner = function ($parent) {
      return $parent.addClass('is-loading').find('.custom-notification-event-loading').removeClass('fa-check').addClass('fa-spin fa-spinner').removeClass('is-done');
    };

    NotificationsForm.prototype.saveEvent = function ($checkbox, $parent) {
      var form;
      form = $parent.parents('form:first');
      return $.ajax({
        url: form.attr('action'),
        method: form.attr('method'),
        dataType: 'json',
        data: form.serialize(),
        beforeSend: function (_this) {
          return function () {
            return _this.showCheckboxLoadingSpinner($parent);
          };
        }(this)
      }).done(function (data) {
        $checkbox.enable();
        if (data.saved) {
          $parent.find('.custom-notification-event-loading').toggleClass('fa-spin fa-spinner fa-check is-done');
          return setTimeout(function () {
            return $parent.removeClass('is-loading').find('.custom-notification-event-loading').toggleClass('fa-spin fa-spinner fa-check is-done');
          }, 2000);
        }
      });
    };

    return NotificationsForm;
  }();
}).call(window);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "I8f0":
/***/ (function(module, exports) {

(function () {
  /*
   * TODO: Make these methods more configurable (e.g. parseSeconds timePeriodContstraints,
   * stringifyTime condensed or non-condensed, abbreviateTimelengths)
   * */

  var utils = window.gl.utils = gl.utils || {};
  var prettyTime = utils.prettyTime = {
    /*
     * Accepts seconds and returns a timeObject { weeks: #, days: #, hours: #, minutes: # }
     * Seconds can be negative or positive, zero or non-zero.
    */
    parseSeconds: function parseSeconds(seconds) {
      var DAYS_PER_WEEK = 5;
      var HOURS_PER_DAY = 8;
      var MINUTES_PER_HOUR = 60;
      var MINUTES_PER_WEEK = DAYS_PER_WEEK * HOURS_PER_DAY * MINUTES_PER_HOUR;
      var MINUTES_PER_DAY = HOURS_PER_DAY * MINUTES_PER_HOUR;

      var timePeriodConstraints = {
        weeks: MINUTES_PER_WEEK,
        days: MINUTES_PER_DAY,
        hours: MINUTES_PER_HOUR,
        minutes: 1
      };

      var unorderedMinutes = prettyTime.secondsToMinutes(seconds);

      return _.mapObject(timePeriodConstraints, function (minutesPerPeriod) {
        var periodCount = Math.floor(unorderedMinutes / minutesPerPeriod);

        unorderedMinutes -= periodCount * minutesPerPeriod;

        return periodCount;
      });
    },


    /*
    * Accepts a timeObject and returns a condensed string representation of it
    * (e.g. '1w 2d 3h 1m' or '1h 30m'). Zero value units are not included.
    */

    stringifyTime: function stringifyTime(timeObject) {
      var reducedTime = _.reduce(timeObject, function (memo, unitValue, unitName) {
        var isNonZero = !!unitValue;
        return isNonZero ? memo + ' ' + unitValue + unitName.charAt(0) : memo;
      }, '').trim();
      return reducedTime.length ? reducedTime : '0m';
    },


    /*
    * Accepts a time string of any size (e.g. '1w 2d 3h 5m' or '1w 2d') and returns
    *  the first non-zero unit/value pair.
    */

    abbreviateTime: function abbreviateTime(timeStr) {
      return timeStr.split(' ').filter(function (unitStr) {
        return unitStr.charAt(0) !== '0';
      })[0];
    },
    secondsToMinutes: function secondsToMinutes(seconds) {
      return Math.abs(seconds / 60);
    }
  };
})(window.gl || (window.gl = {}));

/***/ }),

/***/ "INx4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hook__ = __webpack_require__("7h5G");
/* eslint-disable */



var HookButton = function HookButton(trigger, list, plugins, config) {
  __WEBPACK_IMPORTED_MODULE_0__hook__["a" /* default */].call(this, trigger, list, plugins, config);

  this.type = 'button';
  this.event = 'click';

  this.eventWrapper = {};

  this.addEvents();
  this.addPlugins();
};

HookButton.prototype = Object.create(__WEBPACK_IMPORTED_MODULE_0__hook__["a" /* default */].prototype);

Object.assign(HookButton.prototype, {
  addPlugins: function addPlugins() {
    var _this = this;

    this.plugins.forEach(function (plugin) {
      return plugin.init(_this);
    });
  },

  clicked: function clicked(e) {
    var buttonEvent = new CustomEvent('click.dl', {
      detail: {
        hook: this
      },
      bubbles: true,
      cancelable: true
    });
    e.target.dispatchEvent(buttonEvent);

    this.list.toggle();
  },

  addEvents: function addEvents() {
    this.eventWrapper.clicked = this.clicked.bind(this);
    this.trigger.addEventListener('click', this.eventWrapper.clicked);
  },

  removeEvents: function removeEvents() {
    this.trigger.removeEventListener('click', this.eventWrapper.clicked);
  },

  restoreInitialState: function restoreInitialState() {
    this.list.list.innerHTML = this.list.initialState;
  },

  removePlugins: function removePlugins() {
    this.plugins.forEach(function (plugin) {
      return plugin.destroy();
    });
  },

  destroy: function destroy() {
    this.restoreInitialState();

    this.removeEvents();
    this.removePlugins();
  },

  constructor: HookButton
});

/* harmony default export */ __webpack_exports__["a"] = (HookButton);

/***/ }),

/***/ "IRlT":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, prefer-arrow-callback, space-before-function-paren, no-var, prefer-rest-params, wrap-iife, one-var, one-var-declaration-per-line, consistent-return, no-param-reassign, max-len */

(function () {
  var bind = function bind(fn, me) {
    return function () {
      return fn.apply(me, arguments);
    };
  };

  window.SingleFileDiff = function () {
    var COLLAPSED_HTML, ERROR_HTML, LOADING_HTML, WRAPPER;

    WRAPPER = '<div class="diff-content diff-wrap-lines"></div>';

    LOADING_HTML = '<i class="fa fa-spinner fa-spin"></i>';

    ERROR_HTML = '<div class="nothing-here-block"><i class="fa fa-warning"></i> Could not load diff</div>';

    COLLAPSED_HTML = '<div class="nothing-here-block diff-collapsed">This diff is collapsed. <a class="click-to-expand">Click to expand it.</a></div>';

    function SingleFileDiff(file) {
      this.file = file;
      this.toggleDiff = bind(this.toggleDiff, this);
      this.content = $('.diff-content', this.file);
      this.$toggleIcon = $('.diff-toggle-caret', this.file);
      this.diffForPath = this.content.find('[data-diff-for-path]').data('diff-for-path');
      this.isOpen = !this.diffForPath;
      if (this.diffForPath) {
        this.collapsedContent = this.content;
        this.loadingContent = $(WRAPPER).addClass('loading').html(LOADING_HTML).hide();
        this.content = null;
        this.collapsedContent.after(this.loadingContent);
        this.$toggleIcon.addClass('fa-caret-right');
      } else {
        this.collapsedContent = $(WRAPPER).html(COLLAPSED_HTML).hide();
        this.content.after(this.collapsedContent);
        this.$toggleIcon.addClass('fa-caret-down');
      }

      $('.js-file-title, .click-to-expand', this.file).on('click', function (e) {
        this.toggleDiff($(e.target));
      }.bind(this));
    }

    SingleFileDiff.prototype.toggleDiff = function ($target, cb) {
      if (!$target.hasClass('js-file-title') && !$target.hasClass('click-to-expand') && !$target.hasClass('diff-toggle-caret')) return;
      this.isOpen = !this.isOpen;
      if (!this.isOpen && !this.hasError) {
        this.content.hide();
        this.$toggleIcon.addClass('fa-caret-right').removeClass('fa-caret-down');
        this.collapsedContent.show();
        if (typeof gl.diffNotesCompileComponents !== 'undefined') {
          gl.diffNotesCompileComponents();
        }
      } else if (this.content) {
        this.collapsedContent.hide();
        this.content.show();
        this.$toggleIcon.addClass('fa-caret-down').removeClass('fa-caret-right');
        if (typeof gl.diffNotesCompileComponents !== 'undefined') {
          gl.diffNotesCompileComponents();
        }
      } else {
        this.$toggleIcon.addClass('fa-caret-down').removeClass('fa-caret-right');
        return this.getContentHTML(cb);
      }
    };

    SingleFileDiff.prototype.getContentHTML = function (cb) {
      this.collapsedContent.hide();
      this.loadingContent.show();
      $.get(this.diffForPath, function (_this) {
        return function (data) {
          _this.loadingContent.hide();
          if (data.html) {
            _this.content = $(data.html);
            _this.content.syntaxHighlight();
          } else {
            _this.hasError = true;
            _this.content = $(ERROR_HTML);
          }
          _this.collapsedContent.after(_this.content);

          if (typeof gl.diffNotesCompileComponents !== 'undefined') {
            gl.diffNotesCompileComponents();
          }

          if (cb) cb();
        };
      }(this));
    };

    return SingleFileDiff;
  }();

  $.fn.singleFileDiff = function () {
    return this.each(function () {
      if (!$.data(this, 'singleFileDiff')) {
        return $.data(this, 'singleFileDiff', new window.SingleFileDiff(this));
      }
    });
  };
}).call(window);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "J6H8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emojis_digests_json__ = __webpack_require__("fA9n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_emojis_digests_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_emojis_digests_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_emojis_aliases_json__ = __webpack_require__("owyH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_emojis_aliases_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_emojis_aliases_json__);



function isEmojiNameValid(inputName) {
  var name = Object.prototype.hasOwnProperty.call(__WEBPACK_IMPORTED_MODULE_1_emojis_aliases_json___default.a, inputName) ? __WEBPACK_IMPORTED_MODULE_1_emojis_aliases_json___default.a[inputName] : inputName;

  return name && __WEBPACK_IMPORTED_MODULE_0_emojis_digests_json___default.a[name];
}

/* harmony default export */ __webpack_exports__["a"] = (isEmojiNameValid);

/***/ }),

/***/ "JAXo":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, wrap-iife, prefer-arrow-callback, no-unused-vars, no-return-assign, max-len */

window.BuildArtifacts = function () {
  function BuildArtifacts() {
    this.disablePropagation();
    this.setupEntryClick();
  }

  BuildArtifacts.prototype.disablePropagation = function () {
    $('.top-block').on('click', '.download', function (e) {
      return e.stopPropagation();
    });
    return $('.tree-holder').on('click', 'tr[data-link] a', function (e) {
      return e.stopImmediatePropagation();
    });
  };

  BuildArtifacts.prototype.setupEntryClick = function () {
    return $('.tree-holder').on('click', 'tr[data-link]', function (e) {
      return window.location = this.dataset.link;
    });
  };

  return BuildArtifacts;
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "JB8C":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable class-methods-use-this, no-unneeded-ternary, quote-props */
/* global UsersSelect */

var Todos = function () {
  function Todos() {
    _classCallCheck(this, Todos);

    this.initFilters();
    this.bindEvents();
    this.todo_ids = [];

    this.cleanupWrapper = this.cleanup.bind(this);
    document.addEventListener('beforeunload', this.cleanupWrapper);
  }

  _createClass(Todos, [{
    key: 'cleanup',
    value: function cleanup() {
      this.unbindEvents();
      document.removeEventListener('beforeunload', this.cleanupWrapper);
    }
  }, {
    key: 'unbindEvents',
    value: function unbindEvents() {
      $('.js-done-todo, .js-undo-todo, .js-add-todo').off('click', this.updateRowStateClickedWrapper);
      $('.js-todos-mark-all', '.js-todos-undo-all').off('click', this.updateallStateClickedWrapper);
      $('.todo').off('click', this.goToTodoUrl);
    }
  }, {
    key: 'bindEvents',
    value: function bindEvents() {
      this.updateRowStateClickedWrapper = this.updateRowStateClicked.bind(this);
      this.updateAllStateClickedWrapper = this.updateAllStateClicked.bind(this);

      $('.js-done-todo, .js-undo-todo, .js-add-todo').on('click', this.updateRowStateClickedWrapper);
      $('.js-todos-mark-all, .js-todos-undo-all').on('click', this.updateAllStateClickedWrapper);
      $('.todo').on('click', this.goToTodoUrl);
    }
  }, {
    key: 'initFilters',
    value: function initFilters() {
      this.initFilterDropdown($('.js-project-search'), 'project_id', ['text']);
      this.initFilterDropdown($('.js-type-search'), 'type');
      this.initFilterDropdown($('.js-action-search'), 'action_id');

      $('form.filter-form').on('submit', function applyFilters(event) {
        event.preventDefault();
        gl.utils.visitUrl(this.action + '&' + $(this).serialize());
      });
      return new UsersSelect();
    }
  }, {
    key: 'initFilterDropdown',
    value: function initFilterDropdown($dropdown, fieldName, searchFields) {
      $dropdown.glDropdown({
        fieldName: fieldName,
        selectable: true,
        filterable: searchFields ? true : false,
        search: { fields: searchFields },
        data: $dropdown.data('data'),
        clicked: function clicked() {
          return $dropdown.closest('form.filter-form').submit();
        }
      });
    }
  }, {
    key: 'updateRowStateClicked',
    value: function updateRowStateClicked(e) {
      var _this = this;

      e.preventDefault();

      var target = e.target;
      target.setAttribute('disabled', true);
      target.classList.add('disabled');
      $.ajax({
        type: 'POST',
        url: target.dataset.href,
        dataType: 'json',
        data: {
          '_method': target.dataset.method
        },
        success: function success(data) {
          _this.updateRowState(target);
          return _this.updateBadges(data);
        }
      });
    }
  }, {
    key: 'updateRowState',
    value: function updateRowState(target) {
      var row = target.closest('li');
      var restoreBtn = row.querySelector('.js-undo-todo');
      var doneBtn = row.querySelector('.js-done-todo');

      target.classList.add('hidden');
      target.removeAttribute('disabled');
      target.classList.remove('disabled');

      if (target === doneBtn) {
        row.classList.add('done-reversible');
        restoreBtn.classList.remove('hidden');
      } else if (target === restoreBtn) {
        row.classList.remove('done-reversible');
        doneBtn.classList.remove('hidden');
      } else {
        row.parentNode.removeChild(row);
      }
    }
  }, {
    key: 'updateAllStateClicked',
    value: function updateAllStateClicked(e) {
      var _this2 = this;

      e.preventDefault();

      var target = e.currentTarget;
      var requestData = { '_method': target.dataset.method, ids: this.todo_ids };
      target.setAttribute('disabled', true);
      target.classList.add('disabled');
      $.ajax({
        type: 'POST',
        url: target.dataset.href,
        dataType: 'json',
        data: requestData,
        success: function success(data) {
          _this2.updateAllState(target, data);
          return _this2.updateBadges(data);
        }
      });
    }
  }, {
    key: 'updateAllState',
    value: function updateAllState(target, data) {
      var markAllDoneBtn = document.querySelector('.js-todos-mark-all');
      var undoAllBtn = document.querySelector('.js-todos-undo-all');
      var todoListContainer = document.querySelector('.js-todos-list-container');
      var nothingHereContainer = document.querySelector('.js-nothing-here-container');

      target.removeAttribute('disabled');
      target.classList.remove('disabled');

      this.todo_ids = target === markAllDoneBtn ? data.updated_ids : [];
      undoAllBtn.classList.toggle('hidden');
      markAllDoneBtn.classList.toggle('hidden');
      todoListContainer.classList.toggle('hidden');
      nothingHereContainer.classList.toggle('hidden');
    }
  }, {
    key: 'updateBadges',
    value: function updateBadges(data) {
      $(document).trigger('todo:toggle', data.count);
      document.querySelector('.todos-pending .badge').innerHTML = data.count;
      document.querySelector('.todos-done .badge').innerHTML = data.done_count;
    }
  }, {
    key: 'goToTodoUrl',
    value: function goToTodoUrl(e) {
      var todoLink = this.dataset.url;

      if (!todoLink) {
        return;
      }

      if (gl.utils.isMetaClick(e)) {
        var windowTarget = '_blank';
        var selected = e.target;
        e.preventDefault();

        if (selected.tagName === 'IMG') {
          var avatarUrl = selected.parentElement.getAttribute('href');
          window.open(avatarUrl, windowTarget);
        } else {
          window.open(todoLink, windowTarget);
        }
      } else {
        gl.utils.visitUrl(todoLink);
      }
    }
  }]);

  return Todos;
}();

window.gl = window.gl || {};
gl.Todos = Todos;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "JSKa":
/***/ (function(module, exports) {

/* eslint-disable func-names, space-before-function-paren, wrap-iife, no-var, one-var, one-var-declaration-per-line, consistent-return, prefer-arrow-callback, no-return-assign, object-shorthand, comma-dangle, no-param-reassign, max-len */

(function () {
  (function (w) {
    var notificationGranted, notifyMe, notifyPermissions;
    notificationGranted = function notificationGranted(message, opts, onclick) {
      var notification;
      notification = new Notification(message, opts);
      setTimeout(function () {
        return notification.close();
        // Hide the notification after X amount of seconds
      }, 8000);
      if (onclick) {
        return notification.onclick = onclick;
      }
    };
    notifyPermissions = function notifyPermissions() {
      if ('Notification' in window) {
        return Notification.requestPermission();
      }
    };
    notifyMe = function notifyMe(message, body, icon, onclick) {
      var opts;
      opts = {
        body: body,
        icon: icon
      };
      // Let's check if the browser supports notifications
      if (!('Notification' in window)) {

        // do nothing
      } else if (Notification.permission === 'granted') {
        // If it's okay let's create a notification
        return notificationGranted(message, opts, onclick);
      } else if (Notification.permission !== 'denied') {
        return Notification.requestPermission(function (permission) {
          // If the user accepts, let's create a notification
          if (permission === 'granted') {
            return notificationGranted(message, opts, onclick);
          }
        });
      }
    };
    w.notify = notifyMe;
    return w.notifyPermissions = notifyPermissions;
  })(window);
}).call(window);

/***/ }),

/***/ "KA+m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filterable_list__ = __webpack_require__("whmF");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



/**
 * Makes search request for projects when user types a value in the search input.
 * Updates the html content of the page with the received one.
 */

var ProjectsList = function ProjectsList() {
  _classCallCheck(this, ProjectsList);

  var form = document.querySelector('form#project-filter-form');
  var filter = document.querySelector('.js-projects-list-filter');
  var holder = document.querySelector('.js-projects-list-holder');

  if (form && filter && holder) {
    var list = new __WEBPACK_IMPORTED_MODULE_0__filterable_list__["a" /* default */](form, filter, holder);
    list.initSearch();
  }
};

/* harmony default export */ __webpack_exports__["a"] = (ProjectsList);

/***/ }),

/***/ "KA6S":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, no-var, prefer-rest-params, wrap-iife, vars-on-top, no-unused-vars, max-len */
(function () {
  var bind = function bind(fn, me) {
    return function () {
      return fn.apply(me, arguments);
    };
  };

  this.Labels = function () {
    function Labels() {
      this.setSuggestedColor = bind(this.setSuggestedColor, this);
      this.updateColorPreview = bind(this.updateColorPreview, this);
      var form;
      form = $('.label-form');
      this.cleanBinding();
      this.addBinding();
      this.updateColorPreview();
    }

    Labels.prototype.addBinding = function () {
      $(document).on('click', '.suggest-colors a', this.setSuggestedColor);
      return $(document).on('input', 'input#label_color', this.updateColorPreview);
    };

    Labels.prototype.cleanBinding = function () {
      $(document).off('click', '.suggest-colors a');
      return $(document).off('input', 'input#label_color');
    };

    Labels.prototype.updateColorPreview = function () {
      var previewColor;
      previewColor = $('input#label_color').val();
      return $('div.label-color-preview').css('background-color', previewColor);
      // Updates the the preview color with the hex-color input
    };

    // Updates the preview color with a click on a suggested color
    Labels.prototype.setSuggestedColor = function (e) {
      var color;
      color = $(e.currentTarget).data('color');
      $('input#label_color').val(color);
      this.updateColorPreview();
      // Notify the form, that color has changed
      $('.label-form').trigger('keyup');
      return e.preventDefault();
    };

    return Labels;
  }();
}).call(window);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "KLXO":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable comma-dangle, consistent-return, class-methods-use-this, arrow-parens, no-param-reassign, max-len */

(function (global) {
  var debounceTimeoutDuration = 1000;
  var invalidInputClass = 'gl-field-error-outline';
  var successInputClass = 'gl-field-success-outline';
  var unavailableMessageSelector = '.username .validation-error';
  var successMessageSelector = '.username .validation-success';
  var pendingMessageSelector = '.username .validation-pending';
  var invalidMessageSelector = '.username .gl-field-error';

  var UsernameValidator = function () {
    function UsernameValidator() {
      var _this = this;

      _classCallCheck(this, UsernameValidator);

      this.inputElement = $('#new_user_username');
      this.inputDomElement = this.inputElement.get(0);
      this.state = {
        available: false,
        valid: false,
        pending: false,
        empty: true
      };

      var debounceTimeout = _.debounce(function (username) {
        _this.validateUsername(username);
      }, debounceTimeoutDuration);

      this.inputElement.on('keyup.username_check', function () {
        var username = _this.inputElement.val();

        _this.state.valid = _this.inputDomElement.validity.valid;
        _this.state.empty = !username.length;

        if (_this.state.valid) {
          return debounceTimeout(username);
        }

        _this.renderState();
      });

      // Override generic field validation
      this.inputElement.on('invalid', this.interceptInvalid.bind(this));
    }

    _createClass(UsernameValidator, [{
      key: 'renderState',
      value: function renderState() {
        // Clear all state
        this.clearFieldValidationState();

        if (this.state.valid && this.state.available) {
          return this.setSuccessState();
        }

        if (this.state.empty) {
          return this.clearFieldValidationState();
        }

        if (this.state.pending) {
          return this.setPendingState();
        }

        if (!this.state.available) {
          return this.setUnavailableState();
        }

        if (!this.state.valid) {
          return this.setInvalidState();
        }
      }
    }, {
      key: 'interceptInvalid',
      value: function interceptInvalid(event) {
        event.preventDefault();
        event.stopPropagation();
      }
    }, {
      key: 'validateUsername',
      value: function validateUsername(username) {
        var _this2 = this;

        if (this.state.valid) {
          this.state.pending = true;
          this.state.available = false;
          this.renderState();
          return $.ajax({
            type: 'GET',
            url: gon.relative_url_root + '/users/' + username + '/exists',
            dataType: 'json',
            success: function success(res) {
              return _this2.setAvailabilityState(res.exists);
            }
          });
        }
      }
    }, {
      key: 'setAvailabilityState',
      value: function setAvailabilityState(usernameTaken) {
        if (usernameTaken) {
          this.state.valid = false;
          this.state.available = false;
        } else {
          this.state.available = true;
        }
        this.state.pending = false;
        this.renderState();
      }
    }, {
      key: 'clearFieldValidationState',
      value: function clearFieldValidationState() {
        this.inputElement.siblings('p').hide();

        this.inputElement.removeClass(invalidInputClass).removeClass(successInputClass);
      }
    }, {
      key: 'setUnavailableState',
      value: function setUnavailableState() {
        var $usernameUnavailableMessage = this.inputElement.siblings(unavailableMessageSelector);
        this.inputElement.addClass(invalidInputClass).removeClass(successInputClass);
        $usernameUnavailableMessage.show();
      }
    }, {
      key: 'setSuccessState',
      value: function setSuccessState() {
        var $usernameSuccessMessage = this.inputElement.siblings(successMessageSelector);
        this.inputElement.addClass(successInputClass).removeClass(invalidInputClass);
        $usernameSuccessMessage.show();
      }
    }, {
      key: 'setPendingState',
      value: function setPendingState() {
        var $usernamePendingMessage = $(pendingMessageSelector);
        if (this.state.pending) {
          $usernamePendingMessage.show();
        } else {
          $usernamePendingMessage.hide();
        }
      }
    }, {
      key: 'setInvalidState',
      value: function setInvalidState() {
        var $inputErrorMessage = $(invalidMessageSelector);
        this.inputElement.addClass(invalidInputClass).removeClass(successInputClass);
        $inputErrorMessage.show();
      }
    }]);

    return UsernameValidator;
  }();

  global.UsernameValidator = UsernameValidator;
})(window);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "KV3v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hook_button__ = __webpack_require__("INx4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hook_input__ = __webpack_require__("svvi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__("MoEV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__keyboard__ = __webpack_require__("+dQH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__("2ub6");
/* eslint-disable */







var DropLab = function DropLab() {
  this.ready = false;
  this.hooks = [];
  this.queuedData = [];
  this.config = {};

  this.eventWrapper = {};
};

Object.assign(DropLab.prototype, {
  loadStatic: function loadStatic() {
    var dropdownTriggers = [].slice.apply(document.querySelectorAll('[' + __WEBPACK_IMPORTED_MODULE_4__constants__["a" /* DATA_TRIGGER */] + ']'));
    this.addHooks(dropdownTriggers);
  },

  addData: function addData() {
    var args = [].slice.apply(arguments);
    this.applyArgs(args, '_addData');
  },

  setData: function setData() {
    var args = [].slice.apply(arguments);
    this.applyArgs(args, '_setData');
  },

  destroy: function destroy() {
    this.hooks.forEach(function (hook) {
      return hook.destroy();
    });
    this.hooks = [];
    this.removeEvents();
  },

  applyArgs: function applyArgs(args, methodName) {
    if (this.ready) return this[methodName].apply(this, args);

    this.queuedData = this.queuedData || [];
    this.queuedData.push(args);
  },

  _addData: function _addData(trigger, data) {
    this._processData(trigger, data, 'addData');
  },

  _setData: function _setData(trigger, data) {
    this._processData(trigger, data, 'setData');
  },

  _processData: function _processData(trigger, data, methodName) {
    this.hooks.forEach(function (hook) {
      if (Array.isArray(trigger)) hook.list[methodName](trigger);

      if (hook.trigger.id === trigger) hook.list[methodName](data);
    });
  },

  addEvents: function addEvents() {
    this.eventWrapper.documentClicked = this.documentClicked.bind(this);
    document.addEventListener('click', this.eventWrapper.documentClicked);
  },

  documentClicked: function documentClicked(e) {
    var thisTag = e.target;

    if (thisTag.tagName !== 'UL') thisTag = __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].closest(thisTag, 'UL');
    if (__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].isDropDownParts(thisTag, this.hooks) || __WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].isDropDownParts(e.target, this.hooks)) return;

    this.hooks.forEach(function (hook) {
      return hook.list.hide();
    });
  },

  removeEvents: function removeEvents() {
    document.removeEventListener('click', this.eventWrapper.documentClicked);
  },

  changeHookList: function changeHookList(trigger, list, plugins, config) {
    var _this = this;

    var availableTrigger = typeof trigger === 'string' ? document.getElementById(trigger) : trigger;

    this.hooks.forEach(function (hook, i) {
      hook.list.list.dataset.dropdownActive = false;

      if (hook.trigger !== availableTrigger) return;

      hook.destroy();
      _this.hooks.splice(i, 1);
      _this.addHook(availableTrigger, list, plugins, config);
    });
  },

  addHook: function addHook(hook, list, plugins, config) {
    var availableHook = typeof hook === 'string' ? document.querySelector(hook) : hook;
    var availableList = void 0;

    if (typeof list === 'string') {
      availableList = document.querySelector(list);
    } else if (list instanceof Element) {
      availableList = list;
    } else {
      availableList = document.querySelector(hook.dataset[__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* default */].toCamelCase(__WEBPACK_IMPORTED_MODULE_4__constants__["a" /* DATA_TRIGGER */])]);
    }

    availableList.dataset.dropdownActive = true;

    var HookObject = availableHook.tagName === 'INPUT' ? __WEBPACK_IMPORTED_MODULE_1__hook_input__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_0__hook_button__["a" /* default */];
    this.hooks.push(new HookObject(availableHook, availableList, plugins, config));

    return this;
  },

  addHooks: function addHooks(hooks, plugins, config) {
    var _this2 = this;

    hooks.forEach(function (hook) {
      return _this2.addHook(hook, null, plugins, config);
    });
    return this;
  },

  setConfig: function setConfig(obj) {
    this.config = obj;
  },

  fireReady: function fireReady() {
    var readyEvent = new CustomEvent('ready.dl', {
      detail: {
        dropdown: this
      }
    });
    document.dispatchEvent(readyEvent);

    this.ready = true;
  },

  init: function init(hook, list, plugins, config) {
    var _this3 = this;

    hook ? this.addHook(hook, list, plugins, config) : this.loadStatic();

    this.addEvents();

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__keyboard__["a" /* default */])();

    this.fireReady();

    this.queuedData.forEach(function (data) {
      return _this3.addData(data);
    });
    this.queuedData = [];

    return this;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (DropLab);

/***/ }),

/***/ "Kk2p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__("9eM+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var GroupName = function () {
  function GroupName() {
    _classCallCheck(this, GroupName);

    this.titleContainer = document.querySelector('.title-container');
    this.title = document.querySelector('.title');
    this.titleWidth = this.title.offsetWidth;
    this.groupTitle = document.querySelector('.group-title');
    this.groups = document.querySelectorAll('.group-path');
    this.toggle = null;
    this.isHidden = false;
    this.init();
  }

  _createClass(GroupName, [{
    key: 'init',
    value: function init() {
      if (this.groups.length > 0) {
        this.groups[this.groups.length - 1].classList.remove('hidable');
        this.toggleHandler();
        window.addEventListener('resize', __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.debounce(this.toggleHandler.bind(this), 100));
      }
      this.render();
    }
  }, {
    key: 'toggleHandler',
    value: function toggleHandler() {
      if (this.titleWidth > this.titleContainer.offsetWidth) {
        if (!this.toggle) this.createToggle();
        this.showToggle();
      } else if (this.toggle) {
        this.hideToggle();
      }
    }
  }, {
    key: 'createToggle',
    value: function createToggle() {
      this.toggle = document.createElement('button');
      this.toggle.className = 'text-expander group-name-toggle';
      this.toggle.setAttribute('aria-label', 'Toggle full path');
      this.toggle.innerHTML = '...';
      this.toggle.addEventListener('click', this.toggleGroups.bind(this));
      this.titleContainer.insertBefore(this.toggle, this.title);
      this.toggleGroups();
    }
  }, {
    key: 'showToggle',
    value: function showToggle() {
      this.title.classList.add('wrap');
      this.toggle.classList.remove('hidden');
      if (this.isHidden) this.groupTitle.classList.add('is-hidden');
    }
  }, {
    key: 'hideToggle',
    value: function hideToggle() {
      this.title.classList.remove('wrap');
      this.toggle.classList.add('hidden');
      if (this.isHidden) this.groupTitle.classList.remove('is-hidden');
    }
  }, {
    key: 'toggleGroups',
    value: function toggleGroups() {
      this.isHidden = !this.isHidden;
      this.groupTitle.classList.toggle('is-hidden');
    }
  }, {
    key: 'render',
    value: function render() {
      this.title.classList.remove('initializing');
    }
  }]);

  return GroupName;
}();

/* harmony default export */ __webpack_exports__["a"] = (GroupName);

/***/ }),

/***/ "LINv":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, wrap-iife, one-var, no-var, one-var-declaration-per-line, quotes, no-shadow, prefer-arrow-callback, prefer-template, consistent-return, no-return-assign, new-parens, no-param-reassign, max-len */

var Breakpoints = function () {
  var BreakpointInstance, instance;

  function Breakpoints() {}

  instance = null;

  BreakpointInstance = function () {
    var BREAKPOINTS;

    BREAKPOINTS = ["xs", "sm", "md", "lg"];

    function BreakpointInstance() {
      this.setup();
    }

    BreakpointInstance.prototype.setup = function () {
      var allDeviceSelector, els;
      allDeviceSelector = BREAKPOINTS.map(function (breakpoint) {
        return ".device-" + breakpoint;
      });
      if ($(allDeviceSelector.join(",")).length) {
        return;
      }
      // Create all the elements
      els = $.map(BREAKPOINTS, function (breakpoint) {
        return "<div class='device-" + breakpoint + " visible-" + breakpoint + "'></div>";
      });
      return $("body").append(els.join(''));
    };

    BreakpointInstance.prototype.visibleDevice = function () {
      var allDeviceSelector;
      allDeviceSelector = BREAKPOINTS.map(function (breakpoint) {
        return ".device-" + breakpoint;
      });
      return $(allDeviceSelector.join(",")).filter(":visible");
    };

    BreakpointInstance.prototype.getBreakpointSize = function () {
      var $visibleDevice;
      $visibleDevice = this.visibleDevice;
      // TODO: Consider refactoring in light of turbolinks removal.
      // the page refreshed via turbolinks
      if (!$visibleDevice().length) {
        this.setup();
      }
      $visibleDevice = this.visibleDevice();
      return $visibleDevice.attr("class").split("visible-")[1];
    };

    return BreakpointInstance;
  }();

  Breakpoints.get = function () {
    return instance != null ? instance : instance = new BreakpointInstance();
  };

  return Breakpoints;
}();

$(function () {
  window.bp = Breakpoints.get();
});

window.Breakpoints = Breakpoints;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "LQkq":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable no-param-reassign */
/* global Breakpoints */

__webpack_require__("LINv");
__webpack_require__("CrpE");

(function (global) {
  var Wikis = function () {
    function Wikis() {
      var _this = this;

      _classCallCheck(this, Wikis);

      this.bp = Breakpoints.get();
      this.sidebarEl = document.querySelector('.js-wiki-sidebar');
      this.sidebarExpanded = false;
      $(this.sidebarEl).niceScroll();

      var sidebarToggles = document.querySelectorAll('.js-sidebar-wiki-toggle');
      for (var i = 0; i < sidebarToggles.length; i += 1) {
        sidebarToggles[i].addEventListener('click', function (e) {
          return _this.handleToggleSidebar(e);
        });
      }

      this.newWikiForm = document.querySelector('form.new-wiki-page');
      if (this.newWikiForm) {
        this.newWikiForm.addEventListener('submit', function (e) {
          return _this.handleNewWikiSubmit(e);
        });
      }

      window.addEventListener('resize', function () {
        return _this.renderSidebar();
      });
      this.renderSidebar();
    }

    _createClass(Wikis, [{
      key: 'handleNewWikiSubmit',
      value: function handleNewWikiSubmit(e) {
        if (!this.newWikiForm) return;

        var slugInput = this.newWikiForm.querySelector('#new_wiki_path');
        var slug = gl.text.slugify(slugInput.value);

        if (slug.length > 0) {
          var wikisPath = slugInput.getAttribute('data-wikis-path');
          window.location.href = wikisPath + '/' + slug;
          e.preventDefault();
        }
      }
    }, {
      key: 'handleToggleSidebar',
      value: function handleToggleSidebar(e) {
        e.preventDefault();
        this.sidebarExpanded = !this.sidebarExpanded;
        this.renderSidebar();
      }
    }, {
      key: 'sidebarCanCollapse',
      value: function sidebarCanCollapse() {
        var bootstrapBreakpoint = this.bp.getBreakpointSize();
        return bootstrapBreakpoint === 'xs' || bootstrapBreakpoint === 'sm';
      }
    }, {
      key: 'renderSidebar',
      value: function renderSidebar() {
        if (!this.sidebarEl) return;
        var classList = this.sidebarEl.classList;

        if (this.sidebarExpanded || !this.sidebarCanCollapse()) {
          if (!classList.contains('right-sidebar-expanded')) {
            classList.remove('right-sidebar-collapsed');
            classList.add('right-sidebar-expanded');
          }
        } else if (classList.contains('right-sidebar-expanded')) {
          classList.add('right-sidebar-collapsed');
          classList.remove('right-sidebar-expanded');
        }
      }
    }]);

    return Wikis;
  }();

  global.Wikis = Wikis;
})(window.gl || (window.gl = {}));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "MIHg":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($, jQuery) {/* eslint-disable func-names, space-before-function-paren, no-var, one-var, one-var-declaration-per-line, prefer-rest-params, max-len, vars-on-top, wrap-iife, no-unused-vars, quotes, no-shadow, no-cond-assign, prefer-arrow-callback, no-return-assign, no-else-return, camelcase, comma-dangle, no-lonely-if, guard-for-in, no-restricted-syntax, consistent-return, prefer-template, no-param-reassign, no-loop-func, no-mixed-operators */
/* global fuzzaldrinPlus */

var GitLabDropdown,
    GitLabDropdownFilter,
    GitLabDropdownRemote,
    bind = function bind(fn, me) {
  return function () {
    return fn.apply(me, arguments);
  };
},
    indexOf = [].indexOf || function (item) {
  for (var i = 0, l = this.length; i < l; i += 1) {
    if (i in this && this[i] === item) return i;
  }return -1;
};

GitLabDropdownFilter = function () {
  var ARROW_KEY_CODES, BLUR_KEYCODES, HAS_VALUE_CLASS;

  BLUR_KEYCODES = [27, 40];

  ARROW_KEY_CODES = [38, 40];

  HAS_VALUE_CLASS = "has-value";

  function GitLabDropdownFilter(input, options) {
    var $clearButton, $inputContainer, ref, timeout;
    this.input = input;
    this.options = options;
    this.filterInputBlur = (ref = this.options.filterInputBlur) != null ? ref : true;
    $inputContainer = this.input.parent();
    $clearButton = $inputContainer.find('.js-dropdown-input-clear');
    $clearButton.on('click', function (_this) {
      // Clear click
      return function (e) {
        e.preventDefault();
        e.stopPropagation();
        return _this.input.val('').trigger('input').focus();
      };
    }(this));
    // Key events
    timeout = "";
    this.input.on('keydown', function (e) {
      var keyCode = e.which;
      if (keyCode === 13 && !options.elIsInput) {
        e.preventDefault();
      }
    }).on('input', function () {
      if (this.input.val() !== "" && !$inputContainer.hasClass(HAS_VALUE_CLASS)) {
        $inputContainer.addClass(HAS_VALUE_CLASS);
      } else if (this.input.val() === "" && $inputContainer.hasClass(HAS_VALUE_CLASS)) {
        $inputContainer.removeClass(HAS_VALUE_CLASS);
      }
      // Only filter asynchronously only if option remote is set
      if (this.options.remote) {
        clearTimeout(timeout);
        return timeout = setTimeout(function () {
          $inputContainer.parent().addClass('is-loading');

          return this.options.query(this.input.val(), function (data) {
            $inputContainer.parent().removeClass('is-loading');
            return this.options.callback(data);
          }.bind(this));
        }.bind(this), 250);
      } else {
        return this.filter(this.input.val());
      }
    }.bind(this));
  }

  GitLabDropdownFilter.prototype.shouldBlur = function (keyCode) {
    return BLUR_KEYCODES.indexOf(keyCode) !== -1;
  };

  GitLabDropdownFilter.prototype.filter = function (search_text) {
    var data, elements, group, key, results, tmp;
    if (this.options.onFilter) {
      this.options.onFilter(search_text);
    }
    data = this.options.data();
    if (data != null && !this.options.filterByText) {
      results = data;
      if (search_text !== '') {
        // When data is an array of objects therefore [object Array] e.g.
        // [
        //   { prop: 'foo' },
        //   { prop: 'baz' }
        // ]
        if (_.isArray(data)) {
          results = fuzzaldrinPlus.filter(data, search_text, {
            key: this.options.keys
          });
        } else {
          // If data is grouped therefore an [object Object]. e.g.
          // {
          //   groupName1: [
          //     { prop: 'foo' },
          //     { prop: 'baz' }
          //   ],
          //   groupName2: [
          //     { prop: 'abc' },
          //     { prop: 'def' }
          //   ]
          // }
          if (gl.utils.isObject(data)) {
            results = {};
            for (key in data) {
              group = data[key];
              tmp = fuzzaldrinPlus.filter(group, search_text, {
                key: this.options.keys
              });
              if (tmp.length) {
                results[key] = tmp.map(function (item) {
                  return item;
                });
              }
            }
          }
        }
      }
      return this.options.callback(results);
    } else {
      elements = this.options.elements();
      if (search_text) {
        return elements.each(function () {
          var $el, matches;
          $el = $(this);
          matches = fuzzaldrinPlus.match($el.text().trim(), search_text);
          if (!$el.is('.dropdown-header')) {
            if (matches.length) {
              return $el.show().removeClass('option-hidden');
            } else {
              return $el.hide().addClass('option-hidden');
            }
          }
        });
      } else {
        return elements.show().removeClass('option-hidden');
      }
    }
  };

  return GitLabDropdownFilter;
}();

GitLabDropdownRemote = function () {
  function GitLabDropdownRemote(dataEndpoint, options) {
    this.dataEndpoint = dataEndpoint;
    this.options = options;
  }

  GitLabDropdownRemote.prototype.execute = function () {
    if (typeof this.dataEndpoint === "string") {
      return this.fetchData();
    } else if (typeof this.dataEndpoint === "function") {
      if (this.options.beforeSend) {
        this.options.beforeSend();
      }
      return this.dataEndpoint("", function (_this) {
        // Fetch the data by calling the data funcfion
        return function (data) {
          if (_this.options.success) {
            _this.options.success(data);
          }
          if (_this.options.beforeSend) {
            return _this.options.beforeSend();
          }
        };
      }(this));
    }
  };

  GitLabDropdownRemote.prototype.fetchData = function () {
    return $.ajax({
      url: this.dataEndpoint,
      dataType: this.options.dataType,
      beforeSend: function (_this) {
        return function () {
          if (_this.options.beforeSend) {
            return _this.options.beforeSend();
          }
        };
      }(this),
      success: function (_this) {
        return function (data) {
          if (_this.options.success) {
            return _this.options.success(data);
          }
        };
      }(this)
    });
    // Fetch the data through ajax if the data is a string
  };

  return GitLabDropdownRemote;
}();

GitLabDropdown = function () {
  var ACTIVE_CLASS, FILTER_INPUT, INDETERMINATE_CLASS, LOADING_CLASS, PAGE_TWO_CLASS, NON_SELECTABLE_CLASSES, SELECTABLE_CLASSES, CURSOR_SELECT_SCROLL_PADDING, currentIndex;

  LOADING_CLASS = "is-loading";

  PAGE_TWO_CLASS = "is-page-two";

  ACTIVE_CLASS = "is-active";

  INDETERMINATE_CLASS = "is-indeterminate";

  currentIndex = -1;

  NON_SELECTABLE_CLASSES = '.divider, .separator, .dropdown-header, .dropdown-menu-empty-link';

  SELECTABLE_CLASSES = ".dropdown-content li:not(" + NON_SELECTABLE_CLASSES + ", .option-hidden)";

  CURSOR_SELECT_SCROLL_PADDING = 5;

  FILTER_INPUT = '.dropdown-input .dropdown-input-field';

  function GitLabDropdown(el1, options) {
    var searchFields, selector, self;
    this.el = el1;
    this.options = options;
    this.updateLabel = bind(this.updateLabel, this);
    this.hidden = bind(this.hidden, this);
    this.opened = bind(this.opened, this);
    this.shouldPropagate = bind(this.shouldPropagate, this);
    self = this;
    selector = $(this.el).data("target");
    this.dropdown = selector != null ? $(selector) : $(this.el).parent();
    // Set Defaults
    this.filterInput = this.options.filterInput || this.getElement(FILTER_INPUT);
    this.highlight = !!this.options.highlight;
    this.filterInputBlur = this.options.filterInputBlur != null ? this.options.filterInputBlur : true;
    // If no input is passed create a default one
    self = this;
    // If selector was passed
    if (_.isString(this.filterInput)) {
      this.filterInput = this.getElement(this.filterInput);
    }
    searchFields = this.options.search ? this.options.search.fields : [];
    if (this.options.data) {
      // If we provided data
      // data could be an array of objects or a group of arrays
      if (_.isObject(this.options.data) && !_.isFunction(this.options.data)) {
        this.fullData = this.options.data;
        currentIndex = -1;
        this.parseData(this.options.data);
        this.focusTextInput();
      } else {
        this.remote = new GitLabDropdownRemote(this.options.data, {
          dataType: this.options.dataType,
          beforeSend: this.toggleLoading.bind(this),
          success: function (_this) {
            return function (data) {
              _this.fullData = data;
              _this.parseData(_this.fullData);
              _this.focusTextInput();
              if (_this.options.filterable && _this.filter && _this.filter.input && _this.filter.input.val() && _this.filter.input.val().trim() !== '') {
                return _this.filter.input.trigger('input');
              }
            };
            // Remote data
          }(this)
        });
      }
    }
    // Init filterable
    if (this.options.filterable) {
      this.filter = new GitLabDropdownFilter(this.filterInput, {
        elIsInput: $(this.el).is('input'),
        filterInputBlur: this.filterInputBlur,
        filterByText: this.options.filterByText,
        onFilter: this.options.onFilter,
        remote: this.options.filterRemote,
        query: this.options.data,
        keys: searchFields,
        elements: function (_this) {
          return function () {
            selector = '.dropdown-content li:not(' + NON_SELECTABLE_CLASSES + ')';
            if (_this.dropdown.find('.dropdown-toggle-page').length) {
              selector = ".dropdown-page-one " + selector;
            }
            return $(selector);
          };
        }(this),
        data: function (_this) {
          return function () {
            return _this.fullData;
          };
        }(this),
        callback: function (_this) {
          return function (data) {
            _this.parseData(data);
            if (_this.filterInput.val() !== '') {
              selector = SELECTABLE_CLASSES;
              if (_this.dropdown.find('.dropdown-toggle-page').length) {
                selector = ".dropdown-page-one " + selector;
              }
              if ($(_this.el).is('input')) {
                currentIndex = -1;
              } else {
                $(selector, _this.dropdown).first().find('a').addClass('is-focused');
                currentIndex = 0;
              }
            }
          };
        }(this)
      });
    }
    // Event listeners
    this.dropdown.on("shown.bs.dropdown", this.opened);
    this.dropdown.on("hidden.bs.dropdown", this.hidden);
    $(this.el).on("update.label", this.updateLabel);
    this.dropdown.on("click", ".dropdown-menu, .dropdown-menu-close", this.shouldPropagate);
    this.dropdown.on('keyup', function (_this) {
      return function (e) {
        // Escape key
        if (e.which === 27) {
          return $('.dropdown-menu-close', _this.dropdown).trigger('click');
        }
      };
    }(this));
    this.dropdown.on('blur', 'a', function (_this) {
      return function (e) {
        var $dropdownMenu, $relatedTarget;
        if (e.relatedTarget != null) {
          $relatedTarget = $(e.relatedTarget);
          $dropdownMenu = $relatedTarget.closest('.dropdown-menu');
          if ($dropdownMenu.length === 0) {
            return _this.dropdown.removeClass('open');
          }
        }
      };
    }(this));
    if (this.dropdown.find(".dropdown-toggle-page").length) {
      this.dropdown.find(".dropdown-toggle-page, .dropdown-menu-back").on("click", function (_this) {
        return function (e) {
          e.preventDefault();
          e.stopPropagation();
          return _this.togglePage();
        };
      }(this));
    }
    if (this.options.selectable) {
      selector = ".dropdown-content a";
      if (this.dropdown.find(".dropdown-toggle-page").length) {
        selector = ".dropdown-page-one .dropdown-content a";
      }
      this.dropdown.on("click", selector, function (e) {
        var $el, selected, selectedObj, isMarking;
        $el = $(this);
        selected = self.rowClicked($el);
        selectedObj = selected ? selected[0] : null;
        isMarking = selected ? selected[1] : null;
        if (self.options.clicked) {
          self.options.clicked(selectedObj, $el, e, isMarking);
        }

        // Update label right after all modifications in dropdown has been done
        if (self.options.toggleLabel) {
          self.updateLabel(selectedObj, $el, self);
        }

        $el.trigger('blur');
      });
    }
  }

  // Finds an element inside wrapper element
  GitLabDropdown.prototype.getElement = function (selector) {
    return this.dropdown.find(selector);
  };

  GitLabDropdown.prototype.toggleLoading = function () {
    return $('.dropdown-menu', this.dropdown).toggleClass(LOADING_CLASS);
  };

  GitLabDropdown.prototype.togglePage = function () {
    var menu;
    menu = $('.dropdown-menu', this.dropdown);
    if (menu.hasClass(PAGE_TWO_CLASS)) {
      if (this.remote) {
        this.remote.execute();
      }
    }
    menu.toggleClass(PAGE_TWO_CLASS);
    // Focus first visible input on active page
    return this.dropdown.find('[class^="dropdown-page-"]:visible :text:visible:first').focus();
  };

  GitLabDropdown.prototype.parseData = function (data) {
    var full_html, groupData, html, name;
    this.renderedData = data;
    if (this.options.filterable && data.length === 0) {
      // render no matching results
      html = [this.noResults()];
    } else {
      // Handle array groups
      if (gl.utils.isObject(data)) {
        html = [];
        for (name in data) {
          groupData = data[name];
          html.push(this.renderItem({
            header: name
            // Add header for each group
          }, name));
          this.renderData(groupData, name).map(function (item) {
            return html.push(item);
          });
        }
      } else {
        // Render each row
        html = this.renderData(data);
      }
    }
    // Render the full menu
    full_html = this.renderMenu(html);
    return this.appendMenu(full_html);
  };

  GitLabDropdown.prototype.renderData = function (data, group) {
    if (group == null) {
      group = false;
    }
    return data.map(function (_this) {
      return function (obj, index) {
        return _this.renderItem(obj, group, index);
      };
    }(this));
  };

  GitLabDropdown.prototype.shouldPropagate = function (e) {
    var $target;
    if (this.options.multiSelect) {
      $target = $(e.target);
      if ($target && !$target.hasClass('dropdown-menu-close') && !$target.hasClass('dropdown-menu-close-icon') && !$target.data('is-link')) {
        e.stopPropagation();
        return false;
      } else {
        return true;
      }
    }
  };

  GitLabDropdown.prototype.opened = function (e) {
    var contentHtml;
    this.resetRows();
    this.addArrowKeyEvent();

    // Makes indeterminate items effective
    if (this.fullData && this.dropdown.find('.dropdown-menu-toggle').hasClass('js-filter-bulk-update')) {
      this.parseData(this.fullData);
    }
    contentHtml = $('.dropdown-content', this.dropdown).html();
    if (this.remote && contentHtml === "") {
      this.remote.execute();
    } else {
      this.focusTextInput();
    }

    if (this.options.showMenuAbove) {
      this.positionMenuAbove();
    }

    if (this.options.opened) {
      this.options.opened.call(this, e);
    }

    return this.dropdown.trigger('shown.gl.dropdown');
  };

  GitLabDropdown.prototype.positionMenuAbove = function () {
    var $button = $(this.el);
    var $menu = this.dropdown.find('.dropdown-menu');

    $menu.css('top', ($button.height() + $menu.height()) * -1);
  };

  GitLabDropdown.prototype.hidden = function (e) {
    var $input;
    this.resetRows();
    this.removeArrayKeyEvent();
    $input = this.dropdown.find(".dropdown-input-field");
    if (this.options.filterable) {
      $input.blur();
    }
    if (this.dropdown.find(".dropdown-toggle-page").length) {
      $('.dropdown-menu', this.dropdown).removeClass(PAGE_TWO_CLASS);
    }
    if (this.options.hidden) {
      this.options.hidden.call(this, e);
    }
    return this.dropdown.trigger('hidden.gl.dropdown');
  };

  // Render the full menu
  GitLabDropdown.prototype.renderMenu = function (html) {
    if (this.options.renderMenu) {
      return this.options.renderMenu(html);
    } else {
      var ul = document.createElement('ul');

      for (var i = 0; i < html.length; i += 1) {
        var el = html[i];

        if (el instanceof jQuery) {
          el = el.get(0);
        }

        if (typeof el === 'string') {
          ul.innerHTML += el;
        } else {
          ul.appendChild(el);
        }
      }

      return ul;
    }
  };

  // Append the menu into the dropdown
  GitLabDropdown.prototype.appendMenu = function (html) {
    return this.clearMenu().append(html);
  };

  GitLabDropdown.prototype.clearMenu = function () {
    var selector;
    selector = '.dropdown-content';
    if (this.dropdown.find(".dropdown-toggle-page").length) {
      selector = ".dropdown-page-one .dropdown-content";
    }

    return $(selector, this.dropdown).empty();
  };

  GitLabDropdown.prototype.renderItem = function (data, group, index) {
    var field, fieldName, html, selected, text, url, value;
    if (group == null) {
      group = false;
    }
    if (index == null) {
      // Render the row
      index = false;
    }
    html = document.createElement('li');
    if (data === 'divider' || data === 'separator') {
      html.className = data;
      return html;
    }
    // Header
    if (data.header != null) {
      html.className = 'dropdown-header';
      html.innerHTML = data.header;
      return html;
    }
    if (this.options.renderRow) {
      // Call the render function
      html = this.options.renderRow.call(this.options, data, this);
    } else {
      if (!selected) {
        value = this.options.id ? this.options.id(data) : data.id;
        fieldName = this.options.fieldName;

        if (value) {
          value = value.toString().replace(/'/g, '\\\'');
        }

        field = this.dropdown.parent().find("input[name='" + fieldName + "'][value='" + value + "']");
        if (field.length) {
          selected = true;
        }
      }
      // Set URL
      if (this.options.url != null) {
        url = this.options.url(data);
      } else {
        url = data.url != null ? data.url : '#';
      }
      // Set Text
      if (this.options.text != null) {
        text = this.options.text(data);
      } else {
        text = data.text != null ? data.text : '';
      }
      if (this.highlight) {
        text = this.highlightTextMatches(text, this.filterInput.val());
      }
      // Create the list item & the link
      var link = document.createElement('a');

      link.href = url;
      link.innerHTML = text;

      if (selected) {
        link.className = 'is-active';
      }

      if (group) {
        link.dataset.group = group;
        link.dataset.index = index;
      }

      html.appendChild(link);
    }
    return html;
  };

  GitLabDropdown.prototype.highlightTextMatches = function (text, term) {
    var occurrences;
    occurrences = fuzzaldrinPlus.match(text, term);
    return text.split('').map(function (character, i) {
      if (indexOf.call(occurrences, i) !== -1) {
        return "<b>" + character + "</b>";
      } else {
        return character;
      }
    }).join('');
  };

  GitLabDropdown.prototype.noResults = function () {
    var html;
    return html = "<li class='dropdown-menu-empty-link'> <a href='#' class='is-focused'> No matching results. </a> </li>";
  };

  GitLabDropdown.prototype.rowClicked = function (el) {
    var field, fieldName, groupName, isInput, selectedIndex, selectedObject, value, isMarking;

    fieldName = this.options.fieldName;
    isInput = $(this.el).is('input');
    if (this.renderedData) {
      groupName = el.data('group');
      if (groupName) {
        selectedIndex = el.data('index');
        selectedObject = this.renderedData[groupName][selectedIndex];
      } else {
        selectedIndex = el.closest('li').index();
        selectedObject = this.renderedData[selectedIndex];
      }
    }

    if (this.options.vue) {
      if (el.hasClass(ACTIVE_CLASS)) {
        el.removeClass(ACTIVE_CLASS);
      } else {
        el.addClass(ACTIVE_CLASS);
      }

      return [selectedObject];
    }

    field = [];
    value = this.options.id ? this.options.id(selectedObject, el) : selectedObject.id;
    if (isInput) {
      field = $(this.el);
    } else if (value) {
      field = this.dropdown.parent().find("input[name='" + fieldName + "'][value='" + value.toString().replace(/'/g, '\\\'') + "']");
    }

    if (this.options.isSelectable && !this.options.isSelectable(selectedObject, el)) {
      return;
    }

    if (el.hasClass(ACTIVE_CLASS)) {
      isMarking = false;
      el.removeClass(ACTIVE_CLASS);
      if (field && field.length) {
        this.clearField(field, isInput);
      }
    } else if (el.hasClass(INDETERMINATE_CLASS)) {
      isMarking = true;
      el.addClass(ACTIVE_CLASS);
      el.removeClass(INDETERMINATE_CLASS);
      if (field && field.length && value == null) {
        this.clearField(field, isInput);
      }
      if ((!field || !field.length) && fieldName) {
        this.addInput(fieldName, value, selectedObject);
      }
    } else {
      isMarking = true;
      if (!this.options.multiSelect || el.hasClass('dropdown-clear-active')) {
        this.dropdown.find("." + ACTIVE_CLASS).removeClass(ACTIVE_CLASS);
        if (!isInput) {
          this.dropdown.parent().find("input[name='" + fieldName + "']").remove();
        }
      }
      if (field && field.length && value == null) {
        this.clearField(field, isInput);
      }
      // Toggle active class for the tick mark
      el.addClass(ACTIVE_CLASS);
      if (value != null) {
        if ((!field || !field.length) && fieldName) {
          this.addInput(fieldName, value, selectedObject);
        } else if (field && field.length) {
          field.val(value).trigger('change');
        }
      }
    }

    return [selectedObject, isMarking];
  };

  GitLabDropdown.prototype.focusTextInput = function () {
    if (this.options.filterable) {
      this.filterInput.focus();
    }
  };

  GitLabDropdown.prototype.addInput = function (fieldName, value, selectedObject) {
    var $input;
    // Create hidden input for form
    $input = $('<input>').attr('type', 'hidden').attr('name', fieldName).val(value);
    if (this.options.inputId != null) {
      $input.attr('id', this.options.inputId);
    }
    return this.dropdown.before($input);
  };

  GitLabDropdown.prototype.selectRowAtIndex = function (index) {
    var $el, selector;
    // If we pass an option index
    if (typeof index !== "undefined") {
      selector = SELECTABLE_CLASSES + ":eq(" + index + ") a";
    } else {
      selector = ".dropdown-content .is-focused";
    }
    if (this.dropdown.find(".dropdown-toggle-page").length) {
      selector = ".dropdown-page-one " + selector;
    }
    // simulate a click on the first link
    $el = $(selector, this.dropdown);
    if ($el.length) {
      var href = $el.attr('href');
      if (href && href !== '#') {
        gl.utils.visitUrl(href);
      } else {
        $el.first().trigger('click');
      }
    }
  };

  GitLabDropdown.prototype.addArrowKeyEvent = function () {
    var $input, ARROW_KEY_CODES, selector;
    ARROW_KEY_CODES = [38, 40];
    $input = this.dropdown.find(".dropdown-input-field");
    selector = SELECTABLE_CLASSES;
    if (this.dropdown.find(".dropdown-toggle-page").length) {
      selector = ".dropdown-page-one " + selector;
    }
    return $('body').on('keydown', function (_this) {
      return function (e) {
        var $listItems, PREV_INDEX, currentKeyCode;
        currentKeyCode = e.which;
        if (ARROW_KEY_CODES.indexOf(currentKeyCode) !== -1) {
          e.preventDefault();
          e.stopImmediatePropagation();
          PREV_INDEX = currentIndex;
          $listItems = $(selector, _this.dropdown);
          // if @options.filterable
          //   $input.blur()
          if (currentKeyCode === 40) {
            // Move down
            if (currentIndex < $listItems.length - 1) {
              currentIndex += 1;
            }
          } else if (currentKeyCode === 38) {
            // Move up
            if (currentIndex > 0) {
              currentIndex -= 1;
            }
          }
          if (currentIndex !== PREV_INDEX) {
            _this.highlightRowAtIndex($listItems, currentIndex);
          }
          return false;
        }
        if (currentKeyCode === 13 && currentIndex !== -1) {
          e.preventDefault();
          _this.selectRowAtIndex();
        }
      };
    }(this));
  };

  GitLabDropdown.prototype.removeArrayKeyEvent = function () {
    return $('body').off('keydown');
  };

  GitLabDropdown.prototype.resetRows = function resetRows() {
    currentIndex = -1;
    $('.is-focused', this.dropdown).removeClass('is-focused');
  };

  GitLabDropdown.prototype.highlightRowAtIndex = function ($listItems, index) {
    var $dropdownContent, $listItem, dropdownContentBottom, dropdownContentHeight, dropdownContentTop, dropdownScrollTop, listItemBottom, listItemHeight, listItemTop;
    // Remove the class for the previously focused row
    $('.is-focused', this.dropdown).removeClass('is-focused');
    // Update the class for the row at the specific index
    $listItem = $listItems.eq(index);
    $listItem.find('a:first-child').addClass("is-focused");
    // Dropdown content scroll area
    $dropdownContent = $listItem.closest('.dropdown-content');
    dropdownScrollTop = $dropdownContent.scrollTop();
    dropdownContentHeight = $dropdownContent.outerHeight();
    dropdownContentTop = $dropdownContent.prop('offsetTop');
    dropdownContentBottom = dropdownContentTop + dropdownContentHeight;
    // Get the offset bottom of the list item
    listItemHeight = $listItem.outerHeight();
    listItemTop = $listItem.prop('offsetTop');
    listItemBottom = listItemTop + listItemHeight;
    if (!index) {
      // Scroll the dropdown content to the top
      $dropdownContent.scrollTop(0);
    } else if (index === $listItems.length - 1) {
      // Scroll the dropdown content to the bottom
      $dropdownContent.scrollTop($dropdownContent.prop('scrollHeight'));
    } else if (listItemBottom > dropdownContentBottom + dropdownScrollTop) {
      // Scroll the dropdown content down
      $dropdownContent.scrollTop(listItemBottom - dropdownContentBottom + CURSOR_SELECT_SCROLL_PADDING);
    } else if (listItemTop < dropdownContentTop + dropdownScrollTop) {
      // Scroll the dropdown content up
      return $dropdownContent.scrollTop(listItemTop - dropdownContentTop - CURSOR_SELECT_SCROLL_PADDING);
    }
  };

  GitLabDropdown.prototype.updateLabel = function (selected, el, instance) {
    if (selected == null) {
      selected = null;
    }
    if (el == null) {
      el = null;
    }
    if (instance == null) {
      instance = null;
    }
    return $(this.el).find(".dropdown-toggle-text").text(this.options.toggleLabel(selected, el, instance));
  };

  GitLabDropdown.prototype.clearField = function (field, isInput) {
    return isInput ? field.val('') : field.remove();
  };

  return GitLabDropdown;
}();

$.fn.glDropdown = function (opts) {
  return this.each(function () {
    if (!$.data(this, 'glDropdown')) {
      return $.data(this, 'glDropdown', new GitLabDropdown(this, opts));
    }
  });
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq"), __webpack_require__("lwLq")))

/***/ }),

/***/ "MKXP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__issue__ = __webpack_require__("cMCw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__behaviors_bind_in_out__ = __webpack_require__("Vhgc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__group__ = __webpack_require__("Cvli");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__group_name__ = __webpack_require__("Kk2p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__groups_list__ = __webpack_require__("3Yvy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__projects_list__ = __webpack_require__("KA+m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mini_pipeline_graph_dropdown__ = __webpack_require__("6cNp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__blob_blob_line_permalink_updater__ = __webpack_require__("QzBj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__blob_blob_fork_suggestion__ = __webpack_require__("w2Or");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__user_callout__ = __webpack_require__("chcu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__protected_tags__ = __webpack_require__("FCUV");
/* eslint-disable func-names, space-before-function-paren, no-var, prefer-arrow-callback, wrap-iife, no-shadow, consistent-return, one-var, one-var-declaration-per-line, camelcase, default-case, no-new, quotes, no-duplicate-case, no-case-declarations, no-fallthrough, max-len */
/* global UsernameValidator */
/* global ActiveTabMemoizer */
/* global ShortcutsNavigation */
/* global Build */
/* global Issuable */
/* global ShortcutsIssuable */
/* global ZenMode */
/* global Milestone */
/* global IssuableForm */
/* global LabelsSelect */
/* global MilestoneSelect */
/* global MergedButtons */
/* global Commit */
/* global NotificationsForm */
/* global TreeView */
/* global NotificationsDropdown */
/* global UsersSelect */
/* global GroupAvatar */
/* global LineHighlighter */
/* global ProjectFork */
/* global BuildArtifacts */
/* global GroupsSelect */
/* global Search */
/* global Admin */
/* global NamespaceSelects */
/* global Project */
/* global ProjectAvatar */
/* global CompareAutocomplete */
/* global ProjectNew */
/* global Star */
/* global ProjectShow */
/* global Labels */
/* global Shortcuts */
/* global Sidebar */














var ShortcutsBlob = __webpack_require__("/YCK");

(function () {
  var Dispatcher;

  $(function () {
    return new Dispatcher();
  });

  Dispatcher = function () {
    function Dispatcher() {
      this.initSearch();
      this.initFieldErrors();
      this.initPageScripts();
    }

    Dispatcher.prototype.initPageScripts = function () {
      var page, path, shortcut_handler, fileBlobPermalinkUrlElement, fileBlobPermalinkUrl;
      page = $('body').attr('data-page');
      if (!page) {
        return false;
      }
      path = page.split(':');
      shortcut_handler = null;

      function initBlob() {
        new LineHighlighter();

        new __WEBPACK_IMPORTED_MODULE_7__blob_blob_line_permalink_updater__["a" /* default */](document.querySelector('#blob-content-holder'), '.diff-line-num[data-line-number]', document.querySelectorAll('.js-data-file-blob-permalink-url, .js-blob-blame-link'));

        shortcut_handler = new ShortcutsNavigation();
        fileBlobPermalinkUrlElement = document.querySelector('.js-data-file-blob-permalink-url');
        fileBlobPermalinkUrl = fileBlobPermalinkUrlElement && fileBlobPermalinkUrlElement.getAttribute('href');
        new ShortcutsBlob({
          skipResetBindings: true,
          fileBlobPermalinkUrl: fileBlobPermalinkUrl
        });

        new __WEBPACK_IMPORTED_MODULE_8__blob_blob_fork_suggestion__["a" /* default */](document.querySelector('.js-edit-blob-link-fork-toggler'), document.querySelector('.js-cancel-fork-suggestion'), document.querySelector('.js-file-fork-suggestion-section'));
      }

      switch (page) {
        case 'sessions:new':
          new UsernameValidator();
          new ActiveTabMemoizer();
          break;
        case 'projects:boards:show':
        case 'projects:boards:index':
          shortcut_handler = new ShortcutsNavigation();
          break;
        case 'projects:builds:show':
          new Build();
          break;
        case 'projects:merge_requests:index':
        case 'projects:issues:index':
          if (gl.FilteredSearchManager) {
            new gl.FilteredSearchManager(page === 'projects:issues:index' ? 'issues' : 'merge_requests');
          }
          Issuable.init();
          new gl.IssuableBulkActions({
            prefixId: page === 'projects:merge_requests:index' ? 'merge_request_' : 'issue_'
          });
          shortcut_handler = new ShortcutsNavigation();
          break;
        case 'projects:issues:show':
          new __WEBPACK_IMPORTED_MODULE_0__issue__["a" /* default */]();
          shortcut_handler = new ShortcutsIssuable();
          new ZenMode();
          break;
        case 'projects:milestones:show':
        case 'groups:milestones:show':
        case 'dashboard:milestones:show':
          new Milestone();
          new Sidebar();
          break;
        case 'dashboard:todos:index':
          new gl.Todos();
          break;
        case 'dashboard:projects:index':
        case 'dashboard:projects:starred':
        case 'explore:projects:index':
        case 'explore:projects:trending':
        case 'explore:projects:starred':
        case 'admin:projects:index':
          new __WEBPACK_IMPORTED_MODULE_5__projects_list__["a" /* default */]();
          break;
        case 'dashboard:groups:index':
        case 'explore:groups:index':
          new __WEBPACK_IMPORTED_MODULE_4__groups_list__["default"]();
          break;
        case 'projects:milestones:new':
        case 'projects:milestones:edit':
        case 'projects:milestones:update':
        case 'groups:milestones:new':
        case 'groups:milestones:edit':
        case 'groups:milestones:update':
          new ZenMode();
          new gl.DueDateSelectors();
          new gl.GLForm($('.milestone-form'));
          break;
        case 'projects:compare:show':
          new gl.Diff();
          break;
        case 'projects:branches:index':
          gl.AjaxLoadingSpinner.init();
          break;
        case 'projects:issues:new':
        case 'projects:issues:edit':
          shortcut_handler = new ShortcutsNavigation();
          new gl.GLForm($('.issue-form'));
          new IssuableForm($('.issue-form'));
          new LabelsSelect();
          new MilestoneSelect();
          new gl.IssuableTemplateSelectors();
          break;
        case 'projects:merge_requests:new':
        case 'projects:merge_requests:new_diffs':
        case 'projects:merge_requests:edit':
          new gl.Diff();
          shortcut_handler = new ShortcutsNavigation();
          new gl.GLForm($('.merge-request-form'));
          new IssuableForm($('.merge-request-form'));
          new LabelsSelect();
          new MilestoneSelect();
          new gl.IssuableTemplateSelectors();
          break;
        case 'projects:tags:new':
          new ZenMode();
          new gl.GLForm($('.tag-form'));
          break;
        case 'projects:releases:edit':
          new ZenMode();
          new gl.GLForm($('.release-form'));
          break;
        case 'projects:merge_requests:show':
          new gl.Diff();
          shortcut_handler = new ShortcutsIssuable(true);
          new ZenMode();
          new MergedButtons();
          break;
        case 'projects:merge_requests:commits':
          new MergedButtons();
          break;
        case "projects:merge_requests:diffs":
          new gl.Diff();
          new ZenMode();
          new MergedButtons();
          break;
        case 'dashboard:activity':
          new gl.Activities();
          break;
        case 'projects:commit:show':
          new Commit();
          new gl.Diff();
          new ZenMode();
          shortcut_handler = new ShortcutsNavigation();
          new __WEBPACK_IMPORTED_MODULE_6__mini_pipeline_graph_dropdown__["a" /* default */]({
            container: '.js-commit-pipeline-graph'
          }).bindEvents();
          break;
        case 'projects:commit:pipelines':
          new __WEBPACK_IMPORTED_MODULE_6__mini_pipeline_graph_dropdown__["a" /* default */]({
            container: '.js-commit-pipeline-graph'
          }).bindEvents();
          break;
        case 'projects:commits:show':
        case 'projects:activity':
          shortcut_handler = new ShortcutsNavigation();
          break;
        case 'projects:show':
          shortcut_handler = new ShortcutsNavigation();
          new NotificationsForm();
          if ($('#tree-slider').length) {
            new TreeView();
          }
          break;
        case 'projects:pipelines:builds':
        case 'projects:pipelines:show':
          var controllerAction = document.querySelector('.js-pipeline-container').dataset.controllerAction;

          var pipelineStatusUrl = document.querySelector('.js-pipeline-tab-link a').getAttribute('href') + '/status.json';

          new gl.Pipelines({
            initTabs: true,
            pipelineStatusUrl: pipelineStatusUrl,
            tabsOptions: {
              action: controllerAction,
              defaultAction: 'pipelines',
              parentEl: '.pipelines-tabs'
            }
          });
          break;
        case 'groups:activity':
          new gl.Activities();
          break;
        case 'groups:show':
          shortcut_handler = new ShortcutsNavigation();
          new NotificationsForm();
          new NotificationsDropdown();
          new __WEBPACK_IMPORTED_MODULE_5__projects_list__["a" /* default */]();
          break;
        case 'groups:group_members:index':
          new gl.MemberExpirationDate();
          new gl.Members();
          new UsersSelect();
          break;
        case 'projects:members:show':
          new gl.MemberExpirationDate('.js-access-expiration-date-groups');
          new GroupsSelect();
          new gl.MemberExpirationDate();
          new gl.Members();
          new UsersSelect();
          break;
        case 'groups:new':
        case 'admin:groups:new':
        case 'groups:create':
        case 'admin:groups:create':
          __WEBPACK_IMPORTED_MODULE_1__behaviors_bind_in_out__["a" /* default */].initAll();
          new __WEBPACK_IMPORTED_MODULE_2__group__["default"]();
          new GroupAvatar();
          break;
        case 'groups:edit':
        case 'admin:groups:edit':
          new GroupAvatar();
          break;
        case 'projects:tree:show':
          shortcut_handler = new ShortcutsNavigation();
          new TreeView();
          gl.TargetBranchDropDown.bootstrap();
          break;
        case 'projects:find_file:show':
          shortcut_handler = true;
          break;
        case 'projects:blob:new':
          gl.TargetBranchDropDown.bootstrap();
          break;
        case 'projects:blob:create':
          gl.TargetBranchDropDown.bootstrap();
          break;
        case 'projects:blob:show':
          gl.TargetBranchDropDown.bootstrap();
          initBlob();
          break;
        case 'projects:blob:edit':
          gl.TargetBranchDropDown.bootstrap();
          break;
        case 'projects:blame:show':
          initBlob();
          break;
        case 'groups:labels:new':
        case 'groups:labels:edit':
        case 'projects:labels:new':
        case 'projects:labels:edit':
          new Labels();
          break;
        case 'projects:labels:index':
          if ($('.prioritized-labels').length) {
            new gl.LabelManager();
          }
          break;
        case 'projects:network:show':
          // Ensure we don't create a particular shortcut handler here. This is
          // already created, where the network graph is created.
          shortcut_handler = true;
          break;
        case 'projects:forks:new':
          new ProjectFork();
          break;
        case 'projects:artifacts:browse':
          new BuildArtifacts();
          break;
        case 'help:index':
          gl.VersionCheckImage.bindErrorEvent($('img.js-version-status-badge'));
          break;
        case 'search:show':
          new Search();
          break;
        case 'projects:repository:show':
          // Initialize Protected Branch Settings
          new gl.ProtectedBranchCreate();
          new gl.ProtectedBranchEditList();
          // Initialize Protected Tag Settings
          new __WEBPACK_IMPORTED_MODULE_10__protected_tags__["ProtectedTagCreate"]();
          new __WEBPACK_IMPORTED_MODULE_10__protected_tags__["ProtectedTagEditList"]();
          break;
        case 'projects:ci_cd:show':
          new gl.ProjectVariables();
          break;
        case 'ci:lints:create':
        case 'ci:lints:show':
          new gl.CILintEditor();
          break;
        case 'users:show':
          new __WEBPACK_IMPORTED_MODULE_9__user_callout__["a" /* default */]();
          break;
      }
      switch (path.first()) {
        case 'sessions':
        case 'omniauth_callbacks':
          if (!gon.u2f) break;
          gl.u2fAuthenticate = new gl.U2FAuthenticate($('#js-authenticate-u2f'), '#js-login-u2f-form', gon.u2f, document.querySelector('#js-login-2fa-device'), document.querySelector('.js-2fa-form'));
          gl.u2fAuthenticate.start();
        case 'admin':
          new Admin();
          switch (path[1]) {
            case 'cohorts':
              new gl.UsagePing();
              break;
            case 'groups':
              new UsersSelect();
              break;
            case 'projects':
              new NamespaceSelects();
              break;
            case 'labels':
              switch (path[2]) {
                case 'new':
                case 'edit':
                  new Labels();
              }
            case 'abuse_reports':
              new gl.AbuseReports();
              break;
          }
          break;
        case 'dashboard':
        case 'root':
          new __WEBPACK_IMPORTED_MODULE_9__user_callout__["a" /* default */]();
          break;
        case 'groups':
          new __WEBPACK_IMPORTED_MODULE_3__group_name__["a" /* default */]();
          break;
        case 'profiles':
          new NotificationsForm();
          new NotificationsDropdown();
          break;
        case 'projects':
          new Project();
          new ProjectAvatar();
          new __WEBPACK_IMPORTED_MODULE_3__group_name__["a" /* default */]();
          switch (path[1]) {
            case 'compare':
              new CompareAutocomplete();
              break;
            case 'edit':
              shortcut_handler = new ShortcutsNavigation();
              new ProjectNew();
              break;
            case 'new':
              new ProjectNew();
              break;
            case 'show':
              new Star();
              new ProjectNew();
              new ProjectShow();
              new NotificationsDropdown();
              break;
            case 'wikis':
              new gl.Wikis();
              shortcut_handler = new ShortcutsNavigation();
              new ZenMode();
              new gl.GLForm($('.wiki-form'));
              break;
            case 'snippets':
              shortcut_handler = new ShortcutsNavigation();
              if (path[2] === 'show') {
                new ZenMode();
              }
              break;
            case 'labels':
            case 'graphs':
            case 'compare':
            case 'pipelines':
            case 'forks':
            case 'milestones':
            case 'project_members':
            case 'deploy_keys':
            case 'builds':
            case 'hooks':
            case 'services':
            case 'protected_branches':
              shortcut_handler = new ShortcutsNavigation();
          }
      }
      // If we haven't installed a custom shortcut handler, install the default one
      if (!shortcut_handler) {
        new Shortcuts();
      }
    };

    Dispatcher.prototype.initSearch = function () {
      // Only when search form is present
      if ($('.search').length) {
        return new gl.SearchAutocomplete();
      }
    };

    Dispatcher.prototype.initFieldErrors = function () {
      $('.gl-show-field-errors').each(function (i, form) {
        new gl.GlFieldErrors(form);
      });
    };

    return Dispatcher;
  }();
}).call(window);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("lwLq")))

/***/ }),

/***/ "MgdX":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/*!

Copyright (C) 2014-2016 by Andrea Giammarchi - @WebReflection

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

*/
// global window Object
// optional polyfill info
//    'auto' used by default, everything is feature detected
//    'force' use the polyfill even if not fully needed
function installCustomElements(window, polyfill) {'use strict';

  // DO NOT USE THIS FILE DIRECTLY, IT WON'T WORK
  // THIS IS A PROJECT BASED ON A BUILD SYSTEM
  // THIS FILE IS JUST WRAPPED UP RESULTING IN
  // build/document-register-element.node.js

  var
    document = window.document,
    Object = window.Object
  ;

  var htmlClass = (function (info) {
    // (C) Andrea Giammarchi - @WebReflection - MIT Style
    var
      catchClass = /^[A-Z]+[a-z]/,
      filterBy = function (re) {
        var arr = [], tag;
        for (tag in register) {
          if (re.test(tag)) arr.push(tag);
        }
        return arr;
      },
      add = function (Class, tag) {
        tag = tag.toLowerCase();
        if (!(tag in register)) {
          register[Class] = (register[Class] || []).concat(tag);
          register[tag] = (register[tag.toUpperCase()] = Class);
        }
      },
      register = (Object.create || Object)(null),
      htmlClass = {},
      i, section, tags, Class
    ;
    for (section in info) {
      for (Class in info[section]) {
        tags = info[section][Class];
        register[Class] = tags;
        for (i = 0; i < tags.length; i++) {
          register[tags[i].toLowerCase()] =
          register[tags[i].toUpperCase()] = Class;
        }
      }
    }
    htmlClass.get = function get(tagOrClass) {
      return typeof tagOrClass === 'string' ?
        (register[tagOrClass] || (catchClass.test(tagOrClass) ? [] : '')) :
        filterBy(tagOrClass);
    };
    htmlClass.set = function set(tag, Class) {
      return (catchClass.test(tag) ?
        add(tag, Class) :
        add(Class, tag)
      ), htmlClass;
    };
    return htmlClass;
  }({
    "collections": {
      "HTMLAllCollection": [
        "all"
      ],
      "HTMLCollection": [
        "forms"
      ],
      "HTMLFormControlsCollection": [
        "elements"
      ],
      "HTMLOptionsCollection": [
        "options"
      ]
    },
    "elements": {
      "Element": [
        "element"
      ],
      "HTMLAnchorElement": [
        "a"
      ],
      "HTMLAppletElement": [
        "applet"
      ],
      "HTMLAreaElement": [
        "area"
      ],
      "HTMLAttachmentElement": [
        "attachment"
      ],
      "HTMLAudioElement": [
        "audio"
      ],
      "HTMLBRElement": [
        "br"
      ],
      "HTMLBaseElement": [
        "base"
      ],
      "HTMLBodyElement": [
        "body"
      ],
      "HTMLButtonElement": [
        "button"
      ],
      "HTMLCanvasElement": [
        "canvas"
      ],
      "HTMLContentElement": [
        "content"
      ],
      "HTMLDListElement": [
        "dl"
      ],
      "HTMLDataElement": [
        "data"
      ],
      "HTMLDataListElement": [
        "datalist"
      ],
      "HTMLDetailsElement": [
        "details"
      ],
      "HTMLDialogElement": [
        "dialog"
      ],
      "HTMLDirectoryElement": [
        "dir"
      ],
      "HTMLDivElement": [
        "div"
      ],
      "HTMLDocument": [
        "document"
      ],
      "HTMLElement": [
        "element",
        "abbr",
        "address",
        "article",
        "aside",
        "b",
        "bdi",
        "bdo",
        "cite",
        "code",
        "command",
        "dd",
        "dfn",
        "dt",
        "em",
        "figcaption",
        "figure",
        "footer",
        "header",
        "i",
        "kbd",
        "mark",
        "nav",
        "noscript",
        "rp",
        "rt",
        "ruby",
        "s",
        "samp",
        "section",
        "small",
        "strong",
        "sub",
        "summary",
        "sup",
        "u",
        "var",
        "wbr"
      ],
      "HTMLEmbedElement": [
        "embed"
      ],
      "HTMLFieldSetElement": [
        "fieldset"
      ],
      "HTMLFontElement": [
        "font"
      ],
      "HTMLFormElement": [
        "form"
      ],
      "HTMLFrameElement": [
        "frame"
      ],
      "HTMLFrameSetElement": [
        "frameset"
      ],
      "HTMLHRElement": [
        "hr"
      ],
      "HTMLHeadElement": [
        "head"
      ],
      "HTMLHeadingElement": [
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6"
      ],
      "HTMLHtmlElement": [
        "html"
      ],
      "HTMLIFrameElement": [
        "iframe"
      ],
      "HTMLImageElement": [
        "img"
      ],
      "HTMLInputElement": [
        "input"
      ],
      "HTMLKeygenElement": [
        "keygen"
      ],
      "HTMLLIElement": [
        "li"
      ],
      "HTMLLabelElement": [
        "label"
      ],
      "HTMLLegendElement": [
        "legend"
      ],
      "HTMLLinkElement": [
        "link"
      ],
      "HTMLMapElement": [
        "map"
      ],
      "HTMLMarqueeElement": [
        "marquee"
      ],
      "HTMLMediaElement": [
        "media"
      ],
      "HTMLMenuElement": [
        "menu"
      ],
      "HTMLMenuItemElement": [
        "menuitem"
      ],
      "HTMLMetaElement": [
        "meta"
      ],
      "HTMLMeterElement": [
        "meter"
      ],
      "HTMLModElement": [
        "del",
        "ins"
      ],
      "HTMLOListElement": [
        "ol"
      ],
      "HTMLObjectElement": [
        "object"
      ],
      "HTMLOptGroupElement": [
        "optgroup"
      ],
      "HTMLOptionElement": [
        "option"
      ],
      "HTMLOutputElement": [
        "output"
      ],
      "HTMLParagraphElement": [
        "p"
      ],
      "HTMLParamElement": [
        "param"
      ],
      "HTMLPictureElement": [
        "picture"
      ],
      "HTMLPreElement": [
        "pre"
      ],
      "HTMLProgressElement": [
        "progress"
      ],
      "HTMLQuoteElement": [
        "blockquote",
        "q",
        "quote"
      ],
      "HTMLScriptElement": [
        "script"
      ],
      "HTMLSelectElement": [
        "select"
      ],
      "HTMLShadowElement": [
        "shadow"
      ],
      "HTMLSlotElement": [
        "slot"
      ],
      "HTMLSourceElement": [
        "source"
      ],
      "HTMLSpanElement": [
        "span"
      ],
      "HTMLStyleElement": [
        "style"
      ],
      "HTMLTableCaptionElement": [
        "caption"
      ],
      "HTMLTableCellElement": [
        "td",
        "th"
      ],
      "HTMLTableColElement": [
        "col",
        "colgroup"
      ],
      "HTMLTableElement": [
        "table"
      ],
      "HTMLTableRowElement": [
        "tr"
      ],
      "HTMLTableSectionElement": [
        "thead",
        "tbody",
        "tfoot"
      ],
      "HTMLTemplateElement": [
        "template"
      ],
      "HTMLTextAreaElement": [
        "textarea"
      ],
      "HTMLTimeElement": [
        "time"
      ],
      "HTMLTitleElement": [
        "title"
      ],
      "HTMLTrackElement": [
        "track"
      ],
      "HTMLUListElement": [
        "ul"
      ],
      "HTMLUnknownElement": [
        "unknown",
        "vhgroupv",
        "vkeygen"
      ],
      "HTMLVideoElement": [
        "video"
      ]
    },
    "nodes": {
      "Attr": [
        "node"
      ],
      "Audio": [
        "audio"
      ],
      "CDATASection": [
        "node"
      ],
      "CharacterData": [
        "node"
      ],
      "Comment": [
        "#comment"
      ],
      "Document": [
        "#document"
      ],
      "DocumentFragment": [
        "#document-fragment"
      ],
      "DocumentType": [
        "node"
      ],
      "HTMLDocument": [
        "#document"
      ],
      "Image": [
        "img"
      ],
      "Option": [
        "option"
      ],
      "ProcessingInstruction": [
        "node"
      ],
      "ShadowRoot": [
        "#shadow-root"
      ],
      "Text": [
        "#text"
      ],
      "XMLDocument": [
        "xml"
      ]
    }
  }));
  
  
    
  // passed at runtime, configurable
  // via nodejs module
  if (!polyfill) polyfill = 'auto';
  
  var
    // V0 polyfill entry
    REGISTER_ELEMENT = 'registerElement',
  
    // IE < 11 only + old WebKit for attributes + feature detection
    EXPANDO_UID = '__' + REGISTER_ELEMENT + (window.Math.random() * 10e4 >> 0),
  
    // shortcuts and costants
    ADD_EVENT_LISTENER = 'addEventListener',
    ATTACHED = 'attached',
    CALLBACK = 'Callback',
    DETACHED = 'detached',
    EXTENDS = 'extends',
  
    ATTRIBUTE_CHANGED_CALLBACK = 'attributeChanged' + CALLBACK,
    ATTACHED_CALLBACK = ATTACHED + CALLBACK,
    CONNECTED_CALLBACK = 'connected' + CALLBACK,
    DISCONNECTED_CALLBACK = 'disconnected' + CALLBACK,
    CREATED_CALLBACK = 'created' + CALLBACK,
    DETACHED_CALLBACK = DETACHED + CALLBACK,
  
    ADDITION = 'ADDITION',
    MODIFICATION = 'MODIFICATION',
    REMOVAL = 'REMOVAL',
  
    DOM_ATTR_MODIFIED = 'DOMAttrModified',
    DOM_CONTENT_LOADED = 'DOMContentLoaded',
    DOM_SUBTREE_MODIFIED = 'DOMSubtreeModified',
  
    PREFIX_TAG = '<',
    PREFIX_IS = '=',
  
    // valid and invalid node names
    validName = /^[A-Z][A-Z0-9]*(?:-[A-Z0-9]+)+$/,
    invalidNames = [
      'ANNOTATION-XML',
      'COLOR-PROFILE',
      'FONT-FACE',
      'FONT-FACE-SRC',
      'FONT-FACE-URI',
      'FONT-FACE-FORMAT',
      'FONT-FACE-NAME',
      'MISSING-GLYPH'
    ],
  
    // registered types and their prototypes
    types = [],
    protos = [],
  
    // to query subnodes
    query = '',
  
    // html shortcut used to feature detect
    documentElement = document.documentElement,
  
    // ES5 inline helpers || basic patches
    indexOf = types.indexOf || function (v) {
      for(var i = this.length; i-- && this[i] !== v;){}
      return i;
    },
  
    // other helpers / shortcuts
    OP = Object.prototype,
    hOP = OP.hasOwnProperty,
    iPO = OP.isPrototypeOf,
  
    defineProperty = Object.defineProperty,
    empty = [],
    gOPD = Object.getOwnPropertyDescriptor,
    gOPN = Object.getOwnPropertyNames,
    gPO = Object.getPrototypeOf,
    sPO = Object.setPrototypeOf,
  
    // jshint proto: true
    hasProto = !!Object.__proto__,
  
    // V1 helpers
    fixGetClass = false,
    DRECEV1 = '__dreCEv1',
    customElements = window.customElements,
    usableCustomElements = polyfill !== 'force' && !!(
      customElements &&
      customElements.define &&
      customElements.get &&
      customElements.whenDefined
    ),
    Dict = Object.create || Object,
    Map = window.Map || function Map() {
      var K = [], V = [], i;
      return {
        get: function (k) {
          return V[indexOf.call(K, k)];
        },
        set: function (k, v) {
          i = indexOf.call(K, k);
          if (i < 0) V[K.push(k) - 1] = v;
          else V[i] = v;
        }
      };
    },
    Promise = window.Promise || function (fn) {
      var
        notify = [],
        done = false,
        p = {
          'catch': function () {
            return p;
          },
          'then': function (cb) {
            notify.push(cb);
            if (done) setTimeout(resolve, 1);
            return p;
          }
        }
      ;
      function resolve(value) {
        done = true;
        while (notify.length) notify.shift()(value);
      }
      fn(resolve);
      return p;
    },
    justCreated = false,
    constructors = Dict(null),
    waitingList = Dict(null),
    nodeNames = new Map(),
    secondArgument = String,
  
    // used to create unique instances
    create = Object.create || function Bridge(proto) {
      // silly broken polyfill probably ever used but short enough to work
      return proto ? ((Bridge.prototype = proto), new Bridge()) : this;
    },
  
    // will set the prototype if possible
    // or copy over all properties
    setPrototype = sPO || (
      hasProto ?
        function (o, p) {
          o.__proto__ = p;
          return o;
        } : (
      (gOPN && gOPD) ?
        (function(){
          function setProperties(o, p) {
            for (var
              key,
              names = gOPN(p),
              i = 0, length = names.length;
              i < length; i++
            ) {
              key = names[i];
              if (!hOP.call(o, key)) {
                defineProperty(o, key, gOPD(p, key));
              }
            }
          }
          return function (o, p) {
            do {
              setProperties(o, p);
            } while ((p = gPO(p)) && !iPO.call(p, o));
            return o;
          };
        }()) :
        function (o, p) {
          for (var key in p) {
            o[key] = p[key];
          }
          return o;
        }
    )),
  
    // DOM shortcuts and helpers, if any
  
    MutationObserver = window.MutationObserver ||
                       window.WebKitMutationObserver,
  
    HTMLElementPrototype = (
      window.HTMLElement ||
      window.Element ||
      window.Node
    ).prototype,
  
    IE8 = !iPO.call(HTMLElementPrototype, documentElement),
  
    safeProperty = IE8 ? function (o, k, d) {
      o[k] = d.value;
      return o;
    } : defineProperty,
  
    isValidNode = IE8 ?
      function (node) {
        return node.nodeType === 1;
      } :
      function (node) {
        return iPO.call(HTMLElementPrototype, node);
      },
  
    targets = IE8 && [],
  
    attachShadow = HTMLElementPrototype.attachShadow,
    cloneNode = HTMLElementPrototype.cloneNode,
    dispatchEvent = HTMLElementPrototype.dispatchEvent,
    getAttribute = HTMLElementPrototype.getAttribute,
    hasAttribute = HTMLElementPrototype.hasAttribute,
    removeAttribute = HTMLElementPrototype.removeAttribute,
    setAttribute = HTMLElementPrototype.setAttribute,
  
    // replaced later on
    createElement = document.createElement,
    patchedCreateElement = createElement,
  
    // shared observer for all attributes
    attributesObserver = MutationObserver && {
      attributes: true,
      characterData: true,
      attributeOldValue: true
    },
  
    // useful to detect only if there's no MutationObserver
    DOMAttrModified = MutationObserver || function(e) {
      doesNotSupportDOMAttrModified = false;
      documentElement.removeEventListener(
        DOM_ATTR_MODIFIED,
        DOMAttrModified
      );
    },
  
    // will both be used to make DOMNodeInserted asynchronous
    asapQueue,
    asapTimer = 0,
  
    // internal flags
    setListener = false,
    doesNotSupportDOMAttrModified = true,
    dropDomContentLoaded = true,
  
    // needed for the innerHTML helper
    notFromInnerHTMLHelper = true,
  
    // optionally defined later on
    onSubtreeModified,
    callDOMAttrModified,
    getAttributesMirror,
    observer,
    observe,
  
    // based on setting prototype capability
    // will check proto or the expando attribute
    // in order to setup the node once
    patchIfNotAlready,
    patch
  ;
  
  // only if needed
  if (!(REGISTER_ELEMENT in document)) {
  
    if (sPO || hasProto) {
        patchIfNotAlready = function (node, proto) {
          if (!iPO.call(proto, node)) {
            setupNode(node, proto);
          }
        };
        patch = setupNode;
    } else {
        patchIfNotAlready = function (node, proto) {
          if (!node[EXPANDO_UID]) {
            node[EXPANDO_UID] = Object(true);
            setupNode(node, proto);
          }
        };
        patch = patchIfNotAlready;
    }
  
    if (IE8) {
      doesNotSupportDOMAttrModified = false;
      (function (){
        var
          descriptor = gOPD(HTMLElementPrototype, ADD_EVENT_LISTENER),
          addEventListener = descriptor.value,
          patchedRemoveAttribute = function (name) {
            var e = new CustomEvent(DOM_ATTR_MODIFIED, {bubbles: true});
            e.attrName = name;
            e.prevValue = getAttribute.call(this, name);
            e.newValue = null;
            e[REMOVAL] = e.attrChange = 2;
            removeAttribute.call(this, name);
            dispatchEvent.call(this, e);
          },
          patchedSetAttribute = function (name, value) {
            var
              had = hasAttribute.call(this, name),
              old = had && getAttribute.call(this, name),
              e = new CustomEvent(DOM_ATTR_MODIFIED, {bubbles: true})
            ;
            setAttribute.call(this, name, value);
            e.attrName = name;
            e.prevValue = had ? old : null;
            e.newValue = value;
            if (had) {
              e[MODIFICATION] = e.attrChange = 1;
            } else {
              e[ADDITION] = e.attrChange = 0;
            }
            dispatchEvent.call(this, e);
          },
          onPropertyChange = function (e) {
            // jshint eqnull:true
            var
              node = e.currentTarget,
              superSecret = node[EXPANDO_UID],
              propertyName = e.propertyName,
              event
            ;
            if (superSecret.hasOwnProperty(propertyName)) {
              superSecret = superSecret[propertyName];
              event = new CustomEvent(DOM_ATTR_MODIFIED, {bubbles: true});
              event.attrName = superSecret.name;
              event.prevValue = superSecret.value || null;
              event.newValue = (superSecret.value = node[propertyName] || null);
              if (event.prevValue == null) {
                event[ADDITION] = event.attrChange = 0;
              } else {
                event[MODIFICATION] = event.attrChange = 1;
              }
              dispatchEvent.call(node, event);
            }
          }
        ;
        descriptor.value = function (type, handler, capture) {
          if (
            type === DOM_ATTR_MODIFIED &&
            this[ATTRIBUTE_CHANGED_CALLBACK] &&
            this.setAttribute !== patchedSetAttribute
          ) {
            this[EXPANDO_UID] = {
              className: {
                name: 'class',
                value: this.className
              }
            };
            this.setAttribute = patchedSetAttribute;
            this.removeAttribute = patchedRemoveAttribute;
            addEventListener.call(this, 'propertychange', onPropertyChange);
          }
          addEventListener.call(this, type, handler, capture);
        };
        defineProperty(HTMLElementPrototype, ADD_EVENT_LISTENER, descriptor);
      }());
    } else if (!MutationObserver) {
      documentElement[ADD_EVENT_LISTENER](DOM_ATTR_MODIFIED, DOMAttrModified);
      documentElement.setAttribute(EXPANDO_UID, 1);
      documentElement.removeAttribute(EXPANDO_UID);
      if (doesNotSupportDOMAttrModified) {
        onSubtreeModified = function (e) {
          var
            node = this,
            oldAttributes,
            newAttributes,
            key
          ;
          if (node === e.target) {
            oldAttributes = node[EXPANDO_UID];
            node[EXPANDO_UID] = (newAttributes = getAttributesMirror(node));
            for (key in newAttributes) {
              if (!(key in oldAttributes)) {
                // attribute was added
                return callDOMAttrModified(
                  0,
                  node,
                  key,
                  oldAttributes[key],
                  newAttributes[key],
                  ADDITION
                );
              } else if (newAttributes[key] !== oldAttributes[key]) {
                // attribute was changed
                return callDOMAttrModified(
                  1,
                  node,
                  key,
                  oldAttributes[key],
                  newAttributes[key],
                  MODIFICATION
                );
              }
            }
            // checking if it has been removed
            for (key in oldAttributes) {
              if (!(key in newAttributes)) {
                // attribute removed
                return callDOMAttrModified(
                  2,
                  node,
                  key,
                  oldAttributes[key],
                  newAttributes[key],
                  REMOVAL
                );
              }
            }
          }
        };
        callDOMAttrModified = function (
          attrChange,
          currentTarget,
          attrName,
          prevValue,
          newValue,
          action
        ) {
          var e = {
            attrChange: attrChange,
            currentTarget: currentTarget,
            attrName: attrName,
            prevValue: prevValue,
            newValue: newValue
          };
          e[action] = attrChange;
          onDOMAttrModified(e);
        };
        getAttributesMirror = function (node) {
          for (var
            attr, name,
            result = {},
            attributes = node.attributes,
            i = 0, length = attributes.length;
            i < length; i++
          ) {
            attr = attributes[i];
            name = attr.name;
            if (name !== 'setAttribute') {
              result[name] = attr.value;
            }
          }
          return result;
        };
      }
    }
  
    // set as enumerable, writable and configurable
    document[REGISTER_ELEMENT] = function registerElement(type, options) {
      upperType = type.toUpperCase();
      if (!setListener) {
        // only first time document.registerElement is used
        // we need to set this listener
        // setting it by default might slow down for no reason
        setListener = true;
        if (MutationObserver) {
          observer = (function(attached, detached){
            function checkEmAll(list, callback) {
              for (var i = 0, length = list.length; i < length; callback(list[i++])){}
            }
            return new MutationObserver(function (records) {
              for (var
                current, node, newValue,
                i = 0, length = records.length; i < length; i++
              ) {
                current = records[i];
                if (current.type === 'childList') {
                  checkEmAll(current.addedNodes, attached);
                  checkEmAll(current.removedNodes, detached);
                } else {
                  node = current.target;
                  if (notFromInnerHTMLHelper &&
                      node[ATTRIBUTE_CHANGED_CALLBACK] &&
                      current.attributeName !== 'style') {
                    newValue = getAttribute.call(node, current.attributeName);
                    if (newValue !== current.oldValue) {
                      node[ATTRIBUTE_CHANGED_CALLBACK](
                        current.attributeName,
                        current.oldValue,
                        newValue
                      );
                    }
                  }
                }
              }
            });
          }(executeAction(ATTACHED), executeAction(DETACHED)));
          observe = function (node) {
            observer.observe(
              node,
              {
                childList: true,
                subtree: true
              }
            );
            return node;
          };
          observe(document);
          if (attachShadow) {
            HTMLElementPrototype.attachShadow = function () {
              return observe(attachShadow.apply(this, arguments));
            };
          }
        } else {
          asapQueue = [];
          document[ADD_EVENT_LISTENER]('DOMNodeInserted', onDOMNode(ATTACHED));
          document[ADD_EVENT_LISTENER]('DOMNodeRemoved', onDOMNode(DETACHED));
        }
  
        document[ADD_EVENT_LISTENER](DOM_CONTENT_LOADED, onReadyStateChange);
        document[ADD_EVENT_LISTENER]('readystatechange', onReadyStateChange);
  
        HTMLElementPrototype.cloneNode = function (deep) {
          var
            node = cloneNode.call(this, !!deep),
            i = getTypeIndex(node)
          ;
          if (-1 < i) patch(node, protos[i]);
          if (deep) loopAndSetup(node.querySelectorAll(query));
          return node;
        };
      }
  
      if (-2 < (
        indexOf.call(types, PREFIX_IS + upperType) +
        indexOf.call(types, PREFIX_TAG + upperType)
      )) {
        throwTypeError(type);
      }
  
      if (!validName.test(upperType) || -1 < indexOf.call(invalidNames, upperType)) {
        throw new Error('The type ' + type + ' is invalid');
      }
  
      var
        constructor = function () {
          return extending ?
            document.createElement(nodeName, upperType) :
            document.createElement(nodeName);
        },
        opt = options || OP,
        extending = hOP.call(opt, EXTENDS),
        nodeName = extending ? options[EXTENDS].toUpperCase() : upperType,
        upperType,
        i
      ;
  
      if (extending && -1 < (
        indexOf.call(types, PREFIX_TAG + nodeName)
      )) {
        throwTypeError(nodeName);
      }
  
      i = types.push((extending ? PREFIX_IS : PREFIX_TAG) + upperType) - 1;
  
      query = query.concat(
        query.length ? ',' : '',
        extending ? nodeName + '[is="' + type.toLowerCase() + '"]' : nodeName
      );
  
      constructor.prototype = (
        protos[i] = hOP.call(opt, 'prototype') ?
          opt.prototype :
          create(HTMLElementPrototype)
      );
  
      loopAndVerify(
        document.querySelectorAll(query),
        ATTACHED
      );
  
      return constructor;
    };
  
    document.createElement = (patchedCreateElement = function (localName, typeExtension) {
      var
        is = getIs(typeExtension),
        node = is ?
          createElement.call(document, localName, secondArgument(is)) :
          createElement.call(document, localName),
        name = '' + localName,
        i = indexOf.call(
          types,
          (is ? PREFIX_IS : PREFIX_TAG) +
          (is || name).toUpperCase()
        ),
        setup = -1 < i
      ;
      if (is) {
        node.setAttribute('is', is = is.toLowerCase());
        if (setup) {
          setup = isInQSA(name.toUpperCase(), is);
        }
      }
      notFromInnerHTMLHelper = !document.createElement.innerHTMLHelper;
      if (setup) patch(node, protos[i]);
      return node;
    });
  
  }
  
  function ASAP() {
    var queue = asapQueue.splice(0, asapQueue.length);
    asapTimer = 0;
    while (queue.length) {
      queue.shift().call(
        null, queue.shift()
      );
    }
  }
  
  function loopAndVerify(list, action) {
    for (var i = 0, length = list.length; i < length; i++) {
      verifyAndSetupAndAction(list[i], action);
    }
  }
  
  function loopAndSetup(list) {
    for (var i = 0, length = list.length, node; i < length; i++) {
      node = list[i];
      patch(node, protos[getTypeIndex(node)]);
    }
  }
  
  function executeAction(action) {
    return function (node) {
      if (isValidNode(node)) {
        verifyAndSetupAndAction(node, action);
        loopAndVerify(
          node.querySelectorAll(query),
          action
        );
      }
    };
  }
  
  function getTypeIndex(target) {
    var
      is = getAttribute.call(target, 'is'),
      nodeName = target.nodeName.toUpperCase(),
      i = indexOf.call(
        types,
        is ?
            PREFIX_IS + is.toUpperCase() :
            PREFIX_TAG + nodeName
      )
    ;
    return is && -1 < i && !isInQSA(nodeName, is) ? -1 : i;
  }
  
  function isInQSA(name, type) {
    return -1 < query.indexOf(name + '[is="' + type + '"]');
  }
  
  function onDOMAttrModified(e) {
    var
      node = e.currentTarget,
      attrChange = e.attrChange,
      attrName = e.attrName,
      target = e.target,
      addition = e[ADDITION] || 2,
      removal = e[REMOVAL] || 3
    ;
    if (notFromInnerHTMLHelper &&
        (!target || target === node) &&
        node[ATTRIBUTE_CHANGED_CALLBACK] &&
        attrName !== 'style' && (
          e.prevValue !== e.newValue ||
          // IE9, IE10, and Opera 12 gotcha
          e.newValue === '' && (
            attrChange === addition ||
            attrChange === removal
          )
    )) {
      node[ATTRIBUTE_CHANGED_CALLBACK](
        attrName,
        attrChange === addition ? null : e.prevValue,
        attrChange === removal ? null : e.newValue
      );
    }
  }
  
  function onDOMNode(action) {
    var executor = executeAction(action);
    return function (e) {
      asapQueue.push(executor, e.target);
      if (asapTimer) clearTimeout(asapTimer);
      asapTimer = setTimeout(ASAP, 1);
    };
  }
  
  function onReadyStateChange(e) {
    if (dropDomContentLoaded) {
      dropDomContentLoaded = false;
      e.currentTarget.removeEventListener(DOM_CONTENT_LOADED, onReadyStateChange);
    }
    loopAndVerify(
      (e.target || document).querySelectorAll(query),
      e.detail === DETACHED ? DETACHED : ATTACHED
    );
    if (IE8) purge();
  }
  
  function patchedSetAttribute(name, value) {
    // jshint validthis:true
    var self = this;
    setAttribute.call(self, name, value);
    onSubtreeModified.call(self, {target: self});
  }
  
  function setupNode(node, proto) {
    setPrototype(node, proto);
    if (observer) {
      observer.observe(node, attributesObserver);
    } else {
      if (doesNotSupportDOMAttrModified) {
        node.setAttribute = patchedSetAttribute;
        node[EXPANDO_UID] = getAttributesMirror(node);
        node[ADD_EVENT_LISTENER](DOM_SUBTREE_MODIFIED, onSubtreeModified);
      }
      node[ADD_EVENT_LISTENER](DOM_ATTR_MODIFIED, onDOMAttrModified);
    }
    if (node[CREATED_CALLBACK] && notFromInnerHTMLHelper) {
      node.created = true;
      node[CREATED_CALLBACK]();
      node.created = false;
    }
  }
  
  function purge() {
    for (var
      node,
      i = 0,
      length = targets.length;
      i < length; i++
    ) {
      node = targets[i];
      if (!documentElement.contains(node)) {
        length--;
        targets.splice(i--, 1);
        verifyAndSetupAndAction(node, DETACHED);
      }
    }
  }
  
  function throwTypeError(type) {
    throw new Error('A ' + type + ' type is already registered');
  }
  
  function verifyAndSetupAndAction(node, action) {
    var
      fn,
      i = getTypeIndex(node)
    ;
    if (-1 < i) {
      patchIfNotAlready(node, protos[i]);
      i = 0;
      if (action === ATTACHED && !node[ATTACHED]) {
        node[DETACHED] = false;
        node[ATTACHED] = true;
        i = 1;
        if (IE8 && indexOf.call(targets, node) < 0) {
          targets.push(node);
        }
      } else if (action === DETACHED && !node[DETACHED]) {
        node[ATTACHED] = false;
        node[DETACHED] = true;
        i = 1;
      }
      if (i && (fn = node[action + CALLBACK])) fn.call(node);
    }
  }
  
  
  
  // V1 in da House!
  function CustomElementRegistry() {}
  
  CustomElementRegistry.prototype = {
    constructor: CustomElementRegistry,
    // a workaround for the stubborn WebKit
    define: usableCustomElements ?
      function (name, Class, options) {
        if (options) {
          CERDefine(name, Class, options);
        } else {
          var NAME = name.toUpperCase();
          constructors[NAME] = {
            constructor: Class,
            create: [NAME]
          };
          nodeNames.set(Class, NAME);
          customElements.define(name, Class);
        }
      } :
      CERDefine,
    get: usableCustomElements ?
      function (name) {
        return customElements.get(name) || get(name);
      } :
      get,
    whenDefined: usableCustomElements ?
      function (name) {
        return Promise.race([
          customElements.whenDefined(name),
          whenDefined(name)
        ]);
      } :
      whenDefined
  };
  
  function CERDefine(name, Class, options) {
    var
      is = options && options[EXTENDS] || '',
      CProto = Class.prototype,
      proto = create(CProto),
      attributes = Class.observedAttributes || empty,
      definition = {prototype: proto}
    ;
    // TODO: is this needed at all since it's inherited?
    // defineProperty(proto, 'constructor', {value: Class});
    safeProperty(proto, CREATED_CALLBACK, {
        value: function () {
          if (justCreated) justCreated = false;
          else if (!this[DRECEV1]) {
            this[DRECEV1] = true;
            new Class(this);
            if (CProto[CREATED_CALLBACK])
              CProto[CREATED_CALLBACK].call(this);
            var info = constructors[nodeNames.get(Class)];
            if (!usableCustomElements || info.create.length > 1) {
              notifyAttributes(this);
            }
          }
      }
    });
    safeProperty(proto, ATTRIBUTE_CHANGED_CALLBACK, {
      value: function (name) {
        if (-1 < indexOf.call(attributes, name))
          CProto[ATTRIBUTE_CHANGED_CALLBACK].apply(this, arguments);
      }
    });
    if (CProto[CONNECTED_CALLBACK]) {
      safeProperty(proto, ATTACHED_CALLBACK, {
        value: CProto[CONNECTED_CALLBACK]
      });
    }
    if (CProto[DISCONNECTED_CALLBACK]) {
      safeProperty(proto, DETACHED_CALLBACK, {
        value: CProto[DISCONNECTED_CALLBACK]
      });
    }
    if (is) definition[EXTENDS] = is;
    name = name.toUpperCase();
    constructors[name] = {
      constructor: Class,
      create: is ? [is, secondArgument(name)] : [name]
    };
    nodeNames.set(Class, name);
    document[REGISTER_ELEMENT](name.toLowerCase(), definition);
    whenDefined(name);
    waitingList[name].r();
  }
  
  function get(name) {
    var info = constructors[name.toUpperCase()];
    return info && info.constructor;
  }
  
  function getIs(options) {
    return typeof options === 'string' ?
        options : (options && options.is || '');
  }
  
  function notifyAttributes(self) {
    var
      callback = self[ATTRIBUTE_CHANGED_CALLBACK],
      attributes = callback ? self.attributes : empty,
      i = attributes.length,
      attribute
    ;
    while (i--) {
      attribute =  attributes[i]; // || attributes.item(i);
      callback.call(
        self,
        attribute.name || attribute.nodeName,
        null,
        attribute.value || attribute.nodeValue
      );
    }
  }
  
  function whenDefined(name) {
    name = name.toUpperCase();
    if (!(name in waitingList)) {
      waitingList[name] = {};
      waitingList[name].p = new Promise(function (resolve) {
        waitingList[name].r = resolve;
      });
    }
    return waitingList[name].p;
  }
  
  function polyfillV1() {
    if (customElements) delete window.customElements;
    defineProperty(window, 'customElements', {
      configurable: true,
      value: new CustomElementRegistry()
    });
    defineProperty(window, 'CustomElementRegistry', {
      configurable: true,
      value: CustomElementRegistry
    });
    for (var
      patchClass = function (name) {
        var Class = window[name];
        if (Class) {
          window[name] = function CustomElementsV1(self) {
            var info, isNative;
            if (!self) self = this;
            if (!self[DRECEV1]) {
              justCreated = true;
              info = constructors[nodeNames.get(self.constructor)];
              isNative = usableCustomElements && info.create.length === 1;
              self = isNative ?
                Reflect.construct(Class, empty, info.constructor) :
                document.createElement.apply(document, info.create);
              self[DRECEV1] = true;
              justCreated = false;
              if (!isNative) notifyAttributes(self);
            }
            return self;
          };
          window[name].prototype = Class.prototype;
          try {
            Class.prototype.constructor = window[name];
          } catch(WebKit) {
            fixGetClass = true;
            defineProperty(Class, DRECEV1, {value: window[name]});
          }
        }
      },
      Classes = htmlClass.get(/^HTML[A-Z]*[a-z]/),
      i = Classes.length;
      i--;
      patchClass(Classes[i])
    ) {}
    (document.createElement = function (name, options) {
      var is = getIs(options);
      return is ?
        patchedCreateElement.call(this, name, secondArgument(is)) :
        patchedCreateElement.call(this, name);
    });
  }
  
  // if customElements is not there at all
  if (!customElements || polyfill === 'force') polyfillV1();
  else {
    // if available test extends work as expected
    try {
      (function (DRE, options, name) {
        options[EXTENDS] = 'a';
        DRE.prototype = create(HTMLAnchorElement.prototype);
        DRE.prototype.constructor = DRE;
        window.customElements.define(name, DRE, options);
        if (
          getAttribute.call(document.createElement('a', {is: name}), 'is') !== name ||
          (usableCustomElements && getAttribute.call(new DRE(), 'is') !== name)
        ) {
          throw options;
        }
      }(
        function DRE() {
          return Reflect.construct(HTMLAnchorElement, [], DRE);
        },
        {},
        'document-register-element-a'
      ));
    } catch(o_O) {
      // or force the polyfill if not
      // and keep internal original reference
      polyfillV1();
    }
  }
  
  try {
    createElement.call(document, 'a', 'a');
  } catch(FireFox) {
    secondArgument = function (is) {
      return {is: is};
    };
  }
  
}

module.exports = installCustomElements;
installCustomElements(global);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("Pkug")))

/***/ }),

/***/ "MoEV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("2ub6");
/* eslint-disable */



var utils = {
  toCamelCase: function toCamelCase(attr) {
    return this.camelize(attr.split('-').slice(1).join(' '));
  },
  t: function t(s, d) {
    for (var p in d) {
      if (Object.prototype.hasOwnProperty.call(d, p)) {
        s = s.replace(new RegExp('{{' + p + '}}', 'g'), d[p]);
      }
    }
    return s;
  },
  camelize: function camelize(str) {
    return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (letter, index) {
      return index === 0 ? letter.toLowerCase() : letter.toUpperCase();
    }).replace(/\s+/g, '');
  },
  closest: function closest(thisTag, stopTag) {
    while (thisTag && thisTag.tagName !== stopTag && thisTag.tagName !== 'HTML') {
      thisTag = thisTag.parentNode;
    }
    return thisTag;
  },
  isDropDownParts: function isDropDownParts(target) {
    if (!target || target.tagName === 'HTML') return false;
    return target.hasAttribute(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* DATA_TRIGGER */]) || target.hasAttribute(__WEBPACK_IMPORTED_MODULE_0__constants__["e" /* DATA_DROPDOWN */]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (utils);

/***/ }),

/***/ "Mv3y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__("yoQO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable class-methods-use-this, comma-dangle, arrow-parens, no-param-reassign */



(function (global) {
  global.User = function () {
    function _class(_ref) {
      var action = _ref.action;

      _classCallCheck(this, _class);

      this.action = action;
      this.placeProfileAvatarsToTop();
      this.initTabs();
      this.hideProjectLimitMessage();
    }

    _createClass(_class, [{
      key: 'placeProfileAvatarsToTop',
      value: function placeProfileAvatarsToTop() {
        $('.profile-groups-avatars').tooltip({
          placement: 'top'
        });
      }
    }, {
      key: 'initTabs',
      value: function initTabs() {
        return new global.UserTabs({
          parentEl: '.user-profile',
          action: this.action
        });
      }
    }, {
      key: 'hideProjectLimitMessage',
      value: function hideProjectLimitMessage() {
        var _this = this;

        $('.hide-project-limit-message').on('click', function (e) {
          e.preventDefault();
          __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set('hide_project_limit_message', 'false');
          $(_this).parents('.project-limit-message').remove();
        });
      }
    }]);

    return _class;
  }();
})(window.gl || (window.gl = {}));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("lwLq")))

/***/ }),

/***/ "N9Tt":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable no-new, comma-dangle, class-methods-use-this, no-param-reassign */

(function (global) {
  var IssuableTemplateSelectors = function () {
    function IssuableTemplateSelectors() {
      var _this = this;

      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          $dropdowns = _ref.$dropdowns,
          editor = _ref.editor;

      _classCallCheck(this, IssuableTemplateSelectors);

      this.$dropdowns = $dropdowns || $('.js-issuable-selector');
      this.editor = editor || this.initEditor();

      this.$dropdowns.each(function (i, dropdown) {
        var $dropdown = $(dropdown);
        new gl.IssuableTemplateSelector({
          pattern: /(\.md)/,
          data: $dropdown.data('data'),
          wrapper: $dropdown.closest('.js-issuable-selector-wrap'),
          dropdown: $dropdown,
          editor: _this.editor
        });
      });
    }

    _createClass(IssuableTemplateSelectors, [{
      key: 'initEditor',
      value: function initEditor() {
        var editor = $('.markdown-area');
        // Proxy ace-editor's .setValue to jQuery's .val
        editor.setValue = editor.val;
        editor.getValue = editor.val;
        return editor;
      }
    }]);

    return IssuableTemplateSelectors;
  }();

  global.IssuableTemplateSelectors = IssuableTemplateSelectors;
})(window.gl || (window.gl = {}));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "OX5X":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  /*
  *   SubbableResource can be extended to provide a pubsub-style service for one-off REST
  *   calls. Subscribe by passing a callback or render method you will use to handle responses.
   *
  * */

  var SubbableResource = function () {
    function SubbableResource(resourcePath) {
      _classCallCheck(this, SubbableResource);

      this.endpoint = resourcePath;

      // TODO: Switch to axios.create
      this.resource = $.ajax;
      this.subscribers = [];
    }

    _createClass(SubbableResource, [{
      key: "subscribe",
      value: function subscribe(callback) {
        this.subscribers.push(callback);
      }
    }, {
      key: "publish",
      value: function publish(newResponse) {
        var responseCopy = _.extend({}, newResponse);
        this.subscribers.forEach(function (fn) {
          fn(responseCopy);
        });
        return newResponse;
      }
    }, {
      key: "get",
      value: function get(payload) {
        var _this = this;

        return this.resource(payload).then(function (data) {
          return _this.publish(data);
        });
      }
    }, {
      key: "post",
      value: function post(payload) {
        var _this2 = this;

        return this.resource(payload).then(function (data) {
          return _this2.publish(data);
        });
      }
    }, {
      key: "put",
      value: function put(payload) {
        var _this3 = this;

        return this.resource(payload).then(function (data) {
          return _this3.publish(data);
        });
      }
    }, {
      key: "delete",
      value: function _delete(payload) {
        var _this4 = this;

        return this.resource(payload).then(function (data) {
          return _this4.publish(data);
        });
      }
    }]);

    return SubbableResource;
  }();

  gl.SubbableResource = SubbableResource;
})(window.gl || (window.gl = {}));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "OwTH":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, prefer-arrow-callback, space-before-function-paren */

$(function () {
  $('.reveal-variables').off('click').on('click', function () {
    $('.js-build').toggle().niceScroll();
    $(this).hide();
  });
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "PN0v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable */

var InputSetter = {
  init: function init(hook) {
    this.hook = hook;
    this.destroyed = false;
    this.config = hook.config.InputSetter || (this.hook.config.InputSetter = {});

    this.eventWrapper = {};

    this.addEvents();
  },
  addEvents: function addEvents() {
    this.eventWrapper.setInputs = this.setInputs.bind(this);
    this.hook.list.list.addEventListener('click.dl', this.eventWrapper.setInputs);
  },
  removeEvents: function removeEvents() {
    this.hook.list.list.removeEventListener('click.dl', this.eventWrapper.setInputs);
  },
  setInputs: function setInputs(e) {
    var _this = this;

    if (this.destroyed) return;

    var selectedItem = e.detail.selected;

    if (!Array.isArray(this.config)) this.config = [this.config];

    this.config.forEach(function (config) {
      return _this.setInput(config, selectedItem);
    });
  },
  setInput: function setInput(config, selectedItem) {
    var input = config.input || this.hook.trigger;
    var newValue = selectedItem.getAttribute(config.valueAttribute);
    var inputAttribute = config.inputAttribute;

    if (input.hasAttribute(inputAttribute)) return input.setAttribute(inputAttribute, newValue);
    if (input.tagName === 'INPUT') return input.value = newValue;
    return input.textContent = newValue;
  },
  destroy: function destroy() {
    this.destroyed = true;

    this.removeEvents();
  }
};

/* harmony default export */ __webpack_exports__["a"] = (InputSetter);

/***/ }),

/***/ "PQIw":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, no-var, wrap-iife, one-var, camelcase, one-var-declaration-per-line, quotes, object-shorthand, prefer-arrow-callback, comma-dangle, consistent-return, yoda, prefer-rest-params, prefer-spread, no-unused-vars, prefer-template, max-len */
/* global Api */

var slice = [].slice;

window.GroupsSelect = function () {
  function GroupsSelect() {
    $('.ajax-groups-select').each(function (_this) {
      var self = _this;

      return function (i, select) {
        var all_available, skip_groups;
        var $select = $(select);
        all_available = $select.data('all-available');
        skip_groups = $select.data('skip-groups') || [];

        $select.select2({
          placeholder: "Search for a group",
          multiple: $select.hasClass('multiselect'),
          minimumInputLength: 0,
          ajax: {
            url: Api.buildUrl(Api.groupsPath),
            dataType: 'json',
            quietMillis: 250,
            transport: function transport(params) {
              $.ajax(params).then(function (data, status, xhr) {
                var results = data || [];

                var headers = gl.utils.normalizeCRLFHeaders(xhr.getAllResponseHeaders());
                var currentPage = parseInt(headers['X-PAGE'], 10) || 0;
                var totalPages = parseInt(headers['X-TOTAL-PAGES'], 10) || 0;
                var more = currentPage < totalPages;

                return {
                  results: results,
                  pagination: {
                    more: more
                  }
                };
              }).then(params.success).fail(params.error);
            },
            data: function data(search, page) {
              return {
                search: search,
                page: page,
                per_page: GroupsSelect.PER_PAGE,
                all_available: all_available
              };
            },
            results: function results(data, page) {
              if (data.length) return { results: [] };

              var groups = data.length ? data : data.results || [];
              var more = data.pagination ? data.pagination.more : false;
              var results = groups.filter(function (group) {
                return skip_groups.indexOf(group.id) === -1;
              });

              return {
                results: results,
                page: page,
                more: more
              };
            }
          },
          initSelection: function initSelection(element, callback) {
            var id;
            id = $(element).val();
            if (id !== "") {
              return Api.group(id, callback);
            }
          },
          formatResult: function formatResult() {
            var args;
            args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
            return self.formatResult.apply(self, args);
          },
          formatSelection: function formatSelection() {
            var args;
            args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
            return self.formatSelection.apply(self, args);
          },
          dropdownCssClass: "ajax-groups-dropdown select2-infinite",
          // we do not want to escape markup since we are displaying html in results
          escapeMarkup: function escapeMarkup(m) {
            return m;
          }
        });

        self.dropdown = document.querySelector('.select2-infinite .select2-results');

        $select.on('select2-loaded', self.forceOverflow.bind(self));
      };
    }(this));
  }

  GroupsSelect.prototype.formatResult = function (group) {
    var avatar;
    if (group.avatar_url) {
      avatar = group.avatar_url;
    } else {
      avatar = gon.default_avatar_url;
    }
    return "<div class='group-result'> <div class='group-name'>" + group.full_name + "</div> <div class='group-path'>" + group.full_path + "</div> </div>";
  };

  GroupsSelect.prototype.formatSelection = function (group) {
    return group.full_name;
  };

  GroupsSelect.prototype.forceOverflow = function (e) {
    var itemHeight = this.dropdown.querySelector('.select2-result:first-child').clientHeight;
    this.dropdown.style.height = Math.floor(this.dropdown.scrollHeight - itemHeight * 0.9) + 'px';
  };

  GroupsSelect.PER_PAGE = 20;

  return GroupsSelect;
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "Pkug":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "Pw5p":
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

window.gl = window.gl || {};

var CILintEditor = function CILintEditor() {
  var _this = this;

  _classCallCheck(this, CILintEditor);

  this.editor = window.ace.edit('ci-editor');
  this.textarea = document.querySelector('#content');

  this.editor.getSession().setMode('ace/mode/yaml');
  this.editor.on('input', function () {
    var content = _this.editor.getSession().getValue();
    _this.textarea.value = content;
  });
};

gl.CILintEditor = CILintEditor;

/***/ }),

/***/ "QJd+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__smart_interval__ = __webpack_require__("EQHa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__smart_interval___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__smart_interval__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mini_pipeline_graph_dropdown__ = __webpack_require__("6cNp");
/* eslint-disable max-len, no-var, func-names, space-before-function-paren, vars-on-top, comma-dangle, no-return-assign, consistent-return, no-param-reassign, one-var, one-var-declaration-per-line, quotes, prefer-template, no-else-return, prefer-arrow-callback, no-unused-vars, no-underscore-dangle, no-shadow, no-mixed-operators, camelcase, default-case, wrap-iife */
/* global notify */
/* global notifyPermissions */
/* global merge_request_widget */




(function (global) {
  var indexOf = [].indexOf || function (item) {
    for (var i = 0, l = this.length; i < l; i += 1) {
      if (i in this && this[i] === item) return i;
    }return -1;
  };

  var DEPLOYMENT_TEMPLATE = '<div class="mr-widget-heading" id="<%- id %>">\n       <div class="ci_widget ci-success">\n         <%= ci_success_icon %>\n         <span>\n           Deployed to\n           <a href="<%- url %>" target="_blank" rel="noopener noreferrer" class="environment">\n             <%- name %>\n           </a>\n           <span class="js-environment-timeago" data-toggle="tooltip" data-placement="top" data-title="<%- deployed_at_formatted %>">\n             <%- deployed_at %>\n           </span>\n           <a class="js-environment-link" href="<%- external_url %>" target="_blank" rel="noopener noreferrer">\n             <i class="fa fa-external-link"></i>\n             View on <%- external_url_formatted %>\n           </a>\n         </span>\n         <span class="stop-env-container js-stop-env-link">\n          <a href="<%- stop_url %>" class="close-evn-link" data-method="post" rel="nofollow" data-confirm="Are you sure you want to stop this environment?">\n            <i class="fa fa-stop-circle-o"/>\n            Stop environment\n          </a>\n         </span>\n       </div>\n     </div>';

  global.MergeRequestWidget = function () {
    function MergeRequestWidget(opts) {
      // Initialize MergeRequestWidget behavior
      //
      //   check_enable         - Boolean, whether to check automerge status
      //   merge_check_url      - String, URL to use to check automerge status
      //   ci_status_url        - String, URL to use to check CI status
      //   pipeline_status_url  - String, URL to use to get CI status for Favicon
      //
      this.opts = opts;
      this.opts.pipeline_status_url = this.opts.pipeline_status_url + '.json';
      this.$widgetBody = $('.mr-widget-body');
      $('#modal_merge_info').modal({
        show: false
      });
      this.clearEventListeners();
      this.addEventListeners();
      this.getCIStatus(false);
      this.retrieveSuccessIcon();

      this.initMiniPipelineGraph();

      this.ciStatusInterval = new global.SmartInterval({
        callback: this.getCIStatus.bind(this, true),
        startingInterval: 10000,
        maxInterval: 30000,
        hiddenInterval: 120000,
        incrementByFactorOf: 5000
      });
      this.ciEnvironmentStatusInterval = new global.SmartInterval({
        callback: this.getCIEnvironmentsStatus.bind(this),
        startingInterval: 30000,
        maxInterval: 120000,
        hiddenInterval: 240000,
        incrementByFactorOf: 15000,
        immediateExecution: true
      });

      notifyPermissions();
    }

    MergeRequestWidget.prototype.clearEventListeners = function () {
      return $(document).off('DOMContentLoaded');
    };

    MergeRequestWidget.prototype.addEventListeners = function () {
      var allowedPages;
      allowedPages = ['show', 'commits', 'pipelines', 'changes'];
      $(document).on('DOMContentLoaded', function (_this) {
        return function () {
          var page;
          page = $('body').data('page').split(':').last();
          if (allowedPages.indexOf(page) === -1) {
            return _this.clearEventListeners();
          }
        };
      }(this));
    };

    MergeRequestWidget.prototype.retrieveSuccessIcon = function () {
      var $ciSuccessIcon = $('.js-success-icon');
      this.$ciSuccessIcon = $ciSuccessIcon.html();
      $ciSuccessIcon.remove();
    };

    MergeRequestWidget.prototype.mergeInProgress = function (deleteSourceBranch) {
      if (deleteSourceBranch == null) {
        deleteSourceBranch = false;
      }
      return $.ajax({
        type: 'GET',
        url: $('.merge-request').data('url'),
        success: function (_this) {
          return function (data) {
            var callback, urlSuffix;
            if (data.state === "merged") {
              urlSuffix = deleteSourceBranch ? '?deleted_source_branch=true' : '';
              return window.location.href = window.location.pathname + urlSuffix;
            } else if (data.merge_error) {
              return $('.mr-widget-body').html("<h4>" + data.merge_error + "</h4>");
            } else {
              callback = function callback() {
                return merge_request_widget.mergeInProgress(deleteSourceBranch);
              };
              return setTimeout(callback, 2000);
            }
          };
        }(this),
        dataType: 'json'
      });
    };

    MergeRequestWidget.prototype.cancelPolling = function () {
      this.ciStatusInterval.cancel();
      this.ciEnvironmentStatusInterval.cancel();
    };

    MergeRequestWidget.prototype.getMergeStatus = function () {
      var _this2 = this;

      return $.get(this.opts.merge_check_url, function (data) {
        var $html = $(data);
        _this2.updateMergeButton(_this2.status, _this2.hasCi, $html);
        $('.mr-widget-body').replaceWith($html.find('.mr-widget-body'));
        $('.mr-widget-footer').replaceWith($html.find('.mr-widget-footer'));
      });
    };

    MergeRequestWidget.prototype.ciLabelForStatus = function (status) {
      switch (status) {
        case 'success':
          return 'passed';
        case 'success_with_warnings':
          return 'passed with warnings';
        default:
          return status;
      }
    };

    MergeRequestWidget.prototype.getCIStatus = function (showNotification) {
      var _this;
      _this = this;
      $('.ci-widget-fetching').show();
      return $.getJSON(this.opts.ci_status_url, function (_this) {
        return function (data) {
          var message, status, title, callback;
          _this.status = data.status;
          _this.hasCi = data.has_ci;
          _this.updateMergeButton(_this.status, _this.hasCi);
          gl.utils.setCiStatusFavicon(_this.opts.pipeline_status_url);
          if (data.environments && data.environments.length) _this.renderEnvironments(data.environments);
          if (data.status !== _this.opts.ci_status || data.sha !== _this.opts.ci_sha || data.pipeline !== _this.opts.ci_pipeline) {
            _this.opts.ci_status = data.status;
            _this.showCIStatus(data.status);
            if (data.coverage) {
              _this.showCICoverage(data.coverage);
            }
            if (data.pipeline) {
              _this.opts.ci_pipeline = data.pipeline;
              _this.updatePipelineUrls(data.pipeline);
            }
            if (data.sha) {
              _this.opts.ci_sha = data.sha;
              _this.updateCommitUrls(data.sha);
            }
            if (data.status === "success" || data.status === "failed") {
              callback = function callback() {
                return _this.getMergeStatus();
              };
              return setTimeout(callback, 2000);
            }
            if (showNotification && data.status) {
              status = _this.ciLabelForStatus(data.status);
              if (status === "preparing") {
                title = _this.opts.ci_title.preparing;
                status = status.charAt(0).toUpperCase() + status.slice(1);
                message = _this.opts.ci_message.preparing.replace('{{status}}', status);
              } else {
                title = _this.opts.ci_title.normal;
                message = _this.opts.ci_message.normal.replace('{{status}}', status);
              }
              title = title.replace('{{status}}', status);
              message = message.replace('{{sha}}', data.sha);
              message = message.replace('{{title}}', data.title);
              notify(title, message, _this.opts.gitlab_icon, function () {
                this.close();
              });
            }
          }
        };
      }(this));
    };

    MergeRequestWidget.prototype.getCIEnvironmentsStatus = function () {
      var _this3 = this;

      $.getJSON(this.opts.ci_environments_status_url, function (environments) {
        if (environments && environments.length) _this3.renderEnvironments(environments);
      });
    };

    MergeRequestWidget.prototype.renderEnvironments = function (environments) {
      for (var i = 0; i < environments.length; i += 1) {
        var environment = environments[i];
        if ($('.mr-state-widget #' + environment.id).length) return;
        var $template = $(DEPLOYMENT_TEMPLATE);
        if (!environment.external_url || !environment.external_url_formatted) $('.js-environment-link', $template).remove();

        if (!environment.stop_url) {
          $('.js-stop-env-link', $template).remove();
        }

        if (environment.deployed_at && environment.deployed_at_formatted) {
          environment.deployed_at = gl.utils.getTimeago().format(environment.deployed_at, 'gl_en') + '.';
        } else {
          $('.js-environment-timeago', $template).remove();
          environment.name += '.';
        }
        environment.ci_success_icon = this.$ciSuccessIcon;
        var templateString = _.unescape($template[0].outerHTML);
        var template = _.template(templateString)(environment);
        this.$widgetBody.before(template);
      }
    };

    MergeRequestWidget.prototype.showCIStatus = function (state) {
      var allowed_states;
      if (state == null) {
        return;
      }
      $('.ci_widget').hide();
      $('.ci_widget.ci-' + state).show();

      this.initMiniPipelineGraph();
    };

    MergeRequestWidget.prototype.showCICoverage = function (coverage) {
      var text = 'Coverage ' + coverage + '%';
      return $('.ci_widget:visible .ci-coverage').text(text);
    };

    MergeRequestWidget.prototype.updateMergeButton = function (state, hasCi, $html) {
      var allowed_states = ["failed", "canceled", "running", "pending", "success", "success_with_warnings", "skipped", "not_found"];
      var stateClass = 'btn-danger';
      if (!hasCi) {
        stateClass = 'btn-create';
      } else if (indexOf.call(allowed_states, state) !== -1) {
        switch (state) {
          case "failed":
          case "canceled":
          case "not_found":
            stateClass = 'btn-danger';
            break;
          case "running":
            stateClass = 'btn-info';
            break;
          case "success":
          case "success_with_warnings":
            stateClass = 'btn-create';
        }
      } else {
        $('.ci_widget.ci-error').show();
        stateClass = 'btn-danger';
      }

      this.setMergeButtonClass(stateClass, $html);
    };

    MergeRequestWidget.prototype.setMergeButtonClass = function (css_class) {
      var $html = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $('.mr-state-widget');

      return $html.find('.js-merge-button').removeClass('btn-danger btn-info btn-create').addClass(css_class);
    };

    MergeRequestWidget.prototype.updatePipelineUrls = function (id) {
      var pipelineUrl = this.opts.pipeline_path;
      $('.pipeline').text('#' + id).attr('href', [pipelineUrl, id].join('/'));
    };

    MergeRequestWidget.prototype.updateCommitUrls = function (id) {
      var commitsUrl = this.opts.commits_path;
      $('.js-commit-link').text('#' + id).attr('href', [commitsUrl, id].join('/'));
    };

    MergeRequestWidget.prototype.initMiniPipelineGraph = function () {
      new __WEBPACK_IMPORTED_MODULE_1__mini_pipeline_graph_dropdown__["a" /* default */]({
        container: '.js-pipeline-inline-mr-widget-graph:visible'
      }).bindEvents();
    };

    return MergeRequestWidget;
  }();
})(window.gl || (window.gl = {}));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("lwLq")))

/***/ }),

/***/ "Qepg":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery, module) {
/*
 *
 * More info at [www.dropzonejs.com](http://www.dropzonejs.com)
 *
 * Copyright (c) 2012, Matias Meno
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *
 */

(function() {
  var Dropzone, Emitter, camelize, contentLoaded, detectVerticalSquash, drawImageIOSFix, noop, without,
    __slice = [].slice,
    __hasProp = {}.hasOwnProperty,
    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

  noop = function() {};

  Emitter = (function() {
    function Emitter() {}

    Emitter.prototype.addEventListener = Emitter.prototype.on;

    Emitter.prototype.on = function(event, fn) {
      this._callbacks = this._callbacks || {};
      if (!this._callbacks[event]) {
        this._callbacks[event] = [];
      }
      this._callbacks[event].push(fn);
      return this;
    };

    Emitter.prototype.emit = function() {
      var args, callback, callbacks, event, _i, _len;
      event = arguments[0], args = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
      this._callbacks = this._callbacks || {};
      callbacks = this._callbacks[event];
      if (callbacks) {
        for (_i = 0, _len = callbacks.length; _i < _len; _i++) {
          callback = callbacks[_i];
          callback.apply(this, args);
        }
      }
      return this;
    };

    Emitter.prototype.removeListener = Emitter.prototype.off;

    Emitter.prototype.removeAllListeners = Emitter.prototype.off;

    Emitter.prototype.removeEventListener = Emitter.prototype.off;

    Emitter.prototype.off = function(event, fn) {
      var callback, callbacks, i, _i, _len;
      if (!this._callbacks || arguments.length === 0) {
        this._callbacks = {};
        return this;
      }
      callbacks = this._callbacks[event];
      if (!callbacks) {
        return this;
      }
      if (arguments.length === 1) {
        delete this._callbacks[event];
        return this;
      }
      for (i = _i = 0, _len = callbacks.length; _i < _len; i = ++_i) {
        callback = callbacks[i];
        if (callback === fn) {
          callbacks.splice(i, 1);
          break;
        }
      }
      return this;
    };

    return Emitter;

  })();

  Dropzone = (function(_super) {
    var extend, resolveOption;

    __extends(Dropzone, _super);

    Dropzone.prototype.Emitter = Emitter;


    /*
    This is a list of all available events you can register on a dropzone object.
    
    You can register an event handler like this:
    
        dropzone.on("dragEnter", function() { });
     */

    Dropzone.prototype.events = ["drop", "dragstart", "dragend", "dragenter", "dragover", "dragleave", "addedfile", "addedfiles", "removedfile", "thumbnail", "error", "errormultiple", "processing", "processingmultiple", "uploadprogress", "totaluploadprogress", "sending", "sendingmultiple", "success", "successmultiple", "canceled", "canceledmultiple", "complete", "completemultiple", "reset", "maxfilesexceeded", "maxfilesreached", "queuecomplete"];

    Dropzone.prototype.defaultOptions = {
      url: null,
      method: "post",
      withCredentials: false,
      parallelUploads: 2,
      uploadMultiple: false,
      maxFilesize: 256,
      paramName: "file",
      createImageThumbnails: true,
      maxThumbnailFilesize: 10,
      thumbnailWidth: 120,
      thumbnailHeight: 120,
      filesizeBase: 1000,
      maxFiles: null,
      params: {},
      clickable: true,
      ignoreHiddenFiles: true,
      acceptedFiles: null,
      acceptedMimeTypes: null,
      autoProcessQueue: true,
      autoQueue: true,
      addRemoveLinks: false,
      previewsContainer: null,
      hiddenInputContainer: "body",
      capture: null,
      dictDefaultMessage: "Drop files here to upload",
      dictFallbackMessage: "Your browser does not support drag'n'drop file uploads.",
      dictFallbackText: "Please use the fallback form below to upload your files like in the olden days.",
      dictFileTooBig: "File is too big ({{filesize}}MiB). Max filesize: {{maxFilesize}}MiB.",
      dictInvalidFileType: "You can't upload files of this type.",
      dictResponseError: "Server responded with {{statusCode}} code.",
      dictCancelUpload: "Cancel upload",
      dictCancelUploadConfirmation: "Are you sure you want to cancel this upload?",
      dictRemoveFile: "Remove file",
      dictRemoveFileConfirmation: null,
      dictMaxFilesExceeded: "You can not upload any more files.",
      accept: function(file, done) {
        return done();
      },
      init: function() {
        return noop;
      },
      forceFallback: false,
      fallback: function() {
        var child, messageElement, span, _i, _len, _ref;
        this.element.className = "" + this.element.className + " dz-browser-not-supported";
        _ref = this.element.getElementsByTagName("div");
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          child = _ref[_i];
          if (/(^| )dz-message($| )/.test(child.className)) {
            messageElement = child;
            child.className = "dz-message";
            continue;
          }
        }
        if (!messageElement) {
          messageElement = Dropzone.createElement("<div class=\"dz-message\"><span></span></div>");
          this.element.appendChild(messageElement);
        }
        span = messageElement.getElementsByTagName("span")[0];
        if (span) {
          if (span.textContent != null) {
            span.textContent = this.options.dictFallbackMessage;
          } else if (span.innerText != null) {
            span.innerText = this.options.dictFallbackMessage;
          }
        }
        return this.element.appendChild(this.getFallbackForm());
      },
      resize: function(file) {
        var info, srcRatio, trgRatio;
        info = {
          srcX: 0,
          srcY: 0,
          srcWidth: file.width,
          srcHeight: file.height
        };
        srcRatio = file.width / file.height;
        info.optWidth = this.options.thumbnailWidth;
        info.optHeight = this.options.thumbnailHeight;
        if ((info.optWidth == null) && (info.optHeight == null)) {
          info.optWidth = info.srcWidth;
          info.optHeight = info.srcHeight;
        } else if (info.optWidth == null) {
          info.optWidth = srcRatio * info.optHeight;
        } else if (info.optHeight == null) {
          info.optHeight = (1 / srcRatio) * info.optWidth;
        }
        trgRatio = info.optWidth / info.optHeight;
        if (file.height < info.optHeight || file.width < info.optWidth) {
          info.trgHeight = info.srcHeight;
          info.trgWidth = info.srcWidth;
        } else {
          if (srcRatio > trgRatio) {
            info.srcHeight = file.height;
            info.srcWidth = info.srcHeight * trgRatio;
          } else {
            info.srcWidth = file.width;
            info.srcHeight = info.srcWidth / trgRatio;
          }
        }
        info.srcX = (file.width - info.srcWidth) / 2;
        info.srcY = (file.height - info.srcHeight) / 2;
        return info;
      },

      /*
      Those functions register themselves to the events on init and handle all
      the user interface specific stuff. Overwriting them won't break the upload
      but can break the way it's displayed.
      You can overwrite them if you don't like the default behavior. If you just
      want to add an additional event handler, register it on the dropzone object
      and don't overwrite those options.
       */
      drop: function(e) {
        return this.element.classList.remove("dz-drag-hover");
      },
      dragstart: noop,
      dragend: function(e) {
        return this.element.classList.remove("dz-drag-hover");
      },
      dragenter: function(e) {
        return this.element.classList.add("dz-drag-hover");
      },
      dragover: function(e) {
        return this.element.classList.add("dz-drag-hover");
      },
      dragleave: function(e) {
        return this.element.classList.remove("dz-drag-hover");
      },
      paste: noop,
      reset: function() {
        return this.element.classList.remove("dz-started");
      },
      addedfile: function(file) {
        var node, removeFileEvent, removeLink, _i, _j, _k, _len, _len1, _len2, _ref, _ref1, _ref2, _results;
        if (this.element === this.previewsContainer) {
          this.element.classList.add("dz-started");
        }
        if (this.previewsContainer) {
          file.previewElement = Dropzone.createElement(this.options.previewTemplate.trim());
          file.previewTemplate = file.previewElement;
          this.previewsContainer.appendChild(file.previewElement);
          _ref = file.previewElement.querySelectorAll("[data-dz-name]");
          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
            node = _ref[_i];
            node.textContent = file.name;
          }
          _ref1 = file.previewElement.querySelectorAll("[data-dz-size]");
          for (_j = 0, _len1 = _ref1.length; _j < _len1; _j++) {
            node = _ref1[_j];
            node.innerHTML = this.filesize(file.size);
          }
          if (this.options.addRemoveLinks) {
            file._removeLink = Dropzone.createElement("<a class=\"dz-remove\" href=\"javascript:undefined;\" data-dz-remove>" + this.options.dictRemoveFile + "</a>");
            file.previewElement.appendChild(file._removeLink);
          }
          removeFileEvent = (function(_this) {
            return function(e) {
              e.preventDefault();
              e.stopPropagation();
              if (file.status === Dropzone.UPLOADING) {
                return Dropzone.confirm(_this.options.dictCancelUploadConfirmation, function() {
                  return _this.removeFile(file);
                });
              } else {
                if (_this.options.dictRemoveFileConfirmation) {
                  return Dropzone.confirm(_this.options.dictRemoveFileConfirmation, function() {
                    return _this.removeFile(file);
                  });
                } else {
                  return _this.removeFile(file);
                }
              }
            };
          })(this);
          _ref2 = file.previewElement.querySelectorAll("[data-dz-remove]");
          _results = [];
          for (_k = 0, _len2 = _ref2.length; _k < _len2; _k++) {
            removeLink = _ref2[_k];
            _results.push(removeLink.addEventListener("click", removeFileEvent));
          }
          return _results;
        }
      },
      removedfile: function(file) {
        var _ref;
        if (file.previewElement) {
          if ((_ref = file.previewElement) != null) {
            _ref.parentNode.removeChild(file.previewElement);
          }
        }
        return this._updateMaxFilesReachedClass();
      },
      thumbnail: function(file, dataUrl) {
        var thumbnailElement, _i, _len, _ref;
        if (file.previewElement) {
          file.previewElement.classList.remove("dz-file-preview");
          _ref = file.previewElement.querySelectorAll("[data-dz-thumbnail]");
          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
            thumbnailElement = _ref[_i];
            thumbnailElement.alt = file.name;
            thumbnailElement.src = dataUrl;
          }
          return setTimeout(((function(_this) {
            return function() {
              return file.previewElement.classList.add("dz-image-preview");
            };
          })(this)), 1);
        }
      },
      error: function(file, message) {
        var node, _i, _len, _ref, _results;
        if (file.previewElement) {
          file.previewElement.classList.add("dz-error");
          if (typeof message !== "String" && message.error) {
            message = message.error;
          }
          _ref = file.previewElement.querySelectorAll("[data-dz-errormessage]");
          _results = [];
          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
            node = _ref[_i];
            _results.push(node.textContent = message);
          }
          return _results;
        }
      },
      errormultiple: noop,
      processing: function(file) {
        if (file.previewElement) {
          file.previewElement.classList.add("dz-processing");
          if (file._removeLink) {
            return file._removeLink.textContent = this.options.dictCancelUpload;
          }
        }
      },
      processingmultiple: noop,
      uploadprogress: function(file, progress, bytesSent) {
        var node, _i, _len, _ref, _results;
        if (file.previewElement) {
          _ref = file.previewElement.querySelectorAll("[data-dz-uploadprogress]");
          _results = [];
          for (_i = 0, _len = _ref.length; _i < _len; _i++) {
            node = _ref[_i];
            if (node.nodeName === 'PROGRESS') {
              _results.push(node.value = progress);
            } else {
              _results.push(node.style.width = "" + progress + "%");
            }
          }
          return _results;
        }
      },
      totaluploadprogress: noop,
      sending: noop,
      sendingmultiple: noop,
      success: function(file) {
        if (file.previewElement) {
          return file.previewElement.classList.add("dz-success");
        }
      },
      successmultiple: noop,
      canceled: function(file) {
        return this.emit("error", file, "Upload canceled.");
      },
      canceledmultiple: noop,
      complete: function(file) {
        if (file._removeLink) {
          file._removeLink.textContent = this.options.dictRemoveFile;
        }
        if (file.previewElement) {
          return file.previewElement.classList.add("dz-complete");
        }
      },
      completemultiple: noop,
      maxfilesexceeded: noop,
      maxfilesreached: noop,
      queuecomplete: noop,
      addedfiles: noop,
      previewTemplate: "<div class=\"dz-preview dz-file-preview\">\n  <div class=\"dz-image\"><img data-dz-thumbnail /></div>\n  <div class=\"dz-details\">\n    <div class=\"dz-size\"><span data-dz-size></span></div>\n    <div class=\"dz-filename\"><span data-dz-name></span></div>\n  </div>\n  <div class=\"dz-progress\"><span class=\"dz-upload\" data-dz-uploadprogress></span></div>\n  <div class=\"dz-error-message\"><span data-dz-errormessage></span></div>\n  <div class=\"dz-success-mark\">\n    <svg width=\"54px\" height=\"54px\" viewBox=\"0 0 54 54\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns:sketch=\"http://www.bohemiancoding.com/sketch/ns\">\n      <title>Check</title>\n      <defs></defs>\n      <g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" sketch:type=\"MSPage\">\n        <path d=\"M23.5,31.8431458 L17.5852419,25.9283877 C16.0248253,24.3679711 13.4910294,24.366835 11.9289322,25.9289322 C10.3700136,27.4878508 10.3665912,30.0234455 11.9283877,31.5852419 L20.4147581,40.0716123 C20.5133999,40.1702541 20.6159315,40.2626649 20.7218615,40.3488435 C22.2835669,41.8725651 24.794234,41.8626202 26.3461564,40.3106978 L43.3106978,23.3461564 C44.8771021,21.7797521 44.8758057,19.2483887 43.3137085,17.6862915 C41.7547899,16.1273729 39.2176035,16.1255422 37.6538436,17.6893022 L23.5,31.8431458 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z\" id=\"Oval-2\" stroke-opacity=\"0.198794158\" stroke=\"#747474\" fill-opacity=\"0.816519475\" fill=\"#FFFFFF\" sketch:type=\"MSShapeGroup\"></path>\n      </g>\n    </svg>\n  </div>\n  <div class=\"dz-error-mark\">\n    <svg width=\"54px\" height=\"54px\" viewBox=\"0 0 54 54\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns:sketch=\"http://www.bohemiancoding.com/sketch/ns\">\n      <title>Error</title>\n      <defs></defs>\n      <g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" sketch:type=\"MSPage\">\n        <g id=\"Check-+-Oval-2\" sketch:type=\"MSLayerGroup\" stroke=\"#747474\" stroke-opacity=\"0.198794158\" fill=\"#FFFFFF\" fill-opacity=\"0.816519475\">\n          <path d=\"M32.6568542,29 L38.3106978,23.3461564 C39.8771021,21.7797521 39.8758057,19.2483887 38.3137085,17.6862915 C36.7547899,16.1273729 34.2176035,16.1255422 32.6538436,17.6893022 L27,23.3431458 L21.3461564,17.6893022 C19.7823965,16.1255422 17.2452101,16.1273729 15.6862915,17.6862915 C14.1241943,19.2483887 14.1228979,21.7797521 15.6893022,23.3461564 L21.3431458,29 L15.6893022,34.6538436 C14.1228979,36.2202479 14.1241943,38.7516113 15.6862915,40.3137085 C17.2452101,41.8726271 19.7823965,41.8744578 21.3461564,40.3106978 L27,34.6568542 L32.6538436,40.3106978 C34.2176035,41.8744578 36.7547899,41.8726271 38.3137085,40.3137085 C39.8758057,38.7516113 39.8771021,36.2202479 38.3106978,34.6538436 L32.6568542,29 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z\" id=\"Oval-2\" sketch:type=\"MSShapeGroup\"></path>\n        </g>\n      </g>\n    </svg>\n  </div>\n</div>"
    };

    extend = function() {
      var key, object, objects, target, val, _i, _len;
      target = arguments[0], objects = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
      for (_i = 0, _len = objects.length; _i < _len; _i++) {
        object = objects[_i];
        for (key in object) {
          val = object[key];
          target[key] = val;
        }
      }
      return target;
    };

    function Dropzone(element, options) {
      var elementOptions, fallback, _ref;
      this.element = element;
      this.version = Dropzone.version;
      this.defaultOptions.previewTemplate = this.defaultOptions.previewTemplate.replace(/\n*/g, "");
      this.clickableElements = [];
      this.listeners = [];
      this.files = [];
      if (typeof this.element === "string") {
        this.element = document.querySelector(this.element);
      }
      if (!(this.element && (this.element.nodeType != null))) {
        throw new Error("Invalid dropzone element.");
      }
      if (this.element.dropzone) {
        throw new Error("Dropzone already attached.");
      }
      Dropzone.instances.push(this);
      this.element.dropzone = this;
      elementOptions = (_ref = Dropzone.optionsForElement(this.element)) != null ? _ref : {};
      this.options = extend({}, this.defaultOptions, elementOptions, options != null ? options : {});
      if (this.options.forceFallback || !Dropzone.isBrowserSupported()) {
        return this.options.fallback.call(this);
      }
      if (this.options.url == null) {
        this.options.url = this.element.getAttribute("action");
      }
      if (!this.options.url) {
        throw new Error("No URL provided.");
      }
      if (this.options.acceptedFiles && this.options.acceptedMimeTypes) {
        throw new Error("You can't provide both 'acceptedFiles' and 'acceptedMimeTypes'. 'acceptedMimeTypes' is deprecated.");
      }
      if (this.options.acceptedMimeTypes) {
        this.options.acceptedFiles = this.options.acceptedMimeTypes;
        delete this.options.acceptedMimeTypes;
      }
      this.options.method = this.options.method.toUpperCase();
      if ((fallback = this.getExistingFallback()) && fallback.parentNode) {
        fallback.parentNode.removeChild(fallback);
      }
      if (this.options.previewsContainer !== false) {
        if (this.options.previewsContainer) {
          this.previewsContainer = Dropzone.getElement(this.options.previewsContainer, "previewsContainer");
        } else {
          this.previewsContainer = this.element;
        }
      }
      if (this.options.clickable) {
        if (this.options.clickable === true) {
          this.clickableElements = [this.element];
        } else {
          this.clickableElements = Dropzone.getElements(this.options.clickable, "clickable");
        }
      }
      this.init();
    }

    Dropzone.prototype.getAcceptedFiles = function() {
      var file, _i, _len, _ref, _results;
      _ref = this.files;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        file = _ref[_i];
        if (file.accepted) {
          _results.push(file);
        }
      }
      return _results;
    };

    Dropzone.prototype.getRejectedFiles = function() {
      var file, _i, _len, _ref, _results;
      _ref = this.files;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        file = _ref[_i];
        if (!file.accepted) {
          _results.push(file);
        }
      }
      return _results;
    };

    Dropzone.prototype.getFilesWithStatus = function(status) {
      var file, _i, _len, _ref, _results;
      _ref = this.files;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        file = _ref[_i];
        if (file.status === status) {
          _results.push(file);
        }
      }
      return _results;
    };

    Dropzone.prototype.getQueuedFiles = function() {
      return this.getFilesWithStatus(Dropzone.QUEUED);
    };

    Dropzone.prototype.getUploadingFiles = function() {
      return this.getFilesWithStatus(Dropzone.UPLOADING);
    };

    Dropzone.prototype.getAddedFiles = function() {
      return this.getFilesWithStatus(Dropzone.ADDED);
    };

    Dropzone.prototype.getActiveFiles = function() {
      var file, _i, _len, _ref, _results;
      _ref = this.files;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        file = _ref[_i];
        if (file.status === Dropzone.UPLOADING || file.status === Dropzone.QUEUED) {
          _results.push(file);
        }
      }
      return _results;
    };

    Dropzone.prototype.init = function() {
      var eventName, noPropagation, setupHiddenFileInput, _i, _len, _ref, _ref1;
      if (this.element.tagName === "form") {
        this.element.setAttribute("enctype", "multipart/form-data");
      }
      if (this.element.classList.contains("dropzone") && !this.element.querySelector(".dz-message")) {
        this.element.appendChild(Dropzone.createElement("<div class=\"dz-default dz-message\"><span>" + this.options.dictDefaultMessage + "</span></div>"));
      }
      if (this.clickableElements.length) {
        setupHiddenFileInput = (function(_this) {
          return function() {
            if (_this.hiddenFileInput) {
              _this.hiddenFileInput.parentNode.removeChild(_this.hiddenFileInput);
            }
            _this.hiddenFileInput = document.createElement("input");
            _this.hiddenFileInput.setAttribute("type", "file");
            if ((_this.options.maxFiles == null) || _this.options.maxFiles > 1) {
              _this.hiddenFileInput.setAttribute("multiple", "multiple");
            }
            _this.hiddenFileInput.className = "dz-hidden-input";
            if (_this.options.acceptedFiles != null) {
              _this.hiddenFileInput.setAttribute("accept", _this.options.acceptedFiles);
            }
            if (_this.options.capture != null) {
              _this.hiddenFileInput.setAttribute("capture", _this.options.capture);
            }
            _this.hiddenFileInput.style.visibility = "hidden";
            _this.hiddenFileInput.style.position = "absolute";
            _this.hiddenFileInput.style.top = "0";
            _this.hiddenFileInput.style.left = "0";
            _this.hiddenFileInput.style.height = "0";
            _this.hiddenFileInput.style.width = "0";
            document.querySelector(_this.options.hiddenInputContainer).appendChild(_this.hiddenFileInput);
            return _this.hiddenFileInput.addEventListener("change", function() {
              var file, files, _i, _len;
              files = _this.hiddenFileInput.files;
              if (files.length) {
                for (_i = 0, _len = files.length; _i < _len; _i++) {
                  file = files[_i];
                  _this.addFile(file);
                }
              }
              _this.emit("addedfiles", files);
              return setupHiddenFileInput();
            });
          };
        })(this);
        setupHiddenFileInput();
      }
      this.URL = (_ref = window.URL) != null ? _ref : window.webkitURL;
      _ref1 = this.events;
      for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
        eventName = _ref1[_i];
        this.on(eventName, this.options[eventName]);
      }
      this.on("uploadprogress", (function(_this) {
        return function() {
          return _this.updateTotalUploadProgress();
        };
      })(this));
      this.on("removedfile", (function(_this) {
        return function() {
          return _this.updateTotalUploadProgress();
        };
      })(this));
      this.on("canceled", (function(_this) {
        return function(file) {
          return _this.emit("complete", file);
        };
      })(this));
      this.on("complete", (function(_this) {
        return function(file) {
          if (_this.getAddedFiles().length === 0 && _this.getUploadingFiles().length === 0 && _this.getQueuedFiles().length === 0) {
            return setTimeout((function() {
              return _this.emit("queuecomplete");
            }), 0);
          }
        };
      })(this));
      noPropagation = function(e) {
        e.stopPropagation();
        if (e.preventDefault) {
          return e.preventDefault();
        } else {
          return e.returnValue = false;
        }
      };
      this.listeners = [
        {
          element: this.element,
          events: {
            "dragstart": (function(_this) {
              return function(e) {
                return _this.emit("dragstart", e);
              };
            })(this),
            "dragenter": (function(_this) {
              return function(e) {
                noPropagation(e);
                return _this.emit("dragenter", e);
              };
            })(this),
            "dragover": (function(_this) {
              return function(e) {
                var efct;
                try {
                  efct = e.dataTransfer.effectAllowed;
                } catch (_error) {}
                e.dataTransfer.dropEffect = 'move' === efct || 'linkMove' === efct ? 'move' : 'copy';
                noPropagation(e);
                return _this.emit("dragover", e);
              };
            })(this),
            "dragleave": (function(_this) {
              return function(e) {
                return _this.emit("dragleave", e);
              };
            })(this),
            "drop": (function(_this) {
              return function(e) {
                noPropagation(e);
                return _this.drop(e);
              };
            })(this),
            "dragend": (function(_this) {
              return function(e) {
                return _this.emit("dragend", e);
              };
            })(this)
          }
        }
      ];
      this.clickableElements.forEach((function(_this) {
        return function(clickableElement) {
          return _this.listeners.push({
            element: clickableElement,
            events: {
              "click": function(evt) {
                if ((clickableElement !== _this.element) || (evt.target === _this.element || Dropzone.elementInside(evt.target, _this.element.querySelector(".dz-message")))) {
                  _this.hiddenFileInput.click();
                }
                return true;
              }
            }
          });
        };
      })(this));
      this.enable();
      return this.options.init.call(this);
    };

    Dropzone.prototype.destroy = function() {
      var _ref;
      this.disable();
      this.removeAllFiles(true);
      if ((_ref = this.hiddenFileInput) != null ? _ref.parentNode : void 0) {
        this.hiddenFileInput.parentNode.removeChild(this.hiddenFileInput);
        this.hiddenFileInput = null;
      }
      delete this.element.dropzone;
      return Dropzone.instances.splice(Dropzone.instances.indexOf(this), 1);
    };

    Dropzone.prototype.updateTotalUploadProgress = function() {
      var activeFiles, file, totalBytes, totalBytesSent, totalUploadProgress, _i, _len, _ref;
      totalBytesSent = 0;
      totalBytes = 0;
      activeFiles = this.getActiveFiles();
      if (activeFiles.length) {
        _ref = this.getActiveFiles();
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          file = _ref[_i];
          totalBytesSent += file.upload.bytesSent;
          totalBytes += file.upload.total;
        }
        totalUploadProgress = 100 * totalBytesSent / totalBytes;
      } else {
        totalUploadProgress = 100;
      }
      return this.emit("totaluploadprogress", totalUploadProgress, totalBytes, totalBytesSent);
    };

    Dropzone.prototype._getParamName = function(n) {
      if (typeof this.options.paramName === "function") {
        return this.options.paramName(n);
      } else {
        return "" + this.options.paramName + (this.options.uploadMultiple ? "[" + n + "]" : "");
      }
    };

    Dropzone.prototype.getFallbackForm = function() {
      var existingFallback, fields, fieldsString, form;
      if (existingFallback = this.getExistingFallback()) {
        return existingFallback;
      }
      fieldsString = "<div class=\"dz-fallback\">";
      if (this.options.dictFallbackText) {
        fieldsString += "<p>" + this.options.dictFallbackText + "</p>";
      }
      fieldsString += "<input type=\"file\" name=\"" + (this._getParamName(0)) + "\" " + (this.options.uploadMultiple ? 'multiple="multiple"' : void 0) + " /><input type=\"submit\" value=\"Upload!\"></div>";
      fields = Dropzone.createElement(fieldsString);
      if (this.element.tagName !== "FORM") {
        form = Dropzone.createElement("<form action=\"" + this.options.url + "\" enctype=\"multipart/form-data\" method=\"" + this.options.method + "\"></form>");
        form.appendChild(fields);
      } else {
        this.element.setAttribute("enctype", "multipart/form-data");
        this.element.setAttribute("method", this.options.method);
      }
      return form != null ? form : fields;
    };

    Dropzone.prototype.getExistingFallback = function() {
      var fallback, getFallback, tagName, _i, _len, _ref;
      getFallback = function(elements) {
        var el, _i, _len;
        for (_i = 0, _len = elements.length; _i < _len; _i++) {
          el = elements[_i];
          if (/(^| )fallback($| )/.test(el.className)) {
            return el;
          }
        }
      };
      _ref = ["div", "form"];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        tagName = _ref[_i];
        if (fallback = getFallback(this.element.getElementsByTagName(tagName))) {
          return fallback;
        }
      }
    };

    Dropzone.prototype.setupEventListeners = function() {
      var elementListeners, event, listener, _i, _len, _ref, _results;
      _ref = this.listeners;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        elementListeners = _ref[_i];
        _results.push((function() {
          var _ref1, _results1;
          _ref1 = elementListeners.events;
          _results1 = [];
          for (event in _ref1) {
            listener = _ref1[event];
            _results1.push(elementListeners.element.addEventListener(event, listener, false));
          }
          return _results1;
        })());
      }
      return _results;
    };

    Dropzone.prototype.removeEventListeners = function() {
      var elementListeners, event, listener, _i, _len, _ref, _results;
      _ref = this.listeners;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        elementListeners = _ref[_i];
        _results.push((function() {
          var _ref1, _results1;
          _ref1 = elementListeners.events;
          _results1 = [];
          for (event in _ref1) {
            listener = _ref1[event];
            _results1.push(elementListeners.element.removeEventListener(event, listener, false));
          }
          return _results1;
        })());
      }
      return _results;
    };

    Dropzone.prototype.disable = function() {
      var file, _i, _len, _ref, _results;
      this.clickableElements.forEach(function(element) {
        return element.classList.remove("dz-clickable");
      });
      this.removeEventListeners();
      _ref = this.files;
      _results = [];
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        file = _ref[_i];
        _results.push(this.cancelUpload(file));
      }
      return _results;
    };

    Dropzone.prototype.enable = function() {
      this.clickableElements.forEach(function(element) {
        return element.classList.add("dz-clickable");
      });
      return this.setupEventListeners();
    };

    Dropzone.prototype.filesize = function(size) {
      var cutoff, i, selectedSize, selectedUnit, unit, units, _i, _len;
      selectedSize = 0;
      selectedUnit = "b";
      if (size > 0) {
        units = ['TB', 'GB', 'MB', 'KB', 'b'];
        for (i = _i = 0, _len = units.length; _i < _len; i = ++_i) {
          unit = units[i];
          cutoff = Math.pow(this.options.filesizeBase, 4 - i) / 10;
          if (size >= cutoff) {
            selectedSize = size / Math.pow(this.options.filesizeBase, 4 - i);
            selectedUnit = unit;
            break;
          }
        }
        selectedSize = Math.round(10 * selectedSize) / 10;
      }
      return "<strong>" + selectedSize + "</strong> " + selectedUnit;
    };

    Dropzone.prototype._updateMaxFilesReachedClass = function() {
      if ((this.options.maxFiles != null) && this.getAcceptedFiles().length >= this.options.maxFiles) {
        if (this.getAcceptedFiles().length === this.options.maxFiles) {
          this.emit('maxfilesreached', this.files);
        }
        return this.element.classList.add("dz-max-files-reached");
      } else {
        return this.element.classList.remove("dz-max-files-reached");
      }
    };

    Dropzone.prototype.drop = function(e) {
      var files, items;
      if (!e.dataTransfer) {
        return;
      }
      this.emit("drop", e);
      files = e.dataTransfer.files;
      this.emit("addedfiles", files);
      if (files.length) {
        items = e.dataTransfer.items;
        if (items && items.length && (items[0].webkitGetAsEntry != null)) {
          this._addFilesFromItems(items);
        } else {
          this.handleFiles(files);
        }
      }
    };

    Dropzone.prototype.paste = function(e) {
      var items, _ref;
      if ((e != null ? (_ref = e.clipboardData) != null ? _ref.items : void 0 : void 0) == null) {
        return;
      }
      this.emit("paste", e);
      items = e.clipboardData.items;
      if (items.length) {
        return this._addFilesFromItems(items);
      }
    };

    Dropzone.prototype.handleFiles = function(files) {
      var file, _i, _len, _results;
      _results = [];
      for (_i = 0, _len = files.length; _i < _len; _i++) {
        file = files[_i];
        _results.push(this.addFile(file));
      }
      return _results;
    };

    Dropzone.prototype._addFilesFromItems = function(items) {
      var entry, item, _i, _len, _results;
      _results = [];
      for (_i = 0, _len = items.length; _i < _len; _i++) {
        item = items[_i];
        if ((item.webkitGetAsEntry != null) && (entry = item.webkitGetAsEntry())) {
          if (entry.isFile) {
            _results.push(this.addFile(item.getAsFile()));
          } else if (entry.isDirectory) {
            _results.push(this._addFilesFromDirectory(entry, entry.name));
          } else {
            _results.push(void 0);
          }
        } else if (item.getAsFile != null) {
          if ((item.kind == null) || item.kind === "file") {
            _results.push(this.addFile(item.getAsFile()));
          } else {
            _results.push(void 0);
          }
        } else {
          _results.push(void 0);
        }
      }
      return _results;
    };

    Dropzone.prototype._addFilesFromDirectory = function(directory, path) {
      var dirReader, entriesReader;
      dirReader = directory.createReader();
      entriesReader = (function(_this) {
        return function(entries) {
          var entry, _i, _len;
          for (_i = 0, _len = entries.length; _i < _len; _i++) {
            entry = entries[_i];
            if (entry.isFile) {
              entry.file(function(file) {
                if (_this.options.ignoreHiddenFiles && file.name.substring(0, 1) === '.') {
                  return;
                }
                file.fullPath = "" + path + "/" + file.name;
                return _this.addFile(file);
              });
            } else if (entry.isDirectory) {
              _this._addFilesFromDirectory(entry, "" + path + "/" + entry.name);
            }
          }
        };
      })(this);
      return dirReader.readEntries(entriesReader, function(error) {
        return typeof console !== "undefined" && console !== null ? typeof console.log === "function" ? console.log(error) : void 0 : void 0;
      });
    };

    Dropzone.prototype.accept = function(file, done) {
      if (file.size > this.options.maxFilesize * 1024 * 1024) {
        return done(this.options.dictFileTooBig.replace("{{filesize}}", Math.round(file.size / 1024 / 10.24) / 100).replace("{{maxFilesize}}", this.options.maxFilesize));
      } else if (!Dropzone.isValidFile(file, this.options.acceptedFiles)) {
        return done(this.options.dictInvalidFileType);
      } else if ((this.options.maxFiles != null) && this.getAcceptedFiles().length >= this.options.maxFiles) {
        done(this.options.dictMaxFilesExceeded.replace("{{maxFiles}}", this.options.maxFiles));
        return this.emit("maxfilesexceeded", file);
      } else {
        return this.options.accept.call(this, file, done);
      }
    };

    Dropzone.prototype.addFile = function(file) {
      file.upload = {
        progress: 0,
        total: file.size,
        bytesSent: 0
      };
      this.files.push(file);
      file.status = Dropzone.ADDED;
      this.emit("addedfile", file);
      this._enqueueThumbnail(file);
      return this.accept(file, (function(_this) {
        return function(error) {
          if (error) {
            file.accepted = false;
            _this._errorProcessing([file], error);
          } else {
            file.accepted = true;
            if (_this.options.autoQueue) {
              _this.enqueueFile(file);
            }
          }
          return _this._updateMaxFilesReachedClass();
        };
      })(this));
    };

    Dropzone.prototype.enqueueFiles = function(files) {
      var file, _i, _len;
      for (_i = 0, _len = files.length; _i < _len; _i++) {
        file = files[_i];
        this.enqueueFile(file);
      }
      return null;
    };

    Dropzone.prototype.enqueueFile = function(file) {
      if (file.status === Dropzone.ADDED && file.accepted === true) {
        file.status = Dropzone.QUEUED;
        if (this.options.autoProcessQueue) {
          return setTimeout(((function(_this) {
            return function() {
              return _this.processQueue();
            };
          })(this)), 0);
        }
      } else {
        throw new Error("This file can't be queued because it has already been processed or was rejected.");
      }
    };

    Dropzone.prototype._thumbnailQueue = [];

    Dropzone.prototype._processingThumbnail = false;

    Dropzone.prototype._enqueueThumbnail = function(file) {
      if (this.options.createImageThumbnails && file.type.match(/image.*/) && file.size <= this.options.maxThumbnailFilesize * 1024 * 1024) {
        this._thumbnailQueue.push(file);
        return setTimeout(((function(_this) {
          return function() {
            return _this._processThumbnailQueue();
          };
        })(this)), 0);
      }
    };

    Dropzone.prototype._processThumbnailQueue = function() {
      if (this._processingThumbnail || this._thumbnailQueue.length === 0) {
        return;
      }
      this._processingThumbnail = true;
      return this.createThumbnail(this._thumbnailQueue.shift(), (function(_this) {
        return function() {
          _this._processingThumbnail = false;
          return _this._processThumbnailQueue();
        };
      })(this));
    };

    Dropzone.prototype.removeFile = function(file) {
      if (file.status === Dropzone.UPLOADING) {
        this.cancelUpload(file);
      }
      this.files = without(this.files, file);
      this.emit("removedfile", file);
      if (this.files.length === 0) {
        return this.emit("reset");
      }
    };

    Dropzone.prototype.removeAllFiles = function(cancelIfNecessary) {
      var file, _i, _len, _ref;
      if (cancelIfNecessary == null) {
        cancelIfNecessary = false;
      }
      _ref = this.files.slice();
      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
        file = _ref[_i];
        if (file.status !== Dropzone.UPLOADING || cancelIfNecessary) {
          this.removeFile(file);
        }
      }
      return null;
    };

    Dropzone.prototype.createThumbnail = function(file, callback) {
      var fileReader;
      fileReader = new FileReader;
      fileReader.onload = (function(_this) {
        return function() {
          if (file.type === "image/svg+xml") {
            _this.emit("thumbnail", file, fileReader.result);
            if (callback != null) {
              callback();
            }
            return;
          }
          return _this.createThumbnailFromUrl(file, fileReader.result, callback);
        };
      })(this);
      return fileReader.readAsDataURL(file);
    };

    Dropzone.prototype.createThumbnailFromUrl = function(file, imageUrl, callback, crossOrigin) {
      var img;
      img = document.createElement("img");
      if (crossOrigin) {
        img.crossOrigin = crossOrigin;
      }
      img.onload = (function(_this) {
        return function() {
          var canvas, ctx, resizeInfo, thumbnail, _ref, _ref1, _ref2, _ref3;
          file.width = img.width;
          file.height = img.height;
          resizeInfo = _this.options.resize.call(_this, file);
          if (resizeInfo.trgWidth == null) {
            resizeInfo.trgWidth = resizeInfo.optWidth;
          }
          if (resizeInfo.trgHeight == null) {
            resizeInfo.trgHeight = resizeInfo.optHeight;
          }
          canvas = document.createElement("canvas");
          ctx = canvas.getContext("2d");
          canvas.width = resizeInfo.trgWidth;
          canvas.height = resizeInfo.trgHeight;
          drawImageIOSFix(ctx, img, (_ref = resizeInfo.srcX) != null ? _ref : 0, (_ref1 = resizeInfo.srcY) != null ? _ref1 : 0, resizeInfo.srcWidth, resizeInfo.srcHeight, (_ref2 = resizeInfo.trgX) != null ? _ref2 : 0, (_ref3 = resizeInfo.trgY) != null ? _ref3 : 0, resizeInfo.trgWidth, resizeInfo.trgHeight);
          thumbnail = canvas.toDataURL("image/png");
          _this.emit("thumbnail", file, thumbnail);
          if (callback != null) {
            return callback();
          }
        };
      })(this);
      if (callback != null) {
        img.onerror = callback;
      }
      return img.src = imageUrl;
    };

    Dropzone.prototype.processQueue = function() {
      var i, parallelUploads, processingLength, queuedFiles;
      parallelUploads = this.options.parallelUploads;
      processingLength = this.getUploadingFiles().length;
      i = processingLength;
      if (processingLength >= parallelUploads) {
        return;
      }
      queuedFiles = this.getQueuedFiles();
      if (!(queuedFiles.length > 0)) {
        return;
      }
      if (this.options.uploadMultiple) {
        return this.processFiles(queuedFiles.slice(0, parallelUploads - processingLength));
      } else {
        while (i < parallelUploads) {
          if (!queuedFiles.length) {
            return;
          }
          this.processFile(queuedFiles.shift());
          i++;
        }
      }
    };

    Dropzone.prototype.processFile = function(file) {
      return this.processFiles([file]);
    };

    Dropzone.prototype.processFiles = function(files) {
      var file, _i, _len;
      for (_i = 0, _len = files.length; _i < _len; _i++) {
        file = files[_i];
        file.processing = true;
        file.status = Dropzone.UPLOADING;
        this.emit("processing", file);
      }
      if (this.options.uploadMultiple) {
        this.emit("processingmultiple", files);
      }
      return this.uploadFiles(files);
    };

    Dropzone.prototype._getFilesWithXhr = function(xhr) {
      var file, files;
      return files = (function() {
        var _i, _len, _ref, _results;
        _ref = this.files;
        _results = [];
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          file = _ref[_i];
          if (file.xhr === xhr) {
            _results.push(file);
          }
        }
        return _results;
      }).call(this);
    };

    Dropzone.prototype.cancelUpload = function(file) {
      var groupedFile, groupedFiles, _i, _j, _len, _len1, _ref;
      if (file.status === Dropzone.UPLOADING) {
        groupedFiles = this._getFilesWithXhr(file.xhr);
        for (_i = 0, _len = groupedFiles.length; _i < _len; _i++) {
          groupedFile = groupedFiles[_i];
          groupedFile.status = Dropzone.CANCELED;
        }
        file.xhr.abort();
        for (_j = 0, _len1 = groupedFiles.length; _j < _len1; _j++) {
          groupedFile = groupedFiles[_j];
          this.emit("canceled", groupedFile);
        }
        if (this.options.uploadMultiple) {
          this.emit("canceledmultiple", groupedFiles);
        }
      } else if ((_ref = file.status) === Dropzone.ADDED || _ref === Dropzone.QUEUED) {
        file.status = Dropzone.CANCELED;
        this.emit("canceled", file);
        if (this.options.uploadMultiple) {
          this.emit("canceledmultiple", [file]);
        }
      }
      if (this.options.autoProcessQueue) {
        return this.processQueue();
      }
    };

    resolveOption = function() {
      var args, option;
      option = arguments[0], args = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
      if (typeof option === 'function') {
        return option.apply(this, args);
      }
      return option;
    };

    Dropzone.prototype.uploadFile = function(file) {
      return this.uploadFiles([file]);
    };

    Dropzone.prototype.uploadFiles = function(files) {
      var file, formData, handleError, headerName, headerValue, headers, i, input, inputName, inputType, key, method, option, progressObj, response, updateProgress, url, value, xhr, _i, _j, _k, _l, _len, _len1, _len2, _len3, _m, _ref, _ref1, _ref2, _ref3, _ref4, _ref5;
      xhr = new XMLHttpRequest();
      for (_i = 0, _len = files.length; _i < _len; _i++) {
        file = files[_i];
        file.xhr = xhr;
      }
      method = resolveOption(this.options.method, files);
      url = resolveOption(this.options.url, files);
      xhr.open(method, url, true);
      xhr.withCredentials = !!this.options.withCredentials;
      response = null;
      handleError = (function(_this) {
        return function() {
          var _j, _len1, _results;
          _results = [];
          for (_j = 0, _len1 = files.length; _j < _len1; _j++) {
            file = files[_j];
            _results.push(_this._errorProcessing(files, response || _this.options.dictResponseError.replace("{{statusCode}}", xhr.status), xhr));
          }
          return _results;
        };
      })(this);
      updateProgress = (function(_this) {
        return function(e) {
          var allFilesFinished, progress, _j, _k, _l, _len1, _len2, _len3, _results;
          if (e != null) {
            progress = 100 * e.loaded / e.total;
            for (_j = 0, _len1 = files.length; _j < _len1; _j++) {
              file = files[_j];
              file.upload = {
                progress: progress,
                total: e.total,
                bytesSent: e.loaded
              };
            }
          } else {
            allFilesFinished = true;
            progress = 100;
            for (_k = 0, _len2 = files.length; _k < _len2; _k++) {
              file = files[_k];
              if (!(file.upload.progress === 100 && file.upload.bytesSent === file.upload.total)) {
                allFilesFinished = false;
              }
              file.upload.progress = progress;
              file.upload.bytesSent = file.upload.total;
            }
            if (allFilesFinished) {
              return;
            }
          }
          _results = [];
          for (_l = 0, _len3 = files.length; _l < _len3; _l++) {
            file = files[_l];
            _results.push(_this.emit("uploadprogress", file, progress, file.upload.bytesSent));
          }
          return _results;
        };
      })(this);
      xhr.onload = (function(_this) {
        return function(e) {
          var _ref;
          if (files[0].status === Dropzone.CANCELED) {
            return;
          }
          if (xhr.readyState !== 4) {
            return;
          }
          response = xhr.responseText;
          if (xhr.getResponseHeader("content-type") && ~xhr.getResponseHeader("content-type").indexOf("application/json")) {
            try {
              response = JSON.parse(response);
            } catch (_error) {
              e = _error;
              response = "Invalid JSON response from server.";
            }
          }
          updateProgress();
          if (!((200 <= (_ref = xhr.status) && _ref < 300))) {
            return handleError();
          } else {
            return _this._finished(files, response, e);
          }
        };
      })(this);
      xhr.onerror = (function(_this) {
        return function() {
          if (files[0].status === Dropzone.CANCELED) {
            return;
          }
          return handleError();
        };
      })(this);
      progressObj = (_ref = xhr.upload) != null ? _ref : xhr;
      progressObj.onprogress = updateProgress;
      headers = {
        "Accept": "application/json",
        "Cache-Control": "no-cache",
        "X-Requested-With": "XMLHttpRequest"
      };
      if (this.options.headers) {
        extend(headers, this.options.headers);
      }
      for (headerName in headers) {
        headerValue = headers[headerName];
        if (headerValue) {
          xhr.setRequestHeader(headerName, headerValue);
        }
      }
      formData = new FormData();
      if (this.options.params) {
        _ref1 = this.options.params;
        for (key in _ref1) {
          value = _ref1[key];
          formData.append(key, value);
        }
      }
      for (_j = 0, _len1 = files.length; _j < _len1; _j++) {
        file = files[_j];
        this.emit("sending", file, xhr, formData);
      }
      if (this.options.uploadMultiple) {
        this.emit("sendingmultiple", files, xhr, formData);
      }
      if (this.element.tagName === "FORM") {
        _ref2 = this.element.querySelectorAll("input, textarea, select, button");
        for (_k = 0, _len2 = _ref2.length; _k < _len2; _k++) {
          input = _ref2[_k];
          inputName = input.getAttribute("name");
          inputType = input.getAttribute("type");
          if (input.tagName === "SELECT" && input.hasAttribute("multiple")) {
            _ref3 = input.options;
            for (_l = 0, _len3 = _ref3.length; _l < _len3; _l++) {
              option = _ref3[_l];
              if (option.selected) {
                formData.append(inputName, option.value);
              }
            }
          } else if (!inputType || ((_ref4 = inputType.toLowerCase()) !== "checkbox" && _ref4 !== "radio") || input.checked) {
            formData.append(inputName, input.value);
          }
        }
      }
      for (i = _m = 0, _ref5 = files.length - 1; 0 <= _ref5 ? _m <= _ref5 : _m >= _ref5; i = 0 <= _ref5 ? ++_m : --_m) {
        formData.append(this._getParamName(i), files[i], files[i].name);
      }
      return this.submitRequest(xhr, formData, files);
    };

    Dropzone.prototype.submitRequest = function(xhr, formData, files) {
      return xhr.send(formData);
    };

    Dropzone.prototype._finished = function(files, responseText, e) {
      var file, _i, _len;
      for (_i = 0, _len = files.length; _i < _len; _i++) {
        file = files[_i];
        file.status = Dropzone.SUCCESS;
        this.emit("success", file, responseText, e);
        this.emit("complete", file);
      }
      if (this.options.uploadMultiple) {
        this.emit("successmultiple", files, responseText, e);
        this.emit("completemultiple", files);
      }
      if (this.options.autoProcessQueue) {
        return this.processQueue();
      }
    };

    Dropzone.prototype._errorProcessing = function(files, message, xhr) {
      var file, _i, _len;
      for (_i = 0, _len = files.length; _i < _len; _i++) {
        file = files[_i];
        file.status = Dropzone.ERROR;
        this.emit("error", file, message, xhr);
        this.emit("complete", file);
      }
      if (this.options.uploadMultiple) {
        this.emit("errormultiple", files, message, xhr);
        this.emit("completemultiple", files);
      }
      if (this.options.autoProcessQueue) {
        return this.processQueue();
      }
    };

    return Dropzone;

  })(Emitter);

  Dropzone.version = "4.2.0";

  Dropzone.options = {};

  Dropzone.optionsForElement = function(element) {
    if (element.getAttribute("id")) {
      return Dropzone.options[camelize(element.getAttribute("id"))];
    } else {
      return void 0;
    }
  };

  Dropzone.instances = [];

  Dropzone.forElement = function(element) {
    if (typeof element === "string") {
      element = document.querySelector(element);
    }
    if ((element != null ? element.dropzone : void 0) == null) {
      throw new Error("No Dropzone found for given element. This is probably because you're trying to access it before Dropzone had the time to initialize. Use the `init` option to setup any additional observers on your Dropzone.");
    }
    return element.dropzone;
  };

  Dropzone.autoDiscover = true;

  Dropzone.discover = function() {
    var checkElements, dropzone, dropzones, _i, _len, _results;
    if (document.querySelectorAll) {
      dropzones = document.querySelectorAll(".dropzone");
    } else {
      dropzones = [];
      checkElements = function(elements) {
        var el, _i, _len, _results;
        _results = [];
        for (_i = 0, _len = elements.length; _i < _len; _i++) {
          el = elements[_i];
          if (/(^| )dropzone($| )/.test(el.className)) {
            _results.push(dropzones.push(el));
          } else {
            _results.push(void 0);
          }
        }
        return _results;
      };
      checkElements(document.getElementsByTagName("div"));
      checkElements(document.getElementsByTagName("form"));
    }
    _results = [];
    for (_i = 0, _len = dropzones.length; _i < _len; _i++) {
      dropzone = dropzones[_i];
      if (Dropzone.optionsForElement(dropzone) !== false) {
        _results.push(new Dropzone(dropzone));
      } else {
        _results.push(void 0);
      }
    }
    return _results;
  };

  Dropzone.blacklistedBrowsers = [/opera.*Macintosh.*version\/12/i];

  Dropzone.isBrowserSupported = function() {
    var capableBrowser, regex, _i, _len, _ref;
    capableBrowser = true;
    if (window.File && window.FileReader && window.FileList && window.Blob && window.FormData && document.querySelector) {
      if (!("classList" in document.createElement("a"))) {
        capableBrowser = false;
      } else {
        _ref = Dropzone.blacklistedBrowsers;
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          regex = _ref[_i];
          if (regex.test(navigator.userAgent)) {
            capableBrowser = false;
            continue;
          }
        }
      }
    } else {
      capableBrowser = false;
    }
    return capableBrowser;
  };

  without = function(list, rejectedItem) {
    var item, _i, _len, _results;
    _results = [];
    for (_i = 0, _len = list.length; _i < _len; _i++) {
      item = list[_i];
      if (item !== rejectedItem) {
        _results.push(item);
      }
    }
    return _results;
  };

  camelize = function(str) {
    return str.replace(/[\-_](\w)/g, function(match) {
      return match.charAt(1).toUpperCase();
    });
  };

  Dropzone.createElement = function(string) {
    var div;
    div = document.createElement("div");
    div.innerHTML = string;
    return div.childNodes[0];
  };

  Dropzone.elementInside = function(element, container) {
    if (element === container) {
      return true;
    }
    while (element = element.parentNode) {
      if (element === container) {
        return true;
      }
    }
    return false;
  };

  Dropzone.getElement = function(el, name) {
    var element;
    if (typeof el === "string") {
      element = document.querySelector(el);
    } else if (el.nodeType != null) {
      element = el;
    }
    if (element == null) {
      throw new Error("Invalid `" + name + "` option provided. Please provide a CSS selector or a plain HTML element.");
    }
    return element;
  };

  Dropzone.getElements = function(els, name) {
    var e, el, elements, _i, _j, _len, _len1, _ref;
    if (els instanceof Array) {
      elements = [];
      try {
        for (_i = 0, _len = els.length; _i < _len; _i++) {
          el = els[_i];
          elements.push(this.getElement(el, name));
        }
      } catch (_error) {
        e = _error;
        elements = null;
      }
    } else if (typeof els === "string") {
      elements = [];
      _ref = document.querySelectorAll(els);
      for (_j = 0, _len1 = _ref.length; _j < _len1; _j++) {
        el = _ref[_j];
        elements.push(el);
      }
    } else if (els.nodeType != null) {
      elements = [els];
    }
    if (!((elements != null) && elements.length)) {
      throw new Error("Invalid `" + name + "` option provided. Please provide a CSS selector, a plain HTML element or a list of those.");
    }
    return elements;
  };

  Dropzone.confirm = function(question, accepted, rejected) {
    if (window.confirm(question)) {
      return accepted();
    } else if (rejected != null) {
      return rejected();
    }
  };

  Dropzone.isValidFile = function(file, acceptedFiles) {
    var baseMimeType, mimeType, validType, _i, _len;
    if (!acceptedFiles) {
      return true;
    }
    acceptedFiles = acceptedFiles.split(",");
    mimeType = file.type;
    baseMimeType = mimeType.replace(/\/.*$/, "");
    for (_i = 0, _len = acceptedFiles.length; _i < _len; _i++) {
      validType = acceptedFiles[_i];
      validType = validType.trim();
      if (validType.charAt(0) === ".") {
        if (file.name.toLowerCase().indexOf(validType.toLowerCase(), file.name.length - validType.length) !== -1) {
          return true;
        }
      } else if (/\/\*$/.test(validType)) {
        if (baseMimeType === validType.replace(/\/.*$/, "")) {
          return true;
        }
      } else {
        if (mimeType === validType) {
          return true;
        }
      }
    }
    return false;
  };

  if (typeof jQuery !== "undefined" && jQuery !== null) {
    jQuery.fn.dropzone = function(options) {
      return this.each(function() {
        return new Dropzone(this, options);
      });
    };
  }

  if (typeof module !== "undefined" && module !== null) {
    module.exports = Dropzone;
  } else {
    window.Dropzone = Dropzone;
  }

  Dropzone.ADDED = "added";

  Dropzone.QUEUED = "queued";

  Dropzone.ACCEPTED = Dropzone.QUEUED;

  Dropzone.UPLOADING = "uploading";

  Dropzone.PROCESSING = Dropzone.UPLOADING;

  Dropzone.CANCELED = "canceled";

  Dropzone.ERROR = "error";

  Dropzone.SUCCESS = "success";


  /*
  
  Bugfix for iOS 6 and 7
  Source: http://stackoverflow.com/questions/11929099/html5-canvas-drawimage-ratio-bug-ios
  based on the work of https://github.com/stomita/ios-imagefile-megapixel
   */

  detectVerticalSquash = function(img) {
    var alpha, canvas, ctx, data, ey, ih, iw, py, ratio, sy;
    iw = img.naturalWidth;
    ih = img.naturalHeight;
    canvas = document.createElement("canvas");
    canvas.width = 1;
    canvas.height = ih;
    ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0);
    data = ctx.getImageData(0, 0, 1, ih).data;
    sy = 0;
    ey = ih;
    py = ih;
    while (py > sy) {
      alpha = data[(py - 1) * 4 + 3];
      if (alpha === 0) {
        ey = py;
      } else {
        sy = py;
      }
      py = (ey + sy) >> 1;
    }
    ratio = py / ih;
    if (ratio === 0) {
      return 1;
    } else {
      return ratio;
    }
  };

  drawImageIOSFix = function(ctx, img, sx, sy, sw, sh, dx, dy, dw, dh) {
    var vertSquashRatio;
    vertSquashRatio = detectVerticalSquash(img);
    return ctx.drawImage(img, sx, sy, sw, sh, dx, dy, dw, dh / vertSquashRatio);
  };


  /*
   * contentloaded.js
   *
   * Author: Diego Perini (diego.perini at gmail.com)
   * Summary: cross-browser wrapper for DOMContentLoaded
   * Updated: 20101020
   * License: MIT
   * Version: 1.2
   *
   * URL:
   * http://javascript.nwbox.com/ContentLoaded/
   * http://javascript.nwbox.com/ContentLoaded/MIT-LICENSE
   */

  contentLoaded = function(win, fn) {
    var add, doc, done, init, poll, pre, rem, root, top;
    done = false;
    top = true;
    doc = win.document;
    root = doc.documentElement;
    add = (doc.addEventListener ? "addEventListener" : "attachEvent");
    rem = (doc.addEventListener ? "removeEventListener" : "detachEvent");
    pre = (doc.addEventListener ? "" : "on");
    init = function(e) {
      if (e.type === "readystatechange" && doc.readyState !== "complete") {
        return;
      }
      (e.type === "load" ? win : doc)[rem](pre + e.type, init, false);
      if (!done && (done = true)) {
        return fn.call(win, e.type || e);
      }
    };
    poll = function() {
      var e;
      try {
        root.doScroll("left");
      } catch (_error) {
        e = _error;
        setTimeout(poll, 50);
        return;
      }
      return init("poll");
    };
    if (doc.readyState !== "complete") {
      if (doc.createEventObject && root.doScroll) {
        try {
          top = !win.frameElement;
        } catch (_error) {}
        if (top) {
          poll();
        }
      }
      doc[add](pre + "DOMContentLoaded", init, false);
      doc[add](pre + "readystatechange", init, false);
      return win[add](pre + "load", init, false);
    }
  };

  Dropzone._autoDiscoverFunction = function() {
    if (Dropzone.autoDiscover) {
      return Dropzone.discover();
    }
  };

  contentLoaded(window, Dropzone._autoDiscoverFunction);

}).call(this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq"), __webpack_require__("aYag")(module)))

/***/ }),

/***/ "Qlrq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__("yoQO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* eslint-disable func-names, space-before-function-paren, no-var, prefer-rest-params, wrap-iife, no-unused-vars, consistent-return, one-var, one-var-declaration-per-line, quotes, prefer-template, object-shorthand, comma-dangle, no-else-return, no-param-reassign, max-len */



(function () {
  var bind = function bind(fn, me) {
    return function () {
      return fn.apply(me, arguments);
    };
  };

  this.Sidebar = function () {
    function Sidebar(currentUser) {
      this.toggleTodo = bind(this.toggleTodo, this);
      this.sidebar = $('aside');
      this.removeListeners();
      this.addEventListeners();
    }

    Sidebar.prototype.removeListeners = function () {
      this.sidebar.off('click', '.sidebar-collapsed-icon');
      $('.dropdown').off('hidden.gl.dropdown');
      $('.dropdown').off('loading.gl.dropdown');
      $('.dropdown').off('loaded.gl.dropdown');
      $(document).off('click', '.js-sidebar-toggle');
    };

    Sidebar.prototype.addEventListeners = function () {
      var $document = $(document);
      var throttledSetSidebarHeight = _.throttle(this.setSidebarHeight, 10);

      this.sidebar.on('click', '.sidebar-collapsed-icon', this, this.sidebarCollapseClicked);
      $('.dropdown').on('hidden.gl.dropdown', this, this.onSidebarDropdownHidden);
      $('.dropdown').on('loading.gl.dropdown', this.sidebarDropdownLoading);
      $('.dropdown').on('loaded.gl.dropdown', this.sidebarDropdownLoaded);
      $(window).on('resize', function () {
        return throttledSetSidebarHeight();
      });
      $document.on('scroll', function () {
        return throttledSetSidebarHeight();
      });
      $document.on('click', '.js-sidebar-toggle', function (e, triggered) {
        var $allGutterToggleIcons, $this, $thisIcon;
        e.preventDefault();
        $this = $(this);
        $thisIcon = $this.find('i');
        $allGutterToggleIcons = $('.js-sidebar-toggle i');
        if ($thisIcon.hasClass('fa-angle-double-right')) {
          $allGutterToggleIcons.removeClass('fa-angle-double-right').addClass('fa-angle-double-left');
          $('aside.right-sidebar').removeClass('right-sidebar-expanded').addClass('right-sidebar-collapsed');
          $('.page-with-sidebar').removeClass('right-sidebar-expanded').addClass('right-sidebar-collapsed');
        } else {
          $allGutterToggleIcons.removeClass('fa-angle-double-left').addClass('fa-angle-double-right');
          $('aside.right-sidebar').removeClass('right-sidebar-collapsed').addClass('right-sidebar-expanded');
          $('.page-with-sidebar').removeClass('right-sidebar-collapsed').addClass('right-sidebar-expanded');
        }
        if (!triggered) {
          return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set("collapsed_gutter", $('.right-sidebar').hasClass('right-sidebar-collapsed'));
        }
      });
      return $(document).off('click', '.js-issuable-todo').on('click', '.js-issuable-todo', this.toggleTodo);
    };

    Sidebar.prototype.toggleTodo = function (e) {
      var $btnText, $this, $todoLoading, ajaxType, url;
      $this = $(e.currentTarget);
      ajaxType = $this.attr('data-delete-path') ? 'DELETE' : 'POST';
      if ($this.attr('data-delete-path')) {
        url = "" + $this.attr('data-delete-path');
      } else {
        url = "" + $this.data('url');
      }

      $this.tooltip('hide');

      return $.ajax({
        url: url,
        type: ajaxType,
        dataType: 'json',
        data: {
          issuable_id: $this.data('issuable-id'),
          issuable_type: $this.data('issuable-type')
        },
        beforeSend: function (_this) {
          return function () {
            $('.js-issuable-todo').disable().addClass('is-loading');
          };
        }(this)
      }).done(function (_this) {
        return function (data) {
          return _this.todoUpdateDone(data);
        };
      }(this));
    };

    Sidebar.prototype.todoUpdateDone = function (data) {
      var deletePath = data.delete_path ? data.delete_path : null;
      var attrPrefix = deletePath ? 'mark' : 'todo';
      var $todoBtns = $('.js-issuable-todo');

      $(document).trigger('todo:toggle', data.count);

      $todoBtns.each(function (i, el) {
        var $el = $(el);
        var $elText = $el.find('.js-issuable-todo-inner');

        $el.removeClass('is-loading').enable().attr('aria-label', $el.data(attrPrefix + '-text')).attr('data-delete-path', deletePath).attr('title', $el.data(attrPrefix + '-text'));

        if ($el.hasClass('has-tooltip')) {
          $el.tooltip('fixTitle');
        }

        if ($el.data(attrPrefix + '-icon')) {
          $elText.html($el.data(attrPrefix + '-icon'));
        } else {
          $elText.text($el.data(attrPrefix + '-text'));
        }
      });
    };

    Sidebar.prototype.sidebarDropdownLoading = function (e) {
      var $loading, $sidebarCollapsedIcon, i, img;
      $sidebarCollapsedIcon = $(this).closest('.block').find('.sidebar-collapsed-icon');
      img = $sidebarCollapsedIcon.find('img');
      i = $sidebarCollapsedIcon.find('i');
      $loading = $('<i class="fa fa-spinner fa-spin"></i>');
      if (img.length) {
        img.before($loading);
        return img.hide();
      } else if (i.length) {
        i.before($loading);
        return i.hide();
      }
    };

    Sidebar.prototype.sidebarDropdownLoaded = function (e) {
      var $sidebarCollapsedIcon, i, img;
      $sidebarCollapsedIcon = $(this).closest('.block').find('.sidebar-collapsed-icon');
      img = $sidebarCollapsedIcon.find('img');
      $sidebarCollapsedIcon.find('i.fa-spin').remove();
      i = $sidebarCollapsedIcon.find('i');
      if (img.length) {
        return img.show();
      } else {
        return i.show();
      }
    };

    Sidebar.prototype.sidebarCollapseClicked = function (e) {
      var $block, sidebar;
      if ($(e.currentTarget).hasClass('dont-change-state')) {
        return;
      }
      sidebar = e.data;
      e.preventDefault();
      $block = $(this).closest('.block');
      return sidebar.openDropdown($block);
    };

    Sidebar.prototype.openDropdown = function (blockOrName) {
      var $block;
      $block = _.isString(blockOrName) ? this.getBlock(blockOrName) : blockOrName;
      $block.find('.edit-link').trigger('click');
      if (!this.isOpen()) {
        this.setCollapseAfterUpdate($block);
        return this.toggleSidebar('open');
      }
    };

    Sidebar.prototype.setCollapseAfterUpdate = function ($block) {
      $block.addClass('collapse-after-update');
      return $('.page-with-sidebar').addClass('with-overlay');
    };

    Sidebar.prototype.onSidebarDropdownHidden = function (e) {
      var $block, sidebar;
      sidebar = e.data;
      e.preventDefault();
      $block = $(this).closest('.block');
      return sidebar.sidebarDropdownHidden($block);
    };

    Sidebar.prototype.sidebarDropdownHidden = function ($block) {
      if ($block.hasClass('collapse-after-update')) {
        $block.removeClass('collapse-after-update');
        $('.page-with-sidebar').removeClass('with-overlay');
        return this.toggleSidebar('hide');
      }
    };

    Sidebar.prototype.triggerOpenSidebar = function () {
      return this.sidebar.find('.js-sidebar-toggle').trigger('click');
    };

    Sidebar.prototype.toggleSidebar = function (action) {
      if (action == null) {
        action = 'toggle';
      }
      if (action === 'toggle') {
        this.triggerOpenSidebar();
      }
      if (action === 'open') {
        if (!this.isOpen()) {
          this.triggerOpenSidebar();
        }
      }
      if (action === 'hide') {
        if (this.isOpen()) {
          return this.triggerOpenSidebar();
        }
      }
    };

    Sidebar.prototype.setSidebarHeight = function () {
      var $navHeight = $('.navbar-gitlab').outerHeight() + $('.layout-nav').outerHeight() + $('.sub-nav-scroll').outerHeight();
      var $rightSidebar = $('.js-right-sidebar');
      var diff = $navHeight - $(window).scrollTop();
      if (diff > 0) {
        $rightSidebar.outerHeight($(window).height() - diff);
      } else {
        $rightSidebar.outerHeight('100%');
      }
    };

    Sidebar.prototype.isOpen = function () {
      return this.sidebar.is('.right-sidebar-expanded');
    };

    Sidebar.prototype.getBlock = function (name) {
      return this.sidebar.find(".block." + name);
    };

    return Sidebar;
  }();
}).call(window);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("lwLq")))

/***/ }),

/***/ "QzBj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var lineNumberRe = /^L[0-9]+/;

var updateLineNumbersOnBlobPermalinks = function updateLineNumbersOnBlobPermalinks(linksToUpdate) {
  var hash = gl.utils.getLocationHash();
  if (hash && lineNumberRe.test(hash)) {
    var hashUrlString = '#' + hash;

    [].concat(Array.prototype.slice.call(linksToUpdate)).forEach(function (permalinkButton) {
      var baseHref = permalinkButton.getAttribute('data-original-href') || function () {
        var href = permalinkButton.getAttribute('href');
        permalinkButton.setAttribute('data-original-href', href);
        return href;
      }();
      permalinkButton.setAttribute('href', '' + baseHref + hashUrlString);
    });
  }
};

function BlobLinePermalinkUpdater(blobContentHolder, lineNumberSelector, elementsToUpdate) {
  var updateBlameAndBlobPermalinkCb = function updateBlameAndBlobPermalinkCb() {
    // Wait for the hash to update from the LineHighlighter callback
    setTimeout(function () {
      updateLineNumbersOnBlobPermalinks(elementsToUpdate);
    }, 0);
  };

  blobContentHolder.addEventListener('click', function (e) {
    if (e.target.matches(lineNumberSelector)) {
      updateBlameAndBlobPermalinkCb();
    }
  });
  updateBlameAndBlobPermalinkCb();
}

/* harmony default export */ __webpack_exports__["a"] = (BlobLinePermalinkUpdater);

/***/ }),

/***/ "RsTm":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, wrap-iife, no-var, no-unused-expressions, no-param-reassign, no-else-return, quotes, object-shorthand, comma-dangle, camelcase, one-var, vars-on-top, one-var-declaration-per-line, no-return-assign, consistent-return, max-len, prefer-template */
(function () {
  (function (w) {
    var base;
    var faviconEl = document.getElementById('favicon');
    var originalFavicon = faviconEl ? faviconEl.getAttribute('href') : null;
    w.gl || (w.gl = {});
    (base = w.gl).utils || (base.utils = {});
    w.gl.utils.isInGroupsPage = function () {
      return gl.utils.getPagePath() === 'groups';
    };
    w.gl.utils.isInProjectPage = function () {
      return gl.utils.getPagePath() === 'projects';
    };
    w.gl.utils.getProjectSlug = function () {
      if (this.isInProjectPage()) {
        return $('body').data('project');
      } else {
        return null;
      }
    };
    w.gl.utils.getGroupSlug = function () {
      if (this.isInGroupsPage()) {
        return $('body').data('group');
      } else {
        return null;
      }
    };

    w.gl.utils.ajaxGet = function (url) {
      return $.ajax({
        type: "GET",
        url: url,
        dataType: "script"
      });
    };

    w.gl.utils.extractLast = function (term) {
      return this.split(term).pop();
    };

    w.gl.utils.rstrip = function rstrip(val) {
      if (val) {
        return val.replace(/\s+$/, '');
      } else {
        return val;
      }
    };

    w.gl.utils.disableButtonIfEmptyField = function (field_selector, button_selector, event_name) {
      event_name = event_name || 'input';
      var closest_submit, field, that;
      that = this;
      field = $(field_selector);
      closest_submit = field.closest('form').find(button_selector);
      if (this.rstrip(field.val()) === "") {
        closest_submit.disable();
      }
      return field.on(event_name, function () {
        if (that.rstrip($(this).val()) === "") {
          return closest_submit.disable();
        } else {
          return closest_submit.enable();
        }
      });
    };

    // automatically adjust scroll position for hash urls taking the height of the navbar into account
    // https://github.com/twitter/bootstrap/issues/1768
    w.gl.utils.handleLocationHash = function () {
      var hash = w.gl.utils.getLocationHash();
      if (!hash) return;

      // This is required to handle non-unicode characters in hash
      hash = decodeURIComponent(hash);

      // scroll to user-generated markdown anchor if we cannot find a match
      if (document.getElementById(hash) === null) {
        var target = document.getElementById('user-content-' + hash);
        if (target && target.scrollIntoView) {
          target.scrollIntoView(true);
        }
      } else {
        // only adjust for fixedTabs when not targeting user-generated content
        var fixedTabs = document.querySelector('.js-tabs-affix');
        if (fixedTabs) {
          window.scrollBy(0, -fixedTabs.offsetHeight);
        }
      }
    };

    // Check if element scrolled into viewport from above or below
    // Courtesy http://stackoverflow.com/a/7557433/414749
    w.gl.utils.isInViewport = function (el) {
      var rect = el.getBoundingClientRect();

      return rect.top >= 0 && rect.left >= 0 && rect.bottom <= window.innerHeight && rect.right <= window.innerWidth;
    };

    gl.utils.getPagePath = function (index) {
      index = index || 0;
      return $('body').data('page').split(':')[index];
    };

    gl.utils.parseUrl = function (url) {
      var parser = document.createElement('a');
      parser.href = url;
      return parser;
    };

    gl.utils.parseUrlPathname = function (url) {
      var parsedUrl = gl.utils.parseUrl(url);
      // parsedUrl.pathname will return an absolute path for Firefox and a relative path for IE11
      // We have to make sure we always have an absolute path.
      return parsedUrl.pathname.charAt(0) === '/' ? parsedUrl.pathname : '/' + parsedUrl.pathname;
    };

    gl.utils.getUrlParamsArray = function () {
      // We can trust that each param has one & since values containing & will be encoded
      // Remove the first character of search as it is always ?
      return window.location.search.slice(1).split('&');
    };

    gl.utils.isMetaKey = function (e) {
      return e.metaKey || e.ctrlKey || e.altKey || e.shiftKey;
    };

    gl.utils.isMetaClick = function (e) {
      // Identify following special clicks
      // 1) Cmd + Click on Mac (e.metaKey)
      // 2) Ctrl + Click on PC (e.ctrlKey)
      // 3) Middle-click or Mouse Wheel Click (e.which is 2)
      return e.metaKey || e.ctrlKey || e.which === 2;
    };

    gl.utils.scrollToElement = function ($el) {
      var top = $el.offset().top;
      gl.mrTabsHeight = gl.mrTabsHeight || $('.merge-request-tabs').height();

      return $('body, html').animate({
        scrollTop: top - gl.mrTabsHeight
      }, 200);
    };

    /**
      this will take in the `name` of the param you want to parse in the url
      if the name does not exist this function will return `null`
      otherwise it will return the value of the param key provided
    */
    w.gl.utils.getParameterByName = function (name) {
      var url = window.location.href;
      name = name.replace(/[[\]]/g, '\\$&');
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
      var results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    };

    w.gl.utils.getSelectedFragment = function () {
      var selection = window.getSelection();
      if (selection.rangeCount === 0) return null;
      var documentFragment = selection.getRangeAt(0).cloneContents();
      if (documentFragment.textContent.length === 0) return null;

      return documentFragment;
    };

    w.gl.utils.insertText = function (target, text) {
      // Firefox doesn't support `document.execCommand('insertText', false, text)` on textareas

      var selectionStart = target.selectionStart;
      var selectionEnd = target.selectionEnd;
      var value = target.value;

      var textBefore = value.substring(0, selectionStart);
      var textAfter = value.substring(selectionEnd, value.length);
      var newText = textBefore + text + textAfter;

      target.value = newText;
      target.selectionStart = target.selectionEnd = selectionStart + text.length;

      // Trigger autosave
      $(target).trigger('input');

      // Trigger autosize
      var event = document.createEvent('Event');
      event.initEvent('autosize:update', true, false);
      target.dispatchEvent(event);
    };

    w.gl.utils.nodeMatchesSelector = function (node, selector) {
      var matches = Element.prototype.matches || Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector;

      if (matches) {
        return matches.call(node, selector);
      }

      // IE11 doesn't support `node.matches(selector)`

      var parentNode = node.parentNode;
      if (!parentNode) {
        parentNode = document.createElement('div');
        node = node.cloneNode(true);
        parentNode.appendChild(node);
      }

      var matchingNodes = parentNode.querySelectorAll(selector);
      return Array.prototype.indexOf.call(matchingNodes, node) !== -1;
    };

    /**
      this will take in the headers from an API response and normalize them
      this way we don't run into production issues when nginx gives us lowercased header keys
    */
    w.gl.utils.normalizeHeaders = function (headers) {
      var upperCaseHeaders = {};

      Object.keys(headers).forEach(function (e) {
        upperCaseHeaders[e.toUpperCase()] = headers[e];
      });

      return upperCaseHeaders;
    };

    /**
      this will take in the getAllResponseHeaders result and normalize them
      this way we don't run into production issues when nginx gives us lowercased header keys
    */
    w.gl.utils.normalizeCRLFHeaders = function (headers) {
      var headersObject = {};
      var headersArray = headers.split('\n');

      headersArray.forEach(function (header) {
        var keyValue = header.split(': ');
        headersObject[keyValue[0]] = keyValue[1];
      });

      return w.gl.utils.normalizeHeaders(headersObject);
    };

    /**
     * Parses pagination object string values into numbers.
     *
     * @param {Object} paginationInformation
     * @returns {Object}
     */
    w.gl.utils.parseIntPagination = function (paginationInformation) {
      return {
        perPage: parseInt(paginationInformation['X-PER-PAGE'], 10),
        page: parseInt(paginationInformation['X-PAGE'], 10),
        total: parseInt(paginationInformation['X-TOTAL'], 10),
        totalPages: parseInt(paginationInformation['X-TOTAL-PAGES'], 10),
        nextPage: parseInt(paginationInformation['X-NEXT-PAGE'], 10),
        previousPage: parseInt(paginationInformation['X-PREV-PAGE'], 10)
      };
    };

    /**
     * Updates the search parameter of a URL given the parameter and value provided.
     *
     * If no search params are present we'll add it.
     * If param for page is already present, we'll update it
     * If there are params but not for the given one, we'll add it at the end.
     * Returns the new search parameters.
     *
     * @param {String} param
     * @param {Number|String|Undefined|Null} value
     * @return {String}
     */
    w.gl.utils.setParamInURL = function (param, value) {
      var search = void 0;
      var locationSearch = window.location.search;

      if (locationSearch.length) {
        var parameters = locationSearch.substring(1, locationSearch.length).split('&').reduce(function (acc, element) {
          var val = element.split('=');
          acc[val[0]] = decodeURIComponent(val[1]);
          return acc;
        }, {});

        parameters[param] = value;

        var _toString = Object.keys(parameters).map(function (val) {
          return val + '=' + encodeURIComponent(parameters[val]);
        }).join('&');

        search = '?' + _toString;
      } else {
        search = '?' + param + '=' + value;
      }

      return search;
    };

    /**
     * Converts permission provided as strings to booleans.
     *
     * @param  {String} string
     * @returns {Boolean}
     */
    w.gl.utils.convertPermissionToBoolean = function (permission) {
      return permission === 'true';
    };

    /**
     * Back Off exponential algorithm
     * backOff :: (Function<next, stop>, Number) -> Promise<Any, Error>
     *
     * @param {Function<next, stop>} fn function to be called
     * @param {Number} timeout
     * @return {Promise<Any, Error>}
     * @example
     * ```
     *  backOff(function (next, stop) {
     *    // Let's perform this function repeatedly for 60s or for the timeout provided.
     *
     *    ourFunction()
     *      .then(function (result) {
     *        // continue if result is not what we need
     *        next();
     *
     *        // when result is what we need let's stop with the repetions and jump out of the cycle
     *        stop(result);
     *      })
     *      .catch(function (error) {
     *        // if there is an error, we need to stop this with an error.
     *        stop(error);
     *      })
     *  }, 60000)
     *  .then(function (result) {})
     *  .catch(function (error) {
     *    // deal with errors passed to stop()
     *  })
     * ```
     */
    w.gl.utils.backOff = function (fn) {
      var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 60000;

      var maxInterval = 32000;
      var nextInterval = 2000;

      var startTime = Date.now();

      return new Promise(function (resolve, reject) {
        var stop = function stop(arg) {
          return arg instanceof Error ? reject(arg) : resolve(arg);
        };

        var next = function next() {
          if (Date.now() - startTime < timeout) {
            setTimeout(fn.bind(null, next, stop), nextInterval);
            nextInterval = Math.min(nextInterval + nextInterval, maxInterval);
          } else {
            reject(new Error('BACKOFF_TIMEOUT'));
          }
        };

        fn(next, stop);
      });
    };

    w.gl.utils.setFavicon = function (faviconPath) {
      if (faviconEl && faviconPath) {
        faviconEl.setAttribute('href', faviconPath);
      }
    };

    w.gl.utils.resetFavicon = function () {
      if (faviconEl) {
        faviconEl.setAttribute('href', originalFavicon);
      }
    };

    w.gl.utils.setCiStatusFavicon = function (pageUrl) {
      $.ajax({
        url: pageUrl,
        dataType: 'json',
        success: function success(data) {
          if (data && data.favicon) {
            gl.utils.setFavicon(data.favicon);
          } else {
            gl.utils.resetFavicon();
          }
        },
        error: function error() {
          gl.utils.resetFavicon();
        }
      });
    };
  })(window);
}).call(window);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "S1Cs":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable func-names, space-before-function-paren, prefer-arrow-callback, comma-dangle, prefer-template, quotes, no-param-reassign, wrap-iife, max-len */
/* global Api */

var CreateLabelDropdown = function () {
  function CreateLabelDropdown($el, namespacePath, projectPath) {
    _classCallCheck(this, CreateLabelDropdown);

    this.$el = $el;
    this.namespacePath = namespacePath;
    this.projectPath = projectPath;
    this.$dropdownBack = $('.dropdown-menu-back', this.$el.closest('.dropdown'));
    this.$cancelButton = $('.js-cancel-label-btn', this.$el);
    this.$newLabelField = $('#new_label_name', this.$el);
    this.$newColorField = $('#new_label_color', this.$el);
    this.$colorPreview = $('.js-dropdown-label-color-preview', this.$el);
    this.$newLabelError = $('.js-label-error', this.$el);
    this.$newLabelCreateButton = $('.js-new-label-btn', this.$el);
    this.$colorSuggestions = $('.suggest-colors-dropdown a', this.$el);

    this.$newLabelError.hide();
    this.$newLabelCreateButton.disable();

    this.cleanBinding();
    this.addBinding();
  }

  _createClass(CreateLabelDropdown, [{
    key: 'cleanBinding',
    value: function cleanBinding() {
      this.$colorSuggestions.off('click');
      this.$newLabelField.off('keyup change');
      this.$newColorField.off('keyup change');
      this.$dropdownBack.off('click');
      this.$cancelButton.off('click');
      this.$newLabelCreateButton.off('click');
    }
  }, {
    key: 'addBinding',
    value: function addBinding() {
      var self = this;

      this.$colorSuggestions.on('click', function (e) {
        var $this = $(this);
        self.addColorValue(e, $this);
      });

      this.$newLabelField.on('keyup change', this.enableLabelCreateButton.bind(this));
      this.$newColorField.on('keyup change', this.enableLabelCreateButton.bind(this));

      this.$dropdownBack.on('click', this.resetForm.bind(this));

      this.$cancelButton.on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        self.resetForm();
        self.$dropdownBack.trigger('click');
      });

      this.$newLabelCreateButton.on('click', this.saveLabel.bind(this));
    }
  }, {
    key: 'addColorValue',
    value: function addColorValue(e, $this) {
      e.preventDefault();
      e.stopPropagation();

      this.$newColorField.val($this.data('color')).trigger('change');
      this.$colorPreview.css('background-color', $this.data('color')).parent().addClass('is-active');
    }
  }, {
    key: 'enableLabelCreateButton',
    value: function enableLabelCreateButton() {
      if (this.$newLabelField.val() !== '' && this.$newColorField.val() !== '') {
        this.$newLabelError.hide();
        this.$newLabelCreateButton.enable();
      } else {
        this.$newLabelCreateButton.disable();
      }
    }
  }, {
    key: 'resetForm',
    value: function resetForm() {
      this.$newLabelField.val('').trigger('change');

      this.$newColorField.val('').trigger('change');

      this.$colorPreview.css('background-color', '').parent().removeClass('is-active');
    }
  }, {
    key: 'saveLabel',
    value: function saveLabel(e) {
      var _this = this;

      e.preventDefault();
      e.stopPropagation();

      Api.newLabel(this.namespacePath, this.projectPath, {
        title: this.$newLabelField.val(),
        color: this.$newColorField.val()
      }, function (label) {
        _this.$newLabelCreateButton.enable();

        if (label.message) {
          var errors = void 0;

          if (typeof label.message === 'string') {
            errors = label.message;
          } else {
            errors = Object.keys(label.message).map(function (key) {
              return gl.text.humanize(key) + ' ' + label.message[key].join(', ');
            }).join("<br/>");
          }

          _this.$newLabelError.html(errors).show();
        } else {
          _this.$dropdownBack.trigger('click');

          $(document).trigger('created.label', label);
        }
      });
    }
  }]);

  return CreateLabelDropdown;
}();

window.gl = window.gl || {};
gl.CreateLabelDropdown = CreateLabelDropdown;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "SSWZ":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, consistent-return, no-var, no-else-return, prefer-arrow-callback, max-len */

// Syntax Highlighter
//
// Applies a syntax highlighting color scheme CSS class to any element with the
// `js-syntax-highlight` class
//
// ### Example Markup
//
//   <div class="js-syntax-highlight"></div>
//
(function () {
  $.fn.syntaxHighlight = function () {
    var $children;

    if ($(this).hasClass('js-syntax-highlight')) {
      // Given the element itself, apply highlighting
      return $(this).addClass(gon.user_color_scheme);
    } else {
      // Given a parent element, recurse to any of its applicable children
      $children = $(this).find('.js-syntax-highlight');
      if ($children.length) {
        return $children.syntaxHighlight();
      }
    }
  };
}).call(window);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "Sl/F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shortcuts_dashboard_navigation__ = __webpack_require__("vckv");
/* eslint-disable func-names, space-before-function-paren, no-var, prefer-rest-params, wrap-iife, quotes, prefer-arrow-callback, consistent-return, object-shorthand, no-unused-vars, one-var, one-var-declaration-per-line, no-else-return, comma-dangle, max-len */
/* global Mousetrap */
/* global findFileURL */


(function () {
  var bind = function bind(fn, me) {
    return function () {
      return fn.apply(me, arguments);
    };
  };

  this.Shortcuts = function () {
    function Shortcuts(skipResetBindings) {
      var _this = this;

      this.onToggleHelp = bind(this.onToggleHelp, this);
      this.enabledHelp = [];
      if (!skipResetBindings) {
        Mousetrap.reset();
      }
      Mousetrap.bind('?', this.onToggleHelp);
      Mousetrap.bind('s', Shortcuts.focusSearch);
      Mousetrap.bind('f', function (e) {
        return _this.focusFilter(e);
      });

      var $globalDropdownMenu = $('.global-dropdown-menu');
      var $globalDropdownToggle = $('.global-dropdown-toggle');

      $('.global-dropdown').on('hide.bs.dropdown', function () {
        $globalDropdownMenu.removeClass('shortcuts');
      });

      Mousetrap.bind('n', function () {
        $globalDropdownMenu.toggleClass('shortcuts');
        $globalDropdownToggle.trigger('click');

        if (!$globalDropdownMenu.is(':visible')) {
          $globalDropdownToggle.blur();
        }
      });

      Mousetrap.bind('shift+t', function () {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-todos');
      });
      Mousetrap.bind('shift+a', function () {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shortcuts_dashboard_navigation__["a" /* default */])('.dashboard-shortcuts-activity');
      });
      Mousetrap.bind('shift+i', function () {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shortcuts_dashboard_navigation__["a" /* default */])('.dashboard-shortcuts-issues');
      });
      Mousetrap.bind('shift+m', function () {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shortcuts_dashboard_navigation__["a" /* default */])('.dashboard-shortcuts-merge_requests');
      });
      Mousetrap.bind('shift+p', function () {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shortcuts_dashboard_navigation__["a" /* default */])('.dashboard-shortcuts-projects');
      });
      Mousetrap.bind('shift+g', function () {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shortcuts_dashboard_navigation__["a" /* default */])('.dashboard-shortcuts-groups');
      });
      Mousetrap.bind('shift+l', function () {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shortcuts_dashboard_navigation__["a" /* default */])('.dashboard-shortcuts-milestones');
      });
      Mousetrap.bind('shift+s', function () {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shortcuts_dashboard_navigation__["a" /* default */])('.dashboard-shortcuts-snippets');
      });

      Mousetrap.bind(['ctrl+shift+p', 'command+shift+p'], this.toggleMarkdownPreview);
      if (typeof findFileURL !== "undefined" && findFileURL !== null) {
        Mousetrap.bind('t', function () {
          return gl.utils.visitUrl(findFileURL);
        });
      }
    }

    Shortcuts.prototype.onToggleHelp = function (e) {
      e.preventDefault();
      return Shortcuts.toggleHelp(this.enabledHelp);
    };

    Shortcuts.prototype.toggleMarkdownPreview = function (e) {
      // Check if short-cut was triggered while in Write Mode
      if ($(e.target).hasClass('js-note-text')) {
        $('.js-md-preview-button').focus();
      }
      return $(document).triggerHandler('markdown-preview:toggle', [e]);
    };

    Shortcuts.toggleHelp = function (location) {
      var $modal;
      $modal = $('#modal-shortcuts');
      if ($modal.length) {
        $modal.modal('toggle');
        return;
      }
      return $.ajax({
        url: gon.shortcuts_path,
        dataType: 'script',
        success: function success(e) {
          var i, l, len, results;
          if (location && location.length > 0) {
            results = [];
            for (i = 0, len = location.length; i < len; i += 1) {
              l = location[i];
              results.push($(l).show());
            }
            return results;
          } else {
            $('.hidden-shortcut').show();
            return $('.js-more-help-button').remove();
          }
        }
      });
    };

    Shortcuts.prototype.focusFilter = function (e) {
      if (this.filterInput == null) {
        this.filterInput = $('input[type=search]', '.nav-controls');
      }
      this.filterInput.focus();
      return e.preventDefault();
    };

    Shortcuts.focusSearch = function (e) {
      $('#search').focus();
      return e.preventDefault();
    };

    return Shortcuts;
  }();

  $(document).on('click.more_help', '.js-more-help-button', function (e) {
    $(this).remove();
    $('.hidden-shortcut').show();
    return e.preventDefault();
  });

  Mousetrap.stopCallback = function () {
    var defaultStopCallback;
    defaultStopCallback = Mousetrap.stopCallback;
    return function (e, element, combo) {
      // allowed shortcuts if textarea, input, contenteditable are focused
      if (['ctrl+shift+p', 'command+shift+p'].indexOf(combo) !== -1) {
        return false;
      } else {
        return defaultStopCallback.apply(this, arguments);
      }
    };
  }();
}).call(window);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("lwLq")))

/***/ }),

/***/ "TA5E":
/***/ (function(module, exports) {

/* eslint-disable func-names, space-before-function-paren, wrap-iife */
(function () {
  this.U2FUtil = function () {
    function U2FUtil() {}

    U2FUtil.isU2FSupported = function () {
      return window.u2f;
    };

    return U2FUtil;
  }();
}).call(window);

/***/ }),

/***/ "TWsL":
/***/ (function(module, exports) {

/* eslint-disable func-names, space-before-function-paren, wrap-iife, no-var, no-param-reassign, no-cond-assign, no-return-assign, max-len */
(function () {
  (function (w) {
    var base;
    if (w.gl == null) {
      w.gl = {};
    }
    if ((base = w.gl).utils == null) {
      base.utils = {};
    }
    return w.gl.utils.isObject = function (obj) {
      return obj != null && obj.constructor === Object;
    };
  })(window);
}).call(window);

/***/ }),

/***/ "Tzl9":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable wrap-iife, func-names, space-before-function-paren, comma-dangle, prefer-template, consistent-return, class-methods-use-this, arrow-body-style, no-unused-vars, no-underscore-dangle, no-new, max-len, no-sequences, no-unused-expressions, no-param-reassign */
/* global dateFormat */
/* global Pikaday */

var DueDateSelect = function () {
  function DueDateSelect() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        $dropdown = _ref.$dropdown,
        $loading = _ref.$loading;

    _classCallCheck(this, DueDateSelect);

    var $dropdownParent = $dropdown.closest('.dropdown');
    var $block = $dropdown.closest('.block');
    this.$loading = $loading;
    this.$dropdown = $dropdown;
    this.$dropdownParent = $dropdownParent;
    this.$datePicker = $dropdownParent.find('.js-due-date-calendar');
    this.$block = $block;
    this.$selectbox = $dropdown.closest('.selectbox');
    this.$value = $block.find('.value');
    this.$valueContent = $block.find('.value-content');
    this.$sidebarValue = $('.js-due-date-sidebar-value', $block);
    this.fieldName = $dropdown.data('field-name'), this.abilityName = $dropdown.data('ability-name'), this.issueUpdateURL = $dropdown.data('issue-update');

    this.rawSelectedDate = null;
    this.displayedDate = null;
    this.datePayload = null;

    this.initGlDropdown();
    this.initRemoveDueDate();
    this.initDatePicker();
  }

  _createClass(DueDateSelect, [{
    key: 'initGlDropdown',
    value: function initGlDropdown() {
      var _this = this;

      this.$dropdown.glDropdown({
        opened: function opened() {
          var calendar = _this.$datePicker.data('pikaday');
          calendar.show();
        },
        hidden: function hidden() {
          _this.$selectbox.hide();
          _this.$value.css('display', '');
        }
      });
    }
  }, {
    key: 'initDatePicker',
    value: function initDatePicker() {
      var _this2 = this;

      var $dueDateInput = $('input[name=\'' + this.fieldName + '\']');

      var calendar = new Pikaday({
        field: $dueDateInput.get(0),
        theme: 'gitlab-theme',
        format: 'yyyy-mm-dd',
        onSelect: function onSelect(dateText) {
          var formattedDate = dateFormat(new Date(dateText), 'yyyy-mm-dd');

          $dueDateInput.val(formattedDate);

          if (_this2.$dropdown.hasClass('js-issue-boards-due-date')) {
            gl.issueBoards.BoardsStore.detail.issue.dueDate = $dueDateInput.val();
            _this2.updateIssueBoardIssue();
          } else {
            _this2.saveDueDate(true);
          }
        }
      });

      calendar.setDate(new Date($dueDateInput.val()));
      this.$datePicker.append(calendar.el);
      this.$datePicker.data('pikaday', calendar);
    }
  }, {
    key: 'initRemoveDueDate',
    value: function initRemoveDueDate() {
      var _this3 = this;

      this.$block.on('click', '.js-remove-due-date', function (e) {
        var calendar = _this3.$datePicker.data('pikaday');
        e.preventDefault();

        calendar.setDate(null);

        if (_this3.$dropdown.hasClass('js-issue-boards-due-date')) {
          gl.issueBoards.BoardsStore.detail.issue.dueDate = '';
          _this3.updateIssueBoardIssue();
        } else {
          $("input[name='" + _this3.fieldName + "']").val('');
          return _this3.saveDueDate(false);
        }
      });
    }
  }, {
    key: 'saveDueDate',
    value: function saveDueDate(isDropdown) {
      this.parseSelectedDate();
      this.prepSelectedDate();
      this.submitSelectedDate(isDropdown);
    }
  }, {
    key: 'parseSelectedDate',
    value: function parseSelectedDate() {
      this.rawSelectedDate = $('input[name=\'' + this.fieldName + '\']').val();

      if (this.rawSelectedDate.length) {
        // Construct Date object manually to avoid buggy dateString support within Date constructor
        var dateArray = this.rawSelectedDate.split('-').map(function (v) {
          return parseInt(v, 10);
        });
        var dateObj = new Date(dateArray[0], dateArray[1] - 1, dateArray[2]);
        this.displayedDate = dateFormat(dateObj, 'mmm d, yyyy');
      } else {
        this.displayedDate = 'No due date';
      }
    }
  }, {
    key: 'prepSelectedDate',
    value: function prepSelectedDate() {
      var datePayload = {};
      datePayload[this.abilityName] = {};
      datePayload[this.abilityName].due_date = this.rawSelectedDate;
      this.datePayload = datePayload;
    }
  }, {
    key: 'updateIssueBoardIssue',
    value: function updateIssueBoardIssue() {
      var _this4 = this;

      this.$loading.fadeIn();
      this.$dropdown.trigger('loading.gl.dropdown');
      this.$selectbox.hide();
      this.$value.css('display', '');

      gl.issueBoards.BoardsStore.detail.issue.update(this.$dropdown.attr('data-issue-update')).then(function () {
        _this4.$loading.fadeOut();
      });
    }
  }, {
    key: 'submitSelectedDate',
    value: function submitSelectedDate(isDropdown) {
      var _this5 = this;

      return $.ajax({
        type: 'PUT',
        url: this.issueUpdateURL,
        data: this.datePayload,
        dataType: 'json',
        beforeSend: function beforeSend() {
          var selectedDateValue = _this5.datePayload[_this5.abilityName].due_date;
          var displayedDateStyle = _this5.displayedDate !== 'No due date' ? 'bold' : 'no-value';

          _this5.$loading.removeClass('hidden').fadeIn();

          if (isDropdown) {
            _this5.$dropdown.trigger('loading.gl.dropdown');
            _this5.$selectbox.hide();
          }

          _this5.$value.css('display', '');
          _this5.$valueContent.html('<span class=\'' + displayedDateStyle + '\'>' + _this5.displayedDate + '</span>');
          _this5.$sidebarValue.html(_this5.displayedDate);

          return selectedDateValue.length ? $('.js-remove-due-date-holder').removeClass('hidden') : $('.js-remove-due-date-holder').addClass('hidden');
        }
      }).done(function (data) {
        if (isDropdown) {
          _this5.$dropdown.trigger('loaded.gl.dropdown');
          _this5.$dropdown.dropdown('toggle');
        }
        return _this5.$loading.fadeOut();
      });
    }
  }]);

  return DueDateSelect;
}();

var DueDateSelectors = function () {
  function DueDateSelectors() {
    _classCallCheck(this, DueDateSelectors);

    this.initMilestoneDatePicker();
    this.initIssuableSelect();
  }

  _createClass(DueDateSelectors, [{
    key: 'initMilestoneDatePicker',
    value: function initMilestoneDatePicker() {
      $('.datepicker').each(function () {
        var $datePicker = $(this);
        var calendar = new Pikaday({
          field: $datePicker.get(0),
          theme: 'gitlab-theme',
          format: 'yyyy-mm-dd',
          onSelect: function onSelect(dateText) {
            $datePicker.val(dateFormat(new Date(dateText), 'yyyy-mm-dd'));
          }
        });
        calendar.setDate(new Date($datePicker.val()));

        $datePicker.data('pikaday', calendar);
      });

      $('.js-clear-due-date,.js-clear-start-date').on('click', function (e) {
        e.preventDefault();
        var calendar = $(e.target).siblings('.datepicker').data('pikaday');
        calendar.setDate(null);
      });
    }
  }, {
    key: 'initIssuableSelect',
    value: function initIssuableSelect() {
      var $loading = $('.js-issuable-update .due_date').find('.block-loading').hide();

      $('.js-due-date-select').each(function (i, dropdown) {
        var $dropdown = $(dropdown);
        new DueDateSelect({
          $dropdown: $dropdown,
          $loading: $loading
        });
      });
    }
  }]);

  return DueDateSelectors;
}();

window.gl = window.gl || {};
window.gl.DueDateSelectors = DueDateSelectors;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "UK9k":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, wrap-iife, quotes, no-var, one-var, one-var-declaration-per-line, no-useless-escape, max-len */

window.GroupAvatar = function () {
  function GroupAvatar() {
    $('.js-choose-group-avatar-button').on("click", function () {
      var form;
      form = $(this).closest("form");
      return form.find(".js-group-avatar-input").click();
    });
    $('.js-group-avatar-input').on("change", function () {
      var filename, form;
      form = $(this).closest("form");
      filename = $(this).val().replace(/^.*[\\\/]/, '');
      return form.find(".js-avatar-filename").text(filename);
    });
  }

  return GroupAvatar;
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "UQvG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vendor_autosize__ = __webpack_require__("loCD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vendor_autosize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vendor_autosize__);


$(function () {
  var $fields = $('.js-autosize');

  $fields.on('autosize:resized', function resized() {
    var $field = $(this);
    $field.data('height', $field.outerHeight());
  });

  $fields.on('resize.autosize', function resize() {
    var $field = $(this);
    if ($field.data('height') !== $field.outerHeight()) {
      $field.data('height', $field.outerHeight());
      __WEBPACK_IMPORTED_MODULE_0_vendor_autosize___default.a.destroy($field);
      $field.css('max-height', window.outerHeight);
    }
  });

  __WEBPACK_IMPORTED_MODULE_0_vendor_autosize___default()($fields);
  __WEBPACK_IMPORTED_MODULE_0_vendor_autosize___default.a.update($fields);
  $fields.css('resize', 'vertical');
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("lwLq")))

/***/ }),

/***/ "URhJ":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, wrap-iife, camelcase, no-var, one-var, one-var-declaration-per-line, prefer-template, quotes, object-shorthand, comma-dangle, no-unused-vars, prefer-arrow-callback, no-else-return, vars-on-top, no-new, max-len */

(function () {
  window.ImporterStatus = function () {
    function ImporterStatus(jobs_url, import_url) {
      this.jobs_url = jobs_url;
      this.import_url = import_url;
      this.initStatusPage();
      this.setAutoUpdate();
    }

    ImporterStatus.prototype.initStatusPage = function () {
      $('.js-add-to-import').off('click').on('click', function (_this) {
        return function (e) {
          var $btn, $namespace_input, $target_field, $tr, id, target_namespace, newName;
          $btn = $(e.currentTarget);
          $tr = $btn.closest('tr');
          $target_field = $tr.find('.import-target');
          $namespace_input = $target_field.find('.js-select-namespace option:selected');
          id = $tr.attr('id').replace('repo_', '');
          target_namespace = null;
          newName = null;
          if ($namespace_input.length > 0) {
            target_namespace = $namespace_input[0].innerHTML;
            newName = $target_field.find('#path').prop('value');
            $target_field.empty().append(target_namespace + "/" + newName);
          }
          $btn.disable().addClass('is-loading');
          return $.post(_this.import_url, {
            repo_id: id,
            target_namespace: target_namespace,
            new_name: newName
          }, {
            dataType: 'script'
          });
        };
      }(this));
      return $('.js-import-all').off('click').on('click', function (e) {
        var $btn;
        $btn = $(this);
        $btn.disable().addClass('is-loading');
        return $('.js-add-to-import').each(function () {
          return $(this).trigger('click');
        });
      });
    };

    ImporterStatus.prototype.setAutoUpdate = function () {
      return setInterval(function (_this) {
        return function () {
          return $.get(_this.jobs_url, function (data) {
            return $.each(data, function (i, job) {
              var job_item, status_field;
              job_item = $("#project_" + job.id);
              status_field = job_item.find(".job-status");
              if (job.import_status === 'finished') {
                job_item.removeClass("active").addClass("success");
                return status_field.html('<span><i class="fa fa-check"></i> done</span>');
              } else if (job.import_status === 'started') {
                return status_field.html("<i class='fa fa-spinner fa-spin'></i> started");
              } else {
                return status_field.html(job.import_status);
              }
            });
          });
        };
      }(this), 4000);
    };

    return ImporterStatus;
  }();

  $(function () {
    if ($('.js-importer-status').length) {
      var jobsImportPath = $('.js-importer-status').data('jobs-import-path');
      var importPath = $('.js-importer-status').data('import-path');

      new window.ImporterStatus(jobsImportPath, importPath);
    }
  });
}).call(window);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "Uou4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__protected_tag_access_dropdown__ = __webpack_require__("XcYM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__protected_tag_dropdown__ = __webpack_require__("18ib");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var ProtectedTagCreate = function () {
  function ProtectedTagCreate() {
    _classCallCheck(this, ProtectedTagCreate);

    this.$form = $('.js-new-protected-tag');
    this.buildDropdowns();
  }

  _createClass(ProtectedTagCreate, [{
    key: 'buildDropdowns',
    value: function buildDropdowns() {
      var $allowedToCreateDropdown = this.$form.find('.js-allowed-to-create');

      // Cache callback
      this.onSelectCallback = this.onSelect.bind(this);

      // Allowed to Create dropdown
      this.protectedTagAccessDropdown = new __WEBPACK_IMPORTED_MODULE_0__protected_tag_access_dropdown__["a" /* default */]({
        $dropdown: $allowedToCreateDropdown,
        data: gon.create_access_levels,
        onSelect: this.onSelectCallback
      });

      // Select default
      $allowedToCreateDropdown.data('glDropdown').selectRowAtIndex(0);

      // Protected tag dropdown
      this.protectedTagDropdown = new __WEBPACK_IMPORTED_MODULE_1__protected_tag_dropdown__["a" /* default */]({
        $dropdown: this.$form.find('.js-protected-tag-select'),
        onSelect: this.onSelectCallback
      });
    }

    // This will run after clicked callback

  }, {
    key: 'onSelect',
    value: function onSelect() {
      // Enable submit button
      var $tagInput = this.$form.find('input[name="protected_tag[name]"]');
      var $allowedToCreateInput = this.$form.find('#create_access_levels_attributes');

      this.$form.find('input[type="submit"]').attr('disabled', !($tagInput.val() && $allowedToCreateInput.length));
    }
  }]);

  return ProtectedTagCreate;
}();

/* harmony default export */ __webpack_exports__["a"] = (ProtectedTagCreate);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("lwLq")))

/***/ }),

/***/ "UqoV":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable comma-dangle, no-return-assign, one-var, no-var, no-underscore-dangle, one-var-declaration-per-line, no-unused-vars, no-cond-assign, consistent-return, object-shorthand, prefer-arrow-callback, func-names, space-before-function-paren, prefer-template, quotes, class-methods-use-this, no-unused-expressions, no-sequences, wrap-iife, no-lonely-if, no-else-return, no-param-reassign, vars-on-top, max-len */

(function (global) {
  var KEYCODE = {
    ESCAPE: 27,
    BACKSPACE: 8,
    ENTER: 13,
    UP: 38,
    DOWN: 40
  };

  var SearchAutocomplete = function () {
    function SearchAutocomplete() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          wrap = _ref.wrap,
          optsEl = _ref.optsEl,
          autocompletePath = _ref.autocompletePath,
          projectId = _ref.projectId,
          projectRef = _ref.projectRef;

      _classCallCheck(this, SearchAutocomplete);

      this.bindEventContext();
      this.wrap = wrap || $('.search');
      this.optsEl = optsEl || this.wrap.find('.search-autocomplete-opts');
      this.autocompletePath = autocompletePath || this.optsEl.data('autocomplete-path');
      this.projectId = projectId || this.optsEl.data('autocomplete-project-id') || '';
      this.projectRef = projectRef || this.optsEl.data('autocomplete-project-ref') || '';
      this.dropdown = this.wrap.find('.dropdown');
      this.dropdownContent = this.dropdown.find('.dropdown-content');
      this.locationBadgeEl = this.getElement('.location-badge');
      this.scopeInputEl = this.getElement('#scope');
      this.searchInput = this.getElement('.search-input');
      this.projectInputEl = this.getElement('#search_project_id');
      this.groupInputEl = this.getElement('#group_id');
      this.searchCodeInputEl = this.getElement('#search_code');
      this.repositoryInputEl = this.getElement('#repository_ref');
      this.clearInput = this.getElement('.js-clear-input');
      this.saveOriginalState();
      // Only when user is logged in
      if (gon.current_user_id) {
        this.createAutocomplete();
      }
      this.searchInput.addClass('disabled');
      this.saveTextLength();
      this.bindEvents();
    }

    // Finds an element inside wrapper element


    _createClass(SearchAutocomplete, [{
      key: 'bindEventContext',
      value: function bindEventContext() {
        this.onSearchInputBlur = this.onSearchInputBlur.bind(this);
        this.onClearInputClick = this.onClearInputClick.bind(this);
        this.onSearchInputFocus = this.onSearchInputFocus.bind(this);
        this.onSearchInputClick = this.onSearchInputClick.bind(this);
        this.onSearchInputKeyUp = this.onSearchInputKeyUp.bind(this);
        this.onSearchInputKeyDown = this.onSearchInputKeyDown.bind(this);
      }
    }, {
      key: 'getElement',
      value: function getElement(selector) {
        return this.wrap.find(selector);
      }
    }, {
      key: 'saveOriginalState',
      value: function saveOriginalState() {
        return this.originalState = this.serializeState();
      }
    }, {
      key: 'saveTextLength',
      value: function saveTextLength() {
        return this.lastTextLength = this.searchInput.val().length;
      }
    }, {
      key: 'createAutocomplete',
      value: function createAutocomplete() {
        return this.searchInput.glDropdown({
          filterInputBlur: false,
          filterable: true,
          filterRemote: true,
          highlight: true,
          enterCallback: false,
          filterInput: 'input#search',
          search: {
            fields: ['text']
          },
          id: this.getSearchText,
          data: this.getData.bind(this),
          selectable: true,
          clicked: this.onClick.bind(this)
        });
      }
    }, {
      key: 'getSearchText',
      value: function getSearchText(selectedObject, el) {
        return selectedObject.id ? selectedObject.text : '';
      }
    }, {
      key: 'getData',
      value: function getData(term, callback) {
        var _this, contents, jqXHR;
        _this = this;
        if (!term) {
          if (contents = this.getCategoryContents()) {
            this.searchInput.data('glDropdown').filter.options.callback(contents);
            this.enableAutocomplete();
          }
          return;
        }
        // Prevent multiple ajax calls
        if (this.loadingSuggestions) {
          return;
        }
        this.loadingSuggestions = true;
        return jqXHR = $.get(this.autocompletePath, {
          project_id: this.projectId,
          project_ref: this.projectRef,
          term: term
        }, function (response) {
          var data, firstCategory, i, lastCategory, len, suggestion;
          // Hide dropdown menu if no suggestions returns
          if (!response.length) {
            _this.disableAutocomplete();
            return;
          }
          data = [];
          // List results
          firstCategory = true;
          for (i = 0, len = response.length; i < len; i += 1) {
            suggestion = response[i];
            // Add group header before list each group
            if (lastCategory !== suggestion.category) {
              if (!firstCategory) {
                data.push('separator');
              }
              if (firstCategory) {
                firstCategory = false;
              }
              data.push({
                header: suggestion.category
              });
              lastCategory = suggestion.category;
            }
            data.push({
              id: suggestion.category.toLowerCase() + "-" + suggestion.id,
              category: suggestion.category,
              text: suggestion.label,
              url: suggestion.url
            });
          }
          // Add option to proceed with the search
          if (data.length) {
            data.push('separator');
            data.push({
              text: "Result name contains \"" + term + "\"",
              url: "/search?search=" + term + "&project_id=" + _this.projectInputEl.val() + "&group_id=" + _this.groupInputEl.val()
            });
          }
          return callback(data);
        }).always(function () {
          return _this.loadingSuggestions = false;
        });
      }
    }, {
      key: 'getCategoryContents',
      value: function getCategoryContents() {
        var dashboardOptions, groupOptions, issuesPath, items, mrPath, name, options, projectOptions, userId, userName, utils;
        userId = gon.current_user_id;
        userName = gon.current_username;
        utils = gl.utils, projectOptions = gl.projectOptions, groupOptions = gl.groupOptions, dashboardOptions = gl.dashboardOptions;
        if (utils.isInGroupsPage() && groupOptions) {
          options = groupOptions[utils.getGroupSlug()];
        } else if (utils.isInProjectPage() && projectOptions) {
          options = projectOptions[utils.getProjectSlug()];
        } else if (dashboardOptions) {
          options = dashboardOptions;
        }
        issuesPath = options.issuesPath, mrPath = options.mrPath, name = options.name;
        items = [{
          header: "" + name
        }, {
          text: 'Issues assigned to me',
          url: issuesPath + "/?assignee_username=" + userName
        }, {
          text: "Issues I've created",
          url: issuesPath + "/?author_username=" + userName
        }, 'separator', {
          text: 'Merge requests assigned to me',
          url: mrPath + "/?assignee_username=" + userName
        }, {
          text: "Merge requests I've created",
          url: mrPath + "/?author_username=" + userName
        }];
        if (!name) {
          items.splice(0, 1);
        }
        return items;
      }
    }, {
      key: 'serializeState',
      value: function serializeState() {
        return {
          // Search Criteria
          search_project_id: this.projectInputEl.val(),
          group_id: this.groupInputEl.val(),
          search_code: this.searchCodeInputEl.val(),
          repository_ref: this.repositoryInputEl.val(),
          scope: this.scopeInputEl.val(),
          // Location badge
          _location: this.locationBadgeEl.text()
        };
      }
    }, {
      key: 'bindEvents',
      value: function bindEvents() {
        this.searchInput.on('keydown', this.onSearchInputKeyDown);
        this.searchInput.on('keyup', this.onSearchInputKeyUp);
        this.searchInput.on('click', this.onSearchInputClick);
        this.searchInput.on('focus', this.onSearchInputFocus);
        this.searchInput.on('blur', this.onSearchInputBlur);
        this.clearInput.on('click', this.onClearInputClick);
        return this.locationBadgeEl.on('click', function (_this) {
          return function () {
            return _this.searchInput.focus();
          };
        }(this));
      }
    }, {
      key: 'enableAutocomplete',
      value: function enableAutocomplete() {
        var _this;
        // No need to enable anything if user is not logged in
        if (!gon.current_user_id) {
          return;
        }
        if (!this.dropdown.hasClass('open')) {
          _this = this;
          this.loadingSuggestions = false;
          this.dropdown.addClass('open').trigger('shown.bs.dropdown');
          return this.searchInput.removeClass('disabled');
        }
      }

      // Saves last length of the entered text

    }, {
      key: 'onSearchInputKeyDown',
      value: function onSearchInputKeyDown() {
        return this.saveTextLength();
      }
    }, {
      key: 'onSearchInputKeyUp',
      value: function onSearchInputKeyUp(e) {
        switch (e.keyCode) {
          case KEYCODE.BACKSPACE:
            // when trying to remove the location badge
            if (this.lastTextLength === 0 && this.badgePresent()) {
              this.removeLocationBadge();
            }
            // When removing the last character and no badge is present
            if (this.lastTextLength === 1) {
              this.disableAutocomplete();
            }
            // When removing any character from existin value
            if (this.lastTextLength > 1) {
              this.enableAutocomplete();
            }
            break;
          case KEYCODE.ESCAPE:
            this.restoreOriginalState();
            break;
          case KEYCODE.ENTER:
            this.disableAutocomplete();
            break;
          case KEYCODE.UP:
          case KEYCODE.DOWN:
            return;
          default:
            // Handle the case when deleting the input value other than backspace
            // e.g. Pressing ctrl + backspace or ctrl + x
            if (this.searchInput.val() === '') {
              this.disableAutocomplete();
            } else {
              // We should display the menu only when input is not empty
              if (e.keyCode !== KEYCODE.ENTER) {
                this.enableAutocomplete();
              }
            }
        }
        this.wrap.toggleClass('has-value', !!e.target.value);
      }

      // Avoid falsy value to be returned

    }, {
      key: 'onSearchInputClick',
      value: function onSearchInputClick(e) {
        return e.stopImmediatePropagation();
      }
    }, {
      key: 'onSearchInputFocus',
      value: function onSearchInputFocus() {
        this.isFocused = true;
        this.wrap.addClass('search-active');
        if (this.getValue() === '') {
          return this.getData();
        }
      }
    }, {
      key: 'getValue',
      value: function getValue() {
        return this.searchInput.val();
      }
    }, {
      key: 'onClearInputClick',
      value: function onClearInputClick(e) {
        e.preventDefault();
        return this.searchInput.val('').focus();
      }
    }, {
      key: 'onSearchInputBlur',
      value: function onSearchInputBlur(e) {
        this.isFocused = false;
        this.wrap.removeClass('search-active');
        // If input is blank then restore state
        if (this.searchInput.val() === '') {
          return this.restoreOriginalState();
        }
      }
    }, {
      key: 'addLocationBadge',
      value: function addLocationBadge(item) {
        var badgeText, category, value;
        category = item.category != null ? item.category + ": " : '';
        value = item.value != null ? item.value : '';
        badgeText = "" + category + value;
        this.locationBadgeEl.text(badgeText).show();
        return this.wrap.addClass('has-location-badge');
      }
    }, {
      key: 'hasLocationBadge',
      value: function hasLocationBadge() {
        return this.wrap.is('.has-location-badge');
      }
    }, {
      key: 'restoreOriginalState',
      value: function restoreOriginalState() {
        var i, input, inputs, len;
        inputs = Object.keys(this.originalState);
        for (i = 0, len = inputs.length; i < len; i += 1) {
          input = inputs[i];
          this.getElement("#" + input).val(this.originalState[input]);
        }
        if (this.originalState._location === '') {
          return this.locationBadgeEl.hide();
        } else {
          return this.addLocationBadge({
            value: this.originalState._location
          });
        }
      }
    }, {
      key: 'badgePresent',
      value: function badgePresent() {
        return this.locationBadgeEl.length;
      }
    }, {
      key: 'resetSearchState',
      value: function resetSearchState() {
        var i, input, inputs, len, results;
        inputs = Object.keys(this.originalState);
        results = [];
        for (i = 0, len = inputs.length; i < len; i += 1) {
          input = inputs[i];
          // _location isnt a input
          if (input === '_location') {
            break;
          }
          results.push(this.getElement("#" + input).val(''));
        }
        return results;
      }
    }, {
      key: 'removeLocationBadge',
      value: function removeLocationBadge() {
        this.locationBadgeEl.hide();
        this.resetSearchState();
        this.wrap.removeClass('has-location-badge');
        return this.disableAutocomplete();
      }
    }, {
      key: 'disableAutocomplete',
      value: function disableAutocomplete() {
        if (!this.searchInput.hasClass('disabled') && this.dropdown.hasClass('open')) {
          this.searchInput.addClass('disabled');
          this.dropdown.removeClass('open').trigger('hidden.bs.dropdown');
          this.restoreMenu();
        }
      }
    }, {
      key: 'restoreMenu',
      value: function restoreMenu() {
        var html;
        html = "<ul> <li><a class='dropdown-menu-empty-link is-focused'>Loading...</a></li> </ul>";
        return this.dropdownContent.html(html);
      }
    }, {
      key: 'onClick',
      value: function onClick(item, $el, e) {
        if (location.pathname.indexOf(item.url) !== -1) {
          if (!e.metaKey) e.preventDefault();
          if (!this.badgePresent) {
            if (item.category === 'Projects') {
              this.projectInputEl.val(item.id);
              this.addLocationBadge({
                value: 'This project'
              });
            }
            if (item.category === 'Groups') {
              this.groupInputEl.val(item.id);
              this.addLocationBadge({
                value: 'This group'
              });
            }
          }
          $el.removeClass('is-active');
          this.disableAutocomplete();
          return this.searchInput.val('').focus();
        }
      }
    }]);

    return SearchAutocomplete;
  }();

  global.SearchAutocomplete = SearchAutocomplete;

  $(function () {
    var $projectOptionsDataEl = $('.js-search-project-options');
    var $groupOptionsDataEl = $('.js-search-group-options');
    var $dashboardOptionsDataEl = $('.js-search-dashboard-options');

    if ($projectOptionsDataEl.length) {
      gl.projectOptions = gl.projectOptions || {};

      var projectPath = $projectOptionsDataEl.data('project-path');

      gl.projectOptions[projectPath] = {
        name: $projectOptionsDataEl.data('name'),
        issuesPath: $projectOptionsDataEl.data('issues-path'),
        mrPath: $projectOptionsDataEl.data('mr-path')
      };
    }

    if ($groupOptionsDataEl.length) {
      gl.groupOptions = gl.groupOptions || {};

      var groupPath = $groupOptionsDataEl.data('group-path');

      gl.groupOptions[groupPath] = {
        name: $groupOptionsDataEl.data('name'),
        issuesPath: $groupOptionsDataEl.data('issues-path'),
        mrPath: $groupOptionsDataEl.data('mr-path')
      };
    }

    if ($dashboardOptionsDataEl.length) {
      gl.dashboardOptions = {
        issuesPath: $dashboardOptionsDataEl.data('issues-path'),
        mrPath: $dashboardOptionsDataEl.data('mr-path')
      };
    }
  });
})(window.gl || (window.gl = {}));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "Vhgc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BindInOut = function () {
  function BindInOut(bindIn, bindOut) {
    _classCallCheck(this, BindInOut);

    this.in = bindIn;
    this.out = bindOut;

    this.eventWrapper = {};
    this.eventType = /(INPUT|TEXTAREA)/.test(bindIn.tagName) ? 'keyup' : 'change';
  }

  _createClass(BindInOut, [{
    key: 'addEvents',
    value: function addEvents() {
      this.eventWrapper.updateOut = this.updateOut.bind(this);

      this.in.addEventListener(this.eventType, this.eventWrapper.updateOut);

      return this;
    }
  }, {
    key: 'updateOut',
    value: function updateOut() {
      this.out.textContent = this.in.value;

      return this;
    }
  }, {
    key: 'removeEvents',
    value: function removeEvents() {
      this.in.removeEventListener(this.eventType, this.eventWrapper.updateOut);

      return this;
    }
  }], [{
    key: 'initAll',
    value: function initAll() {
      var ins = document.querySelectorAll('*[data-bind-in]');

      return [].map.call(ins, function (anIn) {
        return BindInOut.init(anIn);
      });
    }
  }, {
    key: 'init',
    value: function init(anIn, anOut) {
      var out = anOut || document.querySelector('*[data-bind-out="' + anIn.dataset.bindIn + '"]');

      if (!out) return null;

      var bindInOut = new BindInOut(anIn, out);

      return bindInOut.addEvents().updateOut();
    }
  }]);

  return BindInOut;
}();

/* harmony default export */ __webpack_exports__["a"] = (BindInOut);

/***/ }),

/***/ "VuBo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vendor_clipboard__ = __webpack_require__("hZZT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vendor_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vendor_clipboard__);
/* eslint-disable func-names, space-before-function-paren, one-var, no-var, one-var-declaration-per-line, prefer-template, quotes, no-unused-vars, prefer-arrow-callback, max-len */



var genericError, genericSuccess, showTooltip;

genericSuccess = function genericSuccess(e) {
  showTooltip(e.trigger, 'Copied');
  // Clear the selection and blur the trigger so it loses its border
  e.clearSelection();
  return $(e.trigger).blur();
};

// Safari doesn't support `execCommand`, so instead we inform the user to
// copy manually.
//
// See http://clipboardjs.com/#browser-support
genericError = function genericError(e) {
  var key;
  if (/Mac/i.test(navigator.userAgent)) {
    key = '&#8984;'; // Command
  } else {
    key = 'Ctrl';
  }
  return showTooltip(e.trigger, "Press " + key + "-C to copy");
};

showTooltip = function showTooltip(target, title) {
  var $target = $(target);
  var originalTitle = $target.data('original-title');

  $target.attr('title', 'Copied').tooltip('fixTitle').tooltip('show').attr('title', originalTitle).tooltip('fixTitle');
};

$(function () {
  var clipboard = new __WEBPACK_IMPORTED_MODULE_0_vendor_clipboard___default.a('[data-clipboard-target], [data-clipboard-text]');
  clipboard.on('success', genericSuccess);
  clipboard.on('error', genericError);

  // This a workaround around ClipboardJS limitations to allow the context-specific copy/pasting of plain text or GFM.
  // The Ruby `clipboard_button` helper sneaks a JSON hash with `text` and `gfm` keys into the `data-clipboard-text`
  // attribute that ClipboardJS reads from.
  // When ClipboardJS creates a new `textarea` (directly inside `body`, with a `readonly` attribute`), sets its value
  // to the value of this data attribute, focusses on it, and finally programmatically issues the 'Copy' command,
  // this code intercepts the copy command/event at the last minute to deconstruct this JSON hash and set the
  // `text/plain` and `text/x-gfm` copy data types to the intended values.
  $(document).on('copy', 'body > textarea[readonly]', function (e) {
    var clipboardData = e.originalEvent.clipboardData;
    if (!clipboardData) return;

    var text = e.target.value;

    var json = void 0;
    try {
      json = JSON.parse(text);
    } catch (ex) {
      return;
    }

    if (!json.text || !json.gfm) return;

    e.preventDefault();

    clipboardData.setData('text/plain', json.text);
    clipboardData.setData('text/x-gfm', json.gfm);
  });
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("lwLq")))

/***/ }),

/***/ "XMDg":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, wrap-iife, quotes, no-var, object-shorthand, consistent-return, no-unused-vars, comma-dangle, vars-on-top, prefer-template, max-len */

window.Compare = function () {
  function Compare(opts) {
    this.opts = opts;
    this.source_loading = $(".js-source-loading");
    this.target_loading = $(".js-target-loading");
    $('.js-compare-dropdown').each(function (_this) {
      return function (i, dropdown) {
        var $dropdown;
        $dropdown = $(dropdown);
        return $dropdown.glDropdown({
          selectable: true,
          fieldName: $dropdown.data('field-name'),
          filterable: true,
          id: function id(obj, $el) {
            return $el.data('id');
          },
          toggleLabel: function toggleLabel(obj, $el) {
            return $el.text().trim();
          },
          clicked: function clicked(e, el) {
            if ($dropdown.is('.js-target-branch')) {
              return _this.getTargetHtml();
            } else if ($dropdown.is('.js-source-branch')) {
              return _this.getSourceHtml();
            } else if ($dropdown.is('.js-target-project')) {
              return _this.getTargetProject();
            }
          }
        });
      };
    }(this));
    this.initialState();
  }

  Compare.prototype.initialState = function () {
    this.getSourceHtml();
    return this.getTargetHtml();
  };

  Compare.prototype.getTargetProject = function () {
    return $.ajax({
      url: this.opts.targetProjectUrl,
      data: {
        target_project_id: $("input[name='merge_request[target_project_id]']").val()
      },
      beforeSend: function beforeSend() {
        return $('.mr_target_commit').empty();
      },
      success: function success(html) {
        return $('.js-target-branch-dropdown .dropdown-content').html(html);
      }
    });
  };

  Compare.prototype.getSourceHtml = function () {
    return this.sendAjax(this.opts.sourceBranchUrl, this.source_loading, '.mr_source_commit', {
      ref: $("input[name='merge_request[source_branch]']").val()
    });
  };

  Compare.prototype.getTargetHtml = function () {
    return this.sendAjax(this.opts.targetBranchUrl, this.target_loading, '.mr_target_commit', {
      target_project_id: $("input[name='merge_request[target_project_id]']").val(),
      ref: $("input[name='merge_request[target_branch]']").val()
    });
  };

  Compare.prototype.sendAjax = function (url, loading, target, data) {
    var $target;
    $target = $(target);
    return $.ajax({
      url: url,
      data: data,
      beforeSend: function beforeSend() {
        loading.show();
        return $target.empty();
      },
      success: function success(html) {
        loading.hide();
        $target.html(html);
        var className = '.' + $target[0].className.replace(' ', '.');
        gl.utils.localTimeAgo($('.js-timeago', className));
      }
    });
  };

  return Compare;
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "XcYM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ProtectedTagAccessDropdown = function () {
  function ProtectedTagAccessDropdown(options) {
    _classCallCheck(this, ProtectedTagAccessDropdown);

    this.options = options;
    this.initDropdown();
  }

  _createClass(ProtectedTagAccessDropdown, [{
    key: 'initDropdown',
    value: function initDropdown() {
      var onSelect = this.options.onSelect;

      this.options.$dropdown.glDropdown({
        data: this.options.data,
        selectable: true,
        inputId: this.options.$dropdown.data('input-id'),
        fieldName: this.options.$dropdown.data('field-name'),
        toggleLabel: function toggleLabel(item, $el) {
          if ($el.is('.is-active')) {
            return item.text;
          }
          return 'Select';
        },
        clicked: function clicked(item, $el, e) {
          e.preventDefault();
          onSelect();
        }
      });
    }
  }]);

  return ProtectedTagAccessDropdown;
}();

/* harmony default export */ __webpack_exports__["a"] = (ProtectedTagAccessDropdown);

/***/ }),

/***/ "Xzwk":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, max-len, no-var, one-var, no-restricted-syntax, vars-on-top, no-use-before-define, no-param-reassign, new-cap, no-underscore-dangle, wrap-iife, one-var-declaration-per-line, quotes, prefer-arrow-callback, consistent-return, prefer-template, no-mixed-operators */
/* global Mousetrap */
/* global ShortcutsNavigation */
/* global sidebar */

__webpack_require__("b2AJ");
__webpack_require__("/3Gu");

(function () {
  var extend = function extend(child, parent) {
    for (var key in parent) {
      if (hasProp.call(parent, key)) child[key] = parent[key];
    }function ctor() {
      this.constructor = child;
    }ctor.prototype = parent.prototype;child.prototype = new ctor();child.__super__ = parent.prototype;return child;
  },
      hasProp = {}.hasOwnProperty;

  this.ShortcutsIssuable = function (superClass) {
    extend(ShortcutsIssuable, superClass);

    function ShortcutsIssuable(isMergeRequest) {
      ShortcutsIssuable.__super__.constructor.call(this);
      Mousetrap.bind('a', this.openSidebarDropdown.bind(this, 'assignee'));
      Mousetrap.bind('m', this.openSidebarDropdown.bind(this, 'milestone'));
      Mousetrap.bind('r', function (_this) {
        return function () {
          _this.replyWithSelectedText();
          return false;
        };
      }(this));
      Mousetrap.bind('e', function (_this) {
        return function () {
          _this.editIssue();
          return false;
        };
      }(this));
      Mousetrap.bind('l', this.openSidebarDropdown.bind(this, 'labels'));
      if (isMergeRequest) {
        this.enabledHelp.push('.hidden-shortcut.merge_requests');
      } else {
        this.enabledHelp.push('.hidden-shortcut.issues');
      }
    }

    ShortcutsIssuable.prototype.replyWithSelectedText = function () {
      var quote, documentFragment, selected, separator;
      var replyField = $('.js-main-target-form #note_note');

      documentFragment = window.gl.utils.getSelectedFragment();
      if (!documentFragment) {
        replyField.focus();
        return;
      }

      // If the documentFragment contains more than just Markdown, don't copy as GFM.
      if (documentFragment.querySelector('.md, .wiki')) return;

      selected = window.gl.CopyAsGFM.nodeToGFM(documentFragment);

      if (selected.trim() === "") {
        return;
      }
      quote = _.map(selected.split("\n"), function (val) {
        return ("> " + val).trim() + "\n";
      });
      // If replyField already has some content, add a newline before our quote
      separator = replyField.val().trim() !== "" && "\n\n" || '';
      replyField.val(function (_, current) {
        return current + separator + quote.join('') + "\n";
      });

      // Trigger autosave
      replyField.trigger('input');

      // Trigger autosize
      var event = document.createEvent('Event');
      event.initEvent('autosize:update', true, false);
      replyField.get(0).dispatchEvent(event);

      // Focus the input field
      return replyField.focus();
    };

    ShortcutsIssuable.prototype.editIssue = function () {
      var $editBtn;
      $editBtn = $('.issuable-edit');
      return gl.utils.visitUrl($editBtn.attr('href'));
    };

    ShortcutsIssuable.prototype.openSidebarDropdown = function (name) {
      sidebar.openDropdown(name);
      return false;
    };

    return ShortcutsIssuable;
  }(ShortcutsNavigation);
}).call(window);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "Yr+x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__("yoQO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__breakpoints__ = __webpack_require__("LINv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__breakpoints___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__breakpoints__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flash__ = __webpack_require__("nYQN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__flash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__flash__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable no-new, class-methods-use-this */
/* global Breakpoints */
/* global Flash */





/* eslint-disable max-len */
// MergeRequestTabs
//
// Handles persisting and restoring the current tab selection and lazily-loading
// content on the MergeRequests#show page.
//
// ### Example Markup
//
//   <ul class="nav-links merge-request-tabs">
//     <li class="notes-tab active">
//       <a data-action="notes" data-target="#notes" data-toggle="tab" href="/foo/bar/merge_requests/1">
//         Discussion
//       </a>
//     </li>
//     <li class="commits-tab">
//       <a data-action="commits" data-target="#commits" data-toggle="tab" href="/foo/bar/merge_requests/1/commits">
//         Commits
//       </a>
//     </li>
//     <li class="diffs-tab">
//       <a data-action="diffs" data-target="#diffs" data-toggle="tab" href="/foo/bar/merge_requests/1/diffs">
//         Diffs
//       </a>
//     </li>
//   </ul>
//
//   <div class="tab-content">
//     <div class="notes tab-pane active" id="notes">
//       Notes Content
//     </div>
//     <div class="commits tab-pane" id="commits">
//       Commits Content
//     </div>
//     <div class="diffs tab-pane" id="diffs">
//       Diffs Content
//     </div>
//   </div>
//
//   <div class="mr-loading-status">
//     <div class="loading">
//       Loading Animation
//     </div>
//   </div>
//
/* eslint-enable max-len */

(function () {
  // Store the `location` object, allowing for easier stubbing in tests
  var location = window.location;

  var MergeRequestTabs = function () {
    function MergeRequestTabs() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          action = _ref.action,
          setUrl = _ref.setUrl,
          stubLocation = _ref.stubLocation;

      _classCallCheck(this, MergeRequestTabs);

      this.diffsLoaded = false;
      this.pipelinesLoaded = false;
      this.commitsLoaded = false;
      this.fixedLayoutPref = null;

      this.setUrl = setUrl !== undefined ? setUrl : true;
      this.setCurrentAction = this.setCurrentAction.bind(this);
      this.tabShown = this.tabShown.bind(this);
      this.showTab = this.showTab.bind(this);

      if (stubLocation) {
        location = stubLocation;
      }

      this.bindEvents();
      this.activateTab(action);
      this.initAffix();
    }

    _createClass(MergeRequestTabs, [{
      key: 'bindEvents',
      value: function bindEvents() {
        $(document).on('shown.bs.tab', '.merge-request-tabs a[data-toggle="tab"]', this.tabShown).on('click', '.js-show-tab', this.showTab);

        $('.merge-request-tabs a[data-toggle="tab"]').on('click', this.clickTab);
      }

      // Used in tests

    }, {
      key: 'unbindEvents',
      value: function unbindEvents() {
        $(document).off('shown.bs.tab', '.merge-request-tabs a[data-toggle="tab"]', this.tabShown).off('click', '.js-show-tab', this.showTab);

        $('.merge-request-tabs a[data-toggle="tab"]').off('click', this.clickTab);
      }
    }, {
      key: 'destroyPipelinesView',
      value: function destroyPipelinesView() {
        if (this.commitPipelinesTable) {
          this.commitPipelinesTable.$destroy();
          this.commitPipelinesTable = null;

          document.querySelector('#commit-pipeline-table-view').innerHTML = '';
        }
      }
    }, {
      key: 'showTab',
      value: function showTab(e) {
        e.preventDefault();
        this.activateTab($(e.target).data('action'));
      }
    }, {
      key: 'clickTab',
      value: function clickTab(e) {
        if (e.currentTarget && gl.utils.isMetaClick(e)) {
          var targetLink = e.currentTarget.getAttribute('href');
          e.stopImmediatePropagation();
          e.preventDefault();
          window.open(targetLink, '_blank');
        }
      }
    }, {
      key: 'tabShown',
      value: function tabShown(e) {
        var $target = $(e.target);
        var action = $target.data('action');

        if (action === 'commits') {
          this.loadCommits($target.attr('href'));
          this.expandView();
          this.resetViewContainer();
          this.destroyPipelinesView();
        } else if (this.isDiffAction(action)) {
          this.loadDiff($target.attr('href'));
          if (Breakpoints.get().getBreakpointSize() !== 'lg') {
            this.shrinkView();
          }
          if (this.diffViewType() === 'parallel') {
            this.expandViewContainer();
          }
          this.destroyPipelinesView();
        } else if (action === 'pipelines') {
          this.resetViewContainer();
          this.mountPipelinesView();
        } else {
          this.expandView();
          this.resetViewContainer();
          this.destroyPipelinesView();
        }
        if (this.setUrl) {
          this.setCurrentAction(action);
        }
      }
    }, {
      key: 'scrollToElement',
      value: function scrollToElement(container) {
        if (location.hash) {
          var offset = -$('.js-tabs-affix').outerHeight();
          var $el = $(container + ' ' + location.hash + ':not(.match)');
          if ($el.length) {
            $.scrollTo($el[0], { offset: offset });
          }
        }
      }

      // Activate a tab based on the current action

    }, {
      key: 'activateTab',
      value: function activateTab(action) {
        var activate = action === 'show' ? 'notes' : action;
        // important note: the .tab('show') method triggers 'shown.bs.tab' event itself
        $('.merge-request-tabs a[data-action=\'' + activate + '\']').tab('show');
      }

      // Replaces the current Merge Request-specific action in the URL with a new one
      //
      // If the action is "notes", the URL is reset to the standard
      // `MergeRequests#show` route.
      //
      // Examples:
      //
      //   location.pathname # => "/namespace/project/merge_requests/1"
      //   setCurrentAction('diffs')
      //   location.pathname # => "/namespace/project/merge_requests/1/diffs"
      //
      //   location.pathname # => "/namespace/project/merge_requests/1/diffs"
      //   setCurrentAction('notes')
      //   location.pathname # => "/namespace/project/merge_requests/1"
      //
      //   location.pathname # => "/namespace/project/merge_requests/1/diffs"
      //   setCurrentAction('commits')
      //   location.pathname # => "/namespace/project/merge_requests/1/commits"
      //
      // Returns the new URL String

    }, {
      key: 'setCurrentAction',
      value: function setCurrentAction(action) {
        this.currentAction = action === 'show' ? 'notes' : action;

        // Remove a trailing '/commits' '/diffs' '/pipelines' '/new' '/new/diffs'
        var newState = location.pathname.replace(/\/(commits|diffs|pipelines|new|new\/diffs)(\.html)?\/?$/, '');

        // Append the new action if we're on a tab other than 'notes'
        if (this.currentAction !== 'notes') {
          newState += '/' + this.currentAction;
        }

        // Ensure parameters and hash come along for the ride
        newState += location.search + location.hash;

        // TODO: Consider refactoring in light of turbolinks removal.

        // Replace the current history state with the new one without breaking
        // Turbolinks' history.
        //
        // See https://github.com/rails/turbolinks/issues/363
        window.history.replaceState({
          url: newState
        }, document.title, newState);

        return newState;
      }
    }, {
      key: 'loadCommits',
      value: function loadCommits(source) {
        var _this = this;

        if (this.commitsLoaded) {
          return;
        }
        this.ajaxGet({
          url: source + '.json',
          success: function success(data) {
            document.querySelector('div#commits').innerHTML = data.html;
            gl.utils.localTimeAgo($('.js-timeago', 'div#commits'));
            _this.commitsLoaded = true;
            _this.scrollToElement('#commits');
          }
        });
      }
    }, {
      key: 'mountPipelinesView',
      value: function mountPipelinesView() {
        this.commitPipelinesTable = new gl.CommitPipelinesTable().$mount();
        // $mount(el) replaces the el with the new rendered component. We need it in order to mount
        // it everytime this tab is clicked - https://vuejs.org/v2/api/#vm-mount
        document.querySelector('#commit-pipeline-table-view').appendChild(this.commitPipelinesTable.$el);
      }
    }, {
      key: 'loadDiff',
      value: function loadDiff(source) {
        var _this2 = this;

        if (this.diffsLoaded) {
          return;
        }

        // We extract pathname for the current Changes tab anchor href
        // some pages like MergeRequestsController#new has query parameters on that anchor
        var urlPathname = gl.utils.parseUrlPathname(source);

        this.ajaxGet({
          url: urlPathname + '.json' + location.search,
          success: function success(data) {
            $('#diffs').html(data.html);

            if (typeof gl.diffNotesCompileComponents !== 'undefined') {
              gl.diffNotesCompileComponents();
            }

            gl.utils.localTimeAgo($('.js-timeago', 'div#diffs'));
            $('#diffs .js-syntax-highlight').syntaxHighlight();

            if (_this2.diffViewType() === 'parallel' && _this2.isDiffAction(_this2.currentAction)) {
              _this2.expandViewContainer();
            }
            _this2.diffsLoaded = true;

            new gl.Diff();
            _this2.scrollToElement('#diffs');
          }
        });
      }

      // Show or hide the loading spinner
      //
      // status - Boolean, true to show, false to hide

    }, {
      key: 'toggleLoading',
      value: function toggleLoading(status) {
        $('.mr-loading-status .loading').toggle(status);
      }
    }, {
      key: 'ajaxGet',
      value: function ajaxGet(options) {
        var _this3 = this;

        var defaults = {
          beforeSend: function beforeSend() {
            return _this3.toggleLoading(true);
          },
          error: function error() {
            return new Flash('An error occurred while fetching this tab.', 'alert');
          },
          complete: function complete() {
            return _this3.toggleLoading(false);
          },
          dataType: 'json',
          type: 'GET'
        };
        $.ajax($.extend({}, defaults, options));
      }
    }, {
      key: 'diffViewType',
      value: function diffViewType() {
        return $('.inline-parallel-buttons a.active').data('view-type');
      }
    }, {
      key: 'isDiffAction',
      value: function isDiffAction(action) {
        return action === 'diffs' || action === 'new/diffs';
      }
    }, {
      key: 'expandViewContainer',
      value: function expandViewContainer() {
        var $wrapper = $('.content-wrapper .container-fluid');
        if (this.fixedLayoutPref === null) {
          this.fixedLayoutPref = $wrapper.hasClass('container-limited');
        }
        $wrapper.removeClass('container-limited');
      }
    }, {
      key: 'resetViewContainer',
      value: function resetViewContainer() {
        if (this.fixedLayoutPref !== null) {
          $('.content-wrapper .container-fluid').toggleClass('container-limited', this.fixedLayoutPref);
        }
      }
    }, {
      key: 'shrinkView',
      value: function shrinkView() {
        var $gutterIcon = $('.js-sidebar-toggle i:visible');

        // Wait until listeners are set
        setTimeout(function () {
          // Only when sidebar is expanded
          if ($gutterIcon.is('.fa-angle-double-right')) {
            $gutterIcon.closest('a').trigger('click', [true]);
          }
        }, 0);
      }

      // Expand the issuable sidebar unless the user explicitly collapsed it

    }, {
      key: 'expandView',
      value: function expandView() {
        if (__WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('collapsed_gutter') === 'true') {
          return;
        }
        var $gutterIcon = $('.js-sidebar-toggle i:visible');

        // Wait until listeners are set
        setTimeout(function () {
          // Only when sidebar is collapsed
          if ($gutterIcon.is('.fa-angle-double-left')) {
            $gutterIcon.closest('a').trigger('click', [true]);
          }
        }, 0);
      }
    }, {
      key: 'initAffix',
      value: function initAffix() {
        var $tabs = $('.js-tabs-affix');

        // Screen space on small screens is usually very sparse
        // So we dont affix the tabs on these
        if (Breakpoints.get().getBreakpointSize() === 'xs' || !$tabs.length) return;

        var $diffTabs = $('#diff-notes-app');

        $tabs.off('affix.bs.affix affix-top.bs.affix').affix({
          offset: {
            top: function top() {
              return $diffTabs.offset().top - $tabs.height();
            }
          }
        }).on('affix.bs.affix', function () {
          return $diffTabs.css({ marginTop: $tabs.height() });
        }).on('affix-top.bs.affix', function () {
          return $diffTabs.css({ marginTop: '' });
        });

        // Fix bug when reloading the page already scrolling
        if ($tabs.hasClass('affix')) {
          $tabs.trigger('affix.bs.affix');
        }
      }
    }]);

    return MergeRequestTabs;
  }();

  window.gl = window.gl || {};
  window.gl.MergeRequestTabs = MergeRequestTabs;
})();
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("lwLq")))

/***/ }),

/***/ "ZORs":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Linked Tabs
 *
 * Handles persisting and restores the current tab selection and content.
 * Reusable component for static content.
 *
 * ### Example Markup
 *
 *  <ul class="nav-links tab-links">
 *    <li class="active">
 *      <a data-action="tab1" data-target="#tab1" data-toggle="tab" href="/path/tab1">
 *        Tab 1
 *      </a>
 *    </li>
 *    <li class="groups-tab">
 *      <a data-action="tab2" data-target="#tab2" data-toggle="tab" href="/path/tab2">
 *        Tab 2
 *      </a>
 *    </li>
 *
 *
 *  <div class="tab-content">
 *    <div class="tab-pane" id="tab1">
 *      Tab 1 Content
 *    </div>
 *    <div class="tab-pane" id="tab2">
 *      Tab 2 Content
 *    </div>
 * </div>
 *
 *
 * ### How to use
 *
 *  new window.gl.LinkedTabs({
 *    action: "#{controller.action_name}",
 *    defaultAction: 'tab1',
 *    parentEl: '.tab-links'
 *  });
 */

(function () {
  window.gl = window.gl || {};

  window.gl.LinkedTabs = function () {
    /**
     * Binds the events and activates de default tab.
     *
     * @param  {Object} options
     */
    function LinkedTabs(options) {
      var _this = this;

      _classCallCheck(this, LinkedTabs);

      this.options = options || {};

      this.defaultAction = this.options.defaultAction;
      this.action = this.options.action || this.defaultAction;

      if (this.action === 'show') {
        this.action = this.defaultAction;
      }

      this.currentLocation = window.location;

      var tabSelector = this.options.parentEl + ' a[data-toggle="tab"]';

      // since this is a custom event we need jQuery :(
      $(document).off('shown.bs.tab', tabSelector).on('shown.bs.tab', tabSelector, function (e) {
        return _this.tabShown(e);
      });

      this.activateTab(this.action);
    }

    /**
     * Handles the `shown.bs.tab` event to set the currect url action.
     *
     * @param  {type} evt
     * @return {Function}
     */


    _createClass(LinkedTabs, [{
      key: 'tabShown',
      value: function tabShown(evt) {
        var source = evt.target.getAttribute('href');

        return this.setCurrentAction(source);
      }

      /**
       * Updates the URL with the path that matched the given action.
       *
       * @param  {String} source
       * @return {String}
       */

    }, {
      key: 'setCurrentAction',
      value: function setCurrentAction(source) {
        var copySource = source;

        copySource.replace(/\/+$/, '');

        var newState = '' + copySource + this.currentLocation.search + this.currentLocation.hash;

        history.replaceState({
          url: newState
        }, document.title, newState);
        return newState;
      }

      /**
       * Given the current action activates the correct tab.
       * http://getbootstrap.com/javascript/#tab-show
       * Note: Will trigger `shown.bs.tab`
       */

    }, {
      key: 'activateTab',
      value: function activateTab() {
        return $(this.options.parentEl + ' a[data-action=\'' + this.action + '\']').tab('show');
      }
    }]);

    return LinkedTabs;
  }();
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "ZYhW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__("l+Tn");
/* harmony export (immutable) */ __webpack_exports__["a"] = formatRelevantDigits;
/* harmony export (immutable) */ __webpack_exports__["b"] = bytesToKiB;


/**
 * Function that allows a number with an X amount of decimals
 * to be formatted in the following fashion:
 * * For 1 digit to the left of the decimal point and X digits to the right of it
 * * * Show 3 digits to the right
 * * For 2 digits to the left of the decimal point and X digits to the right of it
 * * * Show 2 digits to the right
*/
function formatRelevantDigits(number) {
  var digitsLeft = '';
  var relevantDigits = 0;
  var formattedNumber = '';
  if (!isNaN(Number(number))) {
    digitsLeft = number.split('.')[0];
    switch (digitsLeft.length) {
      case 1:
        relevantDigits = 3;
        break;
      case 2:
        relevantDigits = 2;
        break;
      case 3:
        relevantDigits = 1;
        break;
      default:
        relevantDigits = 4;
        break;
    }
    formattedNumber = Number(number).toFixed(relevantDigits);
  }
  return formattedNumber;
}

/**
 * Utility function that calculates KiB of the given bytes.
 *
 * @param  {Number} number bytes
 * @return {Number}        KiB
 */
function bytesToKiB(number) {
  return number / __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* BYTES_IN_KIB */];
}

/***/ }),

/***/ "a9uE":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, no-var, prefer-rest-params, wrap-iife, no-use-before-define, no-useless-escape, no-new, quotes, object-shorthand, no-unused-vars, comma-dangle, no-alert, consistent-return, no-else-return, prefer-template, one-var, one-var-declaration-per-line, curly, max-len */
/* global GitLab */
/* global UsersSelect */
/* global ZenMode */
/* global Autosave */
/* global dateFormat */
/* global Pikaday */

(function () {
  var bind = function bind(fn, me) {
    return function () {
      return fn.apply(me, arguments);
    };
  };

  this.IssuableForm = function () {
    IssuableForm.prototype.issueMoveConfirmMsg = 'Are you sure you want to move this issue to another project?';

    IssuableForm.prototype.wipRegex = /^\s*(\[WIP\]\s*|WIP:\s*|WIP\s+)+\s*/i;

    function IssuableForm(form) {
      var $issuableDueDate, calendar;
      this.form = form;
      this.toggleWip = bind(this.toggleWip, this);
      this.renderWipExplanation = bind(this.renderWipExplanation, this);
      this.resetAutosave = bind(this.resetAutosave, this);
      this.handleSubmit = bind(this.handleSubmit, this);
      gl.GfmAutoComplete.setup();
      new UsersSelect();
      new ZenMode();
      this.titleField = this.form.find("input[name*='[title]']");
      this.descriptionField = this.form.find("textarea[name*='[description]']");
      this.issueMoveField = this.form.find("#move_to_project_id");
      if (!(this.titleField.length && this.descriptionField.length)) {
        return;
      }
      this.initAutosave();
      this.form.on("submit", this.handleSubmit);
      this.form.on("click", ".btn-cancel", this.resetAutosave);
      this.initWip();
      this.initMoveDropdown();
      $issuableDueDate = $('#issuable-due-date');
      if ($issuableDueDate.length) {
        calendar = new Pikaday({
          field: $issuableDueDate.get(0),
          theme: 'gitlab-theme',
          format: 'yyyy-mm-dd',
          onSelect: function onSelect(dateText) {
            $issuableDueDate.val(dateFormat(new Date(dateText), 'yyyy-mm-dd'));
          }
        });
        calendar.setDate(new Date($issuableDueDate.val()));
      }
    }

    IssuableForm.prototype.initAutosave = function () {
      new Autosave(this.titleField, [document.location.pathname, document.location.search, "title"]);
      return new Autosave(this.descriptionField, [document.location.pathname, document.location.search, "description"]);
    };

    IssuableForm.prototype.handleSubmit = function () {
      var fieldId = this.issueMoveField != null ? this.issueMoveField.val() : null;
      if ((parseInt(fieldId, 10) || 0) > 0) {
        if (!confirm(this.issueMoveConfirmMsg)) {
          return false;
        }
      }
      return this.resetAutosave();
    };

    IssuableForm.prototype.resetAutosave = function () {
      this.titleField.data("autosave").reset();
      return this.descriptionField.data("autosave").reset();
    };

    IssuableForm.prototype.initWip = function () {
      this.$wipExplanation = this.form.find(".js-wip-explanation");
      this.$noWipExplanation = this.form.find(".js-no-wip-explanation");
      if (!(this.$wipExplanation.length && this.$noWipExplanation.length)) {
        return;
      }
      this.form.on("click", ".js-toggle-wip", this.toggleWip);
      this.titleField.on("keyup blur", this.renderWipExplanation);
      return this.renderWipExplanation();
    };

    IssuableForm.prototype.workInProgress = function () {
      return this.wipRegex.test(this.titleField.val());
    };

    IssuableForm.prototype.renderWipExplanation = function () {
      if (this.workInProgress()) {
        this.$wipExplanation.show();
        return this.$noWipExplanation.hide();
      } else {
        this.$wipExplanation.hide();
        return this.$noWipExplanation.show();
      }
    };

    IssuableForm.prototype.toggleWip = function (event) {
      event.preventDefault();
      if (this.workInProgress()) {
        this.removeWip();
      } else {
        this.addWip();
      }
      return this.renderWipExplanation();
    };

    IssuableForm.prototype.removeWip = function () {
      return this.titleField.val(this.titleField.val().replace(this.wipRegex, ""));
    };

    IssuableForm.prototype.addWip = function () {
      return this.titleField.val("WIP: " + this.titleField.val());
    };

    IssuableForm.prototype.initMoveDropdown = function () {
      var $moveDropdown, pageSize;
      $moveDropdown = $('.js-move-dropdown');
      if ($moveDropdown.length) {
        pageSize = $moveDropdown.data('page-size');
        return $('.js-move-dropdown').select2({
          ajax: {
            url: $moveDropdown.data('projects-url'),
            quietMillis: 125,
            data: function data(term, page, context) {
              return {
                search: term,
                offset_id: context
              };
            },
            results: function results(data) {
              var context, more;

              if (data.length >= pageSize) more = true;

              if (data[data.length - 1]) context = data[data.length - 1].id;

              return {
                results: data,
                more: more,
                context: context
              };
            }
          },
          formatResult: function formatResult(project) {
            return project.name_with_namespace;
          },
          formatSelection: function formatSelection(project) {
            return project.name_with_namespace;
          }
        });
      }
    };

    return IssuableForm;
  }();
}).call(window);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "aWWo":
/***/ (function(module, exports) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint no-param-reassign: ["error", { "props": false }]*/
/* eslint no-new: "off" */
(function (global) {
  /**
   * Memorize the last selected tab after reloading a page.
   * Does that setting the current selected tab in the localStorage
   */
  var ActiveTabMemoizer = function () {
    function ActiveTabMemoizer() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$currentTabKey = _ref.currentTabKey,
          currentTabKey = _ref$currentTabKey === undefined ? 'current_signin_tab' : _ref$currentTabKey,
          _ref$tabSelector = _ref.tabSelector,
          tabSelector = _ref$tabSelector === undefined ? 'ul.nav-tabs' : _ref$tabSelector;

      _classCallCheck(this, ActiveTabMemoizer);

      this.currentTabKey = currentTabKey;
      this.tabSelector = tabSelector;
      this.bootstrap();
    }

    _createClass(ActiveTabMemoizer, [{
      key: 'bootstrap',
      value: function bootstrap() {
        var _this = this;

        var tabs = document.querySelectorAll(this.tabSelector);
        if (tabs.length > 0) {
          tabs[0].addEventListener('click', function (e) {
            if (e.target && e.target.nodeName === 'A') {
              var anchorName = e.target.getAttribute('href');
              _this.saveData(anchorName);
            }
          });
        }

        this.showTab();
      }
    }, {
      key: 'showTab',
      value: function showTab() {
        var anchorName = this.readData();
        if (anchorName) {
          var tab = document.querySelector(this.tabSelector + ' a[href="' + anchorName + '"]');
          if (tab) {
            tab.click();
          }
        }
      }
    }, {
      key: 'saveData',
      value: function saveData(val) {
        localStorage.setItem(this.currentTabKey, val);
      }
    }, {
      key: 'readData',
      value: function readData() {
        return localStorage.getItem(this.currentTabKey);
      }
    }]);

    return ActiveTabMemoizer;
  }();

  global.ActiveTabMemoizer = ActiveTabMemoizer;
})(window);

/***/ }),

/***/ "aYag":
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),

/***/ "awgk":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, wrap-iife, one-var, no-var, one-var-declaration-per-line, no-unused-vars, consistent-return, prefer-arrow-callback, no-else-return, max-len */
/* global Flash */

(function () {
  this.NotificationsDropdown = function () {
    function NotificationsDropdown() {
      $(document).off('click', '.update-notification').on('click', '.update-notification', function (e) {
        var form, label, notificationLevel;
        e.preventDefault();
        if ($(this).is('.is-active') && $(this).data('notification-level') === 'custom') {
          return;
        }
        notificationLevel = $(this).data('notification-level');
        label = $(this).data('notification-title');
        form = $(this).parents('.notification-form:first');
        form.find('.js-notification-loading').toggleClass('fa-bell fa-spin fa-spinner');
        form.find('#notification_setting_level').val(notificationLevel);
        return form.submit();
      });
      $(document).off('ajax:success', '.notification-form').on('ajax:success', '.notification-form', function (e, data) {
        if (data.saved) {
          return $(e.currentTarget).closest('.js-notification-dropdown').replaceWith(data.html);
        } else {
          return new Flash('Failed to save new settings', 'alert');
        }
      });
    }

    return NotificationsDropdown;
  }();
}).call(window);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "b2AJ":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*global define:false */
/**
 * Copyright 2013 Craig Campbell
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Mousetrap is a simple keyboard shortcut library for Javascript with
 * no external dependencies
 *
 * @version 1.4.6
 * @url craig.is/killing/mice
 */
(function(window, document, undefined) {

    /**
     * mapping of special keycodes to their corresponding keys
     *
     * everything in this dictionary cannot use keypress events
     * so it has to be here to map to the correct keycodes for
     * keyup/keydown events
     *
     * @type {Object}
     */
    var _MAP = {
            8: 'backspace',
            9: 'tab',
            13: 'enter',
            16: 'shift',
            17: 'ctrl',
            18: 'alt',
            20: 'capslock',
            27: 'esc',
            32: 'space',
            33: 'pageup',
            34: 'pagedown',
            35: 'end',
            36: 'home',
            37: 'left',
            38: 'up',
            39: 'right',
            40: 'down',
            45: 'ins',
            46: 'del',
            91: 'meta',
            93: 'meta',
            224: 'meta'
        },

        /**
         * mapping for special characters so they can support
         *
         * this dictionary is only used incase you want to bind a
         * keyup or keydown event to one of these keys
         *
         * @type {Object}
         */
        _KEYCODE_MAP = {
            106: '*',
            107: '+',
            109: '-',
            110: '.',
            111 : '/',
            186: ';',
            187: '=',
            188: ',',
            189: '-',
            190: '.',
            191: '/',
            192: '`',
            219: '[',
            220: '\\',
            221: ']',
            222: '\''
        },

        /**
         * this is a mapping of keys that require shift on a US keypad
         * back to the non shift equivelents
         *
         * this is so you can use keyup events with these keys
         *
         * note that this will only work reliably on US keyboards
         *
         * @type {Object}
         */
        _SHIFT_MAP = {
            '~': '`',
            '!': '1',
            '@': '2',
            '#': '3',
            '$': '4',
            '%': '5',
            '^': '6',
            '&': '7',
            '*': '8',
            '(': '9',
            ')': '0',
            '_': '-',
            '+': '=',
            ':': ';',
            '\"': '\'',
            '<': ',',
            '>': '.',
            '?': '/',
            '|': '\\'
        },

        /**
         * this is a list of special strings you can use to map
         * to modifier keys when you specify your keyboard shortcuts
         *
         * @type {Object}
         */
        _SPECIAL_ALIASES = {
            'option': 'alt',
            'command': 'meta',
            'return': 'enter',
            'escape': 'esc',
            'mod': /Mac|iPod|iPhone|iPad/.test(navigator.platform) ? 'meta' : 'ctrl'
        },

        /**
         * variable to store the flipped version of _MAP from above
         * needed to check if we should use keypress or not when no action
         * is specified
         *
         * @type {Object|undefined}
         */
        _REVERSE_MAP,

        /**
         * a list of all the callbacks setup via Mousetrap.bind()
         *
         * @type {Object}
         */
        _callbacks = {},

        /**
         * direct map of string combinations to callbacks used for trigger()
         *
         * @type {Object}
         */
        _directMap = {},

        /**
         * keeps track of what level each sequence is at since multiple
         * sequences can start out with the same sequence
         *
         * @type {Object}
         */
        _sequenceLevels = {},

        /**
         * variable to store the setTimeout call
         *
         * @type {null|number}
         */
        _resetTimer,

        /**
         * temporary state where we will ignore the next keyup
         *
         * @type {boolean|string}
         */
        _ignoreNextKeyup = false,

        /**
         * temporary state where we will ignore the next keypress
         *
         * @type {boolean}
         */
        _ignoreNextKeypress = false,

        /**
         * are we currently inside of a sequence?
         * type of action ("keyup" or "keydown" or "keypress") or false
         *
         * @type {boolean|string}
         */
        _nextExpectedAction = false;

    /**
     * loop through the f keys, f1 to f19 and add them to the map
     * programatically
     */
    for (var i = 1; i < 20; ++i) {
        _MAP[111 + i] = 'f' + i;
    }

    /**
     * loop through to map numbers on the numeric keypad
     */
    for (i = 0; i <= 9; ++i) {
        _MAP[i + 96] = i;
    }

    /**
     * cross browser add event method
     *
     * @param {Element|HTMLDocument} object
     * @param {string} type
     * @param {Function} callback
     * @returns void
     */
    function _addEvent(object, type, callback) {
        if (object.addEventListener) {
            object.addEventListener(type, callback, false);
            return;
        }

        object.attachEvent('on' + type, callback);
    }

    /**
     * takes the event and returns the key character
     *
     * @param {Event} e
     * @return {string}
     */
    function _characterFromEvent(e) {

        // for keypress events we should return the character as is
        if (e.type == 'keypress') {
            var character = String.fromCharCode(e.which);

            // if the shift key is not pressed then it is safe to assume
            // that we want the character to be lowercase.  this means if
            // you accidentally have caps lock on then your key bindings
            // will continue to work
            //
            // the only side effect that might not be desired is if you
            // bind something like 'A' cause you want to trigger an
            // event when capital A is pressed caps lock will no longer
            // trigger the event.  shift+a will though.
            if (!e.shiftKey) {
                character = character.toLowerCase();
            }

            return character;
        }

        // for non keypress events the special maps are needed
        if (_MAP[e.which]) {
            return _MAP[e.which];
        }

        if (_KEYCODE_MAP[e.which]) {
            return _KEYCODE_MAP[e.which];
        }

        // if it is not in the special map

        // with keydown and keyup events the character seems to always
        // come in as an uppercase character whether you are pressing shift
        // or not.  we should make sure it is always lowercase for comparisons
        return String.fromCharCode(e.which).toLowerCase();
    }

    /**
     * checks if two arrays are equal
     *
     * @param {Array} modifiers1
     * @param {Array} modifiers2
     * @returns {boolean}
     */
    function _modifiersMatch(modifiers1, modifiers2) {
        return modifiers1.sort().join(',') === modifiers2.sort().join(',');
    }

    /**
     * resets all sequence counters except for the ones passed in
     *
     * @param {Object} doNotReset
     * @returns void
     */
    function _resetSequences(doNotReset) {
        doNotReset = doNotReset || {};

        var activeSequences = false,
            key;

        for (key in _sequenceLevels) {
            if (doNotReset[key]) {
                activeSequences = true;
                continue;
            }
            _sequenceLevels[key] = 0;
        }

        if (!activeSequences) {
            _nextExpectedAction = false;
        }
    }

    /**
     * finds all callbacks that match based on the keycode, modifiers,
     * and action
     *
     * @param {string} character
     * @param {Array} modifiers
     * @param {Event|Object} e
     * @param {string=} sequenceName - name of the sequence we are looking for
     * @param {string=} combination
     * @param {number=} level
     * @returns {Array}
     */
    function _getMatches(character, modifiers, e, sequenceName, combination, level) {
        var i,
            callback,
            matches = [],
            action = e.type;

        // if there are no events related to this keycode
        if (!_callbacks[character]) {
            return [];
        }

        // if a modifier key is coming up on its own we should allow it
        if (action == 'keyup' && _isModifier(character)) {
            modifiers = [character];
        }

        // loop through all callbacks for the key that was pressed
        // and see if any of them match
        for (i = 0; i < _callbacks[character].length; ++i) {
            callback = _callbacks[character][i];

            // if a sequence name is not specified, but this is a sequence at
            // the wrong level then move onto the next match
            if (!sequenceName && callback.seq && _sequenceLevels[callback.seq] != callback.level) {
                continue;
            }

            // if the action we are looking for doesn't match the action we got
            // then we should keep going
            if (action != callback.action) {
                continue;
            }

            // if this is a keypress event and the meta key and control key
            // are not pressed that means that we need to only look at the
            // character, otherwise check the modifiers as well
            //
            // chrome will not fire a keypress if meta or control is down
            // safari will fire a keypress if meta or meta+shift is down
            // firefox will fire a keypress if meta or control is down
            if ((action == 'keypress' && !e.metaKey && !e.ctrlKey) || _modifiersMatch(modifiers, callback.modifiers)) {

                // when you bind a combination or sequence a second time it
                // should overwrite the first one.  if a sequenceName or
                // combination is specified in this call it does just that
                //
                // @todo make deleting its own method?
                var deleteCombo = !sequenceName && callback.combo == combination;
                var deleteSequence = sequenceName && callback.seq == sequenceName && callback.level == level;
                if (deleteCombo || deleteSequence) {
                    _callbacks[character].splice(i, 1);
                }

                matches.push(callback);
            }
        }

        return matches;
    }

    /**
     * takes a key event and figures out what the modifiers are
     *
     * @param {Event} e
     * @returns {Array}
     */
    function _eventModifiers(e) {
        var modifiers = [];

        if (e.shiftKey) {
            modifiers.push('shift');
        }

        if (e.altKey) {
            modifiers.push('alt');
        }

        if (e.ctrlKey) {
            modifiers.push('ctrl');
        }

        if (e.metaKey) {
            modifiers.push('meta');
        }

        return modifiers;
    }

    /**
     * prevents default for this event
     *
     * @param {Event} e
     * @returns void
     */
    function _preventDefault(e) {
        if (e.preventDefault) {
            e.preventDefault();
            return;
        }

        e.returnValue = false;
    }

    /**
     * stops propogation for this event
     *
     * @param {Event} e
     * @returns void
     */
    function _stopPropagation(e) {
        if (e.stopPropagation) {
            e.stopPropagation();
            return;
        }

        e.cancelBubble = true;
    }

    /**
     * actually calls the callback function
     *
     * if your callback function returns false this will use the jquery
     * convention - prevent default and stop propogation on the event
     *
     * @param {Function} callback
     * @param {Event} e
     * @returns void
     */
    function _fireCallback(callback, e, combo, sequence) {

        // if this event should not happen stop here
        if (Mousetrap.stopCallback(e, e.target || e.srcElement, combo, sequence)) {
            return;
        }

        if (callback(e, combo) === false) {
            _preventDefault(e);
            _stopPropagation(e);
        }
    }

    /**
     * handles a character key event
     *
     * @param {string} character
     * @param {Array} modifiers
     * @param {Event} e
     * @returns void
     */
    function _handleKey(character, modifiers, e) {
        var callbacks = _getMatches(character, modifiers, e),
            i,
            doNotReset = {},
            maxLevel = 0,
            processedSequenceCallback = false;

        // Calculate the maxLevel for sequences so we can only execute the longest callback sequence
        for (i = 0; i < callbacks.length; ++i) {
            if (callbacks[i].seq) {
                maxLevel = Math.max(maxLevel, callbacks[i].level);
            }
        }

        // loop through matching callbacks for this key event
        for (i = 0; i < callbacks.length; ++i) {

            // fire for all sequence callbacks
            // this is because if for example you have multiple sequences
            // bound such as "g i" and "g t" they both need to fire the
            // callback for matching g cause otherwise you can only ever
            // match the first one
            if (callbacks[i].seq) {

                // only fire callbacks for the maxLevel to prevent
                // subsequences from also firing
                //
                // for example 'a option b' should not cause 'option b' to fire
                // even though 'option b' is part of the other sequence
                //
                // any sequences that do not match here will be discarded
                // below by the _resetSequences call
                if (callbacks[i].level != maxLevel) {
                    continue;
                }

                processedSequenceCallback = true;

                // keep a list of which sequences were matches for later
                doNotReset[callbacks[i].seq] = 1;
                _fireCallback(callbacks[i].callback, e, callbacks[i].combo, callbacks[i].seq);
                continue;
            }

            // if there were no sequence matches but we are still here
            // that means this is a regular match so we should fire that
            if (!processedSequenceCallback) {
                _fireCallback(callbacks[i].callback, e, callbacks[i].combo);
            }
        }

        // if the key you pressed matches the type of sequence without
        // being a modifier (ie "keyup" or "keypress") then we should
        // reset all sequences that were not matched by this event
        //
        // this is so, for example, if you have the sequence "h a t" and you
        // type "h e a r t" it does not match.  in this case the "e" will
        // cause the sequence to reset
        //
        // modifier keys are ignored because you can have a sequence
        // that contains modifiers such as "enter ctrl+space" and in most
        // cases the modifier key will be pressed before the next key
        //
        // also if you have a sequence such as "ctrl+b a" then pressing the
        // "b" key will trigger a "keypress" and a "keydown"
        //
        // the "keydown" is expected when there is a modifier, but the
        // "keypress" ends up matching the _nextExpectedAction since it occurs
        // after and that causes the sequence to reset
        //
        // we ignore keypresses in a sequence that directly follow a keydown
        // for the same character
        var ignoreThisKeypress = e.type == 'keypress' && _ignoreNextKeypress;
        if (e.type == _nextExpectedAction && !_isModifier(character) && !ignoreThisKeypress) {
            _resetSequences(doNotReset);
        }

        _ignoreNextKeypress = processedSequenceCallback && e.type == 'keydown';
    }

    /**
     * handles a keydown event
     *
     * @param {Event} e
     * @returns void
     */
    function _handleKeyEvent(e) {

        // normalize e.which for key events
        // @see http://stackoverflow.com/questions/4285627/javascript-keycode-vs-charcode-utter-confusion
        if (typeof e.which !== 'number') {
            e.which = e.keyCode;
        }

        var character = _characterFromEvent(e);

        // no character found then stop
        if (!character) {
            return;
        }

        // need to use === for the character check because the character can be 0
        if (e.type == 'keyup' && _ignoreNextKeyup === character) {
            _ignoreNextKeyup = false;
            return;
        }

        Mousetrap.handleKey(character, _eventModifiers(e), e);
    }

    /**
     * determines if the keycode specified is a modifier key or not
     *
     * @param {string} key
     * @returns {boolean}
     */
    function _isModifier(key) {
        return key == 'shift' || key == 'ctrl' || key == 'alt' || key == 'meta';
    }

    /**
     * called to set a 1 second timeout on the specified sequence
     *
     * this is so after each key press in the sequence you have 1 second
     * to press the next key before you have to start over
     *
     * @returns void
     */
    function _resetSequenceTimer() {
        clearTimeout(_resetTimer);
        _resetTimer = setTimeout(_resetSequences, 1000);
    }

    /**
     * reverses the map lookup so that we can look for specific keys
     * to see what can and can't use keypress
     *
     * @return {Object}
     */
    function _getReverseMap() {
        if (!_REVERSE_MAP) {
            _REVERSE_MAP = {};
            for (var key in _MAP) {

                // pull out the numeric keypad from here cause keypress should
                // be able to detect the keys from the character
                if (key > 95 && key < 112) {
                    continue;
                }

                if (_MAP.hasOwnProperty(key)) {
                    _REVERSE_MAP[_MAP[key]] = key;
                }
            }
        }
        return _REVERSE_MAP;
    }

    /**
     * picks the best action based on the key combination
     *
     * @param {string} key - character for key
     * @param {Array} modifiers
     * @param {string=} action passed in
     */
    function _pickBestAction(key, modifiers, action) {

        // if no action was picked in we should try to pick the one
        // that we think would work best for this key
        if (!action) {
            action = _getReverseMap()[key] ? 'keydown' : 'keypress';
        }

        // modifier keys don't work as expected with keypress,
        // switch to keydown
        if (action == 'keypress' && modifiers.length) {
            action = 'keydown';
        }

        return action;
    }

    /**
     * binds a key sequence to an event
     *
     * @param {string} combo - combo specified in bind call
     * @param {Array} keys
     * @param {Function} callback
     * @param {string=} action
     * @returns void
     */
    function _bindSequence(combo, keys, callback, action) {

        // start off by adding a sequence level record for this combination
        // and setting the level to 0
        _sequenceLevels[combo] = 0;

        /**
         * callback to increase the sequence level for this sequence and reset
         * all other sequences that were active
         *
         * @param {string} nextAction
         * @returns {Function}
         */
        function _increaseSequence(nextAction) {
            return function() {
                _nextExpectedAction = nextAction;
                ++_sequenceLevels[combo];
                _resetSequenceTimer();
            };
        }

        /**
         * wraps the specified callback inside of another function in order
         * to reset all sequence counters as soon as this sequence is done
         *
         * @param {Event} e
         * @returns void
         */
        function _callbackAndReset(e) {
            _fireCallback(callback, e, combo);

            // we should ignore the next key up if the action is key down
            // or keypress.  this is so if you finish a sequence and
            // release the key the final key will not trigger a keyup
            if (action !== 'keyup') {
                _ignoreNextKeyup = _characterFromEvent(e);
            }

            // weird race condition if a sequence ends with the key
            // another sequence begins with
            setTimeout(_resetSequences, 10);
        }

        // loop through keys one at a time and bind the appropriate callback
        // function.  for any key leading up to the final one it should
        // increase the sequence. after the final, it should reset all sequences
        //
        // if an action is specified in the original bind call then that will
        // be used throughout.  otherwise we will pass the action that the
        // next key in the sequence should match.  this allows a sequence
        // to mix and match keypress and keydown events depending on which
        // ones are better suited to the key provided
        for (var i = 0; i < keys.length; ++i) {
            var isFinal = i + 1 === keys.length;
            var wrappedCallback = isFinal ? _callbackAndReset : _increaseSequence(action || _getKeyInfo(keys[i + 1]).action);
            _bindSingle(keys[i], wrappedCallback, action, combo, i);
        }
    }

    /**
     * Converts from a string key combination to an array
     *
     * @param  {string} combination like "command+shift+l"
     * @return {Array}
     */
    function _keysFromString(combination) {
        if (combination === '+') {
            return ['+'];
        }

        return combination.split('+');
    }

    /**
     * Gets info for a specific key combination
     *
     * @param  {string} combination key combination ("command+s" or "a" or "*")
     * @param  {string=} action
     * @returns {Object}
     */
    function _getKeyInfo(combination, action) {
        var keys,
            key,
            i,
            modifiers = [];

        // take the keys from this pattern and figure out what the actual
        // pattern is all about
        keys = _keysFromString(combination);

        for (i = 0; i < keys.length; ++i) {
            key = keys[i];

            // normalize key names
            if (_SPECIAL_ALIASES[key]) {
                key = _SPECIAL_ALIASES[key];
            }

            // if this is not a keypress event then we should
            // be smart about using shift keys
            // this will only work for US keyboards however
            if (action && action != 'keypress' && _SHIFT_MAP[key]) {
                key = _SHIFT_MAP[key];
                modifiers.push('shift');
            }

            // if this key is a modifier then add it to the list of modifiers
            if (_isModifier(key)) {
                modifiers.push(key);
            }
        }

        // depending on what the key combination is
        // we will try to pick the best event for it
        action = _pickBestAction(key, modifiers, action);

        return {
            key: key,
            modifiers: modifiers,
            action: action
        };
    }

    /**
     * binds a single keyboard combination
     *
     * @param {string} combination
     * @param {Function} callback
     * @param {string=} action
     * @param {string=} sequenceName - name of sequence if part of sequence
     * @param {number=} level - what part of the sequence the command is
     * @returns void
     */
    function _bindSingle(combination, callback, action, sequenceName, level) {

        // store a direct mapped reference for use with Mousetrap.trigger
        _directMap[combination + ':' + action] = callback;

        // make sure multiple spaces in a row become a single space
        combination = combination.replace(/\s+/g, ' ');

        var sequence = combination.split(' '),
            info;

        // if this pattern is a sequence of keys then run through this method
        // to reprocess each pattern one key at a time
        if (sequence.length > 1) {
            _bindSequence(combination, sequence, callback, action);
            return;
        }

        info = _getKeyInfo(combination, action);

        // make sure to initialize array if this is the first time
        // a callback is added for this key
        _callbacks[info.key] = _callbacks[info.key] || [];

        // remove an existing match if there is one
        _getMatches(info.key, info.modifiers, {type: info.action}, sequenceName, combination, level);

        // add this call back to the array
        // if it is a sequence put it at the beginning
        // if not put it at the end
        //
        // this is important because the way these are processed expects
        // the sequence ones to come first
        _callbacks[info.key][sequenceName ? 'unshift' : 'push']({
            callback: callback,
            modifiers: info.modifiers,
            action: info.action,
            seq: sequenceName,
            level: level,
            combo: combination
        });
    }

    /**
     * binds multiple combinations to the same callback
     *
     * @param {Array} combinations
     * @param {Function} callback
     * @param {string|undefined} action
     * @returns void
     */
    function _bindMultiple(combinations, callback, action) {
        for (var i = 0; i < combinations.length; ++i) {
            _bindSingle(combinations[i], callback, action);
        }
    }

    // start!
    _addEvent(document, 'keypress', _handleKeyEvent);
    _addEvent(document, 'keydown', _handleKeyEvent);
    _addEvent(document, 'keyup', _handleKeyEvent);

    var Mousetrap = {

        /**
         * binds an event to mousetrap
         *
         * can be a single key, a combination of keys separated with +,
         * an array of keys, or a sequence of keys separated by spaces
         *
         * be sure to list the modifier keys first to make sure that the
         * correct key ends up getting bound (the last key in the pattern)
         *
         * @param {string|Array} keys
         * @param {Function} callback
         * @param {string=} action - 'keypress', 'keydown', or 'keyup'
         * @returns void
         */
        bind: function(keys, callback, action) {
            keys = keys instanceof Array ? keys : [keys];
            _bindMultiple(keys, callback, action);
            return this;
        },

        /**
         * unbinds an event to mousetrap
         *
         * the unbinding sets the callback function of the specified key combo
         * to an empty function and deletes the corresponding key in the
         * _directMap dict.
         *
         * TODO: actually remove this from the _callbacks dictionary instead
         * of binding an empty function
         *
         * the keycombo+action has to be exactly the same as
         * it was defined in the bind method
         *
         * @param {string|Array} keys
         * @param {string} action
         * @returns void
         */
        unbind: function(keys, action) {
            return Mousetrap.bind(keys, function() {}, action);
        },

        /**
         * triggers an event that has already been bound
         *
         * @param {string} keys
         * @param {string=} action
         * @returns void
         */
        trigger: function(keys, action) {
            if (_directMap[keys + ':' + action]) {
                _directMap[keys + ':' + action]({}, keys);
            }
            return this;
        },

        /**
         * resets the library back to its initial state.  this is useful
         * if you want to clear out the current keyboard shortcuts and bind
         * new ones - for example if you switch to another page
         *
         * @returns void
         */
        reset: function() {
            _callbacks = {};
            _directMap = {};
            return this;
        },

       /**
        * should we stop this event before firing off callbacks
        *
        * @param {Event} e
        * @param {Element} element
        * @return {boolean}
        */
        stopCallback: function(e, element) {

            // if the element has the class "mousetrap" then no need to stop
            if ((' ' + element.className + ' ').indexOf(' mousetrap ') > -1) {
                return false;
            }

            // stop for input, select, and textarea
            return element.tagName == 'INPUT' || element.tagName == 'SELECT' || element.tagName == 'TEXTAREA' || element.isContentEditable;
        },

        /**
         * exposes _handleKey publicly so it can be overwritten by extensions
         */
        handleKey: _handleKey
    };

    // expose mousetrap to the global object
    window.Mousetrap = Mousetrap;

    // expose mousetrap as an AMD module
    if (true) {
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (Mousetrap),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    }
}) (window, document);


/***/ }),

/***/ "bOHH":
/***/ (function(module, exports) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  var gl = window.gl || (window.gl = {});

  var VisibilitySelect = function () {
    function VisibilitySelect(container) {
      _classCallCheck(this, VisibilitySelect);

      if (!container) throw new Error('VisibilitySelect requires a container element as argument 1');
      this.container = container;
      this.helpBlock = this.container.querySelector('.help-block');
      this.select = this.container.querySelector('select');
    }

    _createClass(VisibilitySelect, [{
      key: 'init',
      value: function init() {
        if (this.select) {
          this.updateHelpText();
          this.select.addEventListener('change', this.updateHelpText.bind(this));
        } else {
          this.helpBlock.textContent = this.container.querySelector('.js-locked').dataset.helpBlock;
        }
      }
    }, {
      key: 'updateHelpText',
      value: function updateHelpText() {
        this.helpBlock.textContent = this.select.querySelector('option:checked').dataset.description;
      }
    }]);

    return VisibilitySelect;
  }();

  gl.VisibilitySelect = VisibilitySelect;
})();

/***/ }),

/***/ "cMCw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable func-names, space-before-function-paren, no-var, prefer-rest-params, wrap-iife, one-var, no-underscore-dangle, one-var-declaration-per-line, object-shorthand, no-unused-vars, no-new, comma-dangle, consistent-return, quotes, dot-notation, quote-props, prefer-arrow-callback, max-len */
/* global Flash */

__webpack_require__("nYQN");
__webpack_require__("A+3H");
__webpack_require__("5IIL");
__webpack_require__("3uF6");

var Issue = function () {
  function Issue() {
    _classCallCheck(this, Issue);

    if ($('a.btn-close').length) {
      this.taskList = new gl.TaskList({
        dataType: 'issue',
        fieldName: 'description',
        selector: '.detail-page-description',
        onSuccess: function onSuccess(result) {
          document.querySelector('#task_status').innerText = result.task_status;
          document.querySelector('#task_status_short').innerText = result.task_status_short;
        }
      });
      Issue.initIssueBtnEventListeners();
    }
    Issue.initMergeRequests();
    Issue.initRelatedBranches();
    Issue.initCanCreateBranch();
  }

  _createClass(Issue, null, [{
    key: 'initIssueBtnEventListeners',
    value: function initIssueBtnEventListeners() {
      var issueFailMessage;
      issueFailMessage = 'Unable to update this issue at this time.';
      return $('a.btn-close, a.btn-reopen').on('click', function (e) {
        var $this, isClose, shouldSubmit, url;
        e.preventDefault();
        e.stopImmediatePropagation();
        $this = $(this);
        isClose = $this.hasClass('btn-close');
        shouldSubmit = $this.hasClass('btn-comment');
        if (shouldSubmit) {
          Issue.submitNoteForm($this.closest('form'));
        }
        $this.prop('disabled', true);
        url = $this.attr('href');
        return $.ajax({
          type: 'PUT',
          url: url,
          error: function error(jqXHR, textStatus, errorThrown) {
            var issueStatus;
            issueStatus = isClose ? 'close' : 'open';
            return new Flash(issueFailMessage, 'alert');
          },
          success: function success(data, textStatus, jqXHR) {
            if ('id' in data) {
              $(document).trigger('issuable:change');
              var total = Number($('.issue_counter').text().replace(/[^\d]/, ''));
              if (isClose) {
                $('a.btn-close').addClass('hidden');
                $('a.btn-reopen').removeClass('hidden');
                $('div.status-box-closed').removeClass('hidden');
                $('div.status-box-open').addClass('hidden');
                total -= 1;
              } else {
                $('a.btn-reopen').addClass('hidden');
                $('a.btn-close').removeClass('hidden');
                $('div.status-box-closed').addClass('hidden');
                $('div.status-box-open').removeClass('hidden');
                total += 1;
              }
              $('.issue_counter').text(gl.text.addDelimiter(total));
            } else {
              new Flash(issueFailMessage, 'alert');
            }
            return $this.prop('disabled', false);
          }
        });
      });
    }
  }, {
    key: 'submitNoteForm',
    value: function submitNoteForm(form) {
      var noteText;
      noteText = form.find("textarea.js-note-text").val();
      if (noteText.trim().length > 0) {
        return form.submit();
      }
    }
  }, {
    key: 'initMergeRequests',
    value: function initMergeRequests() {
      var $container;
      $container = $('#merge-requests');
      return $.getJSON($container.data('url')).error(function () {
        return new Flash('Failed to load referenced merge requests', 'alert');
      }).success(function (data) {
        if ('html' in data) {
          return $container.html(data.html);
        }
      });
    }
  }, {
    key: 'initRelatedBranches',
    value: function initRelatedBranches() {
      var $container;
      $container = $('#related-branches');
      return $.getJSON($container.data('url')).error(function () {
        return new Flash('Failed to load related branches', 'alert');
      }).success(function (data) {
        if ('html' in data) {
          return $container.html(data.html);
        }
      });
    }
  }, {
    key: 'initCanCreateBranch',
    value: function initCanCreateBranch() {
      var $container;
      $container = $('#new-branch');
      // If the user doesn't have the required permissions the container isn't
      // rendered at all.
      if ($container.length === 0) {
        return;
      }
      return $.getJSON($container.data('path')).error(function () {
        $container.find('.unavailable').show();
        return new Flash('Failed to check if a new branch can be created.', 'alert');
      }).success(function (data) {
        if (data.can_create_branch) {
          $container.find('.available').show();
        } else {
          return $container.find('.unavailable').show();
        }
      });
    }
  }]);

  return Issue;
}();

/* harmony default export */ __webpack_exports__["a"] = (Issue);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("lwLq")))

/***/ }),

/***/ "cRIW":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, wrap-iife, quotes, prefer-arrow-callback, no-var, one-var, one-var-declaration-per-line, no-else-return, max-len */

window.Aside = function () {
  function Aside() {
    $(document).off("click", "a.show-aside");
    $(document).on("click", 'a.show-aside', function (e) {
      var btn, icon;
      e.preventDefault();
      btn = $(e.currentTarget);
      icon = btn.find('i');
      if (icon.hasClass('fa-angle-left')) {
        btn.parent().find('section').hide();
        btn.parent().find('aside').fadeIn();
        return icon.removeClass('fa-angle-left').addClass('fa-angle-right');
      } else {
        btn.parent().find('aside').hide();
        btn.parent().find('section').fadeIn();
        return icon.removeClass('fa-angle-right').addClass('fa-angle-left');
      }
    });
  }

  return Aside;
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "chcu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__("yoQO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var USER_CALLOUT_COOKIE = 'user_callout_dismissed';

var UserCallout = function () {
  function UserCallout() {
    _classCallCheck(this, UserCallout);

    this.isCalloutDismissed = __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get(USER_CALLOUT_COOKIE);
    this.userCalloutBody = $('.user-callout');
    this.init();
  }

  _createClass(UserCallout, [{
    key: 'init',
    value: function init() {
      var _this = this;

      if (!this.isCalloutDismissed || this.isCalloutDismissed === 'false') {
        $('.js-close-callout').on('click', function (e) {
          return _this.dismissCallout(e);
        });
      }
    }
  }, {
    key: 'dismissCallout',
    value: function dismissCallout(e) {
      var $currentTarget = $(e.currentTarget);

      __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set(USER_CALLOUT_COOKIE, 'true');

      if ($currentTarget.hasClass('close')) {
        this.userCalloutBody.remove();
      }
    }
  }]);

  return UserCallout;
}();

/* harmony default export */ __webpack_exports__["a"] = (UserCallout);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("lwLq")))

/***/ }),

/***/ "css6":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable comma-dangle, class-methods-use-this, no-underscore-dangle, no-param-reassign, no-unused-vars, consistent-return, func-names, space-before-function-paren, max-len */
/* global Flash */
/* global Sortable */

(function (global) {
  var LabelManager = function () {
    function LabelManager() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          togglePriorityButton = _ref.togglePriorityButton,
          prioritizedLabels = _ref.prioritizedLabels,
          otherLabels = _ref.otherLabels;

      _classCallCheck(this, LabelManager);

      this.togglePriorityButton = togglePriorityButton || $('.js-toggle-priority');
      this.prioritizedLabels = prioritizedLabels || $('.js-prioritized-labels');
      this.otherLabels = otherLabels || $('.js-other-labels');
      this.errorMessage = 'Unable to update label prioritization at this time';
      this.emptyState = document.querySelector('#js-priority-labels-empty-state');
      this.sortable = Sortable.create(this.prioritizedLabels.get(0), {
        filter: '.empty-message',
        forceFallback: true,
        fallbackClass: 'is-dragging',
        dataIdAttr: 'data-id',
        onUpdate: this.onPrioritySortUpdate.bind(this)
      });
      this.bindEvents();
    }

    _createClass(LabelManager, [{
      key: 'bindEvents',
      value: function bindEvents() {
        return this.togglePriorityButton.on('click', this, this.onTogglePriorityClick);
      }
    }, {
      key: 'onTogglePriorityClick',
      value: function onTogglePriorityClick(e) {
        e.preventDefault();
        var _this = e.data;
        var $btn = $(e.currentTarget);
        var $label = $('#' + $btn.data('domId'));
        var action = $btn.parents('.js-prioritized-labels').length ? 'remove' : 'add';
        var $tooltip = $('#' + $btn.find('.has-tooltip:visible').attr('aria-describedby'));
        $tooltip.tooltip('destroy');
        _this.toggleLabelPriority($label, action);
        _this.toggleEmptyState($label, $btn, action);
      }
    }, {
      key: 'toggleEmptyState',
      value: function toggleEmptyState($label, $btn, action) {
        this.emptyState.classList.toggle('hidden', !!this.prioritizedLabels[0].querySelector(':scope > li'));
      }
    }, {
      key: 'toggleLabelPriority',
      value: function toggleLabelPriority($label, action, persistState) {
        if (persistState == null) {
          persistState = true;
        }
        var xhr = void 0;
        var _this = this;
        var url = $label.find('.js-toggle-priority').data('url');
        var $target = this.prioritizedLabels;
        var $from = this.otherLabels;
        if (action === 'remove') {
          $target = this.otherLabels;
          $from = this.prioritizedLabels;
        }
        $label.detach().appendTo($target);
        if ($from.find('li').length) {
          $from.find('.empty-message').removeClass('hidden');
        }
        if ($target.find('> li:not(.empty-message)').length) {
          $target.find('.empty-message').addClass('hidden');
        }
        // Return if we are not persisting state
        if (!persistState) {
          return;
        }
        if (action === 'remove') {
          xhr = $.ajax({
            url: url,
            type: 'DELETE'
          });
          // Restore empty message
          if (!$from.find('li').length) {
            $from.find('.empty-message').removeClass('hidden');
          }
        } else {
          xhr = this.savePrioritySort($label, action);
        }
        return xhr.fail(this.rollbackLabelPosition.bind(this, $label, action));
      }
    }, {
      key: 'onPrioritySortUpdate',
      value: function onPrioritySortUpdate() {
        var xhr = this.savePrioritySort();
        return xhr.fail(function () {
          return new Flash(this.errorMessage, 'alert');
        });
      }
    }, {
      key: 'savePrioritySort',
      value: function savePrioritySort() {
        return $.post({
          url: this.prioritizedLabels.data('url'),
          data: {
            label_ids: this.getSortedLabelsIds()
          }
        });
      }
    }, {
      key: 'rollbackLabelPosition',
      value: function rollbackLabelPosition($label, originalAction) {
        var action = originalAction === 'remove' ? 'add' : 'remove';
        this.toggleLabelPriority($label, action, false);
        return new Flash(this.errorMessage, 'alert');
      }
    }, {
      key: 'getSortedLabelsIds',
      value: function getSortedLabelsIds() {
        var sortedIds = [];
        this.prioritizedLabels.find('> li').each(function () {
          var id = $(this).data('id');

          if (id) {
            sortedIds.push(id);
          }
        });
        return sortedIds;
      }
    }]);

    return LabelManager;
  }();

  gl.LabelManager = LabelManager;
})(window.gl || (window.gl = {}));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "dF5a":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var _this2 = this;

/* eslint-disable no-param-reassign, func-names, no-var, camelcase, no-unused-vars, object-shorthand, space-before-function-paren, no-return-assign, comma-dangle, consistent-return, one-var, one-var-declaration-per-line, quotes, prefer-template, prefer-arrow-callback, wrap-iife, max-len */
/* global Issuable */

(function (global) {
  var issuable_created;

  issuable_created = false;

  global.Issuable = {
    init: function init() {
      Issuable.initTemplates();
      Issuable.initSearch();
      Issuable.initChecks();
      Issuable.initResetFilters();
      Issuable.resetIncomingEmailToken();
      return Issuable.initLabelFilterRemove();
    },
    initTemplates: function initTemplates() {
      return Issuable.labelRow = _.template('<% _.each(labels, function(label){ %> <span class="label-row btn-group" role="group" aria-label="<%- label.title %>" style="color: <%- label.text_color %>;"> <a href="#" class="btn btn-transparent has-tooltip" style="background-color: <%- label.color %>;" title="<%- label.description %>" data-container="body"> <%- label.title %> </a> <button type="button" class="btn btn-transparent label-remove js-label-filter-remove" style="background-color: <%- label.color %>;" data-label="<%- label.title %>"> <i class="fa fa-times"></i> </button> </span> <% }); %>');
    },
    initSearch: function initSearch() {
      var $searchInput = $('#issuable_search');

      Issuable.initSearchState($searchInput);

      // `immediate` param set to false debounces on the `trailing` edge, lets user finish typing
      var debouncedExecSearch = _.debounce(Issuable.executeSearch, 1000, false);

      $searchInput.off('keyup').on('keyup', debouncedExecSearch);

      // ensures existing filters are preserved when manually submitted
      $('#issuable_search_form').on('submit', function (e) {
        e.preventDefault();
        debouncedExecSearch(e);
      });
    },
    initSearchState: function initSearchState($searchInput) {
      var currentSearchVal = $searchInput.val();

      Issuable.searchState = {
        elem: $searchInput,
        current: currentSearchVal
      };

      Issuable.maybeFocusOnSearch();
    },
    accessSearchPristine: function accessSearchPristine(set) {
      // store reference to previous value to prevent search on non-mutating keyup
      var state = Issuable.searchState;
      var currentSearchVal = state.elem.val();

      if (set) {
        state.current = currentSearchVal;
      } else {
        return state.current === currentSearchVal;
      }
    },
    maybeFocusOnSearch: function maybeFocusOnSearch() {
      var currentSearchVal = Issuable.searchState.current;
      if (currentSearchVal && currentSearchVal !== '') {
        var queryLength = currentSearchVal.length;
        var $searchInput = Issuable.searchState.elem;

        /* The following ensures that the cursor is initially placed at
          * the end of search input when focus is applied. It accounts
          * for differences in browser implementations of `setSelectionRange`
          * and cursor placement for elements in focus.
        */
        $searchInput.focus();
        if ($searchInput.setSelectionRange) {
          $searchInput.setSelectionRange(queryLength, queryLength);
        } else {
          $searchInput.val(currentSearchVal);
        }
      }
    },
    executeSearch: function executeSearch(e) {
      var $search = $('#issuable_search');
      var $searchName = $search.attr('name');
      var $searchValue = $search.val();
      var $filtersForm = $('.js-filter-form');
      var $input = $('input[name=\'' + $searchName + '\']', $filtersForm);
      var isPristine = Issuable.accessSearchPristine();

      if (isPristine) {
        return;
      }

      if (!$input.length) {
        $filtersForm.append('<input type=\'hidden\' name=\'' + $searchName + '\' value=\'' + _.escape($searchValue) + '\'/>');
      } else {
        $input.val($searchValue);
      }

      Issuable.filterResults($filtersForm);
    },
    initLabelFilterRemove: function initLabelFilterRemove() {
      return $(document).off('click', '.js-label-filter-remove').on('click', '.js-label-filter-remove', function (e) {
        var $button;
        $button = $(this);
        // Remove the label input box
        $('input[name="label_name[]"]').filter(function () {
          return this.value === $button.data('label');
        }).remove();
        // Submit the form to get new data
        Issuable.filterResults($('.filter-form'));
      });
    },
    filterResults: function (_this) {
      return function (form) {
        var formAction, formData, issuesUrl;
        formData = form.serializeArray();
        formData = formData.filter(function (data) {
          return data.value !== '';
        });
        formData = $.param(formData);
        formAction = form.attr('action');
        issuesUrl = formAction;
        issuesUrl += "" + (formAction.indexOf('?') === -1 ? '?' : '&');
        issuesUrl += formData;
        return gl.utils.visitUrl(issuesUrl);
      };
    }(_this2),
    initResetFilters: function initResetFilters() {
      $('.reset-filters').on('click', function (e) {
        e.preventDefault();
        var target = e.target;
        var $form = $(target).parents('.js-filter-form');
        var baseIssuesUrl = target.href;

        $form.attr('action', baseIssuesUrl);
        gl.utils.visitUrl(baseIssuesUrl);
      });
    },
    initChecks: function initChecks() {
      this.issuableBulkActions = $('.bulk-update').data('bulkActions');
      $('.check_all_issues').off('click').on('click', function () {
        $('.selected_issue').prop('checked', this.checked);
        return Issuable.checkChanged();
      });
      return $('.selected_issue').off('change').on('change', Issuable.checkChanged.bind(this));
    },
    checkChanged: function checkChanged() {
      var $checkedIssues = $('.selected_issue:checked');
      var $updateIssuesIds = $('#update_issuable_ids');
      var $issuesOtherFilters = $('.issues-other-filters');
      var $issuesBulkUpdate = $('.issues_bulk_update');

      this.issuableBulkActions.willUpdateLabels = false;
      this.issuableBulkActions.setOriginalDropdownData();

      if ($checkedIssues.length > 0) {
        var ids = $.map($checkedIssues, function (value) {
          return $(value).data('id');
        });
        $updateIssuesIds.val(ids);
        $issuesOtherFilters.hide();
        $issuesBulkUpdate.show();
      } else {
        $updateIssuesIds.val([]);
        $issuesBulkUpdate.hide();
        $issuesOtherFilters.show();
      }
      return true;
    },

    resetIncomingEmailToken: function resetIncomingEmailToken() {
      $('.incoming-email-token-reset').on('click', function (e) {
        e.preventDefault();

        $.ajax({
          type: 'PUT',
          url: $('.incoming-email-token-reset').attr('href'),
          dataType: 'json',
          success: function success(response) {
            $('#issue_email').val(response.new_issue_address).focus();
          },
          beforeSend: function beforeSend() {
            $('.incoming-email-token-reset').text('resetting...');
          },
          complete: function complete() {
            $('.incoming-email-token-reset').text('reset it');
          }
        });
      });
    }
  };
})(window);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "dTE/":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, one-var, no-var, one-var-declaration-per-line, object-shorthand, comma-dangle, prefer-arrow-callback, no-else-return, newline-per-chained-call, wrap-iife, max-len */

window.CompareAutocomplete = function () {
  function CompareAutocomplete() {
    this.initDropdown();
  }

  CompareAutocomplete.prototype.initDropdown = function () {
    return $('.js-compare-dropdown').each(function () {
      var $dropdown, selected;
      $dropdown = $(this);
      selected = $dropdown.data('selected');
      var $dropdownContainer = $dropdown.closest('.dropdown');
      var $fieldInput = $('input[name="' + $dropdown.data('field-name') + '"]', $dropdownContainer);
      var $filterInput = $('input[type="search"]', $dropdownContainer);
      $dropdown.glDropdown({
        data: function data(term, callback) {
          return $.ajax({
            url: $dropdown.data('refs-url'),
            data: {
              ref: $dropdown.data('ref'),
              search: term
            }
          }).done(function (refs) {
            return callback(refs);
          });
        },
        selectable: true,
        filterable: true,
        filterRemote: true,
        fieldName: $dropdown.data('field-name'),
        filterInput: 'input[type="search"]',
        renderRow: function renderRow(ref) {
          var link;
          if (ref.header != null) {
            return $('<li />').addClass('dropdown-header').text(ref.header);
          } else {
            link = $('<a />').attr('href', '#').addClass(ref === selected ? 'is-active' : '').text(ref).attr('data-ref', escape(ref));
            return $('<li />').append(link);
          }
        },
        id: function id(obj, $el) {
          return $el.attr('data-ref');
        },
        toggleLabel: function toggleLabel(obj, $el) {
          return $el.text().trim();
        }
      });
      $filterInput.on('keyup', function (e) {
        var keyCode = e.keyCode || e.which;
        if (keyCode !== 13) return;
        var text = $filterInput.val();
        $fieldInput.val(text);
        $('.dropdown-toggle-text', $dropdown).text(text);
        $dropdownContainer.removeClass('open');
      });

      $dropdownContainer.on('click', '.dropdown-content a', function (e) {
        $dropdown.prop('title', e.target.text.replace(/_+?/g, '-'));
        if ($dropdown.hasClass('has-tooltip')) {
          $dropdown.tooltip('fixTitle');
        }
      });
    });
  };

  return CompareAutocomplete;
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "dekX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__("yoQO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__comment_type_toggle__ = __webpack_require__("iqF/");
/* eslint-disable no-restricted-properties, func-names, space-before-function-paren, no-var, prefer-rest-params, wrap-iife, no-use-before-define, camelcase, no-unused-expressions, quotes, max-len, one-var, one-var-declaration-per-line, default-case, prefer-template, consistent-return, no-alert, no-return-assign, no-param-reassign, prefer-arrow-callback, no-else-return, comma-dangle, no-new, brace-style, no-lonely-if, vars-on-top, no-unused-vars, no-sequences, no-shadow, newline-per-chained-call, no-useless-escape */
/* global Flash */
/* global Autosave */
/* global ResolveService */
/* global mrRefreshWidgetUrl */




__webpack_require__("+Y/g");
window.autosize = __webpack_require__("loCD");
window.Dropzone = __webpack_require__("Qepg");
__webpack_require__("r5TZ");
__webpack_require__("0/gX");
__webpack_require__("0L03"); // required by jquery.atwho
__webpack_require__("M4/5");
__webpack_require__("3uF6");

(function () {
  var bind = function bind(fn, me) {
    return function () {
      return fn.apply(me, arguments);
    };
  };

  this.Notes = function () {
    var MAX_VISIBLE_COMMIT_LIST_COUNT = 3;

    Notes.interval = null;

    function Notes(notes_url, note_ids, last_fetched_at, view) {
      this.updateTargetButtons = bind(this.updateTargetButtons, this);
      this.updateCloseButton = bind(this.updateCloseButton, this);
      this.visibilityChange = bind(this.visibilityChange, this);
      this.cancelDiscussionForm = bind(this.cancelDiscussionForm, this);
      this.addDiffNote = bind(this.addDiffNote, this);
      this.setupDiscussionNoteForm = bind(this.setupDiscussionNoteForm, this);
      this.replyToDiscussionNote = bind(this.replyToDiscussionNote, this);
      this.removeNote = bind(this.removeNote, this);
      this.cancelEdit = bind(this.cancelEdit, this);
      this.updateNote = bind(this.updateNote, this);
      this.addDiscussionNote = bind(this.addDiscussionNote, this);
      this.addNoteError = bind(this.addNoteError, this);
      this.addNote = bind(this.addNote, this);
      this.resetMainTargetForm = bind(this.resetMainTargetForm, this);
      this.refresh = bind(this.refresh, this);
      this.keydownNoteText = bind(this.keydownNoteText, this);
      this.toggleCommitList = bind(this.toggleCommitList, this);
      this.notes_url = notes_url;
      this.note_ids = note_ids;
      this.last_fetched_at = last_fetched_at;
      this.noteable_url = document.URL;
      this.notesCountBadge || (this.notesCountBadge = $(".issuable-details").find(".notes-tab .badge"));
      this.basePollingInterval = 15000;
      this.maxPollingSteps = 4;
      this.cleanBinding();
      this.addBinding();
      this.setPollingInterval();
      this.setupMainTargetNoteForm();
      this.taskList = new gl.TaskList({
        dataType: 'note',
        fieldName: 'note',
        selector: '.notes'
      });
      this.collapseLongCommitList();
      this.setViewType(view);

      // We are in the Merge Requests page so we need another edit form for Changes tab
      if (gl.utils.getPagePath(1) === 'merge_requests') {
        $('.note-edit-form').clone().addClass('mr-note-edit-form').insertAfter('.note-edit-form');
      }
    }

    Notes.prototype.setViewType = function (view) {
      this.view = __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('diff_view') || view;
    };

    Notes.prototype.addBinding = function () {
      // add note to UI after creation
      $(document).on("ajax:success", ".js-main-target-form", this.addNote);
      $(document).on("ajax:success", ".js-discussion-note-form", this.addDiscussionNote);
      // catch note ajax errors
      $(document).on("ajax:error", ".js-main-target-form", this.addNoteError);
      // change note in UI after update
      $(document).on("ajax:success", "form.edit-note", this.updateNote);
      // Edit note link
      $(document).on("click", ".js-note-edit", this.showEditForm.bind(this));
      $(document).on("click", ".note-edit-cancel", this.cancelEdit);
      // Reopen and close actions for Issue/MR combined with note form submit
      $(document).on("click", ".js-comment-button", this.updateCloseButton);
      $(document).on("keyup input", ".js-note-text", this.updateTargetButtons);
      // resolve a discussion
      $(document).on('click', '.js-comment-resolve-button', this.resolveDiscussion);
      // remove a note (in general)
      $(document).on("click", ".js-note-delete", this.removeNote);
      // delete note attachment
      $(document).on("click", ".js-note-attachment-delete", this.removeAttachment);
      // reset main target form after submit
      $(document).on("ajax:complete", ".js-main-target-form", this.reenableTargetFormSubmitButton);
      $(document).on("ajax:success", ".js-main-target-form", this.resetMainTargetForm);
      // reset main target form when clicking discard
      $(document).on("click", ".js-note-discard", this.resetMainTargetForm);
      // update the file name when an attachment is selected
      $(document).on("change", ".js-note-attachment-input", this.updateFormAttachment);
      // reply to diff/discussion notes
      $(document).on("click", ".js-discussion-reply-button", this.replyToDiscussionNote);
      // add diff note
      $(document).on("click", ".js-add-diff-note-button", this.addDiffNote);
      // hide diff note form
      $(document).on("click", ".js-close-discussion-note-form", this.cancelDiscussionForm);
      // toggle commit list
      $(document).on("click", '.system-note-commit-list-toggler', this.toggleCommitList);
      // fetch notes when tab becomes visible
      $(document).on("visibilitychange", this.visibilityChange);
      // when issue status changes, we need to refresh data
      $(document).on("issuable:change", this.refresh);
      // when a key is clicked on the notes
      return $(document).on("keydown", ".js-note-text", this.keydownNoteText);
    };

    Notes.prototype.cleanBinding = function () {
      $(document).off("ajax:success", ".js-main-target-form");
      $(document).off("ajax:success", ".js-discussion-note-form");
      $(document).off("ajax:success", "form.edit-note");
      $(document).off("click", ".js-note-edit");
      $(document).off("click", ".note-edit-cancel");
      $(document).off("click", ".js-note-delete");
      $(document).off("click", ".js-note-attachment-delete");
      $(document).off("ajax:complete", ".js-main-target-form");
      $(document).off("ajax:success", ".js-main-target-form");
      $(document).off("click", ".js-discussion-reply-button");
      $(document).off("click", ".js-add-diff-note-button");
      $(document).off("visibilitychange");
      $(document).off("keyup", ".js-note-text");
      $(document).off("click", ".js-note-target-reopen");
      $(document).off("click", ".js-note-target-close");
      $(document).off("click", ".js-note-discard");
      $(document).off("keydown", ".js-note-text");
      $(document).off('click', '.js-comment-resolve-button');
      $(document).off("click", '.system-note-commit-list-toggler');
    };

    Notes.initCommentTypeToggle = function (form) {
      var dropdownTrigger = form.querySelector('.js-comment-type-dropdown .dropdown-toggle');
      var dropdownList = form.querySelector('.js-comment-type-dropdown .dropdown-menu');
      var noteTypeInput = form.querySelector('#note_type');
      var submitButton = form.querySelector('.js-comment-type-dropdown .js-comment-submit-button');
      var closeButton = form.querySelector('.js-note-target-close');
      var reopenButton = form.querySelector('.js-note-target-reopen');

      var commentTypeToggle = new __WEBPACK_IMPORTED_MODULE_1__comment_type_toggle__["a" /* default */]({
        dropdownTrigger: dropdownTrigger,
        dropdownList: dropdownList,
        noteTypeInput: noteTypeInput,
        submitButton: submitButton,
        closeButton: closeButton,
        reopenButton: reopenButton
      });

      commentTypeToggle.initDroplab();
    };

    Notes.prototype.keydownNoteText = function (e) {
      var $textarea, discussionNoteForm, editNote, myLastNote, myLastNoteEditBtn, newText, originalText;
      if (gl.utils.isMetaKey(e)) {
        return;
      }

      $textarea = $(e.target);
      // Edit previous note when UP arrow is hit
      switch (e.which) {
        case 38:
          if ($textarea.val() !== '') {
            return;
          }
          myLastNote = $("li.note[data-author-id='" + gon.current_user_id + "'][data-editable]:last");
          if (myLastNote.length) {
            myLastNoteEditBtn = myLastNote.find('.js-note-edit');
            return myLastNoteEditBtn.trigger('click', [true, myLastNote]);
          }
          break;
        // Cancel creating diff note or editing any note when ESCAPE is hit
        case 27:
          discussionNoteForm = $textarea.closest('.js-discussion-note-form');
          if (discussionNoteForm.length) {
            if ($textarea.val() !== '') {
              if (!confirm('Are you sure you want to cancel creating this comment?')) {
                return;
              }
            }
            this.removeDiscussionNoteForm(discussionNoteForm);
            return;
          }
          editNote = $textarea.closest('.note');
          if (editNote.length) {
            originalText = $textarea.closest('form').data('original-note');
            newText = $textarea.val();
            if (originalText !== newText) {
              if (!confirm('Are you sure you want to cancel editing this comment?')) {
                return;
              }
            }
            return this.removeNoteEditForm(editNote);
          }
      }
    };

    Notes.prototype.initRefresh = function () {
      clearInterval(Notes.interval);
      return Notes.interval = setInterval(function (_this) {
        return function () {
          return _this.refresh();
        };
      }(this), this.pollingInterval);
    };

    Notes.prototype.refresh = function () {
      if (!document.hidden) {
        return this.getContent();
      }
    };

    Notes.prototype.getContent = function () {
      if (this.refreshing) {
        return;
      }
      this.refreshing = true;
      return $.ajax({
        url: this.notes_url,
        headers: { "X-Last-Fetched-At": this.last_fetched_at },
        dataType: "json",
        success: function (_this) {
          return function (data) {
            var notes;
            notes = data.notes;
            _this.last_fetched_at = data.last_fetched_at;
            _this.setPollingInterval(data.notes.length);
            return $.each(notes, function (i, note) {
              _this.renderNote(note);
            });
          };
        }(this)
      }).always(function (_this) {
        return function () {
          return _this.refreshing = false;
        };
      }(this));
    };

    /*
    Increase @pollingInterval up to 120 seconds on every function call,
    if `shouldReset` has a truthy value, 'null' or 'undefined' the variable
    will reset to @basePollingInterval.
     Note: this function is used to gradually increase the polling interval
    if there aren't new notes coming from the server
     */

    Notes.prototype.setPollingInterval = function (shouldReset) {
      var nthInterval;
      if (shouldReset == null) {
        shouldReset = true;
      }
      nthInterval = this.basePollingInterval * Math.pow(2, this.maxPollingSteps - 1);
      if (shouldReset) {
        this.pollingInterval = this.basePollingInterval;
      } else if (this.pollingInterval < nthInterval) {
        this.pollingInterval *= 2;
      }
      return this.initRefresh();
    };

    Notes.prototype.handleCreateChanges = function (note) {
      var votesBlock;
      if (typeof note === 'undefined') {
        return;
      }

      if (note.commands_changes) {
        if ('merge' in note.commands_changes) {
          $.get(mrRefreshWidgetUrl);
        }

        if ('emoji_award' in note.commands_changes) {
          votesBlock = $('.js-awards-block').eq(0);
          gl.awardsHandler.addAwardToEmojiBar(votesBlock, note.commands_changes.emoji_award);
          return gl.awardsHandler.scrollToAwards();
        }
      }
    };

    /*
    Render note in main comments area.
     Note: for rendering inline notes use renderDiscussionNote
     */

    Notes.prototype.renderNote = function (note, $form) {
      var $notesList;
      if (note.discussion_html != null) {
        return this.renderDiscussionNote(note, $form);
      }

      if (!note.valid) {
        if (note.errors.commands_only) {
          new Flash(note.errors.commands_only, 'notice', this.parentTimeline);
          this.refresh();
        }
        return;
      }

      if (this.isNewNote(note)) {
        this.note_ids.push(note.id);
        $notesList = $('ul.main-notes-list');
        $notesList.append(note.html).syntaxHighlight();
        // Update datetime format on the recent note
        gl.utils.localTimeAgo($notesList.find("#note_" + note.id + " .js-timeago"), false);
        this.collapseLongCommitList();
        this.taskList.init();
        this.refresh();
        return this.updateNotesCount(1);
      }
    };

    /*
    Check if note does not exists on page
     */

    Notes.prototype.isNewNote = function (note) {
      return $.inArray(note.id, this.note_ids) === -1;
    };

    Notes.prototype.isParallelView = function () {
      return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('diff_view') === 'parallel';
    };

    /*
    Render note in discussion area.
     Note: for rendering inline notes use renderDiscussionNote
     */

    Notes.prototype.renderDiscussionNote = function (note, $form) {
      var discussionContainer, form, row, lineType, diffAvatarContainer;
      if (!this.isNewNote(note)) {
        return;
      }
      this.note_ids.push(note.id);
      form = $form || $(".js-discussion-note-form[data-discussion-id='" + note.discussion_id + "']");
      row = form.closest("tr");
      lineType = this.isParallelView() ? form.find('#line_type').val() : 'old';
      diffAvatarContainer = row.prevAll('.line_holder').first().find('.js-avatar-container.' + lineType + '_line');
      // is this the first note of discussion?
      discussionContainer = $(".notes[data-discussion-id='" + note.discussion_id + "']");
      if (!discussionContainer.length) {
        discussionContainer = form.closest('.discussion').find('.notes');
      }
      if (discussionContainer.length === 0) {
        if (note.diff_discussion_html) {
          var $discussion = $(note.diff_discussion_html).renderGFM();

          if (!this.isParallelView() || row.hasClass('js-temp-notes-holder')) {
            // insert the note and the reply button after the temp row
            row.after($discussion);
          } else {
            // Merge new discussion HTML in
            var $notes = $discussion.find('.notes[data-discussion-id="' + note.discussion_id + '"]');
            var contentContainerClass = '.' + $notes.closest('.notes_content').attr('class').split(' ').join('.');

            row.find(contentContainerClass + ' .content').append($notes.closest('.content').children());
          }
        }

        // Init discussion on 'Discussion' page if it is merge request page
        if ($('body').attr('data-page').indexOf('projects:merge_request') === 0 || !note.diff_discussion_html) {
          $('ul.main-notes-list').append($(note.discussion_html).renderGFM());
        }
      } else {
        // append new note to all matching discussions
        discussionContainer.append($(note.html).renderGFM());
      }

      if (typeof gl.diffNotesCompileComponents !== 'undefined' && note.discussion_resolvable) {
        gl.diffNotesCompileComponents();
        this.renderDiscussionAvatar(diffAvatarContainer, note);
      }

      gl.utils.localTimeAgo($('.js-timeago'), false);
      return this.updateNotesCount(1);
    };

    Notes.prototype.getLineHolder = function (changesDiscussionContainer) {
      return $(changesDiscussionContainer).closest('.notes_holder').prevAll('.line_holder').first().get(0);
    };

    Notes.prototype.renderDiscussionAvatar = function (diffAvatarContainer, note) {
      var commentButton = diffAvatarContainer.find('.js-add-diff-note-button');
      var avatarHolder = diffAvatarContainer.find('.diff-comment-avatar-holders');

      if (!avatarHolder.length) {
        avatarHolder = document.createElement('diff-note-avatars');
        avatarHolder.setAttribute('discussion-id', note.discussion_id);

        diffAvatarContainer.append(avatarHolder);

        gl.diffNotesCompileComponents();
      }

      if (commentButton.length) {
        commentButton.remove();
      }
    };

    /*
    Called in response the main target form has been successfully submitted.
     Removes any errors.
    Resets text and preview.
    Resets buttons.
     */

    Notes.prototype.resetMainTargetForm = function (e) {
      var form;
      form = $(".js-main-target-form");
      // remove validation errors
      form.find(".js-errors").remove();
      // reset text and preview
      form.find(".js-md-write-button").click();
      form.find(".js-note-text").val("").trigger("input");
      form.find(".js-note-text").data("autosave").reset();

      var event = document.createEvent('Event');
      event.initEvent('autosize:update', true, false);
      form.find('.js-autosize')[0].dispatchEvent(event);

      this.updateTargetButtons(e);
    };

    Notes.prototype.reenableTargetFormSubmitButton = function () {
      var form;
      form = $(".js-main-target-form");
      return form.find(".js-note-text").trigger("input");
    };

    /*
    Shows the main form and does some setup on it.
     Sets some hidden fields in the form.
     */

    Notes.prototype.setupMainTargetNoteForm = function () {
      var form;
      // find the form
      form = $(".js-new-note-form");
      // Set a global clone of the form for later cloning
      this.formClone = form.clone();
      // show the form
      this.setupNoteForm(form);
      // fix classes
      form.removeClass("js-new-note-form");
      form.addClass("js-main-target-form");
      form.find("#note_line_code").remove();
      form.find("#note_position").remove();
      form.find("#note_type").val('');
      form.find("#in_reply_to_discussion_id").remove();
      form.find('.js-comment-resolve-button').closest('comment-and-resolve-btn').remove();
      this.parentTimeline = form.parents('.timeline');

      if (form.length) {
        Notes.initCommentTypeToggle(form.get(0));
      }
    };

    /*
    General note form setup.
     deactivates the submit button when text is empty
    hides the preview button when text is empty
    setup GFM auto complete
    show the form
     */

    Notes.prototype.setupNoteForm = function (form) {
      var textarea, key;
      new gl.GLForm(form);
      textarea = form.find(".js-note-text");
      key = ["Note", form.find("#note_noteable_type").val(), form.find("#note_noteable_id").val(), form.find("#note_commit_id").val(), form.find("#note_type").val(), form.find("#in_reply_to_discussion_id").val(),

      // LegacyDiffNote
      form.find("#note_line_code").val(),

      // DiffNote
      form.find("#note_position").val()];
      return new Autosave(textarea, key);
    };

    /*
    Called in response to the new note form being submitted
     Adds new note to list.
     */

    Notes.prototype.addNote = function (xhr, note, status) {
      this.handleCreateChanges(note);
      return this.renderNote(note);
    };

    Notes.prototype.addNoteError = function (xhr, note, status) {
      return new Flash('Your comment could not be submitted! Please check your network connection and try again.', 'alert', this.parentTimeline);
    };

    /*
    Called in response to the new note form being submitted
     Adds new note to list.
     */

    Notes.prototype.addDiscussionNote = function (xhr, note, status) {
      var $form = $(xhr.target);

      if ($form.attr('data-resolve-all') != null) {
        var projectPath = $form.data('project-path');
        var discussionId = $form.data('discussion-id');
        var mergeRequestId = $form.data('noteable-iid');

        if (ResolveService != null) {
          ResolveService.toggleResolveForDiscussion(mergeRequestId, discussionId);
        }
      }

      this.renderNote(note, $form);
      // cleanup after successfully creating a diff/discussion note
      this.removeDiscussionNoteForm($form);
    };

    /*
    Called in response to the edit note form being submitted
     Updates the current note field.
     */

    Notes.prototype.updateNote = function (_xhr, note, _status) {
      var $html, $note_li;
      // Convert returned HTML to a jQuery object so we can modify it further
      $html = $(note.html);
      this.revertNoteEditForm();
      gl.utils.localTimeAgo($('.js-timeago', $html));
      $html.renderGFM();
      $html.find('.js-task-list-container').taskList('enable');
      // Find the note's `li` element by ID and replace it with the updated HTML
      $note_li = $('.note-row-' + note.id);

      $note_li.replaceWith($html);

      if (typeof gl.diffNotesCompileComponents !== 'undefined') {
        gl.diffNotesCompileComponents();
      }
    };

    Notes.prototype.checkContentToAllowEditing = function ($el) {
      var initialContent = $el.find('.original-note-content').text().trim();
      var currentContent = $el.find('.note-textarea').val();
      var isAllowed = true;

      if (currentContent === initialContent) {
        this.removeNoteEditForm($el);
      } else {
        var $buttons = $el.find('.note-form-actions');
        var isWidgetVisible = gl.utils.isInViewport($el.get(0));

        if (!isWidgetVisible) {
          gl.utils.scrollToElement($el);
        }

        $el.find('.js-edit-warning').show();
        isAllowed = false;
      }

      return isAllowed;
    };

    /*
    Called in response to clicking the edit note link
     Replaces the note text with the note edit form
    Adds a data attribute to the form with the original content of the note for cancellations
    */
    Notes.prototype.showEditForm = function (e, scrollTo, myLastNote) {
      e.preventDefault();

      var $target = $(e.target);
      var $editForm = $(this.getEditFormSelector($target));
      var $note = $target.closest('.note');
      var $currentlyEditing = $('.note.is-editting:visible');

      if ($currentlyEditing.length) {
        var isEditAllowed = this.checkContentToAllowEditing($currentlyEditing);

        if (!isEditAllowed) {
          return;
        }
      }

      $note.find('.js-note-attachment-delete').show();
      $editForm.addClass('current-note-edit-form');
      $note.addClass('is-editting');
      this.putEditFormInPlace($target);
    };

    /*
    Called in response to clicking the edit note link
     Hides edit form and restores the original note text to the editor textarea.
     */

    Notes.prototype.cancelEdit = function (e) {
      e.preventDefault();
      var $target = $(e.target);
      var note = $target.closest('.note');
      note.find('.js-edit-warning').hide();
      this.revertNoteEditForm($target);
      return this.removeNoteEditForm(note);
    };

    Notes.prototype.revertNoteEditForm = function ($target) {
      $target = $target || $('.note.is-editting:visible');
      var selector = this.getEditFormSelector($target);
      var $editForm = $(selector);

      $editForm.insertBefore('.notes-form');
      $editForm.find('.js-comment-button').enable();
      $editForm.find('.js-edit-warning').hide();
    };

    Notes.prototype.getEditFormSelector = function ($el) {
      var selector = '.note-edit-form:not(.mr-note-edit-form)';

      if ($el.parents('#diffs').length) {
        selector = '.note-edit-form.mr-note-edit-form';
      }

      return selector;
    };

    Notes.prototype.removeNoteEditForm = function (note) {
      var form = note.find('.current-note-edit-form');
      note.removeClass('is-editting');
      form.removeClass('current-note-edit-form');
      form.find('.js-edit-warning').hide();
      // Replace markdown textarea text with original note text.
      return form.find('.js-note-text').val(form.find('form.edit-note').data('original-note'));
    };

    /*
    Called in response to deleting a note of any kind.
     Removes the actual note from view.
    Removes the whole discussion if the last note is being removed.
     */

    Notes.prototype.removeNote = function (e) {
      var noteElId, noteId, dataNoteId, $note, lineHolder;
      $note = $(e.currentTarget).closest('.note');
      noteElId = $note.attr('id');
      noteId = $note.attr('data-note-id');
      lineHolder = $(e.currentTarget).closest('.notes[data-discussion-id]').closest('.notes_holder').prev('.line_holder');
      $(".note[id='" + noteElId + "']").each(function (_this) {
        // A same note appears in the "Discussion" and in the "Changes" tab, we have
        // to remove all. Using $(".note[id='noteId']") ensure we get all the notes,
        // where $("#noteId") would return only one.
        return function (i, el) {
          var note, notes;
          note = $(el);
          notes = note.closest(".discussion-notes");

          if (typeof gl.diffNotesCompileComponents !== 'undefined') {
            if (gl.diffNoteApps[noteElId]) {
              gl.diffNoteApps[noteElId].$destroy();
            }
          }

          note.remove();

          // check if this is the last note for this line
          if (notes.find(".note").length === 0) {
            var notesTr = notes.closest("tr");

            // "Discussions" tab
            notes.closest(".timeline-entry").remove();

            // The notes tr can contain multiple lists of notes, like on the parallel diff
            if (notesTr.find('.discussion-notes').length > 1) {
              notes.remove();
            } else {
              notesTr.remove();
            }
          }
        };
      }(this));
      // Decrement the "Discussions" counter only once
      return this.updateNotesCount(-1);
    };

    /*
    Called in response to clicking the delete attachment link
     Removes the attachment wrapper view, including image tag if it exists
    Resets the note editing form
     */

    Notes.prototype.removeAttachment = function () {
      var note;
      note = $(this).closest(".note");
      note.find(".note-attachment").remove();
      note.find(".note-body > .note-text").show();
      note.find(".note-header").show();
      return note.find(".current-note-edit-form").remove();
    };

    /*
    Called when clicking on the "reply" button for a diff line.
     Shows the note form below the notes.
     */

    Notes.prototype.replyToDiscussionNote = function (e) {
      var form, replyLink;
      form = this.cleanForm(this.formClone.clone());
      replyLink = $(e.target).closest(".js-discussion-reply-button");
      // insert the form after the button
      replyLink.closest('.discussion-reply-holder').hide().after(form);
      // show the form
      return this.setupDiscussionNoteForm(replyLink, form);
    };

    /*
    Shows the diff or discussion form and does some setup on it.
     Sets some hidden fields in the form.
     Note: dataHolder must have the "discussionId" and "lineCode" data attributes set.
     */

    Notes.prototype.setupDiscussionNoteForm = function (dataHolder, form) {
      // setup note target
      var discussionID = dataHolder.data("discussionId");

      if (discussionID) {
        form.attr("data-discussion-id", discussionID);
        form.find("#in_reply_to_discussion_id").val(discussionID);
      }

      form.attr("data-line-code", dataHolder.data("lineCode"));
      form.find("#line_type").val(dataHolder.data("lineType"));

      form.find("#note_noteable_type").val(dataHolder.data("noteableType"));
      form.find("#note_noteable_id").val(dataHolder.data("noteableId"));
      form.find("#note_commit_id").val(dataHolder.data("commitId"));
      form.find("#note_type").val(dataHolder.data("noteType"));

      // LegacyDiffNote
      form.find("#note_line_code").val(dataHolder.data("lineCode"));

      // DiffNote
      form.find("#note_position").val(dataHolder.attr("data-position"));

      form.find('.js-note-discard').show().removeClass('js-note-discard').addClass('js-close-discussion-note-form').text(form.find('.js-close-discussion-note-form').data('cancel-text'));
      form.find('.js-note-target-close').remove();
      form.find('.js-note-new-discussion').remove();
      this.setupNoteForm(form);

      form.removeClass('js-main-target-form').addClass("discussion-form js-discussion-note-form");

      if (typeof gl.diffNotesCompileComponents !== 'undefined') {
        var $commentBtn = form.find('comment-and-resolve-btn');
        $commentBtn.attr(':discussion-id', '\'' + discussionID + '\'');

        gl.diffNotesCompileComponents();
      }

      form.find(".js-note-text").focus();
      form.find('.js-comment-resolve-button').attr('data-discussion-id', discussionID);
    };

    /*
    Called when clicking on the "add a comment" button on the side of a diff line.
     Inserts a temporary row for the form below the line.
    Sets up the form and shows it.
     */

    Notes.prototype.addDiffNote = function (e) {
      var $link, addForm, hasNotes, lineType, newForm, nextRow, noteForm, notesContent, notesContentSelector, replyButton, row, rowCssToAdd, targetContent, isDiffCommentAvatar;
      e.preventDefault();
      $link = $(e.currentTarget || e.target);
      row = $link.closest("tr");
      nextRow = row.next();
      hasNotes = nextRow.is(".notes_holder");
      addForm = false;
      notesContentSelector = ".notes_content";
      rowCssToAdd = "<tr class=\"notes_holder js-temp-notes-holder\"><td class=\"notes_line\" colspan=\"2\"></td><td class=\"notes_content\"><div class=\"content\"></div></td></tr>";
      isDiffCommentAvatar = $link.hasClass('js-diff-comment-avatar');
      // In parallel view, look inside the correct left/right pane
      if (this.isParallelView()) {
        lineType = $link.data("lineType");
        notesContentSelector += "." + lineType;
        rowCssToAdd = "<tr class=\"notes_holder js-temp-notes-holder\"><td class=\"notes_line old\"></td><td class=\"notes_content parallel old\"><div class=\"content\"></div></td><td class=\"notes_line new\"></td><td class=\"notes_content parallel new\"><div class=\"content\"></div></td></tr>";
      }
      notesContentSelector += " .content";
      notesContent = nextRow.find(notesContentSelector);

      if (hasNotes && !isDiffCommentAvatar) {
        nextRow.show();
        notesContent = nextRow.find(notesContentSelector);
        if (notesContent.length) {
          notesContent.show();
          replyButton = notesContent.find(".js-discussion-reply-button:visible");
          if (replyButton.length) {
            e.target = replyButton[0];
            $.proxy(this.replyToDiscussionNote, replyButton[0], e).call();
          } else {
            // In parallel view, the form may not be present in one of the panes
            noteForm = notesContent.find(".js-discussion-note-form");
            if (noteForm.length === 0) {
              addForm = true;
            }
          }
        }
      } else if (!isDiffCommentAvatar) {
        // add a notes row and insert the form
        row.after(rowCssToAdd);
        nextRow = row.next();
        notesContent = nextRow.find(notesContentSelector);
        addForm = true;
      } else {
        nextRow.show();
        notesContent.toggle(!notesContent.is(':visible'));

        if (!nextRow.find('.content:not(:empty)').is(':visible')) {
          nextRow.hide();
        }
      }

      if (addForm) {
        newForm = this.cleanForm(this.formClone.clone());
        newForm.appendTo(notesContent);
        // show the form
        return this.setupDiscussionNoteForm($link, newForm);
      }
    };

    /*
    Called in response to "cancel" on a diff note form.
     Shows the reply button again.
    Removes the form and if necessary it's temporary row.
     */

    Notes.prototype.removeDiscussionNoteForm = function (form) {
      var glForm, row;
      row = form.closest("tr");
      glForm = form.data('gl-form');
      glForm.destroy();
      form.find(".js-note-text").data("autosave").reset();
      // show the reply button (will only work for replies)
      form.prev('.discussion-reply-holder').show();
      if (row.is(".js-temp-notes-holder")) {
        // remove temporary row for diff lines
        return row.remove();
      } else {
        // only remove the form
        return form.remove();
      }
    };

    Notes.prototype.cancelDiscussionForm = function (e) {
      var form;
      e.preventDefault();
      form = $(e.target).closest(".js-discussion-note-form");
      return this.removeDiscussionNoteForm(form);
    };

    /*
    Called after an attachment file has been selected.
     Updates the file name for the selected attachment.
     */

    Notes.prototype.updateFormAttachment = function () {
      var filename, form;
      form = $(this).closest("form");
      // get only the basename
      filename = $(this).val().replace(/^.*[\\\/]/, "");
      return form.find(".js-attachment-filename").text(filename);
    };

    /*
    Called when the tab visibility changes
     */

    Notes.prototype.visibilityChange = function () {
      return this.refresh();
    };

    Notes.prototype.updateCloseButton = function (e) {
      var closebtn, form, textarea;
      textarea = $(e.target);
      form = textarea.parents('form');
      closebtn = form.find('.js-note-target-close');
      return closebtn.text(closebtn.data('original-text'));
    };

    Notes.prototype.updateTargetButtons = function (e) {
      var closebtn, closetext, discardbtn, form, reopenbtn, reopentext, textarea;
      textarea = $(e.target);
      form = textarea.parents('form');
      reopenbtn = form.find('.js-note-target-reopen');
      closebtn = form.find('.js-note-target-close');
      discardbtn = form.find('.js-note-discard');

      if (textarea.val().trim().length > 0) {
        reopentext = reopenbtn.attr('data-alternative-text');
        closetext = closebtn.attr('data-alternative-text');
        if (reopenbtn.text() !== reopentext) {
          reopenbtn.text(reopentext);
        }
        if (closebtn.text() !== closetext) {
          closebtn.text(closetext);
        }
        if (reopenbtn.is(':not(.btn-comment-and-reopen)')) {
          reopenbtn.addClass('btn-comment-and-reopen');
        }
        if (closebtn.is(':not(.btn-comment-and-close)')) {
          closebtn.addClass('btn-comment-and-close');
        }
        if (discardbtn.is(':hidden')) {
          return discardbtn.show();
        }
      } else {
        reopentext = reopenbtn.data('original-text');
        closetext = closebtn.data('original-text');
        if (reopenbtn.text() !== reopentext) {
          reopenbtn.text(reopentext);
        }
        if (closebtn.text() !== closetext) {
          closebtn.text(closetext);
        }
        if (reopenbtn.is('.btn-comment-and-reopen')) {
          reopenbtn.removeClass('btn-comment-and-reopen');
        }
        if (closebtn.is('.btn-comment-and-close')) {
          closebtn.removeClass('btn-comment-and-close');
        }
        if (discardbtn.is(':visible')) {
          return discardbtn.hide();
        }
      }
    };

    Notes.prototype.putEditFormInPlace = function ($el) {
      var $editForm = $(this.getEditFormSelector($el));
      var $note = $el.closest('.note');

      $editForm.insertAfter($note.find('.note-text'));

      var $originalContentEl = $note.find('.original-note-content');
      var originalContent = $originalContentEl.text().trim();
      var postUrl = $originalContentEl.data('post-url');
      var targetId = $originalContentEl.data('target-id');
      var targetType = $originalContentEl.data('target-type');

      new gl.GLForm($editForm.find('form'));

      $editForm.find('form').attr('action', postUrl).attr('data-remote', 'true');
      $editForm.find('.js-form-target-id').val(targetId);
      $editForm.find('.js-form-target-type').val(targetType);
      $editForm.find('.js-note-text').focus().val(originalContent);
      $editForm.find('.js-md-write-button').trigger('click');
      $editForm.find('.referenced-users').hide();
    };

    Notes.prototype.updateNotesCount = function (updateCount) {
      return this.notesCountBadge.text(parseInt(this.notesCountBadge.text(), 10) + updateCount);
    };

    Notes.prototype.resolveDiscussion = function () {
      var $this = $(this);
      var discussionId = $this.attr('data-discussion-id');

      $this.closest('form').attr('data-discussion-id', discussionId).attr('data-resolve-all', 'true').attr('data-project-path', $this.attr('data-project-path'));
    };

    Notes.prototype.toggleCommitList = function (e) {
      var $element = $(e.currentTarget);
      var $closestSystemCommitList = $element.siblings('.system-note-commit-list');

      $element.find('.fa').toggleClass('fa-angle-down').toggleClass('fa-angle-up');
      $closestSystemCommitList.toggleClass('hide-shade');
    };

    /**
    Scans system notes with `ul` elements in system note body
    then collapse long commit list pushed by user to make it less
    intrusive.
     */
    Notes.prototype.collapseLongCommitList = function () {
      var systemNotes = $('#notes-list').find('li.system-note').has('ul');

      $.each(systemNotes, function (index, systemNote) {
        var $systemNote = $(systemNote);
        var headerMessage = $systemNote.find('.note-text').find('p:first').text().replace(':', '');

        $systemNote.find('.note-header .system-note-message').html(headerMessage);

        if ($systemNote.find('li').length > MAX_VISIBLE_COMMIT_LIST_COUNT) {
          $systemNote.find('.note-text').addClass('system-note-commit-list');
          $systemNote.find('.system-note-commit-list-toggler').show();
        } else {
          $systemNote.find('.note-text').addClass('system-note-commit-list hide-shade');
        }
      });
    };

    Notes.prototype.cleanForm = function ($form) {
      // Remove JS classes that are not needed here
      $form.find('.js-comment-type-dropdown').removeClass('btn-group');

      // Remove dropdown
      $form.find('.dropdown-menu').remove();

      return $form;
    };

    return Notes;
  }();
}).call(window);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("lwLq")))

/***/ }),

/***/ "djKQ":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable func-names, space-before-function-paren, max-len, no-var, one-var, no-restricted-syntax, vars-on-top, no-use-before-define, no-param-reassign, new-cap, no-underscore-dangle, wrap-iife, max-len */
/* global Mousetrap */
/* global ShortcutsNavigation */

__webpack_require__("/3Gu");

(function () {
  var extend = function extend(child, parent) {
    for (var key in parent) {
      if (hasProp.call(parent, key)) child[key] = parent[key];
    }function ctor() {
      this.constructor = child;
    }ctor.prototype = parent.prototype;child.prototype = new ctor();child.__super__ = parent.prototype;return child;
  },
      hasProp = {}.hasOwnProperty;

  this.ShortcutsNetwork = function (superClass) {
    extend(ShortcutsNetwork, superClass);

    function ShortcutsNetwork(graph) {
      this.graph = graph;
      ShortcutsNetwork.__super__.constructor.call(this);
      Mousetrap.bind(['left', 'h'], this.graph.scrollLeft);
      Mousetrap.bind(['right', 'l'], this.graph.scrollRight);
      Mousetrap.bind(['up', 'k'], this.graph.scrollUp);
      Mousetrap.bind(['down', 'j'], this.graph.scrollDown);
      Mousetrap.bind(['shift+up', 'shift+k'], this.graph.scrollTop);
      Mousetrap.bind(['shift+down', 'shift+j'], this.graph.scrollBottom);
      this.enabledHelp.push('.hidden-shortcut.network');
    }

    return ShortcutsNetwork;
  }(ShortcutsNavigation);
}).call(window);

/***/ }),

/***/ "eitI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__("lwLq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore__ = __webpack_require__("9eM+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie__ = __webpack_require__("yoQO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pikaday__ = __webpack_require__("ksyN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pikaday___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_pikaday__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_dropzone__ = __webpack_require__("Qepg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vendor_Sortable__ = __webpack_require__("qmzy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vendor_Sortable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vendor_Sortable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mousetrap__ = __webpack_require__("b2AJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mousetrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_mousetrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mousetrap_plugins_pause_mousetrap_pause__ = __webpack_require__("4f1f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_mousetrap_plugins_pause_mousetrap_pause___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_mousetrap_plugins_pause_mousetrap_pause__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vendor_fuzzaldrin_plus__ = __webpack_require__("jdYI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vendor_fuzzaldrin_plus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vendor_fuzzaldrin_plus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__extensions_array__ = __webpack_require__("zv24");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__extensions_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__extensions_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shortcuts__ = __webpack_require__("Sl/F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shortcuts_blob__ = __webpack_require__("/YCK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shortcuts_blob___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__shortcuts_blob__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shortcuts_dashboard_navigation__ = __webpack_require__("vckv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shortcuts_navigation__ = __webpack_require__("/3Gu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__shortcuts_find_file__ = __webpack_require__("hGiy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__shortcuts_find_file___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__shortcuts_find_file__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__shortcuts_issuable__ = __webpack_require__("Xzwk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__shortcuts_issuable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__shortcuts_issuable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__shortcuts_network__ = __webpack_require__("djKQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__shortcuts_network___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__shortcuts_network__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__behaviors___ = __webpack_require__("51yH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__blob_create_branch_dropdown__ = __webpack_require__("+y4v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__blob_create_branch_dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__blob_create_branch_dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__blob_target_branch_dropdown__ = __webpack_require__("pJ4l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__blob_target_branch_dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__blob_target_branch_dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__templates_issuable_template_selector__ = __webpack_require__("u1Ad");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__templates_issuable_template_selectors__ = __webpack_require__("N9Tt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__templates_issuable_template_selectors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__templates_issuable_template_selectors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__commit_file__ = __webpack_require__("0esH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__commit_file___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__commit_file__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__commit_image_file__ = __webpack_require__("EKdV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__commit_image_file___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__commit_image_file__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__lib_utils_animate__ = __webpack_require__("jQR1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__lib_utils_animate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__lib_utils_animate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__lib_utils_bootstrap_linked_tabs__ = __webpack_require__("ZORs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__lib_utils_bootstrap_linked_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__lib_utils_bootstrap_linked_tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__lib_utils_common_utils__ = __webpack_require__("RsTm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__lib_utils_common_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__lib_utils_common_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__lib_utils_datetime_utility__ = __webpack_require__("pRPh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__lib_utils_datetime_utility___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__lib_utils_datetime_utility__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__lib_utils_notify__ = __webpack_require__("JSKa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__lib_utils_notify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__lib_utils_notify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__lib_utils_pretty_time__ = __webpack_require__("I8f0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__lib_utils_pretty_time___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__lib_utils_pretty_time__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__lib_utils_text_utility__ = __webpack_require__("A+3H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__lib_utils_text_utility___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__lib_utils_text_utility__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__lib_utils_type_utility__ = __webpack_require__("TWsL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__lib_utils_type_utility___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__lib_utils_type_utility__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__lib_utils_url_utility__ = __webpack_require__("2iOG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__lib_utils_url_utility___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__lib_utils_url_utility__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__u2f_authenticate__ = __webpack_require__("vfNn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__u2f_authenticate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__u2f_authenticate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__u2f_error__ = __webpack_require__("wtTe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__u2f_error___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__u2f_error__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__u2f_register__ = __webpack_require__("tI6A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__u2f_register___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__u2f_register__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__u2f_util__ = __webpack_require__("TA5E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__u2f_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__u2f_util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__abuse_reports__ = __webpack_require__("jgNA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__abuse_reports___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__abuse_reports__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__activities__ = __webpack_require__("f9QQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__admin__ = __webpack_require__("2xbY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__admin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__admin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__ajax_loading_spinner__ = __webpack_require__("2nfG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__ajax_loading_spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__ajax_loading_spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__api__ = __webpack_require__("fitr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__api___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__api__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__aside__ = __webpack_require__("cRIW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__aside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__aside__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__autosave__ = __webpack_require__("+Y/g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__autosave___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__autosave__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__awards_handler__ = __webpack_require__("sv8m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__breakpoints__ = __webpack_require__("LINv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__breakpoints___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__breakpoints__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__broadcast_message__ = __webpack_require__("9ZE/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__broadcast_message___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__broadcast_message__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__build__ = __webpack_require__("nsGX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__build_artifacts__ = __webpack_require__("JAXo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__build_artifacts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48__build_artifacts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__build_variables__ = __webpack_require__("OwTH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__build_variables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49__build_variables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__ci_lint_editor__ = __webpack_require__("Pw5p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__ci_lint_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50__ci_lint_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__commit__ = __webpack_require__("tZLB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__commit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51__commit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__commits__ = __webpack_require__("foE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__commits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52__commits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__compare__ = __webpack_require__("XMDg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__compare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53__compare__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__compare_autocomplete__ = __webpack_require__("dTE/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__compare_autocomplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54__compare_autocomplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__confirm_danger_modal__ = __webpack_require__("vOe4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__confirm_danger_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55__confirm_danger_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__copy_as_gfm__ = __webpack_require__("38m2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__copy_as_gfm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56__copy_as_gfm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__copy_to_clipboard__ = __webpack_require__("VuBo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__create_label__ = __webpack_require__("S1Cs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__create_label___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_58__create_label__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__diff__ = __webpack_require__("qr6X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__diff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_59__diff__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__dispatcher__ = __webpack_require__("MKXP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__dropzone_input__ = __webpack_require__("r5TZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__dropzone_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_61__dropzone_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__due_date_select__ = __webpack_require__("Tzl9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__due_date_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_62__due_date_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__files_comment_button__ = __webpack_require__("CH+5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__files_comment_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_63__files_comment_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__flash__ = __webpack_require__("nYQN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__flash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_64__flash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__gfm_auto_complete__ = __webpack_require__("0/gX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__gl_dropdown__ = __webpack_require__("MIHg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__gl_dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_66__gl_dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__gl_field_error__ = __webpack_require__("2lN2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__gl_field_error___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_67__gl_field_error__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__gl_field_errors__ = __webpack_require__("GEo8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__gl_field_errors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_68__gl_field_errors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__gl_form__ = __webpack_require__("pVjb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__gl_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_69__gl_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__group_avatar__ = __webpack_require__("UK9k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__group_avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_70__group_avatar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__group_label_subscription__ = __webpack_require__("ucU0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__group_label_subscription___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_71__group_label_subscription__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__groups_select__ = __webpack_require__("PQIw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__groups_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_72__groups_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__header__ = __webpack_require__("BInT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_73__header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__importer_status__ = __webpack_require__("URhJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__importer_status___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_74__importer_status__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__issuable__ = __webpack_require__("dF5a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__issuable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_75__issuable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__issuable_context__ = __webpack_require__("FHk+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__issuable_form__ = __webpack_require__("a9uE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__issuable_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_77__issuable_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__issue__ = __webpack_require__("cMCw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__issue_status_select__ = __webpack_require__("ChLi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__issue_status_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_79__issue_status_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__issues_bulk_assignment__ = __webpack_require__("f81c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__issues_bulk_assignment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_80__issues_bulk_assignment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__label_manager__ = __webpack_require__("css6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__label_manager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_81__label_manager__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__labels__ = __webpack_require__("KA6S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__labels___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_82__labels__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__labels_select__ = __webpack_require__("n+MV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__labels_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_83__labels_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__layout_nav__ = __webpack_require__("wmIu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__layout_nav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_84__layout_nav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__line_highlighter__ = __webpack_require__("+CTv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__line_highlighter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_85__line_highlighter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__logo__ = __webpack_require__("zzV7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__logo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_86__logo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__member_expiration_date__ = __webpack_require__("f+kI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__member_expiration_date___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_87__member_expiration_date__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__members__ = __webpack_require__("4UWX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__members___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_88__members__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__merge_request__ = __webpack_require__("nIl8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__merge_request___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_89__merge_request__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__merge_request_tabs__ = __webpack_require__("Yr+x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__merge_request_widget__ = __webpack_require__("QJd+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__merged_buttons__ = __webpack_require__("nMf0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__merged_buttons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_92__merged_buttons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__milestone__ = __webpack_require__("722W");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__milestone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_93__milestone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__milestone_select__ = __webpack_require__("+n1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__milestone_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_94__milestone_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__mini_pipeline_graph_dropdown__ = __webpack_require__("6cNp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__namespace_select__ = __webpack_require__("GCD9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__namespace_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_96__namespace_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__new_branch_form__ = __webpack_require__("EuaS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__new_branch_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_97__new_branch_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__new_commit_form__ = __webpack_require__("qs7a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__new_commit_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_98__new_commit_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__notes__ = __webpack_require__("dekX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__notifications_dropdown__ = __webpack_require__("awgk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__notifications_dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_100__notifications_dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__notifications_form__ = __webpack_require__("HuIY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__notifications_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_101__notifications_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__pager__ = __webpack_require__("wstl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__pager___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_102__pager__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__pipelines__ = __webpack_require__("o4Ji");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__pipelines___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_103__pipelines__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__preview_markdown__ = __webpack_require__("25vu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__preview_markdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_104__preview_markdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__project__ = __webpack_require__("wrBJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__project_avatar__ = __webpack_require__("rd/T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__project_avatar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_106__project_avatar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__project_find_file__ = __webpack_require__("wqCH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__project_find_file___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_107__project_find_file__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__project_fork__ = __webpack_require__("xUX4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__project_fork___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_108__project_fork__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__project_import__ = __webpack_require__("kdHk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__project_import___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_109__project_import__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__project_label_subscription__ = __webpack_require__("ztjw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__project_label_subscription___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_110__project_label_subscription__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__project_new__ = __webpack_require__("G2NG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__project_new___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_111__project_new__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__project_select__ = __webpack_require__("rs3V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__project_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_112__project_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__project_show__ = __webpack_require__("7cT8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__project_show___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_113__project_show__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__project_variables__ = __webpack_require__("lu3/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__project_variables___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_114__project_variables__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__projects_list__ = __webpack_require__("KA+m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__render_gfm__ = __webpack_require__("BO5O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__render_gfm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_116__render_gfm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117__render_math__ = __webpack_require__("pynW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117__render_math___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_117__render_math__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118__right_sidebar__ = __webpack_require__("Qlrq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119__search__ = __webpack_require__("mCVl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119__search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_119__search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120__search_autocomplete__ = __webpack_require__("UqoV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120__search_autocomplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_120__search_autocomplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121__signin_tabs_memoizer__ = __webpack_require__("aWWo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121__signin_tabs_memoizer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_121__signin_tabs_memoizer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122__single_file_diff__ = __webpack_require__("IRlT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122__single_file_diff___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_122__single_file_diff__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123__smart_interval__ = __webpack_require__("EQHa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123__smart_interval___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_123__smart_interval__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124__snippets_list__ = __webpack_require__("sAqb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124__snippets_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_124__snippets_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125__star__ = __webpack_require__("4PsW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125__star___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_125__star__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_126__subbable_resource__ = __webpack_require__("OX5X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_126__subbable_resource___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_126__subbable_resource__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_127__subscription__ = __webpack_require__("6sPP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_127__subscription___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_127__subscription__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_128__subscription_select__ = __webpack_require__("7bfy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_128__subscription_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_128__subscription_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_129__syntax_highlight__ = __webpack_require__("SSWZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_129__syntax_highlight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_129__syntax_highlight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_130__task_list__ = __webpack_require__("3uF6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_130__task_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_130__task_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_131__todos__ = __webpack_require__("JB8C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_131__todos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_131__todos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_132__tree__ = __webpack_require__("rIn1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_132__tree___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_132__tree__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_133__usage_ping__ = __webpack_require__("6JIX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_133__usage_ping___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_133__usage_ping__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_134__user__ = __webpack_require__("Mv3y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_135__user_tabs__ = __webpack_require__("E+6d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_135__user_tabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_135__user_tabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_136__username_validator__ = __webpack_require__("KLXO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_136__username_validator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_136__username_validator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_137__users_select__ = __webpack_require__("378X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_137__users_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_137__users_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_138__version_check_image__ = __webpack_require__("o5lJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_138__version_check_image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_138__version_check_image__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_139__visibility_select__ = __webpack_require__("bOHH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_139__visibility_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_139__visibility_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_140__wikis__ = __webpack_require__("LQkq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_140__wikis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_140__wikis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_141__zen_mode__ = __webpack_require__("vd0+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_141__zen_mode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_141__zen_mode__);
/* eslint-disable func-names, space-before-function-paren, no-var, quotes, consistent-return, prefer-arrow-callback, comma-dangle, object-shorthand, no-new, max-len, no-multi-spaces, import/newline-after-import, import/first */
/* global bp */
/* global Flash */
/* global ConfirmDangerModal */
/* global Aside */








// libraries with import side-effects




// extensions


// expose common libraries as globals (TODO: remove these)
window.jQuery = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;
window.$ = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a;
window._ = __WEBPACK_IMPORTED_MODULE_1_underscore___default.a;
window.Pikaday = __WEBPACK_IMPORTED_MODULE_3_pikaday___default.a;
window.Dropzone = __WEBPACK_IMPORTED_MODULE_4_dropzone___default.a;
window.Sortable = __WEBPACK_IMPORTED_MODULE_5_vendor_Sortable___default.a;

// shortcuts








// behaviors


// blob



// templates



// commit



// lib/utils










// u2f





// everything else










































































































// eslint-disable-next-line global-require
if (false) require('./test_utils/');

document.addEventListener('beforeunload', function () {
  // Unbind scroll events
  $(document).off('scroll');
  // Close any open tooltips
  $('.has-tooltip, [data-toggle="tooltip"]').tooltip('destroy');
});

window.addEventListener('hashchange', gl.utils.handleLocationHash);
window.addEventListener('load', function onLoad() {
  window.removeEventListener('load', onLoad, false);
  gl.utils.handleLocationHash();
}, false);

$(function () {
  var $body = $('body');
  var $document = $(document);
  var $window = $(window);
  var $sidebarGutterToggle = $('.js-sidebar-toggle');
  var $flash = $('.flash-container');
  var bootstrapBreakpoint = bp.getBreakpointSize();
  var fitSidebarForSize;

  // Set the default path for all cookies to GitLab's root directory
  __WEBPACK_IMPORTED_MODULE_2_js_cookie___default.a.defaults.path = gon.relative_url_root || '/';

  // `hashchange` is not triggered when link target is already in window.location
  $body.on('click', 'a[href^="#"]', function () {
    var href = this.getAttribute('href');
    if (href.substr(1) === gl.utils.getLocationHash()) {
      setTimeout(gl.utils.handleLocationHash, 1);
    }
  });

  // prevent default action for disabled buttons
  $('.btn').click(function (e) {
    if ($(this).hasClass('disabled')) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return false;
    }
  });

  $('.js-select-on-focus').on('focusin', function () {
    return $(this).select().one('mouseup', function (e) {
      return e.preventDefault();
    });
    // Click a .js-select-on-focus field, select the contents
    // Prevent a mouseup event from deselecting the input
  });
  $('.remove-row').bind('ajax:success', function () {
    $(this).tooltip('destroy').closest('li').fadeOut();
  });
  $('.js-remove-tr').bind('ajax:before', function () {
    return $(this).hide();
  });
  $('.js-remove-tr').bind('ajax:success', function () {
    return $(this).closest('tr').fadeOut();
  });
  $('select.select2').select2({
    width: 'resolve',
    // Initialize select2 selects
    dropdownAutoWidth: true
  });
  $('.js-select2').bind('select2-close', function () {
    return setTimeout(function () {
      $('.select2-container-active').removeClass('select2-container-active');
      return $(':focus').blur();
    }, 1);
    // Close select2 on escape
  });
  // Initialize tooltips
  $.fn.tooltip.Constructor.DEFAULTS.trigger = 'hover';
  $body.tooltip({
    selector: '.has-tooltip, [data-toggle="tooltip"]',
    placement: function placement(tip, el) {
      return $(el).data('placement') || 'bottom';
    }
  });
  $('.trigger-submit').on('change', function () {
    return $(this).parents('form').submit();
    // Form submitter
  });
  gl.utils.localTimeAgo($('abbr.timeago, .js-timeago'), true);
  // Flash
  if ($flash.length > 0) {
    $flash.click(function () {
      return $(this).fadeOut();
    });
    $flash.show();
  }
  // Disable form buttons while a form is submitting
  $body.on('ajax:complete, ajax:beforeSend, submit', 'form', function (e) {
    var buttons;
    buttons = $('[type="submit"], .js-disable-on-submit', this);
    switch (e.type) {
      case 'ajax:beforeSend':
      case 'submit':
        return buttons.disable();
      default:
        return buttons.enable();
    }
  });
  $(document).ajaxError(function (e, xhrObj) {
    var ref = xhrObj.status;
    if (xhrObj.status === 401) {
      return new Flash('You need to be logged in.', 'alert');
    } else if (ref === 404 || ref === 500) {
      return new Flash('Something went wrong on our end.', 'alert');
    }
  });
  $('.account-box').hover(function () {
    // Show/Hide the profile menu when hovering the account box
    return $(this).toggleClass('hover');
  });
  $document.on('click', '.diff-content .js-show-suppressed-diff', function () {
    var $container;
    $container = $(this).parent();
    $container.next('table').show();
    return $container.remove();
    // Commit show suppressed diff
  });
  $('.navbar-toggle').on('click', function () {
    $('.header-content .title').toggle();
    $('.header-content .header-logo').toggle();
    $('.header-content .navbar-collapse').toggle();
    return $('.navbar-toggle').toggleClass('active');
  });
  // Show/hide comments on diff
  $body.on('click', '.js-toggle-diff-comments', function (e) {
    var $this = $(this);
    var notesHolders = $this.closest('.diff-file').find('.notes_holder');
    $this.toggleClass('active');
    if ($this.hasClass('active')) {
      notesHolders.show().find('.hide, .content').show();
    } else {
      notesHolders.hide().find('.content').hide();
    }
    $(document).trigger('toggle.comments');
    return e.preventDefault();
  });
  $document.off('click', '.js-confirm-danger');
  $document.on('click', '.js-confirm-danger', function (e) {
    var btn = $(e.target);
    var form = btn.closest('form');
    var text = btn.data('confirm-danger-message');
    e.preventDefault();
    return new ConfirmDangerModal(form, text);
  });
  $('input[type="search"]').each(function () {
    var $this = $(this);
    $this.attr('value', $this.val());
  });
  $document.off('keyup', 'input[type="search"]').on('keyup', 'input[type="search"]', function () {
    var $this;
    $this = $(this);
    return $this.attr('value', $this.val());
  });
  $document.off('breakpoint:change').on('breakpoint:change', function (e, breakpoint) {
    var $gutterIcon;
    if (breakpoint === 'sm' || breakpoint === 'xs') {
      $gutterIcon = $sidebarGutterToggle.find('i');
      if ($gutterIcon.hasClass('fa-angle-double-right')) {
        return $sidebarGutterToggle.trigger('click');
      }
    }
  });
  fitSidebarForSize = function fitSidebarForSize() {
    var oldBootstrapBreakpoint;
    oldBootstrapBreakpoint = bootstrapBreakpoint;
    bootstrapBreakpoint = bp.getBreakpointSize();
    if (bootstrapBreakpoint !== oldBootstrapBreakpoint) {
      return $document.trigger('breakpoint:change', [bootstrapBreakpoint]);
    }
  };
  $window.off('resize.app').on('resize.app', function () {
    return fitSidebarForSize();
  });
  gl.awardsHandler = new __WEBPACK_IMPORTED_MODULE_44__awards_handler__["a" /* default */]();
  new Aside();

  gl.utils.initTimeagoTimeout();

  $(document).trigger('init.scrolling-tabs');
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("lwLq")))

/***/ }),

/***/ "f+kI":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* global Pikaday */
/* global dateFormat */
(function () {
  // Add datepickers to all `js-access-expiration-date` elements. If those elements are
  // children of an element with the `clearable-input` class, and have a sibling
  // `js-clear-input` element, then show that element when there is a value in the
  // datepicker, and make clicking on that element clear the field.
  //
  window.gl = window.gl || {};
  gl.MemberExpirationDate = function () {
    var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '.js-access-expiration-date';

    function toggleClearInput() {
      $(this).closest('.clearable-input').toggleClass('has-value', $(this).val() !== '');
    }
    var inputs = $(selector);

    inputs.each(function (i, el) {
      var $input = $(el);

      var calendar = new Pikaday({
        field: $input.get(0),
        theme: 'gitlab-theme',
        format: 'yyyy-mm-dd',
        minDate: new Date(),
        onSelect: function onSelect(dateText) {
          $input.val(dateFormat(new Date(dateText), 'yyyy-mm-dd'));

          $input.trigger('change');

          toggleClearInput.call($input);
        }
      });

      calendar.setDate(new Date($input.val()));
      $input.data('pikaday', calendar);
    });

    inputs.next('.js-clear-input').on('click', function clicked(event) {
      event.preventDefault();

      var input = $(this).closest('.clearable-input').find(selector);
      var calendar = input.data('pikaday');

      calendar.setDate(null);
      input.trigger('change');
      toggleClearInput.call(input);
    });

    inputs.on('blur', toggleClearInput);

    inputs.each(toggleClearInput);
  };
}).call(window);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "f81c":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable comma-dangle, quotes, consistent-return, func-names, array-callback-return, space-before-function-paren, prefer-arrow-callback, max-len, no-unused-expressions, no-sequences, no-underscore-dangle, no-unused-vars, no-param-reassign */
/* global Issuable */
/* global Flash */

(function (global) {
  var IssuableBulkActions = function () {
    function IssuableBulkActions() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          container = _ref.container,
          form = _ref.form,
          issues = _ref.issues,
          prefixId = _ref.prefixId;

      _classCallCheck(this, IssuableBulkActions);

      this.prefixId = prefixId || 'issue_';
      this.form = form || this.getElement('.bulk-update');
      this.$labelDropdown = this.form.find('.js-label-select');
      this.issues = issues || this.getElement('.issues-list .issue');
      this.form.data('bulkActions', this);
      this.willUpdateLabels = false;
      this.bindEvents();
      // Fixes bulk-assign not working when navigating through pages
      Issuable.initChecks();
    }

    _createClass(IssuableBulkActions, [{
      key: 'bindEvents',
      value: function bindEvents() {
        return this.form.off('submit').on('submit', this.onFormSubmit.bind(this));
      }
    }, {
      key: 'onFormSubmit',
      value: function onFormSubmit(e) {
        e.preventDefault();
        return this.submit();
      }
    }, {
      key: 'submit',
      value: function submit() {
        var _this = this;
        var xhr = $.ajax({
          url: this.form.attr('action'),
          method: this.form.attr('method'),
          dataType: 'JSON',
          data: this.getFormDataAsObject()
        });
        xhr.done(function () {
          return window.location.reload();
        });
        xhr.fail(function () {
          return new Flash("Issue update failed");
        });
        return xhr.always(this.onFormSubmitAlways.bind(this));
      }
    }, {
      key: 'onFormSubmitAlways',
      value: function onFormSubmitAlways() {
        return this.form.find('[type="submit"]').enable();
      }
    }, {
      key: 'getSelectedIssues',
      value: function getSelectedIssues() {
        return this.issues.has('.selected_issue:checked');
      }
    }, {
      key: 'getLabelsFromSelection',
      value: function getLabelsFromSelection() {
        var labels = [];
        this.getSelectedIssues().map(function () {
          var labelsData = $(this).data('labels');
          if (labelsData) {
            return labelsData.map(function (labelId) {
              if (labels.indexOf(labelId) === -1) {
                return labels.push(labelId);
              }
            });
          }
        });
        return labels;
      }

      /**
       * Will return only labels that were marked previously and the user has unmarked
       * @return {Array} Label IDs
       */

    }, {
      key: 'getUnmarkedIndeterminedLabels',
      value: function getUnmarkedIndeterminedLabels() {
        var result = [];
        var labelsToKeep = this.$labelDropdown.data('indeterminate');

        this.getLabelsFromSelection().forEach(function (id) {
          if (labelsToKeep.indexOf(id) === -1) {
            result.push(id);
          }
        });

        return result;
      }

      /**
       * Simple form serialization, it will return just what we need
       * Returns key/value pairs from form data
       */

    }, {
      key: 'getFormDataAsObject',
      value: function getFormDataAsObject() {
        var formData = {
          update: {
            state_event: this.form.find('input[name="update[state_event]"]').val(),
            assignee_id: this.form.find('input[name="update[assignee_id]"]').val(),
            milestone_id: this.form.find('input[name="update[milestone_id]"]').val(),
            issuable_ids: this.form.find('input[name="update[issuable_ids]"]').val(),
            subscription_event: this.form.find('input[name="update[subscription_event]"]').val(),
            add_label_ids: [],
            remove_label_ids: []
          }
        };
        if (this.willUpdateLabels) {
          formData.update.add_label_ids = this.$labelDropdown.data('marked');
          formData.update.remove_label_ids = this.$labelDropdown.data('unmarked');
        }
        return formData;
      }
    }, {
      key: 'setOriginalDropdownData',
      value: function setOriginalDropdownData() {
        var $labelSelect = $('.bulk-update .js-label-select');
        $labelSelect.data('common', this.getOriginalCommonIds());
        $labelSelect.data('marked', this.getOriginalMarkedIds());
        $labelSelect.data('indeterminate', this.getOriginalIndeterminateIds());
      }

      // From issuable's initial bulk selection

    }, {
      key: 'getOriginalCommonIds',
      value: function getOriginalCommonIds() {
        var _this2 = this;

        var labelIds = [];

        this.getElement('.selected_issue:checked').each(function (i, el) {
          labelIds.push(_this2.getElement('#' + _this2.prefixId + el.dataset.id).data('labels'));
        });
        return _.intersection.apply(this, labelIds);
      }

      // From issuable's initial bulk selection

    }, {
      key: 'getOriginalMarkedIds',
      value: function getOriginalMarkedIds() {
        var _this3 = this;

        var labelIds = [];
        this.getElement('.selected_issue:checked').each(function (i, el) {
          labelIds.push(_this3.getElement('#' + _this3.prefixId + el.dataset.id).data('labels'));
        });
        return _.intersection.apply(this, labelIds);
      }

      // From issuable's initial bulk selection

    }, {
      key: 'getOriginalIndeterminateIds',
      value: function getOriginalIndeterminateIds() {
        var _this4 = this;

        var uniqueIds = [];
        var labelIds = [];
        var issuableLabels = [];

        // Collect unique label IDs for all checked issues
        this.getElement('.selected_issue:checked').each(function (i, el) {
          issuableLabels = _this4.getElement('#' + _this4.prefixId + el.dataset.id).data('labels');
          issuableLabels.forEach(function (labelId) {
            // Store unique IDs
            if (uniqueIds.indexOf(labelId) === -1) {
              uniqueIds.push(labelId);
            }
          });
          // Store array of IDs per issuable
          labelIds.push(issuableLabels);
        });
        // Add uniqueIds to add it as argument for _.intersection
        labelIds.unshift(uniqueIds);
        // Return IDs that are present but not in all selected issueables
        return _.difference(uniqueIds, _.intersection.apply(this, labelIds));
      }
    }, {
      key: 'getElement',
      value: function getElement(selector) {
        this.scopeEl = this.scopeEl || $('.content');
        return this.scopeEl.find(selector);
      }
    }]);

    return IssuableBulkActions;
  }();

  global.IssuableBulkActions = IssuableBulkActions;
})(window.gl || (window.gl = {}));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "f9QQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__("yoQO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable no-param-reassign, class-methods-use-this */
/* global Pager */



var Activities = function () {
  function Activities() {
    var _this = this;

    _classCallCheck(this, Activities);

    Pager.init(20, true, false, this.updateTooltips);
    $('.event-filter-link').on('click', function (e) {
      e.preventDefault();
      _this.toggleFilter(e.currentTarget);
      _this.reloadActivities();
    });
  }

  _createClass(Activities, [{
    key: 'updateTooltips',
    value: function updateTooltips() {
      gl.utils.localTimeAgo($('.js-timeago', '.content_list'));
    }
  }, {
    key: 'reloadActivities',
    value: function reloadActivities() {
      $('.content_list').html('');
      Pager.init(20, true, false, this.updateTooltips);
    }
  }, {
    key: 'toggleFilter',
    value: function toggleFilter(sender) {
      var $sender = $(sender);
      var filter = $sender.attr('id').split('_')[0];

      $('.event-filter .active').removeClass('active');
      __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set('event_filter', filter);

      $sender.closest('li').toggleClass('active');
    }
  }]);

  return Activities;
}();

window.gl = window.gl || {};
window.gl.Activities = Activities;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("lwLq")))

/***/ }),

/***/ "fA9n":
/***/ (function(module, exports) {

module.exports = {
	"100": {
		"category": "symbols",
		"moji": "💯",
		"unicodeVersion": "6.0",
		"digest": "add3bd7d06b6dd445788b277f8c9e5dcf42a54d3ec8b7fb9e7a39695dd95d094"
	},
	"1234": {
		"category": "symbols",
		"moji": "🔢",
		"unicodeVersion": "6.0",
		"digest": "c5ac5c8147f5bfd644fad6b470432bba86ffc7bcee04a0e0d277cd1ca485207f"
	},
	"8ball": {
		"category": "activity",
		"moji": "🎱",
		"unicodeVersion": "6.0",
		"digest": "a6e6855775b66c505adee65926a264103ebddf2e2d963db7c009b4fec3a24178"
	},
	"a": {
		"category": "symbols",
		"moji": "🅰",
		"unicodeVersion": "6.0",
		"digest": "bddbb39e8a1d35d42b7c08e7d47f63988cb4d8614b79f74e70b9c67c221896cc"
	},
	"ab": {
		"category": "symbols",
		"moji": "🆎",
		"unicodeVersion": "6.0",
		"digest": "67430fe5fce981160e2ea9052962e49f264322d3abfc2828fbc311b6cdf67ae8"
	},
	"abc": {
		"category": "symbols",
		"moji": "🔤",
		"unicodeVersion": "6.0",
		"digest": "282c817ee3414d77a74b815962c33dd9fe71fabaea8c7a9cec466100fbe32187"
	},
	"abcd": {
		"category": "symbols",
		"moji": "🔡",
		"unicodeVersion": "6.0",
		"digest": "686728c759f4683c64762ee4eda0a91bf2041f0ae4f358aacf6c09bf51892eff"
	},
	"accept": {
		"category": "symbols",
		"moji": "🉑",
		"unicodeVersion": "6.0",
		"digest": "7208d34c761f10a7fd28f98e25535eba13ff91a64442fc282a98bb77722614f1"
	},
	"aerial_tramway": {
		"category": "travel",
		"moji": "🚡",
		"unicodeVersion": "6.0",
		"digest": "98df666f34370fc34ce280d84bba5a7e617f733fbbfe66caa424b2afa6ab6777"
	},
	"airplane": {
		"category": "travel",
		"moji": "✈",
		"unicodeVersion": "1.1",
		"digest": "cc12cf259ef88e57717620cd2bd5aa6a02a8631ee532a3bde24bee78edc5de33"
	},
	"airplane_arriving": {
		"category": "travel",
		"moji": "🛬",
		"unicodeVersion": "7.0",
		"digest": "80d5b4675f91c4cff06d146d795a065b0ce2a74557df4d9e3314e3d3b5c4ae82"
	},
	"airplane_departure": {
		"category": "travel",
		"moji": "🛫",
		"unicodeVersion": "7.0",
		"digest": "5544eace06b8e1b6ea91940e893e013d33d6b166e14e6d128a87f2cd2de88332"
	},
	"airplane_small": {
		"category": "travel",
		"moji": "🛩",
		"unicodeVersion": "7.0",
		"digest": "1a2e07abbbe90d05cee7ff8dd52f443d595ccb38959f3089fe016b77e5d6de7d"
	},
	"alarm_clock": {
		"category": "objects",
		"moji": "⏰",
		"unicodeVersion": "6.0",
		"digest": "fef05a3cd1cddbeca4de8091b94bddb93790b03fa213da86c0eec420f8c49599"
	},
	"alembic": {
		"category": "objects",
		"moji": "⚗",
		"unicodeVersion": "4.1",
		"digest": "c94b2a4bf24ccf4db27a22c9725cfe900f4a99ec49ef2411d67952bcb2ca1bfb"
	},
	"alien": {
		"category": "people",
		"moji": "👽",
		"unicodeVersion": "6.0",
		"digest": "856ba98202b244c13a5ee3014a6f7ad592d8c119a30d79e4fc790b74b0e321f7"
	},
	"ambulance": {
		"category": "travel",
		"moji": "🚑",
		"unicodeVersion": "6.0",
		"digest": "d9b3c1873de496a4554e715342c72290fb69a9c6766d7885f38bfe9491d052da"
	},
	"amphora": {
		"category": "objects",
		"moji": "🏺",
		"unicodeVersion": "8.0",
		"digest": "4015f907b649b5e348502cc0e3685ed184e180dca5cc81c43ec516e14df127bf"
	},
	"anchor": {
		"category": "travel",
		"moji": "⚓",
		"unicodeVersion": "4.1",
		"digest": "2b29b34ef896ebab70016301e3d1880209bbc3c5a5b8d832e43afff9b17ad792"
	},
	"angel": {
		"category": "people",
		"moji": "👼",
		"unicodeVersion": "6.0",
		"digest": "db75c2460aaf9cd07cb41fe22c8a6079f3667ffe612a71611358720e2b5512a4"
	},
	"angel_tone1": {
		"category": "people",
		"moji": "👼🏻",
		"unicodeVersion": "8.0",
		"digest": "5871a622469b96296365adaf77d83167759692124c20e5a6e062a525af33472a"
	},
	"angel_tone2": {
		"category": "people",
		"moji": "👼🏼",
		"unicodeVersion": "8.0",
		"digest": "f5993198a5d9daf39e761c783461f07bca237f4e9b739ac300bb8ca001a69a1a"
	},
	"angel_tone3": {
		"category": "people",
		"moji": "👼🏽",
		"unicodeVersion": "8.0",
		"digest": "f0c97a7c4354626267d6ab0f388e4297ad255ab9b061f9c68fbcaa0abfc52783"
	},
	"angel_tone4": {
		"category": "people",
		"moji": "👼🏾",
		"unicodeVersion": "8.0",
		"digest": "6e5dc724c1939d1b0d1a91343662b5bd61ced7709c97802977145ffab6a1f7ac"
	},
	"angel_tone5": {
		"category": "people",
		"moji": "👼🏿",
		"unicodeVersion": "8.0",
		"digest": "52186e1de350c27d25d6010edf44f64a30338b65912ca178429fbcfbd88113c2"
	},
	"anger": {
		"category": "symbols",
		"moji": "💢",
		"unicodeVersion": "6.0",
		"digest": "332493913891aa0eda2743b4bb16c4682400f249998bf34eb292246c9009e17f"
	},
	"anger_right": {
		"category": "symbols",
		"moji": "🗯",
		"unicodeVersion": "7.0",
		"digest": "8b049511ef3b1b28325841e2f87c60773eaf2f65cabba58d8b0ec3de9b10c0ae"
	},
	"angry": {
		"category": "people",
		"moji": "😠",
		"unicodeVersion": "6.0",
		"digest": "7e09e7e821f511606341fb5ce4011a8ed9809766ab86b7983ffa6ea352b39ec1"
	},
	"ant": {
		"category": "nature",
		"moji": "🐜",
		"unicodeVersion": "6.0",
		"digest": "929abeaff7ba21ab71cd1ab798af7a6b611e3b3ce1af80cede09a116b223e442"
	},
	"apple": {
		"category": "food",
		"moji": "🍎",
		"unicodeVersion": "6.0",
		"digest": "2a1b85ce57e3d236ae7777dcf332ec37d03bfd7b19806521a353bc532083224d"
	},
	"aquarius": {
		"category": "symbols",
		"moji": "♒",
		"unicodeVersion": "1.1",
		"digest": "fdc42cd41b0dace5eae6baba3143f1e40295d48a29e7103a5bba1d84a056c39d"
	},
	"aries": {
		"category": "symbols",
		"moji": "♈",
		"unicodeVersion": "1.1",
		"digest": "deb135debcde0a98f40361a84ab64d57c18b5b445cd2f4199e8936f052899737"
	},
	"arrow_backward": {
		"category": "symbols",
		"moji": "◀",
		"unicodeVersion": "1.1",
		"digest": "e162ac82e90d1e925d479fa5c45b9340e0a53287be04e43cbbb2a89c7e7e45e4"
	},
	"arrow_double_down": {
		"category": "symbols",
		"moji": "⏬",
		"unicodeVersion": "6.0",
		"digest": "03ca890b05338d40972c7a056d672df620a203c6ca52ff3ff530f1a710905507"
	},
	"arrow_double_up": {
		"category": "symbols",
		"moji": "⏫",
		"unicodeVersion": "6.0",
		"digest": "e753f05bce993d62d5dc79e33c441ced059381b6ce21fa3ea4200f1b3236e59d"
	},
	"arrow_down": {
		"category": "symbols",
		"moji": "⬇",
		"unicodeVersion": "4.0",
		"digest": "9bf1bd2ea652ca9321087de58c7a112ea04c35676a6ee0766154183f8b95af6c"
	},
	"arrow_down_small": {
		"category": "symbols",
		"moji": "🔽",
		"unicodeVersion": "6.0",
		"digest": "7766198bc60cf59d6cdaeeaa700c2282bfff2f0fdeb22cf4581ca284b87a3bb7"
	},
	"arrow_forward": {
		"category": "symbols",
		"moji": "▶",
		"unicodeVersion": "1.1",
		"digest": "db77d9accd1e02224f5d612f79cd691e6befdf22063475204836be6572510fb7"
	},
	"arrow_heading_down": {
		"category": "symbols",
		"moji": "⤵",
		"unicodeVersion": "3.2",
		"digest": "f5396069c8f63c13e6c3e0ecd34267c932451309ade9c1171d410563153bf909"
	},
	"arrow_heading_up": {
		"category": "symbols",
		"moji": "⤴",
		"unicodeVersion": "3.2",
		"digest": "1cad71923fa3df24cf543cae4ce775b0f74936f2edd685fd86a7525c41a14568"
	},
	"arrow_left": {
		"category": "symbols",
		"moji": "⬅",
		"unicodeVersion": "4.0",
		"digest": "b629bb3dbe161ef89cfcfced0c7968a68e44a019ad509132987e4973bdc874e7"
	},
	"arrow_lower_left": {
		"category": "symbols",
		"moji": "↙",
		"unicodeVersion": "1.1",
		"digest": "879136ba0e24e6bf3be70118abcb716d71bd74f7b62347bc052b6533c0ea534d"
	},
	"arrow_lower_right": {
		"category": "symbols",
		"moji": "↘",
		"unicodeVersion": "1.1",
		"digest": "86d52ac9b961991e3aaa6a9f9b5ace4db6ffd1b5c171c09c23b516473b55066d"
	},
	"arrow_right": {
		"category": "symbols",
		"moji": "➡",
		"unicodeVersion": "1.1",
		"digest": "45f26a1cbb0f00ed3609b39da52e9d9e896a77e361c4c8036b1bf8038171bd49"
	},
	"arrow_right_hook": {
		"category": "symbols",
		"moji": "↪",
		"unicodeVersion": "1.1",
		"digest": "4f452679c71bcea4fc4a701c55156fef3ddc1ebbc70570bedfc9d3a029637ab1"
	},
	"arrow_up": {
		"category": "symbols",
		"moji": "⬆",
		"unicodeVersion": "4.0",
		"digest": "982b988ef6651d8a71867ba7c87f640f62dd0eeb0b7c358f5a5c37e8fe507b8b"
	},
	"arrow_up_down": {
		"category": "symbols",
		"moji": "↕",
		"unicodeVersion": "1.1",
		"digest": "645ed8fb6646f49bfd95af1752336deacdadbe5cba13904023a704288f3b0e2c"
	},
	"arrow_up_small": {
		"category": "symbols",
		"moji": "🔼",
		"unicodeVersion": "6.0",
		"digest": "4a8c5789c13a852517e639e7a62c2d331464e6fb0358985aa97c1515e97b5e8b"
	},
	"arrow_upper_left": {
		"category": "symbols",
		"moji": "↖",
		"unicodeVersion": "1.1",
		"digest": "79026f828d6ceb7c55a9542770962ba6dcd08203995f6ceeb70333a12307d376"
	},
	"arrow_upper_right": {
		"category": "symbols",
		"moji": "↗",
		"unicodeVersion": "1.1",
		"digest": "7e0f33dfbe65628991c170130d366a3e2cedaf8862ddfcaf3960f395d3da1926"
	},
	"arrows_clockwise": {
		"category": "symbols",
		"moji": "🔃",
		"unicodeVersion": "6.0",
		"digest": "88669679977f7157f0acaa9d6a1b77ccf84d25eb78c5bc8afcde38d3635e7144"
	},
	"arrows_counterclockwise": {
		"category": "symbols",
		"moji": "🔄",
		"unicodeVersion": "6.0",
		"digest": "a2c6a6d3643c128aee3304cd03bb3d7cfe4d35d3ba825bc9c1142d7832b4426e"
	},
	"art": {
		"category": "activity",
		"moji": "🎨",
		"unicodeVersion": "6.0",
		"digest": "b6bc6c4bfb594aadcbb641d006031867678504764bbe0ab84e7b08567a9498da"
	},
	"articulated_lorry": {
		"category": "travel",
		"moji": "🚛",
		"unicodeVersion": "6.0",
		"digest": "c115e6613ebd718268aa31d265e017138b9fb58bbb8201eb3f40de2380e460aa"
	},
	"asterisk": {
		"category": "symbols",
		"moji": "*⃣",
		"unicodeVersion": "3.0",
		"digest": "33d92093f2914448d5a939cf62e8ee3e32931923abdef5f0210e8a8150fa312d"
	},
	"astonished": {
		"category": "people",
		"moji": "😲",
		"unicodeVersion": "6.0",
		"digest": "f8531bdda5070d10492709085f4ff652b8be9be6458758940358b9fc594a1f14"
	},
	"athletic_shoe": {
		"category": "people",
		"moji": "👟",
		"unicodeVersion": "6.0",
		"digest": "1f90dc390e0dea679085465b7f9e786dfd7dd56a3b219987144ed37ab1e9bf95"
	},
	"atm": {
		"category": "symbols",
		"moji": "🏧",
		"unicodeVersion": "6.0",
		"digest": "7d3ce6a6afb4951546883404b8e36904179f88f1aa533706cf7bf0bbe0d6fd3c"
	},
	"atom": {
		"category": "symbols",
		"moji": "⚛",
		"unicodeVersion": "4.1",
		"digest": "6b6bb83b00707a314e46ff8eefbda40978a291ec7881caba1b1ee273f49c1368"
	},
	"avocado": {
		"category": "food",
		"moji": "🥑",
		"unicodeVersion": "9.0",
		"digest": "bc1fb203d63b18985598400925de24050bb192afda1cbf0813f85cb139869eff"
	},
	"b": {
		"category": "symbols",
		"moji": "🅱",
		"unicodeVersion": "6.0",
		"digest": "722f9db9442e7c0fc0d0ac0f5291fbf47c6a0ac4d8abd42e97957da705fb82bf"
	},
	"baby": {
		"category": "people",
		"moji": "👶",
		"unicodeVersion": "6.0",
		"digest": "219ae5a571aaf90c060956cd1c56dcc27708c827cecdca3ba1122058a3c4847b"
	},
	"baby_bottle": {
		"category": "food",
		"moji": "🍼",
		"unicodeVersion": "6.0",
		"digest": "4fb71689e9d634e8d1699cf454a71e43f2b5b1a5dbab0bf186626934fdf5b782"
	},
	"baby_chick": {
		"category": "nature",
		"moji": "🐤",
		"unicodeVersion": "6.0",
		"digest": "14119874e9b5548028dfb9cc593a541efc1d075ac839a565b92e0c3253cffe7e"
	},
	"baby_symbol": {
		"category": "symbols",
		"moji": "🚼",
		"unicodeVersion": "6.0",
		"digest": "fb4db66868cda45ea3879ffc2ff4f763c56d2d889ae0ab17fe171129ede02f98"
	},
	"baby_tone1": {
		"category": "people",
		"moji": "👶🏻",
		"unicodeVersion": "8.0",
		"digest": "cd3faf223a298c34e05d469d9d0db08438d97df7fd82c0973f8a9e07d553f5b1"
	},
	"baby_tone2": {
		"category": "people",
		"moji": "👶🏼",
		"unicodeVersion": "8.0",
		"digest": "5b4539e22e0dd726c27eb8af2357f9240a52aed3f710f3234571cff029cc6198"
	},
	"baby_tone3": {
		"category": "people",
		"moji": "👶🏽",
		"unicodeVersion": "8.0",
		"digest": "720e740e1ac63c6372269132b1fb6e07a6b91f5c808cc3adef59f0b4500e5e72"
	},
	"baby_tone4": {
		"category": "people",
		"moji": "👶🏾",
		"unicodeVersion": "8.0",
		"digest": "5e43b69c509bd526ad6f081764578c30b6f3285fb7442222e05ccf62e53bfb64"
	},
	"baby_tone5": {
		"category": "people",
		"moji": "👶🏿",
		"unicodeVersion": "8.0",
		"digest": "85bba6e0940ccfb99999fe124e815f9dd340d00a5568e13967b02245a62dbf54"
	},
	"back": {
		"category": "symbols",
		"moji": "🔙",
		"unicodeVersion": "6.0",
		"digest": "083e4e48b51092c28efb4532e840e1091b5d4b685c6e0f221aa0228f061cd91e"
	},
	"bacon": {
		"category": "food",
		"moji": "🥓",
		"unicodeVersion": "9.0",
		"digest": "18ad3817f1f88a69706db5727a58e763dde6c21a2d4f184c3d728c32dc5fa05a"
	},
	"badminton": {
		"category": "activity",
		"moji": "🏸",
		"unicodeVersion": "8.0",
		"digest": "353eb7ee93decd9fe0072e4d78a5618d5e2d9e77a6e4de9fe171870d75e02a66"
	},
	"baggage_claim": {
		"category": "symbols",
		"moji": "🛄",
		"unicodeVersion": "6.0",
		"digest": "7d6bceca92c266da6d2b91dfcf244546fc11022e039e7da8e6888c1696bb2186"
	},
	"balloon": {
		"category": "objects",
		"moji": "🎈",
		"unicodeVersion": "6.0",
		"digest": "65760aedc1503b426927cff78c24449d563843a274961d962718fa9638375d54"
	},
	"ballot_box": {
		"category": "objects",
		"moji": "🗳",
		"unicodeVersion": "7.0",
		"digest": "4175a56eca5c6458574a681e109b1403fbb143cf27f69ae6c1917650f3e08892"
	},
	"ballot_box_with_check": {
		"category": "symbols",
		"moji": "☑",
		"unicodeVersion": "1.1",
		"digest": "c98d6f3588dd87e2f318bbfe6c646399a905450edfd814edae4e5b1bddef2134"
	},
	"bamboo": {
		"category": "nature",
		"moji": "🎍",
		"unicodeVersion": "6.0",
		"digest": "e4ee65088df43d7081b1ce6fd996f66f3e0accd88840855c47a98a22997823dd"
	},
	"banana": {
		"category": "food",
		"moji": "🍌",
		"unicodeVersion": "6.0",
		"digest": "f9e8ff910c282c20a8907ff64926b5de4ee250529a1ed718fb33302e6fff8dd9"
	},
	"bangbang": {
		"category": "symbols",
		"moji": "‼",
		"unicodeVersion": "1.1",
		"digest": "76536fee63fe964a3f3839d309b1f45028fb0c43f4d1eeee495f17e1532b4def"
	},
	"bank": {
		"category": "travel",
		"moji": "🏦",
		"unicodeVersion": "6.0",
		"digest": "f5d2976bf6d521638ccacc74be06bd4abfeab06c5d898a9d245edad45a5b6306"
	},
	"bar_chart": {
		"category": "objects",
		"moji": "📊",
		"unicodeVersion": "6.0",
		"digest": "65a328a1b2d7a5332dd4d93f4dbca13d976f0a505b00835c3fc458e394804240"
	},
	"barber": {
		"category": "objects",
		"moji": "💈",
		"unicodeVersion": "6.0",
		"digest": "5e8053d3bb3765a8632fd1cbfe21163f74ed79f6be377eb9603eaaf883d8dc46"
	},
	"baseball": {
		"category": "activity",
		"moji": "⚾",
		"unicodeVersion": "5.2",
		"digest": "46ac16f8b5455b942f6dbff9483a6fd277721e6719d2731573baabd21c44b34f"
	},
	"basketball": {
		"category": "activity",
		"moji": "🏀",
		"unicodeVersion": "6.0",
		"digest": "cc83e2aea8fcd2e9a5789e1932ee3766c40843c142fd3565c4e77dafb21ec7d7"
	},
	"basketball_player": {
		"category": "activity",
		"moji": "⛹",
		"unicodeVersion": "5.2",
		"digest": "793ba53c95e8def769383b612037bc9b9bceecaf1e0430c50a4cc128ad18d9b9"
	},
	"basketball_player_tone1": {
		"category": "activity",
		"moji": "⛹🏻",
		"unicodeVersion": "8.0",
		"digest": "2a06522b971e68ee5b8777a58253009b548f4da2fb723c638acb3d7b04edba8f"
	},
	"basketball_player_tone2": {
		"category": "activity",
		"moji": "⛹🏼",
		"unicodeVersion": "8.0",
		"digest": "ecc0e44ab9bc478ba45a055fd69a3a38377b917aac5047963fe80ff8ae5fd8e3"
	},
	"basketball_player_tone3": {
		"category": "activity",
		"moji": "⛹🏽",
		"unicodeVersion": "8.0",
		"digest": "2d38f1851c685d29532c042461d7b5b996e5f04f0ed54857c66073c62a99ceac"
	},
	"basketball_player_tone4": {
		"category": "activity",
		"moji": "⛹🏾",
		"unicodeVersion": "8.0",
		"digest": "09e957c6e9ffc196415f28073aa261feba8efba0bdc694dc08f8f7cd1f88f720"
	},
	"basketball_player_tone5": {
		"category": "activity",
		"moji": "⛹🏿",
		"unicodeVersion": "8.0",
		"digest": "c631cefc5d2a0a31bdb9f0a0d97ea68b1c6928e565468998403034644572a0b0"
	},
	"bat": {
		"category": "nature",
		"moji": "🦇",
		"unicodeVersion": "9.0",
		"digest": "8fc19e0d7d6f80906bdbc06d616a810de66180d96cf28070a53fa61b88904535"
	},
	"bath": {
		"category": "activity",
		"moji": "🛀",
		"unicodeVersion": "6.0",
		"digest": "33b371832f90aad50baf5296f3ad4cc081c319b279f989c74409903d8568e917"
	},
	"bath_tone1": {
		"category": "activity",
		"moji": "🛀🏻",
		"unicodeVersion": "8.0",
		"digest": "7ae2989e47788ba71359d52da68feec95aaff68a77d5a6556957df1617af8536"
	},
	"bath_tone2": {
		"category": "activity",
		"moji": "🛀🏼",
		"unicodeVersion": "8.0",
		"digest": "2e86f8edad54d15a7094cd52160cbe51d10aa1750cfb0b3b58e93533f070e327"
	},
	"bath_tone3": {
		"category": "activity",
		"moji": "🛀🏽",
		"unicodeVersion": "8.0",
		"digest": "654c0cd083a67ff330a38d07352876d265390e5399e5352598d64a6c7e5eeba7"
	},
	"bath_tone4": {
		"category": "activity",
		"moji": "🛀🏾",
		"unicodeVersion": "8.0",
		"digest": "adad88c6830f31c4b5be194d1987d6aadf4adf45e4cb7f2e4657f0d20c0d663a"
	},
	"bath_tone5": {
		"category": "activity",
		"moji": "🛀🏿",
		"unicodeVersion": "8.0",
		"digest": "952c4c9bf24e001e23a33ebf97bd92969cd9143e28ce93f9aafc708a8f966903"
	},
	"bathtub": {
		"category": "objects",
		"moji": "🛁",
		"unicodeVersion": "6.0",
		"digest": "844dffb87ef872594195069b0d0df27c3fe51f3967ccbc8b2df811a086dd483a"
	},
	"battery": {
		"category": "objects",
		"moji": "🔋",
		"unicodeVersion": "6.0",
		"digest": "949ae06648667fb13d9121a6dfdd03bf8692794b28c36e9a8e8ac4515664449a"
	},
	"beach": {
		"category": "travel",
		"moji": "🏖",
		"unicodeVersion": "7.0",
		"digest": "37fa2158977d470186caaa1aa06669b6dc5026ba49a0c44c5255541f8e974e26"
	},
	"beach_umbrella": {
		"category": "objects",
		"moji": "⛱",
		"unicodeVersion": "5.2",
		"digest": "d045f1de10038b9fb1eaa2529b2f80b7e3be1cff503efcc2d680663d1fbbc18f"
	},
	"bear": {
		"category": "nature",
		"moji": "🐻",
		"unicodeVersion": "6.0",
		"digest": "a4b9066eaa5681e6af06e596a96a5217037460ffc3b013e8db4d34d762413246"
	},
	"bed": {
		"category": "objects",
		"moji": "🛏",
		"unicodeVersion": "7.0",
		"digest": "08f6e20db51b1fb650b390a0a3074938646772f3fcee8c295d47742e44fe1e30"
	},
	"bee": {
		"category": "nature",
		"moji": "🐝",
		"unicodeVersion": "6.0",
		"digest": "5beb9a1650681b4adf69999d4808231c38f41a3ec693480b807cda86f964c570"
	},
	"beer": {
		"category": "food",
		"moji": "🍺",
		"unicodeVersion": "6.0",
		"digest": "69e227104976548ee0f37375fe1526fd65ef0a328d2d92db2feb1edfd7032bd4"
	},
	"beers": {
		"category": "food",
		"moji": "🍻",
		"unicodeVersion": "6.0",
		"digest": "db8b32d93bf6d161a3b027e55651d8f51231b13928b3610987ef62bb634d7501"
	},
	"beetle": {
		"category": "nature",
		"moji": "🐞",
		"unicodeVersion": "6.0",
		"digest": "5aaa428e3f63f7cd1696839ab05be03fa0cd0cbed30a05c36cb270da330c3849"
	},
	"beginner": {
		"category": "symbols",
		"moji": "🔰",
		"unicodeVersion": "6.0",
		"digest": "2de4fdf92f182c42b12b7527034eaf767d996848b61f31ee69167728411ca0b1"
	},
	"bell": {
		"category": "symbols",
		"moji": "🔔",
		"unicodeVersion": "6.0",
		"digest": "18d419417746ead408072b78fe2edb6314cdb49492873966fa9f9f06be09899b"
	},
	"bellhop": {
		"category": "objects",
		"moji": "🛎",
		"unicodeVersion": "7.0",
		"digest": "b8187bc4059f6a0924a47fe3f6c07f656bed0334bbcbfa1e89f800fe6594ff08"
	},
	"bento": {
		"category": "food",
		"moji": "🍱",
		"unicodeVersion": "6.0",
		"digest": "d46d4f681c5da7f7678b51be3445454a8ed18d917e132ae79077f05310e485f1"
	},
	"bicyclist": {
		"category": "activity",
		"moji": "🚴",
		"unicodeVersion": "6.0",
		"digest": "3302147b6b47c16adb97d78b7b761a1ca80e6d0b41d0b60f4da338d2f55f968b"
	},
	"bicyclist_tone1": {
		"category": "activity",
		"moji": "🚴🏻",
		"unicodeVersion": "8.0",
		"digest": "27eaae0eb61f5e7b3cd9faf02c042d6643a368051a7c9d7da4e0fb9802d39242"
	},
	"bicyclist_tone2": {
		"category": "activity",
		"moji": "🚴🏼",
		"unicodeVersion": "8.0",
		"digest": "39ee9e1071700da7079ad0146bf5711c3a222991eeca8b29b72a65677604444d"
	},
	"bicyclist_tone3": {
		"category": "activity",
		"moji": "🚴🏽",
		"unicodeVersion": "8.0",
		"digest": "03e1d2c4232c896147a9d4bf43becd61edbb5c84fc7193ecea474c0f9fb36817"
	},
	"bicyclist_tone4": {
		"category": "activity",
		"moji": "🚴🏾",
		"unicodeVersion": "8.0",
		"digest": "61393d9c4805be0379d86dd5bec9a1b02314433ab36cfd85bb48dfd073746617"
	},
	"bicyclist_tone5": {
		"category": "activity",
		"moji": "🚴🏿",
		"unicodeVersion": "8.0",
		"digest": "2b46d5f8303e5710dbf5db3a4edc9d88a032fe123fe79158024c9f51df5458c6"
	},
	"bike": {
		"category": "travel",
		"moji": "🚲",
		"unicodeVersion": "6.0",
		"digest": "b41daa7c549d483e2336186a28baaa8ecb11986f490c0c54c793c44900c8f652"
	},
	"bikini": {
		"category": "people",
		"moji": "👙",
		"unicodeVersion": "6.0",
		"digest": "07fe156f64673818d69ce3bf03950ca59e3b5d346e45ca541da4078ab791f5ae"
	},
	"biohazard": {
		"category": "symbols",
		"moji": "☣",
		"unicodeVersion": "1.1",
		"digest": "96163e31f0b8dc5a59772133ede9cc2f40f94330d0b15e3d044b28747e2be788"
	},
	"bird": {
		"category": "nature",
		"moji": "🐦",
		"unicodeVersion": "6.0",
		"digest": "f916eaf8f271b3767ade9eabb69594c0479f45472d471cabaf59f6e965c161e0"
	},
	"birthday": {
		"category": "food",
		"moji": "🎂",
		"unicodeVersion": "6.0",
		"digest": "89e7c4c598ebee8ec8ab11ebe4ccc6defb7c4d2987ee2379a19b3b59827dd98a"
	},
	"black_circle": {
		"category": "symbols",
		"moji": "⚫",
		"unicodeVersion": "4.1",
		"digest": "c2ba672994ad0f99d7fdc449f3fee45a2dca68a58f9fe95825b38465a30ef44e"
	},
	"black_heart": {
		"category": "symbols",
		"moji": "🖤",
		"unicodeVersion": "9.0",
		"digest": "f334679168d6dd7328c28e9ae3cb2b1fca0e9c2777938d586bfe623db2a688b9"
	},
	"black_joker": {
		"category": "symbols",
		"moji": "🃏",
		"unicodeVersion": "6.0",
		"digest": "d004b25f186494d5b2c65204caa9daecd749c840a0bea5718735e18109e5394d"
	},
	"black_large_square": {
		"category": "symbols",
		"moji": "⬛",
		"unicodeVersion": "5.1",
		"digest": "cbd90dcbc2f674eafa53820548b5263c18c9845ab39937f085e85aca0aebb479"
	},
	"black_medium_small_square": {
		"category": "symbols",
		"moji": "◾",
		"unicodeVersion": "3.2",
		"digest": "ab38363c2e862b8f67c719397a09a18e1ef996eec190691fdf769f5cfb209660"
	},
	"black_medium_square": {
		"category": "symbols",
		"moji": "◼",
		"unicodeVersion": "3.2",
		"digest": "c9ffa87c37e8ee65fadcf755176949901aec7367e02abb85e63cad60cd922116"
	},
	"black_nib": {
		"category": "objects",
		"moji": "✒",
		"unicodeVersion": "1.1",
		"digest": "58fb23b1155102970eaa23765e7d529a21e8e545e076ec1158bf11b4de5f51a8"
	},
	"black_small_square": {
		"category": "symbols",
		"moji": "▪",
		"unicodeVersion": "1.1",
		"digest": "f69be6de578fffce5a3e60eda690104b2ef6a855c630040104fb760a02ff1aef"
	},
	"black_square_button": {
		"category": "symbols",
		"moji": "🔲",
		"unicodeVersion": "6.0",
		"digest": "9d818fcd08ed38cd0bbbcfd83e665aa29b3761c0d8b9806d8954d36785e267a8"
	},
	"blossom": {
		"category": "nature",
		"moji": "🌼",
		"unicodeVersion": "6.0",
		"digest": "e8cf369d4e4cdb4eccc2ebcbb35439b0344221115701daae642e58dff8544922"
	},
	"blowfish": {
		"category": "nature",
		"moji": "🐡",
		"unicodeVersion": "6.0",
		"digest": "e706849ed00f08a82312381c76f6f9ba6cc261fbf87a839c85e7dd54138f9dc3"
	},
	"blue_book": {
		"category": "objects",
		"moji": "📘",
		"unicodeVersion": "6.0",
		"digest": "4c845748fe890516b32981b0b62bf3e8e9d906840c2060179f4f844100780615"
	},
	"blue_car": {
		"category": "travel",
		"moji": "🚙",
		"unicodeVersion": "6.0",
		"digest": "eca91934eb5481726cfd897b1ed5eac306e14d02499fbe49316aaec6c72b6707"
	},
	"blue_heart": {
		"category": "symbols",
		"moji": "💙",
		"unicodeVersion": "6.0",
		"digest": "2caa0c8d18538cc871c6fe328a52f71e1df8aabf4d1cc2f5324b261d1b8cb99a"
	},
	"blush": {
		"category": "people",
		"moji": "😊",
		"unicodeVersion": "6.0",
		"digest": "3bfe8d603cfa39999c164779f666d39bbc507f124ba80233ee72da7b3b0c0457"
	},
	"boar": {
		"category": "nature",
		"moji": "🐗",
		"unicodeVersion": "6.0",
		"digest": "c9d67479cace427ac3c30460fcffa1bf9a8e5262c0390962405dbbe6bf830fa6"
	},
	"bomb": {
		"category": "objects",
		"moji": "💣",
		"unicodeVersion": "6.0",
		"digest": "0155559abc4084f80e9b0b2a2091b8710ddd6369993b7fdd0685f4f8c2fd7e6c"
	},
	"book": {
		"category": "objects",
		"moji": "📖",
		"unicodeVersion": "6.0",
		"digest": "9d912a9d1bb10dc7f2645b345ed09e90461e83df0de275acb806f1f75cef1fcf"
	},
	"bookmark": {
		"category": "objects",
		"moji": "🔖",
		"unicodeVersion": "6.0",
		"digest": "5705e3108259d6900649157843c50e22d0086c3630b291d3f942da1a736e3e3d"
	},
	"bookmark_tabs": {
		"category": "objects",
		"moji": "📑",
		"unicodeVersion": "6.0",
		"digest": "c8fc7c9f3f82e1ccc97fc591345fdd88b09eec0fca428d8d4632a121cf1bc39a"
	},
	"books": {
		"category": "objects",
		"moji": "📚",
		"unicodeVersion": "6.0",
		"digest": "cbcf55d39dd05d26ef7350bc51e0e2f064f78bb8f59d407b516d63f68558f8e4"
	},
	"boom": {
		"category": "nature",
		"moji": "💥",
		"unicodeVersion": "6.0",
		"digest": "f5400e9583f7f997cd2385f21379f6229424a9b221445bc8f36c0bb64bdb3168"
	},
	"boot": {
		"category": "people",
		"moji": "👢",
		"unicodeVersion": "6.0",
		"digest": "b4706ff35909a6fb759a3b8a797e90cb67ffc60e4853386a7d89ace9693a9364"
	},
	"bouquet": {
		"category": "nature",
		"moji": "💐",
		"unicodeVersion": "6.0",
		"digest": "b93751a27b40f6185a22b3e8b413f0fe09b6010d1057c672e1a23088e0b8286f"
	},
	"bow": {
		"category": "people",
		"moji": "🙇",
		"unicodeVersion": "6.0",
		"digest": "33cd6da4d408f18d98bebc6a277dea8b914150e32ee472586ce3f1eb814462bd"
	},
	"bow_and_arrow": {
		"category": "activity",
		"moji": "🏹",
		"unicodeVersion": "8.0",
		"digest": "051b4d50ab21a68b8583a6313ec183e3e1e96f493b0f4541fbb888f0b95fdd4d"
	},
	"bow_tone1": {
		"category": "people",
		"moji": "🙇🏻",
		"unicodeVersion": "8.0",
		"digest": "995c8400ad60d5adc66c9ae5e3c0ecf56c48b478ad79418d45b6289933d25bdd"
	},
	"bow_tone2": {
		"category": "people",
		"moji": "🙇🏼",
		"unicodeVersion": "8.0",
		"digest": "af89eec2fccda99d9bdd373b2345595882fee1c0a15d29af9028089e20255325"
	},
	"bow_tone3": {
		"category": "people",
		"moji": "🙇🏽",
		"unicodeVersion": "8.0",
		"digest": "015d8122abdf2d0caa03815545f50fb7a71e05dacd46aaa133cc9ace5192f266"
	},
	"bow_tone4": {
		"category": "people",
		"moji": "🙇🏾",
		"unicodeVersion": "8.0",
		"digest": "e8409096a795b775def654d36aeccb8eb91e83d7d1b32145cd73fd0b7b9e885c"
	},
	"bow_tone5": {
		"category": "people",
		"moji": "🙇🏿",
		"unicodeVersion": "8.0",
		"digest": "d87042cde8dbad9fb1a91a2ec60116e27b4a76388b5779d771a0bbae12a2814d"
	},
	"bowling": {
		"category": "activity",
		"moji": "🎳",
		"unicodeVersion": "6.0",
		"digest": "737f2cdfa4ac964baade585a39771b18080bd5e9b55c8661d3518f468f344662"
	},
	"boxing_glove": {
		"category": "activity",
		"moji": "🥊",
		"unicodeVersion": "9.0",
		"digest": "c914b2ce45f20afad66ad6f0d1b0750c4469e4f48b686dfc4aad1ec8d289c563"
	},
	"boy": {
		"category": "people",
		"moji": "👦",
		"unicodeVersion": "6.0",
		"digest": "7bc0173d8c88f3f12d41f213f7a3a9f5ebf65efad610fd5a2a31935128a6a6c1"
	},
	"boy_tone1": {
		"category": "people",
		"moji": "👦🏻",
		"unicodeVersion": "8.0",
		"digest": "c0e2f0483715b239fe145b0056566f7a3a722319d9a87c1e66733dff1916a19f"
	},
	"boy_tone2": {
		"category": "people",
		"moji": "👦🏼",
		"unicodeVersion": "8.0",
		"digest": "0001d0bd1ff4dbd898604ba965b4039d09667d955bc0349301b992f9ab6dd7fd"
	},
	"boy_tone3": {
		"category": "people",
		"moji": "👦🏽",
		"unicodeVersion": "8.0",
		"digest": "e0f08755955fd2e0bd1c5d5e84429b2a234b24a744bb50bb9f1148495b2b29f9"
	},
	"boy_tone4": {
		"category": "people",
		"moji": "👦🏾",
		"unicodeVersion": "8.0",
		"digest": "04b6bfee58a26b1ce2e5b403504a7033aaf395f03f5cd23e824f32c90c395fe6"
	},
	"boy_tone5": {
		"category": "people",
		"moji": "👦🏿",
		"unicodeVersion": "8.0",
		"digest": "0f76e97237203950da36c737dcc6f56dcd6c123401a8c817a0636376c7f38ef5"
	},
	"bread": {
		"category": "food",
		"moji": "🍞",
		"unicodeVersion": "6.0",
		"digest": "81739830f16f33e6a1dd7cc17c25df207846062bb5167bb8abed7fdd49268b86"
	},
	"bride_with_veil": {
		"category": "people",
		"moji": "👰",
		"unicodeVersion": "6.0",
		"digest": "8e24bd91c3f564cf6148f2b3b4a7d692c11dd059e76a13331fdfb04ae060ea70"
	},
	"bride_with_veil_tone1": {
		"category": "people",
		"moji": "👰🏻",
		"unicodeVersion": "8.0",
		"digest": "0bd2f16f72586f50e768b14b9b353f2e98ccbb2581a568c33b06be56e70ca063"
	},
	"bride_with_veil_tone2": {
		"category": "people",
		"moji": "👰🏼",
		"unicodeVersion": "8.0",
		"digest": "e5463f811b2075754f0718b891757cd2e81071edf7af2215581227e1aad1d068"
	},
	"bride_with_veil_tone3": {
		"category": "people",
		"moji": "👰🏽",
		"unicodeVersion": "8.0",
		"digest": "e5a053a26f7ccebae7eb12f638be5ed80f77b744708d783eab2eb8aa091cf516"
	},
	"bride_with_veil_tone4": {
		"category": "people",
		"moji": "👰🏾",
		"unicodeVersion": "8.0",
		"digest": "410e23825e4401460946dc67a618bd3ace6e1a7c07dd88580a2349423685261f"
	},
	"bride_with_veil_tone5": {
		"category": "people",
		"moji": "👰🏿",
		"unicodeVersion": "8.0",
		"digest": "454e87e5a74e13e5b4993541231516fbbe6dbe9f990e1a6f3f4a744d7d4c1615"
	},
	"bridge_at_night": {
		"category": "travel",
		"moji": "🌉",
		"unicodeVersion": "6.0",
		"digest": "9d3cda5a59e27e3c90939f1ddbe7e998b3ea4fcacfa1467dea0edf39613c2d7f"
	},
	"briefcase": {
		"category": "people",
		"moji": "💼",
		"unicodeVersion": "6.0",
		"digest": "9d00d6a92632aaadc71b017f448c883b27eb31a7554ebb51f7e3a9841f0f7f2b"
	},
	"broken_heart": {
		"category": "symbols",
		"moji": "💔",
		"unicodeVersion": "6.0",
		"digest": "c7ca53f444d72e596af46b61ffbc9e7c18a645020c22691e44f967db98dbf853"
	},
	"bug": {
		"category": "nature",
		"moji": "🐛",
		"unicodeVersion": "6.0",
		"digest": "0dccb1d5eb91769377b4c5b310f007b60f54a5c48ba9e467b3a06898a4831b90"
	},
	"bulb": {
		"category": "objects",
		"moji": "💡",
		"unicodeVersion": "6.0",
		"digest": "ccdaa2dfde5a88a347035a94b9d4d86cfc335ce0a73292423f5788a4bd21a5a8"
	},
	"bullettrain_front": {
		"category": "travel",
		"moji": "🚅",
		"unicodeVersion": "6.0",
		"digest": "5195a6a6d23f28e1aa5ebac6ede0f6c6a8b7ff33a9edf034814f227fe976177a"
	},
	"bullettrain_side": {
		"category": "travel",
		"moji": "🚄",
		"unicodeVersion": "6.0",
		"digest": "96e74842e919716b7bbbab57339bfd70f099a9bcb4710dffd7c80cf38a7bbff7"
	},
	"burrito": {
		"category": "food",
		"moji": "🌯",
		"unicodeVersion": "8.0",
		"digest": "b2cf81f1efdf87e674461f73f67cd4b58a5f695e65598d0dd3899f2597da43cf"
	},
	"bus": {
		"category": "travel",
		"moji": "🚌",
		"unicodeVersion": "6.0",
		"digest": "192850b762edad21ac8770df38b9cae6d2bc1697a838462f3e36066bfb4eee50"
	},
	"busstop": {
		"category": "travel",
		"moji": "🚏",
		"unicodeVersion": "6.0",
		"digest": "adabb1ec36402b33feb636eae3656e5a8b51ff1071bcb14125d8ab80d6d12d2a"
	},
	"bust_in_silhouette": {
		"category": "people",
		"moji": "👤",
		"unicodeVersion": "6.0",
		"digest": "277ae43301f1e49e0be03c8e52f0dc7b70c67f9d146bca0a14172e0098f115e6"
	},
	"busts_in_silhouette": {
		"category": "people",
		"moji": "👥",
		"unicodeVersion": "6.0",
		"digest": "7fee96f1b68bb2c6002e47f2ed13c06baa6a3168441b9aca572db7ec45612f7b"
	},
	"butterfly": {
		"category": "nature",
		"moji": "🦋",
		"unicodeVersion": "9.0",
		"digest": "a91b6598c17b44a8dc8935a1d99e25f4483ea41470cdd2da343039a9eec29ef1"
	},
	"cactus": {
		"category": "nature",
		"moji": "🌵",
		"unicodeVersion": "6.0",
		"digest": "2c5c4c35f26c7046fdc002b337e0d939729b33a26980e675950f9934c91e40fd"
	},
	"cake": {
		"category": "food",
		"moji": "🍰",
		"unicodeVersion": "6.0",
		"digest": "b928902df8084210d51c1da36f9119164a325393c391b28cd8ea914e0b95c17b"
	},
	"calendar": {
		"category": "objects",
		"moji": "📆",
		"unicodeVersion": "6.0",
		"digest": "9d990be27778daab041a3583edbd8f83fc8957e42a3aec729c0e2e224a8d05e3"
	},
	"calendar_spiral": {
		"category": "objects",
		"moji": "🗓",
		"unicodeVersion": "7.0",
		"digest": "441a0750eade7ce33e28e58bec76958990c412b68409fcdde59ebad1f25361bb"
	},
	"call_me": {
		"category": "people",
		"moji": "🤙",
		"unicodeVersion": "9.0",
		"digest": "83d2ed96dcb8b4adf4f4d030ffd07e25ca16351e1a4fbefdf9f46f5ca496a55f"
	},
	"call_me_tone1": {
		"category": "people",
		"moji": "🤙🏻",
		"unicodeVersion": "9.0",
		"digest": "4a5748efa83e7294e8338b8795d4d315ff1cd31ead6759004d0eb330e50de8cd"
	},
	"call_me_tone2": {
		"category": "people",
		"moji": "🤙🏼",
		"unicodeVersion": "9.0",
		"digest": "54feaa6e3c5789ae6e15622127f0e0213234b4b886e1588ce95814348b1f1519"
	},
	"call_me_tone3": {
		"category": "people",
		"moji": "🤙🏽",
		"unicodeVersion": "9.0",
		"digest": "57e949b951e14843b712dab5a828f915ee255f5bb973db33946aab4057427419"
	},
	"call_me_tone4": {
		"category": "people",
		"moji": "🤙🏾",
		"unicodeVersion": "9.0",
		"digest": "f7787e933978a09c7b8ab8d3b1e1ab395aaae998c455e93bb3db24a4c8a60fe0"
	},
	"call_me_tone5": {
		"category": "people",
		"moji": "🤙🏿",
		"unicodeVersion": "9.0",
		"digest": "1fdb7d833d000b117d20d48142d3026a61cc9c8b712ebb498fa66bf75c74d7a5"
	},
	"calling": {
		"category": "objects",
		"moji": "📲",
		"unicodeVersion": "6.0",
		"digest": "acf668c75c11c36686005788266524a972fa1c5bcf666ff3403d909edc5cee91"
	},
	"camel": {
		"category": "nature",
		"moji": "🐫",
		"unicodeVersion": "6.0",
		"digest": "5f927927a7ab1277d0dc8b8211436957968b1e11365a8bf535e9bb94f92c5631"
	},
	"camera": {
		"category": "objects",
		"moji": "📷",
		"unicodeVersion": "6.0",
		"digest": "fde03e396822a36cd6ae756ede885b945a074395264162731ca5db47a3b39d80"
	},
	"camera_with_flash": {
		"category": "objects",
		"moji": "📸",
		"unicodeVersion": "7.0",
		"digest": "9afd380208187780f00244c45d4db6c5ea1ea088d4a1bd8fc92a8f3877149750"
	},
	"camping": {
		"category": "travel",
		"moji": "🏕",
		"unicodeVersion": "7.0",
		"digest": "a42a4ff9521affa72db7b0f01da169b4cb6afb9db1c5dfad47dd4c507bfc30d9"
	},
	"cancer": {
		"category": "symbols",
		"moji": "♋",
		"unicodeVersion": "1.1",
		"digest": "528c6f21df99a756b553d93a7f395b0f662b30a323affd05f0cedee8ff7b41d6"
	},
	"candle": {
		"category": "objects",
		"moji": "🕯",
		"unicodeVersion": "7.0",
		"digest": "211c04dc3a91b071c284d4180ed09f9d3320e3fd6ba8a9fddd0677bc97fd12cb"
	},
	"candy": {
		"category": "food",
		"moji": "🍬",
		"unicodeVersion": "6.0",
		"digest": "9cff4538918f60f770fceb96e964f5dc3ce31fd08ddd2ab3bfdf2981bfa74100"
	},
	"canoe": {
		"category": "travel",
		"moji": "🛶",
		"unicodeVersion": "9.0",
		"digest": "56ca308cc2ad4827468cf58c4ccf6ef6b3382835a91e935540a2b973e01d2572"
	},
	"capital_abcd": {
		"category": "symbols",
		"moji": "🔠",
		"unicodeVersion": "6.0",
		"digest": "a416d0b3f564037b680f801fb773b6eaf67225e2cbbfd2cb8a5db0de044321fa"
	},
	"capricorn": {
		"category": "symbols",
		"moji": "♑",
		"unicodeVersion": "1.1",
		"digest": "f11abad102603737b55486fe2ea4d01f28b203394bcd84f19a7948156e6c4b96"
	},
	"card_box": {
		"category": "objects",
		"moji": "🗃",
		"unicodeVersion": "7.0",
		"digest": "7a6199d562f30e02ed31094de6aebeb99eae8ac156f6910463dfed73256f4c9a"
	},
	"card_index": {
		"category": "objects",
		"moji": "📇",
		"unicodeVersion": "6.0",
		"digest": "86e187e0a72ca5d00207d6ef34d66ce15046848a831c2b5184fb840c5332a2a8"
	},
	"carousel_horse": {
		"category": "travel",
		"moji": "🎠",
		"unicodeVersion": "6.0",
		"digest": "c0e7059efc39a64233f774c02ddb1ab51888fff180f906ce13a6e4f9509672fe"
	},
	"carrot": {
		"category": "food",
		"moji": "🥕",
		"unicodeVersion": "9.0",
		"digest": "3a6fd98b63ee73d982a9cdacb08cf7b4014368cde8ffce6056b7df25a5a472b1"
	},
	"cartwheel": {
		"category": "activity",
		"moji": "🤸",
		"unicodeVersion": "9.0",
		"digest": "d78de3435e0b04a9b1a1048ae12e63e3248f9ace3a0db4d3bda584f22af18863"
	},
	"cartwheel_tone1": {
		"category": "activity",
		"moji": "🤸🏻",
		"unicodeVersion": "9.0",
		"digest": "39a49781a269bb40d8efc8fd73c973b00fb2e192850ea6073062b5dea0cd5b74"
	},
	"cartwheel_tone2": {
		"category": "activity",
		"moji": "🤸🏼",
		"unicodeVersion": "9.0",
		"digest": "6231eb35be45457fd648f8f4b79983f03705c9d983a18067f7e6d9ae47bc1958"
	},
	"cartwheel_tone3": {
		"category": "activity",
		"moji": "🤸🏽",
		"unicodeVersion": "9.0",
		"digest": "ca483c78cc823811a8c279c501d9b283e4c990dafc5995ad40e68ecb0af554df"
	},
	"cartwheel_tone4": {
		"category": "activity",
		"moji": "🤸🏾,",
		"unicodeVersion": "9.0",
		"digest": "8253afb672431c84e498014c30babb00b9284bec773009e79f7f06aa7108643e"
	},
	"cartwheel_tone5": {
		"category": "activity",
		"moji": "🤸🏿",
		"unicodeVersion": "9.0",
		"digest": "6fd92baff57c38b3adb6753d9e7e547e762971a8872fd3f1e71c6aaf0b1d3ab9"
	},
	"cat": {
		"category": "nature",
		"moji": "🐱",
		"unicodeVersion": "6.0",
		"digest": "e52d0d3a205a0ba99094717e171a7f572b713a0e21b276ffa4a826596fe5cafc"
	},
	"cat2": {
		"category": "nature",
		"moji": "🐈",
		"unicodeVersion": "6.0",
		"digest": "46aa67a99f782935932c77b8de93287142297abe52928c173191cf55bb8f4339"
	},
	"cd": {
		"category": "objects",
		"moji": "💿",
		"unicodeVersion": "6.0",
		"digest": "16363d8a34b873c12df6354b99f575cae3d80e0d27100ed7eea70f0310953c7b"
	},
	"chains": {
		"category": "objects",
		"moji": "⛓",
		"unicodeVersion": "5.2",
		"digest": "3884cdbc6f2b433062af06f942552e563231c24727a2f10fa280b3bb7aa614e2"
	},
	"champagne": {
		"category": "food",
		"moji": "🍾",
		"unicodeVersion": "8.0",
		"digest": "9e6e8987f30a37ae0f3d7dab2f5eeb50aa32b4f31402b29315eb2994afc72457"
	},
	"champagne_glass": {
		"category": "food",
		"moji": "🥂",
		"unicodeVersion": "9.0",
		"digest": "5a2e4773f7eb126a00122cbfa4dc535da51ce00e0bf0d8d6ff8bab8b3365f8d2"
	},
	"chart": {
		"category": "symbols",
		"moji": "💹",
		"unicodeVersion": "6.0",
		"digest": "a092dbc08f925b028286b2b495a5f59033b8537a586a694f46f4c1e7c3a1e27f"
	},
	"chart_with_downwards_trend": {
		"category": "objects",
		"moji": "📉",
		"unicodeVersion": "6.0",
		"digest": "5db7ccbc37665736a9c0b2f50247dcc09e404ec37f39db45b7b8b9464172a18c"
	},
	"chart_with_upwards_trend": {
		"category": "objects",
		"moji": "📈",
		"unicodeVersion": "6.0",
		"digest": "bc4ea250b102fe5c09847e471478aff065ad3df755d9717896d38d887d9c6733"
	},
	"checkered_flag": {
		"category": "travel",
		"moji": "🏁",
		"unicodeVersion": "6.0",
		"digest": "0e77180e0cf9fc87e755a5a42cf23aec6bf30931db41331311e97ba0be178b78"
	},
	"cheese": {
		"category": "food",
		"moji": "🧀",
		"unicodeVersion": "8.0",
		"digest": "50a6cb906c2120e2bbc0e22105924262007cfe1554d7b02b8cc84b6adedc6a0b"
	},
	"cherries": {
		"category": "food",
		"moji": "🍒",
		"unicodeVersion": "6.0",
		"digest": "13b8db9e7e6eec8509aa80c762966e1bf3538fcb1ac3d6eab18ee4da1528cf84"
	},
	"cherry_blossom": {
		"category": "nature",
		"moji": "🌸",
		"unicodeVersion": "6.0",
		"digest": "af3083f5f8dd94936113f2e16caba5aec7a774d5589aa08bf5de82a2d278cc66"
	},
	"chestnut": {
		"category": "nature",
		"moji": "🌰",
		"unicodeVersion": "6.0",
		"digest": "9f85b79b207a69ab81ab88dcef04954000965b039b4cf57de5f1b381745ab98b"
	},
	"chicken": {
		"category": "nature",
		"moji": "🐔",
		"unicodeVersion": "6.0",
		"digest": "57ceb4459d183740009caac6ebed089d2f1e12f67c138e1be1d0f992313c0ac4"
	},
	"children_crossing": {
		"category": "symbols",
		"moji": "🚸",
		"unicodeVersion": "6.0",
		"digest": "0ded7d9aca0161e8ef8e2858c3c198e70e4badc7105ac3a6886e06975de19106"
	},
	"chipmunk": {
		"category": "nature",
		"moji": "🐿",
		"unicodeVersion": "7.0",
		"digest": "5b0dc1a859163097727ba2ba5ffca38b0a54d925eebb089977d28d0b4d917a3f"
	},
	"chocolate_bar": {
		"category": "food",
		"moji": "🍫",
		"unicodeVersion": "6.0",
		"digest": "dd273e5050488acaf885f8a18b6e2b3901f69c5b39fa6465fb60621783d4109a"
	},
	"christmas_tree": {
		"category": "nature",
		"moji": "🎄",
		"unicodeVersion": "6.0",
		"digest": "ce60cbe2ebbe8057be8edea2392455fedd2bcda64a0a831f6a1942028af7e747"
	},
	"church": {
		"category": "travel",
		"moji": "⛪",
		"unicodeVersion": "5.2",
		"digest": "2c328456528f7336e59443e20ec3ab22fe71f1fccb1dd50d0ad68eb206937557"
	},
	"cinema": {
		"category": "symbols",
		"moji": "🎦",
		"unicodeVersion": "6.0",
		"digest": "4c26dcdc76f93dbc2a1dc49ed4e132b8e8f2b7cdc1acf5e09b3dfd99430d97cd"
	},
	"circus_tent": {
		"category": "activity",
		"moji": "🎪",
		"unicodeVersion": "6.0",
		"digest": "fec5f2a06222be8be549178b29720343cc00145177ec387ca4e6f3432481fe77"
	},
	"city_dusk": {
		"category": "travel",
		"moji": "🌆",
		"unicodeVersion": "6.0",
		"digest": "bba345e949dcc51f5f018220f000223797970c82ead2ab9c822f9dc0847aa155"
	},
	"city_sunset": {
		"category": "travel",
		"moji": "🌇",
		"unicodeVersion": "6.0",
		"digest": "a846df1a4c7c778f8e1729804aece86eb29d2fcb95dc39eaaf2aae1897f3dcc7"
	},
	"cityscape": {
		"category": "travel",
		"moji": "🏙",
		"unicodeVersion": "7.0",
		"digest": "ee360be7514c4bfb0d539dd28f3b2031ebcef04e850723ec0685fb54bd8e6d5f"
	},
	"cl": {
		"category": "symbols",
		"moji": "🆑",
		"unicodeVersion": "6.0",
		"digest": "fcec2855dbad9fda11d6e2802bc0dcaabab0b5be233508f5e439f156f07602c1"
	},
	"clap": {
		"category": "people",
		"moji": "👏",
		"unicodeVersion": "6.0",
		"digest": "a1860ce7812a9f6fb55e45761e1b79a2f8f0620eb04f80748a38420889d58a2a"
	},
	"clap_tone1": {
		"category": "people",
		"moji": "👏🏻",
		"unicodeVersion": "8.0",
		"digest": "18a7022e08223fb2109af5a9b9a5b4f47dc870ce4453f4987d2d0b729ef54586"
	},
	"clap_tone2": {
		"category": "people",
		"moji": "👏🏼",
		"unicodeVersion": "8.0",
		"digest": "5954c8658b15e755d2018d8674df84d38e22ffededc4d726c6a33b709f71426a"
	},
	"clap_tone3": {
		"category": "people",
		"moji": "👏🏽",
		"unicodeVersion": "8.0",
		"digest": "22639b6bd3c53784a2f855d6db7bdf31621519f19dfc29a6bc310eee6421f742"
	},
	"clap_tone4": {
		"category": "people",
		"moji": "👏🏾",
		"unicodeVersion": "8.0",
		"digest": "e55248dc163d1bbd118b50cd8767750ead86d082151febbc0a75b32d63abceec"
	},
	"clap_tone5": {
		"category": "people",
		"moji": "👏🏿",
		"unicodeVersion": "8.0",
		"digest": "76046b8157dabbe048a07fc318122456020c9c980fc1b8ab76802330e07b3b53"
	},
	"clapper": {
		"category": "activity",
		"moji": "🎬",
		"unicodeVersion": "6.0",
		"digest": "8149752a0e3e8abede2d433d1afab6d217877d0c76adb1e2845a0142c0cdcbaa"
	},
	"classical_building": {
		"category": "travel",
		"moji": "🏛",
		"unicodeVersion": "7.0",
		"digest": "9ee0d00c43d6e22b6a3ddea67619737270cc7e9294797a19c7c60d5f92aa44fa"
	},
	"clipboard": {
		"category": "objects",
		"moji": "📋",
		"unicodeVersion": "6.0",
		"digest": "bdd7f7d973c714e59d2903d401a876e6018794c7987c9ca57108c137c5edc25f"
	},
	"clock": {
		"category": "objects",
		"moji": "🕰",
		"unicodeVersion": "7.0",
		"digest": "302835eab2637db799acf69b3d795571ef3432251267050db0704f2954e8b190"
	},
	"clock1": {
		"category": "symbols",
		"moji": "🕐",
		"unicodeVersion": "6.0",
		"digest": "1778eec07ce061c9393e5abee5ca83b24e1ce61d8a75fa2e39efcb31aa160395"
	},
	"clock10": {
		"category": "symbols",
		"moji": "🕙",
		"unicodeVersion": "6.0",
		"digest": "601fc12ea5280a54c2e69dbb685f454e4165fe771756ed6f89016e29e683a24f"
	},
	"clock1030": {
		"category": "symbols",
		"moji": "🕥",
		"unicodeVersion": "6.0",
		"digest": "4fd155f08f797542d52cff4b0aa3ca9f080f37a41c301b82f90ff6d4693c890e"
	},
	"clock11": {
		"category": "symbols",
		"moji": "🕚",
		"unicodeVersion": "6.0",
		"digest": "5c79dc812e812e8a01993ea633b323d654ce3a7ea258692781a4896e4ad2017e"
	},
	"clock1130": {
		"category": "symbols",
		"moji": "🕦",
		"unicodeVersion": "6.0",
		"digest": "41497ee2020ee5ac9aa5f9b07560f7afca7c422b04214449cfc5cea9f020f52e"
	},
	"clock12": {
		"category": "symbols",
		"moji": "🕛",
		"unicodeVersion": "6.0",
		"digest": "046bb7ffa5f5d27c2e3411ba543484d9dabb8ebf6d6e7a7e9bfb088c1813500c"
	},
	"clock1230": {
		"category": "symbols",
		"moji": "🕧",
		"unicodeVersion": "6.0",
		"digest": "bbfe9db5a2043aaba19a7a2a0185c7efcebf1e8c9263b8233f75b53c4825f0f4"
	},
	"clock130": {
		"category": "symbols",
		"moji": "🕜",
		"unicodeVersion": "6.0",
		"digest": "8662cb395ee680c2781123305c4c8ce8c0df9565c2c942668940be540cc0c094"
	},
	"clock2": {
		"category": "symbols",
		"moji": "🕑",
		"unicodeVersion": "6.0",
		"digest": "42f7429748b612dce7de77221cbbc710655811f7bb23e2a986c36e6d662f0ec4"
	},
	"clock230": {
		"category": "symbols",
		"moji": "🕝",
		"unicodeVersion": "6.0",
		"digest": "e710b6ef14227cd240ea3e2a867c8ef45b5c060adf3cb30ba9077c2351fe6677"
	},
	"clock3": {
		"category": "symbols",
		"moji": "🕒",
		"unicodeVersion": "6.0",
		"digest": "7340d465b398a378211dff9ec806db579d061206fd6fc238623d070cfe0a55ce"
	},
	"clock330": {
		"category": "symbols",
		"moji": "🕞",
		"unicodeVersion": "6.0",
		"digest": "7aa4a15cc8de04ed3bdeb0f8a54a7915065f2809a07054e002d89926c9766831"
	},
	"clock4": {
		"category": "symbols",
		"moji": "🕓",
		"unicodeVersion": "6.0",
		"digest": "36fd88e81ad488b0ec49a911a838693281573fa14736ae4a6dd1c40a4ff69bb1"
	},
	"clock430": {
		"category": "symbols",
		"moji": "🕟",
		"unicodeVersion": "6.0",
		"digest": "7bd5dd71e89d95dcf18b9e8c1fe2a353a7da3b69aadb8dda80ee9bafb05da58d"
	},
	"clock5": {
		"category": "symbols",
		"moji": "🕔",
		"unicodeVersion": "6.0",
		"digest": "aa406409e56a0bfd8c850e44efe45fd190ffd7bf7061e934ed7928dfbdfc9eba"
	},
	"clock530": {
		"category": "symbols",
		"moji": "🕠",
		"unicodeVersion": "6.0",
		"digest": "25dd3bcc53ddd98eeea498d7dbd4c306ef39dd033f15909063388a0800febf41"
	},
	"clock6": {
		"category": "symbols",
		"moji": "🕕",
		"unicodeVersion": "6.0",
		"digest": "0a321eaf1bc5db8436bbadac66c45ba257fc98ad4c7569ce3fc6602c824b6d7c"
	},
	"clock630": {
		"category": "symbols",
		"moji": "🕡",
		"unicodeVersion": "6.0",
		"digest": "55a4c5a665fdd38a724e9357a93c55401fcd5f1b13078c25754bd70c3fc4ccec"
	},
	"clock7": {
		"category": "symbols",
		"moji": "🕖",
		"unicodeVersion": "6.0",
		"digest": "6154306545716e865da0ec537ee4f22bfe6c7294502a64a2dcf425c587d0e2a2"
	},
	"clock730": {
		"category": "symbols",
		"moji": "🕢",
		"unicodeVersion": "6.0",
		"digest": "6925654de642e50f84661f94364a96c87757d73fffe766aacbf4bbd70130547b"
	},
	"clock8": {
		"category": "symbols",
		"moji": "🕗",
		"unicodeVersion": "6.0",
		"digest": "9be2d189c7ea56d39fd259f84853d753c1cf33e64f8ed57f86f822d9ae23a1ee"
	},
	"clock830": {
		"category": "symbols",
		"moji": "🕣",
		"unicodeVersion": "6.0",
		"digest": "16878613c0000d2f558c88d080551f424a8bd9df1358e0f931dd25c3da68f2d9"
	},
	"clock9": {
		"category": "symbols",
		"moji": "🕘",
		"unicodeVersion": "6.0",
		"digest": "1d1e7e3c9d085ffa5b7c0f3d9fd394b734f16ae3b60df09af50fe6c8d4f3c8bb"
	},
	"clock930": {
		"category": "symbols",
		"moji": "🕤",
		"unicodeVersion": "6.0",
		"digest": "9fdef6a4939315c017b165e1dbac7710fb335df8c309be3fe2a011ef7fc28d74"
	},
	"closed_book": {
		"category": "objects",
		"moji": "📕",
		"unicodeVersion": "6.0",
		"digest": "b18288629d201bfdfc5d66ec47df89809d00642b15732757e6a04789f36a7d9f"
	},
	"closed_lock_with_key": {
		"category": "objects",
		"moji": "🔐",
		"unicodeVersion": "6.0",
		"digest": "e39adfe9b30973bca16472c2b7e6462b064a93b9d452aa48edd74c727641a83d"
	},
	"closed_umbrella": {
		"category": "people",
		"moji": "🌂",
		"unicodeVersion": "6.0",
		"digest": "2cc0592c74601f7439e88c3c1ec4f05e3459608ef1ea6558c5824ed7c3889727"
	},
	"cloud": {
		"category": "nature",
		"moji": "☁",
		"unicodeVersion": "1.1",
		"digest": "5b3a19718dfa8a381929665afdc2284464d24020c8dd0caff4dad465a1f536ba"
	},
	"cloud_lightning": {
		"category": "nature",
		"moji": "🌩",
		"unicodeVersion": "7.0",
		"digest": "2b32f6d87726df2935ad81870879ccec30ce9b4fd5861d1a6317f9eca2f013d9"
	},
	"cloud_rain": {
		"category": "nature",
		"moji": "🌧",
		"unicodeVersion": "7.0",
		"digest": "1e1e8bc59e168e1d2e72bf11f2d43cb578cbf0a5f1daf383bba5c56fb750ee71"
	},
	"cloud_snow": {
		"category": "nature",
		"moji": "🌨",
		"unicodeVersion": "7.0",
		"digest": "2d364f859b83e684213e8eece1640208d80a8de0a49d0fc8e0e24c5a8493a3b1"
	},
	"cloud_tornado": {
		"category": "nature",
		"moji": "🌪",
		"unicodeVersion": "7.0",
		"digest": "7cbed2343c280ba3996082b3d0fb9d8cd57d6e62fe6c9ecb159f46b4a2e49151"
	},
	"clown": {
		"category": "people",
		"moji": "🤡",
		"unicodeVersion": "9.0",
		"digest": "eea95687caabc9e808514c2450ba599e5e24ef47923dbec86f5297a64438e2e5"
	},
	"clubs": {
		"category": "symbols",
		"moji": "♣",
		"unicodeVersion": "1.1",
		"digest": "b8cf72ecd8568ced077b475d94788fb282bdb06d25031b5d54dd63e25effb138"
	},
	"cocktail": {
		"category": "food",
		"moji": "🍸",
		"unicodeVersion": "6.0",
		"digest": "3792def2cde885cf32167f04904d3b0b788388e8af410c63e4cd31550feba775"
	},
	"coffee": {
		"category": "food",
		"moji": "☕",
		"unicodeVersion": "4.0",
		"digest": "0d29615a7a67d3aafa257b909bb915dc74fa8f854acb0d9a2c29e94eedf80326"
	},
	"coffin": {
		"category": "objects",
		"moji": "⚰",
		"unicodeVersion": "4.1",
		"digest": "78eccc1aad2a822649fba8503d4d30354bef367c4271193c40ddb692308f9db8"
	},
	"cold_sweat": {
		"category": "people",
		"moji": "😰",
		"unicodeVersion": "6.0",
		"digest": "f53aab523ed3fa2224a16881d263fb5e039f163380f92feb2c63c20f9b14dcd2"
	},
	"comet": {
		"category": "nature",
		"moji": "☄",
		"unicodeVersion": "1.1",
		"digest": "40ce93e55c6e57a88d80670b37171190bd5ffc87b7078891d8de5b15795385c5"
	},
	"compression": {
		"category": "objects",
		"moji": "🗜",
		"unicodeVersion": "7.0",
		"digest": "c8841f7afb5345f1c31da116a7fb41d07232ea58d3f7f1a75c5890aa1a80bfd6"
	},
	"computer": {
		"category": "objects",
		"moji": "💻",
		"unicodeVersion": "6.0",
		"digest": "c970ce76b5607434895b0407bdaa93140f887930781a17dd7dcf16f711451d93"
	},
	"confetti_ball": {
		"category": "objects",
		"moji": "🎊",
		"unicodeVersion": "6.0",
		"digest": "a638b16f1acdbcf69edf760161b1bd7ff1fd5426c5b1203ad9d294dcc0701f10"
	},
	"confounded": {
		"category": "people",
		"moji": "😖",
		"unicodeVersion": "6.0",
		"digest": "e2ff3b4df65d00c1ca9ae0cb379f959ea2cecefb3d676d4f8c2c5f2c103da4f6"
	},
	"confused": {
		"category": "people",
		"moji": "😕",
		"unicodeVersion": "6.1",
		"digest": "118d7f830ec08a3ac4b798eebb77a989b8c142f2588727181be4a2548e3c4f06"
	},
	"congratulations": {
		"category": "symbols",
		"moji": "㊗",
		"unicodeVersion": "1.1",
		"digest": "02fd1338c54fe5f9a0fd861f23c56edc1d39bcd3140b68f0f626f9e2494d2d1c"
	},
	"construction": {
		"category": "travel",
		"moji": "🚧",
		"unicodeVersion": "6.0",
		"digest": "c3a0401331111b9eda1206bee5f322db80b0870547d307b10dcac1314e4078c8"
	},
	"construction_site": {
		"category": "travel",
		"moji": "🏗",
		"unicodeVersion": "7.0",
		"digest": "c611f0a5de10f000a0756935f226845c7292f19ff5581d1f7a7554316338bbcb"
	},
	"construction_worker": {
		"category": "people",
		"moji": "👷",
		"unicodeVersion": "6.0",
		"digest": "8c094733987e7c4da8d3aa4588b530ae07042bd70cf337b1fd412a70ee8f0ed6"
	},
	"construction_worker_tone1": {
		"category": "people",
		"moji": "👷🏻",
		"unicodeVersion": "8.0",
		"digest": "fcd927405fef4486105cd3aff62155467d21cebbc013924d4b52b717b566602b"
	},
	"construction_worker_tone2": {
		"category": "people",
		"moji": "👷🏼",
		"unicodeVersion": "8.0",
		"digest": "d1ec773828936c703dd6e334e696dc3cf7c34c0a8ec691564a384b735cdeaaba"
	},
	"construction_worker_tone3": {
		"category": "people",
		"moji": "👷🏽",
		"unicodeVersion": "8.0",
		"digest": "37c114d6879b9b32b800b0d4cf770dcbe04d1455698130ecd709a0cb9dea880b"
	},
	"construction_worker_tone4": {
		"category": "people",
		"moji": "👷🏾",
		"unicodeVersion": "8.0",
		"digest": "5264996c1bedb6061a0dfdddce233d863bf308d27127ad152b63bfd983162cf7"
	},
	"construction_worker_tone5": {
		"category": "people",
		"moji": "👷🏿",
		"unicodeVersion": "8.0",
		"digest": "87051aec81fd5dfd4dc44ff0411a528ee08253e9494d37efa550694e28dde6d3"
	},
	"control_knobs": {
		"category": "objects",
		"moji": "🎛",
		"unicodeVersion": "7.0",
		"digest": "0d7f33ff7acc1cc3a81e6a786ff007df20da145e3070f338505dfed5100e9fcb"
	},
	"convenience_store": {
		"category": "travel",
		"moji": "🏪",
		"unicodeVersion": "6.0",
		"digest": "975dcf9b8e9e3fb1e29574b41300b9d96fd64703b3c18ff52f9f1875d1cf1b52"
	},
	"cookie": {
		"category": "food",
		"moji": "🍪",
		"unicodeVersion": "6.0",
		"digest": "4bed3522bd50091ac5b68ca760661eb484d7f1b9c9d564d2097bd812b7f28ae4"
	},
	"cooking": {
		"category": "food",
		"moji": "🍳",
		"unicodeVersion": "6.0",
		"digest": "563ffd6cae381ce1e318cdacc54e70040d6a01a50d0db8aeb50edbbe413eac58"
	},
	"cool": {
		"category": "symbols",
		"moji": "🆒",
		"unicodeVersion": "6.0",
		"digest": "5739a37341c782a4736adfce804e12776ae33081098a3d052d8ae9a64b4d22d1"
	},
	"cop": {
		"category": "people",
		"moji": "👮",
		"unicodeVersion": "6.0",
		"digest": "78996521bbe231d03ebea355226d8a1515f47cde7b2fbeca1037e7b7e5133466"
	},
	"cop_tone1": {
		"category": "people",
		"moji": "👮🏻",
		"unicodeVersion": "8.0",
		"digest": "8a38cd107f5f4c0b821ac43f32df5dc57facaf39fbafb98483ec00fd7df41baf"
	},
	"cop_tone2": {
		"category": "people",
		"moji": "👮🏼",
		"unicodeVersion": "8.0",
		"digest": "8ab8ab086f3ff82aa4bf4760c3c822846ec2696c41d21dffdac12d5afbe398b7"
	},
	"cop_tone3": {
		"category": "people",
		"moji": "👮🏽",
		"unicodeVersion": "8.0",
		"digest": "fce710a99fd44a7c8af3ea01b2007e46d3ff38d7a0dff1ef26d6f893ede7e6d2"
	},
	"cop_tone4": {
		"category": "people",
		"moji": "👮🏾",
		"unicodeVersion": "8.0",
		"digest": "3017dd73ef475379911c5e6c79bd0f9f533dbbc5057bce6a11244faa12996ba0"
	},
	"cop_tone5": {
		"category": "people",
		"moji": "👮🏿",
		"unicodeVersion": "8.0",
		"digest": "a3b8807b3f2a8d6ee9bcec0339355bda486e8c930f727139f5447a4b046a6307"
	},
	"copyright": {
		"category": "symbols",
		"moji": "©",
		"unicodeVersion": "1.1",
		"digest": "cc28663cdd3f8333d9bb57b511348cde4e51bda19cf0629dccb05c8fc425e079"
	},
	"corn": {
		"category": "food",
		"moji": "🌽",
		"unicodeVersion": "6.0",
		"digest": "a099a0b291fa758690e6ee6c762b9ade9a0e3350a707c52d968dfffbcc467de5"
	},
	"couch": {
		"category": "objects",
		"moji": "🛋",
		"unicodeVersion": "7.0",
		"digest": "84cd734dbaa7f9f519438036d687e7a53217130779bc3de30258f163521b9474"
	},
	"couple": {
		"category": "people",
		"moji": "👫",
		"unicodeVersion": "6.0",
		"digest": "c897ba76e24e2f43a4aa261c2754800a8473f43c7ce53f9909a6af2c4897732a"
	},
	"couple_mm": {
		"category": "people",
		"moji": "👨‍❤️‍👨",
		"unicodeVersion": "6.0",
		"digest": "c812471d35d46e12270653039a907d1dfa2dea0defd65596283e5b8e03cea803"
	},
	"couple_with_heart": {
		"category": "people",
		"moji": "💑",
		"unicodeVersion": "6.0",
		"digest": "420bfa81bad10365550c77a98e1c07eb00d03663fe7b610fab1aca8a0a9d201b"
	},
	"couple_ww": {
		"category": "people",
		"moji": "👩‍❤️‍👩",
		"unicodeVersion": "6.0",
		"digest": "7ac49153a612d63302299eee996308b7dcafa0a152473dab679215036fe6567e"
	},
	"couplekiss": {
		"category": "people",
		"moji": "💏",
		"unicodeVersion": "6.0",
		"digest": "1acfef9d375c4c1deb235babd856b0f90ad4f3194751694cb6abb44f00f29e42"
	},
	"cow": {
		"category": "nature",
		"moji": "🐮",
		"unicodeVersion": "6.0",
		"digest": "d71c854ff8b343ee24b8c2b9d56c7cb3fc6fa1a6dc0d7a137841b9f646e6d71b"
	},
	"cow2": {
		"category": "nature",
		"moji": "🐄",
		"unicodeVersion": "6.0",
		"digest": "e7a5131d7dee0f3356814b0ac1ea8ff280b12a7b580181e20ddb0b7eeb7e7339"
	},
	"cowboy": {
		"category": "people",
		"moji": "🤠",
		"unicodeVersion": "9.0",
		"digest": "1aabf23f6b95a9b772fdb8eb45b8ec93584a5357f9131c6eabc9d1b83fe67e89"
	},
	"crab": {
		"category": "nature",
		"moji": "🦀",
		"unicodeVersion": "8.0",
		"digest": "e6be16699fdb5d87f42f28f6cc141a44b7ffd834ecdd536813c4b5b86d3fc4a5"
	},
	"crayon": {
		"category": "objects",
		"moji": "🖍",
		"unicodeVersion": "7.0",
		"digest": "b180d6afa4777861222a4228164ce284230fe90c589f52ffa9351bac777e901a"
	},
	"credit_card": {
		"category": "objects",
		"moji": "💳",
		"unicodeVersion": "6.0",
		"digest": "808cd120fd3738eb2be1f6c6c029d98387b0e03fca7d1451e8fbf9c5ab3f643f"
	},
	"crescent_moon": {
		"category": "nature",
		"moji": "🌙",
		"unicodeVersion": "6.0",
		"digest": "042e7e01e6e88b97a763b7cc41e2a2b3fe68a649bacf4a090cd28fc653baf640"
	},
	"cricket": {
		"category": "activity",
		"moji": "🏏",
		"unicodeVersion": "8.0",
		"digest": "4c4559d0b4efe24cc248fa57f413541307992e519d0cb9fb8828637ac2f4cc16"
	},
	"crocodile": {
		"category": "nature",
		"moji": "🐊",
		"unicodeVersion": "6.0",
		"digest": "59cb4164c50b6bc9ae311ce6f7610467c1aaafa848b5fff7614f064715f91992"
	},
	"croissant": {
		"category": "food",
		"moji": "🥐",
		"unicodeVersion": "9.0",
		"digest": "b751e287157a1e276617a841a5b5f7f1208ca226cfd8fa947f144390b65a5e16"
	},
	"cross": {
		"category": "symbols",
		"moji": "✝",
		"unicodeVersion": "1.1",
		"digest": "a6b07c838fb75ef2ebefa2df6005e8d784753239ec03c37695a13e3b1954d653"
	},
	"crossed_flags": {
		"category": "objects",
		"moji": "🎌",
		"unicodeVersion": "6.0",
		"digest": "2841c671075e6f1a79c61c2d716423159fb0bc0786e3fb0049697766533bf262"
	},
	"crossed_swords": {
		"category": "objects",
		"moji": "⚔",
		"unicodeVersion": "4.1",
		"digest": "3771a5b26b514236521ce44e15f7730fa9148c6a782b9b600ab870a1f7de6f9f"
	},
	"crown": {
		"category": "people",
		"moji": "👑",
		"unicodeVersion": "6.0",
		"digest": "6741e58d8f823194e0a3484ac1563e20d9e0b44c1bc46d82444dfffa092cdfc7"
	},
	"cruise_ship": {
		"category": "travel",
		"moji": "🛳",
		"unicodeVersion": "7.0",
		"digest": "2b7b62db5d118a632673564099e3405ea6d61ea9b8e123b5a2aaf011bb2a54a4"
	},
	"cry": {
		"category": "people",
		"moji": "😢",
		"unicodeVersion": "6.0",
		"digest": "fc3307ec4fe75539770c1123a0e8e721d9e021009a502655132f68d7cc453816"
	},
	"crying_cat_face": {
		"category": "people",
		"moji": "😿",
		"unicodeVersion": "6.0",
		"digest": "4942c24935c22babdcb8af41d2c0a7588356b6b674bc238902e2f10ad03e2c5b"
	},
	"crystal_ball": {
		"category": "objects",
		"moji": "🔮",
		"unicodeVersion": "6.0",
		"digest": "05f73b30b1e5b0fc66fb5dc6caddd2d547ee7b9d2f97513dc908ba1a2e352e30"
	},
	"cucumber": {
		"category": "food",
		"moji": "🥒",
		"unicodeVersion": "9.0",
		"digest": "d1196e23f2f155ef5c1330f8497f40957a7357cb177127f457c5c471f0a23727"
	},
	"cupid": {
		"category": "symbols",
		"moji": "💘",
		"unicodeVersion": "6.0",
		"digest": "246e71f44c6ebc2e4f887e25438e4f894e8cc92e06069e711b893ff391abb658"
	},
	"curly_loop": {
		"category": "symbols",
		"moji": "➰",
		"unicodeVersion": "6.0",
		"digest": "9e4eb98d6597888f91208080c6a79824adb432ea34f46c85da26cb630bd1cc73"
	},
	"currency_exchange": {
		"category": "symbols",
		"moji": "💱",
		"unicodeVersion": "6.0",
		"digest": "b85377265b9876888969aa42b65bba0be523a370175baf226f20131e535af554"
	},
	"curry": {
		"category": "food",
		"moji": "🍛",
		"unicodeVersion": "6.0",
		"digest": "a01c0a713662817720b485f7739f57e61afc025f5c43792f4de961c94f92f31e"
	},
	"custard": {
		"category": "food",
		"moji": "🍮",
		"unicodeVersion": "6.0",
		"digest": "85c2b9ac904134a6c3587eb0a0806f2ab4282c5ed5c79d41734f3203998f757e"
	},
	"customs": {
		"category": "symbols",
		"moji": "🛃",
		"unicodeVersion": "6.0",
		"digest": "eb2546e1e617d4c1a1f614318af5e5dacf3e8d9479ffa08108977defa83ded32"
	},
	"cyclone": {
		"category": "symbols",
		"moji": "🌀",
		"unicodeVersion": "6.0",
		"digest": "7a0f8564d76adf2d0ed272f56dc0d01fb7b557852e0ca797e73f5472b8630bf3"
	},
	"dagger": {
		"category": "objects",
		"moji": "🗡",
		"unicodeVersion": "7.0",
		"digest": "35a179168198d03295e626cc27d3b92d30a732c55a2ca75d7a11a0fbed414772"
	},
	"dancer": {
		"category": "people",
		"moji": "💃",
		"unicodeVersion": "6.0",
		"digest": "66ffa86827e85acae4aa870c0859fe3a9dad03d21ff4bc800b61c95c902a8a90"
	},
	"dancer_tone1": {
		"category": "people",
		"moji": "💃🏻",
		"unicodeVersion": "8.0",
		"digest": "bdbee740addc890e369d3469a3585eb0d1e4fbc7e04dd6f6aca762d8aeee6a8c"
	},
	"dancer_tone2": {
		"category": "people",
		"moji": "💃🏼",
		"unicodeVersion": "8.0",
		"digest": "9f7b4c627241eaa2def9717a5286a423f0b9c1b044dd9ea4442a76f1858d14a4"
	},
	"dancer_tone3": {
		"category": "people",
		"moji": "💃🏽",
		"unicodeVersion": "8.0",
		"digest": "a6bd49a377ce6c2004bf126b6f66d0b21d8c14103c2add7b10f12ed9e1c2d302"
	},
	"dancer_tone4": {
		"category": "people",
		"moji": "💃🏾",
		"unicodeVersion": "8.0",
		"digest": "4ec2a7629c01b0e9006b5cda4deae3bf297ce3b71d18063f93eeb5c14be19a1a"
	},
	"dancer_tone5": {
		"category": "people",
		"moji": "💃🏿",
		"unicodeVersion": "8.0",
		"digest": "2b48e3a6b366c6f55f73b816e6fb03c39e9890f586f7e9c9043cf0c013d9cdd5"
	},
	"dancers": {
		"category": "people",
		"moji": "👯",
		"unicodeVersion": "6.0",
		"digest": "12be66ed19d232bb387270f40bece68bd0cb2342b318f6c9bb8b49c64ff7d0ad"
	},
	"dango": {
		"category": "food",
		"moji": "🍡",
		"unicodeVersion": "6.0",
		"digest": "34e8cd153c50f2d725abe8934c35c96a3ab533f0cc5fbb1e1474eafad1dc1fc2"
	},
	"dark_sunglasses": {
		"category": "people",
		"moji": "🕶",
		"unicodeVersion": "7.0",
		"digest": "d0a735ad5bf0ece00af2a21abf950b89292ebd8ca6e28b1dbb1368252fb44afe"
	},
	"dart": {
		"category": "activity",
		"moji": "🎯",
		"unicodeVersion": "6.0",
		"digest": "998642f06a875905e0a6bf30963c025baff1cf55b8e76884b9119f2d71188b0c"
	},
	"dash": {
		"category": "nature",
		"moji": "💨",
		"unicodeVersion": "6.0",
		"digest": "f7aae7d3887c67d76f3329c2dc9e6807dc580a4b07ab35599c7805e41823a345"
	},
	"date": {
		"category": "objects",
		"moji": "📅",
		"unicodeVersion": "6.0",
		"digest": "d0b695e4a7cfbbe71b4fbebf345b66ca98f0cf1c751362928e54c23ca78d4c7b"
	},
	"deciduous_tree": {
		"category": "nature",
		"moji": "🌳",
		"unicodeVersion": "6.0",
		"digest": "3c70f1a77f2754f41c830e88d43b7d53c14311d64626ded164aa9ac7d2695790"
	},
	"deer": {
		"category": "nature",
		"moji": "🦌",
		"unicodeVersion": "9.0",
		"digest": "7f4302ca68fd121ee73be48d0a0a0fb9e7e2741071a491ad2b7b0eab9f11ad25"
	},
	"department_store": {
		"category": "travel",
		"moji": "🏬",
		"unicodeVersion": "6.0",
		"digest": "4be910d2efe74d8ce2c1f41d7753c8873579faca83fcf779a4887d8ab9e5923b"
	},
	"desert": {
		"category": "travel",
		"moji": "🏜",
		"unicodeVersion": "7.0",
		"digest": "d4b1a11c5130debe042df6cc2b3389f15c68a5cb32dc1b3a82b78f733d0c9e4e"
	},
	"desktop": {
		"category": "objects",
		"moji": "🖥",
		"unicodeVersion": "7.0",
		"digest": "cde5bfb6c71bb7d663808a3561b24cb5b5560f95f510b40f81250cac1b21933e"
	},
	"diamond_shape_with_a_dot_inside": {
		"category": "symbols",
		"moji": "💠",
		"unicodeVersion": "6.0",
		"digest": "e91323577ab89e95b0fa0b9272ea0c797b76908f24d36992630e9325273a4ce3"
	},
	"diamonds": {
		"category": "symbols",
		"moji": "♦",
		"unicodeVersion": "1.1",
		"digest": "bf3d9a020afe8aa226db73590bc193a9c2c3e6e642edd2445c5960c3e67cf153"
	},
	"disappointed": {
		"category": "people",
		"moji": "😞",
		"unicodeVersion": "6.0",
		"digest": "c0f406c6beea0fd1328adefc097d04aa16b72f7a5afa0867967d8ea25d72db17"
	},
	"disappointed_relieved": {
		"category": "people",
		"moji": "😥",
		"unicodeVersion": "6.0",
		"digest": "c826f5dd4f2f7e5289d720851d4826ab8284d915606c1b152ab229b7fadbba14"
	},
	"dividers": {
		"category": "objects",
		"moji": "🗂",
		"unicodeVersion": "7.0",
		"digest": "4b2c653b18cf0fa31f1f0ac94a6fbd214ea0d1b0a90a450ab6e169906fc5764f"
	},
	"dizzy": {
		"category": "nature",
		"moji": "💫",
		"unicodeVersion": "6.0",
		"digest": "d577545c2de42389695447c6ebbfef895f30f0fda84eef45684f9bf4a9c27ff1"
	},
	"dizzy_face": {
		"category": "people",
		"moji": "😵",
		"unicodeVersion": "6.0",
		"digest": "7b3aeaffb4e15ccf633b91dda4a44847a1eb28d78ce58b4d171b20a771bde414"
	},
	"do_not_litter": {
		"category": "symbols",
		"moji": "🚯",
		"unicodeVersion": "6.0",
		"digest": "98b07fbbcdb438d1b8a755869fa2de8e180a77fce359ec830eb46d38ec3e67cb"
	},
	"dog": {
		"category": "nature",
		"moji": "🐶",
		"unicodeVersion": "6.0",
		"digest": "3b31ce067b13e463284ce85536512cb1f8cd8b52fe73659f69971d0d6c1dfc11"
	},
	"dog2": {
		"category": "nature",
		"moji": "🐕",
		"unicodeVersion": "6.0",
		"digest": "0a8901bce5ed994533ff84299b2a1364de28d872c9f9510d3426a83e8a9d2e34"
	},
	"dollar": {
		"category": "objects",
		"moji": "💵",
		"unicodeVersion": "6.0",
		"digest": "52438e38867aedc021740bb41f9ba336e75a50faa148419412a01d75d8c93155"
	},
	"dolls": {
		"category": "objects",
		"moji": "🎎",
		"unicodeVersion": "6.0",
		"digest": "a687184e9a0915deef44bb3cacfb19d3f3f19cf2c110f1da90191dd567333c57"
	},
	"dolphin": {
		"category": "nature",
		"moji": "🐬",
		"unicodeVersion": "6.0",
		"digest": "0b7ee08f4236232ca533ed3a3023d28020d36f178efaec5ce8b0e13a84778512"
	},
	"door": {
		"category": "objects",
		"moji": "🚪",
		"unicodeVersion": "6.0",
		"digest": "984a9ca88852ebdb539e0c385d9c6ffe5010e9189bc372a3d00f5c8d44c8e6f5"
	},
	"doughnut": {
		"category": "food",
		"moji": "🍩",
		"unicodeVersion": "6.0",
		"digest": "27634587e6a53807baa32157bb06b0e115c8ad8aefebba7ebb0b65a084170e3a"
	},
	"dove": {
		"category": "nature",
		"moji": "🕊",
		"unicodeVersion": "7.0",
		"digest": "7c665f8594ffa53e72b01647e9d27360fb87d52d02fe9f20fc5fda08f9797dc3"
	},
	"dragon": {
		"category": "nature",
		"moji": "🐉",
		"unicodeVersion": "6.0",
		"digest": "2abcb3d945d848e34ffc76203b29ef26df7458856166fffd155611f7bbe72652"
	},
	"dragon_face": {
		"category": "nature",
		"moji": "🐲",
		"unicodeVersion": "6.0",
		"digest": "0030548931b931e3b51f26cf660394aee36499e688ba83ce9cfccb635dcd4d54"
	},
	"dress": {
		"category": "people",
		"moji": "👗",
		"unicodeVersion": "6.0",
		"digest": "96ceba928fb356f7c0ae99bf22552321f08a65d5f1c0340ab89641219ad366ad"
	},
	"dromedary_camel": {
		"category": "nature",
		"moji": "🐪",
		"unicodeVersion": "6.0",
		"digest": "e06ef69c29f0fb12481727c0b4124e700572d3d7955e173279320f43f286518d"
	},
	"drooling_face": {
		"category": "people",
		"moji": "🤤",
		"unicodeVersion": "9.0",
		"digest": "5203cb05cd266d7a7c929ab40364ad68571d380d9c7ff93a8d6d55261abaa1ba"
	},
	"droplet": {
		"category": "nature",
		"moji": "💧",
		"unicodeVersion": "6.0",
		"digest": "6475b4a4460a672c436a68f282ac97fb31e2934db4b80620063ee816159aa7c3"
	},
	"drum": {
		"category": "activity",
		"moji": "🥁",
		"unicodeVersion": "9.0",
		"digest": "0d0639980b1a5dcbf1c3e7ef47263fb6543b871242c58452a8c2f642525d9dd8"
	},
	"duck": {
		"category": "nature",
		"moji": "🦆",
		"unicodeVersion": "9.0",
		"digest": "8f8373798a7727368b32328e7a9a349727a949e7391ddd243b6456141a4f7e94"
	},
	"dvd": {
		"category": "objects",
		"moji": "📀",
		"unicodeVersion": "6.0",
		"digest": "3b7903285d91277181c26fdc9df857761bbac509d352e320c2519ea3b132704f"
	},
	"e-mail": {
		"category": "objects",
		"moji": "📧",
		"unicodeVersion": "6.0",
		"digest": "39b5a57a2376e4a1137e381be02a1775bd580e0371438f5297a401ea634f1830"
	},
	"eagle": {
		"category": "nature",
		"moji": "🦅",
		"unicodeVersion": "9.0",
		"digest": "b44fd4f61b83c5114358a272343ac9b0eabbc70847f739bbdbf8aae3ade5bc1d"
	},
	"ear": {
		"category": "people",
		"moji": "👂",
		"unicodeVersion": "6.0",
		"digest": "4fdeb5a46e69311ecfd09c5b45c9018c24b625e28475cca8fa516b086ef952f8"
	},
	"ear_of_rice": {
		"category": "nature",
		"moji": "🌾",
		"unicodeVersion": "6.0",
		"digest": "2997c340c2b333d6ba9b73f94ff1a1881735fe0cc4f0c72d7719b305499fc425"
	},
	"ear_tone1": {
		"category": "people",
		"moji": "👂🏻",
		"unicodeVersion": "8.0",
		"digest": "5ca759b8569a377a4e63e30d94b585b9f76d15348a8a0c1ba19fdc522790615e"
	},
	"ear_tone2": {
		"category": "people",
		"moji": "👂🏼",
		"unicodeVersion": "8.0",
		"digest": "12aafb3ef2cfcdc892b2877c2e24920620f0f77f850e12afbfe55eadce9e37df"
	},
	"ear_tone3": {
		"category": "people",
		"moji": "👂🏽",
		"unicodeVersion": "8.0",
		"digest": "f4d28d9f72cf116ac92d80061eb84c918d6523bf53b2ad526f5457aba487d527"
	},
	"ear_tone4": {
		"category": "people",
		"moji": "👂🏾",
		"unicodeVersion": "8.0",
		"digest": "eaa9453670f7e3adc6ec6934ee70efc9bf60fe6c99c5804b7ba9e3804aec65de"
	},
	"ear_tone5": {
		"category": "people",
		"moji": "👂🏿",
		"unicodeVersion": "8.0",
		"digest": "54bd0782419489556b80e9e0d15b05df74757aa4e04ba565f45c20d3dd60e3f1"
	},
	"earth_africa": {
		"category": "nature",
		"moji": "🌍",
		"unicodeVersion": "6.0",
		"digest": "c691a6f591f5a07b268fd64efe113e81cec8d5963ad83ced2537422343ff7ecf"
	},
	"earth_americas": {
		"category": "nature",
		"moji": "🌎",
		"unicodeVersion": "6.0",
		"digest": "a9c60cf8341ff59a9cc1a715b7144af734fcd28915a8e003a31ebf2abf9aedb1"
	},
	"earth_asia": {
		"category": "nature",
		"moji": "🌏",
		"unicodeVersion": "6.0",
		"digest": "ee2beb61fb8c87279161c5a8c4ad17bb71ce790123f8fa33522941d027e060a5"
	},
	"egg": {
		"category": "food",
		"moji": "🥚",
		"unicodeVersion": "9.0",
		"digest": "72b9c841af784e7cbccbbe48ba833df5cecdd284397c199cab079872e879d92f"
	},
	"eggplant": {
		"category": "food",
		"moji": "🍆",
		"unicodeVersion": "6.0",
		"digest": "ec0a460e0cf0e615f51279677594a899672e1b4ecd9396e17a8cfa2a3efe5238"
	},
	"eight": {
		"category": "symbols",
		"moji": "8️⃣",
		"unicodeVersion": "3.0",
		"digest": "57ff905033a32747690adba6486d12b09eb4d45de556f4e1ab6fb04e1fb861a8"
	},
	"eight_pointed_black_star": {
		"category": "symbols",
		"moji": "✴",
		"unicodeVersion": "1.1",
		"digest": "7bf11f6e28591e3d0625296aaabf4ecb75c982e425abf3049339e93494acc17e"
	},
	"eight_spoked_asterisk": {
		"category": "symbols",
		"moji": "✳",
		"unicodeVersion": "1.1",
		"digest": "bb0758e7cc0e357285937671a91489bd32ce9d248eecdcc9c275a53a66325b26"
	},
	"eject": {
		"category": "symbols",
		"moji": "⏏",
		"unicodeVersion": "4.0",
		"digest": "eeb0cd23ead0c965e307de517a6805265f0c780c3e454e64bc4c1425dfe7548e"
	},
	"electric_plug": {
		"category": "objects",
		"moji": "🔌",
		"unicodeVersion": "6.0",
		"digest": "b10ce87af86fa4f4022572ceb5ecd73bea867347a86832a7ea248364b0aad8d0"
	},
	"elephant": {
		"category": "nature",
		"moji": "🐘",
		"unicodeVersion": "6.0",
		"digest": "b7750f4b013fbd28ac5330e1694ef4d3b4a9c6fc7b807879db0c24b035a16c29"
	},
	"end": {
		"category": "symbols",
		"moji": "🔚",
		"unicodeVersion": "6.0",
		"digest": "dd93aee6986eb637a8b58f234da47568b88525599f73246e322af030351997a2"
	},
	"envelope": {
		"category": "objects",
		"moji": "✉",
		"unicodeVersion": "1.1",
		"digest": "f5a512022a2f5280f372ff39c22cbda815f698710ca66f8f8c4d08418f98ca78"
	},
	"envelope_with_arrow": {
		"category": "objects",
		"moji": "📩",
		"unicodeVersion": "6.0",
		"digest": "f8643212e6a94f58ccf2bcedc54c5fda8ebeab274f4a8803f253de5f50ddb1d6"
	},
	"euro": {
		"category": "objects",
		"moji": "💶",
		"unicodeVersion": "6.0",
		"digest": "3af3e223e8f26468a94f6f5c17198432656e8d20b3bab31566c2b5a86e717df4"
	},
	"european_castle": {
		"category": "travel",
		"moji": "🏰",
		"unicodeVersion": "6.0",
		"digest": "21082d0be7e3b2794e59ff0170da0cfe42a9b734cf02704603e3b52ff48202ba"
	},
	"european_post_office": {
		"category": "travel",
		"moji": "🏤",
		"unicodeVersion": "6.0",
		"digest": "02b4c7602939f0cb9cb2b4e05996bcdb6bd93cf8025c2ea02db8cbe13ca397d0"
	},
	"evergreen_tree": {
		"category": "nature",
		"moji": "🌲",
		"unicodeVersion": "6.0",
		"digest": "74b226098e66c0a94a92e0f22b9d631736e12dca72c34182c9d0ba56aa593172"
	},
	"exclamation": {
		"category": "symbols",
		"moji": "❗",
		"unicodeVersion": "5.2",
		"digest": "45b87ae4593656d7da49ff5645fb6a2a18d582553295358da9f09f1ae8272445"
	},
	"expressionless": {
		"category": "people",
		"moji": "😑",
		"unicodeVersion": "6.1",
		"digest": "34e2a1c8121f4f0bc4ce33d226d8cc1a4ebf5260746df2b23e29eef24ee9372e"
	},
	"eye": {
		"category": "people",
		"moji": "👁",
		"unicodeVersion": "7.0",
		"digest": "79ecff79c2edee630e72725b54e67ee2e96d24ca03fef2954a56a09c0a2227f8"
	},
	"eye_in_speech_bubble": {
		"category": "symbols",
		"moji": "👁‍🗨",
		"unicodeVersion": "7.0",
		"digest": "c0050c026c2a3060723cab2df2603c1c7da7ed81faedb9ebe16cd89721928a55"
	},
	"eyeglasses": {
		"category": "people",
		"moji": "👓",
		"unicodeVersion": "6.0",
		"digest": "d4a9585d6c43ef514a97c45c64607162e775a45544821f1470c6f8f25b93ab81"
	},
	"eyes": {
		"category": "people",
		"moji": "👀",
		"unicodeVersion": "6.0",
		"digest": "1d5cae0b9b2e51e1de54295685d7f0c72ee794e2e6335a95b1d056c7e77260e8"
	},
	"face_palm": {
		"category": "people",
		"moji": "🤦",
		"unicodeVersion": "9.0",
		"digest": "4ec873048b34b1bb34430724cf28e4bee6c0a9eee88ce39b9d1565047dc92420"
	},
	"face_palm_tone1": {
		"category": "people",
		"moji": "🤦🏻",
		"unicodeVersion": "9.0",
		"digest": "e93ef92b4c01dbea6c400e708e23dd36da92ccfbf5eb4f177b3b20c3a46bdc19"
	},
	"face_palm_tone2": {
		"category": "people",
		"moji": "🤦🏼",
		"unicodeVersion": "9.0",
		"digest": "22c8bf9fd9fa2ed9dca7a6397ed00ba6cfe9aeef2b0fb7b516ee4dda0df050ea"
	},
	"face_palm_tone3": {
		"category": "people",
		"moji": "🤦🏽",
		"unicodeVersion": "9.0",
		"digest": "c0b8bb9d2423e6787b6bdf1ca5a13f52853e4f48a9a1af0f2d4af1364fff022e"
	},
	"face_palm_tone4": {
		"category": "people",
		"moji": "🤦🏾",
		"unicodeVersion": "9.0",
		"digest": "f522ab186adcbb4549ea2c03500cdd7a86add548e43ebf7a54d58cc24deea072"
	},
	"face_palm_tone5": {
		"category": "people",
		"moji": "🤦🏿",
		"unicodeVersion": "9.0",
		"digest": "363507ae7178b5ec583635f47bcab10c897346f48b85d8759b1004c32cd8ad65"
	},
	"factory": {
		"category": "travel",
		"moji": "🏭",
		"unicodeVersion": "6.0",
		"digest": "c7aeb61ed8b0ac5c91d5197c73f1e2bb801921c22a76bb82c7659d990680dcb0"
	},
	"fallen_leaf": {
		"category": "nature",
		"moji": "🍂",
		"unicodeVersion": "6.0",
		"digest": "81fce04231d48db0e55f3697f930e9a7e3306bed5e35f1234e98c40a24ac5626"
	},
	"family": {
		"category": "people",
		"moji": "👪",
		"unicodeVersion": "6.0",
		"digest": "06f2ce63768ffe43b3d9b2a9660b34d043f37b3c91610dd62343ba21df8ecbe5"
	},
	"family_mmb": {
		"category": "people",
		"moji": "👨‍👨‍👦",
		"unicodeVersion": "6.0",
		"digest": "41a18405be796699a7eb7c36ab6f7d898e322749997f45387377acf5bb16a50f"
	},
	"family_mmbb": {
		"category": "people",
		"moji": "👨‍👨‍👦‍👦",
		"unicodeVersion": "6.0",
		"digest": "87255d1d18c6971c8c083c818e598424c1bd717eed892478b7e9516639dbfb45"
	},
	"family_mmg": {
		"category": "people",
		"moji": "👨‍👨‍👧",
		"unicodeVersion": "6.0",
		"digest": "a132b1b8f10b318d8e23aee15dab4caa14528aeb3c89966d4bcc25fb54af72ad"
	},
	"family_mmgb": {
		"category": "people",
		"moji": "👨‍👨‍👧‍👦",
		"unicodeVersion": "6.0",
		"digest": "eb2bc1966df406aaf38ce5a58db9324162799cdacf31f74f40e6384807a8efc2"
	},
	"family_mmgg": {
		"category": "people",
		"moji": "👨‍👨‍👧‍👧",
		"unicodeVersion": "6.0",
		"digest": "24f3d60f98fbd6b687f7cacfb629390b90509a754036e5439ae5294759c0606b"
	},
	"family_mwbb": {
		"category": "people",
		"moji": "👨‍👩‍👦‍👦",
		"unicodeVersion": "6.0",
		"digest": "2f77692bcb9275c4df501b64a18401dcaf8c68b21f26fbdad59b1feab0c98fd1"
	},
	"family_mwg": {
		"category": "people",
		"moji": "👨‍👩‍👧",
		"unicodeVersion": "6.0",
		"digest": "1a976d13127665d9386cebfdb24e5572dc499bda484c0ee05585886edc616130"
	},
	"family_mwgb": {
		"category": "people",
		"moji": "👨‍👩‍👧‍👦",
		"unicodeVersion": "6.0",
		"digest": "960ec2cbac13ef208e73644cd36711b83e6c070c36950f834f3669812839b7f8"
	},
	"family_mwgg": {
		"category": "people",
		"moji": "👨‍👩‍👧‍👧",
		"unicodeVersion": "6.0",
		"digest": "8353b03dfa5c24aba75a0abdfdac01603f593819d54b4c7f2f88aafb31da0c6a"
	},
	"family_wwb": {
		"category": "people",
		"moji": "👩‍👩‍👦",
		"unicodeVersion": "6.0",
		"digest": "07a5dd397718c553573689f6512f386729c13a12d5dc78be47c06405769cd98a"
	},
	"family_wwbb": {
		"category": "people",
		"moji": "👩‍👩‍👦‍👦",
		"unicodeVersion": "6.0",
		"digest": "b627f460f1da0d47b0b662402940b2b77c9538d380d05436dfca4b456c50c939"
	},
	"family_wwg": {
		"category": "people",
		"moji": "👩‍👩‍👧",
		"unicodeVersion": "6.0",
		"digest": "2d6f373bed53f1028f0fbe9caf036465a351f37b9e00fca7d722cc5a1984f251"
	},
	"family_wwgb": {
		"category": "people",
		"moji": "👩‍👩‍👧‍👦",
		"unicodeVersion": "6.0",
		"digest": "72be5c85e1621f73d6794edd6e428febdb366b9e4c816f7829897fd1ab34642b"
	},
	"family_wwgg": {
		"category": "people",
		"moji": "👩‍👩‍👧‍👧",
		"unicodeVersion": "6.0",
		"digest": "c39e0916069460d2d9741bddf58e76f5d6a09254cba0eeb262345adf8630bc32"
	},
	"fast_forward": {
		"category": "symbols",
		"moji": "⏩",
		"unicodeVersion": "6.0",
		"digest": "e7d2d8085cfd406c2b096e8dd147dd3722290a5727b1f7df185989526a2335ec"
	},
	"fax": {
		"category": "objects",
		"moji": "📠",
		"unicodeVersion": "6.0",
		"digest": "ff85ffa440c5379c9b138ebe2d7912d6098da3b37a051b80442d5557b7f993b0"
	},
	"fearful": {
		"category": "people",
		"moji": "😨",
		"unicodeVersion": "6.0",
		"digest": "b72bdf7d075d5c4e38bbd8512fb45fda2e85c9c8732a47e67575ae9f2ed4c5df"
	},
	"feet": {
		"category": "nature",
		"moji": "🐾",
		"unicodeVersion": "6.0",
		"digest": "45aca538d3a9831a0c7de491e5656c17705c07b8f4ac8e85254656b608976016"
	},
	"fencer": {
		"category": "activity",
		"moji": "🤺",
		"unicodeVersion": "9.0",
		"digest": "5db00fa456af9f6c7cb88d300579dd63e426bcb97ad25486b664aff25c688e21"
	},
	"ferris_wheel": {
		"category": "travel",
		"moji": "🎡",
		"unicodeVersion": "6.0",
		"digest": "24b4551b7b79a2a5fd73de61542f2b444f896a52030c5f29791c8fcfcc28b95c"
	},
	"ferry": {
		"category": "travel",
		"moji": "⛴",
		"unicodeVersion": "5.2",
		"digest": "5002a72af2e3c4cef9a36ad5987aeed7d99f96bfd13e56f78957315ec7e749a3"
	},
	"field_hockey": {
		"category": "activity",
		"moji": "🏑",
		"unicodeVersion": "8.0",
		"digest": "4ee091d96161ba719ab8fd6f2b03f96d902a6f22cffe0563b930618bb8ac2b67"
	},
	"file_cabinet": {
		"category": "objects",
		"moji": "🗄",
		"unicodeVersion": "7.0",
		"digest": "92914147bf93e6d64271ff99d217a18a9850a367d08a5f9f458ecf9311a5bbe9"
	},
	"file_folder": {
		"category": "objects",
		"moji": "📁",
		"unicodeVersion": "6.0",
		"digest": "62a42a929267cfbfdb795ead381c9657c343458bc5fca95ea8a0ab892c61d4f6"
	},
	"film_frames": {
		"category": "objects",
		"moji": "🎞",
		"unicodeVersion": "7.0",
		"digest": "4da212148cadb9c4ea91e60d2d8316e38cea99ef4f14afc023711dd7c54ade5a"
	},
	"fingers_crossed": {
		"category": "people",
		"moji": "🤞",
		"unicodeVersion": "9.0",
		"digest": "a5c797ead191b9712e185083266b455cdf09f6a34c10f8c51aa145e6073427e1"
	},
	"fingers_crossed_tone1": {
		"category": "people",
		"moji": "🤞🏻",
		"unicodeVersion": "9.0",
		"digest": "db56d47bf887f2d8459a3aaba23f15c0087234ae5a54125052e7046e034a4988"
	},
	"fingers_crossed_tone2": {
		"category": "people",
		"moji": "🤞🏼",
		"unicodeVersion": "9.0",
		"digest": "19f1bcca3991db7ed2037278c0baab6cd7f12aeaf2e0074de402c4d9e45c1899"
	},
	"fingers_crossed_tone3": {
		"category": "people",
		"moji": "🤞🏽",
		"unicodeVersion": "9.0",
		"digest": "895a3314f6a310f31f7e728bcca20ff834fbfac62ce00e27e3ea5ad0dfc1ba35"
	},
	"fingers_crossed_tone4": {
		"category": "people",
		"moji": "🤞🏾",
		"unicodeVersion": "9.0",
		"digest": "fcb5c4de2001d23a5df1b8702624d134b7f94e93e2dcc8adf6c1033c77722b0e"
	},
	"fingers_crossed_tone5": {
		"category": "people",
		"moji": "🤞🏿",
		"unicodeVersion": "9.0",
		"digest": "50132c78d530b048c21be4e788b446872a79b3b3a91009db12f4021c44c8469d"
	},
	"fire": {
		"category": "nature",
		"moji": "🔥",
		"unicodeVersion": "6.0",
		"digest": "b3e67c913903d900f5e50e7e7e4d7e9370bb6ceedfbee548be39e4c9e4b69416"
	},
	"fire_engine": {
		"category": "travel",
		"moji": "🚒",
		"unicodeVersion": "6.0",
		"digest": "c3a518f27d625e3b62dffa227eb82764bf0a147f10ec0e7f4f43f3f96751af20"
	},
	"fireworks": {
		"category": "travel",
		"moji": "🎆",
		"unicodeVersion": "6.0",
		"digest": "b62ae08a00c0cc6eba8f9666c8fd9946ce57c3cfc01fe99542a8690a4a566a65"
	},
	"first_place": {
		"category": "activity",
		"moji": "🥇",
		"unicodeVersion": "9.0",
		"digest": "e3de5d9f14f05544dbee5965cc2baa20e7b417a488c8a18598979038860fd901"
	},
	"first_quarter_moon": {
		"category": "nature",
		"moji": "🌓",
		"unicodeVersion": "6.0",
		"digest": "a207ce93084448622a4a5c49c85c566a9fda6be7337c86a013eeb713fe47fd29"
	},
	"first_quarter_moon_with_face": {
		"category": "nature",
		"moji": "🌛",
		"unicodeVersion": "6.0",
		"digest": "1d1f54a5075f2311bcc017c44898b9d8c58edc13b298d58c238fff9ab8ee2ef3"
	},
	"fish": {
		"category": "nature",
		"moji": "🐟",
		"unicodeVersion": "6.0",
		"digest": "8f62f08fbeaf39694c19816b5c7d4f292017fe5bf9f8dd7e40f1630f5f83b28b"
	},
	"fish_cake": {
		"category": "food",
		"moji": "🍥",
		"unicodeVersion": "6.0",
		"digest": "5a6ca2100c8830927b22afa6f1d2fc821f5692cd23507fe5a776f6e085cbbfb2"
	},
	"fishing_pole_and_fish": {
		"category": "activity",
		"moji": "🎣",
		"unicodeVersion": "6.0",
		"digest": "f8fb84eccceec88321b0a2a46f732ecfc378f787c19c27ac1327735f1ca9a48b"
	},
	"fist": {
		"category": "people",
		"moji": "✊",
		"unicodeVersion": "6.0",
		"digest": "557f96d85615b8d78436bc67266115bfc8556c97c14f7909dfda1cf134e8344f"
	},
	"fist_tone1": {
		"category": "people",
		"moji": "✊🏻",
		"unicodeVersion": "8.0",
		"digest": "6c1b946f9e01abc39b5085e24e8b6077fc0e34188e8daa30c6a3adddd387413e"
	},
	"fist_tone2": {
		"category": "people",
		"moji": "✊🏼",
		"unicodeVersion": "8.0",
		"digest": "e9b9e1ec638dca4d5e1519bca7338f58cce2f2a282ee4c3581e8643166fc415f"
	},
	"fist_tone3": {
		"category": "people",
		"moji": "✊🏽",
		"unicodeVersion": "8.0",
		"digest": "8c14d24055c143960b3d2a27fe23c55d2d3ac5f84f87e4e876616235e8698c7f"
	},
	"fist_tone4": {
		"category": "people",
		"moji": "✊🏾",
		"unicodeVersion": "8.0",
		"digest": "923f034f481e952e6e5d1664588f99f79bd5416d4197b0ade6621f2669ce5765"
	},
	"fist_tone5": {
		"category": "people",
		"moji": "✊🏿",
		"unicodeVersion": "8.0",
		"digest": "d691d2902216080916a29047e07d7a5bf2aed07e062067ca9d01cbf6fdf48c8d"
	},
	"five": {
		"category": "symbols",
		"moji": "5️⃣",
		"unicodeVersion": "3.0",
		"digest": "8f03f62fdbf744ae49c8a60fbf715ebfccbd6b62d91148e0923907006f3c2726"
	},
	"flag_ac": {
		"category": "flags",
		"moji": "🇦🇨",
		"unicodeVersion": "6.0",
		"digest": "2e5c08535dc8ea96422d56a36b4fffc0b3bd2a13f2ab0d8dbd0e3a29bf3fc40c"
	},
	"flag_ad": {
		"category": "flags",
		"moji": "🇦🇩",
		"unicodeVersion": "6.0",
		"digest": "184fdcf790b8e2fd851b2b2b32f8636c595dd289734d12dc01ae4aa177e2043a"
	},
	"flag_ae": {
		"category": "flags",
		"moji": "🇦🇪",
		"unicodeVersion": "6.0",
		"digest": "4a3257a9ce118e97567e76280f24d60fb555f1bada2eb26a2442a47f9398d21e"
	},
	"flag_af": {
		"category": "flags",
		"moji": "🇦🇫",
		"unicodeVersion": "6.0",
		"digest": "0f6c719cac7ab3140694f6b580787ecdbf503e38f16de7ec5803f7d06a088ec3"
	},
	"flag_ag": {
		"category": "flags",
		"moji": "🇦🇬",
		"unicodeVersion": "6.0",
		"digest": "92bf5a0e74564739862e9ba79331ffa656b7bae2ace0fc8dfd288984e4d510d4"
	},
	"flag_ai": {
		"category": "flags",
		"moji": "🇦🇮",
		"unicodeVersion": "6.0",
		"digest": "aeaadc7ffafd8a1e01fdabc69d35f725d5f737b4c284a36191d96729f4e66e8f"
	},
	"flag_al": {
		"category": "flags",
		"moji": "🇦🇱",
		"unicodeVersion": "6.0",
		"digest": "5ce7866d214d18c5f3438d480d14e77d104c4de679f0fdfca8cf0a44ce48eeea"
	},
	"flag_am": {
		"category": "flags",
		"moji": "🇦🇲",
		"unicodeVersion": "6.0",
		"digest": "b40f5705f0cf9ef0fa7ffff0b371c4099319001ce79f894c317912f4dc5de4c8"
	},
	"flag_ao": {
		"category": "flags",
		"moji": "🇦🇴",
		"unicodeVersion": "6.0",
		"digest": "eab6fbc1824d6e3cd152e8ec1d82e1beaebe02b53b35c6f7a883b8548af02f3a"
	},
	"flag_aq": {
		"category": "flags",
		"moji": "🇦🇶",
		"unicodeVersion": "6.0",
		"digest": "367f6677a683a5f0e7248ab3a8f46d06ba146a0fd75004c70bac0e913147cdaa"
	},
	"flag_ar": {
		"category": "flags",
		"moji": "🇦🇷",
		"unicodeVersion": "6.0",
		"digest": "f0dc466b3216957f2679d7208c2d7cf288448b0739b9270a7c5fa717577bdf25"
	},
	"flag_as": {
		"category": "flags",
		"moji": "🇦🇸",
		"unicodeVersion": "6.0",
		"digest": "fcb7a865c7763c63b23485cc27207b99a3a8492e83d5b5ee2df259a9f68f77d6"
	},
	"flag_at": {
		"category": "flags",
		"moji": "🇦🇹",
		"unicodeVersion": "6.0",
		"digest": "1d3d58e9abc034f9a093a94716eddf9811d54dfaf27969fd322b3809fac70217"
	},
	"flag_au": {
		"category": "flags",
		"moji": "🇦🇺",
		"unicodeVersion": "6.0",
		"digest": "789563b64c71a5ad49078d335dc166ef614edb56d1e401885d32fb191c198fbd"
	},
	"flag_aw": {
		"category": "flags",
		"moji": "🇦🇼",
		"unicodeVersion": "6.0",
		"digest": "1504dc3fd8457b44fdf75c15e136dc46a13e8342d1f98949728cdc1238843e0c"
	},
	"flag_ax": {
		"category": "flags",
		"moji": "🇦🇽",
		"unicodeVersion": "6.0",
		"digest": "e96fa3525f3be25016a4cf8428261735f3ed5fc9fe5b827b461746a3f08877bf"
	},
	"flag_az": {
		"category": "flags",
		"moji": "🇦🇿",
		"unicodeVersion": "6.0",
		"digest": "12c366ac2c38b91314fb29056e09fa6e7417766cebde3045859cdb127549f4a2"
	},
	"flag_ba": {
		"category": "flags",
		"moji": "🇧🇦",
		"unicodeVersion": "6.0",
		"digest": "0819ea3901510ac20c7f10e67e5f6c818210f17a362c1d12e299c41feb07f828"
	},
	"flag_bb": {
		"category": "flags",
		"moji": "🇧🇧",
		"unicodeVersion": "6.0",
		"digest": "cf32778a272ed6cbc8e783b59befd9b204009c69c61a425e148d867808b7fab9"
	},
	"flag_bd": {
		"category": "flags",
		"moji": "🇧🇩",
		"unicodeVersion": "6.0",
		"digest": "e6ed186644a874588e879513aec92f8107220dcdd14c766dee61f266ce045665"
	},
	"flag_be": {
		"category": "flags",
		"moji": "🇧🇪",
		"unicodeVersion": "6.0",
		"digest": "4d941011d15d9f6e755d6f7694884758baf17ac0691bf5d63700f8d6dbcdb948"
	},
	"flag_bf": {
		"category": "flags",
		"moji": "🇧🇫",
		"unicodeVersion": "6.0",
		"digest": "fcc57dbda9a86f725f558b6c6309484c97e65f1644aae4f9fb5e642681f6c2e0"
	},
	"flag_bg": {
		"category": "flags",
		"moji": "🇧🇬",
		"unicodeVersion": "6.0",
		"digest": "816c47ed96c36c90723da150645902ea8ba18b44757fdd776c7b3542cfecfb18"
	},
	"flag_bh": {
		"category": "flags",
		"moji": "🇧🇭",
		"unicodeVersion": "6.0",
		"digest": "2cd5c21775a6e73f59d08c9ee0cedf4e8241e562eab939573501d47681987737"
	},
	"flag_bi": {
		"category": "flags",
		"moji": "🇧🇮",
		"unicodeVersion": "6.0",
		"digest": "2da82acbec5518360633c1b0b56d55a79b67237f67d92af5e5cd75a2f3bd550e"
	},
	"flag_bj": {
		"category": "flags",
		"moji": "🇧🇯",
		"unicodeVersion": "6.0",
		"digest": "8fe8c34651eb4e28ab395261a5b72b6f37579535ed676d15de131914e19c0436"
	},
	"flag_bl": {
		"category": "flags",
		"moji": "🇧🇱",
		"unicodeVersion": "6.0",
		"digest": "d37f2a215ee7ef5b5ab62d2a0c87e90553b17c6ee310f803a71e9fd72db880e7"
	},
	"flag_black": {
		"category": "objects",
		"moji": "🏴",
		"unicodeVersion": "6.0",
		"digest": "3740bfc9bcb3b46b697b8b7c47ab2c3e95eca9dbcba12f2bf98a01302704f203"
	},
	"flag_bm": {
		"category": "flags",
		"moji": "🇧🇲",
		"unicodeVersion": "6.0",
		"digest": "ccd21655573f3c955d616c5c7b1eac2be1d4772ff611648d6713ba55d9e4aa9b"
	},
	"flag_bn": {
		"category": "flags",
		"moji": "🇧🇳",
		"unicodeVersion": "6.0",
		"digest": "54330c3d7a37392e69098c213fd8c78f3faab4e7e5909c039188110422514228"
	},
	"flag_bo": {
		"category": "flags",
		"moji": "🇧🇴",
		"unicodeVersion": "6.0",
		"digest": "32aff973b26f4f91ca19dddd7861b564da43cfbee87603d8c004f1111342366c"
	},
	"flag_bq": {
		"category": "flags",
		"moji": "🇧🇶",
		"unicodeVersion": "6.0",
		"digest": "b1ebc959c43f706ca430d8633d9efaa9c60133871506b5f030b730cfb4c19e6f"
	},
	"flag_br": {
		"category": "flags",
		"moji": "🇧🇷",
		"unicodeVersion": "6.0",
		"digest": "64fb154d71fa34ff4838bc405f3e58a4102cf0cb49ca4b06fc3c7a6bf39671f0"
	},
	"flag_bs": {
		"category": "flags",
		"moji": "🇧🇸",
		"unicodeVersion": "6.0",
		"digest": "c4b07e5f652ab06ece95d3774ce8b1399a935f8a28d440cb13cc8bd0b9728ed5"
	},
	"flag_bt": {
		"category": "flags",
		"moji": "🇧🇹",
		"unicodeVersion": "6.0",
		"digest": "901ddbd999dd89a87c1e1208b1470cb4e604a9bc023d0cbcdee64e1bc54079ba"
	},
	"flag_bv": {
		"category": "flags",
		"moji": "🇧🇻",
		"unicodeVersion": "6.0",
		"digest": "bbf6daa6174c6fbbbf541c8274f31b6757c3a16007c2687015ea041fd1e2c6b6"
	},
	"flag_bw": {
		"category": "flags",
		"moji": "🇧🇼",
		"unicodeVersion": "6.0",
		"digest": "05aa351bc04dc0fe2669441ab500e000d48b1f0d7ad9e885c7abfb898aa0eb3f"
	},
	"flag_by": {
		"category": "flags",
		"moji": "🇧🇾",
		"unicodeVersion": "6.0",
		"digest": "6eda3b87336ecf0aae4963986d86b916a055d8268c70520303288f235a93b0d9"
	},
	"flag_bz": {
		"category": "flags",
		"moji": "🇧🇿",
		"unicodeVersion": "6.0",
		"digest": "d76ed945b1408558a30a99b8eed6712de968fc49fba1721b5660b8f48087e45a"
	},
	"flag_ca": {
		"category": "flags",
		"moji": "🇨🇦",
		"unicodeVersion": "6.0",
		"digest": "2fd036047d89751c05de5577909b58347883bc89c3b7d90bec28ad4770a98ecd"
	},
	"flag_cc": {
		"category": "flags",
		"moji": "🇨🇨",
		"unicodeVersion": "6.0",
		"digest": "837ba181a01c71f05d438d205efaaee99f93b2370c97b13e6132f99860323e36"
	},
	"flag_cd": {
		"category": "flags",
		"moji": "🇨🇩",
		"unicodeVersion": "6.0",
		"digest": "318689274b4b3b58aed7fc1654127499a9da69bff1b83e592e86e69d167ce16f"
	},
	"flag_cf": {
		"category": "flags",
		"moji": "🇨🇫",
		"unicodeVersion": "6.0",
		"digest": "06d6042849d3b7b217c2b18ba787aae449e8c7d2537e2e5974744ec196062228"
	},
	"flag_cg": {
		"category": "flags",
		"moji": "🇨🇬",
		"unicodeVersion": "6.0",
		"digest": "09f45d2dcb5a24d8349ef86e7405cc29ef3d65a908c0bff3221c3b4546547813"
	},
	"flag_ch": {
		"category": "flags",
		"moji": "🇨🇭",
		"unicodeVersion": "6.0",
		"digest": "53d6d35aeeebb0b4b1ad858dc3691e649ac73d30b3be76f96d5fe9605fa99386"
	},
	"flag_ci": {
		"category": "flags",
		"moji": "🇨🇮",
		"unicodeVersion": "6.0",
		"digest": "7d85a0c314b7397c9397a54ce2f3a4dc5f40d0234e586dbd8a541a8666f0f51e"
	},
	"flag_ck": {
		"category": "flags",
		"moji": "🇨🇰",
		"unicodeVersion": "6.0",
		"digest": "c1aa105fe106ed09ed59a596859a0ce4e65a415c59f63df51961491cb947b136"
	},
	"flag_cl": {
		"category": "flags",
		"moji": "🇨🇱",
		"unicodeVersion": "6.0",
		"digest": "0fffdad0d892f5c08aaa332af1ed2c228583d89a43190e979a3c3cb020d5a723"
	},
	"flag_cm": {
		"category": "flags",
		"moji": "🇨🇲",
		"unicodeVersion": "6.0",
		"digest": "e9f55e41a1fd2735a82ad7a7ac39326a944cb20423ffba3608ac53a46036caad"
	},
	"flag_cn": {
		"category": "flags",
		"moji": "🇨🇳",
		"unicodeVersion": "6.0",
		"digest": "e2c8fee7e3bd51b13d6083d5bf344abe6b9b642e3cbb099d38b4ce341c99d890"
	},
	"flag_co": {
		"category": "flags",
		"moji": "🇨🇴",
		"unicodeVersion": "6.0",
		"digest": "51c60d0979bf8342eaff7cda9faf4b0dfab38efaf5ddf3717eb8f0e2a595b15f"
	},
	"flag_cp": {
		"category": "flags",
		"moji": "🇨🇵",
		"unicodeVersion": "6.0",
		"digest": "a0124683aa88cd7da886da70c65796c5ad84eb3751e356e9b2aa8ac249cf0bf9"
	},
	"flag_cr": {
		"category": "flags",
		"moji": "🇨🇷",
		"unicodeVersion": "6.0",
		"digest": "907905971b219e617a34eef4839b0bd08d98f3480e2631bce523120dcef95196"
	},
	"flag_cu": {
		"category": "flags",
		"moji": "🇨🇺",
		"unicodeVersion": "6.0",
		"digest": "d88cea729dc9dbbbcadac0409ec561995f061b2280577c01c6c6b37de347f150"
	},
	"flag_cv": {
		"category": "flags",
		"moji": "🇨🇻",
		"unicodeVersion": "6.0",
		"digest": "5ce97944adfce09e96387e6f872256482ac99ccbc60017c4d58ddd15b6fb67a7"
	},
	"flag_cw": {
		"category": "flags",
		"moji": "🇨🇼",
		"unicodeVersion": "6.0",
		"digest": "a6fc31bd66ddc2ee8e7bde3aeabfe1c4ad00c9688abae234a541cc1236d68c1b"
	},
	"flag_cx": {
		"category": "flags",
		"moji": "🇨🇽",
		"unicodeVersion": "6.0",
		"digest": "1261b32bfa22fa1441f5390ff499ac6b921d7ac59cc8acda3deb3a2beb4fb345"
	},
	"flag_cy": {
		"category": "flags",
		"moji": "🇨🇾",
		"unicodeVersion": "6.0",
		"digest": "82b1baa05ecffa0ea1f9a83b518163cbd7910985a21955740520bb16b7bb624f"
	},
	"flag_cz": {
		"category": "flags",
		"moji": "🇨🇿",
		"unicodeVersion": "6.0",
		"digest": "a169b18968992a52299b67c24fba495e84de28dec2ebb947a08e0d615ac54a5a"
	},
	"flag_de": {
		"category": "flags",
		"moji": "🇩🇪",
		"unicodeVersion": "6.0",
		"digest": "99d1906944966a188c72ae592362ed907e2a0bfe95263955c34a0941507b30c1"
	},
	"flag_dg": {
		"category": "flags",
		"moji": "🇩🇬",
		"unicodeVersion": "6.0",
		"digest": "dd45e1afe792fca57d4161434bf611bcb7170072d63e4a27fb9dcd6e8912621e"
	},
	"flag_dj": {
		"category": "flags",
		"moji": "🇩🇯",
		"unicodeVersion": "6.0",
		"digest": "e90ba4e98fca71ff0ca5e65c28b911cc52f043428f375d8f954ecbd3b0c8f4dd"
	},
	"flag_dk": {
		"category": "flags",
		"moji": "🇩🇰",
		"unicodeVersion": "6.0",
		"digest": "65b3b5f31935a4969d81fedbb8279c7ad32da454d15c5eafcceba5d140927c77"
	},
	"flag_dm": {
		"category": "flags",
		"moji": "🇩🇲",
		"unicodeVersion": "6.0",
		"digest": "f6225ded6d2cfd6c182ab1a53b8c49dc9df195df11eb7ff27b15f5d3721ba0eb"
	},
	"flag_do": {
		"category": "flags",
		"moji": "🇩🇴",
		"unicodeVersion": "6.0",
		"digest": "dc2ad6856cebbe47c5bd7f5dcf087e4f680d396b2d49440a9b71f0ad49fb8102"
	},
	"flag_dz": {
		"category": "flags",
		"moji": "🇩🇿",
		"unicodeVersion": "6.0",
		"digest": "ea69fffc4d545f9c0fcef6768257501952955ba4d274c9b81843229a1265c5ed"
	},
	"flag_ea": {
		"category": "flags",
		"moji": "🇪🇦",
		"unicodeVersion": "6.0",
		"digest": "e63bfe15428c481dd23b569e7aaf0a76106e58a946995b4415a81097ecd53b7d"
	},
	"flag_ec": {
		"category": "flags",
		"moji": "🇪🇨",
		"unicodeVersion": "6.0",
		"digest": "0cdabf85cd567047fda1d9a4508220cab829943a7c542c315078db0aac33edac"
	},
	"flag_ee": {
		"category": "flags",
		"moji": "🇪🇪",
		"unicodeVersion": "6.0",
		"digest": "6dc4e3377e8e2af3ff40cf940a914bc7840980b4a14e7da86954343f2b1025fe"
	},
	"flag_eg": {
		"category": "flags",
		"moji": "🇪🇬",
		"unicodeVersion": "6.0",
		"digest": "2ed6bc056015694d75993eb5ee3c1850921d5630681207b04dfbdb982ab346a2"
	},
	"flag_eh": {
		"category": "flags",
		"moji": "🇪🇭",
		"unicodeVersion": "6.0",
		"digest": "72adb55943e4df99c00843c65463718609d937480f73dcf4a4451d46b9967a5e"
	},
	"flag_er": {
		"category": "flags",
		"moji": "🇪🇷",
		"unicodeVersion": "6.0",
		"digest": "3fa59331eb5300c8c1f7b1f1bc15cfcfe688da6fa4a79341854598086a44eebc"
	},
	"flag_es": {
		"category": "flags",
		"moji": "🇪🇸",
		"unicodeVersion": "6.0",
		"digest": "1fa1d5cb0a7e8b14aaec758b2e7bf49cdf8f3d09bbcc7dfd589053a432eeae25"
	},
	"flag_et": {
		"category": "flags",
		"moji": "🇪🇹",
		"unicodeVersion": "6.0",
		"digest": "72771decfb214394e4beb594e848ea590c3615800adbba24b5df4c5db6ee9617"
	},
	"flag_eu": {
		"category": "flags",
		"moji": "🇪🇺",
		"unicodeVersion": "6.0",
		"digest": "4bfa1b2ef23764ead5ef7899806f93e13fd29a09c75e61431579a4116c836aa4"
	},
	"flag_fi": {
		"category": "flags",
		"moji": "🇫🇮",
		"unicodeVersion": "6.0",
		"digest": "d0208cdd5b153a2865f9f674179c62871d4675abb0fb639fba88fcd62553f54e"
	},
	"flag_fj": {
		"category": "flags",
		"moji": "🇫🇯",
		"unicodeVersion": "6.0",
		"digest": "6c5ec41114af3846b093a418f6e2b5ff7a83cb72cecde75a7dc62e8cb6dcfe45"
	},
	"flag_fk": {
		"category": "flags",
		"moji": "🇫🇰",
		"unicodeVersion": "6.0",
		"digest": "c69ad641d53785deff5c3934b7dcfcd3dc32ffc31b6d3e799d0555b03c23fc15"
	},
	"flag_fm": {
		"category": "flags",
		"moji": "🇫🇲",
		"unicodeVersion": "6.0",
		"digest": "1e29fb06b273f253c23a9e4aa8ff84bfe22cffb5fa158a0c6f4cdeabe0216990"
	},
	"flag_fo": {
		"category": "flags",
		"moji": "🇫🇴",
		"unicodeVersion": "6.0",
		"digest": "f4907d2f606f4f9d3bef06c6d38e8e88f2a148197b1573668866431a007afc2e"
	},
	"flag_fr": {
		"category": "flags",
		"moji": "🇫🇷",
		"unicodeVersion": "6.0",
		"digest": "5a1308ab3cbf6bffcab12588cf3325151a6c72990db7408c2b8605d89f94ed6e"
	},
	"flag_ga": {
		"category": "flags",
		"moji": "🇬🇦",
		"unicodeVersion": "6.0",
		"digest": "ddc32dee2976507be878ec3d3d2408632ca21bc434cd9f58db4f6ac9774a2db5"
	},
	"flag_gb": {
		"category": "flags",
		"moji": "🇬🇧",
		"unicodeVersion": "6.0",
		"digest": "6b3bb254d134870b02cb066b06e206f652638a915c84b8649ceb30ec67fbebde"
	},
	"flag_gd": {
		"category": "flags",
		"moji": "🇬🇩",
		"unicodeVersion": "6.0",
		"digest": "b6a210541ca22d816405f2a7d0d5241dc4d5488c8a36e15bd1e3063f9c41327f"
	},
	"flag_ge": {
		"category": "flags",
		"moji": "🇬🇪",
		"unicodeVersion": "6.0",
		"digest": "e9a5035b7a46b925737e7f7b0ae2419cc4af0e980fbee5bd916edeef13823367"
	},
	"flag_gf": {
		"category": "flags",
		"moji": "🇬🇫",
		"unicodeVersion": "6.0",
		"digest": "ce1bcd8c303897c1c22c5994182f21240b4aa635f0d7ce9944f76cbdbf0e4956"
	},
	"flag_gg": {
		"category": "flags",
		"moji": "🇬🇬",
		"unicodeVersion": "6.0",
		"digest": "a435aab3609533ab2d68acd97deba844bfb0fc27b2adac68668223011f23ae5d"
	},
	"flag_gh": {
		"category": "flags",
		"moji": "🇬🇭",
		"unicodeVersion": "6.0",
		"digest": "7cad43b40f69b9b00cc1b38036789ce774fd3d597c89f0bf38433847ea69be26"
	},
	"flag_gi": {
		"category": "flags",
		"moji": "🇬🇮",
		"unicodeVersion": "6.0",
		"digest": "70e9b17d18bf3e0e4d03f4f824323a57909416e4082ca9d8a0796a6959de4f07"
	},
	"flag_gl": {
		"category": "flags",
		"moji": "🇬🇱",
		"unicodeVersion": "6.0",
		"digest": "1963d8cca1c1f06b7536b7fb8f5a4782ac0bb05afdf6e481101bce45c58cdd4b"
	},
	"flag_gm": {
		"category": "flags",
		"moji": "🇬🇲",
		"unicodeVersion": "6.0",
		"digest": "6c776a8daa3f4daa2597b0025aec06fc0a53aed262e845d4da3897cd7a89c6a1"
	},
	"flag_gn": {
		"category": "flags",
		"moji": "🇬🇳",
		"unicodeVersion": "6.0",
		"digest": "134cf7c839370d171ae80a72e5d18d32ea1967df19c191d1a4ea446d649e9558"
	},
	"flag_gp": {
		"category": "flags",
		"moji": "🇬🇵",
		"unicodeVersion": "6.0",
		"digest": "be3e906b039ba4884053c78f4f14de9aa87c5573860ccb69ec766068ae3887c2"
	},
	"flag_gq": {
		"category": "flags",
		"moji": "🇬🇶",
		"unicodeVersion": "6.0",
		"digest": "d476059c4ab41f5a1ef88583087362a5bc57cede930126f37041d1546564ab70"
	},
	"flag_gr": {
		"category": "flags",
		"moji": "🇬🇷",
		"unicodeVersion": "6.0",
		"digest": "b9fa9304647aaa08167a07858bb18d778dcc399375f86f580b8d4244794678bc"
	},
	"flag_gs": {
		"category": "flags",
		"moji": "🇬🇸",
		"unicodeVersion": "6.0",
		"digest": "de33fbef6e294eb7af36e5b94d8ff573b354a4ff1ebdccf50ca528b86ed601d9"
	},
	"flag_gt": {
		"category": "flags",
		"moji": "🇬🇹",
		"unicodeVersion": "6.0",
		"digest": "4160843e5d642df597c8423eb8e3b74deafe304f3d141c8a4d2fc07509e44832"
	},
	"flag_gu": {
		"category": "flags",
		"moji": "🇬🇺",
		"unicodeVersion": "6.0",
		"digest": "3b0cb257ba5b1c3e15d9102410c5f7418da03372e91ce90513de25b9f45283e3"
	},
	"flag_gw": {
		"category": "flags",
		"moji": "🇬🇼",
		"unicodeVersion": "6.0",
		"digest": "bdf07a8f93c0f0a573af5f5361be404a3ba65b729c1a4c05b7632c03d85efc72"
	},
	"flag_gy": {
		"category": "flags",
		"moji": "🇬🇾",
		"unicodeVersion": "6.0",
		"digest": "b47d8c98b747556f827ad0d1169264eb68ecaf9d2fb76595e8c31866361cbfc6"
	},
	"flag_hk": {
		"category": "flags",
		"moji": "🇭🇰",
		"unicodeVersion": "6.0",
		"digest": "8e5a54b2e4bd4f5182085299b9648062463da05d535cf0e46a7d9c58eaeb171f"
	},
	"flag_hm": {
		"category": "flags",
		"moji": "🇭🇲",
		"unicodeVersion": "6.0",
		"digest": "63c3e080c5e82a72c6d4cf5997ac823dc02184719ec59aadea6dd41b127abf22"
	},
	"flag_hn": {
		"category": "flags",
		"moji": "🇭🇳",
		"unicodeVersion": "6.0",
		"digest": "87c1d160db810b5ed208fb33add54f96c17b0f08d87b81f6f09429abf6ec93ac"
	},
	"flag_hr": {
		"category": "flags",
		"moji": "🇭🇷",
		"unicodeVersion": "6.0",
		"digest": "8b68112f79baea38565673acf4f1cb90675a5829ff17e4cf9415c928b62aed88"
	},
	"flag_ht": {
		"category": "flags",
		"moji": "🇭🇹",
		"unicodeVersion": "6.0",
		"digest": "05dbd548c310ef1ebd1724aa85d821f8320106b16ddbf1f6442ea37e4407d5e1"
	},
	"flag_hu": {
		"category": "flags",
		"moji": "🇭🇺",
		"unicodeVersion": "6.0",
		"digest": "5079f3d6f1459e6df8dda5c19d2367ead8f5a755b8874ac999bae58e3c9f47a7"
	},
	"flag_ic": {
		"category": "flags",
		"moji": "🇮🇨",
		"unicodeVersion": "6.0",
		"digest": "8dcb18c4b75a60867a68d2f6edbf81e782aafb4b9a0404c8081f872dfe71e432"
	},
	"flag_id": {
		"category": "flags",
		"moji": "🇮🇩",
		"unicodeVersion": "6.0",
		"digest": "1b0eb69a158ed3afe24be448d44751f95dcc5cbc7d1393a5753293f16ef0a66c"
	},
	"flag_ie": {
		"category": "flags",
		"moji": "🇮🇪",
		"unicodeVersion": "6.0",
		"digest": "5fc8c101ad7296224455f72f73c335aa4f676023b68645bafaf69087f69af390"
	},
	"flag_il": {
		"category": "flags",
		"moji": "🇮🇱",
		"unicodeVersion": "6.0",
		"digest": "5aea4207415b7615dcdd69413705aefda700aefd0d27010cd0a0a338d879d9b8"
	},
	"flag_im": {
		"category": "flags",
		"moji": "🇮🇲",
		"unicodeVersion": "6.0",
		"digest": "1ee9b3a5f1a52fc6d8369bfd81995fc0567e7a61deacd013701b3ec5fd64502e"
	},
	"flag_in": {
		"category": "flags",
		"moji": "🇮🇳",
		"unicodeVersion": "6.0",
		"digest": "202ede502f34d55d180726ac2f29141c6875516f1b3e7ee99f266b16c2fe4bfd"
	},
	"flag_io": {
		"category": "flags",
		"moji": "🇮🇴",
		"unicodeVersion": "6.0",
		"digest": "dd45e1afe792fca57d4161434bf611bcb7170072d63e4a27fb9dcd6e8912621e"
	},
	"flag_iq": {
		"category": "flags",
		"moji": "🇮🇶",
		"unicodeVersion": "6.0",
		"digest": "bef294772b5ffccd6c061c19d60af66f61b248d78705faf347ade9ebfca2b46d"
	},
	"flag_ir": {
		"category": "flags",
		"moji": "🇮🇷",
		"unicodeVersion": "6.0",
		"digest": "d4faca93577a5546330ab6a09252307e19fb420d89912c0b48ceb90bf409d48e"
	},
	"flag_is": {
		"category": "flags",
		"moji": "🇮🇸",
		"unicodeVersion": "6.0",
		"digest": "b2fc04226b274009b4d99d92bcb72b255b534b6fd4b76d82dce1575ad975a456"
	},
	"flag_it": {
		"category": "flags",
		"moji": "🇮🇹",
		"unicodeVersion": "6.0",
		"digest": "735760f193855d55460a0fb93dad55ff67253cab63176eceb90b9bde1faead1e"
	},
	"flag_je": {
		"category": "flags",
		"moji": "🇯🇪",
		"unicodeVersion": "6.0",
		"digest": "671a487a60571d928d2abaf306d0a9ba50239ec54ada14ea29a9a99df658d3cc"
	},
	"flag_jm": {
		"category": "flags",
		"moji": "🇯🇲",
		"unicodeVersion": "6.0",
		"digest": "fb9047199d030b78fc0dcfc58d9b524fdb929238d922809da88147b7cebf4211"
	},
	"flag_jo": {
		"category": "flags",
		"moji": "🇯🇴",
		"unicodeVersion": "6.0",
		"digest": "19f7d536d0293ebf3db49e05a158097cbde467115ef96523a0553808fd0b4178"
	},
	"flag_jp": {
		"category": "flags",
		"moji": "🇯🇵",
		"unicodeVersion": "6.0",
		"digest": "51e971f777fe481ca9f7e077ecb2ce252c3cc0086b76384e7b965cdc337f3f9e"
	},
	"flag_ke": {
		"category": "flags",
		"moji": "🇰🇪",
		"unicodeVersion": "6.0",
		"digest": "0cec8f068548cfd3e7a20c10af84f97ca415fd6f8ab8b50783bf982e77d7260e"
	},
	"flag_kg": {
		"category": "flags",
		"moji": "🇰🇬",
		"unicodeVersion": "6.0",
		"digest": "5803ea6ab028261923fd7570c670a50518c6f462a2fb4d463531b12c3e382e6f"
	},
	"flag_kh": {
		"category": "flags",
		"moji": "🇰🇭",
		"unicodeVersion": "6.0",
		"digest": "287d357afe47179853fd485fb102834ead145598ed892664fc62d245cac16080"
	},
	"flag_ki": {
		"category": "flags",
		"moji": "🇰🇮",
		"unicodeVersion": "6.0",
		"digest": "ae4aee0d9cd7a21d4e250d45a484f5f641acdab3d79b437337b25fe34a0b49b0"
	},
	"flag_km": {
		"category": "flags",
		"moji": "🇰🇲",
		"unicodeVersion": "6.0",
		"digest": "2d1730acbf5421fd02bd5483e26a86d82ec2fa99f0ff75bfd728a9df7914ad3b"
	},
	"flag_kn": {
		"category": "flags",
		"moji": "🇰🇳",
		"unicodeVersion": "6.0",
		"digest": "b9ed979db9c6d243b00f61f19a9ec0f2c2390b2e5cace5ad61d9371dc8c670ac"
	},
	"flag_kp": {
		"category": "flags",
		"moji": "🇰🇵",
		"unicodeVersion": "6.0",
		"digest": "1bab0b9cab8028a95ce7231ad8d88ebcd31601cfa321284bba017ead47f6c729"
	},
	"flag_kr": {
		"category": "flags",
		"moji": "🇰🇷",
		"unicodeVersion": "6.0",
		"digest": "33be8c09ebe273e203aa703cc827d52a6d9bf1699f5445bba13a77af2df45fa6"
	},
	"flag_kw": {
		"category": "flags",
		"moji": "🇰🇼",
		"unicodeVersion": "6.0",
		"digest": "04d901a92ea55b13dc4983a9e3adb52dc89c9f3decee86fd06022aa902678b6d"
	},
	"flag_ky": {
		"category": "flags",
		"moji": "🇰🇾",
		"unicodeVersion": "6.0",
		"digest": "10f4d02f33cadd34da89de71a3b763809bad480cd9ae9d2ec000db026bd94cd1"
	},
	"flag_kz": {
		"category": "flags",
		"moji": "🇰🇿",
		"unicodeVersion": "6.0",
		"digest": "dfaff69a78cf635f7fad41bd5bdcc8003298454708a6178ba7348b1b40c360c1"
	},
	"flag_la": {
		"category": "flags",
		"moji": "🇱🇦",
		"unicodeVersion": "6.0",
		"digest": "4fcfbdc694cf99ae3f832500cdcdedb88c444b6df88bc9b7141f4f26ba3d5bfd"
	},
	"flag_lb": {
		"category": "flags",
		"moji": "🇱🇧",
		"unicodeVersion": "6.0",
		"digest": "af4b1f784bea0ec7a712495491dffbd1152cc857a99fd433f76bfeb313819a62"
	},
	"flag_lc": {
		"category": "flags",
		"moji": "🇱🇨",
		"unicodeVersion": "6.0",
		"digest": "40784aa558b75d07ae499c004e2cc5d0b2efdfc3e5be705b5a9f6b70d681c396"
	},
	"flag_li": {
		"category": "flags",
		"moji": "🇱🇮",
		"unicodeVersion": "6.0",
		"digest": "c4eb4c43f457ce60ff9d046adb512c1d3462203403eeb595bff3ebc010ed6633"
	},
	"flag_lk": {
		"category": "flags",
		"moji": "🇱🇰",
		"unicodeVersion": "6.0",
		"digest": "a5285cdfdc3715fa3941f5f0eb03dc425969eaaf22c719c27ab4418628d09bc5"
	},
	"flag_lr": {
		"category": "flags",
		"moji": "🇱🇷",
		"unicodeVersion": "6.0",
		"digest": "ed04334264953b4da570db8c392b99d2fab4e0b7efc2331427016c6a08e818be"
	},
	"flag_ls": {
		"category": "flags",
		"moji": "🇱🇸",
		"unicodeVersion": "6.0",
		"digest": "cd56022106d027317cc9bf4c848758cf29ffe277ce71fdb9c1cf89ac4fd6e6db"
	},
	"flag_lt": {
		"category": "flags",
		"moji": "🇱🇹",
		"unicodeVersion": "6.0",
		"digest": "3c4395b068e421100fd97a102f170cb8d5c093885eef7cb40d3faff4f4e47fe9"
	},
	"flag_lu": {
		"category": "flags",
		"moji": "🇱🇺",
		"unicodeVersion": "6.0",
		"digest": "df15a2c47eecad17e0cc169bdf0d31c6a51eb22de7ca4e70d2431359a33f930d"
	},
	"flag_lv": {
		"category": "flags",
		"moji": "🇱🇻",
		"unicodeVersion": "6.0",
		"digest": "9b53c6ce23287935200da8ca8a8af78013a4b1572f9821e7e1724cbad248e7e2"
	},
	"flag_ly": {
		"category": "flags",
		"moji": "🇱🇾",
		"unicodeVersion": "6.0",
		"digest": "42efa9f3526ef006d6723fa17538a98ab9556ae25f14df1b06d21361bf7e1a44"
	},
	"flag_ma": {
		"category": "flags",
		"moji": "🇲🇦",
		"unicodeVersion": "6.0",
		"digest": "96c07296cfd7aa1cb642faed8ace26744105b81ca880157a4ef4caee0befe26e"
	},
	"flag_mc": {
		"category": "flags",
		"moji": "🇲🇨",
		"unicodeVersion": "6.0",
		"digest": "6b44608842fe849ae2b4bae5eb87ccd436459a427051dfda25080196273d4b9f"
	},
	"flag_md": {
		"category": "flags",
		"moji": "🇲🇩",
		"unicodeVersion": "6.0",
		"digest": "78c7b01c698873a9129d52ba38b3eb4cfc683ef2ae10b7b922b17c07f1c938c8"
	},
	"flag_me": {
		"category": "flags",
		"moji": "🇲🇪",
		"unicodeVersion": "6.0",
		"digest": "01aa0f9df89302edc4ae319b5dd78069ba8807c3f38cc7bfe01bff67c8efd416"
	},
	"flag_mf": {
		"category": "flags",
		"moji": "🇲🇫",
		"unicodeVersion": "6.0",
		"digest": "a0124683aa88cd7da886da70c65796c5ad84eb3751e356e9b2aa8ac249cf0bf9"
	},
	"flag_mg": {
		"category": "flags",
		"moji": "🇲🇬",
		"unicodeVersion": "6.0",
		"digest": "56ebcd2a2e144d656d3b38a62595138fe6e50f9c1144f70b0a120cce7a72eb5b"
	},
	"flag_mh": {
		"category": "flags",
		"moji": "🇲🇭",
		"unicodeVersion": "6.0",
		"digest": "008660adc4c2e4d04830498988184d1ef8a372a6c085da369a94ee6b820dbbb7"
	},
	"flag_mk": {
		"category": "flags",
		"moji": "🇲🇰",
		"unicodeVersion": "6.0",
		"digest": "f3c4c5106ace81c21fc0c6a7cc5c5e04e9453468fbc6ccbc851bb8dd61ff237f"
	},
	"flag_ml": {
		"category": "flags",
		"moji": "🇲🇱",
		"unicodeVersion": "6.0",
		"digest": "e70a6b30e46adc2e19684308a848fef2c3ad76e2cac4bb493ee3270ad39f9d1b"
	},
	"flag_mm": {
		"category": "flags",
		"moji": "🇲🇲",
		"unicodeVersion": "6.0",
		"digest": "720f5d38887202ba049cd5a46c183679be6a01f169d99e6e656c73b515793a7d"
	},
	"flag_mn": {
		"category": "flags",
		"moji": "🇲🇳",
		"unicodeVersion": "6.0",
		"digest": "5f0fd6fcb2ed73a5a6d9396c3703612503c1f16283bbb4e9362a1c8324b762ad"
	},
	"flag_mo": {
		"category": "flags",
		"moji": "🇲🇴",
		"unicodeVersion": "6.0",
		"digest": "fc2a9e7323867cf195f551e59afdab778c56b84c96af28c20207c9870caa2c39"
	},
	"flag_mp": {
		"category": "flags",
		"moji": "🇲🇵",
		"unicodeVersion": "6.0",
		"digest": "ddce3be9d72914240c42e1b97ea97af01016d0a3879999cb0e447552682c06ba"
	},
	"flag_mq": {
		"category": "flags",
		"moji": "🇲🇶",
		"unicodeVersion": "6.0",
		"digest": "888f455b1322d6fb83dc9f469f5505fea3dd6ece77d17d0d7345319c3ebcec0e"
	},
	"flag_mr": {
		"category": "flags",
		"moji": "🇲🇷",
		"unicodeVersion": "6.0",
		"digest": "72621914c92dd9c9f3ac9973ee3589583bfe42b841cdd35f47af75e2f629726c"
	},
	"flag_ms": {
		"category": "flags",
		"moji": "🇲🇸",
		"unicodeVersion": "6.0",
		"digest": "5944996295132f41ec55261ff7927518bd47aec95d274a6ff257c357b43657bc"
	},
	"flag_mt": {
		"category": "flags",
		"moji": "🇲🇹",
		"unicodeVersion": "6.0",
		"digest": "95f0550e8823441a4e69b26c540baea94f3ddcc282100fd0239021c00df0b469"
	},
	"flag_mu": {
		"category": "flags",
		"moji": "🇲🇺",
		"unicodeVersion": "6.0",
		"digest": "5fda78a6df0ea7f5cac5fb4c8fd68529c14c5e15bac4e0b167493cb6ac459253"
	},
	"flag_mv": {
		"category": "flags",
		"moji": "🇲🇻",
		"unicodeVersion": "6.0",
		"digest": "f75c8f6fd3a68f2944a04c833c649d4b576997f491100cf3f3160fe77117fabb"
	},
	"flag_mw": {
		"category": "flags",
		"moji": "🇲🇼",
		"unicodeVersion": "6.0",
		"digest": "d46b484a97e5b90b6b259f8de1712b553f93f0dfb6391209200358bb9429ebf5"
	},
	"flag_mx": {
		"category": "flags",
		"moji": "🇲🇽",
		"unicodeVersion": "6.0",
		"digest": "dc57c10307fc0aa09bd7fcd25ee0fca561f3b382276faa8432a927c1baea53fd"
	},
	"flag_my": {
		"category": "flags",
		"moji": "🇲🇾",
		"unicodeVersion": "6.0",
		"digest": "15ca00660a1eb0096fdaa00b85a7b95fcf192bf2ee4781ba72c36d2d2cb015ef"
	},
	"flag_mz": {
		"category": "flags",
		"moji": "🇲🇿",
		"unicodeVersion": "6.0",
		"digest": "0c8605a9319dcf86672a833b4c4d6acea5f6aa25a3f8e1dfac78fbf7c452ba97"
	},
	"flag_na": {
		"category": "flags",
		"moji": "🇳🇦",
		"unicodeVersion": "6.0",
		"digest": "e63cde5ee49d3ada1e33d2ab15dc24fbb129b90d65b6fd1d7c07455f71a53601"
	},
	"flag_nc": {
		"category": "flags",
		"moji": "🇳🇨",
		"unicodeVersion": "6.0",
		"digest": "a4a350ce7404ba7bdda9a341e7a48fcfe16312be4964b1bd6eed7115acd2e329"
	},
	"flag_ne": {
		"category": "flags",
		"moji": "🇳🇪",
		"unicodeVersion": "6.0",
		"digest": "6b32483b4445bc52855509f618c570b9c9606de5649e4878b71b44ff2acbc9fd"
	},
	"flag_nf": {
		"category": "flags",
		"moji": "🇳🇫",
		"unicodeVersion": "6.0",
		"digest": "96b1ec33acbd2b1ffe42703c11a2a633b036e6779849b0e6fa8f399167820584"
	},
	"flag_ng": {
		"category": "flags",
		"moji": "🇳🇬",
		"unicodeVersion": "6.0",
		"digest": "f97d0630cbfa5e75440251df7529a67b58c22598643390cbeea82fb04a1cd956"
	},
	"flag_ni": {
		"category": "flags",
		"moji": "🇳🇮",
		"unicodeVersion": "6.0",
		"digest": "c52fb5f9134122a91defa75425be2c6b3c909e051d546244e0e7bdf5f9ee1710"
	},
	"flag_nl": {
		"category": "flags",
		"moji": "🇳🇱",
		"unicodeVersion": "6.0",
		"digest": "b8918f9c0c92513aa0ec6ba6cee5448270168cbe6f0a970fb06e7ceb9f52ec71"
	},
	"flag_no": {
		"category": "flags",
		"moji": "🇳🇴",
		"unicodeVersion": "6.0",
		"digest": "05ce84095f8d93407d611b39d8b6a67fd9f11df6cfab7a185bcb4eec186d85ef"
	},
	"flag_np": {
		"category": "flags",
		"moji": "🇳🇵",
		"unicodeVersion": "6.0",
		"digest": "cc41c2f97ec2b38fe5781d553792f6aab5d37cc3be02586f361fe89d12683bee"
	},
	"flag_nr": {
		"category": "flags",
		"moji": "🇳🇷",
		"unicodeVersion": "6.0",
		"digest": "7837edf59ec33a25380d76afea5f04cfcab4f17df4e33fca0dcaacb517c5cbec"
	},
	"flag_nu": {
		"category": "flags",
		"moji": "🇳🇺",
		"unicodeVersion": "6.0",
		"digest": "fd9ab45c6f32bc4da47542392e5beba73ddac302a4a9a00e6deedc913a4c087d"
	},
	"flag_nz": {
		"category": "flags",
		"moji": "🇳🇿",
		"unicodeVersion": "6.0",
		"digest": "0719830dcca400cefb30ce399bb03f49dd84c9a98f7d6a28270f9278e2a7af75"
	},
	"flag_om": {
		"category": "flags",
		"moji": "🇴🇲",
		"unicodeVersion": "6.0",
		"digest": "3f9039becd52e3454fdf7611cdb0d7fb1196e053eea29ef87daab6c21a94f1ee"
	},
	"flag_pa": {
		"category": "flags",
		"moji": "🇵🇦",
		"unicodeVersion": "6.0",
		"digest": "1adf0e5d4084e072aa44bd9978829e77546e0be75785e9be69f92e326bd714a7"
	},
	"flag_pe": {
		"category": "flags",
		"moji": "🇵🇪",
		"unicodeVersion": "6.0",
		"digest": "f8a4e257676f4ab8962ffe5509b8417777a8be2f0e9dc7735d3e014ff221aab1"
	},
	"flag_pf": {
		"category": "flags",
		"moji": "🇵🇫",
		"unicodeVersion": "6.0",
		"digest": "1ace6cc71d130cdf09246297740a911f14828c322e35330cc548ca5975015c23"
	},
	"flag_pg": {
		"category": "flags",
		"moji": "🇵🇬",
		"unicodeVersion": "6.0",
		"digest": "9c37719d9f51ef31fec0f898d38e522b4253cd00344408e3f660132514efddb7"
	},
	"flag_ph": {
		"category": "flags",
		"moji": "🇵🇭",
		"unicodeVersion": "6.0",
		"digest": "f1af628cf6d1d290cedef3d564b2386e2d6f14ba4426d3fefc0312cb8772e517"
	},
	"flag_pk": {
		"category": "flags",
		"moji": "🇵🇰",
		"unicodeVersion": "6.0",
		"digest": "61c77f73d2a10a5acb289fadfe0d25d1a1c343e1223bd802099ff4e0e9356521"
	},
	"flag_pl": {
		"category": "flags",
		"moji": "🇵🇱",
		"unicodeVersion": "6.0",
		"digest": "38c2c8618446e1f72cf983ab33e736d943f0db7c4cce52a187299e8cec2ea895"
	},
	"flag_pm": {
		"category": "flags",
		"moji": "🇵🇲",
		"unicodeVersion": "6.0",
		"digest": "656be9ea1a79c3885a759c7ce353d338345a198d7939556949affaf5490cb644"
	},
	"flag_pn": {
		"category": "flags",
		"moji": "🇵🇳",
		"unicodeVersion": "6.0",
		"digest": "2792260d8087ab0253b1214c1420f0160ab2eef9afe7315f9e7ff0b87cd15d72"
	},
	"flag_pr": {
		"category": "flags",
		"moji": "🇵🇷",
		"unicodeVersion": "6.0",
		"digest": "c4cfa1f2201dcda9de310a8247e6ce32d2798ae426a14dd70a9ebb00a2804d46"
	},
	"flag_ps": {
		"category": "flags",
		"moji": "🇵🇸",
		"unicodeVersion": "6.0",
		"digest": "197f2ec6294bf0ee4a08cf2f2d1e237ee867c98b3085454a3f42abc955eeb289"
	},
	"flag_pt": {
		"category": "flags",
		"moji": "🇵🇹",
		"unicodeVersion": "6.0",
		"digest": "86a50827963756b5bf471ed9df5b3f2a2058b4c5d778a303414b6b0556e2082b"
	},
	"flag_pw": {
		"category": "flags",
		"moji": "🇵🇼",
		"unicodeVersion": "6.0",
		"digest": "a6321c47a0cd188fbfdf3b55f17a7170c63080d28d50e4f5463eb1ee09af2412"
	},
	"flag_py": {
		"category": "flags",
		"moji": "🇵🇾",
		"unicodeVersion": "6.0",
		"digest": "1a169e8d8703c510c5a2265b57dbed2f811b03ec375bcb341ab4cd0b100a9dd6"
	},
	"flag_qa": {
		"category": "flags",
		"moji": "🇶🇦",
		"unicodeVersion": "6.0",
		"digest": "de6283965cd98a244b7fa6288174f9ff0d8feb497f191f2e4ab3b690138a3d5d"
	},
	"flag_re": {
		"category": "flags",
		"moji": "🇷🇪",
		"unicodeVersion": "6.0",
		"digest": "260e1b97abc1562e5a73d7e53652ffed8059fc9b1c969741c466f48ec6ab0e80"
	},
	"flag_ro": {
		"category": "flags",
		"moji": "🇷🇴",
		"unicodeVersion": "6.0",
		"digest": "6d648e03955fa2a9fd2bad6f60ec96d3e20ee57f5855f3721a4d4e0c8e99f95c"
	},
	"flag_rs": {
		"category": "flags",
		"moji": "🇷🇸",
		"unicodeVersion": "6.0",
		"digest": "95cd5e197ed364e403eeb7f1d18a83487d89166910ba8119ea994e5e19d6a7ee"
	},
	"flag_ru": {
		"category": "flags",
		"moji": "🇷🇺",
		"unicodeVersion": "6.0",
		"digest": "a4a81617a59d9eaf3c526431ca6f90ed334a7c1f516bf70cbd3f1fdc6e6103d7"
	},
	"flag_rw": {
		"category": "flags",
		"moji": "🇷🇼",
		"unicodeVersion": "6.0",
		"digest": "7a369f60db0876ffef111c319a3e8c9eaed620c875c51b98ed9ad5207b836dca"
	},
	"flag_sa": {
		"category": "flags",
		"moji": "🇸🇦",
		"unicodeVersion": "6.0",
		"digest": "b249fbfd7ed415943f60bbd841965cf721979f960ccbe09396aebac1eca913d7"
	},
	"flag_sb": {
		"category": "flags",
		"moji": "🇸🇧",
		"unicodeVersion": "6.0",
		"digest": "526b411260024ea7b6ea6c47f2549345c6cc6960e9a29bfa9aaec0772664d2dc"
	},
	"flag_sc": {
		"category": "flags",
		"moji": "🇸🇨",
		"unicodeVersion": "6.0",
		"digest": "d036b0d068745926120eaf746fa2e4433306e2e14c6b540d0cd6265e34471056"
	},
	"flag_sd": {
		"category": "flags",
		"moji": "🇸🇩",
		"unicodeVersion": "6.0",
		"digest": "889615bdb9b1f9c59c5f83ed4d22d54a0ed5dd5de263e729c58544cb06c55885"
	},
	"flag_se": {
		"category": "flags",
		"moji": "🇸🇪",
		"unicodeVersion": "6.0",
		"digest": "f471d80cfff340960a752c8c152ed4fb482df2a3712b0a56dfab31b9b806926a"
	},
	"flag_sg": {
		"category": "flags",
		"moji": "🇸🇬",
		"unicodeVersion": "6.0",
		"digest": "82f58a09f98593cc87e545f7e5c03d2aedaf82e54e73f71f58c18e994c3085ac"
	},
	"flag_sh": {
		"category": "flags",
		"moji": "🇸🇭",
		"unicodeVersion": "6.0",
		"digest": "53914b1fa8c1b4f30bae6c1f6717f138fb4dbf482c3e20e33f7aea4ecfc0438d"
	},
	"flag_si": {
		"category": "flags",
		"moji": "🇸🇮",
		"unicodeVersion": "6.0",
		"digest": "65d491daa69f9a11cec9ccc4df3a669f12ef95a5c312137776d4472719940ba3"
	},
	"flag_sj": {
		"category": "flags",
		"moji": "🇸🇯",
		"unicodeVersion": "6.0",
		"digest": "bbf6daa6174c6fbbbf541c8274f31b6757c3a16007c2687015ea041fd1e2c6b6"
	},
	"flag_sk": {
		"category": "flags",
		"moji": "🇸🇰",
		"unicodeVersion": "6.0",
		"digest": "d4fd03eca5bd3c9fb324ee04fae37c9a2d852bac8335369e3e720ef9b98fff36"
	},
	"flag_sl": {
		"category": "flags",
		"moji": "🇸🇱",
		"unicodeVersion": "6.0",
		"digest": "1455c98c11c248623d82be5484ab1c4dcd1dae449adc393eb1aa2d8c74aa3f02"
	},
	"flag_sm": {
		"category": "flags",
		"moji": "🇸🇲",
		"unicodeVersion": "6.0",
		"digest": "daec5864ac50c625d7bf49d6c1a170a094cf0d1b9a0bdf62a62406e7ec500a94"
	},
	"flag_sn": {
		"category": "flags",
		"moji": "🇸🇳",
		"unicodeVersion": "6.0",
		"digest": "4e4d43c467e5eb84c70f535f37f4f468319bd4b06c6ec3db3b54f69efdafd334"
	},
	"flag_so": {
		"category": "flags",
		"moji": "🇸🇴",
		"unicodeVersion": "6.0",
		"digest": "c1434dca361563a8e3ba88f1ad19c3f6c9cbb8f3ebc17ce128fde2351ff67d0c"
	},
	"flag_sr": {
		"category": "flags",
		"moji": "🇸🇷",
		"unicodeVersion": "6.0",
		"digest": "f3c6bfee2a052f03d56ba917b88595450cef111ffa9e92c7f39ef8c3c3bd12d1"
	},
	"flag_ss": {
		"category": "flags",
		"moji": "🇸🇸",
		"unicodeVersion": "6.0",
		"digest": "c0ed7e4f41206f5363e8ebdc6c3f28080e2f07d99e6fb73c1f6226d83310e69d"
	},
	"flag_st": {
		"category": "flags",
		"moji": "🇸🇹",
		"unicodeVersion": "6.0",
		"digest": "b022ae5d6885e28c6e9c83c17dd0c24c731d4f3d5773c49051768cdd4df51330"
	},
	"flag_sv": {
		"category": "flags",
		"moji": "🇸🇻",
		"unicodeVersion": "6.0",
		"digest": "5bafdd04d243ee3f3998f4ec0a3d03ff5a3975e771b1f94f89d7713193d7a242"
	},
	"flag_sx": {
		"category": "flags",
		"moji": "🇸🇽",
		"unicodeVersion": "6.0",
		"digest": "fb92e9f514bcc2f7abbd4e146edde50f030c940c833f184618cbb48e56af22bd"
	},
	"flag_sy": {
		"category": "flags",
		"moji": "🇸🇾",
		"unicodeVersion": "6.0",
		"digest": "ee330da644d4ce1fdba98be5eaab5054aed8d91a34ab617199a4b2b77f62a10b"
	},
	"flag_sz": {
		"category": "flags",
		"moji": "🇸🇿",
		"unicodeVersion": "6.0",
		"digest": "7fe0c7429efd9682cc39e57f4bba8d1491d301643ba999d57c4e1bc37517ed64"
	},
	"flag_ta": {
		"category": "flags",
		"moji": "🇹🇦",
		"unicodeVersion": "6.0",
		"digest": "b47e245a2708072a4dbaf190c9606baa4daf02e51627eeae6f20c3b4c95024c0"
	},
	"flag_tc": {
		"category": "flags",
		"moji": "🇹🇨",
		"unicodeVersion": "6.0",
		"digest": "18cfff14c2503b9d24c91c668583d4a14efb17657d800eca86ae49b547c9da5c"
	},
	"flag_td": {
		"category": "flags",
		"moji": "🇹🇩",
		"unicodeVersion": "6.0",
		"digest": "73d1db3365736915c4cdf9ba9343d9fd78962203b60334e8f3724d4b330b17db"
	},
	"flag_tf": {
		"category": "flags",
		"moji": "🇹🇫",
		"unicodeVersion": "6.0",
		"digest": "3bffeb4bc9ceb9cbb150de88e957b6e46509862ca7d616d5693124af084eb435"
	},
	"flag_tg": {
		"category": "flags",
		"moji": "🇹🇬",
		"unicodeVersion": "6.0",
		"digest": "eb13a0e85baf73326f3ae3bc75e8406eca42000d7e42b0641120e64c0ab7ebaa"
	},
	"flag_th": {
		"category": "flags",
		"moji": "🇹🇭",
		"unicodeVersion": "6.0",
		"digest": "a4e42efa4bb94e90f3a92ae9ce14affaacd3a142c1e0da40d8cc839500e771fd"
	},
	"flag_tj": {
		"category": "flags",
		"moji": "🇹🇯",
		"unicodeVersion": "6.0",
		"digest": "ff926fa3e86e095683a61c4754355a5b4dd0ecb74393306bd791d130fd1a909d"
	},
	"flag_tk": {
		"category": "flags",
		"moji": "🇹🇰",
		"unicodeVersion": "6.0",
		"digest": "3fa732d457ded6c83cd5f73d934f64c4e687eb0cde7c157d2fdcdccaf3b5fb52"
	},
	"flag_tl": {
		"category": "flags",
		"moji": "🇹🇱",
		"unicodeVersion": "6.0",
		"digest": "0ec2a4d22fb832060693089e518bbe370a4e13bfc28748f110fc13726409f473"
	},
	"flag_tm": {
		"category": "flags",
		"moji": "🇹🇲",
		"unicodeVersion": "6.0",
		"digest": "b4724aa7ad13352f16a0936e61cbb85f0bd147583fc66597aff7e8ee7cf19c21"
	},
	"flag_tn": {
		"category": "flags",
		"moji": "🇹🇳",
		"unicodeVersion": "6.0",
		"digest": "5ab308ffdde40f504d6ee080817bbddbe4f3f4ddb71f508c75e0144a8c8044d9"
	},
	"flag_to": {
		"category": "flags",
		"moji": "🇹🇴",
		"unicodeVersion": "6.0",
		"digest": "75b7e7198fa42f87986882b8ca251a229afcaa0a1188ae7b9f5ece87dc31a723"
	},
	"flag_tr": {
		"category": "flags",
		"moji": "🇹🇷",
		"unicodeVersion": "6.0",
		"digest": "9cc48a8f8fa9c17c1627272f68d4740da0e7ce17a2cf8c6b5c08cc9b95e1390c"
	},
	"flag_tt": {
		"category": "flags",
		"moji": "🇹🇹",
		"unicodeVersion": "6.0",
		"digest": "f9e63543121bb3cd2e41bc7b0c2c4ba662bc1cc0520b79fc4e201ec6456fdf59"
	},
	"flag_tv": {
		"category": "flags",
		"moji": "🇹🇻",
		"unicodeVersion": "6.0",
		"digest": "6431e5f06cc7995ae7208c429ecf39339b545854cb6d6b7447f465fe53614dfc"
	},
	"flag_tw": {
		"category": "flags",
		"moji": "🇹🇼",
		"unicodeVersion": "6.0",
		"digest": "8395ab3c6a595023b006518a5345ac3612f2893d3a8f011b7e5802414236b03c"
	},
	"flag_tz": {
		"category": "flags",
		"moji": "🇹🇿",
		"unicodeVersion": "6.0",
		"digest": "716181733cd9ac7a8f51a9a64bc5d21020e8112f6768e8c49c4d651a3ee0b8a4"
	},
	"flag_ua": {
		"category": "flags",
		"moji": "🇺🇦",
		"unicodeVersion": "6.0",
		"digest": "304570736345e28734f5ff84a2b0481c2bb00bf29d9892bd749b57dec7741e30"
	},
	"flag_ug": {
		"category": "flags",
		"moji": "🇺🇬",
		"unicodeVersion": "6.0",
		"digest": "a1bafb74c54ee8c92cb025b55aebdb6081eec3fda6a7f86f2ee14d1b801a8e9c"
	},
	"flag_um": {
		"category": "flags",
		"moji": "🇺🇲",
		"unicodeVersion": "6.0",
		"digest": "b3c9ac72211f481f50cde09e10b92aa03b1ea90abf85418e60a35b84963273ee"
	},
	"flag_us": {
		"category": "flags",
		"moji": "🇺🇸",
		"unicodeVersion": "6.0",
		"digest": "da79f9af0a188178a82e7dc3a62298fa416f4cfbcae432838df1abebca5c0d63"
	},
	"flag_uy": {
		"category": "flags",
		"moji": "🇺🇾",
		"unicodeVersion": "6.0",
		"digest": "8348e901d775722497ee911c9c9b4bd767710760c507630a67ecb6d47cc646c7"
	},
	"flag_uz": {
		"category": "flags",
		"moji": "🇺🇿",
		"unicodeVersion": "6.0",
		"digest": "2a1dc1e9469e01c58ea91f545ef3fe0bdfe5544a73a80407f8960d01b1e5db5c"
	},
	"flag_va": {
		"category": "flags",
		"moji": "🇻🇦",
		"unicodeVersion": "6.0",
		"digest": "0e8134ec94bff032bfc63b0b08587d5298c9b7f31edd5a5b35633ae911434e61"
	},
	"flag_vc": {
		"category": "flags",
		"moji": "🇻🇨",
		"unicodeVersion": "6.0",
		"digest": "e0290e1be72c8939ee6c398f00a107703b21b97d91b9bf465e553ffbf00304a7"
	},
	"flag_ve": {
		"category": "flags",
		"moji": "🇻🇪",
		"unicodeVersion": "6.0",
		"digest": "76a6a6c2353def1f984d1a6980831e63f3aea5af2201b574197834e7c203d57a"
	},
	"flag_vg": {
		"category": "flags",
		"moji": "🇻🇬",
		"unicodeVersion": "6.0",
		"digest": "56fc9317b8dd62cccc60010819f8b895dd4569a9b06368a9250f815c39177b8a"
	},
	"flag_vi": {
		"category": "flags",
		"moji": "🇻🇮",
		"unicodeVersion": "6.0",
		"digest": "2526a3e13b8ccd301f0763580430898c227bd209e3ce482c7951140b28948375"
	},
	"flag_vn": {
		"category": "flags",
		"moji": "🇻🇳",
		"unicodeVersion": "6.0",
		"digest": "0cf6b9896bbe4da8ed7718d0abfd56cef1a8321e26f89d3ad1b48488eaffb7a5"
	},
	"flag_vu": {
		"category": "flags",
		"moji": "🇻🇺",
		"unicodeVersion": "6.0",
		"digest": "9dfa282ce1aafc62beacab76e1fc19a141c8bdeaa30898f69b083067b775d362"
	},
	"flag_wf": {
		"category": "flags",
		"moji": "🇼🇫",
		"unicodeVersion": "6.0",
		"digest": "a0124683aa88cd7da886da70c65796c5ad84eb3751e356e9b2aa8ac249cf0bf9"
	},
	"flag_white": {
		"category": "objects",
		"moji": "🏳",
		"unicodeVersion": "6.0",
		"digest": "d9be4b7ceb8309c48f88cfd07a9f7ce6758ea6e620e73293cf14baec03ca381c"
	},
	"flag_ws": {
		"category": "flags",
		"moji": "🇼🇸",
		"unicodeVersion": "6.0",
		"digest": "53addd0dc304a3c8893389ed227986ef2431828b8c071926aa09f9efd815b649"
	},
	"flag_xk": {
		"category": "flags",
		"moji": "🇽🇰",
		"unicodeVersion": "6.0",
		"digest": "eba1a832e489e1c2734e773e685df5d128271fa5559d23c060e68be067bf6469"
	},
	"flag_ye": {
		"category": "flags",
		"moji": "🇾🇪",
		"unicodeVersion": "6.0",
		"digest": "edfa14266785042b6d5fe0f64fafa630b16a3ee7d010501de7cc8554c959afb0"
	},
	"flag_yt": {
		"category": "flags",
		"moji": "🇾🇹",
		"unicodeVersion": "6.0",
		"digest": "472ebc676b5d31dec2ac5e02ce69014a3dd94609d30a95f39f3a752f49c85e8b"
	},
	"flag_za": {
		"category": "flags",
		"moji": "🇿🇦",
		"unicodeVersion": "6.0",
		"digest": "dad162942a43392b4cff6929bd5cbf58c382a03dbc0e552f03c07ad2d8ff08ce"
	},
	"flag_zm": {
		"category": "flags",
		"moji": "🇿🇲",
		"unicodeVersion": "6.0",
		"digest": "1521ecaf1d1fdc8c15f0c96a6b04e6d4050f26f943a826b3d3d661f6ded6d438"
	},
	"flag_zw": {
		"category": "flags",
		"moji": "🇿🇼",
		"unicodeVersion": "6.0",
		"digest": "46d05b597c5c77c8e2dc7bd6d8dd62ebca01bc9c9dc9915dafe694ca56402825"
	},
	"flags": {
		"category": "objects",
		"moji": "🎏",
		"unicodeVersion": "6.0",
		"digest": "f860aa4df587cf140c3e9735bbd101e9fd5a1bfcea42e420d85ac0a9877fa21d"
	},
	"flashlight": {
		"category": "objects",
		"moji": "🔦",
		"unicodeVersion": "6.0",
		"digest": "e929bbe76e0fd2dc5bd6476858a0bbc717fd21467710435d35d80efb38033d73"
	},
	"fleur-de-lis": {
		"category": "symbols",
		"moji": "⚜",
		"unicodeVersion": "4.1",
		"digest": "ebf49007f367dc05580e9dab942e93e9dda12fa1dc2caa410ac7f8d8cd55d2a3"
	},
	"floppy_disk": {
		"category": "objects",
		"moji": "💾",
		"unicodeVersion": "6.0",
		"digest": "4ee0b5bba41b9e301ed125d3ee1c263bef171ca499e6e1b89276b09af2bc03a0"
	},
	"flower_playing_cards": {
		"category": "symbols",
		"moji": "🎴",
		"unicodeVersion": "6.0",
		"digest": "edba47c2e3051b2c7effd98794ec977174052782edcb491daec82a2b0d853869"
	},
	"flushed": {
		"category": "people",
		"moji": "😳",
		"unicodeVersion": "6.0",
		"digest": "e759d46bab92af5494d78b6c712c06568759afe397e7828ca0a0de1e3eab0165"
	},
	"fog": {
		"category": "nature",
		"moji": "🌫",
		"unicodeVersion": "7.0",
		"digest": "0cbd4733961d30fe0f40f95dd1f37254aebbef26f82dd18ad2000e799eb2898e"
	},
	"foggy": {
		"category": "travel",
		"moji": "🌁",
		"unicodeVersion": "6.0",
		"digest": "bc3631a4e9e8473b92e842008937add2cd9ffad5b7d772ce759fb5ff6c0e3dca"
	},
	"football": {
		"category": "activity",
		"moji": "🏈",
		"unicodeVersion": "6.0",
		"digest": "ebd790471c3a28d3077818e3b31d915ffe443e06e299bc5cf0dd2534d080634c"
	},
	"footprints": {
		"category": "people",
		"moji": "👣",
		"unicodeVersion": "6.0",
		"digest": "85bbf2bc0ae8e6259d83a06f513600095d7fcfc44372670f5b2405d380b78811"
	},
	"fork_and_knife": {
		"category": "food",
		"moji": "🍴",
		"unicodeVersion": "6.0",
		"digest": "f228accd36ddccb4ec636207c19d7185191ec79723b780a1bd5c3d00a4b1ef3b"
	},
	"fork_knife_plate": {
		"category": "food",
		"moji": "🍽",
		"unicodeVersion": "7.0",
		"digest": "ec6be99dac8efd3d145807fa60d2b6d8f6d3c02cb95552b55cc0fac39a4db48e"
	},
	"fountain": {
		"category": "travel",
		"moji": "⛲",
		"unicodeVersion": "5.2",
		"digest": "87043f9256e1d4615159307fcfd21bf6ae2aba0bada7de2bd50d7d6f2ab82395"
	},
	"four": {
		"category": "symbols",
		"moji": "4️⃣",
		"unicodeVersion": "3.0",
		"digest": "c2c82a966bbb599aae557d930a4fc42604f2081aa45528872f5caf4942ee79d9"
	},
	"four_leaf_clover": {
		"category": "nature",
		"moji": "🍀",
		"unicodeVersion": "6.0",
		"digest": "ebee16e86bc9be843dfc72ab5372fb462f06be4486b5b25d7d4cac9b2c8b01c8"
	},
	"fox": {
		"category": "nature",
		"moji": "🦊",
		"unicodeVersion": "9.0",
		"digest": "e9903cb0396f7e49bdd2c384b38e614c13bfa576b3ecc1ec7b9819e4a40d91d1"
	},
	"frame_photo": {
		"category": "objects",
		"moji": "🖼",
		"unicodeVersion": "7.0",
		"digest": "d5074f748a15055ec1fb812c1e5e169e6e3cc73c522c54be1359b0e26c0fc75c"
	},
	"free": {
		"category": "symbols",
		"moji": "🆓",
		"unicodeVersion": "6.0",
		"digest": "9973522457158362fc5bdd7da858e6371e28a8403d1ef9e4b6427195c7f72cfa"
	},
	"french_bread": {
		"category": "food",
		"moji": "🥖",
		"unicodeVersion": "9.0",
		"digest": "47518a4312f57207b8e8c38188d4a2bd8b16830a885cfcf2d281cfab50c1bc6e"
	},
	"fried_shrimp": {
		"category": "food",
		"moji": "🍤",
		"unicodeVersion": "6.0",
		"digest": "0792bdc4484852de970c8f43bc3a1a339dc0e48090ec77d6de97cbfcdd17f9e1"
	},
	"fries": {
		"category": "food",
		"moji": "🍟",
		"unicodeVersion": "6.0",
		"digest": "47915aea67251d358d91a0e4dc3dcc347155336007d6b931a192be72a743b4e9"
	},
	"frog": {
		"category": "nature",
		"moji": "🐸",
		"unicodeVersion": "6.0",
		"digest": "d024b2ce771df64040534fb0906737d18b562bc3578dee62c2f25ec03c7caffd"
	},
	"frowning": {
		"category": "people",
		"moji": "😦",
		"unicodeVersion": "6.1",
		"digest": "c01af48537b0011d313d8f65103e1401fce4f5c0269c68e0e9806926c59acc44"
	},
	"frowning2": {
		"category": "people",
		"moji": "☹",
		"unicodeVersion": "1.1",
		"digest": "6568ee393b950c852d440112e86908c456b89fb7780e27778c5fcec168373fbf"
	},
	"fuelpump": {
		"category": "travel",
		"moji": "⛽",
		"unicodeVersion": "5.2",
		"digest": "105e736469f19911b8bab4ab6d29f949ded4b061b54e3dd763726577d6453095"
	},
	"full_moon": {
		"category": "nature",
		"moji": "🌕",
		"unicodeVersion": "6.0",
		"digest": "aaa87f4676a5aaa29c1b721a3b582e89db6c1f35a25c52e4b480bd193ef39c43"
	},
	"full_moon_with_face": {
		"category": "nature",
		"moji": "🌝",
		"unicodeVersion": "6.0",
		"digest": "05c4b9c339fcdf81ae67027641522baa99c370d87873ff4c8133b8349e627e33"
	},
	"game_die": {
		"category": "activity",
		"moji": "🎲",
		"unicodeVersion": "6.0",
		"digest": "00d19ce8e21dba2cdfeb18709fa8741f3af9d6207f81d5657b68e05e64f105a8"
	},
	"gear": {
		"category": "objects",
		"moji": "⚙",
		"unicodeVersion": "4.1",
		"digest": "c5ba354c0f7a36dce95477091984e352ecc59af8c9f26a94ad8e296dc042b9de"
	},
	"gem": {
		"category": "objects",
		"moji": "💎",
		"unicodeVersion": "6.0",
		"digest": "180e66f19d9285e02d0a5e859722c608206826e80323942b9938fc49d44973b1"
	},
	"gemini": {
		"category": "symbols",
		"moji": "♊",
		"unicodeVersion": "1.1",
		"digest": "278239c598d490a110f1f3f52fc3b85259be8e76034b38228ef3f68d7ddd8cdd"
	},
	"ghost": {
		"category": "people",
		"moji": "👻",
		"unicodeVersion": "6.0",
		"digest": "80d528fcf8ef9198631527547e43a608a4332a799f9e5550b8318dec67c9c4d2"
	},
	"gift": {
		"category": "objects",
		"moji": "🎁",
		"unicodeVersion": "6.0",
		"digest": "4061a84a59f0300473299678c43e533341eb965db09597fffc6e221fd7b77376"
	},
	"gift_heart": {
		"category": "symbols",
		"moji": "💝",
		"unicodeVersion": "6.0",
		"digest": "5420199b515b9b32c964a3c19d87e07461639e3068a939dae26c6436335c0cee"
	},
	"girl": {
		"category": "people",
		"moji": "👧",
		"unicodeVersion": "6.0",
		"digest": "8d2d0b72a91e6e44921b71030ffc4c89c0f50f1364787784afe1e7e568cf1bc6"
	},
	"girl_tone1": {
		"category": "people",
		"moji": "👧🏻",
		"unicodeVersion": "8.0",
		"digest": "bda12a6b38994a578ee65166bbdd93ea04df4101697b52ed236de8d687df09de"
	},
	"girl_tone2": {
		"category": "people",
		"moji": "👧🏼",
		"unicodeVersion": "8.0",
		"digest": "de7a0925c30b7181a289f71b1a849c1b7751ee8c104e8f2029bd9c2fe3f91c64"
	},
	"girl_tone3": {
		"category": "people",
		"moji": "👧🏽",
		"unicodeVersion": "8.0",
		"digest": "e41272816db0e642d003dce7cb262e1593a592251f46729f7830f4515149e1f2"
	},
	"girl_tone4": {
		"category": "people",
		"moji": "👧🏾",
		"unicodeVersion": "8.0",
		"digest": "8d6a4513ecbf08408c0ecc5336767777a2216f7a19437faf9e51f65101822469"
	},
	"girl_tone5": {
		"category": "people",
		"moji": "👧🏿",
		"unicodeVersion": "8.0",
		"digest": "f55e4b16a41b6f5e3c817a301420360ba4486e4e82e1092a56a3e3cc4069087d"
	},
	"globe_with_meridians": {
		"category": "symbols",
		"moji": "🌐",
		"unicodeVersion": "6.0",
		"digest": "725bebeb3c09a9e3701ebe49e672dcfbf2b73575e05f0821263511577b013b75"
	},
	"goal": {
		"category": "activity",
		"moji": "🥅",
		"unicodeVersion": "9.0",
		"digest": "7088c432f276ff6f447dc0d431b9062b394fb401de1072fe59ca56267bfd6717"
	},
	"goat": {
		"category": "nature",
		"moji": "🐐",
		"unicodeVersion": "6.0",
		"digest": "d07e384d08529ddcaddd2710f2ad913e5665dc15d5f99c28e16dadd245a111e8"
	},
	"golf": {
		"category": "activity",
		"moji": "⛳",
		"unicodeVersion": "5.2",
		"digest": "eed79364754eec97855e3c7b584f347ae139d9ddb4eb7fb66c00867610b8f1c1"
	},
	"golfer": {
		"category": "activity",
		"moji": "🏌",
		"unicodeVersion": "7.0",
		"digest": "7d7ecc6e226596f646030a4109c2b0001ef0cc690e4863e450bf5d29e7a90344"
	},
	"gorilla": {
		"category": "nature",
		"moji": "🦍",
		"unicodeVersion": "9.0",
		"digest": "4a564dc14f8ae5450d094f6410ec7f099a7f07dc5254b6395f44a35527bdb4b7"
	},
	"grapes": {
		"category": "food",
		"moji": "🍇",
		"unicodeVersion": "6.0",
		"digest": "74d1a09ab411234a84d025a2e717e7ec5791bc02aad29853896d21c0f0283c50"
	},
	"green_apple": {
		"category": "food",
		"moji": "🍏",
		"unicodeVersion": "6.0",
		"digest": "457490e9b2b20894f50768262d63f1021717079da104d4847076b3fa779e9a21"
	},
	"green_book": {
		"category": "objects",
		"moji": "📗",
		"unicodeVersion": "6.0",
		"digest": "370f635b200efe5e4a9f17da58bd22500e258e61d17795cef375f19c9a45468f"
	},
	"green_heart": {
		"category": "symbols",
		"moji": "💚",
		"unicodeVersion": "6.0",
		"digest": "f71e30416d9019873f2ed38ef375c48386424ff60b5a07b89b15dc9e0a3970f9"
	},
	"grey_exclamation": {
		"category": "symbols",
		"moji": "❕",
		"unicodeVersion": "6.0",
		"digest": "2fa1d356e12c17cc4025e43afb6c3070385f677102a35223302fda46c47a9b03"
	},
	"grey_question": {
		"category": "symbols",
		"moji": "❔",
		"unicodeVersion": "6.0",
		"digest": "e1035bcbf0f66d238ef478ba451f5cf2c51627fbf101ed03bad3b2bf38db8aa2"
	},
	"grimacing": {
		"category": "people",
		"moji": "😬",
		"unicodeVersion": "6.1",
		"digest": "2cedad13b8b2a1d4385ca6fa88a251eb7757a4c65dd6d362267864a01247846b"
	},
	"grin": {
		"category": "people",
		"moji": "😁",
		"unicodeVersion": "6.0",
		"digest": "634b2f37e32e57ed6edc7f371993a92e34137dd21ba393de5227cfbbe2422815"
	},
	"grinning": {
		"category": "people",
		"moji": "😀",
		"unicodeVersion": "6.1",
		"digest": "cef76aa41771db9fd1d6bd9b4233c22c1fb1931494af54cab29e6347ed9b678d"
	},
	"guardsman": {
		"category": "people",
		"moji": "💂",
		"unicodeVersion": "6.0",
		"digest": "17bc7fad6b8c8dbd015bb709380d129f8b8e1e971062d15e6ab0b2e63e500564"
	},
	"guardsman_tone1": {
		"category": "people",
		"moji": "💂🏻",
		"unicodeVersion": "8.0",
		"digest": "c531ecb101bdf9ce1db18e1567882e6db927410237100b0a2492a1401860246e"
	},
	"guardsman_tone2": {
		"category": "people",
		"moji": "💂🏼",
		"unicodeVersion": "8.0",
		"digest": "602168c5204af0f1de8b4aa5863b192ef20c19d263999377aa5eb60f98311732"
	},
	"guardsman_tone3": {
		"category": "people",
		"moji": "💂🏽",
		"unicodeVersion": "8.0",
		"digest": "d0a85de46dd02c7bd6cb14bff0f22d2db9083d4b171a8806c83363b49f3dd9ef"
	},
	"guardsman_tone4": {
		"category": "people",
		"moji": "💂🏾",
		"unicodeVersion": "8.0",
		"digest": "1c9d4d72b6b50bdac8271613b6d2a38340ec2067bc344e8ee2a3c863fd5c23a1"
	},
	"guardsman_tone5": {
		"category": "people",
		"moji": "💂🏿",
		"unicodeVersion": "8.0",
		"digest": "9899a796d01842e495d716fbe737a16d85724f7d3e23f50807ec2bc70f057318"
	},
	"guitar": {
		"category": "activity",
		"moji": "🎸",
		"unicodeVersion": "6.0",
		"digest": "a1027ceae4dd3ea270740587c9d373329e5677e375c9e00af6ae3275e0b67500"
	},
	"gun": {
		"category": "objects",
		"moji": "🔫",
		"unicodeVersion": "6.0",
		"digest": "fc12b577df2283e7b336f23774f9cfe5b79f1d26ddd28a64a560519b28d94ca5"
	},
	"haircut": {
		"category": "people",
		"moji": "💇",
		"unicodeVersion": "6.0",
		"digest": "b243a04f5ca889accd45e7abe095ac5caa92274ed95103f5966a36b415fff412"
	},
	"haircut_tone1": {
		"category": "people",
		"moji": "💇🏻",
		"unicodeVersion": "8.0",
		"digest": "a58d0cff1427b80dfd7a9ea5267b4a181e9faaac6a51a0165db522f668b4cf91"
	},
	"haircut_tone2": {
		"category": "people",
		"moji": "💇🏼",
		"unicodeVersion": "8.0",
		"digest": "675083ff40001405f8de99268477d50dd8594ff6ca40ddfd442dd42ad76e8216"
	},
	"haircut_tone3": {
		"category": "people",
		"moji": "💇🏽",
		"unicodeVersion": "8.0",
		"digest": "70d7581e49c315a3771dd61a3713229886db32aaaeb3af078a69cc042f809150"
	},
	"haircut_tone4": {
		"category": "people",
		"moji": "💇🏾",
		"unicodeVersion": "8.0",
		"digest": "ec5e3e909eb3bc375ef9cc0fe0e0f90b33f44f273ada91ccf415bbc43b8ffbfc"
	},
	"haircut_tone5": {
		"category": "people",
		"moji": "💇🏿",
		"unicodeVersion": "8.0",
		"digest": "7c89739ee458546a808fded7f96d9354c47a76883ebb262d5f5abeafd021260e"
	},
	"hamburger": {
		"category": "food",
		"moji": "🍔",
		"unicodeVersion": "6.0",
		"digest": "48204235238bd89d3a69f319f65135102f3d6b181eec241d4d86b302bbffa9bf"
	},
	"hammer": {
		"category": "objects",
		"moji": "🔨",
		"unicodeVersion": "6.0",
		"digest": "d0e7830539d935fcd82820c4e0c1d724f0756dfc83a51171fe0f4b36b69fac42"
	},
	"hammer_pick": {
		"category": "objects",
		"moji": "⚒",
		"unicodeVersion": "4.1",
		"digest": "aa0445f43bca58d17afa7f3577632ca7775f5a28336385b3020b268b15b18142"
	},
	"hamster": {
		"category": "nature",
		"moji": "🐹",
		"unicodeVersion": "6.0",
		"digest": "a7e7582e8b1bccd5b7df27ccb05e353a3f0e39bdeb40877732706b9d74a70de1"
	},
	"hand_splayed": {
		"category": "people",
		"moji": "🖐",
		"unicodeVersion": "7.0",
		"digest": "c51a30cb7e575d29ffed16780a6c95ae3f300b8ac523012f4a6e116d68c1fd15"
	},
	"hand_splayed_tone1": {
		"category": "people",
		"moji": "🖐🏻",
		"unicodeVersion": "8.0",
		"digest": "c31fb44a982ed8808e1c311ec1b0b9c5afcb47f16bb1fc731dc483adf8f0d049"
	},
	"hand_splayed_tone2": {
		"category": "people",
		"moji": "🖐🏼",
		"unicodeVersion": "8.0",
		"digest": "56a236881184e9ffad54613fa08a67368c432af738f5254fb1cd87b20368acdf"
	},
	"hand_splayed_tone3": {
		"category": "people",
		"moji": "🖐🏽",
		"unicodeVersion": "8.0",
		"digest": "9242ca97dfd2bbc1947228f6535029afb31f8feb72c14ff4b7f2deea30217425"
	},
	"hand_splayed_tone4": {
		"category": "people",
		"moji": "🖐🏾",
		"unicodeVersion": "8.0",
		"digest": "43348d9fd3d43b3c45cebaf663bf181bcad3b6df841a5aeed838180db2cdd481"
	},
	"hand_splayed_tone5": {
		"category": "people",
		"moji": "🖐🏿",
		"unicodeVersion": "8.0",
		"digest": "4b3a0aba7829772fec09f26d6facc19a2f822d2998015297b18b5cab85190ee2"
	},
	"handbag": {
		"category": "people",
		"moji": "👜",
		"unicodeVersion": "6.0",
		"digest": "45410a3eed0c2e3f68748d7649fa9e33a90f4e80d5291206bdd0b40380c6da45"
	},
	"handball": {
		"category": "activity",
		"moji": "🤾",
		"unicodeVersion": "9.0",
		"digest": "94ceb28024eb3259d8b137cafd7438773e717fbc04f5da810f85e43ca0fa9e00"
	},
	"handball_tone1": {
		"category": "activity",
		"moji": "🤾🏻",
		"unicodeVersion": "9.0",
		"digest": "8bec4de0d05c80e335e44d65598d186ca92696977353c9fd9c2a5efa122cb842"
	},
	"handball_tone2": {
		"category": "activity",
		"moji": "🤾🏼",
		"unicodeVersion": "9.0",
		"digest": "2ff4131e1e2f089b315d8e176c9348877c26c2bd03706fb75d41bc61bc99bf93"
	},
	"handball_tone3": {
		"category": "activity",
		"moji": "🤾🏽",
		"unicodeVersion": "9.0",
		"digest": "224a71f94dd37d3729325d11412334667a81422e21f6d7c008730ff350f51a80"
	},
	"handball_tone4": {
		"category": "activity",
		"moji": "🤾🏾",
		"unicodeVersion": "9.0",
		"digest": "a5f7a9db790565981bad2d0d9e09554c8c509a8179b4705a418300d58a7894b4"
	},
	"handball_tone5": {
		"category": "activity",
		"moji": "🤾🏿",
		"unicodeVersion": "9.0",
		"digest": "00404572d4683f2e8e8a494aa733e96fbec1723634d0a8cb8d75f2829a789d27"
	},
	"handshake": {
		"category": "people",
		"moji": "🤝",
		"unicodeVersion": "9.0",
		"digest": "cb4b08b70560908f96bda0aecd2f4c966bea180f9b7200e4c81d342dc8d36087"
	},
	"handshake_tone1": {
		"category": "people",
		"moji": "🤝🏻",
		"unicodeVersion": "9.0",
		"digest": "40470e224683ba375ed8698c0cbd560556be5a8898237ddf504377a3a7e89ff0"
	},
	"handshake_tone2": {
		"category": "people",
		"moji": "🤝🏼",
		"unicodeVersion": "9.0",
		"digest": "77ed378243bf682f1f4f1a8caeabcbedf772f54631cc40ea46c099e46a499b18"
	},
	"handshake_tone3": {
		"category": "people",
		"moji": "🤝🏽",
		"unicodeVersion": "9.0",
		"digest": "81b95050f0878b617f5d2640e34031c26a0072e46ca5a688eb4356e48bc74c92"
	},
	"handshake_tone4": {
		"category": "people",
		"moji": "🤝🏾",
		"unicodeVersion": "9.0",
		"digest": "74919a6f026fbbd0ccdbdbd4288d1b2ef3bda8930e9142c07736db4a7f3ef345"
	},
	"handshake_tone5": {
		"category": "people",
		"moji": "🤝🏿",
		"unicodeVersion": "9.0",
		"digest": "a30d662bfad0074ca7e32cf6f7229b643b636c4beaec496777eb7e1d5b6fc470"
	},
	"hash": {
		"category": "symbols",
		"moji": "#⃣",
		"unicodeVersion": "3.0",
		"digest": "01c8b577953010bff0c20f797c2c96ab5d98d4e6ac179c4895a78f34ea904655"
	},
	"hatched_chick": {
		"category": "nature",
		"moji": "🐥",
		"unicodeVersion": "6.0",
		"digest": "006571b9e9e839ec9fcb1a911b935c8ca71eb8bcdce9775bee6a2a4c7c927277"
	},
	"hatching_chick": {
		"category": "nature",
		"moji": "🐣",
		"unicodeVersion": "6.0",
		"digest": "fd7f69fa186407f80de59dec5116e318325a5743ee0e8bba1db541f1e57e7f74"
	},
	"head_bandage": {
		"category": "people",
		"moji": "🤕",
		"unicodeVersion": "8.0",
		"digest": "d09019a73e203b38cc43729a96163147de88e09eab8adb073888e55366854c72"
	},
	"headphones": {
		"category": "activity",
		"moji": "🎧",
		"unicodeVersion": "6.0",
		"digest": "34f9d5598158d5d6f978a5ea5c5aa9948bb2990625565a3afad7710f864fbe2f"
	},
	"hear_no_evil": {
		"category": "nature",
		"moji": "🙉",
		"unicodeVersion": "6.0",
		"digest": "53b030b6d6f4ed1a734fa7d48b46f42eb1b2b01653202c1838b742082f08c4bf"
	},
	"heart": {
		"category": "symbols",
		"moji": "❤",
		"unicodeVersion": "1.1",
		"digest": "92be652ec3e50c6e7393440b5d52b88a367f98a28dffe12660095ed3253aa6c0"
	},
	"heart_decoration": {
		"category": "symbols",
		"moji": "💟",
		"unicodeVersion": "6.0",
		"digest": "6ec5bbf3aa75c6f43eb3dc05e9204366936e8b6b4219310bacdc2fc45f51e245"
	},
	"heart_exclamation": {
		"category": "symbols",
		"moji": "❣",
		"unicodeVersion": "1.1",
		"digest": "5985ea4d82232a2a07052a59db268aed9ac943895d0c82f637595bb5386329a6"
	},
	"heart_eyes": {
		"category": "people",
		"moji": "😍",
		"unicodeVersion": "6.0",
		"digest": "0eff616517a6252ec89d47d9b4ad85589bcf2bdc7f490578934350acb84b2fcc"
	},
	"heart_eyes_cat": {
		"category": "people",
		"moji": "😻",
		"unicodeVersion": "6.0",
		"digest": "8a1f28b97d661ca4cff5ee13889ca61b5fa745ccb590e80832b7d7701df101d6"
	},
	"heartbeat": {
		"category": "symbols",
		"moji": "💓",
		"unicodeVersion": "6.0",
		"digest": "c9ec024943439d476df6f5ec3a6b30508365a7af3427671a80de3ef2f4f95ffe"
	},
	"heartpulse": {
		"category": "symbols",
		"moji": "💗",
		"unicodeVersion": "6.0",
		"digest": "281d8aebfea37db5b7fe82d9115be167006881fe29ab64a5b09ac92ac27a2309"
	},
	"hearts": {
		"category": "symbols",
		"moji": "♥",
		"unicodeVersion": "1.1",
		"digest": "271429d12c40be921897005b7bdd08f9518960af1e1e6f56bb0060f1f183651e"
	},
	"heavy_check_mark": {
		"category": "symbols",
		"moji": "✔",
		"unicodeVersion": "1.1",
		"digest": "e347728e1290eb9e7b0742d628e2fd124fc049e0774f8a6ddf8e5286e7318718"
	},
	"heavy_division_sign": {
		"category": "symbols",
		"moji": "➗",
		"unicodeVersion": "6.0",
		"digest": "c1e8c40f0788f140b1c5fcb81ed9b5ce1bcfa5988bb8140ed2808e9cb7e0d651"
	},
	"heavy_dollar_sign": {
		"category": "symbols",
		"moji": "💲",
		"unicodeVersion": "6.0",
		"digest": "7cdeef38348654b93d566e01a48973281cb404a63d0b75b3bad51032887f3f55"
	},
	"heavy_minus_sign": {
		"category": "symbols",
		"moji": "➖",
		"unicodeVersion": "6.0",
		"digest": "e5335cc6b22abdce49a6127c34269b65a4a6643ddd3253d9baac425089143e7d"
	},
	"heavy_multiplication_x": {
		"category": "symbols",
		"moji": "✖",
		"unicodeVersion": "1.1",
		"digest": "64bbe9e9716a922e405d2f6d3b6d803863a53fac80ff8cd775899971046cb1ca"
	},
	"heavy_plus_sign": {
		"category": "symbols",
		"moji": "➕",
		"unicodeVersion": "6.0",
		"digest": "d0d8ade2020ceb252205180b85c66e665856e6cb505518d395b9913b0b24b746"
	},
	"helicopter": {
		"category": "travel",
		"moji": "🚁",
		"unicodeVersion": "6.0",
		"digest": "4bd6fd13650fbe3a19cfffeffe6c21b1cda74bd6af64c5dc5999185e35444bc3"
	},
	"helmet_with_cross": {
		"category": "people",
		"moji": "⛑",
		"unicodeVersion": "5.2",
		"digest": "8286107391d44b9cd7fce5dc83bfdebbcdcf5a8214c46a8990732ec40263ed77"
	},
	"herb": {
		"category": "nature",
		"moji": "🌿",
		"unicodeVersion": "6.0",
		"digest": "9fe8ed65515ede59d0926dcf98f14e2498785e1965610aa0dd56eca9b4bedad9"
	},
	"hibiscus": {
		"category": "nature",
		"moji": "🌺",
		"unicodeVersion": "6.0",
		"digest": "c442e8eacbd8727bd154bd39692a9a2a03ea2f674b9670ad8361f78a038afe49"
	},
	"high_brightness": {
		"category": "symbols",
		"moji": "🔆",
		"unicodeVersion": "6.0",
		"digest": "35ced42426dcfd5214c2c6c577dce84bb708156433945e6b6adaff7ea530cc57"
	},
	"high_heel": {
		"category": "people",
		"moji": "👠",
		"unicodeVersion": "6.0",
		"digest": "1e7c7aba50eb1d02cf1d9aa372caca741a6005cf47f68dfa75b7310c3cb18f05"
	},
	"hockey": {
		"category": "activity",
		"moji": "🏒",
		"unicodeVersion": "8.0",
		"digest": "2d00fb17baa617e799db8e9b1771cc365bb4545c7633df0123e66e1a6e2ed25d"
	},
	"hole": {
		"category": "objects",
		"moji": "🕳",
		"unicodeVersion": "7.0",
		"digest": "8b5539f6f24f09d5d68ffd56be5aa2a8a2f753a8dfbf64892fb02c8f2703e920"
	},
	"homes": {
		"category": "travel",
		"moji": "🏘",
		"unicodeVersion": "7.0",
		"digest": "cd512f2b4ce747325607d47da48e083dbfe38a44b85b2522bc372bd105afd25f"
	},
	"honey_pot": {
		"category": "food",
		"moji": "🍯",
		"unicodeVersion": "6.0",
		"digest": "f6eec8c32fbd1b461446dc6c5d5031c43e6ee9685dc9b1ea1b839114e48c4eee"
	},
	"horse": {
		"category": "nature",
		"moji": "🐴",
		"unicodeVersion": "6.0",
		"digest": "e377649a9549835770a2a721a92570f699255f88efa646029638eb8ec5f10e3d"
	},
	"horse_racing": {
		"category": "activity",
		"moji": "🏇",
		"unicodeVersion": "6.0",
		"digest": "3b98e94e9c028ad85b9a750cc61db5ee3ac23cf5ad9243ea3e996b1f772bad54"
	},
	"horse_racing_tone1": {
		"category": "activity",
		"moji": "🏇🏻",
		"unicodeVersion": "8.0",
		"digest": "382d8e4502ed34fc1bbf1779ce483bc2e22b83f89c91746c11a5d7aea656d446"
	},
	"horse_racing_tone2": {
		"category": "activity",
		"moji": "🏇🏼",
		"unicodeVersion": "8.0",
		"digest": "198df9973b492ea63e5cfc210dd9591750ccce04a6380adc1dc5b4cb0462a8cd"
	},
	"horse_racing_tone3": {
		"category": "activity",
		"moji": "🏇🏽",
		"unicodeVersion": "8.0",
		"digest": "a67f95fc92c366750ebad3c4db92982893d67a5ed78163c8cc809ac40d2ab9a3"
	},
	"horse_racing_tone4": {
		"category": "activity",
		"moji": "🏇🏾",
		"unicodeVersion": "8.0",
		"digest": "986b1706c4a3395b58a8ae3b7609ffdd4424dfefcbf26c88c8085f4f6379734e"
	},
	"horse_racing_tone5": {
		"category": "activity",
		"moji": "🏇🏿",
		"unicodeVersion": "8.0",
		"digest": "66656b5e3d0f43f16f983f9db6214b07aac73b143eeff6475782f98aa5b9ba53"
	},
	"hospital": {
		"category": "travel",
		"moji": "🏥",
		"unicodeVersion": "6.0",
		"digest": "034573e76df444f5b0eb7aff3a4103e4b49a1813869155ab3ae29a6fc0c6c8a2"
	},
	"hot_pepper": {
		"category": "food",
		"moji": "🌶",
		"unicodeVersion": "7.0",
		"digest": "0b05777d42698196a10db17d04030175b1dfa772d06288f71d666d5f8d3fddbc"
	},
	"hotdog": {
		"category": "food",
		"moji": "🌭",
		"unicodeVersion": "8.0",
		"digest": "7a25bbd1a7531fd34a22c654c0931d9e74bea2bbe7baa9f9cbd88f43baa79fb5"
	},
	"hotel": {
		"category": "travel",
		"moji": "🏨",
		"unicodeVersion": "6.0",
		"digest": "2d78e0ad4cfb0caad778c7de49fefd6e8356afe902a43e3f1c40bceb6b0be422"
	},
	"hotsprings": {
		"category": "symbols",
		"moji": "♨",
		"unicodeVersion": "1.1",
		"digest": "4c10c3a974b44693e8cbe91365c8b8d7f14f62db234cc516b6e54c08a6bacaed"
	},
	"hourglass": {
		"category": "objects",
		"moji": "⌛",
		"unicodeVersion": "1.1",
		"digest": "f0bae8392aaf6f75a83f5d8914936b8650665b24ba1b232fa546b71545dd9acd"
	},
	"hourglass_flowing_sand": {
		"category": "objects",
		"moji": "⏳",
		"unicodeVersion": "6.0",
		"digest": "2d077729f40fc04007a933e97356bd511cbd8be76b8c55962ca3fa0d8b828e23"
	},
	"house": {
		"category": "travel",
		"moji": "🏠",
		"unicodeVersion": "6.0",
		"digest": "b4ac25979fbe161ada0d2a75769aa7552d2371d37d78cddba4ffdc7f076d3279"
	},
	"house_abandoned": {
		"category": "travel",
		"moji": "🏚",
		"unicodeVersion": "7.0",
		"digest": "6e1a58533fbfe88a0eb03668c9f17c5c654a6cc7734ed798d4a885400f823610"
	},
	"house_with_garden": {
		"category": "travel",
		"moji": "🏡",
		"unicodeVersion": "6.0",
		"digest": "817463f23ec0a849393ba75c333e822b4d253cd4db998c127e90d1b924f35d20"
	},
	"hugging": {
		"category": "people",
		"moji": "🤗",
		"unicodeVersion": "8.0",
		"digest": "69810a98b1247e1f1e496aa757e428189ef5cc086764fabd8189cf1eef82234f"
	},
	"hushed": {
		"category": "people",
		"moji": "😯",
		"unicodeVersion": "6.1",
		"digest": "22586107f7399eff64538a52929dade152633aa268fc5ec4e6fe1c0e00a7bd89"
	},
	"ice_cream": {
		"category": "food",
		"moji": "🍨",
		"unicodeVersion": "6.0",
		"digest": "d1a8e685f2ecf83dead28733859e369d6ce120a2669cdab97dc4423547d472ac"
	},
	"ice_skate": {
		"category": "activity",
		"moji": "⛸",
		"unicodeVersion": "5.2",
		"digest": "41ef65c143bc068868fa64080ffd447d91aa3fe2a39e69ecaa97022820af4dcd"
	},
	"icecream": {
		"category": "food",
		"moji": "🍦",
		"unicodeVersion": "6.0",
		"digest": "22cfe17b80cbd2a0377ee90da45bd40d33533c914b2639d363fbb1f00714e194"
	},
	"id": {
		"category": "symbols",
		"moji": "🆔",
		"unicodeVersion": "6.0",
		"digest": "bcf0922e083821d3be7951893084ea0d72a0110ef0b20d11dfec24dd70633893"
	},
	"ideograph_advantage": {
		"category": "symbols",
		"moji": "🉐",
		"unicodeVersion": "6.0",
		"digest": "0b6bf59f63fda1afa92d652814a778a056c3f4abdd9cf3f6796068bd71783051"
	},
	"imp": {
		"category": "people",
		"moji": "👿",
		"unicodeVersion": "6.0",
		"digest": "52598cf2441988f875ccb4e479637baefc679e3ca64e9a6400e56488b0fde811"
	},
	"inbox_tray": {
		"category": "objects",
		"moji": "📥",
		"unicodeVersion": "6.0",
		"digest": "d5d9497022b5318fcfbfdfcd56df9c65dd8f4a4cb5e6283ca260836df57da301"
	},
	"incoming_envelope": {
		"category": "objects",
		"moji": "📨",
		"unicodeVersion": "6.0",
		"digest": "310b7bdcca93452fe10c72c03d0aafa12b98e5d3408896d275d06d3693812c7a"
	},
	"information_desk_person": {
		"category": "people",
		"moji": "💁",
		"unicodeVersion": "6.0",
		"digest": "9f12a4a58a650e8e1d3836ef857003c3ccd42ad4203a2479eb95100bf6559064"
	},
	"information_desk_person_tone1": {
		"category": "people",
		"moji": "💁🏻",
		"unicodeVersion": "8.0",
		"digest": "6674f2e059eff7cfd7fd6abc800da37c4f1087feb4ff26c9e4e31aa29fdf9921"
	},
	"information_desk_person_tone2": {
		"category": "people",
		"moji": "💁🏼",
		"unicodeVersion": "8.0",
		"digest": "9983412ecd130b7e9cfb078167016c06fd043b6f9f3c26d21733ca3f059fd109"
	},
	"information_desk_person_tone3": {
		"category": "people",
		"moji": "💁🏽",
		"unicodeVersion": "8.0",
		"digest": "d8907bf47af5722127afca8fc0da587eab33044a6c60a94890983deb8d6f7a66"
	},
	"information_desk_person_tone4": {
		"category": "people",
		"moji": "💁🏾",
		"unicodeVersion": "8.0",
		"digest": "3be086d4edfe9ca8e4a364b4e8d09b81b5b594b5eeb9ffdf6370179fb3118658"
	},
	"information_desk_person_tone5": {
		"category": "people",
		"moji": "💁🏿",
		"unicodeVersion": "8.0",
		"digest": "2fde4e98dd11c5c29c89cad7cbb7bd2d5077dfad07913b20e01955b2d0dfad40"
	},
	"information_source": {
		"category": "symbols",
		"moji": "ℹ",
		"unicodeVersion": "3.0",
		"digest": "b6bf3cce86d42c2e3c46470baab4af01e900b8ae337b605c3da07c3eba671269"
	},
	"innocent": {
		"category": "people",
		"moji": "😇",
		"unicodeVersion": "6.0",
		"digest": "20f8d856bc3e46f4b1173cea05d4577e1c61f06b2daba46e57db90f4066bb428"
	},
	"interrobang": {
		"category": "symbols",
		"moji": "⁉",
		"unicodeVersion": "3.0",
		"digest": "92a2d5b4c0bd6714e402f6f12fe19774cb41d081b5e9c23c415ce794224d8117"
	},
	"iphone": {
		"category": "objects",
		"moji": "📱",
		"unicodeVersion": "6.0",
		"digest": "1ebc54215713cd4bf1c1e50770999f2512bb4fea29e37d0bb3a8aa2460ff875d"
	},
	"island": {
		"category": "travel",
		"moji": "🏝",
		"unicodeVersion": "7.0",
		"digest": "7f9eb5c0cd865762f7a0f187e09c1be442de7010e7c2e113d56aae998597c90d"
	},
	"izakaya_lantern": {
		"category": "objects",
		"moji": "🏮",
		"unicodeVersion": "6.0",
		"digest": "fbdc290e666d43d0776a73b955c26df4518692b35e72742e073705fc4ca2ae88"
	},
	"jack_o_lantern": {
		"category": "nature",
		"moji": "🎃",
		"unicodeVersion": "6.0",
		"digest": "78d666c2e80f64bfb6796f53e5ba4960a83ec36192110e8661031bee2b5e370a"
	},
	"japan": {
		"category": "travel",
		"moji": "🗾",
		"unicodeVersion": "6.0",
		"digest": "e7d9d6ebf9047fdd3c52e074ba259659c6d8e51a6abae3cdb8d6cf6dbf9a93fe"
	},
	"japanese_castle": {
		"category": "travel",
		"moji": "🏯",
		"unicodeVersion": "6.0",
		"digest": "938ae132c403330288223b88d28c19a47224d4f254fbc2366ecef73d9633112c"
	},
	"japanese_goblin": {
		"category": "people",
		"moji": "👺",
		"unicodeVersion": "6.0",
		"digest": "63d4bcf58b9d0c29612994432aad2ae35819fdd2890674e60a2f1d51601b742e"
	},
	"japanese_ogre": {
		"category": "people",
		"moji": "👹",
		"unicodeVersion": "6.0",
		"digest": "434ceedd102e7dcbc07e086811673dd63659ddf8c3ec4d029a3d759a0abfcbdb"
	},
	"jeans": {
		"category": "people",
		"moji": "👖",
		"unicodeVersion": "6.0",
		"digest": "f986ad32e419cca81c995f8371f0189d1490172a97ebbeac60054a1af08949c5"
	},
	"joy": {
		"category": "people",
		"moji": "😂",
		"unicodeVersion": "6.0",
		"digest": "75d7a05043523d290c46d3b313b19ed3c95271f1110bcf234cf13d4273625b08"
	},
	"joy_cat": {
		"category": "people",
		"moji": "😹",
		"unicodeVersion": "6.0",
		"digest": "a65c999604147e5e20170fcb14f80a1ff0a633f991492e1f790b2ad4caec7b7e"
	},
	"joystick": {
		"category": "objects",
		"moji": "🕹",
		"unicodeVersion": "7.0",
		"digest": "671ee588f397a96f27056a67e6a06d6e8d22c2109ec57b2859badb5fec9cf8dd"
	},
	"juggling": {
		"category": "activity",
		"moji": "🤹",
		"unicodeVersion": "9.0",
		"digest": "1f5dafa78de8b37f3df88fdf3084d2380666bd74ab2f449754d8724f6f8dbfa5"
	},
	"juggling_tone1": {
		"category": "activity",
		"moji": "🤹🏻",
		"unicodeVersion": "9.0",
		"digest": "b0b4d020148c896be69c28b08e3c486f6db270d138c7ccf4be362b29eb99878d"
	},
	"juggling_tone2": {
		"category": "activity",
		"moji": "🤹🏼",
		"unicodeVersion": "9.0",
		"digest": "cfe0c1649b2fdca03673e0e64f3a7d06d4bd49b8954c769aeb7eb88b70ec99f4"
	},
	"juggling_tone3": {
		"category": "activity",
		"moji": "🤹🏽",
		"unicodeVersion": "9.0",
		"digest": "7f87022722008bb265abe245e8157dc7a61944f5da62b3cf86f26ee1b3bdef63"
	},
	"juggling_tone4": {
		"category": "activity",
		"moji": "🤹🏾",
		"unicodeVersion": "9.0",
		"digest": "1f00da8c05582c95501cc6c3fe5ce0f9bfbc16789dcee59844a8fe7831198583"
	},
	"juggling_tone5": {
		"category": "activity",
		"moji": "🤹🏿",
		"unicodeVersion": "9.0",
		"digest": "a195bf734788eb7961c00dbc05255a49da8b9d5042fada29b26cc20393d3ce52"
	},
	"kaaba": {
		"category": "travel",
		"moji": "🕋",
		"unicodeVersion": "8.0",
		"digest": "a4618782f9583f077bd383965f1c91b9985a949bb7b6cec7af22914e7f5e9ab6"
	},
	"key": {
		"category": "objects",
		"moji": "🔑",
		"unicodeVersion": "6.0",
		"digest": "66719fa77a50a0827c8d47237e2704c03e38186e6fef80627a765473b2294c2e"
	},
	"key2": {
		"category": "objects",
		"moji": "🗝",
		"unicodeVersion": "7.0",
		"digest": "f57240a014a9da5da3d4d98c17d0a55e0ff2e5f2d22731d2fc867105cff54c6e"
	},
	"keyboard": {
		"category": "objects",
		"moji": "⌨",
		"unicodeVersion": "1.1",
		"digest": "34da8ff62ca964142f9281b80123dbba74deaac8d77fa61758c30cfb36c31386"
	},
	"kimono": {
		"category": "people",
		"moji": "👘",
		"unicodeVersion": "6.0",
		"digest": "637182590e256c8fb74ce4c0565f5180c07f06e3bdebf30138ed3259b209c27f"
	},
	"kiss": {
		"category": "people",
		"moji": "💋",
		"unicodeVersion": "6.0",
		"digest": "62f9b9ffcb01558cd5bb829344a1d1d399511663ff5235405c1f786c9416a94d"
	},
	"kiss_mm": {
		"category": "people",
		"moji": "👨‍❤️‍💋‍👨",
		"unicodeVersion": "6.0",
		"digest": "6b0ae32ecb7ec0f0f43dc7a1350711185cce114c52752395f364ddbfb4f1fff4"
	},
	"kiss_ww": {
		"category": "people",
		"moji": "👩‍❤️‍💋‍👩",
		"unicodeVersion": "6.0",
		"digest": "6de420cf752e706b1b7e9522b1b9be62eda069cb028c8fd587caf39f6a142e6a"
	},
	"kissing": {
		"category": "people",
		"moji": "😗",
		"unicodeVersion": "6.1",
		"digest": "b4a505f9e3d7fbd0ac60111f0e678cf425a5fd1abc65a3e9db59ae4abcfb8e85"
	},
	"kissing_cat": {
		"category": "people",
		"moji": "😽",
		"unicodeVersion": "6.0",
		"digest": "a00431bf10601db4998e78433279167e52cbd36aed885399482529d5cdab8636"
	},
	"kissing_closed_eyes": {
		"category": "people",
		"moji": "😚",
		"unicodeVersion": "6.0",
		"digest": "ae474db7daf80fe0b82ae1f2a11672cfcd9f9126e100f6e6d4b8a0d135dce39d"
	},
	"kissing_heart": {
		"category": "people",
		"moji": "😘",
		"unicodeVersion": "6.0",
		"digest": "bce372573bd3b347b555c1cd22087e03e650df73c8e0284ab668bf6633251632"
	},
	"kissing_smiling_eyes": {
		"category": "people",
		"moji": "😙",
		"unicodeVersion": "6.1",
		"digest": "f0f8636cb1a02b93cc72ce1b194b890fca823d91e35926b889be3ecfae79207f"
	},
	"kiwi": {
		"category": "food",
		"moji": "🥝",
		"unicodeVersion": "9.0",
		"digest": "70a3a05f333d9455d2da12eed970bc3baae416286848fed8e5dd31b5be0819be"
	},
	"knife": {
		"category": "objects",
		"moji": "🔪",
		"unicodeVersion": "6.0",
		"digest": "e6189e4843c6e80875b4952fcddb0c858f7c6039b9214bbec6a261a1358425df"
	},
	"koala": {
		"category": "nature",
		"moji": "🐨",
		"unicodeVersion": "6.0",
		"digest": "c58f7e0abae42c2218a85efed0e04151df67187815bebca7f3db6f435e0dab4d"
	},
	"koko": {
		"category": "symbols",
		"moji": "🈁",
		"unicodeVersion": "6.0",
		"digest": "5f45eb49bbf298e1fadedfe6cccc297850fcaaa4535e4cc911d48d979af55807"
	},
	"label": {
		"category": "objects",
		"moji": "🏷",
		"unicodeVersion": "7.0",
		"digest": "9550ed50cedbc56eb1bd22a8a0809d837048a33d6e2e6e7d65c50d95fa05a85d"
	},
	"large_blue_circle": {
		"category": "symbols",
		"moji": "🔵",
		"unicodeVersion": "6.0",
		"digest": "0df3fb3b09a6269459a3d9a1fe78db572190a948680844cfe758f53b6a482ff4"
	},
	"large_blue_diamond": {
		"category": "symbols",
		"moji": "🔷",
		"unicodeVersion": "6.0",
		"digest": "7f646b4e9de2788ed09e45f72cb512c269dda4989029b39bf9a2556659321651"
	},
	"large_orange_diamond": {
		"category": "symbols",
		"moji": "🔶",
		"unicodeVersion": "6.0",
		"digest": "80ae005ef9d79190c777f00de0993f8b3cb783f7051d76e971640c8c0827c338"
	},
	"last_quarter_moon": {
		"category": "nature",
		"moji": "🌗",
		"unicodeVersion": "6.0",
		"digest": "3d1f276607c685d50f4b70d00a57750a57ad9ad84256dafd2dc8eef8c72300c3"
	},
	"last_quarter_moon_with_face": {
		"category": "nature",
		"moji": "🌜",
		"unicodeVersion": "6.0",
		"digest": "d516825ba52dc67f5a01433fb9df2aa77742d38efde4225983ebc4882cbdfe5d"
	},
	"laughing": {
		"category": "people",
		"moji": "😆",
		"unicodeVersion": "6.0",
		"digest": "e9ea994b39650740c4961f070ed492d86b3acf6e6a830a6dadaa3a6872e81b81"
	},
	"leaves": {
		"category": "nature",
		"moji": "🍃",
		"unicodeVersion": "6.0",
		"digest": "56a7a0e767a6f214d340d1b5989efd99fec52c6aa306ec5c3328e32234a1631b"
	},
	"ledger": {
		"category": "objects",
		"moji": "📒",
		"unicodeVersion": "6.0",
		"digest": "e58cb714353e96a2891a5d97910ff79660e637af909b81c49c919d3735db55b4"
	},
	"left_facing_fist": {
		"category": "people",
		"moji": "🤛",
		"unicodeVersion": "9.0",
		"digest": "7861be485beefae0de341df2f21576666e22f63511a033e785752f30c07291da"
	},
	"left_facing_fist_tone1": {
		"category": "people",
		"moji": "🤛🏻",
		"unicodeVersion": "9.0",
		"digest": "2e4c4dd96b0e4b46fe0f9ce5666344d266d0f17a8544cbae73d96638d1955296"
	},
	"left_facing_fist_tone2": {
		"category": "people",
		"moji": "🤛🏼",
		"unicodeVersion": "9.0",
		"digest": "b96a63a801175ce98a75f0edad7b5574251a3fbbd894d8ab3f21aeeda366cc13"
	},
	"left_facing_fist_tone3": {
		"category": "people",
		"moji": "🤛🏽",
		"unicodeVersion": "9.0",
		"digest": "99df84635513c2ebfef24df1bd3705233e02149eef788c7b82ca0548df6f6ea5"
	},
	"left_facing_fist_tone4": {
		"category": "people",
		"moji": "🤛🏾",
		"unicodeVersion": "9.0",
		"digest": "68954842ca725aec0aa39bce4aa81aad17ac30f5f298561dfa411feb07414cd3"
	},
	"left_facing_fist_tone5": {
		"category": "people",
		"moji": "🤛🏿",
		"unicodeVersion": "9.0",
		"digest": "a419b33fae82612dc860ff48950c0547a1642d4f0c94b6547324440837d3bb21"
	},
	"left_luggage": {
		"category": "symbols",
		"moji": "🛅",
		"unicodeVersion": "6.0",
		"digest": "6625077767a51163ea20cbc299f3c13fd5ccf1b5ce365ee702ef1fef6be3dadf"
	},
	"left_right_arrow": {
		"category": "symbols",
		"moji": "↔",
		"unicodeVersion": "1.1",
		"digest": "560fcf1b794eb0d5269c73b3f8da57540cbb8a6f1a9af7a9d10b202252247e34"
	},
	"leftwards_arrow_with_hook": {
		"category": "symbols",
		"moji": "↩",
		"unicodeVersion": "1.1",
		"digest": "504714c5559b1bd35aa469be83069a923d1a25f364cac08c10df0195749e7b26"
	},
	"lemon": {
		"category": "food",
		"moji": "🍋",
		"unicodeVersion": "6.0",
		"digest": "ccca25bb6ac47770dba3aaf75144128f9a73299061969b25a35ad1733dcde5fe"
	},
	"leo": {
		"category": "symbols",
		"moji": "♌",
		"unicodeVersion": "1.1",
		"digest": "f2ed930e279699962f189e0cac519cc29d339b3e82debfdc90c5b0935a7543bb"
	},
	"leopard": {
		"category": "nature",
		"moji": "🐆",
		"unicodeVersion": "6.0",
		"digest": "d4a8964b6f2cdf6ddf074d0f1f2f65783a1a43eb4af426905fad0e60899939c7"
	},
	"level_slider": {
		"category": "objects",
		"moji": "🎚",
		"unicodeVersion": "7.0",
		"digest": "48842324f54d971ebf548a89a82ac7f29e235702081c91b477b1a92d427290e7"
	},
	"levitate": {
		"category": "activity",
		"moji": "🕴",
		"unicodeVersion": "7.0",
		"digest": "453c24bf2544ed3ef3c710a7fabbd5fdace4dc65cddd377274d30d921523b50b"
	},
	"libra": {
		"category": "symbols",
		"moji": "♎",
		"unicodeVersion": "1.1",
		"digest": "e330ba05bb449db074bc23d1514246ca5e249110f44ddb5804e5510eef6deac1"
	},
	"lifter": {
		"category": "activity",
		"moji": "🏋",
		"unicodeVersion": "7.0",
		"digest": "d6c94a32eb863d14a2a01add8ab95040f42a55d9e3f90641a0fe143d58127558"
	},
	"lifter_tone1": {
		"category": "activity",
		"moji": "🏋🏻",
		"unicodeVersion": "8.0",
		"digest": "870acf2f554fce360b58d3e98b4c0558d7ec7775587776c0f9d40c6fb1bdacf9"
	},
	"lifter_tone2": {
		"category": "activity",
		"moji": "🏋🏼",
		"unicodeVersion": "8.0",
		"digest": "1a7ece8512e42241cdd95c85ccc509bc0ff9c7c6ffaff2be343c77f417a27576"
	},
	"lifter_tone3": {
		"category": "activity",
		"moji": "🏋🏽",
		"unicodeVersion": "8.0",
		"digest": "4bc633ee82a0fb59feba379fb6901a489e4ac849d758f9c8e7a1a0a26eaa380c"
	},
	"lifter_tone4": {
		"category": "activity",
		"moji": "🏋🏾",
		"unicodeVersion": "8.0",
		"digest": "d086fe5577b5ba80676f2224d886f8ebe4588314f429f12a34c52c971ed71b5c"
	},
	"lifter_tone5": {
		"category": "activity",
		"moji": "🏋🏿",
		"unicodeVersion": "8.0",
		"digest": "79b0edf6ce1fd024dd7f458e322ad8588af0b789a04cc1cf38380dc8b9c76f55"
	},
	"light_rail": {
		"category": "travel",
		"moji": "🚈",
		"unicodeVersion": "6.0",
		"digest": "2f30b23a738371690b2f00d96ddb5ceb90a1442b5478754626a3dfa263ed2fc1"
	},
	"link": {
		"category": "objects",
		"moji": "🔗",
		"unicodeVersion": "6.0",
		"digest": "7bf567aabd1fc38b3d70422f9db3a13b50950cf6207e70962c9938827c196ccb"
	},
	"lion_face": {
		"category": "nature",
		"moji": "🦁",
		"unicodeVersion": "8.0",
		"digest": "dd24f2668e973ec973e97dc111f59a2cc14e9b608387401191dd53368d28d4fa"
	},
	"lips": {
		"category": "people",
		"moji": "👄",
		"unicodeVersion": "6.0",
		"digest": "8740d8086525c7a836d64625a6915cc1c59af69ba143456dbb59e0179276895e"
	},
	"lipstick": {
		"category": "people",
		"moji": "💄",
		"unicodeVersion": "6.0",
		"digest": "751dcb22706a796033b13a2ccb94304236ec13207ad4d011e02d230ae33ab5c1"
	},
	"lizard": {
		"category": "nature",
		"moji": "🦎",
		"unicodeVersion": "9.0",
		"digest": "fb9191f9eab58b8403d4c4626ccbb14ba05c1f6944011751a8edcc4dd03c66e6"
	},
	"lock": {
		"category": "objects",
		"moji": "🔒",
		"unicodeVersion": "6.0",
		"digest": "043b4fc0b8c79d47a07d91308e628e1ac262aea6c1ec05e6b84bf7bcdf89dc83"
	},
	"lock_with_ink_pen": {
		"category": "objects",
		"moji": "🔏",
		"unicodeVersion": "6.0",
		"digest": "7b5e959b26cf7296c7b230fc2be9feb9e38391c5001951a019d16b169a71aba9"
	},
	"lollipop": {
		"category": "food",
		"moji": "🍭",
		"unicodeVersion": "6.0",
		"digest": "17b6a0df47ec758a2f9c087b46a6902cee344d39407ef4c321e408505cbb72ca"
	},
	"loop": {
		"category": "symbols",
		"moji": "➿",
		"unicodeVersion": "6.0",
		"digest": "9f20ecc34b3c871789ba7d0712aa31e7a74b6c1558ac8bea385bc40590056726"
	},
	"loud_sound": {
		"category": "symbols",
		"moji": "🔊",
		"unicodeVersion": "6.0",
		"digest": "64b12db9ddd8adf74a9fc2bd83c7979ea865113347f7ce8666e9ccf5019e715f"
	},
	"loudspeaker": {
		"category": "symbols",
		"moji": "📢",
		"unicodeVersion": "6.0",
		"digest": "1e1f35d16dd2898ebaa6f2b2868203df6e09c8a70df069c92d6d1b5cb2ac0976"
	},
	"love_hotel": {
		"category": "travel",
		"moji": "🏩",
		"unicodeVersion": "6.0",
		"digest": "ff8966a50fd47a216855488eb09a367d231fea21f49e7e5325191d32fb494473"
	},
	"love_letter": {
		"category": "objects",
		"moji": "💌",
		"unicodeVersion": "6.0",
		"digest": "037261c8ca4d72f7205e51664591696da2ae7ceb19f1c1c9f6123da5a5979d29"
	},
	"low_brightness": {
		"category": "symbols",
		"moji": "🔅",
		"unicodeVersion": "6.0",
		"digest": "a065d00a416e297c168b0a675cafcf492fedf94865cb21801a1be5a3914593d4"
	},
	"lying_face": {
		"category": "people",
		"moji": "🤥",
		"unicodeVersion": "9.0",
		"digest": "ce836170165e1b70938273f289c02c2106873cd9ab5472dbcd487c2f9f53f13d"
	},
	"m": {
		"category": "symbols",
		"moji": "Ⓜ",
		"unicodeVersion": "1.1",
		"digest": "54588ac2b7fcd53a96f17124e9de69b617613fcd5af9ad2930a094cb795bb9f4"
	},
	"mag": {
		"category": "objects",
		"moji": "🔍",
		"unicodeVersion": "6.0",
		"digest": "a6e31a2efa7d9427aaa30b45d9f4181ee55c44be08aea2df165a86e0e6d9eaa1"
	},
	"mag_right": {
		"category": "objects",
		"moji": "🔎",
		"unicodeVersion": "6.0",
		"digest": "c7d8ceeb05db261e5eaab31dc4da432d0d5592a2ed71e526c5a542daa230bbaf"
	},
	"mahjong": {
		"category": "symbols",
		"moji": "🀄",
		"unicodeVersion": "5.1",
		"digest": "755d69f988434ce1c17531a8b7ac92ead6f5607c2635a22f10e0ad70f09fc3e6"
	},
	"mailbox": {
		"category": "objects",
		"moji": "📫",
		"unicodeVersion": "6.0",
		"digest": "2069091be90a530a43ef29d5ec7688c351bf4d5b08d63a0d20d72b67d639ec62"
	},
	"mailbox_closed": {
		"category": "objects",
		"moji": "📪",
		"unicodeVersion": "6.0",
		"digest": "d88d65bfebb8216535fd055c69f319564b2cf0b0901820f8312f581864557ed4"
	},
	"mailbox_with_mail": {
		"category": "objects",
		"moji": "📬",
		"unicodeVersion": "6.0",
		"digest": "69e966b4659128991a70c6a2dd4d647551bedb91bdf5ce688958686bbec56381"
	},
	"mailbox_with_no_mail": {
		"category": "objects",
		"moji": "📭",
		"unicodeVersion": "6.0",
		"digest": "9e92d8ee88f660ce56da61077c80ec26c5d8f54ebd2306c4cfa16f6c1b981f83"
	},
	"man": {
		"category": "people",
		"moji": "👨",
		"unicodeVersion": "6.0",
		"digest": "42b882d2c6aa095f1afcf901203838d95c1908bdc725519779186b9c33c728d7"
	},
	"man_dancing": {
		"category": "people",
		"moji": "🕺",
		"unicodeVersion": "9.0",
		"digest": "9f632ee0c886d5f03c61e5f3a27668262c0cc2693b857a91c23c1e5ea3785b9e"
	},
	"man_dancing_tone1": {
		"category": "activity",
		"moji": "🕺🏻",
		"unicodeVersion": "9.0",
		"digest": "6c56a16cb105bcdd97472645b3a351cebdbb1132cbfd18b0118f289db5fbe741"
	},
	"man_dancing_tone2": {
		"category": "activity",
		"moji": "🕺🏼",
		"unicodeVersion": "9.0",
		"digest": "ed7e78c14d205a03fdd5581e5213add69a55e13b4cbaf76a6d5a0d6c80f53327"
	},
	"man_dancing_tone3": {
		"category": "activity",
		"moji": "🕺🏽",
		"unicodeVersion": "9.0",
		"digest": "13b45403e11800163406206eedeb8b579cc83eca2f60246be97e099164387bc8"
	},
	"man_dancing_tone4": {
		"category": "activity",
		"moji": "🕺🏾",
		"unicodeVersion": "9.0",
		"digest": "f6feb1b0b83565fadcdd1a8737d3daa08893e919547d2a06de899160162d9c4a"
	},
	"man_dancing_tone5": {
		"category": "activity",
		"moji": "🕺🏿",
		"unicodeVersion": "9.0",
		"digest": "fe20a9ed9ba991653b4d0683de347ed7c226a5d75610307584a2ddd6fcd1e3f2"
	},
	"man_in_tuxedo": {
		"category": "people",
		"moji": "🤵",
		"unicodeVersion": "9.0",
		"digest": "4d451a971dfefedc4830ba78e19b123f250e09ae65baddccdc56c0f8aa3a9b50"
	},
	"man_in_tuxedo_tone1": {
		"category": "people",
		"moji": "🤵🏻",
		"unicodeVersion": "9.0",
		"digest": "2814833334fb211ae2ecb1fb5964e9752282d0fb4d7f3477de5dd2a4f812a793"
	},
	"man_in_tuxedo_tone2": {
		"category": "people",
		"moji": "🤵🏼",
		"unicodeVersion": "9.0",
		"digest": "cd1bab9ee0e2335d3cd99d51216cccdc4fc3c2cf20129b8b7e11a51a77258f68"
	},
	"man_in_tuxedo_tone3": {
		"category": "people",
		"moji": "🤵🏽",
		"unicodeVersion": "9.0",
		"digest": "f387775f925fe60b9f3e7cad63a55d4d196ddd41658029a70440d14c17cb99f9"
	},
	"man_in_tuxedo_tone4": {
		"category": "people",
		"moji": "🤵🏾",
		"unicodeVersion": "9.0",
		"digest": "08debd7a573d1201aee8a2f281ef7cb638d4a2a096222150391f36963f07c622"
	},
	"man_in_tuxedo_tone5": {
		"category": "people",
		"moji": "🤵🏿",
		"unicodeVersion": "9.0",
		"digest": "e3b10e0619f0911cf9b665a265f4ef829b8f6ba6e9c3a021d0539a27e315f8fe"
	},
	"man_tone1": {
		"category": "people",
		"moji": "👨🏻",
		"unicodeVersion": "8.0",
		"digest": "7053e265fa7d2594de54a6c5d06c21795b9a7dfb36a1c5594ca43c4c6cc56504"
	},
	"man_tone2": {
		"category": "people",
		"moji": "👨🏼",
		"unicodeVersion": "8.0",
		"digest": "7ebc64de40d3ac60fb761be5cf94f53fa10b4f03fb66add46c90f5d98eaf71eb"
	},
	"man_tone3": {
		"category": "people",
		"moji": "👨🏽",
		"unicodeVersion": "8.0",
		"digest": "77ceef4d3740ed4751acb83dd45b6b754cf625c522c6757309cd4d61202d7149"
	},
	"man_tone4": {
		"category": "people",
		"moji": "👨🏾",
		"unicodeVersion": "8.0",
		"digest": "41e6037c393f61cca61b9a81b27ed14a95d75fe380e3a00153c33a371a836ffd"
	},
	"man_tone5": {
		"category": "people",
		"moji": "👨🏿",
		"unicodeVersion": "8.0",
		"digest": "a8cebfd39a5b9c79af7cc37f205e1135376056fee287af967c9f55d415572d99"
	},
	"man_with_gua_pi_mao": {
		"category": "people",
		"moji": "👲",
		"unicodeVersion": "6.0",
		"digest": "3dae285e900c69986a48db0fa89d4f371a49f38608059cdae52be098030c5ac4"
	},
	"man_with_gua_pi_mao_tone1": {
		"category": "people",
		"moji": "👲🏻",
		"unicodeVersion": "8.0",
		"digest": "35404d8e266920c78edd9e7143fb052b42f65242a5698494c4f4365e9183cc67"
	},
	"man_with_gua_pi_mao_tone2": {
		"category": "people",
		"moji": "👲🏼",
		"unicodeVersion": "8.0",
		"digest": "82d4f968665a93c7543372c8a1eeb0f25d0ea6842d5e518bd91c226c6c3ab8c2"
	},
	"man_with_gua_pi_mao_tone3": {
		"category": "people",
		"moji": "👲🏽",
		"unicodeVersion": "8.0",
		"digest": "f44159f0c672b9b833449382896180e799abf574f5b3c6cd9541caa992fa18ce"
	},
	"man_with_gua_pi_mao_tone4": {
		"category": "people",
		"moji": "👲🏾",
		"unicodeVersion": "8.0",
		"digest": "c79060188f9461ca34eaa225b7682d8c410883609509fb731c992db69bfeeb50"
	},
	"man_with_gua_pi_mao_tone5": {
		"category": "people",
		"moji": "👲🏿",
		"unicodeVersion": "8.0",
		"digest": "de9e4acdb10f7abddeeabc0b48d91139fc8b544a601c530db811f099991b0d38"
	},
	"man_with_turban": {
		"category": "people",
		"moji": "👳",
		"unicodeVersion": "6.0",
		"digest": "db72c944e93983f38d00e3e936ebb5b243c6069f1f1236d46f6a9f1beb8d6634"
	},
	"man_with_turban_tone1": {
		"category": "people",
		"moji": "👳🏻",
		"unicodeVersion": "8.0",
		"digest": "b6d7489c4cd151af09fff48b62c54c336303e14866e6ef38f94cd834b085d09e"
	},
	"man_with_turban_tone2": {
		"category": "people",
		"moji": "👳🏼",
		"unicodeVersion": "8.0",
		"digest": "7854ef973c21847f452d7e78e5c460ea300e12b539ce92c69dabe8f1bf3a4382"
	},
	"man_with_turban_tone3": {
		"category": "people",
		"moji": "👳🏽",
		"unicodeVersion": "8.0",
		"digest": "1dbd9bd78f5263cbadee7d0d5754c14cfbc914f7329e25fbd97d9f5b8ce0737e"
	},
	"man_with_turban_tone4": {
		"category": "people",
		"moji": "👳🏾",
		"unicodeVersion": "8.0",
		"digest": "4f4804da4a7c98ad4f9db3ae3eaf674c8977c638e73414e33ef1f65098e413a3"
	},
	"man_with_turban_tone5": {
		"category": "people",
		"moji": "👳🏿",
		"unicodeVersion": "8.0",
		"digest": "240282aa346ef9b1d0d475ea93a02597697f0f56f086305879b532b0b933210a"
	},
	"mans_shoe": {
		"category": "people",
		"moji": "👞",
		"unicodeVersion": "6.0",
		"digest": "f53fe74abd9906cd3e2dd7e7bddbe1feb9f8f7be28b807fabe452f1f60ca1b84"
	},
	"map": {
		"category": "objects",
		"moji": "🗺",
		"unicodeVersion": "7.0",
		"digest": "84f496a062b5c3ae1e8013506175a69036038c8130891bcf780a69ce7fcbe4de"
	},
	"maple_leaf": {
		"category": "nature",
		"moji": "🍁",
		"unicodeVersion": "6.0",
		"digest": "72629a205e33f89337815ad7e51bb5c73947d1a9f98afe5072bdf4846827ae72"
	},
	"martial_arts_uniform": {
		"category": "activity",
		"moji": "🥋",
		"unicodeVersion": "9.0",
		"digest": "a1ae797b31081425b388ab31efc635d8eb73a40980fd0fae4708aa5313e2a964"
	},
	"mask": {
		"category": "people",
		"moji": "😷",
		"unicodeVersion": "6.0",
		"digest": "1b58af9ae599308aabf41bbd38f599fa896bd9fe5df7a40be9f2dc7e0e230600"
	},
	"massage": {
		"category": "people",
		"moji": "💆",
		"unicodeVersion": "6.0",
		"digest": "6ee48b4d8cec0bf31e11d7803ad9fc1f909457c8c00cb320b5671395af3c170c"
	},
	"massage_tone1": {
		"category": "people",
		"moji": "💆🏻",
		"unicodeVersion": "8.0",
		"digest": "9da162c2f39628156b87db986a6ada59372a9e9a6b3f0488d21c9e65ec3309bb"
	},
	"massage_tone2": {
		"category": "people",
		"moji": "💆🏼",
		"unicodeVersion": "8.0",
		"digest": "ac259188549b5b429b8c4929e1da2314859e8857ee49720551467aedfcc96567"
	},
	"massage_tone3": {
		"category": "people",
		"moji": "💆🏽",
		"unicodeVersion": "8.0",
		"digest": "cfd9c105b6debc10448f172afcb20d4192899f7ae5aa8af54c834153a5466364"
	},
	"massage_tone4": {
		"category": "people",
		"moji": "💆🏾",
		"unicodeVersion": "8.0",
		"digest": "38ab715c621c58454f3cb09153a96380118cf082568554b6edc5f83fb62e9297"
	},
	"massage_tone5": {
		"category": "people",
		"moji": "💆🏿",
		"unicodeVersion": "8.0",
		"digest": "32480457734121b0c83e9be6d693ae379c95535f43f963c0c2f0f20434ee12c6"
	},
	"meat_on_bone": {
		"category": "food",
		"moji": "🍖",
		"unicodeVersion": "6.0",
		"digest": "d71a8e0b118d5e6ca60690793ce9649afb78e707fcbd7be890a75564c94434fd"
	},
	"medal": {
		"category": "activity",
		"moji": "🏅",
		"unicodeVersion": "7.0",
		"digest": "9600cbe57e08da090c60629bcafd2821c87322e738c2454f8e883ceb756e7391"
	},
	"mega": {
		"category": "symbols",
		"moji": "📣",
		"unicodeVersion": "6.0",
		"digest": "4b1def6b5b051c5045514063f0ac006222ad81fbfe56d840e14bb950713e331b"
	},
	"melon": {
		"category": "food",
		"moji": "🍈",
		"unicodeVersion": "6.0",
		"digest": "0cdd663e6f2129808856cdf0746e6571b62aac641f224adb553baf3bb63ba3bd"
	},
	"menorah": {
		"category": "symbols",
		"moji": "🕎",
		"unicodeVersion": "8.0",
		"digest": "49fca8c3bc00ea69653ee2f8d4e21e561856ba39716c13e9d107db3e805a2997"
	},
	"mens": {
		"category": "symbols",
		"moji": "🚹",
		"unicodeVersion": "6.0",
		"digest": "7d92292586ee12a5d1a557c37da4d14708dc3ce701cf32d3280dcc83d91e5df8"
	},
	"metal": {
		"category": "people",
		"moji": "🤘",
		"unicodeVersion": "8.0",
		"digest": "ffb750caf187f5d821c990108e2699ac3e216492bcff6ee543f4a7aa55b9fd29"
	},
	"metal_tone1": {
		"category": "people",
		"moji": "🤘🏻",
		"unicodeVersion": "8.0",
		"digest": "5505f0b0340f9ba572db8897e40adf598cfa784686ad5ee360a7351bf44ddc1d"
	},
	"metal_tone2": {
		"category": "people",
		"moji": "🤘🏼",
		"unicodeVersion": "8.0",
		"digest": "8f9eee3ad5fc7eeeb30118d16d27467b16fd87297e0ecf02656db77e701f5aeb"
	},
	"metal_tone3": {
		"category": "people",
		"moji": "🤘🏽",
		"unicodeVersion": "8.0",
		"digest": "8270a7ecf5eb11431a07ef04cc476c2651ac8aacb0d4768e5cb69355f8a5e84e"
	},
	"metal_tone4": {
		"category": "people",
		"moji": "🤘🏾",
		"unicodeVersion": "8.0",
		"digest": "f24f7b137dd6c7899dc0a8794204bbde7ad43ec1e63b419c90dd70a8b77871e8"
	},
	"metal_tone5": {
		"category": "people",
		"moji": "🤘🏿",
		"unicodeVersion": "8.0",
		"digest": "07b0726a632653b980df775f460cd3fe1ea8d4a7b0b46fe29e089b66579482d2"
	},
	"metro": {
		"category": "travel",
		"moji": "🚇",
		"unicodeVersion": "6.0",
		"digest": "b380247b61b5e2ca1b9b70fabff65907b2c3a5191a14b169ae094af94659b9b1"
	},
	"microphone": {
		"category": "activity",
		"moji": "🎤",
		"unicodeVersion": "6.0",
		"digest": "9ef4fc2e40d5391c4bb2d30f34f59662cff7cbb1b04341c9dac210d0e21b44ae"
	},
	"microphone2": {
		"category": "objects",
		"moji": "🎙",
		"unicodeVersion": "7.0",
		"digest": "8a30464d51f7f101335778444c43270ac0679900f49463e6556682d9db1cb4dc"
	},
	"microscope": {
		"category": "objects",
		"moji": "🔬",
		"unicodeVersion": "6.0",
		"digest": "4ca4322c6ba99b8c15acdb8b605f84f87398769e504b262b134c1f3868b2692f"
	},
	"middle_finger": {
		"category": "people",
		"moji": "🖕",
		"unicodeVersion": "7.0",
		"digest": "0c3f1cc0ec7323f6d19508ad22fa90050845f7b5cc83f599ab2cacb89cf5dd0e"
	},
	"middle_finger_tone1": {
		"category": "people",
		"moji": "🖕🏻",
		"unicodeVersion": "8.0",
		"digest": "4ebecf1058a3059aaa826eaad39c1a791120f115f65dde6d6ae32fc5561f60f7"
	},
	"middle_finger_tone2": {
		"category": "people",
		"moji": "🖕🏼",
		"unicodeVersion": "8.0",
		"digest": "85ff506a08c38663c2dfa2e3a90584c02a36aa3dda33af47cdb49834bf9baf83"
	},
	"middle_finger_tone3": {
		"category": "people",
		"moji": "🖕🏽",
		"unicodeVersion": "8.0",
		"digest": "cac697ff5207bf8a4e091912f3127f4e73c88ef69b5c6561d1d7b12ed60be8f1"
	},
	"middle_finger_tone4": {
		"category": "people",
		"moji": "🖕🏾",
		"unicodeVersion": "8.0",
		"digest": "9324a5a4e3986b798ad8c61f31c18fb507ca7a4abfd6e9ae1408b80b185bf8c7"
	},
	"middle_finger_tone5": {
		"category": "people",
		"moji": "🖕🏿",
		"unicodeVersion": "8.0",
		"digest": "078f917cd4d8be08a880724e9400449980d92740ccbee4a57f5046a9cf7f6575"
	},
	"military_medal": {
		"category": "activity",
		"moji": "🎖",
		"unicodeVersion": "7.0",
		"digest": "5da18351dc14b66cfc070148c83b7c8e67e6b1e3f515ae501133c38ee5c28d3d"
	},
	"milk": {
		"category": "food",
		"moji": "🥛",
		"unicodeVersion": "9.0",
		"digest": "38b28ea40399601fabc95bac5eaaf5a9e4e25548ec80325bd5069395ea884f85"
	},
	"milky_way": {
		"category": "travel",
		"moji": "🌌",
		"unicodeVersion": "6.0",
		"digest": "17405ff31d94b13a1fb0adcda204b8adb95ca340bc3980d9ad9f42ba1e366e7d"
	},
	"minibus": {
		"category": "travel",
		"moji": "🚐",
		"unicodeVersion": "6.0",
		"digest": "08ccb4b1bf397b7c9aed901e2b5dcdd6cb8ca5c5487ef26775bb3120f7b92524"
	},
	"minidisc": {
		"category": "objects",
		"moji": "💽",
		"unicodeVersion": "6.0",
		"digest": "bebf82c0b91ef66321e7ae7a0abf322e59b2f7d8e6fbf9a94243210c00229c59"
	},
	"mobile_phone_off": {
		"category": "symbols",
		"moji": "📴",
		"unicodeVersion": "6.0",
		"digest": "6f9d8d6a32fc998f5d8144a5ff7e2ad00de37ad464cd97285e7c72efb09a1feb"
	},
	"money_mouth": {
		"category": "people",
		"moji": "🤑",
		"unicodeVersion": "8.0",
		"digest": "5a43973dadf48a89201b1816fea9972c5cfe501a26fe457b6f7eee0a6362018e"
	},
	"money_with_wings": {
		"category": "objects",
		"moji": "💸",
		"unicodeVersion": "6.0",
		"digest": "15fcf0595021374ba091ca00efdb4167770da4d421eab930964108545f4edab9"
	},
	"moneybag": {
		"category": "objects",
		"moji": "💰",
		"unicodeVersion": "6.0",
		"digest": "02d708e2f603b0df6f6c169b5c49b3452e1c02e7d72e96f228b73d0b0a20bff4"
	},
	"monkey": {
		"category": "nature",
		"moji": "🐒",
		"unicodeVersion": "6.0",
		"digest": "3588a544d6d9e9995b45d60327a1a42002fa1faa4d48224b140facd249af1c67"
	},
	"monkey_face": {
		"category": "nature",
		"moji": "🐵",
		"unicodeVersion": "6.0",
		"digest": "9e263ef5ca42bb76d1b1d1e3cbf020bcf05023a6e9f91301d30c9eb406363a2a"
	},
	"monorail": {
		"category": "travel",
		"moji": "🚝",
		"unicodeVersion": "6.0",
		"digest": "2c9f185babcb4001fcef2b8dfc4a32126729843084d0076c3e3ccdc845ab23ad"
	},
	"mortar_board": {
		"category": "people",
		"moji": "🎓",
		"unicodeVersion": "6.0",
		"digest": "d7fbe41d4b340d3564e484aec46a22c9613521414b2ba6eece2180db4d23e410"
	},
	"mosque": {
		"category": "travel",
		"moji": "🕌",
		"unicodeVersion": "8.0",
		"digest": "5f3d3de7feac953a70a318113531c2857d760a516c3d8d6f42d2a3b3b67ed196"
	},
	"motor_scooter": {
		"category": "travel",
		"moji": "🛵",
		"unicodeVersion": "9.0",
		"digest": "e2dc7c981744a71f46858bd0858ff91af704ac06425ed80377bc3b119e57c872"
	},
	"motorboat": {
		"category": "travel",
		"moji": "🛥",
		"unicodeVersion": "7.0",
		"digest": "81c156643528c5a94a12d6d478e52a019f5a4e3eb58ee365cdd9d2361a7fdb01"
	},
	"motorcycle": {
		"category": "travel",
		"moji": "🏍",
		"unicodeVersion": "7.0",
		"digest": "354aa8157732184ad50eff9330f7a8915309dc9b7893cc308226adb429311a62"
	},
	"motorway": {
		"category": "travel",
		"moji": "🛣",
		"unicodeVersion": "7.0",
		"digest": "148c3c13c7c4565453d16e504e0d4b8d007e4f2cad1ab56b1b51fefe39162d17"
	},
	"mount_fuji": {
		"category": "travel",
		"moji": "🗻",
		"unicodeVersion": "6.0",
		"digest": "f8093b9dba62b22c6c88f137be88b2fd3971c560714db15ec053cf697a3820bc"
	},
	"mountain": {
		"category": "travel",
		"moji": "⛰",
		"unicodeVersion": "5.2",
		"digest": "07423804ad79da68f140948d29df193f5d5343b7b2c23758c086697c4d3a50da"
	},
	"mountain_bicyclist": {
		"category": "activity",
		"moji": "🚵",
		"unicodeVersion": "6.0",
		"digest": "91084b6c887cb7e34f3d7ec30656ecb82c36cc987f53a6c83ccb4c6f7950f96a"
	},
	"mountain_bicyclist_tone1": {
		"category": "activity",
		"moji": "🚵🏻",
		"unicodeVersion": "8.0",
		"digest": "5d57fcfad61bca26c3e8965eb57602a1993a3117ebdda0f24569af730310ab6e"
	},
	"mountain_bicyclist_tone2": {
		"category": "activity",
		"moji": "🚵🏼",
		"unicodeVersion": "8.0",
		"digest": "c0da7fb85d99aa01a665f64063cd7e2d994f8a16d3f6fbf52df5d471e771a98a"
	},
	"mountain_bicyclist_tone3": {
		"category": "activity",
		"moji": "🚵🏽",
		"unicodeVersion": "8.0",
		"digest": "b099e7ee84eae44ebc99023fa06bdf37ffa0d69767c7c0163a89f7ced2a26765"
	},
	"mountain_bicyclist_tone4": {
		"category": "activity",
		"moji": "🚵🏾",
		"unicodeVersion": "8.0",
		"digest": "9d09f7b3899ea44e736f237a161ef8d5170dccfa162a872c59532ceaf65ee007"
	},
	"mountain_bicyclist_tone5": {
		"category": "activity",
		"moji": "🚵🏿",
		"unicodeVersion": "8.0",
		"digest": "71e374981d955056748a60c6d1820b45e9688a156b55318b4ea54a3a67ca801c"
	},
	"mountain_cableway": {
		"category": "travel",
		"moji": "🚠",
		"unicodeVersion": "6.0",
		"digest": "e261c3292758b1c0063c5a0d0c7f5c9803306d2265e08677027e1210506ced94"
	},
	"mountain_railway": {
		"category": "travel",
		"moji": "🚞",
		"unicodeVersion": "6.0",
		"digest": "b0987f8f391b3cbc7a56b9b8945ebfca240e01d12f8fd163877ebebe51d6b277"
	},
	"mountain_snow": {
		"category": "travel",
		"moji": "🏔",
		"unicodeVersion": "7.0",
		"digest": "49aac2b851aa6f2bd2ca641efa8060f93e89395357f49d211658d46f5a2b0189"
	},
	"mouse": {
		"category": "nature",
		"moji": "🐭",
		"unicodeVersion": "6.0",
		"digest": "007dd108507b45224f7a1fad3c1de6ecc75f38d71fc142744611eb13555f5eff"
	},
	"mouse2": {
		"category": "nature",
		"moji": "🐁",
		"unicodeVersion": "6.0",
		"digest": "f3ed37b639b7c16aae49502bd423f9fdeabaf15bc6f0f74063954b189e176b5d"
	},
	"mouse_three_button": {
		"category": "objects",
		"moji": "🖱",
		"unicodeVersion": "7.0",
		"digest": "3724341ac5ad0d01027ef1575db64f1db7619f590ca6ada960d1f2c18dc7fc6a"
	},
	"movie_camera": {
		"category": "objects",
		"moji": "🎥",
		"unicodeVersion": "6.0",
		"digest": "f7e285eda35b4431c07951e071643ddc34147cd76640e0d516fbfd11208346e9"
	},
	"moyai": {
		"category": "objects",
		"moji": "🗿",
		"unicodeVersion": "6.0",
		"digest": "2c1d0662c95928936e6b9ab5a40c6110ff1cea5339f2803c7b63aabc76115afb"
	},
	"mrs_claus": {
		"category": "people",
		"moji": "🤶",
		"unicodeVersion": "9.0",
		"digest": "1f72f586ca75bd7ebb4150cdcc8199a930c32fa4b81510cb8d200f1b3ddd4076"
	},
	"mrs_claus_tone1": {
		"category": "people",
		"moji": "🤶🏻",
		"unicodeVersion": "9.0",
		"digest": "244596919e0fed050203cf9e040899de323d7821235929f175852439927bd129"
	},
	"mrs_claus_tone2": {
		"category": "people",
		"moji": "🤶🏼",
		"unicodeVersion": "9.0",
		"digest": "8cde96e8521f3a90262a7f5f8a2989a9590d9a02cda2c37e92335dc05975c18d"
	},
	"mrs_claus_tone3": {
		"category": "people",
		"moji": "🤶🏽",
		"unicodeVersion": "9.0",
		"digest": "c39cd4346d4581799dd0e9a6447c91a954a75747bf2682c8e4d79c3b0fcf7405"
	},
	"mrs_claus_tone4": {
		"category": "people",
		"moji": "🤶🏾",
		"unicodeVersion": "9.0",
		"digest": "84c85cf54559ea2d78d196fee96149a249af4f959b78e223a0ec4fb72abdbcab"
	},
	"mrs_claus_tone5": {
		"category": "people",
		"moji": "🤶🏿",
		"unicodeVersion": "9.0",
		"digest": "ce26c0e0645713b17e7497d9f2d0484cc5477564dae99320cabf04d160d3b2ff"
	},
	"muscle": {
		"category": "people",
		"moji": "💪",
		"unicodeVersion": "6.0",
		"digest": "e4ce52757b2b7982e2516e0e8bf2e2253617cc9f3e6178f1887c61c9039461ba"
	},
	"muscle_tone1": {
		"category": "people",
		"moji": "💪🏻",
		"unicodeVersion": "8.0",
		"digest": "4a2fa226a05bb847b62cdd163eb6c2d514d3c2330a727991cf550c0d32b0e818"
	},
	"muscle_tone2": {
		"category": "people",
		"moji": "💪🏼",
		"unicodeVersion": "8.0",
		"digest": "a8d5ecce335c782ca5f5e55763c06cfefa1c16c24cd6602237cf125d4ff95e47"
	},
	"muscle_tone3": {
		"category": "people",
		"moji": "💪🏽",
		"unicodeVersion": "8.0",
		"digest": "070354b443faec3969663b770545fc4cf5ec75148557b2b9d6fc82ab22b43bd1"
	},
	"muscle_tone4": {
		"category": "people",
		"moji": "💪🏾",
		"unicodeVersion": "8.0",
		"digest": "8eafcdb6a607aeafa673c257df0d2a1b20f00fc0868d811babcbe784490a0dd3"
	},
	"muscle_tone5": {
		"category": "people",
		"moji": "💪🏿",
		"unicodeVersion": "8.0",
		"digest": "85a1e2b5c89907694240e9c5b9d876a741fa7ba38918c5718273e289cbc40efe"
	},
	"mushroom": {
		"category": "nature",
		"moji": "🍄",
		"unicodeVersion": "6.0",
		"digest": "aaca8cf7c5cfa4487b5fef365a231f98be4bbf041197fc022161bcc8ce6f57c8"
	},
	"musical_keyboard": {
		"category": "activity",
		"moji": "🎹",
		"unicodeVersion": "6.0",
		"digest": "fb0a726728900377d76d94aac9c94dce29107e8e3f1dcb0599d95bce7169b492"
	},
	"musical_note": {
		"category": "symbols",
		"moji": "🎵",
		"unicodeVersion": "6.0",
		"digest": "41288e79b4070bb980281d0e0d1c14d8b144b4aedb2eaadb9f2bebcb4ef892b4"
	},
	"musical_score": {
		"category": "activity",
		"moji": "🎼",
		"unicodeVersion": "6.0",
		"digest": "f0f91b9fa4a2bff7a5a1a11afa6f31cfe7e5fa8b0d6f3cce904b781a28ed0277"
	},
	"mute": {
		"category": "symbols",
		"moji": "🔇",
		"unicodeVersion": "6.0",
		"digest": "def277da49d744b55c7cdde269a15aa05315898f615e721ee7e9205d7b8030d6"
	},
	"nail_care": {
		"category": "people",
		"moji": "💅",
		"unicodeVersion": "6.0",
		"digest": "48b33b1dbbd25b4f34ab2ca07bb99ddaaaa741990142c5623310f76b78c076f9"
	},
	"nail_care_tone1": {
		"category": "people",
		"moji": "💅🏻",
		"unicodeVersion": "8.0",
		"digest": "a9ac92a34f407e7dd7c71377e6275e66657f7f42e4b911c540d1a66a02d92ac5"
	},
	"nail_care_tone2": {
		"category": "people",
		"moji": "💅🏼",
		"unicodeVersion": "8.0",
		"digest": "f295ec85980aaa75818fad619c3d25042146ecbbf361db9e9bb96e7bc202bc73"
	},
	"nail_care_tone3": {
		"category": "people",
		"moji": "💅🏽",
		"unicodeVersion": "8.0",
		"digest": "02ec373052a250977298bae85262177910126cc10de9480f1afa328ac2f65a95"
	},
	"nail_care_tone4": {
		"category": "people",
		"moji": "💅🏾",
		"unicodeVersion": "8.0",
		"digest": "f3d95390ab59caedfda66122bbd0acf3aabedc142fc48352d68900766a7e6f5c"
	},
	"nail_care_tone5": {
		"category": "people",
		"moji": "💅🏿",
		"unicodeVersion": "8.0",
		"digest": "009423c97f2aafd24fb8c7c485c58b30bbf9ae6797cc14b80d472b207327b518"
	},
	"name_badge": {
		"category": "symbols",
		"moji": "📛",
		"unicodeVersion": "6.0",
		"digest": "f9f6a4895ff0be8fb2ccc7ad195b94e9650f742f66ead999e90724cfb77af628"
	},
	"nauseated_face": {
		"category": "people",
		"moji": "🤢",
		"unicodeVersion": "9.0",
		"digest": "f8471cf4720948d8246ec9d30e29783e819f90e3cfe8b1ba628671a1aad1a91c"
	},
	"necktie": {
		"category": "people",
		"moji": "👔",
		"unicodeVersion": "6.0",
		"digest": "01bb18dc8bfe787daa9613b5d09988cd5a065449ef906099ce3cb308c8a7da68"
	},
	"negative_squared_cross_mark": {
		"category": "symbols",
		"moji": "❎",
		"unicodeVersion": "6.0",
		"digest": "1cdaf4abc9adafa089c91c2e33a24e9e647aea0f857e767941a899a16ec53b74"
	},
	"nerd": {
		"category": "people",
		"moji": "🤓",
		"unicodeVersion": "8.0",
		"digest": "9e5f3c93db25cf1d0f9d6e6bd2993161afec6c30573ba3fe85e13b8c84483d66"
	},
	"neutral_face": {
		"category": "people",
		"moji": "😐",
		"unicodeVersion": "6.0",
		"digest": "7449430a60619956573e9dc80834045296f2b99853737b6c7794c785ff53d64e"
	},
	"new": {
		"category": "symbols",
		"moji": "🆕",
		"unicodeVersion": "6.0",
		"digest": "e20bc3e9f40726afd0cfb7268d02f1e1a07343364fd08b252d59f38de067bf06"
	},
	"new_moon": {
		"category": "nature",
		"moji": "🌑",
		"unicodeVersion": "6.0",
		"digest": "dbfc5dcae34b45f15ff767e297cba3a12cb83f3b542db8cfc8dbd9669e0df46c"
	},
	"new_moon_with_face": {
		"category": "nature",
		"moji": "🌚",
		"unicodeVersion": "6.0",
		"digest": "c66d347d2222ac8d77d323a07699aff6b168328648db4f885b1ed0e2831fd59b"
	},
	"newspaper": {
		"category": "objects",
		"moji": "📰",
		"unicodeVersion": "6.0",
		"digest": "c05e986d9cdac11afa30c6a21a72572ddf50fc64e87ae0c4e0ad57ffe70acc5c"
	},
	"newspaper2": {
		"category": "objects",
		"moji": "🗞",
		"unicodeVersion": "7.0",
		"digest": "63db7bcf51effc73e5124392740736383774a4bcfbc1156cf55599504760883d"
	},
	"ng": {
		"category": "symbols",
		"moji": "🆖",
		"unicodeVersion": "6.0",
		"digest": "34d5a11c70f48ea719e602908534f446b192622e775d4160f0e1ec52c342a35c"
	},
	"night_with_stars": {
		"category": "travel",
		"moji": "🌃",
		"unicodeVersion": "6.0",
		"digest": "39d9c079be80ee6ce1667531be528a2aa7f8bd46c7b6c2a6ee279d9a207c84a4"
	},
	"nine": {
		"category": "symbols",
		"moji": "9️⃣",
		"unicodeVersion": "3.0",
		"digest": "8bb40750eda8506ef877c9a3b8e2039d26f20eef345742f635740574a7e8daa6"
	},
	"no_bell": {
		"category": "symbols",
		"moji": "🔕",
		"unicodeVersion": "6.0",
		"digest": "6542a9a5656c79c153f8c37f12d48f677c89b02ed0989ae37fa5e51ce6895422"
	},
	"no_bicycles": {
		"category": "symbols",
		"moji": "🚳",
		"unicodeVersion": "6.0",
		"digest": "af71c183545da2ff4c05609f9d572edb64b63ccba7c6a4b208d271558aa92b0a"
	},
	"no_entry": {
		"category": "symbols",
		"moji": "⛔",
		"unicodeVersion": "5.2",
		"digest": "dc0bac1ed9ab8e9af143f0fce5043fe68f7f46bd80856cdec95d20c3999b637d"
	},
	"no_entry_sign": {
		"category": "symbols",
		"moji": "🚫",
		"unicodeVersion": "6.0",
		"digest": "2c1fceef23b62effca68e0e087b8f020125d25b98d61492b1540055d1914fdc3"
	},
	"no_good": {
		"category": "people",
		"moji": "🙅",
		"unicodeVersion": "6.0",
		"digest": "6eb970b104389be5d18657d7c04be5149958c26855c52ea68574af852c5f85c4"
	},
	"no_good_tone1": {
		"category": "people",
		"moji": "🙅🏻",
		"unicodeVersion": "8.0",
		"digest": "c20a24a1e536240b4dcf90ecb530796de621d7ba1fb9e3fa0f849d048c509c03"
	},
	"no_good_tone2": {
		"category": "people",
		"moji": "🙅🏼",
		"unicodeVersion": "8.0",
		"digest": "f31a4628c1f2e6a39288fda8eb19c9ec89983e3726e17a09384d9ecc13ef0b4c"
	},
	"no_good_tone3": {
		"category": "people",
		"moji": "🙅🏽",
		"unicodeVersion": "8.0",
		"digest": "959dec1bfdaf37b20a86ab2bcbdbacd3179c87b163042377d966eab47564c0fb"
	},
	"no_good_tone4": {
		"category": "people",
		"moji": "🙅🏾",
		"unicodeVersion": "8.0",
		"digest": "efd931f0080adf2e04129c83a8b24fda0ae7a9fa7c4b463686c0b99023620db8"
	},
	"no_good_tone5": {
		"category": "people",
		"moji": "🙅🏿",
		"unicodeVersion": "8.0",
		"digest": "f35df2b26af9baef47c1f8cc97a1b28a58aa7fcb2a13fdac7b2d9189f1e40105"
	},
	"no_mobile_phones": {
		"category": "symbols",
		"moji": "📵",
		"unicodeVersion": "6.0",
		"digest": "a472decd6ac7f9777961c09e00458746b2c04965585e3bee4556be3968e55bcd"
	},
	"no_mouth": {
		"category": "people",
		"moji": "😶",
		"unicodeVersion": "6.0",
		"digest": "72dda8b1e3ad4b05d9b095f9bd05e95d7ba013906c68914976a4554e8edf5866"
	},
	"no_pedestrians": {
		"category": "symbols",
		"moji": "🚷",
		"unicodeVersion": "6.0",
		"digest": "062b4a71b338fe09775e465bfba8ac04efbb3640330e8cabe88f3af62b0f4225"
	},
	"no_smoking": {
		"category": "symbols",
		"moji": "🚭",
		"unicodeVersion": "6.0",
		"digest": "ae2ebb331f79f6074091c0ee9cd69fce16d5e12a131d18973fc05520097e14ee"
	},
	"non-potable_water": {
		"category": "symbols",
		"moji": "🚱",
		"unicodeVersion": "6.0",
		"digest": "32eba0a99b498133c2e4450036f768d3dccaaf5b50adc9ad988757adc777a6a1"
	},
	"nose": {
		"category": "people",
		"moji": "👃",
		"unicodeVersion": "6.0",
		"digest": "9f800e24658ea3cebe1144d5d808cf13a88261f1a7f1f81a10d03b3d9d00e541"
	},
	"nose_tone1": {
		"category": "people",
		"moji": "👃🏻",
		"unicodeVersion": "8.0",
		"digest": "a2d0af22284b1d264eb780943b8360f463996a5c9c9584b8473edf8d442d9173"
	},
	"nose_tone2": {
		"category": "people",
		"moji": "👃🏼",
		"unicodeVersion": "8.0",
		"digest": "244dcaa8540024cf521f29f36bd48f933bf82f4833e35e6fa0abf113022038f3"
	},
	"nose_tone3": {
		"category": "people",
		"moji": "👃🏽",
		"unicodeVersion": "8.0",
		"digest": "c935b64866f0d49da52035aa09f36ff56d238eb7f5b92205386451056e8ea74f"
	},
	"nose_tone4": {
		"category": "people",
		"moji": "👃🏾",
		"unicodeVersion": "8.0",
		"digest": "a87e95fd9319c49e66b6dea0e57319d0ed9921b8d94df037767bf3d5dc7c94f3"
	},
	"nose_tone5": {
		"category": "people",
		"moji": "👃🏿",
		"unicodeVersion": "8.0",
		"digest": "1e0f9842e0f8ad5805eabd3f35a6038b7a2e49d566a1f5c17271f9cdf467ca60"
	},
	"notebook": {
		"category": "objects",
		"moji": "📓",
		"unicodeVersion": "6.0",
		"digest": "fc679d3728f86073d1607a926885dd8b0261132f5c4a0322f1e46ea9f95c8cb8"
	},
	"notebook_with_decorative_cover": {
		"category": "objects",
		"moji": "📔",
		"unicodeVersion": "6.0",
		"digest": "d822eda4b49cbfa399b36f134c1a0b8dcfdd27ed89f12c50bc18f6f0a9aa56ef"
	},
	"notepad_spiral": {
		"category": "objects",
		"moji": "🗒",
		"unicodeVersion": "7.0",
		"digest": "c6a8e16aa62474cef13e5659fddb4afc57e3f79635e32e6020edbee2b5b50f18"
	},
	"notes": {
		"category": "symbols",
		"moji": "🎶",
		"unicodeVersion": "6.0",
		"digest": "98467e0adc134d45676ef1c6c459e5853a9db50c8a6e91b6aec7d449aa737f48"
	},
	"nut_and_bolt": {
		"category": "objects",
		"moji": "🔩",
		"unicodeVersion": "6.0",
		"digest": "a77bd72f29a7302195dcec240174b15586de79e3204258e3fb401a6ea90563b3"
	},
	"o": {
		"category": "symbols",
		"moji": "⭕",
		"unicodeVersion": "5.2",
		"digest": "2387e5fd9ae4c2972d40298d32319b8fa55c50dbfc1c04c5c36088213e6951dd"
	},
	"o2": {
		"category": "symbols",
		"moji": "🅾",
		"unicodeVersion": "6.0",
		"digest": "6a9ccb0bf394e4d05ffda19327cee18f7b9ed80367fc7f41c93da9bb7efab0bf"
	},
	"ocean": {
		"category": "nature",
		"moji": "🌊",
		"unicodeVersion": "6.0",
		"digest": "1a9ca9848d4fb75852addfc10bf84eccf7caa5339714b90e3de4cb6f2518465e"
	},
	"octagonal_sign": {
		"category": "symbols",
		"moji": "🛑",
		"unicodeVersion": "9.0",
		"digest": "9f6927048e1f9da57f89d1ae1eb86fa4ab7abdbabca756a738a799e948d0b3f9"
	},
	"octopus": {
		"category": "nature",
		"moji": "🐙",
		"unicodeVersion": "6.0",
		"digest": "0fcc65c12f4b29ea75a8c4823d20838a7e6db6978fdcb536943072aa1460bc59"
	},
	"oden": {
		"category": "food",
		"moji": "🍢",
		"unicodeVersion": "6.0",
		"digest": "089974cb13a0bef6a245fc73029c5ed5153fd4caae0177b835f779e32200b8aa"
	},
	"office": {
		"category": "travel",
		"moji": "🏢",
		"unicodeVersion": "6.0",
		"digest": "3633a2e91036362e273eef4e0cfbdbbb4cb1208afe2cfa110ebef7b78109a66f"
	},
	"oil": {
		"category": "objects",
		"moji": "🛢",
		"unicodeVersion": "7.0",
		"digest": "00b94d33bcc9b9e8a5d4bd6e7f7e2fced9497ce05919edd5e58eafbc011c2caa"
	},
	"ok": {
		"category": "symbols",
		"moji": "🆗",
		"unicodeVersion": "6.0",
		"digest": "5f320f9b96e98a2f17ebe240daff9b9fd2ae0727cd6c8e4633b1744356e89365"
	},
	"ok_hand": {
		"category": "people",
		"moji": "👌",
		"unicodeVersion": "6.0",
		"digest": "d63002dce3cc3655b67b8765b7c28d370edba0e3758b2329b60e0e61c4d8e78d"
	},
	"ok_hand_tone1": {
		"category": "people",
		"moji": "👌🏻",
		"unicodeVersion": "8.0",
		"digest": "ef1508efcf483b09807554fe0e451c2948224f9deb85463e8e0dad6875b54012"
	},
	"ok_hand_tone2": {
		"category": "people",
		"moji": "👌🏼",
		"unicodeVersion": "8.0",
		"digest": "1215a101a082fd8e04c5d2f7e3c59d0f480cb0bedd79aeab5d36676bfe760088"
	},
	"ok_hand_tone3": {
		"category": "people",
		"moji": "👌🏽",
		"unicodeVersion": "8.0",
		"digest": "6fe0ed9fb42e86bb2bed4cb37b2acacacda1471fb1ee845ad55e54fb0897fbf4"
	},
	"ok_hand_tone4": {
		"category": "people",
		"moji": "👌🏾",
		"unicodeVersion": "8.0",
		"digest": "bfb9041c49d95e901a667264abaf9b398f6c4aa8b52bf5191c122db20c13c020"
	},
	"ok_hand_tone5": {
		"category": "people",
		"moji": "👌🏿",
		"unicodeVersion": "8.0",
		"digest": "1c218dc04d698da2cbdd7bea1ca3f845f9b386e967b7247c52f4b0f6ec8f5320"
	},
	"ok_woman": {
		"category": "people",
		"moji": "🙆",
		"unicodeVersion": "6.0",
		"digest": "3f8bd4ce2c4497155d697e5a71ebdc9339f65633d07fa9a7903e1bd76cfa4ba1"
	},
	"ok_woman_tone1": {
		"category": "people",
		"moji": "🙆🏻",
		"unicodeVersion": "8.0",
		"digest": "1660cd904ccd2ecdc6f4ba00527f7d4ec8c33f3c6183344616f97badae4c3730"
	},
	"ok_woman_tone2": {
		"category": "people",
		"moji": "🙆🏼",
		"unicodeVersion": "8.0",
		"digest": "7ba5fddd1e141424fac6778894dfc5af28e125839c58937c69496f99cd2c4002"
	},
	"ok_woman_tone3": {
		"category": "people",
		"moji": "🙆🏽",
		"unicodeVersion": "8.0",
		"digest": "1d972b8377c52f598406f59ab1e5be41aaf8f027e1fefba3deda66312ccd6a9b"
	},
	"ok_woman_tone4": {
		"category": "people",
		"moji": "🙆🏾",
		"unicodeVersion": "8.0",
		"digest": "a176328d8f53503aa743448968afd21d72ffd3510555526a3fb38d6b30ee7c15"
	},
	"ok_woman_tone5": {
		"category": "people",
		"moji": "🙆🏿",
		"unicodeVersion": "8.0",
		"digest": "13cfc1b589c57e81f768ee07a14b737cafc71407a7eb0956728b2ec4b1df14c4"
	},
	"older_man": {
		"category": "people",
		"moji": "👴",
		"unicodeVersion": "6.0",
		"digest": "4c0462b199bf26181c9e4d2d4cb878a32b0294566941212efc67362d0645f948"
	},
	"older_man_tone1": {
		"category": "people",
		"moji": "👴🏻",
		"unicodeVersion": "8.0",
		"digest": "99baa083f78cb01166d0a928d0b53682be14be04c29fc17bef14aac1a73a61e6"
	},
	"older_man_tone2": {
		"category": "people",
		"moji": "👴🏼",
		"unicodeVersion": "8.0",
		"digest": "5b4ce713e8820ba517fe92c25f3b93e6a6bf3704d1f982c461d5f31fc02b9d3d"
	},
	"older_man_tone3": {
		"category": "people",
		"moji": "👴🏽",
		"unicodeVersion": "8.0",
		"digest": "0eff72b3226c3a703c635798ee84129a695c896fa011fe1adbc105312eecc083"
	},
	"older_man_tone4": {
		"category": "people",
		"moji": "👴🏾",
		"unicodeVersion": "8.0",
		"digest": "ad9ba82b0c5d3b171b0639ee4265370dbddff5e0eeb70729db122659bb8c8f84"
	},
	"older_man_tone5": {
		"category": "people",
		"moji": "👴🏿",
		"unicodeVersion": "8.0",
		"digest": "5eb0a7467cc40e75752e11fd5126b275863dc037557a0d0d3b24b681e00c2386"
	},
	"older_woman": {
		"category": "people",
		"moji": "👵",
		"unicodeVersion": "6.0",
		"digest": "c261fdf3b01e0c7d949e177144531add5895197fbadf1acbba8eb17d18766bf6"
	},
	"older_woman_tone1": {
		"category": "people",
		"moji": "👵🏻",
		"unicodeVersion": "8.0",
		"digest": "1f2bb9e42270a58194498254da27ac2b7a50edaa771b90ee194ccd6d24660c62"
	},
	"older_woman_tone2": {
		"category": "people",
		"moji": "👵🏼",
		"unicodeVersion": "8.0",
		"digest": "2e28198e9b7ac08c55980677ed66655fd899e157f14184958bebd87fcd714940"
	},
	"older_woman_tone3": {
		"category": "people",
		"moji": "👵🏽",
		"unicodeVersion": "8.0",
		"digest": "c968be0170f7e0c65d4f796337034cfb1daba897884da6fad85635ab5b6edf67"
	},
	"older_woman_tone4": {
		"category": "people",
		"moji": "👵🏾",
		"unicodeVersion": "8.0",
		"digest": "3596a6fa9a643bf79255afcd29657b03850df8499db9669b92ce013af908af44"
	},
	"older_woman_tone5": {
		"category": "people",
		"moji": "👵🏿",
		"unicodeVersion": "8.0",
		"digest": "c8998cb3dbd15e22bd1d6dad613d109ce371d9ffca3657e1a8afe5aeb30c1275"
	},
	"om_symbol": {
		"category": "symbols",
		"moji": "🕉",
		"unicodeVersion": "7.0",
		"digest": "5ead73bea546ba9ba6da522f7280cc289c75ff5467742bdba31f92d0e1b3f4e6"
	},
	"on": {
		"category": "symbols",
		"moji": "🔛",
		"unicodeVersion": "6.0",
		"digest": "9cc61a6b31a30c32dab594191bf23f91e341c4105384ab22158a6d43e6364631"
	},
	"oncoming_automobile": {
		"category": "travel",
		"moji": "🚘",
		"unicodeVersion": "6.0",
		"digest": "557c9cacdc3f95215d4f7a6f097a2baa7c007cb9c519492a6717077af4ca6b56"
	},
	"oncoming_bus": {
		"category": "travel",
		"moji": "🚍",
		"unicodeVersion": "6.0",
		"digest": "059f28ce6bfb337e107db5982cbd2004844450ef20b4a54b9ca3cb738360ab05"
	},
	"oncoming_police_car": {
		"category": "travel",
		"moji": "🚔",
		"unicodeVersion": "6.0",
		"digest": "aee79306a0d129cfc1980f58db80391eb46d2d7d5f814bf431414dc7680cab72"
	},
	"oncoming_taxi": {
		"category": "travel",
		"moji": "🚖",
		"unicodeVersion": "6.0",
		"digest": "84351489fc86d980b8d3eb9ec4e81120fe700b3ac01346daebe2b7aeb9607a55"
	},
	"one": {
		"category": "symbols",
		"moji": "1️⃣",
		"unicodeVersion": "3.0",
		"digest": "d5d3fff04e68a114ff6464ee06fc831f3f381713045165f62a88d5e8215c195b"
	},
	"open_file_folder": {
		"category": "objects",
		"moji": "📂",
		"unicodeVersion": "6.0",
		"digest": "96cfc322ee4903ae8cec07604811742245fd7d14f00bb70276d39d29c48bed28"
	},
	"open_hands": {
		"category": "people",
		"moji": "👐",
		"unicodeVersion": "6.0",
		"digest": "a6c131da2040b48103cea14f280e728675da50fa448d2b3f3438fcbb5bf5596a"
	},
	"open_hands_tone1": {
		"category": "people",
		"moji": "👐🏻",
		"unicodeVersion": "8.0",
		"digest": "867128dff2fa9b860c10c6b792f989f0c057928783696062378f834c0ef89d85"
	},
	"open_hands_tone2": {
		"category": "people",
		"moji": "👐🏼",
		"unicodeVersion": "8.0",
		"digest": "487ff2745b03d49bb3b1d0acd86ba530fd8cc3f467ca3fa504f88f0ef1cbbc01"
	},
	"open_hands_tone3": {
		"category": "people",
		"moji": "👐🏽",
		"unicodeVersion": "8.0",
		"digest": "cb8cddc8b8661f874ac9478289d16cc41406b947bb87f3363df518a588a53e16"
	},
	"open_hands_tone4": {
		"category": "people",
		"moji": "👐🏾",
		"unicodeVersion": "8.0",
		"digest": "17dcc2c07230846a769f3c79ce618a757c88b9b58c95c6c5b2d7f968814d447d"
	},
	"open_hands_tone5": {
		"category": "people",
		"moji": "👐🏿",
		"unicodeVersion": "8.0",
		"digest": "36b2493d67c84cea4f3f85a3088c6abcfd35cf99f7aeaeedfafa420ee878e3d2"
	},
	"open_mouth": {
		"category": "people",
		"moji": "😮",
		"unicodeVersion": "6.1",
		"digest": "1906c5100ae0c8326ca5c4f9422976958a38dadd8d77724d68538a25d9623035"
	},
	"ophiuchus": {
		"category": "symbols",
		"moji": "⛎",
		"unicodeVersion": "6.0",
		"digest": "6112e2a1656b1cb8bd9a8b0dfa6cbf66d30cae671710a9ef75c821de344aab2b"
	},
	"orange_book": {
		"category": "objects",
		"moji": "📙",
		"unicodeVersion": "6.0",
		"digest": "41141b08d2beceded21a94795431603c47fd7d42a3a472a2aa8b2bb25fa87ebf"
	},
	"orthodox_cross": {
		"category": "symbols",
		"moji": "☦",
		"unicodeVersion": "1.1",
		"digest": "c16372102f0169dd6d32eb2b27a633aaee74e4e0fddcf723c15ad97f9dc6075c"
	},
	"outbox_tray": {
		"category": "objects",
		"moji": "📤",
		"unicodeVersion": "6.0",
		"digest": "e47cb481a0ffcb39996f32fd313e19b362a91d8dda15ffca48ac23a3b5bb5baf"
	},
	"owl": {
		"category": "nature",
		"moji": "🦉",
		"unicodeVersion": "9.0",
		"digest": "f62ec1ad23ad9038966eea8d8b79660ac212f291af2e89bcdb0fdc683caf41e5"
	},
	"ox": {
		"category": "nature",
		"moji": "🐂",
		"unicodeVersion": "6.0",
		"digest": "d13bc60552190bb9936bf32d681bdc742439b702a09cfc62137ea09a98624aed"
	},
	"package": {
		"category": "objects",
		"moji": "📦",
		"unicodeVersion": "6.0",
		"digest": "e82bf5accebb65136e897c15607eef635fb79fd7b2d8c8e19a9eb00b6786918c"
	},
	"page_facing_up": {
		"category": "objects",
		"moji": "📄",
		"unicodeVersion": "6.0",
		"digest": "3884868bdcb2f29615b09a13a30385cbc5269379094a54b5a7e8a5f4e8ce905a"
	},
	"page_with_curl": {
		"category": "objects",
		"moji": "📃",
		"unicodeVersion": "6.0",
		"digest": "3d6257670189f841ad1fa45415c34feb2433b2cb35bb435c4ee122ce89b39669"
	},
	"pager": {
		"category": "objects",
		"moji": "📟",
		"unicodeVersion": "6.0",
		"digest": "e21c756cc1c58ebc1b37ebcd38e22a25b31e2e81306c6f18285d6a7671f9eb12"
	},
	"paintbrush": {
		"category": "objects",
		"moji": "🖌",
		"unicodeVersion": "7.0",
		"digest": "fc0da7a25b726b8be9dd6467953e27293d2313a21eeff21424c2a19be614fff2"
	},
	"palm_tree": {
		"category": "nature",
		"moji": "🌴",
		"unicodeVersion": "6.0",
		"digest": "90fedafd62fe0abf51325174d0f293ebb9a4794913b9ba93b12f2d0119056df1"
	},
	"pancakes": {
		"category": "food",
		"moji": "🥞",
		"unicodeVersion": "9.0",
		"digest": "5256b4832431e8a88555796b1a9726f12d909a26fb2bdc3a0abff76412c45903"
	},
	"panda_face": {
		"category": "nature",
		"moji": "🐼",
		"unicodeVersion": "6.0",
		"digest": "56a4b84abe983bd6569be1b81ac5e43071015fd308389a16b92231310ae56a5b"
	},
	"paperclip": {
		"category": "objects",
		"moji": "📎",
		"unicodeVersion": "6.0",
		"digest": "d1e2ce94a12b7e8b7a9bba49e47ddc7432ec0288545d3b6817c7a499e806e3f0"
	},
	"paperclips": {
		"category": "objects",
		"moji": "🖇",
		"unicodeVersion": "7.0",
		"digest": "70cefa0d0777f070e393e9f95c24146fe2dd627f30fa3845baa19310d9291fe2"
	},
	"park": {
		"category": "travel",
		"moji": "🏞",
		"unicodeVersion": "7.0",
		"digest": "444dce8014e0817ddd756c36a38adfbbf7ae4c6aa509e4cae291828f0716d5e7"
	},
	"parking": {
		"category": "symbols",
		"moji": "🅿",
		"unicodeVersion": "5.2",
		"digest": "9f1da460a7dd58b26beab8cf701be2691fb812208fbc941c71daa35be1507c2f"
	},
	"part_alternation_mark": {
		"category": "symbols",
		"moji": "〽",
		"unicodeVersion": "3.2",
		"digest": "956da19353bb38fd4dfe0ab5360679a9035d566858fb5de62887b85c75fb8eef"
	},
	"partly_sunny": {
		"category": "nature",
		"moji": "⛅",
		"unicodeVersion": "5.2",
		"digest": "8fb9a6d2caf9e0cce58447762f0dfd6aa0b581b2e83fea6411348e0cbc8cf3c4"
	},
	"passport_control": {
		"category": "symbols",
		"moji": "🛂",
		"unicodeVersion": "6.0",
		"digest": "d9be6eed2c90e1c89171c42d70a06485fdf86a4c68833371832cc1f6897fadd0"
	},
	"pause_button": {
		"category": "symbols",
		"moji": "⏸",
		"unicodeVersion": "7.0",
		"digest": "143221d99e82399ed7824b6c5e185700896492058b65c04e4c668291de78b203"
	},
	"peace": {
		"category": "symbols",
		"moji": "☮",
		"unicodeVersion": "1.1",
		"digest": "65181429e373c1f0507bbd98425c1bec0c042d648fb285a392460cbce60f44d4"
	},
	"peach": {
		"category": "food",
		"moji": "🍑",
		"unicodeVersion": "6.0",
		"digest": "768d1f4f29e1e06aff5abb29043be83087ded16427ce6a2d0f682814e665e311"
	},
	"peanuts": {
		"category": "food",
		"moji": "🥜",
		"unicodeVersion": "9.0",
		"digest": "e2384846b6e4a6c3a56e991ebb749cb68b330ac00a9e9d888b2c39105ff7ff5d"
	},
	"pear": {
		"category": "food",
		"moji": "🍐",
		"unicodeVersion": "6.0",
		"digest": "b7c9cf90bb979649b863d2f4132f1b51f6f8107d42e08fb8b4033fea32844948"
	},
	"pen_ballpoint": {
		"category": "objects",
		"moji": "🖊",
		"unicodeVersion": "7.0",
		"digest": "aacb20b220f26704e10303deeea33be0eec2d3811dcba7795902ca44b6ae9876"
	},
	"pen_fountain": {
		"category": "objects",
		"moji": "🖋",
		"unicodeVersion": "7.0",
		"digest": "3619913eab2b6291f518b40481bb3eca0820d68b0a1b3c11fb6a69c62b75a626"
	},
	"pencil": {
		"category": "objects",
		"moji": "📝",
		"unicodeVersion": "6.0",
		"digest": "accbc3f1439b7faa4411e502385f78a16c8e71851f71fc13582753291ffb507c"
	},
	"pencil2": {
		"category": "objects",
		"moji": "✏",
		"unicodeVersion": "1.1",
		"digest": "9ca1b56b5726f472b1f1b23050ed163e213916dac379d22e38e4c8358fe871e0"
	},
	"penguin": {
		"category": "nature",
		"moji": "🐧",
		"unicodeVersion": "6.0",
		"digest": "a1800ab931d6dc84a9c89bfab2c815198025c276d952509c55b18dd20bd9d316"
	},
	"pensive": {
		"category": "people",
		"moji": "😔",
		"unicodeVersion": "6.0",
		"digest": "d237deff9f5ead8a0b281b7e5c6f4b82e98cc30c80c86c22c3fdc6160090b2f2"
	},
	"performing_arts": {
		"category": "activity",
		"moji": "🎭",
		"unicodeVersion": "6.0",
		"digest": "d7c7bc9213e308ca26286cbbd8012e656b0f9b00293758faf1bfccc4c5ceabed"
	},
	"persevere": {
		"category": "people",
		"moji": "😣",
		"unicodeVersion": "6.0",
		"digest": "c361509c9b8663af19a02a1ffff61b1b0d0b4bd75d693ce3d406b0ca1bde1ca0"
	},
	"person_frowning": {
		"category": "people",
		"moji": "🙍",
		"unicodeVersion": "6.0",
		"digest": "b37be8bd95f21a6860ad3f171b8086125ab37331b382d87bcdb4cd684800546b"
	},
	"person_frowning_tone1": {
		"category": "people",
		"moji": "🙍🏻",
		"unicodeVersion": "8.0",
		"digest": "3d5e78a367f9673baed2a86bc11cf04fd44394aadb65291fa51ade8dca318427"
	},
	"person_frowning_tone2": {
		"category": "people",
		"moji": "🙍🏼",
		"unicodeVersion": "8.0",
		"digest": "7456c414c65ad6b6f11855f68a2eedc18113526f86862c4373202397cb1bed2c"
	},
	"person_frowning_tone3": {
		"category": "people",
		"moji": "🙍🏽",
		"unicodeVersion": "8.0",
		"digest": "c86cf2d6951f1e6a7c786a74caaf68a777cf00e88023e23849d4383f864ae437"
	},
	"person_frowning_tone4": {
		"category": "people",
		"moji": "🙍🏾",
		"unicodeVersion": "8.0",
		"digest": "944e96ced645ced8db6bb50120c7e37ed46b6960d595cbfe964c81803efa83aa"
	},
	"person_frowning_tone5": {
		"category": "people",
		"moji": "🙍🏿",
		"unicodeVersion": "8.0",
		"digest": "4bd0ea571be6ef9f0493784ef0d12d5e47bc2d6ac610fb42c450bf3d87fb2948"
	},
	"person_with_blond_hair": {
		"category": "people",
		"moji": "👱",
		"unicodeVersion": "6.0",
		"digest": "a7f94ede2e43308108c2260d83fc10121dda09a67f94a0a840e6d7bba7fd5616"
	},
	"person_with_blond_hair_tone1": {
		"category": "people",
		"moji": "👱🏻",
		"unicodeVersion": "8.0",
		"digest": "00a116357a7878554c83e5bade4bddfa9cfabf76a229efa19cbb58e0d216219c"
	},
	"person_with_blond_hair_tone2": {
		"category": "people",
		"moji": "👱🏼",
		"unicodeVersion": "8.0",
		"digest": "df509ebe92ed3138b9d5bd4645eff4b13f77f714cf62bb949c59eff1adc00019"
	},
	"person_with_blond_hair_tone3": {
		"category": "people",
		"moji": "👱🏽",
		"unicodeVersion": "8.0",
		"digest": "6f328513f440a0c8cd1dc44596a5028fd8f306bdaf57c1e6f3aa94a3aa262b3c"
	},
	"person_with_blond_hair_tone4": {
		"category": "people",
		"moji": "👱🏾",
		"unicodeVersion": "8.0",
		"digest": "32df1a577815b009696643ad80d063cc97b35d54add6d4e5517fc936f6da9ee8"
	},
	"person_with_blond_hair_tone5": {
		"category": "people",
		"moji": "👱🏿",
		"unicodeVersion": "8.0",
		"digest": "2e270bb39187d8e36a33f4aa4d6045308189595fafc157cf7993e82d7ce93442"
	},
	"person_with_pouting_face": {
		"category": "people",
		"moji": "🙎",
		"unicodeVersion": "6.0",
		"digest": "57e9a6e5f82121516dc189173f2a63b218f726cd51014e24a18c2bdfeeec3a0b"
	},
	"person_with_pouting_face_tone1": {
		"category": "people",
		"moji": "🙎🏻",
		"unicodeVersion": "8.0",
		"digest": "d10dadb1ac03fc2e221eff77b4c47935dc0b4fe897af3de30461e7226c3b4bbc"
	},
	"person_with_pouting_face_tone2": {
		"category": "people",
		"moji": "🙎🏼",
		"unicodeVersion": "8.0",
		"digest": "efface531537ab934b3b96985210a2dac88de812e82e804d6ec12174e536d1cc"
	},
	"person_with_pouting_face_tone3": {
		"category": "people",
		"moji": "🙎🏽",
		"unicodeVersion": "8.0",
		"digest": "7ff26ece237216b949bfa96d16bd12cfd248c6fd3e4ed89aa6c735c09eafaeff"
	},
	"person_with_pouting_face_tone4": {
		"category": "people",
		"moji": "🙎🏾",
		"unicodeVersion": "8.0",
		"digest": "045c04105df41d94ff4942133c7394e42ff35ef76c4ccb711497ab77ae6219f2"
	},
	"person_with_pouting_face_tone5": {
		"category": "people",
		"moji": "🙎🏿",
		"unicodeVersion": "8.0",
		"digest": "783ee37f146fcf61d38af5009f5823cf6526fe99ed891979f454016bce9dd4ba"
	},
	"pick": {
		"category": "objects",
		"moji": "⛏",
		"unicodeVersion": "5.2",
		"digest": "7f0ec5445b4d5c66cf46e2a7332946cce34bd70e9929ac7a119251a7f57f555d"
	},
	"pig": {
		"category": "nature",
		"moji": "🐷",
		"unicodeVersion": "6.0",
		"digest": "51362570ab36805c8f67622ee4543e38811f8abb20f732a1af2ffbff2d63d042"
	},
	"pig2": {
		"category": "nature",
		"moji": "🐖",
		"unicodeVersion": "6.0",
		"digest": "67010e255f28061b9d9210bcdab6edc072642ad134122a1d0c7e3a6b1795a45b"
	},
	"pig_nose": {
		"category": "nature",
		"moji": "🐽",
		"unicodeVersion": "6.0",
		"digest": "0b21cac238bf4910939fbea9bed35552378c1b605a3867d7b85c1556dbda22a9"
	},
	"pill": {
		"category": "objects",
		"moji": "💊",
		"unicodeVersion": "6.0",
		"digest": "cb00be361aaba6dbcf8da58bd20b76221dd75031362ecae99496b088ed413a7f"
	},
	"pineapple": {
		"category": "food",
		"moji": "🍍",
		"unicodeVersion": "6.0",
		"digest": "621d4d4c52b59e566c2e29ed7845c8bd2d1da0946577527342097808d170dd70"
	},
	"ping_pong": {
		"category": "activity",
		"moji": "🏓",
		"unicodeVersion": "8.0",
		"digest": "943a858bd054c81a08a08951f8351c27c8009b85a9359729c7362868298b58e1"
	},
	"pisces": {
		"category": "symbols",
		"moji": "♓",
		"unicodeVersion": "1.1",
		"digest": "453c3915122a4b6b32867056d2447be48675a84469145c88d52f8007fcb0861a"
	},
	"pizza": {
		"category": "food",
		"moji": "🍕",
		"unicodeVersion": "6.0",
		"digest": "169bc6c1e1d7fdab1b8bf2eab0eeec4f9a7ae08b7b9b38f33b0b0c642e72053a"
	},
	"place_of_worship": {
		"category": "symbols",
		"moji": "🛐",
		"unicodeVersion": "8.0",
		"digest": "daf271d36a38ee8c0f8b9de84c128ab8b25a5b7df8f107308d0353c961f2c644"
	},
	"play_pause": {
		"category": "symbols",
		"moji": "⏯",
		"unicodeVersion": "6.0",
		"digest": "af1498f34a3d6e0da8bbd26ebaa447e697e2df08c8eb255437cf7905c93f8c42"
	},
	"point_down": {
		"category": "people",
		"moji": "👇",
		"unicodeVersion": "6.0",
		"digest": "4ecdb3f31c16dc38113b8854ec1a7884613b688a185ebdf967eab9a81018f76d"
	},
	"point_down_tone1": {
		"category": "people",
		"moji": "👇🏻",
		"unicodeVersion": "8.0",
		"digest": "c74a7c94367cddbfa840542dc0924adeb0d108be0c7fde8c25fb95d69115d283"
	},
	"point_down_tone2": {
		"category": "people",
		"moji": "👇🏼",
		"unicodeVersion": "8.0",
		"digest": "dc4bda0726d85418b974addb42738f437fbb9cf16e5815cdbab3859c4ada6cae"
	},
	"point_down_tone3": {
		"category": "people",
		"moji": "👇🏽",
		"unicodeVersion": "8.0",
		"digest": "e460f81a501376d2f0ed1d45e358c5ed03ba049e8f466e4298afb4f3ca6d24dc"
	},
	"point_down_tone4": {
		"category": "people",
		"moji": "👇🏾",
		"unicodeVersion": "8.0",
		"digest": "4bc91cd771f24e0f897a9d8b18f323fec9a82da0fc2429c4a7e4e6a9d885a0a3"
	},
	"point_down_tone5": {
		"category": "people",
		"moji": "👇🏿",
		"unicodeVersion": "8.0",
		"digest": "7e47c6bc73250f36dc7ae1c1c09e7b41f30647b9d0ff703a53a75cc046b5057d"
	},
	"point_left": {
		"category": "people",
		"moji": "👈",
		"unicodeVersion": "6.0",
		"digest": "b5a7e864a0016afbadb3bec41f51ecf8c4af73cc20462e1a08b357f90bca6879"
	},
	"point_left_tone1": {
		"category": "people",
		"moji": "👈🏻",
		"unicodeVersion": "8.0",
		"digest": "9f1868272a10a2b738c065be5d30241643324550cfd47baf01c7a09060e66d31"
	},
	"point_left_tone2": {
		"category": "people",
		"moji": "👈🏼",
		"unicodeVersion": "8.0",
		"digest": "bf0d58c68178a2c2c01d4a6235a1a66b90073cea170f9f6fe2668b6dd68424f7"
	},
	"point_left_tone3": {
		"category": "people",
		"moji": "👈🏽",
		"unicodeVersion": "8.0",
		"digest": "34d28c97bc8f9d111d14e328153c4298fc32cf18e39e20aacaec17846645ed90"
	},
	"point_left_tone4": {
		"category": "people",
		"moji": "👈🏾",
		"unicodeVersion": "8.0",
		"digest": "c40c8436316915d516c53bb1c98a469528cefd98baa719be7e748c4608cbbcc9"
	},
	"point_left_tone5": {
		"category": "people",
		"moji": "👈🏿",
		"unicodeVersion": "8.0",
		"digest": "c410fe32e4ce0ded74845a54b86090e59e5820d457837b16e175b36cc71ecb46"
	},
	"point_right": {
		"category": "people",
		"moji": "👉",
		"unicodeVersion": "6.0",
		"digest": "44d9251ab41f2f48c2250c44a47f92b3476a71f13fbbbfb637547db837fd5a49"
	},
	"point_right_tone1": {
		"category": "people",
		"moji": "👉🏻",
		"unicodeVersion": "8.0",
		"digest": "9fcce259eb81c0b52ec7796b98a1653194e3a9021a1d338df1dbbab7522fc406"
	},
	"point_right_tone2": {
		"category": "people",
		"moji": "👉🏼",
		"unicodeVersion": "8.0",
		"digest": "9d00a0b1cfc435674dc56065b3d28d28839196977504cf20581205351d8708f2"
	},
	"point_right_tone3": {
		"category": "people",
		"moji": "👉🏽",
		"unicodeVersion": "8.0",
		"digest": "e3026a70630ba73d76892a055a80cac2f78d509faddce737f802d2abefa074ba"
	},
	"point_right_tone4": {
		"category": "people",
		"moji": "👉🏾",
		"unicodeVersion": "8.0",
		"digest": "ea508fde90561460361773b4e1b8e80874667b19ac115926206e7c592587cb76"
	},
	"point_right_tone5": {
		"category": "people",
		"moji": "👉🏿",
		"unicodeVersion": "8.0",
		"digest": "d59cdb2864eb2929941ecd233f8b8afcddc30fbd4594e5f9acf6386ae06ac12c"
	},
	"point_up": {
		"category": "people",
		"moji": "☝",
		"unicodeVersion": "1.1",
		"digest": "b69ff4f650989709f2185822d278c7773672bd9eb4a625da80f3038a2b9ce42b"
	},
	"point_up_2": {
		"category": "people",
		"moji": "👆",
		"unicodeVersion": "6.0",
		"digest": "e83cd9eff2af5125a25f5a306c3ee3cfea240add683b5c36a86a994a8d8c805c"
	},
	"point_up_2_tone1": {
		"category": "people",
		"moji": "👆🏻",
		"unicodeVersion": "8.0",
		"digest": "b02ec3e7e04a83bfb769cffb951cbf32aa78e56fa5a51c097f9326df9e08ed33"
	},
	"point_up_2_tone2": {
		"category": "people",
		"moji": "👆🏼",
		"unicodeVersion": "8.0",
		"digest": "32994b85c8b4a1383ca985ebc3382be88866cea1ff1315adfb71fb05e992a232"
	},
	"point_up_2_tone3": {
		"category": "people",
		"moji": "👆🏽",
		"unicodeVersion": "8.0",
		"digest": "9e263bcfb82ada34ff85291f36e64e66b86760fb11a4e0c554e801644d417d6d"
	},
	"point_up_2_tone4": {
		"category": "people",
		"moji": "👆🏾",
		"unicodeVersion": "8.0",
		"digest": "3edc92130a0851ac7b5236772ce7918d088689221df287098688e1ed5b3ff181"
	},
	"point_up_2_tone5": {
		"category": "people",
		"moji": "👆🏿",
		"unicodeVersion": "8.0",
		"digest": "cabb3b7da9290840ef59d0c8b22625bdb2e94842f01b0a575ccbc348f3069d77"
	},
	"point_up_tone1": {
		"category": "people",
		"moji": "☝🏻",
		"unicodeVersion": "8.0",
		"digest": "e496fda349072f8b321ceb7a251175f7244c3076661f5ede48ea75ba1acf8339"
	},
	"point_up_tone2": {
		"category": "people",
		"moji": "☝🏼",
		"unicodeVersion": "8.0",
		"digest": "5a8081323f3baa67e6431e21e16a36559b339f5175d586644e34947f738dd07a"
	},
	"point_up_tone3": {
		"category": "people",
		"moji": "☝🏽",
		"unicodeVersion": "8.0",
		"digest": "07bf0cea812eb226b443334e026e13d1ec23e013478f4af862a3919703107842"
	},
	"point_up_tone4": {
		"category": "people",
		"moji": "☝🏾",
		"unicodeVersion": "8.0",
		"digest": "1fbbd71433108143ee157d0fdadd183f7f013bafa96f0dd93b181e1fd5fd4af2"
	},
	"point_up_tone5": {
		"category": "people",
		"moji": "☝🏿",
		"unicodeVersion": "8.0",
		"digest": "ad068ef32df32f8297955490a9a90590a0f93ed5702a052cd0d8f6484c6cc679"
	},
	"police_car": {
		"category": "travel",
		"moji": "🚓",
		"unicodeVersion": "6.0",
		"digest": "0909be1bd615ae331a7cce71e16dee3ca663c721d5170072c593cb7c76f9f661"
	},
	"poodle": {
		"category": "nature",
		"moji": "🐩",
		"unicodeVersion": "6.0",
		"digest": "f1742fdf3fd26a8a5cfeaba57026518dacaad364cbd03344c4000a35af13e47a"
	},
	"poop": {
		"category": "people",
		"moji": "💩",
		"unicodeVersion": "6.0",
		"digest": "857a61c872138d359a7fe8257bb26118afa49d75186eca2addb415d07c92b3ec"
	},
	"popcorn": {
		"category": "food",
		"moji": "🍿",
		"unicodeVersion": "8.0",
		"digest": "684f1b7ef34ea7ca933aed41569bc6595a19ef0d546a1b7b9e69f8335540b323"
	},
	"post_office": {
		"category": "travel",
		"moji": "🏣",
		"unicodeVersion": "6.0",
		"digest": "54398ee396c1314a7993b1cb1cba264946b5c9d5a7dbb43fd67286854d1d1a0f"
	},
	"postal_horn": {
		"category": "objects",
		"moji": "📯",
		"unicodeVersion": "6.0",
		"digest": "0ea12f44f3bae9a14bde3b37361b48bd738d2f613bb1b53a9204959b70e643f8"
	},
	"postbox": {
		"category": "objects",
		"moji": "📮",
		"unicodeVersion": "6.0",
		"digest": "bbc424ae8d46de380d7023a43ea064002fd614657d00330d3503275827ac87e2"
	},
	"potable_water": {
		"category": "symbols",
		"moji": "🚰",
		"unicodeVersion": "6.0",
		"digest": "dbe80d9637837377cc2a290da2e895f81a3108cc18b049e3d87212402c1c2098"
	},
	"potato": {
		"category": "food",
		"moji": "🥔",
		"unicodeVersion": "9.0",
		"digest": "a56a69f36f3a0793f278726d92c0cea2960554f3062ef1a0904526a04511d8e1"
	},
	"pouch": {
		"category": "people",
		"moji": "👝",
		"unicodeVersion": "6.0",
		"digest": "9f012b90310b4a072b6a8fa2c64def087b5f7ffffaafc36e1856ba943a170351"
	},
	"poultry_leg": {
		"category": "food",
		"moji": "🍗",
		"unicodeVersion": "6.0",
		"digest": "1445ec4f5e68a19e5a84e5537dca8190d62409070c954d112e6097f1a6b7f054"
	},
	"pound": {
		"category": "objects",
		"moji": "💷",
		"unicodeVersion": "6.0",
		"digest": "eb11b83eb52adb0a15e69a3bc15788a2dc7825dedee81ac3af84963c9dd517b5"
	},
	"pouting_cat": {
		"category": "people",
		"moji": "😾",
		"unicodeVersion": "6.0",
		"digest": "8822abedf3499cf98278d7eeea0764d1100ec25cad71b4b2e877f9346f8c8138"
	},
	"pray": {
		"category": "people",
		"moji": "🙏",
		"unicodeVersion": "6.0",
		"digest": "735b79dab34ac2cf81fd42fdcd7eb1f13c24655e5e343816d5764896c03edeea"
	},
	"pray_tone1": {
		"category": "people",
		"moji": "🙏🏻",
		"unicodeVersion": "8.0",
		"digest": "e8b6103450215e8566797f150978355e297deade4eb47a6371f7a7bc558fed9d"
	},
	"pray_tone2": {
		"category": "people",
		"moji": "🙏🏼",
		"unicodeVersion": "8.0",
		"digest": "ee8baacd95d7e8dbad8a1f2d9a12e36c98f3d518db5d3b117d0a18290815e62b"
	},
	"pray_tone3": {
		"category": "people",
		"moji": "🙏🏽",
		"unicodeVersion": "8.0",
		"digest": "ae8c0caa9aca0a6c44069e76a7535c961d0284cd701812f76bbd2bd79ce2bd53"
	},
	"pray_tone4": {
		"category": "people",
		"moji": "🙏🏾",
		"unicodeVersion": "8.0",
		"digest": "64f7b3178b8cd6f6a877ed583539eefe068fa87a0dd658fdcd58c8bc809f7e17"
	},
	"pray_tone5": {
		"category": "people",
		"moji": "🙏🏿",
		"unicodeVersion": "8.0",
		"digest": "5bc8cdce937ac06779c87021423efcec4f602aa4a39dba90b00de81033005332"
	},
	"prayer_beads": {
		"category": "objects",
		"moji": "📿",
		"unicodeVersion": "8.0",
		"digest": "80177091264430cbcf7c994fbe5ee17319d1a58d933636cc752a54dafcf98a05"
	},
	"pregnant_woman": {
		"category": "people",
		"moji": "🤰",
		"unicodeVersion": "9.0",
		"digest": "49abb86409103338bdb6ae43c13a78ca2dc9cd158a26df35eadd0da3c84a4352"
	},
	"pregnant_woman_tone1": {
		"category": "people",
		"moji": "🤰🏻",
		"unicodeVersion": "9.0",
		"digest": "5a9f8ed2b631ecf8af111803a5c11f4c156435a5293cb50329c7b98697c8da25"
	},
	"pregnant_woman_tone2": {
		"category": "people",
		"moji": "🤰🏼",
		"unicodeVersion": "9.0",
		"digest": "279a2eafff603b11629c955b05f5bd3d7da9a271d4fb3f02e9ccd457b8d2d815"
	},
	"pregnant_woman_tone3": {
		"category": "people",
		"moji": "🤰🏽",
		"unicodeVersion": "9.0",
		"digest": "93bb63ec2312db315e3f0065520b715cc413ac0fd65538ec9b5cd97df2a42b20"
	},
	"pregnant_woman_tone4": {
		"category": "people",
		"moji": "🤰🏾",
		"unicodeVersion": "9.0",
		"digest": "b8dc3dcec894bfd832a249459b10850f8786b6778d8887a677d1291865623da2"
	},
	"pregnant_woman_tone5": {
		"category": "people",
		"moji": "🤰🏿",
		"unicodeVersion": "9.0",
		"digest": "73ee432752f81980f353a7f9b9f7a5ece62512dca08e15c1876b89227face21c"
	},
	"prince": {
		"category": "people",
		"moji": "🤴",
		"unicodeVersion": "9.0",
		"digest": "34a0e0625f0a9825d3674192d6233b6cae4d8130451293df09f91a6a4165869c"
	},
	"prince_tone1": {
		"category": "people",
		"moji": "🤴🏻",
		"unicodeVersion": "9.0",
		"digest": "ccecdfeccb2ab1fceceae14f3fba875c8c7099785a4c40131c08a697b5b675fc"
	},
	"prince_tone2": {
		"category": "people",
		"moji": "🤴🏼",
		"unicodeVersion": "9.0",
		"digest": "c373fd3e0c1798415e3d8d88fab6c98c1bbdedcbe6f52f3a3899f6e2124a768d"
	},
	"prince_tone3": {
		"category": "people",
		"moji": "🤴🏽",
		"unicodeVersion": "9.0",
		"digest": "71d15695ca954d55aa69d3c753c7d31a8ba5329713a8ddbc90dafc11e524c4ef"
	},
	"prince_tone4": {
		"category": "people",
		"moji": "🤴🏾",
		"unicodeVersion": "9.0",
		"digest": "08f6cb32424f15cc3aaf83c31a5dac7c01a6be2f37ea8f13aed579ce6fb4db19"
	},
	"prince_tone5": {
		"category": "people",
		"moji": "🤴🏿",
		"unicodeVersion": "9.0",
		"digest": "77d521148efa33fa4d3409693d050fecfd948411e807327484f174e289834649"
	},
	"princess": {
		"category": "people",
		"moji": "👸",
		"unicodeVersion": "6.0",
		"digest": "efabd28480a843c735f0868734da2f9ce28133933b02ab07b645498f494f3f80"
	},
	"princess_tone1": {
		"category": "people",
		"moji": "👸🏻",
		"unicodeVersion": "8.0",
		"digest": "52b88b99ba64f82e8f36e2a1827c85145e4fcd6863478c2345fe9fa9e8901cdf"
	},
	"princess_tone2": {
		"category": "people",
		"moji": "👸🏼",
		"unicodeVersion": "8.0",
		"digest": "7e44289404693668f20e681fcdc2e516512d54a69c627eedae958f69dfe6eea9"
	},
	"princess_tone3": {
		"category": "people",
		"moji": "👸🏽",
		"unicodeVersion": "8.0",
		"digest": "96c9a9857348d7a1a8be899c50d55b352b9a9fd5c65e4777bfa199fe7929d41c"
	},
	"princess_tone4": {
		"category": "people",
		"moji": "👸🏾",
		"unicodeVersion": "8.0",
		"digest": "67696f96be60f2a36598072172d2db197d007e6c1ac3acef526a5ce6d59bf3f7"
	},
	"princess_tone5": {
		"category": "people",
		"moji": "👸🏿",
		"unicodeVersion": "8.0",
		"digest": "007f624e2fad91bb57ce32ecd35213a796d71807f3b12f3f1575bf50e6a50eeb"
	},
	"printer": {
		"category": "objects",
		"moji": "🖨",
		"unicodeVersion": "7.0",
		"digest": "5e5307e3dc7ec4e16c9978fb00934c99c4adefca7d32732a244d1f2de71ce6f8"
	},
	"projector": {
		"category": "objects",
		"moji": "📽",
		"unicodeVersion": "7.0",
		"digest": "7f8e1fdb89584849a56ee34c62cab808af48b7bd4823467d090af4657a2e0420"
	},
	"punch": {
		"category": "people",
		"moji": "👊",
		"unicodeVersion": "6.0",
		"digest": "c7e7edf6d64f755db3f02874354f08337b3971aff329476d19ac946e0b421329"
	},
	"punch_tone1": {
		"category": "people",
		"moji": "👊🏻",
		"unicodeVersion": "8.0",
		"digest": "c9ba508b0c36041047473782acfedab5af40dd7946b33daf4d8d54c726e06a11"
	},
	"punch_tone2": {
		"category": "people",
		"moji": "👊🏼",
		"unicodeVersion": "8.0",
		"digest": "d53011cd2f3334c7b3fffdfe1e2b8cc1c832c74306e1ac6d03f954a1309d7d0b"
	},
	"punch_tone3": {
		"category": "people",
		"moji": "👊🏽",
		"unicodeVersion": "8.0",
		"digest": "f7522347094e0130ed8e304678106574dbd7dd2b6b3aeb4d8a7a0fef880920b2"
	},
	"punch_tone4": {
		"category": "people",
		"moji": "👊🏾",
		"unicodeVersion": "8.0",
		"digest": "3e62bdd426f3e6ff175ce3b8dd6f6d3998d9c1506128defa96b528b455295b47"
	},
	"punch_tone5": {
		"category": "people",
		"moji": "👊🏿",
		"unicodeVersion": "8.0",
		"digest": "7d9bff777dc4ec41ac132b1252fa08cf92a398c8dc146c4a5327b45d568982d8"
	},
	"purple_heart": {
		"category": "symbols",
		"moji": "💜",
		"unicodeVersion": "6.0",
		"digest": "a6bf01de806525942be480e45a4b2879f91df8129b78a1b8734d4f917bcab773"
	},
	"purse": {
		"category": "people",
		"moji": "👛",
		"unicodeVersion": "6.0",
		"digest": "2b785f36e01875d66cfda2192c8c53606e7224a7c869a4826b62cb61613d60c8"
	},
	"pushpin": {
		"category": "objects",
		"moji": "📌",
		"unicodeVersion": "6.0",
		"digest": "c3f7d7008be6bab8dc02284d4d759abf7aafbb3dbbe3a53f0f5b2ff685af88f8"
	},
	"put_litter_in_its_place": {
		"category": "symbols",
		"moji": "🚮",
		"unicodeVersion": "6.0",
		"digest": "f52a57d6f1bada7b6e6b9a6458597d70cb701c01e1120d8cb1d7ff65e01d405c"
	},
	"question": {
		"category": "symbols",
		"moji": "❓",
		"unicodeVersion": "6.0",
		"digest": "40050a1fd29bed321fd601d13dc33de5d6084121f1d873b29bde9dc3d823a310"
	},
	"rabbit": {
		"category": "nature",
		"moji": "🐰",
		"unicodeVersion": "6.0",
		"digest": "678ad953a7ab8f618c59051449a67c965d1f04f42dd6f6669adaf3fadebd080c"
	},
	"rabbit2": {
		"category": "nature",
		"moji": "🐇",
		"unicodeVersion": "6.0",
		"digest": "19b1f5108292472434cc7a49efac4ea9275779735c7aeb0f15c36021d5998ca0"
	},
	"race_car": {
		"category": "travel",
		"moji": "🏎",
		"unicodeVersion": "7.0",
		"digest": "46f4814259d3d17ff35c04110e73e5327aee99f4711cd459ca1ee951508da3a6"
	},
	"racehorse": {
		"category": "nature",
		"moji": "🐎",
		"unicodeVersion": "6.0",
		"digest": "a57b7aca35347ada8225eeee06b70cfd040484104963b4df56ea8fec690576b0"
	},
	"radio": {
		"category": "objects",
		"moji": "📻",
		"unicodeVersion": "6.0",
		"digest": "9245951dd779cdd141089891b15a90d3999a6358acf1fc296aa505100f812108"
	},
	"radio_button": {
		"category": "symbols",
		"moji": "🔘",
		"unicodeVersion": "6.0",
		"digest": "565bec59198df2592e96564c6e314d3cde33c47b453db1bec6c5d027b5cb4fd9"
	},
	"radioactive": {
		"category": "symbols",
		"moji": "☢",
		"unicodeVersion": "1.1",
		"digest": "0ed6634057824e0cfd10b2533753e3632b0624341a7eac8d9835706480335581"
	},
	"rage": {
		"category": "people",
		"moji": "😡",
		"unicodeVersion": "6.0",
		"digest": "d97ba6bd08eec46dbc7199f530c945b73a87a878e35397b0a3e4f2b45039e89e"
	},
	"railway_car": {
		"category": "travel",
		"moji": "🚃",
		"unicodeVersion": "6.0",
		"digest": "2cddc08d555e7fc24e312c3d255ed013fbf9cd2974a6918369c32554049ba2be"
	},
	"railway_track": {
		"category": "travel",
		"moji": "🛤",
		"unicodeVersion": "7.0",
		"digest": "0da351b6d4e75c6beeaef1225e151d9580d4b5c41dfa1cf192715bf3cec981d7"
	},
	"rainbow": {
		"category": "travel",
		"moji": "🌈",
		"unicodeVersion": "6.0",
		"digest": "a93aceb54e965f35e397e8c8716b1831614933308d026012d5464ee42783ed4d"
	},
	"raised_back_of_hand": {
		"category": "people",
		"moji": "🤚",
		"unicodeVersion": "9.0",
		"digest": "20973a697e826625deba5ee3c4f25eb5e1737f2e860ac6fe4ee4d0e0c84b5e12"
	},
	"raised_back_of_hand_tone1": {
		"category": "people",
		"moji": "🤚🏻",
		"unicodeVersion": "9.0",
		"digest": "06af5941255ca69d10d99d0a512bbda6141a296453835dbccf259ce0afe1dd3d"
	},
	"raised_back_of_hand_tone2": {
		"category": "people",
		"moji": "🤚🏼",
		"unicodeVersion": "9.0",
		"digest": "429ed19555c9e5197b729b3e7bd8013346551051cb0b3fbc8a4372717c9a027d"
	},
	"raised_back_of_hand_tone3": {
		"category": "people",
		"moji": "🤚🏽",
		"unicodeVersion": "9.0",
		"digest": "487a1c3f19e77c99b520ec073de2acc4a9e585b739a84b3989f7de85d2c2045c"
	},
	"raised_back_of_hand_tone4": {
		"category": "people",
		"moji": "🤚🏾",
		"unicodeVersion": "9.0",
		"digest": "154254d8500c55ec3de698be4a352f9bcf06e2950cabc4eabaccad0f39a1e1e9"
	},
	"raised_back_of_hand_tone5": {
		"category": "people",
		"moji": "🤚🏿",
		"unicodeVersion": "9.0",
		"digest": "6e9c0855ecd5f14adca5e5862427c3d39ffcf86f7ddd3aaa1fefc3cefc7483c8"
	},
	"raised_hand": {
		"category": "people",
		"moji": "✋",
		"unicodeVersion": "6.0",
		"digest": "5cf11be683aea985d5ba51fbd44722c2327311bfe26b61c3d441c90f5d5a195a"
	},
	"raised_hand_tone1": {
		"category": "people",
		"moji": "✋🏻",
		"unicodeVersion": "8.0",
		"digest": "865afca29b57577fed8fe8c2be57b74254a008c8cf34194680be2759239b5f5d"
	},
	"raised_hand_tone2": {
		"category": "people",
		"moji": "✋🏼",
		"unicodeVersion": "8.0",
		"digest": "832169a0b626a682a58a3b998f68413657b4962c1fab05f1fdc2668e82727210"
	},
	"raised_hand_tone3": {
		"category": "people",
		"moji": "✋🏽",
		"unicodeVersion": "8.0",
		"digest": "3959a873ad7671de82c615c4ed840b011e67baafb2bab7dd16859608d3e83cb1"
	},
	"raised_hand_tone4": {
		"category": "people",
		"moji": "✋🏾",
		"unicodeVersion": "8.0",
		"digest": "db542f65d076ccf3dbfca27cb7c2f135a8bf7a487a81a04873e70172bdfcd579"
	},
	"raised_hand_tone5": {
		"category": "people",
		"moji": "✋🏿",
		"unicodeVersion": "8.0",
		"digest": "88ca884d14baaae48df21d75c22d82fb15bdc395e42026f5ca34cd65e5ae8674"
	},
	"raised_hands": {
		"category": "people",
		"moji": "🙌",
		"unicodeVersion": "6.0",
		"digest": "2ee73466a3f5079e542857fe6f5497e9f87753a81854985ce3356a8d3da1d8b8"
	},
	"raised_hands_tone1": {
		"category": "people",
		"moji": "🙌🏻",
		"unicodeVersion": "8.0",
		"digest": "43e73c60f040a66374b8ec98f3629a90d13ae9f472446ed7676cd5573e824f4b"
	},
	"raised_hands_tone2": {
		"category": "people",
		"moji": "🙌🏼",
		"unicodeVersion": "8.0",
		"digest": "fcc5255bb2b06dc82d6878e74cf34e8ce118c70004a06d39a980683772b98c52"
	},
	"raised_hands_tone3": {
		"category": "people",
		"moji": "🙌🏽",
		"unicodeVersion": "8.0",
		"digest": "3ee3e0aafef486e766a166935e8147fb75a7329cfebc96dec876cc45e83a8754"
	},
	"raised_hands_tone4": {
		"category": "people",
		"moji": "🙌🏾",
		"unicodeVersion": "8.0",
		"digest": "78a8cbf6b2b85be4d6b18f0ff6a77f197963117955725fb7e57e0441effb928f"
	},
	"raised_hands_tone5": {
		"category": "people",
		"moji": "🙌🏿",
		"unicodeVersion": "8.0",
		"digest": "2a5ed7334a17172db0cd820a559e7f75df40ec44de6c25d194c76e1b58c634cb"
	},
	"raising_hand": {
		"category": "people",
		"moji": "🙋",
		"unicodeVersion": "6.0",
		"digest": "512750b00704f1ccefd3c757743540b785ad7670dbbe4a2c4dca8d93e6701920"
	},
	"raising_hand_tone1": {
		"category": "people",
		"moji": "🙋🏻",
		"unicodeVersion": "8.0",
		"digest": "2897722f091c273dd3714cff7423c2475bc3070416c28014ca03322b9ece48bc"
	},
	"raising_hand_tone2": {
		"category": "people",
		"moji": "🙋🏼",
		"unicodeVersion": "8.0",
		"digest": "59199b334b3845911382c1f29bd7c0d5ef9d2486417345e265b166ead7d3e1c1"
	},
	"raising_hand_tone3": {
		"category": "people",
		"moji": "🙋🏽",
		"unicodeVersion": "8.0",
		"digest": "f95b338d5efcf14ef12f415a2c1bba93df48628ddc94f34f70c31e1b3c2e1d28"
	},
	"raising_hand_tone4": {
		"category": "people",
		"moji": "🙋🏾",
		"unicodeVersion": "8.0",
		"digest": "951ddbfdb57d5a60551b59b3d0f7ca00a64912f4a101a73afaebd68445cd6cec"
	},
	"raising_hand_tone5": {
		"category": "people",
		"moji": "🙋🏿",
		"unicodeVersion": "8.0",
		"digest": "9370f93704d8f89ca6dc946715eab5e7dba82bf04dd68c00f5c0abb8bc16371e"
	},
	"ram": {
		"category": "nature",
		"moji": "🐏",
		"unicodeVersion": "6.0",
		"digest": "2875ab28e1018b39062aeb0c5ce488c48a98f13e9f2364470a0a700b126604f2"
	},
	"ramen": {
		"category": "food",
		"moji": "🍜",
		"unicodeVersion": "6.0",
		"digest": "425662a49c4c13577c0de8d45d004e5ba204aaadbaabae62a5c283ecd7a9a2c5"
	},
	"rat": {
		"category": "nature",
		"moji": "🐀",
		"unicodeVersion": "6.0",
		"digest": "14380d65498c6ce037c02a93bca2b24f25a368d85278d6015b8c9f7cd261f8e2"
	},
	"record_button": {
		"category": "symbols",
		"moji": "⏺",
		"unicodeVersion": "7.0",
		"digest": "92be12161ba206bb2e06a39131711c7b17368d55b4aae0b48f0ac5b6b1cde76b"
	},
	"recycle": {
		"category": "symbols",
		"moji": "♻",
		"unicodeVersion": "3.2",
		"digest": "c377e8537367b05b5de9be860a0fcabd7aed2bf4ba146eefc423671a21530369"
	},
	"red_car": {
		"category": "travel",
		"moji": "🚗",
		"unicodeVersion": "6.0",
		"digest": "8a99832a195263c0e922af53d52dea37aa3e07032b3c2a1977f8527b4a144b9c"
	},
	"red_circle": {
		"category": "symbols",
		"moji": "🔴",
		"unicodeVersion": "6.0",
		"digest": "9dcf0132f6f2cc81702f0e3b15b37984e8439796705bf98f68ba449b3dfa5307"
	},
	"registered": {
		"category": "symbols",
		"moji": "®",
		"unicodeVersion": "1.1",
		"digest": "9661b1df529ecb752d130820c55c403e5de263748eb02f7fea327818bc282d94"
	},
	"relaxed": {
		"category": "people",
		"moji": "☺",
		"unicodeVersion": "1.1",
		"digest": "2d5aed4fb8504c6d6660ef8d3bfe0cc053dcd6099c2f53748c202dc970c639bc"
	},
	"relieved": {
		"category": "people",
		"moji": "😌",
		"unicodeVersion": "6.0",
		"digest": "b4ce2ba6c220d887fe5e333c05ed773df9b6df0ac456879fd8f5103ff68604a5"
	},
	"reminder_ribbon": {
		"category": "activity",
		"moji": "🎗",
		"unicodeVersion": "7.0",
		"digest": "c3de2a7c9350b77a0b86c0dcce9dcd9953ea8a97aa1e7aed149755924742f54d"
	},
	"repeat": {
		"category": "symbols",
		"moji": "🔁",
		"unicodeVersion": "6.0",
		"digest": "b9512d508613ed0eb3181eb1030f7f6fd6b994476ecdfa308733c6df975fb99e"
	},
	"repeat_one": {
		"category": "symbols",
		"moji": "🔂",
		"unicodeVersion": "6.0",
		"digest": "53409cf24dd4bb0d7b50ae359f15d06b87b7f4a292ed5c3a09652fa421a90bf2"
	},
	"restroom": {
		"category": "symbols",
		"moji": "🚻",
		"unicodeVersion": "6.0",
		"digest": "2e7a1bfc9a9d49b0272230a91db7369e24d54bf1de8e683d36b85f1d8c037f77"
	},
	"revolving_hearts": {
		"category": "symbols",
		"moji": "💞",
		"unicodeVersion": "6.0",
		"digest": "c43d3197cb4cf06659f643638f6c4e91a2889e0f6531b7d81ea826c2a8b784fc"
	},
	"rewind": {
		"category": "symbols",
		"moji": "⏪",
		"unicodeVersion": "6.0",
		"digest": "d20c918c1e528ff0947312738501ca9a6fb6ff4016aad07db7a8125d00fd65cd"
	},
	"rhino": {
		"category": "nature",
		"moji": "🦏",
		"unicodeVersion": "9.0",
		"digest": "163fa3acd78eead72c431a1f48b8465a6d45272a9169560e456d30b4df93dc6b"
	},
	"ribbon": {
		"category": "objects",
		"moji": "🎀",
		"unicodeVersion": "6.0",
		"digest": "74315fe907f9f0203afe139cd4552aa442eecfa2a64fac12db3e1292fc5a8828"
	},
	"rice": {
		"category": "food",
		"moji": "🍚",
		"unicodeVersion": "6.0",
		"digest": "f544f12606de59d28739798003f14ebd8869856add8e24496ec5dda3e131daf4"
	},
	"rice_ball": {
		"category": "food",
		"moji": "🍙",
		"unicodeVersion": "6.0",
		"digest": "2cba6f5364cd366859bc8948897b65fc97b225ea7973d9be3b24aba388fed8e8"
	},
	"rice_cracker": {
		"category": "food",
		"moji": "🍘",
		"unicodeVersion": "6.0",
		"digest": "ac0f805d41d4f322154c1968bd3ce3e9aabcd39d908182e52fd7d28458dbef92"
	},
	"rice_scene": {
		"category": "travel",
		"moji": "🎑",
		"unicodeVersion": "6.0",
		"digest": "b942a06d3da0570aca59bab0af57cd8c16863934f12a38f70339fd0a36f675f5"
	},
	"right_facing_fist": {
		"category": "people",
		"moji": "🤜",
		"unicodeVersion": "9.0",
		"digest": "f815d1cc0c0345ddcc8886ae9c133582d7dc779732ac9b93dde1ab4fdd3b251d"
	},
	"right_facing_fist_tone1": {
		"category": "people",
		"moji": "🤜🏻",
		"unicodeVersion": "9.0",
		"digest": "0f9269b70cf68071d97389e059a2bdacffd73f2afd2ce6cfd7447bb1a4e9abbb"
	},
	"right_facing_fist_tone2": {
		"category": "people",
		"moji": "🤜🏼",
		"unicodeVersion": "9.0",
		"digest": "32a9833db853972e49e65aa227fb0512c57362da190aa1cc40e1d64f238e837e"
	},
	"right_facing_fist_tone3": {
		"category": "people",
		"moji": "🤜🏽",
		"unicodeVersion": "9.0",
		"digest": "be4706f8bb088411f5cbbf9065a0ae5b773c97456bd975c2b6789765657847b9"
	},
	"right_facing_fist_tone4": {
		"category": "people",
		"moji": "🤜🏾",
		"unicodeVersion": "9.0",
		"digest": "1680862891a9d85c4b6f76232a80e2ef7428bcec93087c86eae2efaba9c6a3f7"
	},
	"right_facing_fist_tone5": {
		"category": "people",
		"moji": "🤜🏿",
		"unicodeVersion": "9.0",
		"digest": "388715a4bc2178c52bbb3bc2729f57be50acab5d751784c9f3220e86c6b1fbcc"
	},
	"ring": {
		"category": "people",
		"moji": "💍",
		"unicodeVersion": "6.0",
		"digest": "b5322907222797b5e1786209cda88513e76cd397a40f0a7da24847245c95ef9d"
	},
	"robot": {
		"category": "people",
		"moji": "🤖",
		"unicodeVersion": "8.0",
		"digest": "4d788e6ec89279588b036fca6b17f5a981291681df8f90306ecf5c039de40848"
	},
	"rocket": {
		"category": "travel",
		"moji": "🚀",
		"unicodeVersion": "6.0",
		"digest": "b82e68a95aa89a6de344d6e256fef86a848ebc91de560b043b3e1f7fd072d57d"
	},
	"rofl": {
		"category": "people",
		"moji": "🤣",
		"unicodeVersion": "9.0",
		"digest": "f4f99ba2ac67b97338f904f9384ff03fb832a2e427bf6e74611bf5fee45f1f48"
	},
	"roller_coaster": {
		"category": "travel",
		"moji": "🎢",
		"unicodeVersion": "6.0",
		"digest": "a65e9ace1d7900499777af1225995f17af90a398bb414764c20b6e09a8c23a2c"
	},
	"rolling_eyes": {
		"category": "people",
		"moji": "🙄",
		"unicodeVersion": "8.0",
		"digest": "23dea8100da488a05721a4e82823eb438393b0ea762211c9ecef011d127aa1b7"
	},
	"rooster": {
		"category": "nature",
		"moji": "🐓",
		"unicodeVersion": "6.0",
		"digest": "2b90c5cf6fa46da13eb77285443d600afcea0c48bd1d215d60167e7dc510da5d"
	},
	"rose": {
		"category": "nature",
		"moji": "🌹",
		"unicodeVersion": "6.0",
		"digest": "73799e459dba188de4de704605d824242feeb65d587c5bf9109acf528d037146"
	},
	"rosette": {
		"category": "activity",
		"moji": "🏵",
		"unicodeVersion": "7.0",
		"digest": "2537def4deef422d4e669b28b1a0675259306ab38601019df3ec3482b14e52d5"
	},
	"rotating_light": {
		"category": "travel",
		"moji": "🚨",
		"unicodeVersion": "6.0",
		"digest": "91fcdb85a752ae904d335a978c7e7936aed4c75d414b35219b5a74430e51555f"
	},
	"round_pushpin": {
		"category": "objects",
		"moji": "📍",
		"unicodeVersion": "6.0",
		"digest": "8ffca77bbdc6f1f726daf3abd6eff338a5ad1aa9b09dbbd8782c1e7ef5452f30"
	},
	"rowboat": {
		"category": "activity",
		"moji": "🚣",
		"unicodeVersion": "6.0",
		"digest": "83715d83a061926d4ad3bb569b21f5d337e3ebd4c9bcdfe493e661c12adc0a16"
	},
	"rowboat_tone1": {
		"category": "activity",
		"moji": "🚣🏻",
		"unicodeVersion": "8.0",
		"digest": "e279ac816442c0876fba1f42c700b80f2fb6de671e1a8a9e9d11b71eed5c58e8"
	},
	"rowboat_tone2": {
		"category": "activity",
		"moji": "🚣🏼",
		"unicodeVersion": "8.0",
		"digest": "6a48eba352ed4971d26498b6c622e5772389c89c5205ed02acde8e995dddcc3b"
	},
	"rowboat_tone3": {
		"category": "activity",
		"moji": "🚣🏽",
		"unicodeVersion": "8.0",
		"digest": "875948f6d8354ebd95ce9a66fde30f06a8366dcd89d5ca3e660845f8801e9305"
	},
	"rowboat_tone4": {
		"category": "activity",
		"moji": "🚣🏾",
		"unicodeVersion": "8.0",
		"digest": "8c7ac7346b0020d0ff5e2f4a1efb1b7785eac637f17556663ec33e2335083f0a"
	},
	"rowboat_tone5": {
		"category": "activity",
		"moji": "🚣🏿",
		"unicodeVersion": "8.0",
		"digest": "a399dbb647892b22323e0bf17bc36a9b5f1708ebedf9ba525233ee7b9d48339a"
	},
	"rugby_football": {
		"category": "activity",
		"moji": "🏉",
		"unicodeVersion": "6.0",
		"digest": "cc6f00ade3e0bbb7899e7bfb138b57216dd66de26d7967d5ffa501f382ed09f4"
	},
	"runner": {
		"category": "people",
		"moji": "🏃",
		"unicodeVersion": "6.0",
		"digest": "e9af7b591be60ade2049dbada0f062ba2d3e17f02bec76cbd34ce68854a2a10c"
	},
	"runner_tone1": {
		"category": "people",
		"moji": "🏃🏻",
		"unicodeVersion": "8.0",
		"digest": "21091cbb09c558712ecf63548bf28b7995df42bdb85235088799a517800e52f5"
	},
	"runner_tone2": {
		"category": "people",
		"moji": "🏃🏼",
		"unicodeVersion": "8.0",
		"digest": "1fe3d194f675a46fe67799394192e66c407dd81163363692c5e7da32ddb9af2b"
	},
	"runner_tone3": {
		"category": "people",
		"moji": "🏃🏽",
		"unicodeVersion": "8.0",
		"digest": "8cea1bf4ef3be71f42dc5bae978d5b7a197a3851543225349ef0dda29a370537"
	},
	"runner_tone4": {
		"category": "people",
		"moji": "🏃🏾",
		"unicodeVersion": "8.0",
		"digest": "c33f0b8b5a71d295fb6ba322e79446964a8eca9e4573efd591e4273808b088a0"
	},
	"runner_tone5": {
		"category": "people",
		"moji": "🏃🏿",
		"unicodeVersion": "8.0",
		"digest": "9f59e6dd0fdf2f17bceb41f5c355b4e6f3c8bb8cbd8af0992f0b5630ff8892e8"
	},
	"running_shirt_with_sash": {
		"category": "activity",
		"moji": "🎽",
		"unicodeVersion": "6.0",
		"digest": "7542307d3595aca45e8ccae66b6e58b6e92870144b738263d5379ec6dc992b76"
	},
	"sa": {
		"category": "symbols",
		"moji": "🈂",
		"unicodeVersion": "6.0",
		"digest": "6042bcabd1516ef3847d695aba22851c49421244432d256e24eba04e8a223dab"
	},
	"sagittarius": {
		"category": "symbols",
		"moji": "♐",
		"unicodeVersion": "1.1",
		"digest": "a02593e025023f2e82a01c587a8c0bbb1eff88cbcabf535a1558413eb32ed1d5"
	},
	"sailboat": {
		"category": "travel",
		"moji": "⛵",
		"unicodeVersion": "5.2",
		"digest": "c95ef4dc939cbdcb757ef3cd90331310e8c0a426add8cc800bae2540148a3195"
	},
	"sake": {
		"category": "food",
		"moji": "🍶",
		"unicodeVersion": "6.0",
		"digest": "0a786075f3d9da48ae91afccf6ae0d097888da9509d354ee1d3cb99afcc88fe4"
	},
	"salad": {
		"category": "food",
		"moji": "🥗",
		"unicodeVersion": "9.0",
		"digest": "fe321487ab847abe670e68a83f1d9e096129741c689c769ee7de4a65aeac29f8"
	},
	"sandal": {
		"category": "people",
		"moji": "👡",
		"unicodeVersion": "6.0",
		"digest": "03c3077cb4bd900934f9bdf921165b465e5cc9a6bee53e45a091411bceb8892d"
	},
	"santa": {
		"category": "people",
		"moji": "🎅",
		"unicodeVersion": "6.0",
		"digest": "178513e3d815917e59958870f5885b3414b43a16b8056980c863a468dfe00179"
	},
	"santa_tone1": {
		"category": "people",
		"moji": "🎅🏻",
		"unicodeVersion": "8.0",
		"digest": "bf900bbc19bbd329229add9326e28e8197b69d6ddceb69f42162b0200fde5d16"
	},
	"santa_tone2": {
		"category": "people",
		"moji": "🎅🏼",
		"unicodeVersion": "8.0",
		"digest": "7340f2171adab97198e3eecac8b0d84c4c2a41f84606301a0d10e9fe655c93d1"
	},
	"santa_tone3": {
		"category": "people",
		"moji": "🎅🏽",
		"unicodeVersion": "8.0",
		"digest": "7368ab75454ec28d8f7d6baef6ad69b5278445a9f50753f6624731bffde32054"
	},
	"santa_tone4": {
		"category": "people",
		"moji": "🎅🏾",
		"unicodeVersion": "8.0",
		"digest": "0ee60188353e0ee7772079c192bebbc6d49e74e63906f840c66da4eb35f4f245"
	},
	"santa_tone5": {
		"category": "people",
		"moji": "🎅🏿",
		"unicodeVersion": "8.0",
		"digest": "e4378a0cc5d21e9b9fe6e35c32d1ebc6fb8c2e1c09554cd096aeaefd3a6eb511"
	},
	"satellite": {
		"category": "objects",
		"moji": "📡",
		"unicodeVersion": "6.0",
		"digest": "c9d63118dcb445856917bb080460ab695cc78e715dcbba30ba18dffa9e906b27"
	},
	"satellite_orbital": {
		"category": "travel",
		"moji": "🛰",
		"unicodeVersion": "7.0",
		"digest": "beb2f50e7f2b010e76bed9daa95d7329a93c783d3ebc4f0b797dd721c5e3d32d"
	},
	"saxophone": {
		"category": "activity",
		"moji": "🎷",
		"unicodeVersion": "6.0",
		"digest": "dfd138634f6702a3b89b5a2a50016720eef3f800b0d1d8c9fe097808c9491e96"
	},
	"scales": {
		"category": "objects",
		"moji": "⚖",
		"unicodeVersion": "4.1",
		"digest": "2280c026f16c6b92e0daa00bc14e718770f8d231c571ab439bde84d837cf31cc"
	},
	"school": {
		"category": "travel",
		"moji": "🏫",
		"unicodeVersion": "6.0",
		"digest": "af198b068a86ccad3daec4c6873e6b4735086c1ecbb3848182e70bae9aa3ee24"
	},
	"school_satchel": {
		"category": "people",
		"moji": "🎒",
		"unicodeVersion": "6.0",
		"digest": "f670ae8aea67eb9d8aaa0bf2748c1cc3e503dcc1dbe999133afcdf21af046b24"
	},
	"scissors": {
		"category": "objects",
		"moji": "✂",
		"unicodeVersion": "1.1",
		"digest": "95225be28f05d8b5a6b6e6bf58d973f61f183ad4fef55a558dc1b810796b85c8"
	},
	"scooter": {
		"category": "travel",
		"moji": "🛴",
		"unicodeVersion": "9.0",
		"digest": "4a7db148880398db75e059711cb53edefb6b8fa9d442009f52856b887ab1dde4"
	},
	"scorpion": {
		"category": "nature",
		"moji": "🦂",
		"unicodeVersion": "8.0",
		"digest": "d41119d1ea5daf727c17dbea7dadec1718c72fc9f98ae88252161df5fde0938a"
	},
	"scorpius": {
		"category": "symbols",
		"moji": "♏",
		"unicodeVersion": "1.1",
		"digest": "a36404b408814c2ecb8fa8b61f5c5432dfcf54cae8c09cc67b8d0fadf7cbdc03"
	},
	"scream": {
		"category": "people",
		"moji": "😱",
		"unicodeVersion": "6.0",
		"digest": "916e4903a4b694da4b00f190f872a4e100e7736b7a2e6171fa1636f46bf646e6"
	},
	"scream_cat": {
		"category": "people",
		"moji": "🙀",
		"unicodeVersion": "6.0",
		"digest": "f1d3a6ff538064e7d5e0321bbc33aba44e8da703dc1894ef1403c0cd6d63d781"
	},
	"scroll": {
		"category": "objects",
		"moji": "📜",
		"unicodeVersion": "6.0",
		"digest": "9b2cb00860bcc2d20017cafb2ed9681b6232dc07273d489d75d53ce29e4ba3ab"
	},
	"seat": {
		"category": "travel",
		"moji": "💺",
		"unicodeVersion": "6.0",
		"digest": "ae68d86fc2a07cae332451b23bd1ceba3f6526a6c56d8c1089777fa4632850e1"
	},
	"second_place": {
		"category": "activity",
		"moji": "🥈",
		"unicodeVersion": "9.0",
		"digest": "9e2336fc16e532829b55380252f94655b58817d47c909fc2570002c5b06b9c40"
	},
	"secret": {
		"category": "symbols",
		"moji": "㊙",
		"unicodeVersion": "1.1",
		"digest": "1d0b9adde2657f41421b135962de20820cf4b4eb0204044f9859522ab9d211b0"
	},
	"see_no_evil": {
		"category": "nature",
		"moji": "🙈",
		"unicodeVersion": "6.0",
		"digest": "3ff66d2e84b36d071d0a34f8e41cfd620a56b83131474ea50ed7803b635551ed"
	},
	"seedling": {
		"category": "nature",
		"moji": "🌱",
		"unicodeVersion": "6.0",
		"digest": "c0ec5e6d20e1afdc4e78eeddb1301c8b708ad6278e7287a4e4e825417c858e75"
	},
	"selfie": {
		"category": "people",
		"moji": "🤳",
		"unicodeVersion": "9.0",
		"digest": "2a1bc9f18ad4d6fb893d91c88ef1b2d9bd063dc2bb1a4b08c248c30f52545d4e"
	},
	"selfie_tone1": {
		"category": "people",
		"moji": "🤳🏻",
		"unicodeVersion": "9.0",
		"digest": "26dc212ffed30c276bd6a66a72bc4513e68098a2205fb4ca5b51ccfa1de5b544"
	},
	"selfie_tone2": {
		"category": "people",
		"moji": "🤳🏼",
		"unicodeVersion": "9.0",
		"digest": "71eceaefda46e3521f374f76693e7fa8f215067498067900080e2925ca94d7de"
	},
	"selfie_tone3": {
		"category": "people",
		"moji": "🤳🏽",
		"unicodeVersion": "9.0",
		"digest": "53eabbd4f6b8ebbd2f7af7bf5cd64309c4039ac1c5b2180290a547deaafcebdf"
	},
	"selfie_tone4": {
		"category": "people",
		"moji": "🤳🏾",
		"unicodeVersion": "9.0",
		"digest": "0baad378b09652b99c5d458db2e03b4db14a1557db4ea0969806a0ca1d33d40c"
	},
	"selfie_tone5": {
		"category": "people",
		"moji": "🤳🏿",
		"unicodeVersion": "9.0",
		"digest": "9a07608f34ec4dad48764a855f83f3965709d7b2fd2342e6dc9ed61f23f4adfd"
	},
	"seven": {
		"category": "symbols",
		"moji": "7️⃣",
		"unicodeVersion": "3.0",
		"digest": "ae85172d2c76c44afb4e3b45d277d400abb2dc895244b9abfbd1dac1cd7c53c2"
	},
	"shallow_pan_of_food": {
		"category": "food",
		"moji": "🥘",
		"unicodeVersion": "9.0",
		"digest": "7c7ad9d5d3f7226427d310b5853e8257fad899febe58dcbc5adb4677964f5c6d"
	},
	"shamrock": {
		"category": "nature",
		"moji": "☘",
		"unicodeVersion": "4.1",
		"digest": "68ed70c26e04a818439a1742d2da6bc169edd02db86b6e6f8014b651f3235488"
	},
	"shark": {
		"category": "nature",
		"moji": "🦈",
		"unicodeVersion": "9.0",
		"digest": "23a2364b6356e7bbb84c138e9cf58e2c68cd8caabb337a0c4d365ce87bf5d2da"
	},
	"shaved_ice": {
		"category": "food",
		"moji": "🍧",
		"unicodeVersion": "6.0",
		"digest": "54048e77268b7548d03088517bf8558d11324db901ca57f9bec93f1873663a74"
	},
	"sheep": {
		"category": "nature",
		"moji": "🐑",
		"unicodeVersion": "6.0",
		"digest": "c867c8e6e51768f1f51f4fe5abd3fbd5c1d69b01a3cb48b5fb94b6e2338a271c"
	},
	"shell": {
		"category": "nature",
		"moji": "🐚",
		"unicodeVersion": "6.0",
		"digest": "8983652d33ad6ab91195518cecb5a268a1c0ae603d271f0ddd756ff50058ddb3"
	},
	"shield": {
		"category": "objects",
		"moji": "🛡",
		"unicodeVersion": "7.0",
		"digest": "763d0a56a62c51c730ccb0fbea38ab597cbf41a85ab968198e6ec35630d50aa5"
	},
	"shinto_shrine": {
		"category": "travel",
		"moji": "⛩",
		"unicodeVersion": "5.2",
		"digest": "38a6d756c5aa9703510afa5076d75192f7814bbb6632394d4b8253d9ceda7f8c"
	},
	"ship": {
		"category": "travel",
		"moji": "🚢",
		"unicodeVersion": "6.0",
		"digest": "79c680845892a3e81ec6af2160ee07c29147155943e5daba6c76d04252014c20"
	},
	"shirt": {
		"category": "people",
		"moji": "👕",
		"unicodeVersion": "6.0",
		"digest": "46c7253e15d7cac03699ddb1550fbb7565bbe487310f7e218c0583aa69f9d3c5"
	},
	"shopping_bags": {
		"category": "objects",
		"moji": "🛍",
		"unicodeVersion": "7.0",
		"digest": "95a3f03c675207bb1354270d02a630c204455c47b3edca23c48523a40cf3ea3b"
	},
	"shopping_cart": {
		"category": "objects",
		"moji": "🛒",
		"unicodeVersion": "9.0",
		"digest": "4599b63f6861cdb4d8272cac84435c24c1d4d6a73c66d51e04a1cd14a1d333e6"
	},
	"shower": {
		"category": "objects",
		"moji": "🚿",
		"unicodeVersion": "6.0",
		"digest": "6b3c767c0eb472d4861c6c3cc2735a5e2c09681872ef42a11dc89f3c80b9da01"
	},
	"shrimp": {
		"category": "nature",
		"moji": "🦐",
		"unicodeVersion": "9.0",
		"digest": "b3651f3be3767125076a013fe903854f5b456a8afae865cb219cf528e0f44caa"
	},
	"shrug": {
		"category": "people",
		"moji": "🤷",
		"unicodeVersion": "9.0",
		"digest": "6e264243cc3b6e396069dea4357a958bdcd4081cb1af0ed6aa47235bef88cf27"
	},
	"shrug_tone1": {
		"category": "people",
		"moji": "🤷🏻",
		"unicodeVersion": "9.0",
		"digest": "0567b9fd95c8a857914003a5465a500ca79c8111811d45b865021b1b1d92d0b1"
	},
	"shrug_tone2": {
		"category": "people",
		"moji": "🤷🏼",
		"unicodeVersion": "9.0",
		"digest": "1557c2f5e3d4599c806d74c0b78afcca940678787534b6862bb89a20601bac8a"
	},
	"shrug_tone3": {
		"category": "people",
		"moji": "🤷🏽",
		"unicodeVersion": "9.0",
		"digest": "f02754541a7bf74ba7eebe6c27daf1e3e1dac25172c35b8ba45641e278dfda3d"
	},
	"shrug_tone4": {
		"category": "people",
		"moji": "🤷🏾",
		"unicodeVersion": "9.0",
		"digest": "2b5121164cb5f4e253d8fb31f6445cf8afaf30dba41732edc511440cdb78d15c"
	},
	"shrug_tone5": {
		"category": "people",
		"moji": "🤷🏿",
		"unicodeVersion": "9.0",
		"digest": "62d99a26bbad479f574f66208c41b9960cd41fb9d79d3a13fbdaa44682077115"
	},
	"signal_strength": {
		"category": "symbols",
		"moji": "📶",
		"unicodeVersion": "6.0",
		"digest": "2c6f04ba4ecd2d2d423e19eb52cfbfd253f4db6e0908d91c1af4ea6192597447"
	},
	"six": {
		"category": "symbols",
		"moji": "6️⃣",
		"unicodeVersion": "3.0",
		"digest": "cede9324261208d0fd5d00fcdfc0df0331944bd9cff4f40b30a582a641526c1c"
	},
	"six_pointed_star": {
		"category": "symbols",
		"moji": "🔯",
		"unicodeVersion": "6.0",
		"digest": "9203e3b4f08af439ae0bfb6a7b29a02dceb027b6c2dc5463b524dfd314cbff4e"
	},
	"ski": {
		"category": "activity",
		"moji": "🎿",
		"unicodeVersion": "6.0",
		"digest": "80f0ca8660ba373fef823af9e98e148c4ddb1e217eb6d0a0ea2bae2288b57570"
	},
	"skier": {
		"category": "activity",
		"moji": "⛷",
		"unicodeVersion": "5.2",
		"digest": "4fff0aa155367f551a59aed9657b8afa159173882b25db9cd8434293d1eed76d"
	},
	"skull": {
		"category": "people",
		"moji": "💀",
		"unicodeVersion": "6.0",
		"digest": "cdd2031164281bf2b0083df4479651d96bc16d11e44bac4deaf402a9c0d6f40a"
	},
	"skull_crossbones": {
		"category": "objects",
		"moji": "☠",
		"unicodeVersion": "1.1",
		"digest": "ae764ba21a1fcc4409f4cc9e75a261d70b87548f64158dbd3451374ad5724123"
	},
	"sleeping": {
		"category": "people",
		"moji": "😴",
		"unicodeVersion": "6.1",
		"digest": "1050a011509b56735c9f30a6fccc876256e2a4546dc6052e518151c8aca4b526"
	},
	"sleeping_accommodation": {
		"category": "objects",
		"moji": "🛌",
		"unicodeVersion": "7.0",
		"digest": "2ce42c027d1d0947abc403c359fd668a7bc44f5ead2582e97f3db7dd4e22e5d5"
	},
	"sleepy": {
		"category": "people",
		"moji": "😪",
		"unicodeVersion": "6.0",
		"digest": "2ee9bb1f72ef99e0e33095ec2bbf7a58ffea0ff7d40b840f4cdba57be9de74b0"
	},
	"slight_frown": {
		"category": "people",
		"moji": "🙁",
		"unicodeVersion": "7.0",
		"digest": "d71d564a6c2d366a8e28a78ef4e07d387a77037fe8c99aa0ea1571299dc490c9"
	},
	"slight_smile": {
		"category": "people",
		"moji": "🙂",
		"unicodeVersion": "7.0",
		"digest": "10f4b66a755f5c78762a330f20d1866e4a22f3f1d495161d758d3bab8d2f36fe"
	},
	"slot_machine": {
		"category": "activity",
		"moji": "🎰",
		"unicodeVersion": "6.0",
		"digest": "914184788f8cd865cd074dca25c22acee31f5498117bd9a6e78cae67e6601652"
	},
	"small_blue_diamond": {
		"category": "symbols",
		"moji": "🔹",
		"unicodeVersion": "6.0",
		"digest": "0b56d8e6b5ddf1f49fcc76e45e5fb2ee9f99ae6ffe682c26eaea4d9b7faac36c"
	},
	"small_orange_diamond": {
		"category": "symbols",
		"moji": "🔸",
		"unicodeVersion": "6.0",
		"digest": "a2235830550e289c1608f2dcf5ede48f5c1a0eff45570699c39708c9677ab950"
	},
	"small_red_triangle": {
		"category": "symbols",
		"moji": "🔺",
		"unicodeVersion": "6.0",
		"digest": "8c2985c4e9ce42d2f3b35539b879bc36206c5ef749f39fbd1eac51bd2676e1e5"
	},
	"small_red_triangle_down": {
		"category": "symbols",
		"moji": "🔻",
		"unicodeVersion": "6.0",
		"digest": "46bd328df2fbf5d0597596bbf00d2d5f6e0c65bcb8f3fb325df8ba0c25e445b5"
	},
	"smile": {
		"category": "people",
		"moji": "😄",
		"unicodeVersion": "6.0",
		"digest": "14905c372d5bf7719bd727c9efae31a03291acec79801652a23710c6848c5d14"
	},
	"smile_cat": {
		"category": "people",
		"moji": "😸",
		"unicodeVersion": "6.0",
		"digest": "c35b76d6df100edb4022d762f47abfeb9f5e70886960c1d25908bd5d57ccb47e"
	},
	"smiley": {
		"category": "people",
		"moji": "😃",
		"unicodeVersion": "6.0",
		"digest": "a89f31eb9d814636852517a7f4eadec59195e2ac2cc9f8d124f1a1cc0f775b4a"
	},
	"smiley_cat": {
		"category": "people",
		"moji": "😺",
		"unicodeVersion": "6.0",
		"digest": "3e66a113c5e3e73fb94be29084cb27986b6bdb0e78ab44785bf2a35a550e71bf"
	},
	"smiling_imp": {
		"category": "people",
		"moji": "😈",
		"unicodeVersion": "6.0",
		"digest": "3e02131d16525938f6facc7e097365dec7e13c8a0049a3be35fc29c80cc291b3"
	},
	"smirk": {
		"category": "people",
		"moji": "😏",
		"unicodeVersion": "6.0",
		"digest": "3c180d46f5574d6fca3bb68eb02517da60b7008843cb3e90f2f9620d0c8ee943"
	},
	"smirk_cat": {
		"category": "people",
		"moji": "😼",
		"unicodeVersion": "6.0",
		"digest": "0683c7f73e1f65984e91313607d7cca21d99acd4b2e9932f00e0fffd0ce90742"
	},
	"smoking": {
		"category": "objects",
		"moji": "🚬",
		"unicodeVersion": "6.0",
		"digest": "baa9cb444bf0fe5c74358f981b19bc9e5c0415ced7f042baf93642282476ea61"
	},
	"snail": {
		"category": "nature",
		"moji": "🐌",
		"unicodeVersion": "6.0",
		"digest": "5733bf3672ae4b2b3e090fa670aeac70dcbcc04ca5b13abc8c8e53b8b3d4ff33"
	},
	"snake": {
		"category": "nature",
		"moji": "🐍",
		"unicodeVersion": "6.0",
		"digest": "18da2d97c771149ef5454dd23470e900903a62ab93f9e2ce301aad5a8181d773"
	},
	"sneezing_face": {
		"category": "people",
		"moji": "🤧",
		"unicodeVersion": "9.0",
		"digest": "c20ef571dc7e35572fe3c18b7845aefc89af083ea925c48a29de3b7387af6e17"
	},
	"snowboarder": {
		"category": "activity",
		"moji": "🏂",
		"unicodeVersion": "6.0",
		"digest": "c6e074139b851aa53b1ba6464d84da14b3da7412fc44c6c196a8469d76915c19"
	},
	"snowflake": {
		"category": "nature",
		"moji": "❄",
		"unicodeVersion": "1.1",
		"digest": "6556c918e181df01ba849e76c43972d5310439971e5d8fc2409d112c05bf0028"
	},
	"snowman": {
		"category": "nature",
		"moji": "⛄",
		"unicodeVersion": "5.2",
		"digest": "6137456b2335e88e09c1859615eb22bb636355ef438f7a3949ad2f3d54478dd3"
	},
	"snowman2": {
		"category": "nature",
		"moji": "☃",
		"unicodeVersion": "1.1",
		"digest": "33ec75c22a13c81fa3c6b24a77ac1a08dc0dbe70b3716cf17b6702014d8a63fe"
	},
	"sob": {
		"category": "people",
		"moji": "😭",
		"unicodeVersion": "6.0",
		"digest": "d1ed4b31861f9f9fd4e9c95a9c17530e2320a1b4cad6ececb1545ce25d65e4ce"
	},
	"soccer": {
		"category": "activity",
		"moji": "⚽",
		"unicodeVersion": "5.2",
		"digest": "6a3f2e6a9a0b64c3fbf8705995792091daf386a4112dba75507a1f556f662f84"
	},
	"soon": {
		"category": "symbols",
		"moji": "🔜",
		"unicodeVersion": "6.0",
		"digest": "a49d1bcfbac3e6ccc05b9a9863eff74b0eb8b4d4b22b8b0f7b2787fcba1c73cc"
	},
	"sos": {
		"category": "symbols",
		"moji": "🆘",
		"unicodeVersion": "6.0",
		"digest": "2fa7e0274383aeed6019eb9177e778d7aab8b88575b078b0ffeb77cd18df14b3"
	},
	"sound": {
		"category": "symbols",
		"moji": "🔉",
		"unicodeVersion": "6.0",
		"digest": "faaca7b315b2495cbc381468580d25f1d11362441c35bb43d8a914f2ec8202d2"
	},
	"space_invader": {
		"category": "activity",
		"moji": "👾",
		"unicodeVersion": "6.0",
		"digest": "e75379cb5063f9a8861d762ad1886097c1697fbb61f2e4e8f531047955a4a2dd"
	},
	"spades": {
		"category": "symbols",
		"moji": "♠",
		"unicodeVersion": "1.1",
		"digest": "2c4d20f6a4893cfc62498d3f1f8f67577f39ed09f3e6682d8cb9cd8f365d30da"
	},
	"spaghetti": {
		"category": "food",
		"moji": "🍝",
		"unicodeVersion": "6.0",
		"digest": "6d3451dc0faa1913539edb99261448f51735f269b61193c53dfe63466c0191e8"
	},
	"sparkle": {
		"category": "symbols",
		"moji": "❇",
		"unicodeVersion": "1.1",
		"digest": "7131163cd6c2f879110c86e9f068c33cf580f7c4b619449c41851fe6083402ee"
	},
	"sparkler": {
		"category": "travel",
		"moji": "🎇",
		"unicodeVersion": "6.0",
		"digest": "88539ed8a13bd66e0c265c0913bd3ec2ddc4d95484323595713beb102221a1f6"
	},
	"sparkles": {
		"category": "nature",
		"moji": "✨",
		"unicodeVersion": "6.0",
		"digest": "cf84d16b1c0a381d5a7ae79031872747c9a6887eab6e92cc4a10a4b8600ef506"
	},
	"sparkling_heart": {
		"category": "symbols",
		"moji": "💖",
		"unicodeVersion": "6.0",
		"digest": "b80b1ddef83b6528b309a194f6f2faf5acab603daeb9254523efc2b941bcb6d2"
	},
	"speak_no_evil": {
		"category": "nature",
		"moji": "🙊",
		"unicodeVersion": "6.0",
		"digest": "d2d7cfb4d471928a496bdc146890adc8422a68500b68115630b24c125d18e81f"
	},
	"speaker": {
		"category": "symbols",
		"moji": "🔈",
		"unicodeVersion": "6.0",
		"digest": "dbca5f7181728d2ad67ff76fd566ffbdf53e333e7eeed341f54668bd47969413"
	},
	"speaking_head": {
		"category": "people",
		"moji": "🗣",
		"unicodeVersion": "7.0",
		"digest": "4be1af79b4506c00af4df64663413bcbae195dab0bc63c5011feb8f9663ed544"
	},
	"speech_balloon": {
		"category": "symbols",
		"moji": "💬",
		"unicodeVersion": "6.0",
		"digest": "817100d9979456e7d2f253ac22e13b7a2302dc1590566214915b003e403c53ca"
	},
	"speedboat": {
		"category": "travel",
		"moji": "🚤",
		"unicodeVersion": "6.0",
		"digest": "a523b2320f0b24be1e9fdbc1ff828e28d8fd9a64d51e5888ab453ef0bc9f0576"
	},
	"spider": {
		"category": "nature",
		"moji": "🕷",
		"unicodeVersion": "7.0",
		"digest": "8411eac0c1b80926fd93cc1d6423e00b05d04c485b79ee232da8f1714e899a37"
	},
	"spider_web": {
		"category": "nature",
		"moji": "🕸",
		"unicodeVersion": "7.0",
		"digest": "2434bdfbe56dcc4a43699dd59b638af431486b52fb1d6d685451f3b231b2be23"
	},
	"spoon": {
		"category": "food",
		"moji": "🥄",
		"unicodeVersion": "9.0",
		"digest": "4fa31d59e5bffd2c45a8e01fcd5652e78a5691cbfa744e69882bc67173ddea05"
	},
	"spy": {
		"category": "people",
		"moji": "🕵",
		"unicodeVersion": "7.0",
		"digest": "99fe3cdeff934726ee5855b0e401bf32570084aaad4eb10df837fd410ca742aa"
	},
	"spy_tone1": {
		"category": "people",
		"moji": "🕵🏻",
		"unicodeVersion": "8.0",
		"digest": "1720a99064061c43c7647b6bd517efa2ee2621b355a644adfb347d62849366a2"
	},
	"spy_tone2": {
		"category": "people",
		"moji": "🕵🏼",
		"unicodeVersion": "8.0",
		"digest": "23ff0026723f2b5a46fbfb55e24c4a4a33af2bd96808b3ea3af76aae99965d68"
	},
	"spy_tone3": {
		"category": "people",
		"moji": "🕵🏽",
		"unicodeVersion": "8.0",
		"digest": "1d0cb3d54fb61e4763a4f0642ef32094bdd40832be0d42799ce9ba69773616df"
	},
	"spy_tone4": {
		"category": "people",
		"moji": "🕵🏾",
		"unicodeVersion": "8.0",
		"digest": "e36a4b52df6cb954fab9d9128111f1301c6d46bdeacf51993ffb5bb354cd0ad3"
	},
	"spy_tone5": {
		"category": "people",
		"moji": "🕵🏿",
		"unicodeVersion": "8.0",
		"digest": "ffc6fefd9a537124ebf0a9ddf387414dce1291335026064644f6cf9315591129"
	},
	"squid": {
		"category": "nature",
		"moji": "🦑",
		"unicodeVersion": "9.0",
		"digest": "65a1b318c2c506b9d26cfd8282a5cf9922109595c8d12e92c3f7481ac7c08c49"
	},
	"stadium": {
		"category": "travel",
		"moji": "🏟",
		"unicodeVersion": "7.0",
		"digest": "73bf955e767ba1518c9c92b2ba59a2aa1ec4b018652dffd97bcd74832a33789f"
	},
	"star": {
		"category": "nature",
		"moji": "⭐",
		"unicodeVersion": "5.1",
		"digest": "d78e5c1b78caed103e100150c10b08a9ca3ee30c243943d6fc3cc08f422122e9"
	},
	"star2": {
		"category": "nature",
		"moji": "🌟",
		"unicodeVersion": "6.0",
		"digest": "f91ac4afe3f5d4a52847ae8b4a9704b591e00399aebba553d150d7e34ee939fa"
	},
	"star_and_crescent": {
		"category": "symbols",
		"moji": "☪",
		"unicodeVersion": "1.1",
		"digest": "1bf3d29e50034f5e7c0dccff0a3a533b74bfa9b489e357b2739a473311f1332a"
	},
	"star_of_david": {
		"category": "symbols",
		"moji": "✡",
		"unicodeVersion": "1.1",
		"digest": "28a0bd0eeac9d0835ceb8425d72c2472464e863dd09b76a0ddc1c08cf1986402"
	},
	"stars": {
		"category": "travel",
		"moji": "🌠",
		"unicodeVersion": "6.0",
		"digest": "837d9045316b8fb5e533457eac61241534f641eb78d8cb75f688f80fb8e8a7f0"
	},
	"station": {
		"category": "travel",
		"moji": "🚉",
		"unicodeVersion": "6.0",
		"digest": "27a163ac0aea4ed247a121cae826eafc475977c68b0d888e9405bea14326ff56"
	},
	"statue_of_liberty": {
		"category": "travel",
		"moji": "🗽",
		"unicodeVersion": "6.0",
		"digest": "f5a43599ab3f24ed3a78a745e06e2ac3e33107a292386ad81c67935ee5b22493"
	},
	"steam_locomotive": {
		"category": "travel",
		"moji": "🚂",
		"unicodeVersion": "6.0",
		"digest": "52ad0073f37b978faf3884fb193046f2b0614e1557bbcc9de1b020e42aff2dba"
	},
	"stew": {
		"category": "food",
		"moji": "🍲",
		"unicodeVersion": "6.0",
		"digest": "c16f61236db314ad8d9f2dd241ec1e15c8d64e5872cce93ec4d0996490dd39df"
	},
	"stop_button": {
		"category": "symbols",
		"moji": "⏹",
		"unicodeVersion": "7.0",
		"digest": "83f9d0da3ad845fef41b4e8336815d30e9c8f042ab2a8340894ade2f428fc98a"
	},
	"stopwatch": {
		"category": "objects",
		"moji": "⏱",
		"unicodeVersion": "6.0",
		"digest": "9b6b9491a24d8ab4f896eb876da7973f028bd5e7c51a3767ba7e61bb6fbb2be0"
	},
	"straight_ruler": {
		"category": "objects",
		"moji": "📏",
		"unicodeVersion": "6.0",
		"digest": "cee31101767bd3f961363599924dc3790675d05a1285a8396428d2f91771c111"
	},
	"strawberry": {
		"category": "food",
		"moji": "🍓",
		"unicodeVersion": "6.0",
		"digest": "5750a15e12f21259286ddbc3a8222a385b3b97a9f368897f42dd000060343174"
	},
	"stuck_out_tongue": {
		"category": "people",
		"moji": "😛",
		"unicodeVersion": "6.1",
		"digest": "92dc42980a6dfdd7204fc874a762d6a0bbf0fdbfb5a7c0698fca04782e99fde6"
	},
	"stuck_out_tongue_closed_eyes": {
		"category": "people",
		"moji": "😝",
		"unicodeVersion": "6.0",
		"digest": "434d25ac24cad7ba699eae876a25d9a99b584449cca50b124bf6aa7f20a83d51"
	},
	"stuck_out_tongue_winking_eye": {
		"category": "people",
		"moji": "😜",
		"unicodeVersion": "6.0",
		"digest": "dbacd6428a2a2933212e6a4dc0c7f302177fb23b963626ccb26f27f91737f03d"
	},
	"stuffed_flatbread": {
		"category": "food",
		"moji": "🥙",
		"unicodeVersion": "9.0",
		"digest": "9f841f2520640d69be4f20a3199023d5811842b28556b5e1152e5ec11f0fda07"
	},
	"sun_with_face": {
		"category": "nature",
		"moji": "🌞",
		"unicodeVersion": "6.0",
		"digest": "7256ff5263006c64c03f1eb66e3ddb56d67d785d65dacc37aa886d0cd4be63be"
	},
	"sunflower": {
		"category": "nature",
		"moji": "🌻",
		"unicodeVersion": "6.0",
		"digest": "27d1161f50f932a6b26c404cf2e8f7083683ed0f2382d62b7472acccaa6eb695"
	},
	"sunglasses": {
		"category": "people",
		"moji": "😎",
		"unicodeVersion": "6.0",
		"digest": "966684382e5c59e98319e4c0ea7c304c61c2638ad5408faa49ce2c83c4416757"
	},
	"sunny": {
		"category": "nature",
		"moji": "☀",
		"unicodeVersion": "1.1",
		"digest": "460fea4cbbdd1595450c1033a2ee5de7fea2e2f147822efa49f7e204812415aa"
	},
	"sunrise": {
		"category": "travel",
		"moji": "🌅",
		"unicodeVersion": "6.0",
		"digest": "7718a49636b0cdd1862ed67c7a9d6e72f471c2591ff0d912485b1be55d1ea115"
	},
	"sunrise_over_mountains": {
		"category": "travel",
		"moji": "🌄",
		"unicodeVersion": "6.0",
		"digest": "743d0701cdbe2a814962363813c3153d3c5e62c3e410349f56d49dbb9581f356"
	},
	"surfer": {
		"category": "activity",
		"moji": "🏄",
		"unicodeVersion": "6.0",
		"digest": "bb440775e9213430942015c37db8de58b5a561ee971b2a0f3993fc3f1d2554d4"
	},
	"surfer_tone1": {
		"category": "activity",
		"moji": "🏄🏻",
		"unicodeVersion": "8.0",
		"digest": "a4937b030aca30b68bb644f37cf63c38aebce3c00b57d1c8a0ffe596b57d2f1e"
	},
	"surfer_tone2": {
		"category": "activity",
		"moji": "🏄🏼",
		"unicodeVersion": "8.0",
		"digest": "1c2a954a9c5284dedf0327d6f3c954c9fdd3953b848076d298874775ad8bf0a3"
	},
	"surfer_tone3": {
		"category": "activity",
		"moji": "🏄🏽",
		"unicodeVersion": "8.0",
		"digest": "418a3408b9ab026124f067c8597b500217e56bc28d9844a29eea5eee6f604ff8"
	},
	"surfer_tone4": {
		"category": "activity",
		"moji": "🏄🏾",
		"unicodeVersion": "8.0",
		"digest": "530870b9ac9f4d45ff750e264feb90b44fb93ca2852f323987b06f5f12fb5a4d"
	},
	"surfer_tone5": {
		"category": "activity",
		"moji": "🏄🏿",
		"unicodeVersion": "8.0",
		"digest": "40e11b1ae652cfd085d083377f1da24160065ed1b67403c6fa4655e6e44169ec"
	},
	"sushi": {
		"category": "food",
		"moji": "🍣",
		"unicodeVersion": "6.0",
		"digest": "b924c621236ca3284b349b0509ae1043f2fc2c7f6d67615716f9717ada78c992"
	},
	"suspension_railway": {
		"category": "travel",
		"moji": "🚟",
		"unicodeVersion": "6.0",
		"digest": "cd3d21da79864f0c018b863e82fb0561fff3c5e3c065303cfcb89c3663d638ba"
	},
	"sweat": {
		"category": "people",
		"moji": "😓",
		"unicodeVersion": "6.0",
		"digest": "1aa771479aa1ac5eeea4bafbe93ebd85a0f692f6d869034f31e25b689c2e264d"
	},
	"sweat_drops": {
		"category": "nature",
		"moji": "💦",
		"unicodeVersion": "6.0",
		"digest": "b575b85415bc9852cf6415d417ebf799167fde03c6819ebcaa24ae1b3dde8dab"
	},
	"sweat_smile": {
		"category": "people",
		"moji": "😅",
		"unicodeVersion": "6.0",
		"digest": "171b0d0845d46c33bedb6d3b39fb1ff366e22ba90685eedabebd91bb2b0680de"
	},
	"sweet_potato": {
		"category": "food",
		"moji": "🍠",
		"unicodeVersion": "6.0",
		"digest": "4b91920f0b87d42763313bc476f4c821a74e4c12dc1c92165a859dddeaaf8844"
	},
	"swimmer": {
		"category": "activity",
		"moji": "🏊",
		"unicodeVersion": "6.0",
		"digest": "2c4ed4a51aad99d9957ae11a219d5164db9748fc3a65002c6085a9f15adfa9e2"
	},
	"swimmer_tone1": {
		"category": "activity",
		"moji": "🏊🏻",
		"unicodeVersion": "8.0",
		"digest": "48588f129ee4af52ca2e0f4594213391978601087cd607896b2f979ca077284b"
	},
	"swimmer_tone2": {
		"category": "activity",
		"moji": "🏊🏼",
		"unicodeVersion": "8.0",
		"digest": "fff209448524bd1ef4d6decabf6c1ead94c8d3d5b1bfb5e54f20cc8e139232fc"
	},
	"swimmer_tone3": {
		"category": "activity",
		"moji": "🏊🏽",
		"unicodeVersion": "8.0",
		"digest": "2003932cb2cf4ae9a10b23338bf375a9293fb18c0ecf91bdfae73be6eebb3800"
	},
	"swimmer_tone4": {
		"category": "activity",
		"moji": "🏊🏾",
		"unicodeVersion": "8.0",
		"digest": "20b4bff9baa1c694ad98067dde834c56092f023b9664bec382c2e512232bd480"
	},
	"swimmer_tone5": {
		"category": "activity",
		"moji": "🏊🏿",
		"unicodeVersion": "8.0",
		"digest": "0ff8eb57c2be8e80a1bc6ba75b8d9ffb9bd8d3be636150c4c03399ec1886f218"
	},
	"symbols": {
		"category": "symbols",
		"moji": "🔣",
		"unicodeVersion": "6.0",
		"digest": "2a2a79816c4d0751a0d73586eec5e63b410653d3c85cc968906bf1fc03d89b94"
	},
	"synagogue": {
		"category": "travel",
		"moji": "🕍",
		"unicodeVersion": "8.0",
		"digest": "98569cdd7c61528963b67b7891dfa46025c5e810cbb22ee18ddb3bd85de2da69"
	},
	"syringe": {
		"category": "objects",
		"moji": "💉",
		"unicodeVersion": "6.0",
		"digest": "e1538e645ccc571227c994b71b3d1be2c4d072d8bd9c944a42ff4a11c91a34a6"
	},
	"taco": {
		"category": "food",
		"moji": "🌮",
		"unicodeVersion": "8.0",
		"digest": "e1e45aefdb7445faeae75c3831df6a3d6f2590fcdd48a20d847593c246df613b"
	},
	"tada": {
		"category": "objects",
		"moji": "🎉",
		"unicodeVersion": "6.0",
		"digest": "1d2e6cbb2a3244240bc70209715d2213d1efee2e370cccfbcc046c333ae2d650"
	},
	"tanabata_tree": {
		"category": "nature",
		"moji": "🎋",
		"unicodeVersion": "6.0",
		"digest": "592f2907ffc1b914390e1a106c15120ff3607e99192158b94d237975647c5540"
	},
	"tangerine": {
		"category": "food",
		"moji": "🍊",
		"unicodeVersion": "6.0",
		"digest": "40c9ddcde1b0bcfaeb466629a87825eb8c2037835720cbee5e2fda04be3c8d0a"
	},
	"taurus": {
		"category": "symbols",
		"moji": "♉",
		"unicodeVersion": "1.1",
		"digest": "21cf24cb6410ab6596e2df8b3e242cc07f9dbb247eabc00c590fe184b373d068"
	},
	"taxi": {
		"category": "travel",
		"moji": "🚕",
		"unicodeVersion": "6.0",
		"digest": "c546cc743831cfbf0c15452767cf2a4faf3775066797e997ae7c1fcbe4eca479"
	},
	"tea": {
		"category": "food",
		"moji": "🍵",
		"unicodeVersion": "6.0",
		"digest": "00e3f1e389fa58c4fcd8c53ebbf83d25872f4315845ab1984b35410ae65553d9"
	},
	"telephone": {
		"category": "objects",
		"moji": "☎",
		"unicodeVersion": "1.1",
		"digest": "3a53851e641f8ad938ce3597b1afca2ea63c9314ff81f62563b99937496a13d7"
	},
	"telephone_receiver": {
		"category": "objects",
		"moji": "📞",
		"unicodeVersion": "6.0",
		"digest": "1614d67f3d8814b0d75f39d55f9149e4d28ef57b343498625e62fcfff8365046"
	},
	"telescope": {
		"category": "objects",
		"moji": "🔭",
		"unicodeVersion": "6.0",
		"digest": "4adf40387870276c4f59fb050d441023e8dac784365b6a8c0282fb519780b495"
	},
	"ten": {
		"category": "symbols",
		"moji": "🔟",
		"unicodeVersion": "6.0",
		"digest": "c7c9491021740d2c17edddb856f79579b0b943d8dc85a2f48dbaac84f35b8a40"
	},
	"tennis": {
		"category": "activity",
		"moji": "🎾",
		"unicodeVersion": "6.0",
		"digest": "dc1600b4d8dce3d26259eb0d1c6ab042566565e3c1f2c96112210f1550a716fd"
	},
	"tent": {
		"category": "travel",
		"moji": "⛺",
		"unicodeVersion": "5.2",
		"digest": "30d9b17ac3219d4970ddf54d7c1a288b0ae50f7f3b82ed232c0b1b19ef585662"
	},
	"thermometer": {
		"category": "objects",
		"moji": "🌡",
		"unicodeVersion": "7.0",
		"digest": "66616babbcaef256d7b652796c760e8e893cb950c073348a408fe70904f80f25"
	},
	"thermometer_face": {
		"category": "people",
		"moji": "🤒",
		"unicodeVersion": "8.0",
		"digest": "ac2b5caddd128563711a9dcc7f690cf210f684d5e8b64b09c0431d6902437126"
	},
	"thinking": {
		"category": "people",
		"moji": "🤔",
		"unicodeVersion": "8.0",
		"digest": "4f0b84e5ab8a650cafb166e93688f0e9b31b9ade22a91035261ac90490edb9d3"
	},
	"third_place": {
		"category": "activity",
		"moji": "🥉",
		"unicodeVersion": "9.0",
		"digest": "27c9bcba44ad95bee30882cc0722e8b0a798206306655dd648e884447ed26808"
	},
	"thought_balloon": {
		"category": "symbols",
		"moji": "💭",
		"unicodeVersion": "6.0",
		"digest": "bf59624560c333561d636aedf2c8827089e275895cf434974daaabb3d5cea46e"
	},
	"three": {
		"category": "symbols",
		"moji": "3️⃣",
		"unicodeVersion": "3.0",
		"digest": "d3f85828787799c769655c38a519cad0743ab799ab276c7606e6e6894cc442e6"
	},
	"thumbsdown": {
		"category": "people",
		"moji": "👎",
		"unicodeVersion": "6.0",
		"digest": "5954334e2dae5357312b3d629f10a496c728029e02216f8c8b887f9b51561c61"
	},
	"thumbsdown_tone1": {
		"category": "people",
		"moji": "👎🏻",
		"unicodeVersion": "8.0",
		"digest": "3c2853491473fd7ae2d1b5415a425cc390d26a8754446f8736c1360e4cb18ba3"
	},
	"thumbsdown_tone2": {
		"category": "people",
		"moji": "👎🏼",
		"unicodeVersion": "8.0",
		"digest": "4e0f8f86a06b69e423df8d93f41ec393f12800633acc82c4cb6dff64ca0d8507"
	},
	"thumbsdown_tone3": {
		"category": "people",
		"moji": "👎🏽",
		"unicodeVersion": "8.0",
		"digest": "e08fa35575f59978612d4330bbc35313eca9c4dfa04f4212626abc700819effe"
	},
	"thumbsdown_tone4": {
		"category": "people",
		"moji": "👎🏾",
		"unicodeVersion": "8.0",
		"digest": "7c6d118d20d5add8ca003e4a53e42685a1f9436b872ed10d79f67ad418fb2a44"
	},
	"thumbsdown_tone5": {
		"category": "people",
		"moji": "👎🏿",
		"unicodeVersion": "8.0",
		"digest": "8697c4a4ee4d6669dc2d47aa97699c42012ca59b80818ad6845878b37b4a9c58"
	},
	"thumbsup": {
		"category": "people",
		"moji": "👍",
		"unicodeVersion": "6.0",
		"digest": "59ec2457ab33e8897261d01a495f6cf5c668d0004807dc541c3b1be5294b1e61"
	},
	"thumbsup_tone1": {
		"category": "people",
		"moji": "👍🏻",
		"unicodeVersion": "8.0",
		"digest": "f57e6c525e8830779ea5026590eec3ca10869dc438a0c779734b617d04f28d21"
	},
	"thumbsup_tone2": {
		"category": "people",
		"moji": "👍🏼",
		"unicodeVersion": "8.0",
		"digest": "980eeeb1d8f5d79dae35c7ff81a576e980aa13a440d07b10e32e98ed34cbf7f1"
	},
	"thumbsup_tone3": {
		"category": "people",
		"moji": "👍🏽",
		"unicodeVersion": "8.0",
		"digest": "b3881060569e56e1dd75ca7960feab0e58ae51f440458781948d65d461116b4e"
	},
	"thumbsup_tone4": {
		"category": "people",
		"moji": "👍🏾",
		"unicodeVersion": "8.0",
		"digest": "86fbe2c95414bce5e38fb5c33da31305d7942fca2c9c79168dcffdbd895e9ad6"
	},
	"thumbsup_tone5": {
		"category": "people",
		"moji": "👍🏿",
		"unicodeVersion": "8.0",
		"digest": "49fa63ff725c746a18649df16c8fab69bad88bbb564884df79d1d15f553b7343"
	},
	"thunder_cloud_rain": {
		"category": "nature",
		"moji": "⛈",
		"unicodeVersion": "5.2",
		"digest": "dacc20b4f6b68e5834aa1b8391afa5e83b5e6eb28e2d2174d3a68186a770506d"
	},
	"ticket": {
		"category": "activity",
		"moji": "🎫",
		"unicodeVersion": "6.0",
		"digest": "b4326fe7761940216e6c76ee2928110a6b37bf913da9d694e96557e7c7c10420"
	},
	"tickets": {
		"category": "activity",
		"moji": "🎟",
		"unicodeVersion": "7.0",
		"digest": "fb73358c3697c04fcfde6a1e705b1c3b47635b93b9cadfe31d5657566c7d190a"
	},
	"tiger": {
		"category": "nature",
		"moji": "🐯",
		"unicodeVersion": "6.0",
		"digest": "e139531e6c930bc46242dc0ed274661229de026b5419d8ea8f99fdb0f8a719ab"
	},
	"tiger2": {
		"category": "nature",
		"moji": "🐅",
		"unicodeVersion": "6.0",
		"digest": "f930cc8714198310d9b0edca6baff243ac5a3320f75fadb56fa5acc6fe34ff24"
	},
	"timer": {
		"category": "objects",
		"moji": "⏲",
		"unicodeVersion": "6.0",
		"digest": "69b33f219523d89d81cbbc070ad7e528711e4b34e124a50acb12a0280a34d0b0"
	},
	"tired_face": {
		"category": "people",
		"moji": "😫",
		"unicodeVersion": "6.0",
		"digest": "775739bc9324517e614878ca0960d793df97775feeb62b14dbfb311a42a21802"
	},
	"tm": {
		"category": "symbols",
		"moji": "™",
		"unicodeVersion": "1.1",
		"digest": "7d9fafdb72d91860478fc185719f289f359eab2c368a132cb936a269e2ab6a24"
	},
	"toilet": {
		"category": "objects",
		"moji": "🚽",
		"unicodeVersion": "6.0",
		"digest": "0d1b0dd0078f51104e8632a0726e1b3f075561a1ffa8a2546602de15798415d0"
	},
	"tokyo_tower": {
		"category": "travel",
		"moji": "🗼",
		"unicodeVersion": "6.0",
		"digest": "73eaf6fd59d16396673afef620c6d928857d5cf616e95a40eaf2861686e0956a"
	},
	"tomato": {
		"category": "food",
		"moji": "🍅",
		"unicodeVersion": "6.0",
		"digest": "d092d8ad381d542e59b6a82b4f1ef0d10fc1ed48460952375c6c5c6258cea111"
	},
	"tone1": {
		"category": "modifier",
		"moji": "🏻",
		"unicodeVersion": "8.0",
		"digest": "5c62003a098b774c068be45d658db3c0dd38483c0871f7c8ae293bc1222c4f0c"
	},
	"tone2": {
		"category": "modifier",
		"moji": "🏼",
		"unicodeVersion": "8.0",
		"digest": "3c636ecbc4e58c7a360f2338daaf44e7da598fd07e0ba1514bb5c0f83fc8819f"
	},
	"tone3": {
		"category": "modifier",
		"moji": "🏽",
		"unicodeVersion": "8.0",
		"digest": "398a1e5441b64c9c2d033bbc01d7a8d90b4db30ea9f30e28f0a9120c72a48df8"
	},
	"tone4": {
		"category": "modifier",
		"moji": "🏾",
		"unicodeVersion": "8.0",
		"digest": "ff4a12195aeb7494c785b81266efad8cd60c8022c407a0fc032a02e8b83216b3"
	},
	"tone5": {
		"category": "modifier",
		"moji": "🏿",
		"unicodeVersion": "8.0",
		"digest": "9e9f0125b5d57011b7456c84719e6be6cf71d06c1b198081d0937c0979164a81"
	},
	"tongue": {
		"category": "people",
		"moji": "👅",
		"unicodeVersion": "6.0",
		"digest": "286e9d2583c371431d6fc979dd4ab48981676da26baada51a846657a3654c19b"
	},
	"tools": {
		"category": "objects",
		"moji": "🛠",
		"unicodeVersion": "7.0",
		"digest": "bf08d60dedc06de73d04dab05703bb8ad81989c72b5035d1a07821e51096f158"
	},
	"top": {
		"category": "symbols",
		"moji": "🔝",
		"unicodeVersion": "6.0",
		"digest": "c9a9f25b17db014e76b6be54aa07ef89bb18f8adb41b3199d180a559ff1d9ea5"
	},
	"tophat": {
		"category": "people",
		"moji": "🎩",
		"unicodeVersion": "6.0",
		"digest": "43a45dfb5d6b57a63a0491f4e3ec780774c0301b53ed39a303a0bd803d16ed71"
	},
	"track_next": {
		"category": "symbols",
		"moji": "⏭",
		"unicodeVersion": "6.0",
		"digest": "88592ef6c720a32aeb752322fb4c794bf5110a72408e21e898630452115c731c"
	},
	"track_previous": {
		"category": "symbols",
		"moji": "⏮",
		"unicodeVersion": "6.0",
		"digest": "98c1b3d643768d94857fb762f6d26cfb87282b449a67792242e8b7068643ac87"
	},
	"trackball": {
		"category": "objects",
		"moji": "🖲",
		"unicodeVersion": "7.0",
		"digest": "32a819a3129429f797ad434d0c40e263dc236808e34878c599ed2304b43702f5"
	},
	"tractor": {
		"category": "travel",
		"moji": "🚜",
		"unicodeVersion": "6.0",
		"digest": "5e4686290f1a4c9953ae208340b7d276f25b3b2197a43e52469aeb6450e93997"
	},
	"traffic_light": {
		"category": "travel",
		"moji": "🚥",
		"unicodeVersion": "6.0",
		"digest": "d96aacade33d1ad3e0414f8a920513010f36eb7e5889774251c1d91148917ead"
	},
	"train": {
		"category": "travel",
		"moji": "🚋",
		"unicodeVersion": "6.0",
		"digest": "7423d17e131df7aadaa350b5d39dcbce3b28de331ff8b6703a3b2d0093963f4b"
	},
	"train2": {
		"category": "travel",
		"moji": "🚆",
		"unicodeVersion": "6.0",
		"digest": "06e65d549e771632f3c64287a38ba67236f9800ccb6a23c3b592bc010e24e122"
	},
	"tram": {
		"category": "travel",
		"moji": "🚊",
		"unicodeVersion": "6.0",
		"digest": "21a7699f1a94f06dcb4d1e896448b98a4205f8efe902a8ac169a5005d11ab100"
	},
	"triangular_flag_on_post": {
		"category": "objects",
		"moji": "🚩",
		"unicodeVersion": "6.0",
		"digest": "1f5ce3828a42f5b1717bac1521d0502cf7081ad9f15e8ed292c1a65f0d1386da"
	},
	"triangular_ruler": {
		"category": "objects",
		"moji": "📐",
		"unicodeVersion": "6.0",
		"digest": "a0367dcf663ec934f1fc7c88bfaccc02b229a896f60930a66bb02241c933e501"
	},
	"trident": {
		"category": "symbols",
		"moji": "🔱",
		"unicodeVersion": "6.0",
		"digest": "ee45920845d3b35c2e45b934cf30ce97bfe2f24c5d72ef1ac6e0842e52b50fc1"
	},
	"triumph": {
		"category": "people",
		"moji": "😤",
		"unicodeVersion": "6.0",
		"digest": "4aa44b8e1682c1269624a359f4b0bf613553683b883d947561ab169d7f85da0f"
	},
	"trolleybus": {
		"category": "travel",
		"moji": "🚎",
		"unicodeVersion": "6.0",
		"digest": "f610b4fd1123f06778a8e3bb8f738d5b0079aeb0b0926b6a63268c0dd0ee03ed"
	},
	"trophy": {
		"category": "activity",
		"moji": "🏆",
		"unicodeVersion": "6.0",
		"digest": "50cfbedac18bf0fa5dec727643e15ec47f64068944b536e97518ee3be4f08006"
	},
	"tropical_drink": {
		"category": "food",
		"moji": "🍹",
		"unicodeVersion": "6.0",
		"digest": "54144fce60d650f426b1edf09e47c70b2762222398c1fe40231881f074603a69"
	},
	"tropical_fish": {
		"category": "nature",
		"moji": "🐠",
		"unicodeVersion": "6.0",
		"digest": "fd92100aaa9328da35e6090388824921b9726b474d1432a926d2cf9c45ad6528"
	},
	"truck": {
		"category": "travel",
		"moji": "🚚",
		"unicodeVersion": "6.0",
		"digest": "0d1571e58e900abc453df0ff683fe7acb5906ecbdd52ab35b7101074359faf18"
	},
	"trumpet": {
		"category": "activity",
		"moji": "🎺",
		"unicodeVersion": "6.0",
		"digest": "cea3614c309f5573f328f4603120dbe930016a35f0dfa400b0d968fe9fff2d55"
	},
	"tulip": {
		"category": "nature",
		"moji": "🌷",
		"unicodeVersion": "6.0",
		"digest": "e744e8dbbdc6b126bd5b15aad56b524191de5a604189f4ab6d96730dfef4d086"
	},
	"tumbler_glass": {
		"category": "food",
		"moji": "🥃",
		"unicodeVersion": "9.0",
		"digest": "7a38658274b9ff28836725a1dbfad49b8fa3af5ec8385e629db6bfdc7d93907a"
	},
	"turkey": {
		"category": "nature",
		"moji": "🦃",
		"unicodeVersion": "8.0",
		"digest": "bf5daef15716b66636a5fdb6d059420521443c0603e2d56bd7c99c791a7285f4"
	},
	"turtle": {
		"category": "nature",
		"moji": "🐢",
		"unicodeVersion": "6.0",
		"digest": "588c35fb42c9502a908e9805517d4cc8c4ba4e74c9beed4035779fea1efe14f8"
	},
	"tv": {
		"category": "objects",
		"moji": "📺",
		"unicodeVersion": "6.0",
		"digest": "1279f3f3955a58dbbf74e248fc914b0bdba9c4c6b6a5176e9d12bf2750ecfeb4"
	},
	"twisted_rightwards_arrows": {
		"category": "symbols",
		"moji": "🔀",
		"unicodeVersion": "6.0",
		"digest": "fed07eebc2cf0d977ca0826bbd80defafbbcf118508444148f47b58949ebe27c"
	},
	"two": {
		"category": "symbols",
		"moji": "2️⃣",
		"unicodeVersion": "3.0",
		"digest": "b346f51f6523b02ebcbd753256804e2f9cc1574c96aa634362bf9401dac2c661"
	},
	"two_hearts": {
		"category": "symbols",
		"moji": "💕",
		"unicodeVersion": "6.0",
		"digest": "6ded120a59aed790b441ec8fbbdea6f5cbfb4fa48e9e4b224cc29c9fde2d2e4c"
	},
	"two_men_holding_hands": {
		"category": "people",
		"moji": "👬",
		"unicodeVersion": "6.0",
		"digest": "bfcf9e20a67d00262cdf6e85f1acd545dda91f2e370d68bfd41ce02f232a2987"
	},
	"two_women_holding_hands": {
		"category": "people",
		"moji": "👭",
		"unicodeVersion": "6.0",
		"digest": "9d9d2b37a7f8e16fde1468dd8b5645003ea81ae4bf8bcf68471e2381845dd0dd"
	},
	"u5272": {
		"category": "symbols",
		"moji": "🈹",
		"unicodeVersion": "6.0",
		"digest": "01e6cb8f74ea3c19fdade59c2d13d158b90dc6b4b293421b2014b7478bf20870"
	},
	"u5408": {
		"category": "symbols",
		"moji": "🈴",
		"unicodeVersion": "6.0",
		"digest": "084cdbd5436670ea4dc22010e269c1ab7b0432897b8675301e69120374bcdd14"
	},
	"u55b6": {
		"category": "symbols",
		"moji": "🈺",
		"unicodeVersion": "6.0",
		"digest": "c1017023d20d4aae78d59342dd3bfc5282716ea0601d9a8c2476335cbf7a2e12"
	},
	"u6307": {
		"category": "symbols",
		"moji": "🈯",
		"unicodeVersion": "5.2",
		"digest": "f459b092b974f459db1fb9cc13617a448b2e4f2b4dc46cc316d8c46af6e7d8bd"
	},
	"u6708": {
		"category": "symbols",
		"moji": "🈷",
		"unicodeVersion": "6.0",
		"digest": "928815abf5b30f92efe5168de0c7e6cf8c17899a03e358ab42f42667e0a4a04c"
	},
	"u6709": {
		"category": "symbols",
		"moji": "🈶",
		"unicodeVersion": "6.0",
		"digest": "f63a48ee06c892d24acec8b5634c021658d2ebde67a42d8faa86f27804a9f26d"
	},
	"u6e80": {
		"category": "symbols",
		"moji": "🈵",
		"unicodeVersion": "6.0",
		"digest": "489181d90a5e43068459530673a153e4af04fdad8514ec341ff7afbcfd366c3b"
	},
	"u7121": {
		"category": "symbols",
		"moji": "🈚",
		"unicodeVersion": "5.2",
		"digest": "9c50fd2ba14221affd2dcd3746322c2137dd75458493f4d385b544eb5bd8d6cd"
	},
	"u7533": {
		"category": "symbols",
		"moji": "🈸",
		"unicodeVersion": "6.0",
		"digest": "2b05819b380a2ea47cc5fde8fcce3d53922fd223d6f5bd83d696d44175b69f18"
	},
	"u7981": {
		"category": "symbols",
		"moji": "🈲",
		"unicodeVersion": "6.0",
		"digest": "adbe12601b22972003ddebcb0bd1532b979aa9c78bfdc147511854b5014eabc0"
	},
	"u7a7a": {
		"category": "symbols",
		"moji": "🈳",
		"unicodeVersion": "6.0",
		"digest": "b9ee0ec7bb0b86c3eb73d4dbbb91848c427bf356ae30a263b9b44bd9bd784482"
	},
	"umbrella": {
		"category": "nature",
		"moji": "☔",
		"unicodeVersion": "4.0",
		"digest": "0328a2f48b7df47905e2655460e524c0794ef12d3d7c32a049a10892d5662f77"
	},
	"umbrella2": {
		"category": "nature",
		"moji": "☂",
		"unicodeVersion": "1.1",
		"digest": "2f6a58110dc590480a822a3ffa2b5bc86f295e0c994a4a632837d25d4cf9fc58"
	},
	"unamused": {
		"category": "people",
		"moji": "😒",
		"unicodeVersion": "6.0",
		"digest": "0d597088e3e7880918d0166e5c69243b18fe64afa31685c39bfdbc71494aa132"
	},
	"underage": {
		"category": "symbols",
		"moji": "🔞",
		"unicodeVersion": "6.0",
		"digest": "b6b194614ca714ac2b1c2c17b75fe5922c7fdadb3d1157ba89ab2a5d03494a67"
	},
	"unicorn": {
		"category": "nature",
		"moji": "🦄",
		"unicodeVersion": "8.0",
		"digest": "f71bb485a7c208e999dd45f2b36d7b7d517898c0627947926b05aa28603804ca"
	},
	"unlock": {
		"category": "objects",
		"moji": "🔓",
		"unicodeVersion": "6.0",
		"digest": "9554ef3a6a315938b873e77970d9b0212e61f13c6cc36e4f17f87acc930a9a53"
	},
	"up": {
		"category": "symbols",
		"moji": "🆙",
		"unicodeVersion": "6.0",
		"digest": "ff2554ccf08c7208b38794c5fa3d9a93a46ff191a49401195d8f740846121906"
	},
	"upside_down": {
		"category": "people",
		"moji": "🙃",
		"unicodeVersion": "8.0",
		"digest": "5129121f0a28f5b334268c28565de26a5907559568deca11de6ec620b097dfe1"
	},
	"urn": {
		"category": "objects",
		"moji": "⚱",
		"unicodeVersion": "4.1",
		"digest": "9bebf589eed8dd361f6a03cd1b325078f2cd0e82270ef63a7dd1b6aee08cd1e6"
	},
	"v": {
		"category": "people",
		"moji": "✌",
		"unicodeVersion": "1.1",
		"digest": "9825bf440df289a8edf8ede494e8c778dc63c95f967f4d7bbea3245cf4f558ec"
	},
	"v_tone1": {
		"category": "people",
		"moji": "✌🏻",
		"unicodeVersion": "8.0",
		"digest": "76e358250d9ca519b60b8d7b6a32900700d784433dcc609e9442254a410f6e37"
	},
	"v_tone2": {
		"category": "people",
		"moji": "✌🏼",
		"unicodeVersion": "8.0",
		"digest": "4081b674be8416136022523fa9f29ec70a0f7e3aa05ca13152606609f3fd003c"
	},
	"v_tone3": {
		"category": "people",
		"moji": "✌🏽",
		"unicodeVersion": "8.0",
		"digest": "b6afb3a4c78384280610b953592d378241c75597a82aa6d16c86a993f8d8f3b0"
	},
	"v_tone4": {
		"category": "people",
		"moji": "✌🏾",
		"unicodeVersion": "8.0",
		"digest": "7ddc3cdd0138da2c8d7f6d8257ffdb8801496043e8a2395f93b0663447ac7fce"
	},
	"v_tone5": {
		"category": "people",
		"moji": "✌🏿",
		"unicodeVersion": "8.0",
		"digest": "a85dc5c589f0d1cf32f8bfa5c82e5c11c40b35439636914686a2f06f7359f539"
	},
	"vertical_traffic_light": {
		"category": "travel",
		"moji": "🚦",
		"unicodeVersion": "6.0",
		"digest": "8cfd49a8f96b15a8313ef855f2e234ea3fa58332e68896dea34760740de9f020"
	},
	"vhs": {
		"category": "objects",
		"moji": "📼",
		"unicodeVersion": "6.0",
		"digest": "3fb1acaf25805cf86f8d40ee2c17cf25da587b7ca93b931167ab43fce041eee8"
	},
	"vibration_mode": {
		"category": "symbols",
		"moji": "📳",
		"unicodeVersion": "6.0",
		"digest": "c9a8899222f46fe51dd8cee3e59f77c48268f0b7cfae2bcb34a791213acb1755"
	},
	"video_camera": {
		"category": "objects",
		"moji": "📹",
		"unicodeVersion": "6.0",
		"digest": "62e56f26c286a7964ef1021f0f23fcb4b38cdcfb5b5af569b472340c412c619a"
	},
	"video_game": {
		"category": "activity",
		"moji": "🎮",
		"unicodeVersion": "6.0",
		"digest": "2787e302aa9e6fd7e9dc382c9bc7f5fbf244ef4940e08a4f9e80d33324f3032e"
	},
	"violin": {
		"category": "activity",
		"moji": "🎻",
		"unicodeVersion": "6.0",
		"digest": "1e69d531ce2b5d5bf1dd9470187dbbe76f479d14428834b6a9e2bf5296dc0ec9"
	},
	"virgo": {
		"category": "symbols",
		"moji": "♍",
		"unicodeVersion": "1.1",
		"digest": "0f75e9c228bc467fd0cec0f93f0e087c943bc5fb1d945fb0d4de53d07718388e"
	},
	"volcano": {
		"category": "travel",
		"moji": "🌋",
		"unicodeVersion": "6.0",
		"digest": "41c92ef88ca533df342a0ebe59d2b676873bfa944c3988495b8a96060a9b8e16"
	},
	"volleyball": {
		"category": "activity",
		"moji": "🏐",
		"unicodeVersion": "8.0",
		"digest": "774a83357f7aee890b4d4383236f0a90946dbd7c86aaabadc5753dcc9b4c9d69"
	},
	"vs": {
		"category": "symbols",
		"moji": "🆚",
		"unicodeVersion": "6.0",
		"digest": "ac943e4c737459c2e1adbac8b71d3fdaebb704dbaf5713012e7a77beb09db1ef"
	},
	"vulcan": {
		"category": "people",
		"moji": "🖖",
		"unicodeVersion": "7.0",
		"digest": "b4d409a0b019e7b06333cefd15ea46cb54aef5132d86e8ba361c1c3b911fe265"
	},
	"vulcan_tone1": {
		"category": "people",
		"moji": "🖖🏻",
		"unicodeVersion": "8.0",
		"digest": "cc6072c85031b5081995f98a57f09ab177168318f69a51f3acc63251760499a4"
	},
	"vulcan_tone2": {
		"category": "people",
		"moji": "🖖🏼",
		"unicodeVersion": "8.0",
		"digest": "858bd5a1ac91dc4d7735f57ba4dd69d39138aa6dac1c80cfc05de30a59a5bc33"
	},
	"vulcan_tone3": {
		"category": "people",
		"moji": "🖖🏽",
		"unicodeVersion": "8.0",
		"digest": "2f74b6f3eab2a75063591b66f1c7350af0d23153e1427af91de20c48a5f4a54a"
	},
	"vulcan_tone4": {
		"category": "people",
		"moji": "🖖🏾",
		"unicodeVersion": "8.0",
		"digest": "87cf8b87d3610f742857a9704b658462df32b4924d8f1ddba26f761e738c4e11"
	},
	"vulcan_tone5": {
		"category": "people",
		"moji": "🖖🏿",
		"unicodeVersion": "8.0",
		"digest": "11e9ff62f2385edeb477dbf66c63734536531def5771daf80b66a3425ac71493"
	},
	"walking": {
		"category": "people",
		"moji": "🚶",
		"unicodeVersion": "6.0",
		"digest": "ae77471fe1e8a734d11711cdb589f64347c35d6ee2fc10f6db16ac550c0557fa"
	},
	"walking_tone1": {
		"category": "people",
		"moji": "🚶🏻",
		"unicodeVersion": "8.0",
		"digest": "3de871c234e1340ccf95338df7babd94d175cfcb17a57b5a74d950e0a31f03b1"
	},
	"walking_tone2": {
		"category": "people",
		"moji": "🚶🏼",
		"unicodeVersion": "8.0",
		"digest": "620eb7bfb753a331a5822b02bdaf08d8dde7b573efd210287a3d3dfdd84a40b9"
	},
	"walking_tone3": {
		"category": "people",
		"moji": "🚶🏽",
		"unicodeVersion": "8.0",
		"digest": "ff39545acc2256006128f8c186433c28052b8c9aaec46fe06f25cff02c71f6b8"
	},
	"walking_tone4": {
		"category": "people",
		"moji": "🚶🏾",
		"unicodeVersion": "8.0",
		"digest": "a9499d142392977a9b9e54fb957952359e9bdffce7ec2f1e8320523d185fb066"
	},
	"walking_tone5": {
		"category": "people",
		"moji": "🚶🏿",
		"unicodeVersion": "8.0",
		"digest": "b47a4c48ce40298f842f454fc1abccae70f69725d73ee2c80e4018f4c4065d7d"
	},
	"waning_crescent_moon": {
		"category": "nature",
		"moji": "🌘",
		"unicodeVersion": "6.0",
		"digest": "2ec7896eefcf821e0ea013556a17af59e997503662c07f080d0a84ab13ef4cf1"
	},
	"waning_gibbous_moon": {
		"category": "nature",
		"moji": "🌖",
		"unicodeVersion": "6.0",
		"digest": "ce2f5aca8fccdacaaf174d10da4e493e853e4608cc4d159aa3081d108a8b58d5"
	},
	"warning": {
		"category": "symbols",
		"moji": "⚠",
		"unicodeVersion": "4.0",
		"digest": "745f1d203958f42bf37ecb5909cd0819934e300308ba0ff20964c8c203092f90"
	},
	"wastebasket": {
		"category": "objects",
		"moji": "🗑",
		"unicodeVersion": "7.0",
		"digest": "221a1b6d9975051038d9d97e18a16556cdf4254a6bca4c29bf1c51f306c79f2a"
	},
	"watch": {
		"category": "objects",
		"moji": "⌚",
		"unicodeVersion": "1.1",
		"digest": "acc0c96751404a789b3085f10425cf34f942185215df459515d2439cde3efc6b"
	},
	"water_buffalo": {
		"category": "nature",
		"moji": "🐃",
		"unicodeVersion": "6.0",
		"digest": "ba6a840d4f57f8f9f3e9f29b8a030faf02a3a3d912e3e31b067616b2ac48a3d1"
	},
	"water_polo": {
		"category": "activity",
		"moji": "🤽",
		"unicodeVersion": "9.0",
		"digest": "fc77e1d2a84a9f4cf0cf19c1ea10cf137cf0940b9103a523121eda87677ad148"
	},
	"water_polo_tone1": {
		"category": "activity",
		"moji": "🤽🏻",
		"unicodeVersion": "9.0",
		"digest": "3be28384edd29ada8109f07720d601a9d5866ed63e6234efe9ee1a194ed5d0c5"
	},
	"water_polo_tone2": {
		"category": "activity",
		"moji": "🤽🏼",
		"unicodeVersion": "9.0",
		"digest": "afcd3f28c6719f869ca79a6fd1ccade2ea976ade844fbc1081fc72865bcb652f"
	},
	"water_polo_tone3": {
		"category": "activity",
		"moji": "🤽🏽",
		"unicodeVersion": "9.0",
		"digest": "d19481c9b82d9413e99c2652e020fd763f2b54408dedaffec8dfe80973ded407"
	},
	"water_polo_tone4": {
		"category": "activity",
		"moji": "🤽🏾",
		"unicodeVersion": "9.0",
		"digest": "375972d882b627e8d525e632e58b30346fc3e01858d7d08d62a9d3bf8132bbc7"
	},
	"water_polo_tone5": {
		"category": "activity",
		"moji": "🤽🏿",
		"unicodeVersion": "9.0",
		"digest": "a8e1ced1c5382a8147a1d1801a133cada9a0e52e41de6272e56c3c1f426f6048"
	},
	"watermelon": {
		"category": "food",
		"moji": "🍉",
		"unicodeVersion": "6.0",
		"digest": "42a3821d2e4dd595c93f5db7a5c70b7af486b8f0ddd3b9d26bc4e743a88e699a"
	},
	"wave": {
		"category": "people",
		"moji": "👋",
		"unicodeVersion": "6.0",
		"digest": "cddbd764d471604446cbaca91f77f6c4119d1cfc2c856732ca0eaac4593cb736"
	},
	"wave_tone1": {
		"category": "people",
		"moji": "👋🏻",
		"unicodeVersion": "8.0",
		"digest": "cf40797437ddf68ec0275f337e6aac4bed81e28da7636d56c9f817ddf8e2b30a"
	},
	"wave_tone2": {
		"category": "people",
		"moji": "👋🏼",
		"unicodeVersion": "8.0",
		"digest": "12c8a3e82c03ee35a734c642be482ba2d9d5948dacf91ec1fda243316dd4a0d0"
	},
	"wave_tone3": {
		"category": "people",
		"moji": "👋🏽",
		"unicodeVersion": "8.0",
		"digest": "ebcaef43e21b475f76de811d4f4d1a67d9393973b57b03876e02164345a2ba4a"
	},
	"wave_tone4": {
		"category": "people",
		"moji": "👋🏾",
		"unicodeVersion": "8.0",
		"digest": "7df7b70cf76766836ba146c3d91b6104930c384450cf2688426e60c1c06a1fc8"
	},
	"wave_tone5": {
		"category": "people",
		"moji": "👋🏿",
		"unicodeVersion": "8.0",
		"digest": "8dfdba6aeff5d7dfd807467d431a137547726b34d021f1a5a0b74e155d270ea7"
	},
	"wavy_dash": {
		"category": "symbols",
		"moji": "〰",
		"unicodeVersion": "1.1",
		"digest": "7b1968474f01d12fd09a1f2572282927138d9e9d6a3642de4bf68af80a8c3738"
	},
	"waxing_crescent_moon": {
		"category": "nature",
		"moji": "🌒",
		"unicodeVersion": "6.0",
		"digest": "852d7e55a19074d061fa3aa80d6b1e7e87a9280bdf44d94bbdbbe6d59178b1be"
	},
	"waxing_gibbous_moon": {
		"category": "nature",
		"moji": "🌔",
		"unicodeVersion": "6.0",
		"digest": "a3a1c7cc72521a3f74929789a90e1c35d81ac86e21225c9f844d718d8940e3b3"
	},
	"wc": {
		"category": "symbols",
		"moji": "🚾",
		"unicodeVersion": "6.0",
		"digest": "4b95d54e0b53e4b705277917653503b32d6a143c2eaf6c547bc8e01c2dc23659"
	},
	"weary": {
		"category": "people",
		"moji": "😩",
		"unicodeVersion": "6.0",
		"digest": "3528f85540996cd5b562efe5421c495fc1bb414dc797bc20062783ae1b730847"
	},
	"wedding": {
		"category": "travel",
		"moji": "💒",
		"unicodeVersion": "6.0",
		"digest": "980f3522cc4c19c3096e668032ea2cd19e7900cdc4b73bbb1c9b4c4d28dc78af"
	},
	"whale": {
		"category": "nature",
		"moji": "🐳",
		"unicodeVersion": "6.0",
		"digest": "6368fe4bc4a7f68aa2bd5386686a5f1b159feacbec16d59515f2b6e5d01adfbd"
	},
	"whale2": {
		"category": "nature",
		"moji": "🐋",
		"unicodeVersion": "6.0",
		"digest": "ccd3edf88167965f2abc18631ffb80e2532f728da35bc0c11144376685da18e8"
	},
	"wheel_of_dharma": {
		"category": "symbols",
		"moji": "☸",
		"unicodeVersion": "1.1",
		"digest": "4a0a13fcd507b9621686c8090bf340aa8770c064e0e3eb576fbae1229000d6da"
	},
	"wheelchair": {
		"category": "symbols",
		"moji": "♿",
		"unicodeVersion": "4.1",
		"digest": "f5250f2b4b5b4ffe6a6f77d30865c3f5d7173fc91aee547869589b2a96da91c8"
	},
	"white_check_mark": {
		"category": "symbols",
		"moji": "✅",
		"unicodeVersion": "6.0",
		"digest": "45eb17bde6e503f22c8579d6e4d507ad6557a15f9eaad14aa716ec9ba1540876"
	},
	"white_circle": {
		"category": "symbols",
		"moji": "⚪",
		"unicodeVersion": "4.1",
		"digest": "2e7323fa4d1e3929e529d49210a0b82a043eae4f7c95128ec86b98c46fdb0e7c"
	},
	"white_flower": {
		"category": "symbols",
		"moji": "💮",
		"unicodeVersion": "6.0",
		"digest": "ace093b310eeefdecf4a4bdaf4fbcbb568457b0191ac80778a466ac5f3f4025a"
	},
	"white_large_square": {
		"category": "symbols",
		"moji": "⬜",
		"unicodeVersion": "5.1",
		"digest": "0db6957ee9ff7325b534b730fc05345a63d4ed9060f0f816807d0dcf004baa3e"
	},
	"white_medium_small_square": {
		"category": "symbols",
		"moji": "◽",
		"unicodeVersion": "3.2",
		"digest": "d79689981a7b38211c60a025a81e44fd39ac6ea4062e227cae3aab8f51572cd4"
	},
	"white_medium_square": {
		"category": "symbols",
		"moji": "◻",
		"unicodeVersion": "3.2",
		"digest": "6c4ce26d3f69667219f29ea18b04f3e79373024426275f25936e09a683e9a4fc"
	},
	"white_small_square": {
		"category": "symbols",
		"moji": "▫",
		"unicodeVersion": "1.1",
		"digest": "ae0d35a6bbba4592b89b2f0f1f2d183efb2f93cf2a2136c0c195aab72f0bb1c8"
	},
	"white_square_button": {
		"category": "symbols",
		"moji": "🔳",
		"unicodeVersion": "6.0",
		"digest": "797f3d9e44e88e940ffc118e52d0f709eec2ef14b13bdf873ad4b0c96cc0b042"
	},
	"white_sun_cloud": {
		"category": "nature",
		"moji": "🌥",
		"unicodeVersion": "7.0",
		"digest": "0e714038bb0a5b091dd4ad8829c5c72dece493e09da6d56ceadcd0b68e1c0fd5"
	},
	"white_sun_rain_cloud": {
		"category": "nature",
		"moji": "🌦",
		"unicodeVersion": "7.0",
		"digest": "82fb2a91d43c7c511afed216e12f98e32aef4475e7f3c7ccc0f39732d2f7d5e5"
	},
	"white_sun_small_cloud": {
		"category": "nature",
		"moji": "🌤",
		"unicodeVersion": "7.0",
		"digest": "0a6164cdadf2413555b7ef47b95f823f5a010f36d2dacfb1a38335a0f59e9601"
	},
	"wilted_rose": {
		"category": "nature",
		"moji": "🥀",
		"unicodeVersion": "9.0",
		"digest": "2c9e01ab9a61d057c71478b09ba7d82ae08f4a5a1c2212b7ad562b74f616677f"
	},
	"wind_blowing_face": {
		"category": "nature",
		"moji": "🌬",
		"unicodeVersion": "7.0",
		"digest": "e4f63149cbc8829118571f6a93487b96d26665fc15d17d578cca4e5c752cd54f"
	},
	"wind_chime": {
		"category": "objects",
		"moji": "🎐",
		"unicodeVersion": "6.0",
		"digest": "1b1b212fbd74a9edc62aee7ffab9bcf91d3a9f69bffb2be4b7fd527914c14ced"
	},
	"wine_glass": {
		"category": "food",
		"moji": "🍷",
		"unicodeVersion": "6.0",
		"digest": "d99107d6809386bc5e219aa58ee4930d27b7c3a6d2b10deb9f523df369f766d1"
	},
	"wink": {
		"category": "people",
		"moji": "😉",
		"unicodeVersion": "6.0",
		"digest": "56e29994a47335a901d0c98fa141d26faae8f647a860517bd3615fa980921885"
	},
	"wolf": {
		"category": "nature",
		"moji": "🐺",
		"unicodeVersion": "6.0",
		"digest": "4a983f5ec8ec0872fcde7890e17605b1229064e5e194b6fca1c4259068d1caed"
	},
	"woman": {
		"category": "people",
		"moji": "👩",
		"unicodeVersion": "6.0",
		"digest": "a06a22a48eeb3aeb885321358fe234e97797ed33be17f52d232ce2830cfbcd97"
	},
	"woman_tone1": {
		"category": "people",
		"moji": "👩🏻",
		"unicodeVersion": "8.0",
		"digest": "c2e4b135c1dac6a0b002569a6ccd9d098f6cb18481c68b5d9115e11241a0978d"
	},
	"woman_tone2": {
		"category": "people",
		"moji": "👩🏼",
		"unicodeVersion": "8.0",
		"digest": "4848e650051214a53c4cd9f6d3d94158f77f65ecb34f891789de34ee0a713006"
	},
	"woman_tone3": {
		"category": "people",
		"moji": "👩🏽",
		"unicodeVersion": "8.0",
		"digest": "b6f751ad47da019cdfb9d6d78f9610adb92120abf204c30df79a9150b57dbdee"
	},
	"woman_tone4": {
		"category": "people",
		"moji": "👩🏾",
		"unicodeVersion": "8.0",
		"digest": "fd27d3a669dc34313fbfe518df7dc2ded3ade5dde695f8d773afe87bf8a8b0d4"
	},
	"woman_tone5": {
		"category": "people",
		"moji": "👩🏿",
		"unicodeVersion": "8.0",
		"digest": "9ae9b14dfff40fa60a565d89479727feeba4fd6ffea9acb353a81b14aba751d4"
	},
	"womans_clothes": {
		"category": "people",
		"moji": "👚",
		"unicodeVersion": "6.0",
		"digest": "d12a27810780fe5cd8118ed4587e0c4e70dbe9bcd014c6866fe6a8c9c7c55698"
	},
	"womans_hat": {
		"category": "people",
		"moji": "👒",
		"unicodeVersion": "6.0",
		"digest": "52a0255b3483085bd125d39b74516ab6a81003964f44995c2fac821e7ff93086"
	},
	"womens": {
		"category": "symbols",
		"moji": "🚺",
		"unicodeVersion": "6.0",
		"digest": "7e38964006f8b28dfa2b3e9b2b16553bb50c18a63455f556b0bff35ee172137e"
	},
	"worried": {
		"category": "people",
		"moji": "😟",
		"unicodeVersion": "6.1",
		"digest": "5a073985e1344bc34201ef94a491f7f2b946f5828c9fdbc57eeb2dcd87ac3a6b"
	},
	"wrench": {
		"category": "objects",
		"moji": "🔧",
		"unicodeVersion": "6.0",
		"digest": "81aae53bc892035b905bf3ec5b442a8ecc95027c5fa9eb51b7c3e7d8fad3f3f4"
	},
	"wrestlers": {
		"category": "activity",
		"moji": "🤼",
		"unicodeVersion": "9.0",
		"digest": "9be983f3f9438f3ab8f6b643a958371d1e710c6d78e728f3465141811f05c2d5"
	},
	"wrestlers_tone1": {
		"category": "activity",
		"moji": "🤼🏻",
		"unicodeVersion": "9.0",
		"digest": "60461f83bfc93ce59dd027eab4782b7f206a7b142719fa72f301e047dc83a5d9"
	},
	"wrestlers_tone2": {
		"category": "activity",
		"moji": "🤼🏼",
		"unicodeVersion": "9.0",
		"digest": "67ad93c86e6c58d552c18e7a0105cc81fd9bb0474da51f788eba2e4c14b4a636"
	},
	"wrestlers_tone3": {
		"category": "activity",
		"moji": "🤼🏽",
		"unicodeVersion": "9.0",
		"digest": "6bfd06c4435cabf2def153912040e05bf8db424fa383148ddda6d0ce8a8a3349"
	},
	"wrestlers_tone4": {
		"category": "activity",
		"moji": "🤼🏾",
		"unicodeVersion": "9.0",
		"digest": "597312678834c4d288c238482879856d5eba4620deb1eaef495f428e2ba5f2a5"
	},
	"wrestlers_tone5": {
		"category": "activity",
		"moji": "🤼🏿",
		"unicodeVersion": "9.0",
		"digest": "d6aebdf1e44fd825b9a5b3716aefbc53f4b4dbb73cb2a628c0f2994ebfd34614"
	},
	"writing_hand": {
		"category": "people",
		"moji": "✍",
		"unicodeVersion": "1.1",
		"digest": "110517ae4da5587e8b0662881658e27da4120bfacec54734fd6657831d4d782f"
	},
	"writing_hand_tone1": {
		"category": "people",
		"moji": "✍🏻",
		"unicodeVersion": "8.0",
		"digest": "2c7e2108e1990490b681343c1b01b4183d4f18fbdef792f113b2f87595e0dad0"
	},
	"writing_hand_tone2": {
		"category": "people",
		"moji": "✍🏼",
		"unicodeVersion": "8.0",
		"digest": "87ec8d44f472d301adbcbd50d8c852b609e46584057f59cc1527401db363c1bf"
	},
	"writing_hand_tone3": {
		"category": "people",
		"moji": "✍🏽",
		"unicodeVersion": "8.0",
		"digest": "4a48ddef91f7264e8fa9cca223554db22b3a2e3153e94b88d146644ea6dd661e"
	},
	"writing_hand_tone4": {
		"category": "people",
		"moji": "✍🏾",
		"unicodeVersion": "8.0",
		"digest": "e5254564a1f91e42ee59f359d8cd26f52abdc04dca8f3b37cb2f140cb7f71390"
	},
	"writing_hand_tone5": {
		"category": "people",
		"moji": "✍🏿",
		"unicodeVersion": "8.0",
		"digest": "61299bf86d83d323ca3e6052c535ae66c6f7b3d9866a37db0464223b8bc28523"
	},
	"x": {
		"category": "symbols",
		"moji": "❌",
		"unicodeVersion": "6.0",
		"digest": "3e5a7918e31ddefdf1ce73972365e2f0bfd2917d6a450c1a278c108349c9425d"
	},
	"yellow_heart": {
		"category": "symbols",
		"moji": "💛",
		"unicodeVersion": "6.0",
		"digest": "a1098f2f04c29754cc9974324508386787d4d803b57cf691d42de414cb2679d6"
	},
	"yen": {
		"category": "objects",
		"moji": "💴",
		"unicodeVersion": "6.0",
		"digest": "944daaeb3f6369c807c0e63b106cee1360040f7800a70c0d942a992f25a55da7"
	},
	"yin_yang": {
		"category": "symbols",
		"moji": "☯",
		"unicodeVersion": "1.1",
		"digest": "5ee8d13dacf41306a09237bfcff6abeef110331b40eb7d6e80600628c1327545"
	},
	"yum": {
		"category": "people",
		"moji": "😋",
		"unicodeVersion": "6.0",
		"digest": "31a89088c21bd7a74a3a26d731a907d1bc49436300a9f9c55248703cf7ef44c7"
	},
	"zap": {
		"category": "nature",
		"moji": "⚡",
		"unicodeVersion": "4.0",
		"digest": "9f8144ae6f866129aea41bbf694b0c858ef9352a139969e57cd8db73385f52c3"
	},
	"zero": {
		"category": "symbols",
		"moji": "0️⃣",
		"unicodeVersion": "3.0",
		"digest": "1b27b5c904defadbdd28ace67a6be5c277ff043297db7cd9f672bbf84e37fa1a"
	},
	"zipper_mouth": {
		"category": "people",
		"moji": "🤐",
		"unicodeVersion": "8.0",
		"digest": "81bee5aa1202dfd5a4c7badb71ec0e44b8f75c2cbef94e6fd35c593d8770ae43"
	},
	"zzz": {
		"category": "people",
		"moji": "💤",
		"unicodeVersion": "6.0",
		"digest": "b3313d0c44a59fa9d4ce9f7eb4d07ff71dfc8bb01798154250f27cdcf3c693b5"
	}
};

/***/ }),

/***/ "fSxH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_document_register_element__ = __webpack_require__("MgdX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_document_register_element___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_document_register_element__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_emojis_digests_json__ = __webpack_require__("fA9n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_emojis_digests_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_emojis_digests_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_emojis_aliases_json__ = __webpack_require__("owyH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_emojis_aliases_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_emojis_aliases_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__gl_emoji_unicode_support_map__ = __webpack_require__("CPat");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__gl_emoji_is_emoji_unicode_supported__ = __webpack_require__("r2DN");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return installGlEmojiElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return glEmojiTag; });
/* unused harmony export emojiImageTag */






__WEBPACK_IMPORTED_MODULE_0_document_register_element___default()(window);

var generatedUnicodeSupportMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__gl_emoji_unicode_support_map__["a" /* getUnicodeSupportMap */])();

function emojiImageTag(name, src) {
  return '<img class="emoji" title=":' + name + ':" alt=":' + name + ':" src="' + src + '" width="20" height="20" align="absmiddle" />';
}

function assembleFallbackImageSrc(inputName) {
  var name = Object.prototype.hasOwnProperty.call(__WEBPACK_IMPORTED_MODULE_2_emojis_aliases_json___default.a, inputName) ? __WEBPACK_IMPORTED_MODULE_2_emojis_aliases_json___default.a[inputName] : inputName;
  var emojiInfo = __WEBPACK_IMPORTED_MODULE_1_emojis_digests_json___default.a[name];
  // Fallback to question mark for unknown emojis
  if (!emojiInfo) {
    name = 'grey_question';
    emojiInfo = __WEBPACK_IMPORTED_MODULE_1_emojis_digests_json___default.a[name];
  }
  var fallbackImageSrc = '' + (gon.asset_host || '') + (gon.relative_url_root || '') + '/assets/emoji/' + name + '-' + emojiInfo.digest + '.png';

  return fallbackImageSrc;
}
var glEmojiTagDefaults = {
  sprite: false,
  forceFallback: false
};
function glEmojiTag(inputName, options) {
  var opts = Object.assign({}, glEmojiTagDefaults, options);
  var name = Object.prototype.hasOwnProperty.call(__WEBPACK_IMPORTED_MODULE_2_emojis_aliases_json___default.a, inputName) ? __WEBPACK_IMPORTED_MODULE_2_emojis_aliases_json___default.a[inputName] : inputName;
  var emojiInfo = __WEBPACK_IMPORTED_MODULE_1_emojis_digests_json___default.a[name];
  // Fallback to question mark for unknown emojis
  if (!emojiInfo) {
    name = 'grey_question';
    emojiInfo = __WEBPACK_IMPORTED_MODULE_1_emojis_digests_json___default.a[name];
  }

  var fallbackImageSrc = assembleFallbackImageSrc(name);
  var fallbackSpriteClass = 'emoji-' + name;

  var classList = [];
  if (opts.forceFallback && opts.sprite) {
    classList.push('emoji-icon');
    classList.push(fallbackSpriteClass);
  }
  var classAttribute = classList.length > 0 ? 'class="' + classList.join(' ') + '"' : '';
  var fallbackSpriteAttribute = opts.sprite ? 'data-fallback-sprite-class="' + fallbackSpriteClass + '"' : '';
  var contents = emojiInfo.moji;
  if (opts.forceFallback && !opts.sprite) {
    contents = emojiImageTag(name, fallbackImageSrc);
  }

  return '\n  <gl-emoji\n    ' + classAttribute + '\n    data-name="' + name + '"\n    data-fallback-src="' + fallbackImageSrc + '"\n    ' + fallbackSpriteAttribute + '\n    data-unicode-version="' + emojiInfo.unicodeVersion + '"\n  >\n    ' + contents + '\n  </gl-emoji>\n  ';
}

function installGlEmojiElement() {
  var GlEmojiElementProto = Object.create(HTMLElement.prototype);
  GlEmojiElementProto.createdCallback = function createdCallback() {
    var emojiUnicode = this.textContent.trim();
    var _dataset = this.dataset,
        name = _dataset.name,
        unicodeVersion = _dataset.unicodeVersion,
        fallbackSrc = _dataset.fallbackSrc,
        fallbackSpriteClass = _dataset.fallbackSpriteClass;


    var isEmojiUnicode = this.childNodes && Array.prototype.every.call(this.childNodes, function (childNode) {
      return childNode.nodeType === 3;
    });
    var hasImageFallback = fallbackSrc && fallbackSrc.length > 0;
    var hasCssSpriteFalback = fallbackSpriteClass && fallbackSpriteClass.length > 0;

    if (isEmojiUnicode && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__gl_emoji_is_emoji_unicode_supported__["a" /* isEmojiUnicodeSupported */])(generatedUnicodeSupportMap, emojiUnicode, unicodeVersion)) {
      // CSS sprite fallback takes precedence over image fallback
      if (hasCssSpriteFalback) {
        // IE 11 doesn't like adding multiple at once :(
        this.classList.add('emoji-icon');
        this.classList.add(fallbackSpriteClass);
      } else if (hasImageFallback) {
        this.innerHTML = emojiImageTag(name, fallbackSrc);
      } else {
        var src = assembleFallbackImageSrc(name);
        this.innerHTML = emojiImageTag(name, src);
      }
    }
  };

  document.registerElement('gl-emoji', {
    prototype: GlEmojiElementProto
  });
}



/***/ }),

/***/ "fitr":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, quotes, object-shorthand, camelcase, no-var, comma-dangle, prefer-arrow-callback, quote-props, no-param-reassign, max-len */

var Api = {
  groupsPath: "/api/:version/groups.json",
  groupPath: "/api/:version/groups/:id.json",
  namespacesPath: "/api/:version/namespaces.json",
  groupProjectsPath: "/api/:version/groups/:id/projects.json",
  projectsPath: "/api/:version/projects.json?simple=true",
  labelsPath: "/:namespace_path/:project_path/labels",
  licensePath: "/api/:version/templates/licenses/:key",
  gitignorePath: "/api/:version/templates/gitignores/:key",
  gitlabCiYmlPath: "/api/:version/templates/gitlab_ci_ymls/:key",
  dockerfilePath: "/api/:version/templates/dockerfiles/:key",
  issuableTemplatePath: "/:namespace_path/:project_path/templates/:type/:key",
  group: function group(group_id, callback) {
    var url = Api.buildUrl(Api.groupPath).replace(':id', group_id);
    return $.ajax({
      url: url,
      dataType: "json"
    }).done(function (group) {
      return callback(group);
    });
  },
  // Return groups list. Filtered by query
  groups: function groups(query, options, callback) {
    var url = Api.buildUrl(Api.groupsPath);
    return $.ajax({
      url: url,
      data: $.extend({
        search: query,
        per_page: 20
      }, options),
      dataType: "json"
    }).done(function (groups) {
      return callback(groups);
    });
  },
  // Return namespaces list. Filtered by query
  namespaces: function namespaces(query, callback) {
    var url = Api.buildUrl(Api.namespacesPath);
    return $.ajax({
      url: url,
      data: {
        search: query,
        per_page: 20
      },
      dataType: "json"
    }).done(function (namespaces) {
      return callback(namespaces);
    });
  },
  // Return projects list. Filtered by query
  projects: function projects(query, options, callback) {
    var url = Api.buildUrl(Api.projectsPath);
    return $.ajax({
      url: url,
      data: $.extend({
        search: query,
        per_page: 20,
        membership: true
      }, options),
      dataType: "json"
    }).done(function (projects) {
      return callback(projects);
    });
  },
  newLabel: function newLabel(namespace_path, project_path, data, callback) {
    var url = Api.buildUrl(Api.labelsPath).replace(':namespace_path', namespace_path).replace(':project_path', project_path);
    return $.ajax({
      url: url,
      type: "POST",
      data: { 'label': data },
      dataType: "json"
    }).done(function (label) {
      return callback(label);
    }).error(function (message) {
      return callback(message.responseJSON);
    });
  },
  // Return group projects list. Filtered by query
  groupProjects: function groupProjects(group_id, query, callback) {
    var url = Api.buildUrl(Api.groupProjectsPath).replace(':id', group_id);
    return $.ajax({
      url: url,
      data: {
        search: query,
        per_page: 20
      },
      dataType: "json"
    }).done(function (projects) {
      return callback(projects);
    });
  },
  // Return text for a specific license
  licenseText: function licenseText(key, data, callback) {
    var url = Api.buildUrl(Api.licensePath).replace(':key', key);
    return $.ajax({
      url: url,
      data: data
    }).done(function (license) {
      return callback(license);
    });
  },
  gitignoreText: function gitignoreText(key, callback) {
    var url = Api.buildUrl(Api.gitignorePath).replace(':key', key);
    return $.get(url, function (gitignore) {
      return callback(gitignore);
    });
  },
  gitlabCiYml: function gitlabCiYml(key, callback) {
    var url = Api.buildUrl(Api.gitlabCiYmlPath).replace(':key', key);
    return $.get(url, function (file) {
      return callback(file);
    });
  },
  dockerfileYml: function dockerfileYml(key, callback) {
    var url = Api.buildUrl(Api.dockerfilePath).replace(':key', key);
    $.get(url, callback);
  },
  issueTemplate: function issueTemplate(namespacePath, projectPath, key, type, callback) {
    var url = Api.buildUrl(Api.issuableTemplatePath).replace(':key', key).replace(':type', type).replace(':project_path', projectPath).replace(':namespace_path', namespacePath);
    $.ajax({
      url: url,
      dataType: 'json'
    }).done(function (file) {
      callback(null, file);
    }).error(callback);
  },
  buildUrl: function buildUrl(url) {
    if (gon.relative_url_root != null) {
      url = gon.relative_url_root + url;
    }
    return url.replace(':version', gon.api_version);
  }
};

window.Api = Api;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "foE1":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, wrap-iife, quotes, consistent-return, no-return-assign, no-param-reassign, one-var, no-var, one-var-declaration-per-line, no-unused-vars, prefer-template, object-shorthand, comma-dangle, max-len, prefer-arrow-callback */
/* global Pager */

window.CommitsList = function () {
  var CommitsList = {};

  CommitsList.timer = null;

  CommitsList.init = function (limit) {
    $("body").on("click", ".day-commits-table li.commit", function (e) {
      if (e.target.nodeName !== "A") {
        location.href = $(this).attr("url");
        e.stopPropagation();
        return false;
      }
    });
    Pager.init(limit, false, false, function () {
      gl.utils.localTimeAgo($('.js-timeago'));
    });
    this.content = $("#commits-list");
    this.searchField = $("#commits-search");
    this.lastSearch = this.searchField.val();
    return this.initSearch();
  };

  CommitsList.initSearch = function () {
    this.timer = null;
    return this.searchField.keyup(function (_this) {
      return function () {
        clearTimeout(_this.timer);
        return _this.timer = setTimeout(_this.filterResults, 500);
      };
    }(this));
  };

  CommitsList.filterResults = function () {
    var commitsUrl, form, search;
    form = $(".commits-search-form");
    search = CommitsList.searchField.val();
    if (search === CommitsList.lastSearch) return;
    commitsUrl = form.attr("action") + '?' + form.serialize();
    CommitsList.content.fadeTo('fast', 0.5);
    return $.ajax({
      type: "GET",
      url: form.attr("action"),
      data: form.serialize(),
      complete: function complete() {
        return CommitsList.content.fadeTo('fast', 1.0);
      },
      success: function success(data) {
        CommitsList.lastSearch = search;
        CommitsList.content.html(data.html);
        return history.replaceState({
          page: commitsUrl
          // Change url so if user reload a page - search results are saved
        }, document.title, commitsUrl);
      },
      error: function error() {
        CommitsList.lastSearch = null;
      },
      dataType: "json"
    });
  };

  return CommitsList;
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "hGiy":
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable func-names, space-before-function-paren, max-len, one-var, no-var, no-restricted-syntax, vars-on-top, no-use-before-define, no-param-reassign, new-cap, no-underscore-dangle, wrap-iife */
/* global Mousetrap */
/* global ShortcutsNavigation */

__webpack_require__("/3Gu");

(function () {
  var extend = function extend(child, parent) {
    for (var key in parent) {
      if (hasProp.call(parent, key)) child[key] = parent[key];
    }function ctor() {
      this.constructor = child;
    }ctor.prototype = parent.prototype;child.prototype = new ctor();child.__super__ = parent.prototype;return child;
  },
      hasProp = {}.hasOwnProperty;

  this.ShortcutsFindFile = function (superClass) {
    extend(ShortcutsFindFile, superClass);

    function ShortcutsFindFile(projectFindFile) {
      var _oldStopCallback;
      this.projectFindFile = projectFindFile;
      ShortcutsFindFile.__super__.constructor.call(this);
      _oldStopCallback = Mousetrap.stopCallback;
      Mousetrap.stopCallback = function (_this) {
        // override to fire shortcuts action when focus in textbox
        return function (event, element, combo) {
          if (element === _this.projectFindFile.inputElement[0] && (combo === 'up' || combo === 'down' || combo === 'esc' || combo === 'enter')) {
            // when press up/down key in textbox, cusor prevent to move to home/end
            event.preventDefault();
            return false;
          }
          return _oldStopCallback(event, element, combo);
        };
      }(this);
      Mousetrap.bind('up', this.projectFindFile.selectRowUp);
      Mousetrap.bind('down', this.projectFindFile.selectRowDown);
      Mousetrap.bind('esc', this.projectFindFile.goToTree);
      Mousetrap.bind('enter', this.projectFindFile.goToBlob);
    }

    return ShortcutsFindFile;
  }(ShortcutsNavigation);
}).call(window);

/***/ }),

/***/ "hZZT":
/***/ (function(module, exports, __webpack_require__) {

var require;var require;/*!
 * clipboard.js v1.4.2
 * https://zenorocha.github.io/clipboard.js
 *
 * Licensed MIT © Zeno Rocha
 */
(function(f){if(true){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.Clipboard = f()}})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return require(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
/**
 * Module dependencies.
 */

var closest = require('closest')
  , event = require('component-event');

/**
 * Delegate event `type` to `selector`
 * and invoke `fn(e)`. A callback function
 * is returned which may be passed to `.unbind()`.
 *
 * @param {Element} el
 * @param {String} selector
 * @param {String} type
 * @param {Function} fn
 * @param {Boolean} capture
 * @return {Function}
 * @api public
 */

// Some events don't bubble, so we want to bind to the capture phase instead
// when delegating.
var forceCaptureEvents = ['focus', 'blur'];

exports.bind = function(el, selector, type, fn, capture){
  if (forceCaptureEvents.indexOf(type) !== -1) capture = true;

  return event.bind(el, type, function(e){
    var target = e.target || e.srcElement;
    e.delegateTarget = closest(target, selector, true, el);
    if (e.delegateTarget) fn.call(el, e);
  }, capture);
};

/**
 * Unbind event `type`'s callback `fn`.
 *
 * @param {Element} el
 * @param {String} type
 * @param {Function} fn
 * @param {Boolean} capture
 * @api public
 */

exports.unbind = function(el, type, fn, capture){
  if (forceCaptureEvents.indexOf(type) !== -1) capture = true;

  event.unbind(el, type, fn, capture);
};

},{"closest":2,"component-event":4}],2:[function(require,module,exports){
var matches = require('matches-selector')

module.exports = function (element, selector, checkYoSelf) {
  var parent = checkYoSelf ? element : element.parentNode

  while (parent && parent !== document) {
    if (matches(parent, selector)) return parent;
    parent = parent.parentNode
  }
}

},{"matches-selector":3}],3:[function(require,module,exports){

/**
 * Element prototype.
 */

var proto = Element.prototype;

/**
 * Vendor function.
 */

var vendor = proto.matchesSelector
  || proto.webkitMatchesSelector
  || proto.mozMatchesSelector
  || proto.msMatchesSelector
  || proto.oMatchesSelector;

/**
 * Expose `match()`.
 */

module.exports = match;

/**
 * Match `el` to `selector`.
 *
 * @param {Element} el
 * @param {String} selector
 * @return {Boolean}
 * @api public
 */

function match(el, selector) {
  if (vendor) return vendor.call(el, selector);
  var nodes = el.parentNode.querySelectorAll(selector);
  for (var i = 0; i < nodes.length; ++i) {
    if (nodes[i] == el) return true;
  }
  return false;
}
},{}],4:[function(require,module,exports){
var bind = window.addEventListener ? 'addEventListener' : 'attachEvent',
    unbind = window.removeEventListener ? 'removeEventListener' : 'detachEvent',
    prefix = bind !== 'addEventListener' ? 'on' : '';

/**
 * Bind `el` event `type` to `fn`.
 *
 * @param {Element} el
 * @param {String} type
 * @param {Function} fn
 * @param {Boolean} capture
 * @return {Function}
 * @api public
 */

exports.bind = function(el, type, fn, capture){
  el[bind](prefix + type, fn, capture || false);
  return fn;
};

/**
 * Unbind `el` event `type`'s callback `fn`.
 *
 * @param {Element} el
 * @param {String} type
 * @param {Function} fn
 * @param {Boolean} capture
 * @return {Function}
 * @api public
 */

exports.unbind = function(el, type, fn, capture){
  el[unbind](prefix + type, fn, capture || false);
  return fn;
};
},{}],5:[function(require,module,exports){
function E () {
	// Keep this empty so it's easier to inherit from
  // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
}

E.prototype = {
	on: function (name, callback, ctx) {
    var e = this.e || (this.e = {});

    (e[name] || (e[name] = [])).push({
      fn: callback,
      ctx: ctx
    });

    return this;
  },

  once: function (name, callback, ctx) {
    var self = this;
    var fn = function () {
      self.off(name, fn);
      callback.apply(ctx, arguments);
    };

    return this.on(name, fn, ctx);
  },

  emit: function (name) {
    var data = [].slice.call(arguments, 1);
    var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
    var i = 0;
    var len = evtArr.length;

    for (i; i < len; i++) {
      evtArr[i].fn.apply(evtArr[i].ctx, data);
    }

    return this;
  },

  off: function (name, callback) {
    var e = this.e || (this.e = {});
    var evts = e[name];
    var liveEvents = [];

    if (evts && callback) {
      for (var i = 0, len = evts.length; i < len; i++) {
        if (evts[i].fn !== callback) liveEvents.push(evts[i]);
      }
    }

    // Remove event from queue to prevent memory leak
    // Suggested by https://github.com/lazd
    // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910

    (liveEvents.length)
      ? e[name] = liveEvents
      : delete e[name];

    return this;
  }
};

module.exports = E;

},{}],6:[function(require,module,exports){
/**
 * Inner class which performs selection from either `text` or `target`
 * properties and then executes copy or cut operations.
 */
'use strict';

exports.__esModule = true;

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var ClipboardAction = (function () {
    /**
     * @param {Object} options
     */

    function ClipboardAction(options) {
        _classCallCheck(this, ClipboardAction);

        this.resolveOptions(options);
        this.initSelection();
    }

    /**
     * Defines base properties passed from constructor.
     * @param {Object} options
     */

    ClipboardAction.prototype.resolveOptions = function resolveOptions() {
        var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

        this.action = options.action;
        this.emitter = options.emitter;
        this.target = options.target;
        this.text = options.text;
        this.trigger = options.trigger;

        this.selectedText = '';
    };

    /**
     * Decides which selection strategy is going to be applied based
     * on the existence of `text` and `target` properties.
     */

    ClipboardAction.prototype.initSelection = function initSelection() {
        if (this.text && this.target) {
            throw new Error('Multiple attributes declared, use either "target" or "text"');
        } else if (this.text) {
            this.selectFake();
        } else if (this.target) {
            this.selectTarget();
        } else {
            throw new Error('Missing required attributes, use either "target" or "text"');
        }
    };

    /**
     * Creates a fake textarea element, sets its value from `text` property,
     * and makes a selection on it.
     */

    ClipboardAction.prototype.selectFake = function selectFake() {
        var _this = this;

        this.removeFake();

        this.fakeHandler = document.body.addEventListener('click', function () {
            return _this.removeFake();
        });

        this.fakeElem = document.createElement('textarea');
        this.fakeElem.style.position = 'absolute';
        this.fakeElem.style.left = '-9999px';
        this.fakeElem.style.top = (window.pageYOffset || document.documentElement.scrollTop) + 'px';
        this.fakeElem.setAttribute('readonly', '');
        this.fakeElem.value = this.text;
        this.selectedText = this.text;

        document.body.appendChild(this.fakeElem);

        this.fakeElem.select();
        this.copyText();
    };

    /**
     * Only removes the fake element after another click event, that way
     * a user can hit `Ctrl+C` to copy because selection still exists.
     */

    ClipboardAction.prototype.removeFake = function removeFake() {
        if (this.fakeHandler) {
            document.body.removeEventListener('click');
            this.fakeHandler = null;
        }

        if (this.fakeElem) {
            document.body.removeChild(this.fakeElem);
            this.fakeElem = null;
        }
    };

    /**
     * Selects the content from element passed on `target` property.
     */

    ClipboardAction.prototype.selectTarget = function selectTarget() {
        if (this.target.nodeName === 'INPUT' || this.target.nodeName === 'TEXTAREA') {
            this.target.select();
            this.selectedText = this.target.value;
        } else {
            var range = document.createRange();
            var selection = window.getSelection();

            selection.removeAllRanges();
            range.selectNodeContents(this.target);
            selection.addRange(range);
            this.selectedText = selection.toString();
        }

        this.copyText();
    };

    /**
     * Executes the copy operation based on the current selection.
     */

    ClipboardAction.prototype.copyText = function copyText() {
        var succeeded = undefined;

        try {
            succeeded = document.execCommand(this.action);
        } catch (err) {
            succeeded = false;
        }

        this.handleResult(succeeded);
    };

    /**
     * Fires an event based on the copy operation result.
     * @param {Boolean} succeeded
     */

    ClipboardAction.prototype.handleResult = function handleResult(succeeded) {
        if (succeeded) {
            this.emitter.emit('success', {
                action: this.action,
                text: this.selectedText,
                trigger: this.trigger,
                clearSelection: this.clearSelection.bind(this)
            });
        } else {
            this.emitter.emit('error', {
                action: this.action,
                trigger: this.trigger,
                clearSelection: this.clearSelection.bind(this)
            });
        }
    };

    /**
     * Removes current selection and focus from `target` element.
     */

    ClipboardAction.prototype.clearSelection = function clearSelection() {
        if (this.target) {
            this.target.blur();
        }

        window.getSelection().removeAllRanges();
    };

    /**
     * Sets the `action` to be performed which can be either 'copy' or 'cut'.
     * @param {String} action
     */

    /**
     * Destroy lifecycle.
     */

    ClipboardAction.prototype.destroy = function destroy() {
        this.removeFake();
    };

    _createClass(ClipboardAction, [{
        key: 'action',
        set: function set() {
            var action = arguments.length <= 0 || arguments[0] === undefined ? 'copy' : arguments[0];

            this._action = action;

            if (this._action !== 'copy' && this._action !== 'cut') {
                throw new Error('Invalid "action" value, use either "copy" or "cut"');
            }
        },

        /**
         * Gets the `action` property.
         * @return {String}
         */
        get: function get() {
            return this._action;
        }

        /**
         * Sets the `target` property using an element
         * that will be have its content copied.
         * @param {Element} target
         */
    }, {
        key: 'target',
        set: function set(target) {
            if (target !== undefined) {
                if (target && typeof target === 'object' && target.nodeType === 1) {
                    this._target = target;
                } else {
                    throw new Error('Invalid "target" value, use a valid Element');
                }
            }
        },

        /**
         * Gets the `target` property.
         * @return {String|HTMLElement}
         */
        get: function get() {
            return this._target;
        }
    }]);

    return ClipboardAction;
})();

exports['default'] = ClipboardAction;
module.exports = exports['default'];

},{}],7:[function(require,module,exports){
'use strict';

exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _clipboardAction = require('./clipboard-action');

var _clipboardAction2 = _interopRequireDefault(_clipboardAction);

var _delegateEvents = require('delegate-events');

var _delegateEvents2 = _interopRequireDefault(_delegateEvents);

var _tinyEmitter = require('tiny-emitter');

var _tinyEmitter2 = _interopRequireDefault(_tinyEmitter);

/**
 * Base class which takes a selector, delegates a click event to it,
 * and instantiates a new `ClipboardAction` on each click.
 */

var Clipboard = (function (_Emitter) {
    _inherits(Clipboard, _Emitter);

    /**
     * @param {String} selector
     * @param {Object} options
     */

    function Clipboard(selector, options) {
        _classCallCheck(this, Clipboard);

        _Emitter.call(this);

        this.resolveOptions(options);
        this.delegateClick(selector);
    }

    /**
     * Helper function to retrieve attribute value.
     * @param {String} suffix
     * @param {Element} element
     */

    /**
     * Defines if attributes would be resolved using internal setter functions
     * or custom functions that were passed in the constructor.
     * @param {Object} options
     */

    Clipboard.prototype.resolveOptions = function resolveOptions() {
        var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

        this.action = typeof options.action === 'function' ? options.action : this.defaultAction;
        this.target = typeof options.target === 'function' ? options.target : this.defaultTarget;
        this.text = typeof options.text === 'function' ? options.text : this.defaultText;
    };

    /**
     * Delegates a click event on the passed selector.
     * @param {String} selector
     */

    Clipboard.prototype.delegateClick = function delegateClick(selector) {
        var _this = this;

        this.binding = _delegateEvents2['default'].bind(document.body, selector, 'click', function (e) {
            return _this.onClick(e);
        });
    };

    /**
     * Undelegates a click event on body.
     * @param {String} selector
     */

    Clipboard.prototype.undelegateClick = function undelegateClick() {
        _delegateEvents2['default'].unbind(document.body, 'click', this.binding);
    };

    /**
     * Defines a new `ClipboardAction` on each click event.
     * @param {Event} e
     */

    Clipboard.prototype.onClick = function onClick(e) {
        if (this.clipboardAction) {
            this.clipboardAction = null;
        }

        this.clipboardAction = new _clipboardAction2['default']({
            action: this.action(e.delegateTarget),
            target: this.target(e.delegateTarget),
            text: this.text(e.delegateTarget),
            trigger: e.delegateTarget,
            emitter: this
        });
    };

    /**
     * Default `action` lookup function.
     * @param {Element} trigger
     */

    Clipboard.prototype.defaultAction = function defaultAction(trigger) {
        return getAttributeValue('action', trigger);
    };

    /**
     * Default `target` lookup function.
     * @param {Element} trigger
     */

    Clipboard.prototype.defaultTarget = function defaultTarget(trigger) {
        var selector = getAttributeValue('target', trigger);

        if (selector) {
            return document.querySelector(selector);
        }
    };

    /**
     * Default `text` lookup function.
     * @param {Element} trigger
     */

    Clipboard.prototype.defaultText = function defaultText(trigger) {
        return getAttributeValue('text', trigger);
    };

    /**
     * Destroy lifecycle.
     */

    Clipboard.prototype.destroy = function destroy() {
        this.undelegateClick();

        if (this.clipboardAction) {
            this.clipboardAction.destroy();
            this.clipboardAction = null;
        }
    };

    return Clipboard;
})(_tinyEmitter2['default']);

function getAttributeValue(suffix, element) {
    var attribute = 'data-clipboard-' + suffix;

    if (!element.hasAttribute(attribute)) {
        return;
    }

    return element.getAttribute(attribute);
}

exports['default'] = Clipboard;
module.exports = exports['default'];

},{"./clipboard-action":6,"delegate-events":1,"tiny-emitter":5}]},{},[7])(7)
});


/***/ }),

/***/ "i4oR":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {
$(function () {
  $('body').on('click', '.js-details-target', function target() {
    $(this).closest('.js-details-container').toggleClass('open');
  });

  // Show details content. Hides link after click.
  //
  // %div
  //   %a.js-details-expand
  //   %div.js-details-content
  //
  $('body').on('click', '.js-details-expand', function expand(e) {
    e.preventDefault();
    $(this).next('.js-details-content').removeClass('hide');
    $(this).hide();

    var truncatedItem = $(this).siblings('.js-details-short');
    if (truncatedItem.length) {
      truncatedItem.addClass('hide');
    }
  });
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "iHtO":
/***/ (function(module, exports, __webpack_require__) {

/*
 * Date Format 1.2.3
 * (c) 2007-2009 Steven Levithan <stevenlevithan.com>
 * MIT license
 *
 * Includes enhancements by Scott Trenda <scott.trenda.net>
 * and Kris Kowal <cixar.com/~kris.kowal/>
 *
 * Accepts a date, a mask, or a date and a mask.
 * Returns a formatted version of the given date.
 * The date defaults to the current date/time.
 * The mask defaults to dateFormat.masks.default.
 */
 (function (global, factory) {
      true ? module.exports = factory() :
     typeof define === 'function' && define.amd ? define(factory) :
     (global.dateFormat = factory());
 }(this, (function () { 'use strict';
  var dateFormat = function () {
    var token = /d{1,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|[LloSZ]|"[^"]*"|'[^']*'/g,
      timezone = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g,
      timezoneClip = /[^-+\dA-Z]/g,
      pad = function (val, len) {
        val = String(val);
        len = len || 2;
        while (val.length < len) val = "0" + val;
        return val;
      };

    // Regexes and supporting functions are cached through closure
    return function (date, mask, utc) {
      var dF = dateFormat;

      // You can't provide utc if you skip other args (use the "UTC:" mask prefix)
      if (arguments.length == 1 && Object.prototype.toString.call(date) == "[object String]" && !/\d/.test(date)) {
        mask = date;
        date = undefined;
      }

      // Passing date through Date applies Date.parse, if necessary
      date = date ? new Date(date) : new Date;
      if (isNaN(date)) throw SyntaxError("invalid date");

      mask = String(dF.masks[mask] || mask || dF.masks["default"]);

      // Allow setting the utc argument via the mask
      if (mask.slice(0, 4) == "UTC:") {
        mask = mask.slice(4);
        utc = true;
      }

      var _ = utc ? "getUTC" : "get",
        d = date[_ + "Date"](),
        D = date[_ + "Day"](),
        m = date[_ + "Month"](),
        y = date[_ + "FullYear"](),
        H = date[_ + "Hours"](),
        M = date[_ + "Minutes"](),
        s = date[_ + "Seconds"](),
        L = date[_ + "Milliseconds"](),
        o = utc ? 0 : date.getTimezoneOffset(),
        flags = {
          d:    d,
          dd:   pad(d),
          ddd:  dF.i18n.dayNames[D],
          dddd: dF.i18n.dayNames[D + 7],
          m:    m + 1,
          mm:   pad(m + 1),
          mmm:  dF.i18n.monthNames[m],
          mmmm: dF.i18n.monthNames[m + 12],
          yy:   String(y).slice(2),
          yyyy: y,
          h:    H % 12 || 12,
          hh:   pad(H % 12 || 12),
          H:    H,
          HH:   pad(H),
          M:    M,
          MM:   pad(M),
          s:    s,
          ss:   pad(s),
          l:    pad(L, 3),
          L:    pad(L > 99 ? Math.round(L / 10) : L),
          t:    H < 12 ? "a"  : "p",
          tt:   H < 12 ? "am" : "pm",
          T:    H < 12 ? "A"  : "P",
          TT:   H < 12 ? "AM" : "PM",
          Z:    utc ? "UTC" : (String(date).match(timezone) || [""]).pop().replace(timezoneClip, ""),
          o:    (o > 0 ? "-" : "+") + pad(Math.floor(Math.abs(o) / 60) * 100 + Math.abs(o) % 60, 4),
          S:    ["th", "st", "nd", "rd"][d % 10 > 3 ? 0 : (d % 100 - d % 10 != 10) * d % 10]
        };

      return mask.replace(token, function ($0) {
        return $0 in flags ? flags[$0] : $0.slice(1, $0.length - 1);
      });
    };
  }();

  // Some common format strings
  dateFormat.masks = {
    "default":      "ddd mmm dd yyyy HH:MM:ss",
    shortDate:      "m/d/yy",
    mediumDate:     "mmm d, yyyy",
    longDate:       "mmmm d, yyyy",
    fullDate:       "dddd, mmmm d, yyyy",
    shortTime:      "h:MM TT",
    mediumTime:     "h:MM:ss TT",
    longTime:       "h:MM:ss TT Z",
    isoDate:        "yyyy-mm-dd",
    isoTime:        "HH:MM:ss",
    isoDateTime:    "yyyy-mm-dd'T'HH:MM:ss",
    isoUtcDateTime: "UTC:yyyy-mm-dd'T'HH:MM:ss'Z'"
  };

  // Internationalization strings
  dateFormat.i18n = {
    dayNames: [
      "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat",
      "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"
    ],
    monthNames: [
      "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
      "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"
    ]
  };

  // For convenience...
  Date.prototype.format = function (mask, utc) {
    return dateFormat(this, mask, utc);
  };

  return dateFormat;
})));


/***/ }),

/***/ "iqF/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__droplab_drop_lab__ = __webpack_require__("KV3v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__droplab_plugins_input_setter__ = __webpack_require__("PN0v");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }




var CommentTypeToggle = function () {
  function CommentTypeToggle() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, CommentTypeToggle);

    this.dropdownTrigger = opts.dropdownTrigger;
    this.dropdownList = opts.dropdownList;
    this.noteTypeInput = opts.noteTypeInput;
    this.submitButton = opts.submitButton;
    this.closeButton = opts.closeButton;
    this.reopenButton = opts.reopenButton;
  }

  _createClass(CommentTypeToggle, [{
    key: 'initDroplab',
    value: function initDroplab() {
      this.droplab = new __WEBPACK_IMPORTED_MODULE_0__droplab_drop_lab__["a" /* default */]();

      var config = this.setConfig();

      this.droplab.init(this.dropdownTrigger, this.dropdownList, [__WEBPACK_IMPORTED_MODULE_1__droplab_plugins_input_setter__["a" /* default */]], config);
    }
  }, {
    key: 'setConfig',
    value: function setConfig() {
      var config = {
        InputSetter: [{
          input: this.noteTypeInput,
          valueAttribute: 'data-value'
        }, {
          input: this.submitButton,
          valueAttribute: 'data-submit-text'
        }]
      };

      if (this.closeButton) {
        config.InputSetter.push({
          input: this.closeButton,
          valueAttribute: 'data-close-text'
        }, {
          input: this.closeButton,
          valueAttribute: 'data-close-text',
          inputAttribute: 'data-alternative-text'
        });
      }

      if (this.reopenButton) {
        config.InputSetter.push({
          input: this.reopenButton,
          valueAttribute: 'data-reopen-text'
        }, {
          input: this.reopenButton,
          valueAttribute: 'data-reopen-text',
          inputAttribute: 'data-alternative-text'
        });
      }

      return config;
    }
  }]);

  return CommentTypeToggle;
}();

/* harmony default export */ __webpack_exports__["a"] = (CommentTypeToggle);

/***/ }),

/***/ "iv5u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($, jQuery) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable class-methods-use-this, no-unused-vars */

var TemplateSelector = function () {
  function TemplateSelector() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        dropdown = _ref.dropdown,
        data = _ref.data,
        pattern = _ref.pattern,
        wrapper = _ref.wrapper,
        editor = _ref.editor,
        $input = _ref.$input;

    _classCallCheck(this, TemplateSelector);

    this.pattern = pattern;
    this.editor = editor;
    this.dropdown = dropdown;
    this.$dropdownContainer = wrapper;
    this.$filenameInput = $input || $('#file_name');
    this.$dropdownIcon = $('.fa-chevron-down', dropdown);

    this.initDropdown(dropdown, data);
    this.listenForFilenameInput();
    this.renderMatchedDropdown();
    this.initAutosizeUpdateEvent();
  }

  _createClass(TemplateSelector, [{
    key: 'initDropdown',
    value: function initDropdown(dropdown, data) {
      var _this = this;

      return $(dropdown).glDropdown({
        data: data,
        filterable: true,
        selectable: true,
        toggleLabel: function toggleLabel(item) {
          return item.name;
        },
        search: {
          fields: ['name']
        },
        clicked: function clicked(item, el, e) {
          return _this.fetchFileTemplate(item, el, e);
        },
        text: function text(item) {
          return item.name;
        }
      });
    }
  }, {
    key: 'initAutosizeUpdateEvent',
    value: function initAutosizeUpdateEvent() {
      this.autosizeUpdateEvent = document.createEvent('Event');
      this.autosizeUpdateEvent.initEvent('autosize:update', true, false);
    }
  }, {
    key: 'listenForFilenameInput',
    value: function listenForFilenameInput() {
      var _this2 = this;

      return this.$filenameInput.on('keyup blur', function (e) {
        return _this2.renderMatchedDropdown(e);
      });
    }
  }, {
    key: 'renderMatchedDropdown',
    value: function renderMatchedDropdown() {
      if (!this.$filenameInput.length) {
        return null;
      }

      var filenameMatches = this.pattern.test(this.$filenameInput.val().trim());

      if (!filenameMatches) {
        return this.$dropdownContainer.addClass('hidden');
      }
      return this.$dropdownContainer.removeClass('hidden');
    }
  }, {
    key: 'fetchFileTemplate',
    value: function fetchFileTemplate(item, el, e) {
      e.preventDefault();
      return this.requestFile(item);
    }
  }, {
    key: 'requestFile',
    value: function requestFile(item) {}
    // This `requestFile` method is an abstract method that should
    // be added by all subclasses.


    // To be implemented on the extending class
    // e.g. Api.gitlabCiYml(query.name, file => this.setEditorContent(file));

  }, {
    key: 'setEditorContent',
    value: function setEditorContent(file) {
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          skipFocus = _ref2.skipFocus;

      if (!file) return;

      var newValue = file.content;

      this.editor.setValue(newValue, 1);

      if (!skipFocus) this.editor.focus();

      if (this.editor instanceof jQuery) {
        this.editor.get(0).dispatchEvent(this.autosizeUpdateEvent);
      }
    }
  }, {
    key: 'startLoadingSpinner',
    value: function startLoadingSpinner() {
      this.$dropdownIcon.addClass('fa-spinner fa-spin').removeClass('fa-chevron-down');
    }
  }, {
    key: 'stopLoadingSpinner',
    value: function stopLoadingSpinner() {
      this.$dropdownIcon.addClass('fa-chevron-down').removeClass('fa-spinner fa-spin');
    }
  }]);

  return TemplateSelector;
}();

/* harmony default export */ __webpack_exports__["a"] = (TemplateSelector);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("lwLq"), __webpack_require__("lwLq")))

/***/ }),

/***/ "j4Jp":
/***/ (function(module, exports) {

!function(t,e){"object"==typeof module&&module.exports?module.exports=e(t):t.timeago=e(t)}("undefined"!=typeof window?window:this,function(){function t(t){return t instanceof Date?t:isNaN(t)?/^\d+$/.test(t)?new Date(e(t)):(t=(t||"").trim().replace(/\.\d+/,"").replace(/-/,"/").replace(/-/,"/").replace(/(\d)T(\d)/,"$1 $2").replace(/Z/," UTC").replace(/([\+\-]\d\d)\:?(\d\d)/," $1$2"),new Date(t)):new Date(e(t))}function e(t){return parseInt(t)}function n(t,n,r){n=d[n]?n:d[r]?r:"en";var i=0,a=t<0?1:0;for(t=Math.abs(t);t>=l[i]&&i<h;i++)t/=l[i];return t=e(t),i*=2,t>(0===i?9:1)&&(i+=1),d[n](t,i)[a].replace("%s",t)}function r(e,n){return n=n?t(n):new Date,(n-t(e))/1e3}function i(t){for(var e=1,n=0,r=Math.abs(t);t>=l[n]&&n<h;n++)t/=l[n],e*=l[n];return r%=e,r=r?e-r:e,Math.ceil(r)}function a(t){return t.dataset.timeago?t.dataset.timeago:t.getAttribute?t.getAttribute(p):t.attr?t.attr(p):void 0}function o(t,e){function o(a,c,f,s){var d=r(c,t);a.innerHTML=n(d,f,e),u["k"+s]=setTimeout(function(){o(a,c,f,s)},Math.min(1e3*i(d),2147483647))}var u={};return e||(e="en"),this.format=function(i,a){return n(r(i,t),a,e)},this.render=function(t,e){void 0===t.length&&(t=[t]);for(var n=0;n<t.length;n++)o(t[n],a(t[n]),e,++c)},this.cancel=function(){for(var t in u)clearTimeout(u[t]);u={}},this.setLocale=function(t){e=t},this}function u(t,e){return new o(t,e)}var c=0,f="second_minute_hour_day_week_month_year".split("_"),s="秒_分钟_小时_天_周_月_年".split("_"),d={en:function(t,e){if(0===e)return["just now","right now"];var n=f[parseInt(e/2)];return t>1&&(n+="s"),[t+" "+n+" ago","in "+t+" "+n]},zh_CN:function(t,e){if(0===e)return["刚刚","片刻后"];var n=s[parseInt(e/2)];return[t+n+"前",t+n+"后"]}},l=[60,60,24,7,365/7/12,12],h=6,p="datetime";return u.register=function(t,e){d[t]=e},u});

/***/ }),

/***/ "jQR1":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, wrap-iife, no-param-reassign, no-void, prefer-template, no-var, new-cap, prefer-arrow-callback, consistent-return, max-len */
(function () {
  (function (w) {
    if (w.gl == null) {
      w.gl = {};
    }
    if (gl.animate == null) {
      gl.animate = {};
    }
    gl.animate.animate = function ($el, animation, options, done) {
      if ((options != null ? options.cssStart : void 0) != null) {
        $el.css(options.cssStart);
      }
      $el.removeClass(animation + ' animated').addClass(animation + ' animated').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function () {
        $(this).removeClass(animation + ' animated');
        if (done != null) {
          done();
        }
        if ((options != null ? options.cssEnd : void 0) != null) {
          $el.css(options.cssEnd);
        }
      });
    };
    gl.animate.animateEach = function ($els, animation, time, options, done) {
      var dfd;
      dfd = $.Deferred();
      if (!$els.length) {
        dfd.resolve();
      }
      $els.each(function (i) {
        setTimeout(function (_this) {
          return function () {
            var $this;
            $this = $(_this);
            return gl.animate.animate($this, animation, options, function () {
              if (i === $els.length - 1) {
                dfd.resolve();
                if (done != null) {
                  return done();
                }
              }
            });
          };
        }(this), time * i);
      });
      return dfd.promise();
    };
  })(window);
}).call(window);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "jdYI":
/***/ (function(module, exports, __webpack_require__) {

var require;var require;/*!
 * fuzzaldrin-plus.js - 0.3.1
 * https://github.com/jeancroy/fuzzaldrin-plus
 *
 * Copyright 2016 - Jean Christophe Roy
 * Released under the MIT license
 * https://github.com/jeancroy/fuzzaldrin-plus/raw/master/LICENSE.md
 */
(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return require(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
fuzzaldrinPlus = require('fuzzaldrin-plus');

},{"fuzzaldrin-plus":3}],2:[function(require,module,exports){
(function() {
  var PathSeparator, legacy_scorer, pluckCandidates, scorer, sortCandidates;

  scorer = require('./scorer');

  legacy_scorer = require('./legacy');

  pluckCandidates = function(a) {
    return a.candidate;
  };

  sortCandidates = function(a, b) {
    return b.score - a.score;
  };

  PathSeparator = require('path').sep;

  module.exports = function(candidates, query, _arg) {
    var allowErrors, bAllowErrors, bKey, candidate, coreQuery, key, legacy, maxInners, maxResults, prepQuery, queryHasSlashes, score, scoredCandidates, spotLeft, string, _i, _j, _len, _len1, _ref;
    _ref = _arg != null ? _arg : {}, key = _ref.key, maxResults = _ref.maxResults, maxInners = _ref.maxInners, allowErrors = _ref.allowErrors, legacy = _ref.legacy;
    scoredCandidates = [];
    spotLeft = (maxInners != null) && maxInners > 0 ? maxInners : candidates.length;
    bAllowErrors = !!allowErrors;
    bKey = key != null;
    prepQuery = scorer.prepQuery(query);
    if (!legacy) {
      for (_i = 0, _len = candidates.length; _i < _len; _i++) {
        candidate = candidates[_i];
        string = bKey ? candidate[key] : candidate;
        if (!string) {
          continue;
        }
        score = scorer.score(string, query, prepQuery, bAllowErrors);
        if (score > 0) {
          scoredCandidates.push({
            candidate: candidate,
            score: score
          });
          if (!--spotLeft) {
            break;
          }
        }
      }
    } else {
      queryHasSlashes = prepQuery.depth > 0;
      coreQuery = prepQuery.core;
      for (_j = 0, _len1 = candidates.length; _j < _len1; _j++) {
        candidate = candidates[_j];
        string = key != null ? candidate[key] : candidate;
        if (!string) {
          continue;
        }
        score = legacy_scorer.score(string, coreQuery, queryHasSlashes);
        if (!queryHasSlashes) {
          score = legacy_scorer.basenameScore(string, coreQuery, score);
        }
        if (score > 0) {
          scoredCandidates.push({
            candidate: candidate,
            score: score
          });
        }
      }
    }
    scoredCandidates.sort(sortCandidates);
    candidates = scoredCandidates.map(pluckCandidates);
    if (maxResults != null) {
      candidates = candidates.slice(0, maxResults);
    }
    return candidates;
  };

}).call(this);

},{"./legacy":4,"./scorer":6,"path":7}],3:[function(require,module,exports){
(function() {
  var PathSeparator, filter, legacy_scorer, matcher, prepQueryCache, scorer;

  scorer = require('./scorer');

  legacy_scorer = require('./legacy');

  filter = require('./filter');

  matcher = require('./matcher');

  PathSeparator = require('path').sep;

  prepQueryCache = null;

  module.exports = {
    filter: function(candidates, query, options) {
      if (!((query != null ? query.length : void 0) && (candidates != null ? candidates.length : void 0))) {
        return [];
      }
      return filter(candidates, query, options);
    },
    prepQuery: function(query) {
      return scorer.prepQuery(query);
    },
    score: function(string, query, prepQuery, _arg) {
      var allowErrors, coreQuery, legacy, queryHasSlashes, score, _ref;
      _ref = _arg != null ? _arg : {}, allowErrors = _ref.allowErrors, legacy = _ref.legacy;
      if (!((string != null ? string.length : void 0) && (query != null ? query.length : void 0))) {
        return 0;
      }
      if (prepQuery == null) {
        prepQuery = prepQueryCache && prepQueryCache.query === query ? prepQueryCache : (prepQueryCache = scorer.prepQuery(query));
      }
      if (!legacy) {
        score = scorer.score(string, query, prepQuery, !!allowErrors);
      } else {
        queryHasSlashes = prepQuery.depth > 0;
        coreQuery = prepQuery.core;
        score = legacy_scorer.score(string, coreQuery, queryHasSlashes);
        if (!queryHasSlashes) {
          score = legacy_scorer.basenameScore(string, coreQuery, score);
        }
      }
      return score;
    },
    match: function(string, query, prepQuery, _arg) {
      var allowErrors, baseMatches, matches, query_lw, string_lw, _i, _ref, _results;
      allowErrors = (_arg != null ? _arg : {}).allowErrors;
      if (!string) {
        return [];
      }
      if (!query) {
        return [];
      }
      if (string === query) {
        return (function() {
          _results = [];
          for (var _i = 0, _ref = string.length; 0 <= _ref ? _i < _ref : _i > _ref; 0 <= _ref ? _i++ : _i--){ _results.push(_i); }
          return _results;
        }).apply(this);
      }
      if (prepQuery == null) {
        prepQuery = prepQueryCache && prepQueryCache.query === query ? prepQueryCache : (prepQueryCache = scorer.prepQuery(query));
      }
      if (!(allowErrors || scorer.isMatch(string, prepQuery.core_lw, prepQuery.core_up))) {
        return [];
      }
      string_lw = string.toLowerCase();
      query_lw = prepQuery.query_lw;
      matches = matcher.match(string, string_lw, prepQuery);
      if (matches.length === 0) {
        return matches;
      }
      if (string.indexOf(PathSeparator) > -1) {
        baseMatches = matcher.basenameMatch(string, string_lw, prepQuery);
        matches = matcher.mergeMatches(matches, baseMatches);
      }
      return matches;
    }
  };

}).call(this);

},{"./filter":2,"./legacy":4,"./matcher":5,"./scorer":6,"path":7}],4:[function(require,module,exports){
(function() {
  var PathSeparator, queryIsLastPathSegment;

  PathSeparator = require('path').sep;

  exports.basenameScore = function(string, query, score) {
    var base, depth, index, lastCharacter, segmentCount, slashCount;
    index = string.length - 1;
    while (string[index] === PathSeparator) {
      index--;
    }
    slashCount = 0;
    lastCharacter = index;
    base = null;
    while (index >= 0) {
      if (string[index] === PathSeparator) {
        slashCount++;
        if (base == null) {
          base = string.substring(index + 1, lastCharacter + 1);
        }
      } else if (index === 0) {
        if (lastCharacter < string.length - 1) {
          if (base == null) {
            base = string.substring(0, lastCharacter + 1);
          }
        } else {
          if (base == null) {
            base = string;
          }
        }
      }
      index--;
    }
    if (base === string) {
      score *= 2;
    } else if (base) {
      score += exports.score(base, query);
    }
    segmentCount = slashCount + 1;
    depth = Math.max(1, 10 - segmentCount);
    score *= depth * 0.01;
    return score;
  };

  exports.score = function(string, query) {
    var character, characterScore, indexInQuery, indexInString, lowerCaseIndex, minIndex, queryLength, queryScore, stringLength, totalCharacterScore, upperCaseIndex, _ref;
    if (string === query) {
      return 1;
    }
    if (queryIsLastPathSegment(string, query)) {
      return 1;
    }
    totalCharacterScore = 0;
    queryLength = query.length;
    stringLength = string.length;
    indexInQuery = 0;
    indexInString = 0;
    while (indexInQuery < queryLength) {
      character = query[indexInQuery++];
      lowerCaseIndex = string.indexOf(character.toLowerCase());
      upperCaseIndex = string.indexOf(character.toUpperCase());
      minIndex = Math.min(lowerCaseIndex, upperCaseIndex);
      if (minIndex === -1) {
        minIndex = Math.max(lowerCaseIndex, upperCaseIndex);
      }
      indexInString = minIndex;
      if (indexInString === -1) {
        return 0;
      }
      characterScore = 0.1;
      if (string[indexInString] === character) {
        characterScore += 0.1;
      }
      if (indexInString === 0 || string[indexInString - 1] === PathSeparator) {
        characterScore += 0.8;
      } else if ((_ref = string[indexInString - 1]) === '-' || _ref === '_' || _ref === ' ') {
        characterScore += 0.7;
      }
      string = string.substring(indexInString + 1, stringLength);
      totalCharacterScore += characterScore;
    }
    queryScore = totalCharacterScore / queryLength;
    return ((queryScore * (queryLength / stringLength)) + queryScore) / 2;
  };

  queryIsLastPathSegment = function(string, query) {
    if (string[string.length - query.length - 1] === PathSeparator) {
      return string.lastIndexOf(query) === string.length - query.length;
    }
  };

  exports.match = function(string, query, stringOffset) {
    var character, indexInQuery, indexInString, lowerCaseIndex, matches, minIndex, queryLength, stringLength, upperCaseIndex, _i, _ref, _results;
    if (stringOffset == null) {
      stringOffset = 0;
    }
    if (string === query) {
      return (function() {
        _results = [];
        for (var _i = stringOffset, _ref = stringOffset + string.length; stringOffset <= _ref ? _i < _ref : _i > _ref; stringOffset <= _ref ? _i++ : _i--){ _results.push(_i); }
        return _results;
      }).apply(this);
    }
    queryLength = query.length;
    stringLength = string.length;
    indexInQuery = 0;
    indexInString = 0;
    matches = [];
    while (indexInQuery < queryLength) {
      character = query[indexInQuery++];
      lowerCaseIndex = string.indexOf(character.toLowerCase());
      upperCaseIndex = string.indexOf(character.toUpperCase());
      minIndex = Math.min(lowerCaseIndex, upperCaseIndex);
      if (minIndex === -1) {
        minIndex = Math.max(lowerCaseIndex, upperCaseIndex);
      }
      indexInString = minIndex;
      if (indexInString === -1) {
        return [];
      }
      matches.push(stringOffset + indexInString);
      stringOffset += indexInString + 1;
      string = string.substring(indexInString + 1, stringLength);
    }
    return matches;
  };

}).call(this);

},{"path":7}],5:[function(require,module,exports){
(function() {
  var PathSeparator, scorer;

  PathSeparator = require('path').sep;

  scorer = require('./scorer');

  exports.basenameMatch = function(subject, subject_lw, prepQuery) {
    var basePos, depth, end;
    end = subject.length - 1;
    while (subject[end] === PathSeparator) {
      end--;
    }
    basePos = subject.lastIndexOf(PathSeparator, end);
    if (basePos === -1) {
      return [];
    }
    depth = prepQuery.depth;
    while (depth-- > 0) {
      basePos = subject.lastIndexOf(PathSeparator, basePos - 1);
      if (basePos === -1) {
        return [];
      }
    }
    basePos++;
    end++;
    return exports.match(subject.slice(basePos, end), subject_lw.slice(basePos, end), prepQuery, basePos);
  };

  exports.mergeMatches = function(a, b) {
    var ai, bj, i, j, m, n, out;
    m = a.length;
    n = b.length;
    if (n === 0) {
      return a.slice();
    }
    if (m === 0) {
      return b.slice();
    }
    i = -1;
    j = 0;
    bj = b[j];
    out = [];
    while (++i < m) {
      ai = a[i];
      while (bj <= ai && ++j < n) {
        if (bj < ai) {
          out.push(bj);
        }
        bj = b[j];
      }
      out.push(ai);
    }
    while (j < n) {
      out.push(b[j++]);
    }
    return out;
  };

  exports.match = function(subject, subject_lw, prepQuery, offset) {
    var DIAGONAL, LEFT, STOP, UP, acro_score, align, backtrack, csc_diag, csc_row, csc_score, i, j, m, matches, move, n, pos, query, query_lw, score, score_diag, score_row, score_up, si_lw, start, trace;
    if (offset == null) {
      offset = 0;
    }
    query = prepQuery.query;
    query_lw = prepQuery.query_lw;
    m = subject.length;
    n = query.length;
    acro_score = scorer.scoreAcronyms(subject, subject_lw, query, query_lw).score;
    score_row = new Array(n);
    csc_row = new Array(n);
    STOP = 0;
    UP = 1;
    LEFT = 2;
    DIAGONAL = 3;
    trace = new Array(m * n);
    pos = -1;
    j = -1;
    while (++j < n) {
      score_row[j] = 0;
      csc_row[j] = 0;
    }
    i = -1;
    while (++i < m) {
      score = 0;
      score_up = 0;
      csc_diag = 0;
      si_lw = subject_lw[i];
      j = -1;
      while (++j < n) {
        csc_score = 0;
        align = 0;
        score_diag = score_up;
        if (query_lw[j] === si_lw) {
          start = scorer.isWordStart(i, subject, subject_lw);
          csc_score = csc_diag > 0 ? csc_diag : scorer.scoreConsecutives(subject, subject_lw, query, query_lw, i, j, start);
          align = score_diag + scorer.scoreCharacter(i, j, start, acro_score, csc_score);
        }
        score_up = score_row[j];
        csc_diag = csc_row[j];
        if (score > score_up) {
          move = LEFT;
        } else {
          score = score_up;
          move = UP;
        }
        if (align > score) {
          score = align;
          move = DIAGONAL;
        } else {
          csc_score = 0;
        }
        score_row[j] = score;
        csc_row[j] = csc_score;
        trace[++pos] = score > 0 ? move : STOP;
      }
    }
    i = m - 1;
    j = n - 1;
    pos = i * n + j;
    backtrack = true;
    matches = [];
    while (backtrack && i >= 0 && j >= 0) {
      switch (trace[pos]) {
        case UP:
          i--;
          pos -= n;
          break;
        case LEFT:
          j--;
          pos--;
          break;
        case DIAGONAL:
          matches.push(i + offset);
          j--;
          i--;
          pos -= n + 1;
          break;
        default:
          backtrack = false;
      }
    }
    matches.reverse();
    return matches;
  };

}).call(this);

},{"./scorer":6,"path":7}],6:[function(require,module,exports){
(function() {
  var AcronymResult, PathSeparator, Query, basenameScore, coreChars, countDir, doScore, emptyAcronymResult, file_coeff, isMatch, isSeparator, isWordEnd, isWordStart, miss_coeff, opt_char_re, pos_bonus, scoreAcronyms, scoreCharacter, scoreConsecutives, scoreExact, scoreExactMatch, scorePattern, scorePosition, scoreSize, tau_depth, tau_size, truncatedUpperCase, wm;

  PathSeparator = require('path').sep;

  wm = 150;

  pos_bonus = 20;

  tau_depth = 13;

  tau_size = 85;

  file_coeff = 1.2;

  miss_coeff = 0.75;

  opt_char_re = /[ _\-:\/\\]/g;

  exports.coreChars = coreChars = function(query) {
    return query.replace(opt_char_re, '');
  };

  exports.score = function(string, query, prepQuery, allowErrors) {
    var score, string_lw;
    if (prepQuery == null) {
      prepQuery = new Query(query);
    }
    if (allowErrors == null) {
      allowErrors = false;
    }
    if (!(allowErrors || isMatch(string, prepQuery.core_lw, prepQuery.core_up))) {
      return 0;
    }
    string_lw = string.toLowerCase();
    score = doScore(string, string_lw, prepQuery);
    return Math.ceil(basenameScore(string, string_lw, prepQuery, score));
  };

  Query = (function() {
    function Query(query) {
      if (!(query != null ? query.length : void 0)) {
        return null;
      }
      this.query = query;
      this.query_lw = query.toLowerCase();
      this.core = coreChars(query);
      this.core_lw = this.core.toLowerCase();
      this.core_up = truncatedUpperCase(this.core);
      this.depth = countDir(query, query.length);
    }

    return Query;

  })();

  exports.prepQuery = function(query) {
    return new Query(query);
  };

  exports.isMatch = isMatch = function(subject, query_lw, query_up) {
    var i, j, m, n, qj_lw, qj_up, si;
    m = subject.length;
    n = query_lw.length;
    if (!m || n > m) {
      return false;
    }
    i = -1;
    j = -1;
    while (++j < n) {
      qj_lw = query_lw[j];
      qj_up = query_up[j];
      while (++i < m) {
        si = subject[i];
        if (si === qj_lw || si === qj_up) {
          break;
        }
      }
      if (i === m) {
        return false;
      }
    }
    return true;
  };

  doScore = function(subject, subject_lw, prepQuery) {
    var acro, acro_score, align, csc_diag, csc_row, csc_score, i, j, m, miss_budget, miss_left, mm, n, pos, query, query_lw, record_miss, score, score_diag, score_row, score_up, si_lw, start, sz;
    query = prepQuery.query;
    query_lw = prepQuery.query_lw;
    m = subject.length;
    n = query.length;
    acro = scoreAcronyms(subject, subject_lw, query, query_lw);
    acro_score = acro.score;
    if (acro.count === n) {
      return scoreExact(n, m, acro_score, acro.pos);
    }
    pos = subject_lw.indexOf(query_lw);
    if (pos > -1) {
      return scoreExactMatch(subject, subject_lw, query, query_lw, pos, n, m);
    }
    score_row = new Array(n);
    csc_row = new Array(n);
    sz = scoreSize(n, m);
    miss_budget = Math.ceil(miss_coeff * n) + 5;
    miss_left = miss_budget;
    j = -1;
    while (++j < n) {
      score_row[j] = 0;
      csc_row[j] = 0;
    }
    i = subject_lw.indexOf(query_lw[0]);
    if (i > -1) {
      i--;
    }
    mm = subject_lw.lastIndexOf(query_lw[n - 1], m);
    if (mm > i) {
      m = mm + 1;
    }
    while (++i < m) {
      score = 0;
      score_diag = 0;
      csc_diag = 0;
      si_lw = subject_lw[i];
      record_miss = true;
      j = -1;
      while (++j < n) {
        score_up = score_row[j];
        if (score_up > score) {
          score = score_up;
        }
        csc_score = 0;
        if (query_lw[j] === si_lw) {
          start = isWordStart(i, subject, subject_lw);
          csc_score = csc_diag > 0 ? csc_diag : scoreConsecutives(subject, subject_lw, query, query_lw, i, j, start);
          align = score_diag + scoreCharacter(i, j, start, acro_score, csc_score);
          if (align > score) {
            score = align;
            miss_left = miss_budget;
          } else {
            if (record_miss && --miss_left <= 0) {
              return score_row[n - 1] * sz;
            }
            record_miss = false;
          }
        }
        score_diag = score_up;
        csc_diag = csc_row[j];
        csc_row[j] = csc_score;
        score_row[j] = score;
      }
    }
    return score * sz;
  };

  exports.isWordStart = isWordStart = function(pos, subject, subject_lw) {
    var curr_s, prev_s;
    if (pos === 0) {
      return true;
    }
    curr_s = subject[pos];
    prev_s = subject[pos - 1];
    return isSeparator(curr_s) || isSeparator(prev_s) || (curr_s !== subject_lw[pos] && prev_s === subject_lw[pos - 1]);
  };

  exports.isWordEnd = isWordEnd = function(pos, subject, subject_lw, len) {
    var curr_s, next_s;
    if (pos === len - 1) {
      return true;
    }
    curr_s = subject[pos];
    next_s = subject[pos + 1];
    return isSeparator(curr_s) || isSeparator(next_s) || (curr_s === subject_lw[pos] && next_s !== subject_lw[pos + 1]);
  };

  isSeparator = function(c) {
    return c === ' ' || c === '.' || c === '-' || c === '_' || c === '/' || c === '\\';
  };

  scorePosition = function(pos) {
    var sc;
    if (pos < pos_bonus) {
      sc = pos_bonus - pos;
      return 100 + sc * sc;
    } else {
      return Math.max(100 + pos_bonus - pos, 0);
    }
  };

  scoreSize = function(n, m) {
    return tau_size / (tau_size + Math.abs(m - n));
  };

  scoreExact = function(n, m, quality, pos) {
    return 2 * n * (wm * quality + scorePosition(pos)) * scoreSize(n, m);
  };

  exports.scorePattern = scorePattern = function(count, len, sameCase, start, end) {
    var bonus, sz;
    sz = count;
    bonus = 6;
    if (sameCase === count) {
      bonus += 2;
    }
    if (start) {
      bonus += 3;
    }
    if (end) {
      bonus += 1;
    }
    if (count === len) {
      if (start) {
        if (sameCase === len) {
          sz += 2;
        } else {
          sz += 1;
        }
      }
      if (end) {
        bonus += 1;
      }
    }
    return sameCase + sz * (sz + bonus);
  };

  exports.scoreCharacter = scoreCharacter = function(i, j, start, acro_score, csc_score) {
    var posBonus;
    posBonus = scorePosition(i);
    if (start) {
      return posBonus + wm * ((acro_score > csc_score ? acro_score : csc_score) + 10);
    }
    return posBonus + wm * csc_score;
  };

  exports.scoreConsecutives = scoreConsecutives = function(subject, subject_lw, query, query_lw, i, j, start) {
    var k, m, mi, n, nj, sameCase, startPos, sz;
    m = subject.length;
    n = query.length;
    mi = m - i;
    nj = n - j;
    k = mi < nj ? mi : nj;
    startPos = i;
    sameCase = 0;
    sz = 0;
    if (query[j] === subject[i]) {
      sameCase++;
    }
    while (++sz < k && query_lw[++j] === subject_lw[++i]) {
      if (query[j] === subject[i]) {
        sameCase++;
      }
    }
    if (sz === 1) {
      return 1 + 2 * sameCase;
    }
    return scorePattern(sz, n, sameCase, start, isWordEnd(i, subject, subject_lw, m));
  };

  exports.scoreExactMatch = scoreExactMatch = function(subject, subject_lw, query, query_lw, pos, n, m) {
    var end, i, pos2, sameCase, start;
    start = isWordStart(pos, subject, subject_lw);
    if (!start) {
      pos2 = subject_lw.indexOf(query_lw, pos + 1);
      if (pos2 > -1) {
        start = isWordStart(pos2, subject, subject_lw);
        if (start) {
          pos = pos2;
        }
      }
    }
    i = -1;
    sameCase = 0;
    while (++i < n) {
      if (query[pos + i] === subject[i]) {
        sameCase++;
      }
    }
    end = isWordEnd(pos + n - 1, subject, subject_lw, m);
    return scoreExact(n, m, scorePattern(n, n, sameCase, start, end), pos);
  };

  AcronymResult = (function() {
    function AcronymResult(score, pos, count) {
      this.score = score;
      this.pos = pos;
      this.count = count;
    }

    return AcronymResult;

  })();

  emptyAcronymResult = new AcronymResult(0, 0.1, 0);

  exports.scoreAcronyms = scoreAcronyms = function(subject, subject_lw, query, query_lw) {
    var count, i, j, m, n, pos, qj_lw, sameCase, score;
    m = subject.length;
    n = query.length;
    if (!(m > 1 && n > 1)) {
      return emptyAcronymResult;
    }
    count = 0;
    pos = 0;
    sameCase = 0;
    i = -1;
    j = -1;
    while (++j < n) {
      qj_lw = query_lw[j];
      while (++i < m) {
        if (qj_lw === subject_lw[i] && isWordStart(i, subject, subject_lw)) {
          if (query[j] === subject[i]) {
            sameCase++;
          }
          pos += i;
          count++;
          break;
        }
      }
      if (i === m) {
        break;
      }
    }
    if (count < 2) {
      return emptyAcronymResult;
    }
    score = scorePattern(count, n, sameCase, true, false);
    return new AcronymResult(score, pos / count, count);
  };

  basenameScore = function(subject, subject_lw, prepQuery, fullPathScore) {
    var alpha, basePathScore, basePos, depth, end;
    if (fullPathScore === 0) {
      return 0;
    }
    end = subject.length - 1;
    while (subject[end] === PathSeparator) {
      end--;
    }
    basePos = subject.lastIndexOf(PathSeparator, end);
    if (basePos === -1) {
      return fullPathScore;
    }
    depth = prepQuery.depth;
    while (depth-- > 0) {
      basePos = subject.lastIndexOf(PathSeparator, basePos - 1);
      if (basePos === -1) {
        return fullPathScore;
      }
    }
    basePos++;
    end++;
    basePathScore = doScore(subject.slice(basePos, end), subject_lw.slice(basePos, end), prepQuery);
    alpha = 0.5 * tau_depth / (tau_depth + countDir(subject, end + 1));
    return alpha * basePathScore + (1 - alpha) * fullPathScore * scoreSize(0, file_coeff * (end - basePos));
  };

  exports.countDir = countDir = function(path, end) {
    var count, i;
    if (end < 1) {
      return 0;
    }
    count = 0;
    i = -1;
    while (++i < end && path[i] === PathSeparator) {
      continue;
    }
    while (++i < end) {
      if (path[i] === PathSeparator) {
        count++;
        while (++i < end && path[i] === PathSeparator) {
          continue;
        }
      }
    }
    return count;
  };

  truncatedUpperCase = function(str) {
    var char, upper, _i, _len;
    upper = "";
    for (_i = 0, _len = str.length; _i < _len; _i++) {
      char = str[_i];
      upper += char.toUpperCase()[0];
    }
    return upper;
  };

}).call(this);

},{"path":7}],7:[function(require,module,exports){
(function (process){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
var splitPathRe =
    /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
var splitPath = function(filename) {
  return splitPathRe.exec(filename).slice(1);
};

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function(path) {
  var result = splitPath(path),
      root = result[0],
      dir = result[1];

  if (!root && !dir) {
    // No dirname whatsoever
    return '.';
  }

  if (dir) {
    // It has a dirname, strip trailing slash
    dir = dir.substr(0, dir.length - 1);
  }

  return root + dir;
};


exports.basename = function(path, ext) {
  var f = splitPath(path)[2];
  // TODO: make this comparison case-insensitive on windows?
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};


exports.extname = function(path) {
  return splitPath(path)[3];
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

}).call(this,require('_process'))
},{"_process":8}],8:[function(require,module,exports){
// shim for using process in browser

var process = module.exports = {};
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = setTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    clearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        setTimeout(drainQueue, 0);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}]},{},[1]);


/***/ }),

/***/ "jgNA":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MAX_MESSAGE_LENGTH = 500;
var MESSAGE_CELL_SELECTOR = '.abuse-reports .message';

var AbuseReports = function () {
  function AbuseReports() {
    _classCallCheck(this, AbuseReports);

    $(MESSAGE_CELL_SELECTOR).each(this.truncateLongMessage);
    $(document).off('click', MESSAGE_CELL_SELECTOR).on('click', MESSAGE_CELL_SELECTOR, this.toggleMessageTruncation);
  }

  _createClass(AbuseReports, [{
    key: 'truncateLongMessage',
    value: function truncateLongMessage() {
      var $messageCellElement = $(this);
      var reportMessage = $messageCellElement.text();
      if (reportMessage.length > MAX_MESSAGE_LENGTH) {
        $messageCellElement.data('original-message', reportMessage);
        $messageCellElement.data('message-truncated', 'true');
        $messageCellElement.text(window.gl.text.truncate(reportMessage, MAX_MESSAGE_LENGTH));
      }
    }
  }, {
    key: 'toggleMessageTruncation',
    value: function toggleMessageTruncation() {
      var $messageCellElement = $(this);
      var originalMessage = $messageCellElement.data('original-message');
      if (!originalMessage) return;
      if ($messageCellElement.data('message-truncated') === 'true') {
        $messageCellElement.data('message-truncated', 'false');
        $messageCellElement.text(originalMessage);
      } else {
        $messageCellElement.data('message-truncated', 'true');
        $messageCellElement.text(originalMessage.substr(0, MAX_MESSAGE_LENGTH - 3) + '...');
      }
    }
  }]);

  return AbuseReports;
}();

window.gl = window.gl || {};
window.gl.AbuseReports = AbuseReports;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "kdHk":
/***/ (function(module, exports) {

/* eslint-disable func-names, space-before-function-paren, wrap-iife, prefer-arrow-callback, max-len */

(function () {
  this.ProjectImport = function () {
    function ProjectImport() {
      setTimeout(function () {
        return gl.utils.visitUrl(location.href);
      }, 5000);
    }

    return ProjectImport;
  }();
}).call(window);

/***/ }),

/***/ "ksyN":
/***/ (function(module, exports, __webpack_require__) {

/*!
 * Pikaday
 *
 * Copyright © 2014 David Bushell | BSD & MIT license | https://github.com/dbushell/Pikaday
 */

(function (root, factory)
{
    'use strict';

    var moment;
    if (true) {
        // CommonJS module
        // Load moment.js as an optional dependency
        try { moment = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"moment\""); e.code = 'MODULE_NOT_FOUND'; throw e; }())); } catch (e) {}
        module.exports = factory(moment);
    } else if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(function (req)
        {
            // Load moment.js as an optional dependency
            var id = 'moment';
            try { moment = req(id); } catch (e) {}
            return factory(moment);
        });
    } else {
        root.Pikaday = factory(root.moment);
    }
}(this, function (moment)
{
    'use strict';

    /**
     * feature detection and helper functions
     */
    var hasMoment = typeof moment === 'function',

    hasEventListeners = !!window.addEventListener,

    document = window.document,

    sto = window.setTimeout,

    addEvent = function(el, e, callback, capture)
    {
        if (hasEventListeners) {
            el.addEventListener(e, callback, !!capture);
        } else {
            el.attachEvent('on' + e, callback);
        }
    },

    removeEvent = function(el, e, callback, capture)
    {
        if (hasEventListeners) {
            el.removeEventListener(e, callback, !!capture);
        } else {
            el.detachEvent('on' + e, callback);
        }
    },

    fireEvent = function(el, eventName, data)
    {
        var ev;

        if (document.createEvent) {
            ev = document.createEvent('HTMLEvents');
            ev.initEvent(eventName, true, false);
            ev = extend(ev, data);
            el.dispatchEvent(ev);
        } else if (document.createEventObject) {
            ev = document.createEventObject();
            ev = extend(ev, data);
            el.fireEvent('on' + eventName, ev);
        }
    },

    trim = function(str)
    {
        return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g,'');
    },

    hasClass = function(el, cn)
    {
        return (' ' + el.className + ' ').indexOf(' ' + cn + ' ') !== -1;
    },

    addClass = function(el, cn)
    {
        if (!hasClass(el, cn)) {
            el.className = (el.className === '') ? cn : el.className + ' ' + cn;
        }
    },

    removeClass = function(el, cn)
    {
        el.className = trim((' ' + el.className + ' ').replace(' ' + cn + ' ', ' '));
    },

    isArray = function(obj)
    {
        return (/Array/).test(Object.prototype.toString.call(obj));
    },

    isDate = function(obj)
    {
        return (/Date/).test(Object.prototype.toString.call(obj)) && !isNaN(obj.getTime());
    },

    isWeekend = function(date)
    {
        var day = date.getDay();
        return day === 0 || day === 6;
    },

    isLeapYear = function(year)
    {
        // solution by Matti Virkkunen: http://stackoverflow.com/a/4881951
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    },

    getDaysInMonth = function(year, month)
    {
        return [31, isLeapYear(year) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
    },

    setToStartOfDay = function(date)
    {
        if (isDate(date)) date.setHours(0,0,0,0);
    },

    compareDates = function(a,b)
    {
        // weak date comparison (use setToStartOfDay(date) to ensure correct result)
        return a.getTime() === b.getTime();
    },

    extend = function(to, from, overwrite)
    {
        var prop, hasProp;
        for (prop in from) {
            hasProp = to[prop] !== undefined;
            if (hasProp && typeof from[prop] === 'object' && from[prop] !== null && from[prop].nodeName === undefined) {
                if (isDate(from[prop])) {
                    if (overwrite) {
                        to[prop] = new Date(from[prop].getTime());
                    }
                }
                else if (isArray(from[prop])) {
                    if (overwrite) {
                        to[prop] = from[prop].slice(0);
                    }
                } else {
                    to[prop] = extend({}, from[prop], overwrite);
                }
            } else if (overwrite || !hasProp) {
                to[prop] = from[prop];
            }
        }
        return to;
    },

    adjustCalendar = function(calendar) {
        if (calendar.month < 0) {
            calendar.year -= Math.ceil(Math.abs(calendar.month)/12);
            calendar.month += 12;
        }
        if (calendar.month > 11) {
            calendar.year += Math.floor(Math.abs(calendar.month)/12);
            calendar.month -= 12;
        }
        return calendar;
    },

    /**
     * defaults and localisation
     */
    defaults = {

        // bind the picker to a form field
        field: null,

        // automatically show/hide the picker on `field` focus (default `true` if `field` is set)
        bound: undefined,

        // position of the datepicker, relative to the field (default to bottom & left)
        // ('bottom' & 'left' keywords are not used, 'top' & 'right' are modifier on the bottom/left position)
        position: 'bottom left',

        // automatically fit in the viewport even if it means repositioning from the position option
        reposition: true,

        // the default output format for `.toString()` and `field` value
        format: 'YYYY-MM-DD',

        // the initial date to view when first opened
        defaultDate: null,

        // make the `defaultDate` the initial selected value
        setDefaultDate: false,

        // first day of week (0: Sunday, 1: Monday etc)
        firstDay: 0,

        // the default flag for moment's strict date parsing
        formatStrict: false,

        // the minimum/earliest date that can be selected
        minDate: null,
        // the maximum/latest date that can be selected
        maxDate: null,

        // number of years either side, or array of upper/lower range
        yearRange: 10,

        // show week numbers at head of row
        showWeekNumber: false,

        // used internally (don't config outside)
        minYear: 0,
        maxYear: 9999,
        minMonth: undefined,
        maxMonth: undefined,

        startRange: null,
        endRange: null,

        isRTL: false,

        // Additional text to append to the year in the calendar title
        yearSuffix: '',

        // Render the month after year in the calendar title
        showMonthAfterYear: false,

        // Render days of the calendar grid that fall in the next or previous month
        showDaysInNextAndPreviousMonths: false,

        // how many months are visible
        numberOfMonths: 1,

        // when numberOfMonths is used, this will help you to choose where the main calendar will be (default `left`, can be set to `right`)
        // only used for the first display or when a selected date is not visible
        mainCalendar: 'left',

        // Specify a DOM element to render the calendar in
        container: undefined,

        // internationalization
        i18n: {
            previousMonth : 'Previous Month',
            nextMonth     : 'Next Month',
            months        : ['January','February','March','April','May','June','July','August','September','October','November','December'],
            weekdays      : ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],
            weekdaysShort : ['Sun','Mon','Tue','Wed','Thu','Fri','Sat']
        },

        // Theme Classname
        theme: null,

        // callback function
        onSelect: null,
        onOpen: null,
        onClose: null,
        onDraw: null
    },


    /**
     * templating functions to abstract HTML rendering
     */
    renderDayName = function(opts, day, abbr)
    {
        day += opts.firstDay;
        while (day >= 7) {
            day -= 7;
        }
        return abbr ? opts.i18n.weekdaysShort[day] : opts.i18n.weekdays[day];
    },

    renderDay = function(opts)
    {
        var arr = [];
        var ariaSelected = 'false';
        if (opts.isEmpty) {
            if (opts.showDaysInNextAndPreviousMonths) {
                arr.push('is-outside-current-month');
            } else {
                return '<td class="is-empty"></td>';
            }
        }
        if (opts.isDisabled) {
            arr.push('is-disabled');
        }
        if (opts.isToday) {
            arr.push('is-today');
        }
        if (opts.isSelected) {
            arr.push('is-selected');
            ariaSelected = 'true';
        }
        if (opts.isInRange) {
            arr.push('is-inrange');
        }
        if (opts.isStartRange) {
            arr.push('is-startrange');
        }
        if (opts.isEndRange) {
            arr.push('is-endrange');
        }
        return '<td data-day="' + opts.day + '" class="' + arr.join(' ') + '" aria-selected="' + ariaSelected + '">' +
                 '<button class="pika-button pika-day" type="button" ' +
                    'data-pika-year="' + opts.year + '" data-pika-month="' + opts.month + '" data-pika-day="' + opts.day + '">' +
                        opts.day +
                 '</button>' +
               '</td>';
    },

    renderWeek = function (d, m, y) {
        // Lifted from http://javascript.about.com/library/blweekyear.htm, lightly modified.
        var onejan = new Date(y, 0, 1),
            weekNum = Math.ceil((((new Date(y, m, d) - onejan) / 86400000) + onejan.getDay()+1)/7);
        return '<td class="pika-week">' + weekNum + '</td>';
    },

    renderRow = function(days, isRTL)
    {
        return '<tr>' + (isRTL ? days.reverse() : days).join('') + '</tr>';
    },

    renderBody = function(rows)
    {
        return '<tbody>' + rows.join('') + '</tbody>';
    },

    renderHead = function(opts)
    {
        var i, arr = [];
        if (opts.showWeekNumber) {
            arr.push('<th></th>');
        }
        for (i = 0; i < 7; i++) {
            arr.push('<th scope="col"><abbr title="' + renderDayName(opts, i) + '">' + renderDayName(opts, i, true) + '</abbr></th>');
        }
        return '<thead><tr>' + (opts.isRTL ? arr.reverse() : arr).join('') + '</tr></thead>';
    },

    renderTitle = function(instance, c, year, month, refYear, randId)
    {
        var i, j, arr,
            opts = instance._o,
            isMinYear = year === opts.minYear,
            isMaxYear = year === opts.maxYear,
            html = '<div id="' + randId + '" class="pika-title" role="heading" aria-live="assertive">',
            monthHtml,
            yearHtml,
            prev = true,
            next = true;

        for (arr = [], i = 0; i < 12; i++) {
            arr.push('<option value="' + (year === refYear ? i - c : 12 + i - c) + '"' +
                (i === month ? ' selected="selected"': '') +
                ((isMinYear && i < opts.minMonth) || (isMaxYear && i > opts.maxMonth) ? 'disabled="disabled"' : '') + '>' +
                opts.i18n.months[i] + '</option>');
        }

        monthHtml = '<div class="pika-label">' + opts.i18n.months[month] + '<select class="pika-select pika-select-month" tabindex="-1">' + arr.join('') + '</select></div>';

        if (isArray(opts.yearRange)) {
            i = opts.yearRange[0];
            j = opts.yearRange[1] + 1;
        } else {
            i = year - opts.yearRange;
            j = 1 + year + opts.yearRange;
        }

        for (arr = []; i < j && i <= opts.maxYear; i++) {
            if (i >= opts.minYear) {
                arr.push('<option value="' + i + '"' + (i === year ? ' selected="selected"': '') + '>' + (i) + '</option>');
            }
        }
        yearHtml = '<div class="pika-label">' + year + opts.yearSuffix + '<select class="pika-select pika-select-year" tabindex="-1">' + arr.join('') + '</select></div>';

        if (opts.showMonthAfterYear) {
            html += yearHtml + monthHtml;
        } else {
            html += monthHtml + yearHtml;
        }

        if (isMinYear && (month === 0 || opts.minMonth >= month)) {
            prev = false;
        }

        if (isMaxYear && (month === 11 || opts.maxMonth <= month)) {
            next = false;
        }

        if (c === 0) {
            html += '<button class="pika-prev' + (prev ? '' : ' is-disabled') + '" type="button">' + opts.i18n.previousMonth + '</button>';
        }
        if (c === (instance._o.numberOfMonths - 1) ) {
            html += '<button class="pika-next' + (next ? '' : ' is-disabled') + '" type="button">' + opts.i18n.nextMonth + '</button>';
        }

        return html += '</div>';
    },

    renderTable = function(opts, data, randId)
    {
        return '<table cellpadding="0" cellspacing="0" class="pika-table" role="grid" aria-labelledby="' + randId + '">' + renderHead(opts) + renderBody(data) + '</table>';
    },


    /**
     * Pikaday constructor
     */
    Pikaday = function(options)
    {
        var self = this,
            opts = self.config(options);

        self._onMouseDown = function(e)
        {
            if (!self._v) {
                return;
            }
            e = e || window.event;
            var target = e.target || e.srcElement;
            if (!target) {
                return;
            }

            if (!hasClass(target, 'is-disabled')) {
                if (hasClass(target, 'pika-button') && !hasClass(target, 'is-empty') && !hasClass(target.parentNode, 'is-disabled')) {
                    self.setDate(new Date(target.getAttribute('data-pika-year'), target.getAttribute('data-pika-month'), target.getAttribute('data-pika-day')));
                    if (opts.bound) {
                        sto(function() {
                            self.hide();
                            if (opts.field) {
                                opts.field.blur();
                            }
                        }, 100);
                    }
                }
                else if (hasClass(target, 'pika-prev')) {
                    self.prevMonth();
                }
                else if (hasClass(target, 'pika-next')) {
                    self.nextMonth();
                }
            }
            if (!hasClass(target, 'pika-select')) {
                // if this is touch event prevent mouse events emulation
                if (e.preventDefault) {
                    e.preventDefault();
                } else {
                    e.returnValue = false;
                    return false;
                }
            } else {
                self._c = true;
            }
        };

        self._onChange = function(e)
        {
            e = e || window.event;
            var target = e.target || e.srcElement;
            if (!target) {
                return;
            }
            if (hasClass(target, 'pika-select-month')) {
                self.gotoMonth(target.value);
            }
            else if (hasClass(target, 'pika-select-year')) {
                self.gotoYear(target.value);
            }
        };

        self._onKeyChange = function(e)
        {
            e = e || window.event;

            if (self.isVisible()) {

                switch(e.keyCode){
                    case 13:
                    case 27:
                        opts.field.blur();
                        break;
                    case 37:
                        e.preventDefault();
                        self.adjustDate('subtract', 1);
                        break;
                    case 38:
                        self.adjustDate('subtract', 7);
                        break;
                    case 39:
                        self.adjustDate('add', 1);
                        break;
                    case 40:
                        self.adjustDate('add', 7);
                        break;
                }
            }
        };

        self._onInputChange = function(e)
        {
            var date;

            if (e.firedBy === self) {
                return;
            }
            if (hasMoment) {
                date = moment(opts.field.value, opts.format, opts.formatStrict);
                date = (date && date.isValid()) ? date.toDate() : null;
            }
            else {
                date = new Date(Date.parse(opts.field.value));
            }
            if (isDate(date)) {
              self.setDate(date);
            }
            if (!self._v) {
                self.show();
            }
        };

        self._onInputFocus = function()
        {
            self.show();
        };

        self._onInputClick = function()
        {
            self.show();
        };

        self._onInputBlur = function()
        {
            // IE allows pika div to gain focus; catch blur the input field
            var pEl = document.activeElement;
            do {
                if (hasClass(pEl, 'pika-single')) {
                    return;
                }
            }
            while ((pEl = pEl.parentNode));

            if (!self._c) {
                self._b = sto(function() {
                    self.hide();
                }, 50);
            }
            self._c = false;
        };

        self._onClick = function(e)
        {
            e = e || window.event;
            var target = e.target || e.srcElement,
                pEl = target;
            if (!target) {
                return;
            }
            if (!hasEventListeners && hasClass(target, 'pika-select')) {
                if (!target.onchange) {
                    target.setAttribute('onchange', 'return;');
                    addEvent(target, 'change', self._onChange);
                }
            }
            do {
                if (hasClass(pEl, 'pika-single') || pEl === opts.trigger) {
                    return;
                }
            }
            while ((pEl = pEl.parentNode));
            if (self._v && target !== opts.trigger && pEl !== opts.trigger) {
                self.hide();
            }
        };

        self.el = document.createElement('div');
        self.el.className = 'pika-single' + (opts.isRTL ? ' is-rtl' : '') + (opts.theme ? ' ' + opts.theme : '');

        addEvent(self.el, 'mousedown', self._onMouseDown, true);
        addEvent(self.el, 'touchend', self._onMouseDown, true);
        addEvent(self.el, 'change', self._onChange);
        addEvent(document, 'keydown', self._onKeyChange);

        if (opts.field) {
            if (opts.container) {
                opts.container.appendChild(self.el);
            } else if (opts.bound) {
                document.body.appendChild(self.el);
            } else {
                opts.field.parentNode.insertBefore(self.el, opts.field.nextSibling);
            }
            addEvent(opts.field, 'change', self._onInputChange);

            if (!opts.defaultDate) {
                if (hasMoment && opts.field.value) {
                    opts.defaultDate = moment(opts.field.value, opts.format).toDate();
                } else {
                    opts.defaultDate = new Date(Date.parse(opts.field.value));
                }
                opts.setDefaultDate = true;
            }
        }

        var defDate = opts.defaultDate;

        if (isDate(defDate)) {
            if (opts.setDefaultDate) {
                self.setDate(defDate, true);
            } else {
                self.gotoDate(defDate);
            }
        } else {
            self.gotoDate(new Date());
        }

        if (opts.bound) {
            this.hide();
            self.el.className += ' is-bound';
            addEvent(opts.trigger, 'click', self._onInputClick);
            addEvent(opts.trigger, 'focus', self._onInputFocus);
            addEvent(opts.trigger, 'blur', self._onInputBlur);
        } else {
            this.show();
        }
    };


    /**
     * public Pikaday API
     */
    Pikaday.prototype = {


        /**
         * configure functionality
         */
        config: function(options)
        {
            if (!this._o) {
                this._o = extend({}, defaults, true);
            }

            var opts = extend(this._o, options, true);

            opts.isRTL = !!opts.isRTL;

            opts.field = (opts.field && opts.field.nodeName) ? opts.field : null;

            opts.theme = (typeof opts.theme) === 'string' && opts.theme ? opts.theme : null;

            opts.bound = !!(opts.bound !== undefined ? opts.field && opts.bound : opts.field);

            opts.trigger = (opts.trigger && opts.trigger.nodeName) ? opts.trigger : opts.field;

            opts.disableWeekends = !!opts.disableWeekends;

            opts.disableDayFn = (typeof opts.disableDayFn) === 'function' ? opts.disableDayFn : null;

            var nom = parseInt(opts.numberOfMonths, 10) || 1;
            opts.numberOfMonths = nom > 4 ? 4 : nom;

            if (!isDate(opts.minDate)) {
                opts.minDate = false;
            }
            if (!isDate(opts.maxDate)) {
                opts.maxDate = false;
            }
            if ((opts.minDate && opts.maxDate) && opts.maxDate < opts.minDate) {
                opts.maxDate = opts.minDate = false;
            }
            if (opts.minDate) {
                this.setMinDate(opts.minDate);
            }
            if (opts.maxDate) {
                this.setMaxDate(opts.maxDate);
            }

            if (isArray(opts.yearRange)) {
                var fallback = new Date().getFullYear() - 10;
                opts.yearRange[0] = parseInt(opts.yearRange[0], 10) || fallback;
                opts.yearRange[1] = parseInt(opts.yearRange[1], 10) || fallback;
            } else {
                opts.yearRange = Math.abs(parseInt(opts.yearRange, 10)) || defaults.yearRange;
                if (opts.yearRange > 100) {
                    opts.yearRange = 100;
                }
            }

            return opts;
        },

        /**
         * return a formatted string of the current selection (using Moment.js if available)
         */
        toString: function(format)
        {
            return !isDate(this._d) ? '' : hasMoment ? moment(this._d).format(format || this._o.format) : this._d.toDateString();
        },

        /**
         * return a Moment.js object of the current selection (if available)
         */
        getMoment: function()
        {
            return hasMoment ? moment(this._d) : null;
        },

        /**
         * set the current selection from a Moment.js object (if available)
         */
        setMoment: function(date, preventOnSelect)
        {
            if (hasMoment && moment.isMoment(date)) {
                this.setDate(date.toDate(), preventOnSelect);
            }
        },

        /**
         * return a Date object of the current selection with fallback for the current date
         */
        getDate: function()
        {
            return isDate(this._d) ? new Date(this._d.getTime()) : new Date();
        },

        /**
         * set the current selection
         */
        setDate: function(date, preventOnSelect)
        {
            if (!date) {
                this._d = null;

                if (this._o.field) {
                    this._o.field.value = '';
                    fireEvent(this._o.field, 'change', { firedBy: this });
                }

                return this.draw();
            }
            if (typeof date === 'string') {
                date = new Date(Date.parse(date));
            }
            if (!isDate(date)) {
                return;
            }

            var min = this._o.minDate,
                max = this._o.maxDate;

            if (isDate(min) && date < min) {
                date = min;
            } else if (isDate(max) && date > max) {
                date = max;
            }

            this._d = new Date(date.getTime());
            setToStartOfDay(this._d);
            this.gotoDate(this._d);

            if (this._o.field) {
                this._o.field.value = this.toString();
                fireEvent(this._o.field, 'change', { firedBy: this });
            }
            if (!preventOnSelect && typeof this._o.onSelect === 'function') {
                this._o.onSelect.call(this, this.getDate());
            }
        },

        /**
         * change view to a specific date
         */
        gotoDate: function(date)
        {
            var newCalendar = true;

            if (!isDate(date)) {
                return;
            }

            if (this.calendars) {
                var firstVisibleDate = new Date(this.calendars[0].year, this.calendars[0].month, 1),
                    lastVisibleDate = new Date(this.calendars[this.calendars.length-1].year, this.calendars[this.calendars.length-1].month, 1),
                    visibleDate = date.getTime();
                // get the end of the month
                lastVisibleDate.setMonth(lastVisibleDate.getMonth()+1);
                lastVisibleDate.setDate(lastVisibleDate.getDate()-1);
                newCalendar = (visibleDate < firstVisibleDate.getTime() || lastVisibleDate.getTime() < visibleDate);
            }

            if (newCalendar) {
                this.calendars = [{
                    month: date.getMonth(),
                    year: date.getFullYear()
                }];
                if (this._o.mainCalendar === 'right') {
                    this.calendars[0].month += 1 - this._o.numberOfMonths;
                }
            }

            this.adjustCalendars();
        },

        adjustDate: function(sign, days) {

            var day = this.getDate();
            var difference = parseInt(days)*24*60*60*1000;

            var newDay;

            if (sign === 'add') {
                newDay = new Date(day.valueOf() + difference);
            } else if (sign === 'subtract') {
                newDay = new Date(day.valueOf() - difference);
            }

            if (hasMoment) {
                if (sign === 'add') {
                    newDay = moment(day).add(days, "days").toDate();
                } else if (sign === 'subtract') {
                    newDay = moment(day).subtract(days, "days").toDate();
                }
            }

            this.setDate(newDay);
        },

        adjustCalendars: function() {
            this.calendars[0] = adjustCalendar(this.calendars[0]);
            for (var c = 1; c < this._o.numberOfMonths; c++) {
                this.calendars[c] = adjustCalendar({
                    month: this.calendars[0].month + c,
                    year: this.calendars[0].year
                });
            }
            this.draw();
        },

        gotoToday: function()
        {
            this.gotoDate(new Date());
        },

        /**
         * change view to a specific month (zero-index, e.g. 0: January)
         */
        gotoMonth: function(month)
        {
            if (!isNaN(month)) {
                this.calendars[0].month = parseInt(month, 10);
                this.adjustCalendars();
            }
        },

        nextMonth: function()
        {
            this.calendars[0].month++;
            this.adjustCalendars();
        },

        prevMonth: function()
        {
            this.calendars[0].month--;
            this.adjustCalendars();
        },

        /**
         * change view to a specific full year (e.g. "2012")
         */
        gotoYear: function(year)
        {
            if (!isNaN(year)) {
                this.calendars[0].year = parseInt(year, 10);
                this.adjustCalendars();
            }
        },

        /**
         * change the minDate
         */
        setMinDate: function(value)
        {
            if(value instanceof Date) {
                setToStartOfDay(value);
                this._o.minDate = value;
                this._o.minYear  = value.getFullYear();
                this._o.minMonth = value.getMonth();
            } else {
                this._o.minDate = defaults.minDate;
                this._o.minYear  = defaults.minYear;
                this._o.minMonth = defaults.minMonth;
                this._o.startRange = defaults.startRange;
            }

            this.draw();
        },

        /**
         * change the maxDate
         */
        setMaxDate: function(value)
        {
            if(value instanceof Date) {
                setToStartOfDay(value);
                this._o.maxDate = value;
                this._o.maxYear = value.getFullYear();
                this._o.maxMonth = value.getMonth();
            } else {
                this._o.maxDate = defaults.maxDate;
                this._o.maxYear = defaults.maxYear;
                this._o.maxMonth = defaults.maxMonth;
                this._o.endRange = defaults.endRange;
            }

            this.draw();
        },

        setStartRange: function(value)
        {
            this._o.startRange = value;
        },

        setEndRange: function(value)
        {
            this._o.endRange = value;
        },

        /**
         * refresh the HTML
         */
        draw: function(force)
        {
            if (!this._v && !force) {
                return;
            }
            var opts = this._o,
                minYear = opts.minYear,
                maxYear = opts.maxYear,
                minMonth = opts.minMonth,
                maxMonth = opts.maxMonth,
                html = '',
                randId;

            if (this._y <= minYear) {
                this._y = minYear;
                if (!isNaN(minMonth) && this._m < minMonth) {
                    this._m = minMonth;
                }
            }
            if (this._y >= maxYear) {
                this._y = maxYear;
                if (!isNaN(maxMonth) && this._m > maxMonth) {
                    this._m = maxMonth;
                }
            }

            randId = 'pika-title-' + Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 2);

            for (var c = 0; c < opts.numberOfMonths; c++) {
                html += '<div class="pika-lendar">' + renderTitle(this, c, this.calendars[c].year, this.calendars[c].month, this.calendars[0].year, randId) + this.render(this.calendars[c].year, this.calendars[c].month, randId) + '</div>';
            }

            this.el.innerHTML = html;

            if (opts.bound) {
                if(opts.field.type !== 'hidden') {
                    sto(function() {
                        opts.trigger.focus();
                    }, 1);
                }
            }

            if (typeof this._o.onDraw === 'function') {
                this._o.onDraw(this);
            }
            
            if (opts.bound) {
                // let the screen reader user know to use arrow keys
                opts.field.setAttribute('aria-label', 'Use the arrow keys to pick a date');
            }
        },

        adjustPosition: function()
        {
            var field, pEl, width, height, viewportWidth, viewportHeight, scrollTop, left, top, clientRect;

            if (this._o.container) return;

            this.el.style.position = 'absolute';

            field = this._o.trigger;
            pEl = field;
            width = this.el.offsetWidth;
            height = this.el.offsetHeight;
            viewportWidth = window.innerWidth || document.documentElement.clientWidth;
            viewportHeight = window.innerHeight || document.documentElement.clientHeight;
            scrollTop = window.pageYOffset || document.body.scrollTop || document.documentElement.scrollTop;

            if (typeof field.getBoundingClientRect === 'function') {
                clientRect = field.getBoundingClientRect();
                left = clientRect.left + window.pageXOffset;
                top = clientRect.bottom + window.pageYOffset;
            } else {
                left = pEl.offsetLeft;
                top  = pEl.offsetTop + pEl.offsetHeight;
                while((pEl = pEl.offsetParent)) {
                    left += pEl.offsetLeft;
                    top  += pEl.offsetTop;
                }
            }

            // default position is bottom & left
            if ((this._o.reposition && left + width > viewportWidth) ||
                (
                    this._o.position.indexOf('right') > -1 &&
                    left - width + field.offsetWidth > 0
                )
            ) {
                left = left - width + field.offsetWidth;
            }
            if ((this._o.reposition && top + height > viewportHeight + scrollTop) ||
                (
                    this._o.position.indexOf('top') > -1 &&
                    top - height - field.offsetHeight > 0
                )
            ) {
                top = top - height - field.offsetHeight;
            }

            this.el.style.left = left + 'px';
            this.el.style.top = top + 'px';
        },

        /**
         * render HTML for a particular month
         */
        render: function(year, month, randId)
        {
            var opts   = this._o,
                now    = new Date(),
                days   = getDaysInMonth(year, month),
                before = new Date(year, month, 1).getDay(),
                data   = [],
                row    = [];
            setToStartOfDay(now);
            if (opts.firstDay > 0) {
                before -= opts.firstDay;
                if (before < 0) {
                    before += 7;
                }
            }
            var previousMonth = month === 0 ? 11 : month - 1,
                nextMonth = month === 11 ? 0 : month + 1,
                yearOfPreviousMonth = month === 0 ? year - 1 : year,
                yearOfNextMonth = month === 11 ? year + 1 : year,
                daysInPreviousMonth = getDaysInMonth(yearOfPreviousMonth, previousMonth);
            var cells = days + before,
                after = cells;
            while(after > 7) {
                after -= 7;
            }
            cells += 7 - after;
            for (var i = 0, r = 0; i < cells; i++)
            {
                var day = new Date(year, month, 1 + (i - before)),
                    isSelected = isDate(this._d) ? compareDates(day, this._d) : false,
                    isToday = compareDates(day, now),
                    isEmpty = i < before || i >= (days + before),
                    dayNumber = 1 + (i - before),
                    monthNumber = month,
                    yearNumber = year,
                    isStartRange = opts.startRange && compareDates(opts.startRange, day),
                    isEndRange = opts.endRange && compareDates(opts.endRange, day),
                    isInRange = opts.startRange && opts.endRange && opts.startRange < day && day < opts.endRange,
                    isDisabled = (opts.minDate && day < opts.minDate) ||
                                 (opts.maxDate && day > opts.maxDate) ||
                                 (opts.disableWeekends && isWeekend(day)) ||
                                 (opts.disableDayFn && opts.disableDayFn(day));

                if (isEmpty) {
                    if (i < before) {
                        dayNumber = daysInPreviousMonth + dayNumber;
                        monthNumber = previousMonth;
                        yearNumber = yearOfPreviousMonth;
                    } else {
                        dayNumber = dayNumber - days;
                        monthNumber = nextMonth;
                        yearNumber = yearOfNextMonth;
                    }
                }

                var dayConfig = {
                        day: dayNumber,
                        month: monthNumber,
                        year: yearNumber,
                        isSelected: isSelected,
                        isToday: isToday,
                        isDisabled: isDisabled,
                        isEmpty: isEmpty,
                        isStartRange: isStartRange,
                        isEndRange: isEndRange,
                        isInRange: isInRange,
                        showDaysInNextAndPreviousMonths: opts.showDaysInNextAndPreviousMonths
                    };

                row.push(renderDay(dayConfig));

                if (++r === 7) {
                    if (opts.showWeekNumber) {
                        row.unshift(renderWeek(i - before, month, year));
                    }
                    data.push(renderRow(row, opts.isRTL));
                    row = [];
                    r = 0;
                }
            }
            return renderTable(opts, data, randId);
        },

        isVisible: function()
        {
            return this._v;
        },

        show: function()
        {
            if (!this.isVisible()) {
                removeClass(this.el, 'is-hidden');
                this._v = true;
                this.draw();
                if (this._o.bound) {
                    addEvent(document, 'click', this._onClick);
                    this.adjustPosition();
                }
                if (typeof this._o.onOpen === 'function') {
                    this._o.onOpen.call(this);
                }
            }
        },

        hide: function()
        {
            var v = this._v;
            if (v !== false) {
                if (this._o.bound) {
                    removeEvent(document, 'click', this._onClick);
                }
                this.el.style.position = 'static'; // reset
                this.el.style.left = 'auto';
                this.el.style.top = 'auto';
                addClass(this.el, 'is-hidden');
                this._v = false;
                if (v !== undefined && typeof this._o.onClose === 'function') {
                    this._o.onClose.call(this);
                }
            }
        },

        /**
         * GAME OVER
         */
        destroy: function()
        {
            this.hide();
            removeEvent(this.el, 'mousedown', this._onMouseDown, true);
            removeEvent(this.el, 'touchend', this._onMouseDown, true);
            removeEvent(this.el, 'change', this._onChange);
            if (this._o.field) {
                removeEvent(this._o.field, 'change', this._onInputChange);
                if (this._o.bound) {
                    removeEvent(this._o.trigger, 'click', this._onInputClick);
                    removeEvent(this._o.trigger, 'focus', this._onInputFocus);
                    removeEvent(this._o.trigger, 'blur', this._onInputBlur);
                }
            }
            if (this.el.parentNode) {
                this.el.parentNode.removeChild(this.el);
            }
        }

    };

    return Pikaday;

}));


/***/ }),

/***/ "l+Tn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BYTES_IN_KIB; });
/* eslint-disable import/prefer-default-export */
var BYTES_IN_KIB = 1024;

/***/ }),

/***/ "loCD":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Autosize 3.0.14
	license: MIT
	http://www.jacklmoore.com/autosize
*/
(function (global, factory) {
	if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, module], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof exports !== 'undefined' && typeof module !== 'undefined') {
		factory(exports, module);
	} else {
		var mod = {
			exports: {}
		};
		factory(mod.exports, mod);
		global.autosize = mod.exports;
	}
})(this, function (exports, module) {
	'use strict';

	var set = typeof Set === 'function' ? new Set() : (function () {
		var list = [];

		return {
			has: function has(key) {
				return Boolean(list.indexOf(key) > -1);
			},
			add: function add(key) {
				list.push(key);
			},
			'delete': function _delete(key) {
				list.splice(list.indexOf(key), 1);
			} };
	})();

	function assign(ta) {
		var _ref = arguments[1] === undefined ? {} : arguments[1];

		var _ref$setOverflowX = _ref.setOverflowX;
		var setOverflowX = _ref$setOverflowX === undefined ? true : _ref$setOverflowX;
		var _ref$setOverflowY = _ref.setOverflowY;
		var setOverflowY = _ref$setOverflowY === undefined ? true : _ref$setOverflowY;

		if (!ta || !ta.nodeName || ta.nodeName !== 'TEXTAREA' || set.has(ta)) return;

		var heightOffset = null;
		var overflowY = null;
		var clientWidth = ta.clientWidth;

		function init() {
			var style = window.getComputedStyle(ta, null);

			overflowY = style.overflowY;

			if (style.resize === 'vertical') {
				ta.style.resize = 'none';
			} else if (style.resize === 'both') {
				ta.style.resize = 'horizontal';
			}

			if (style.boxSizing === 'content-box') {
				heightOffset = -(parseFloat(style.paddingTop) + parseFloat(style.paddingBottom));
			} else {
				heightOffset = parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
			}
			// Fix when a textarea is not on document body and heightOffset is Not a Number
			if (isNaN(heightOffset)) {
				heightOffset = 0;
			}

			update();
		}

		function changeOverflow(value) {
			{
				// Chrome/Safari-specific fix:
				// When the textarea y-overflow is hidden, Chrome/Safari do not reflow the text to account for the space
				// made available by removing the scrollbar. The following forces the necessary text reflow.
				var width = ta.style.width;
				ta.style.width = '0px';
				// Force reflow:
				/* jshint ignore:start */
				ta.offsetWidth;
				/* jshint ignore:end */
				ta.style.width = width;
			}

			overflowY = value;

			if (setOverflowY) {
				ta.style.overflowY = value;
			}

			resize();
		}

		function resize() {
			var htmlTop = window.pageYOffset;
			var bodyTop = document.body.scrollTop;
			var originalHeight = ta.style.height;

			ta.style.height = 'auto';

			var endHeight = ta.scrollHeight + heightOffset;

			if (ta.scrollHeight === 0) {
				// If the scrollHeight is 0, then the element probably has display:none or is detached from the DOM.
				ta.style.height = originalHeight;
				return;
			}

			ta.style.height = endHeight + 'px';

			// used to check if an update is actually necessary on window.resize
			clientWidth = ta.clientWidth;

			// prevents scroll-position jumping
			document.documentElement.scrollTop = htmlTop;
			document.body.scrollTop = bodyTop;
		}

		function update() {
			var startHeight = ta.style.height;

			resize();

			var style = window.getComputedStyle(ta, null);

			if (style.height !== ta.style.height) {
				if (overflowY !== 'visible') {
					changeOverflow('visible');
				}
			} else {
				if (overflowY !== 'hidden') {
					changeOverflow('hidden');
				}
			}

			if (startHeight !== ta.style.height) {
				var evt = document.createEvent('Event');
				evt.initEvent('autosize:resized', true, false);
				ta.dispatchEvent(evt);
			}
		}

		var pageResize = function pageResize() {
			if (ta.clientWidth !== clientWidth) {
				update();
			}
		};

		var destroy = (function (style) {
			window.removeEventListener('resize', pageResize, false);
			ta.removeEventListener('input', update, false);
			ta.removeEventListener('keyup', update, false);
			ta.removeEventListener('autosize:destroy', destroy, false);
			ta.removeEventListener('autosize:update', update, false);
			set['delete'](ta);

			Object.keys(style).forEach(function (key) {
				ta.style[key] = style[key];
			});
		}).bind(ta, {
			height: ta.style.height,
			resize: ta.style.resize,
			overflowY: ta.style.overflowY,
			overflowX: ta.style.overflowX,
			wordWrap: ta.style.wordWrap });

		ta.addEventListener('autosize:destroy', destroy, false);

		// IE9 does not fire onpropertychange or oninput for deletions,
		// so binding to onkeyup to catch most of those events.
		// There is no way that I know of to detect something like 'cut' in IE9.
		if ('onpropertychange' in ta && 'oninput' in ta) {
			ta.addEventListener('keyup', update, false);
		}

		window.addEventListener('resize', pageResize, false);
		ta.addEventListener('input', update, false);
		ta.addEventListener('autosize:update', update, false);
		set.add(ta);

		if (setOverflowX) {
			ta.style.overflowX = 'hidden';
			ta.style.wordWrap = 'break-word';
		}

		init();
	}

	function destroy(ta) {
		if (!(ta && ta.nodeName && ta.nodeName === 'TEXTAREA')) return;
		var evt = document.createEvent('Event');
		evt.initEvent('autosize:destroy', true, false);
		ta.dispatchEvent(evt);
	}

	function update(ta) {
		if (!(ta && ta.nodeName && ta.nodeName === 'TEXTAREA')) return;
		var evt = document.createEvent('Event');
		evt.initEvent('autosize:update', true, false);
		ta.dispatchEvent(evt);
	}

	var autosize = null;

	// Do nothing in Node.js environment and IE8 (or lower)
	if (typeof window === 'undefined' || typeof window.getComputedStyle !== 'function') {
		autosize = function (el) {
			return el;
		};
		autosize.destroy = function (el) {
			return el;
		};
		autosize.update = function (el) {
			return el;
		};
	} else {
		autosize = function (el, options) {
			if (el) {
				Array.prototype.forEach.call(el.length ? el : [el], function (x) {
					return assign(x, options);
				});
			}
			return el;
		};
		autosize.destroy = function (el) {
			if (el) {
				Array.prototype.forEach.call(el.length ? el : [el], destroy);
			}
			return el;
		};
		autosize.update = function (el) {
			if (el) {
				Array.prototype.forEach.call(el.length ? el : [el], update);
			}
			return el;
		};
	}

	module.exports = autosize;
});

/***/ }),

/***/ "lu3/":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  var HIDDEN_VALUE_TEXT = '******';

  var ProjectVariables = function () {
    function ProjectVariables() {
      _classCallCheck(this, ProjectVariables);

      this.$revealBtn = $('.js-btn-toggle-reveal-values');
      this.$revealBtn.on('click', this.toggleRevealState.bind(this));
    }

    _createClass(ProjectVariables, [{
      key: 'toggleRevealState',
      value: function toggleRevealState(e) {
        e.preventDefault();

        var oldStatus = this.$revealBtn.attr('data-status');
        var newStatus = 'hidden';
        var newAction = 'Reveal Values';

        if (oldStatus === 'hidden') {
          newStatus = 'revealed';
          newAction = 'Hide Values';
        }

        this.$revealBtn.attr('data-status', newStatus);

        var $variables = $('.variable-value');

        $variables.each(function (_, variable) {
          var $variable = $(variable);
          var newText = HIDDEN_VALUE_TEXT;

          if (newStatus === 'revealed') {
            newText = $variable.attr('data-value');
          }

          $variable.text(newText);
        });

        this.$revealBtn.text(newAction);
      }
    }]);

    return ProjectVariables;
  }();

  window.gl = window.gl || {};
  window.gl.ProjectVariables = ProjectVariables;
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "mCVl":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, wrap-iife, no-var, one-var, one-var-declaration-per-line, object-shorthand, prefer-arrow-callback, comma-dangle, prefer-template, quotes, no-else-return, max-len */
/* global Api */

(function () {
  this.Search = function () {
    function Search() {
      var $groupDropdown, $projectDropdown;
      $groupDropdown = $('.js-search-group-dropdown');
      $projectDropdown = $('.js-search-project-dropdown');
      this.eventListeners();
      $groupDropdown.glDropdown({
        selectable: true,
        filterable: true,
        fieldName: 'group_id',
        search: {
          fields: ['full_name']
        },
        data: function data(term, callback) {
          return Api.groups(term, {}, function (data) {
            data.unshift({
              full_name: 'Any'
            });
            data.splice(1, 0, 'divider');
            return callback(data);
          });
        },
        id: function id(obj) {
          return obj.id;
        },
        text: function text(obj) {
          return obj.full_name;
        },
        toggleLabel: function toggleLabel(obj) {
          return $groupDropdown.data('default-label') + " " + obj.full_name;
        },
        clicked: function (_this) {
          return function () {
            return _this.submitSearch();
          };
        }(this)
      });
      $projectDropdown.glDropdown({
        selectable: true,
        filterable: true,
        fieldName: 'project_id',
        search: {
          fields: ['name']
        },
        data: function data(term, callback) {
          return Api.projects(term, { order_by: 'id' }, function (data) {
            data.unshift({
              name_with_namespace: 'Any'
            });
            data.splice(1, 0, 'divider');
            return callback(data);
          });
        },
        id: function id(obj) {
          return obj.id;
        },
        text: function text(obj) {
          return obj.name_with_namespace;
        },
        toggleLabel: function toggleLabel(obj) {
          return $projectDropdown.data('default-label') + " " + obj.name_with_namespace;
        },
        clicked: function (_this) {
          return function () {
            return _this.submitSearch();
          };
        }(this)
      });
    }

    Search.prototype.eventListeners = function () {
      $(document).off('keyup', '.js-search-input').on('keyup', '.js-search-input', this.searchKeyUp);
      return $(document).off('click', '.js-search-clear').on('click', '.js-search-clear', this.clearSearchField);
    };

    Search.prototype.submitSearch = function () {
      return $('.js-search-form').submit();
    };

    Search.prototype.searchKeyUp = function () {
      var $input;
      $input = $(this);
      if ($input.val() === '') {
        return $('.js-search-clear').addClass('hidden');
      } else {
        return $('.js-search-clear').removeClass('hidden');
      }
    };

    Search.prototype.clearSearchField = function () {
      return $('.js-search-input').val('').trigger('keyup').focus();
    };

    return Search;
  }();
}).call(window);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "n+MV":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable no-useless-return, func-names, space-before-function-paren, wrap-iife, no-var, no-underscore-dangle, prefer-arrow-callback, max-len, one-var, no-unused-vars, one-var-declaration-per-line, prefer-template, no-new, consistent-return, object-shorthand, comma-dangle, no-shadow, no-param-reassign, brace-style, vars-on-top, quotes, no-lonely-if, no-else-return, dot-notation, no-empty, no-return-assign, camelcase, prefer-spread */
/* global Issuable */
/* global ListLabel */

(function () {
  this.LabelsSelect = function () {
    function LabelsSelect(els) {
      var _this, $els;
      _this = this;

      $els = $(els);

      if (!els) {
        $els = $('.js-label-select');
      }

      $els.each(function (i, dropdown) {
        var $block, $colorPreview, $dropdown, $form, $loading, $selectbox, $sidebarCollapsedValue, $value, abilityName, defaultLabel, enableLabelCreateButton, issueURLSplit, issueUpdateURL, labelHTMLTemplate, labelNoneHTMLTemplate, labelUrl, namespacePath, projectPath, saveLabelData, selectedLabel, showAny, showNo, $sidebarLabelTooltip, initialSelected, $toggleText, fieldName, useId, propertyName, showMenuAbove, $container, $dropdownContainer;
        $dropdown = $(dropdown);
        $dropdownContainer = $dropdown.closest('.labels-filter');
        $toggleText = $dropdown.find('.dropdown-toggle-text');
        namespacePath = $dropdown.data('namespace-path');
        projectPath = $dropdown.data('project-path');
        labelUrl = $dropdown.data('labels');
        issueUpdateURL = $dropdown.data('issueUpdate');
        selectedLabel = $dropdown.data('selected');
        if (selectedLabel != null && !$dropdown.hasClass('js-multiselect')) {
          selectedLabel = selectedLabel.split(',');
        }
        showNo = $dropdown.data('show-no');
        showAny = $dropdown.data('show-any');
        showMenuAbove = $dropdown.data('showMenuAbove');
        defaultLabel = $dropdown.data('default-label');
        abilityName = $dropdown.data('ability-name');
        $selectbox = $dropdown.closest('.selectbox');
        $block = $selectbox.closest('.block');
        $form = $dropdown.closest('form, .js-issuable-update');
        $sidebarCollapsedValue = $block.find('.sidebar-collapsed-icon span');
        $sidebarLabelTooltip = $block.find('.js-sidebar-labels-tooltip');
        $value = $block.find('.value');
        $loading = $block.find('.block-loading').fadeOut();
        fieldName = $dropdown.data('field-name');
        useId = $dropdown.is('.js-issuable-form-dropdown, .js-filter-bulk-update, .js-label-sidebar-dropdown');
        propertyName = useId ? 'id' : 'title';
        initialSelected = $selectbox.find('input[name="' + $dropdown.data('field-name') + '"]').map(function () {
          return this.value;
        }).get();
        if (issueUpdateURL != null) {
          issueURLSplit = issueUpdateURL.split('/');
        }
        if (issueUpdateURL) {
          labelHTMLTemplate = _.template('<% _.each(labels, function(label){ %> <a href="<%- ["",issueURLSplit[1], issueURLSplit[2],""].join("/") %>issues?label_name[]=<%- encodeURIComponent(label.title) %>"> <span class="label has-tooltip color-label" title="<%- label.description %>" style="background-color: <%- label.color %>; color: <%- label.text_color %>;"> <%- label.title %> </span> </a> <% }); %>');
          labelNoneHTMLTemplate = '<span class="no-value">None</span>';
        }

        $sidebarLabelTooltip.tooltip();

        if ($dropdown.closest('.dropdown').find('.dropdown-new-label').length) {
          new gl.CreateLabelDropdown($dropdown.closest('.dropdown').find('.dropdown-new-label'), namespacePath, projectPath);
        }

        saveLabelData = function saveLabelData() {
          var data, selected;
          selected = $dropdown.closest('.selectbox').find("input[name='" + fieldName + "']").map(function () {
            return this.value;
          }).get();

          if (_.isEqual(initialSelected, selected)) return;
          initialSelected = selected;

          data = {};
          data[abilityName] = {};
          data[abilityName].label_ids = selected;
          if (!selected.length) {
            data[abilityName].label_ids = [''];
          }
          $loading.removeClass('hidden').fadeIn();
          $dropdown.trigger('loading.gl.dropdown');
          return $.ajax({
            type: 'PUT',
            url: issueUpdateURL,
            dataType: 'JSON',
            data: data
          }).done(function (data) {
            var labelCount, template, labelTooltipTitle, labelTitles;
            $loading.fadeOut();
            $dropdown.trigger('loaded.gl.dropdown');
            $selectbox.hide();
            data.issueURLSplit = issueURLSplit;
            labelCount = 0;
            if (data.labels.length) {
              template = labelHTMLTemplate(data);
              labelCount = data.labels.length;
            } else {
              template = labelNoneHTMLTemplate;
            }
            $value.removeAttr('style').html(template);
            $sidebarCollapsedValue.text(labelCount);

            if (data.labels.length) {
              labelTitles = data.labels.map(function (label) {
                return label.title;
              });

              if (labelTitles.length > 5) {
                labelTitles = labelTitles.slice(0, 5);
                labelTitles.push('and ' + (data.labels.length - 5) + ' more');
              }

              labelTooltipTitle = labelTitles.join(', ');
            } else {
              labelTooltipTitle = '';
              $sidebarLabelTooltip.tooltip('destroy');
            }

            $sidebarLabelTooltip.attr('title', labelTooltipTitle).tooltip('fixTitle');

            $('.has-tooltip', $value).tooltip({
              container: 'body'
            });
            return $value.find('a').each(function (i) {
              return setTimeout(function (_this) {
                return function () {
                  return gl.animate.animate($(_this), 'pulse');
                };
              }(this), 200 * i);
            });
          });
        };
        $dropdown.glDropdown({
          showMenuAbove: showMenuAbove,
          data: function data(term, callback) {
            return $.ajax({
              url: labelUrl
            }).done(function (data) {
              data = _.chain(data).groupBy(function (label) {
                return label.title;
              }).map(function (label) {
                var color;
                color = _.map(label, function (dup) {
                  return dup.color;
                });
                return {
                  id: label[0].id,
                  title: label[0].title,
                  color: color,
                  duplicate: color.length > 1
                };
              }).value();
              if ($dropdown.hasClass('js-extra-options')) {
                var extraData = [];
                if (showNo) {
                  extraData.unshift({
                    id: 0,
                    title: 'No Label'
                  });
                }
                if (showAny) {
                  extraData.unshift({
                    isAny: true,
                    title: 'Any Label'
                  });
                }
                if (extraData.length) {
                  extraData.push('divider');
                  data = extraData.concat(data);
                }
              }

              callback(data);
              if (showMenuAbove) {
                $dropdown.data('glDropdown').positionMenuAbove();
              }
            });
          },
          renderRow: function renderRow(label, instance) {
            var $a, $li, color, colorEl, indeterminate, removesAll, selectedClass, spacing, i, marked, dropdownName, dropdownValue;
            $li = $('<li>');
            $a = $('<a href="#">');
            selectedClass = [];
            removesAll = label.id <= 0 || label.id == null;
            if ($dropdown.hasClass('js-filter-bulk-update')) {
              indeterminate = $dropdown.data('indeterminate') || [];
              marked = $dropdown.data('marked') || [];

              if (indeterminate.indexOf(label.id) !== -1) {
                selectedClass.push('is-indeterminate');
              }

              if (marked.indexOf(label.id) !== -1) {
                // Remove is-indeterminate class if the item will be marked as active
                i = selectedClass.indexOf('is-indeterminate');
                if (i !== -1) {
                  selectedClass.splice(i, 1);
                }
                selectedClass.push('is-active');
              }
            } else {
              if (this.id(label)) {
                dropdownName = $dropdown.data('fieldName');
                dropdownValue = this.id(label).toString().replace(/'/g, '\\\'');

                if ($form.find("input[type='hidden'][name='" + dropdownName + "'][value='" + dropdownValue + "']").length) {
                  selectedClass.push('is-active');
                }
              }

              if ($dropdown.hasClass('js-multiselect') && removesAll) {
                selectedClass.push('dropdown-clear-active');
              }
            }
            if (label.duplicate) {
              spacing = 100 / label.color.length;
              // Reduce the colors to 4
              label.color = label.color.filter(function (color, i) {
                return i < 4;
              });
              color = _.map(label.color, function (color, i) {
                var percentFirst, percentSecond;
                percentFirst = Math.floor(spacing * i);
                percentSecond = Math.floor(spacing * (i + 1));
                return color + " " + percentFirst + "%," + color + " " + percentSecond + "% ";
              }).join(',');
              color = "linear-gradient(" + color + ")";
            } else {
              if (label.color != null) {
                color = label.color[0];
              }
            }
            if (color) {
              colorEl = "<span class='dropdown-label-box' style='background: " + color + "'></span>";
            } else {
              colorEl = '';
            }
            // We need to identify which items are actually labels
            if (label.id) {
              selectedClass.push('label-item');
              $a.attr('data-label-id', label.id);
            }
            $a.addClass(selectedClass.join(' ')).html(colorEl + " " + label.title);
            // Return generated html
            return $li.html($a).prop('outerHTML');
          },
          search: {
            fields: ['title']
          },
          selectable: true,
          filterable: true,
          selected: $dropdown.data('selected') || [],
          toggleLabel: function toggleLabel(selected, el) {
            var isSelected = el !== null ? el.hasClass('is-active') : false;
            var title = selected.title;
            var selectedLabels = this.selected;

            if (selected.id === 0) {
              this.selected = [];
              return 'No Label';
            } else if (isSelected) {
              this.selected.push(title);
            } else {
              var index = this.selected.indexOf(title);
              this.selected.splice(index, 1);
            }

            if (selectedLabels.length === 1) {
              return selectedLabels;
            } else if (selectedLabels.length) {
              return selectedLabels[0] + " +" + (selectedLabels.length - 1) + " more";
            } else {
              return defaultLabel;
            }
          },
          fieldName: $dropdown.data('field-name'),
          id: function id(label) {
            if (label.id <= 0) return label.title;

            if ($dropdown.hasClass('js-issuable-form-dropdown')) {
              return label.id;
            }

            if ($dropdown.hasClass("js-filter-submit") && label.isAny == null) {
              return label.title;
            } else {
              return label.id;
            }
          },
          hidden: function hidden() {
            var isIssueIndex, isMRIndex, page, selectedLabels;
            page = $('body').data('page');
            isIssueIndex = page === 'projects:issues:index';
            isMRIndex = page === 'projects:merge_requests:index';
            $selectbox.hide();
            // display:block overrides the hide-collapse rule
            $value.removeAttr('style');

            if ($dropdown.hasClass('js-issuable-form-dropdown')) {
              return;
            }

            if ($('html').hasClass('issue-boards-page')) {
              return;
            }
            if ($dropdown.hasClass('js-multiselect')) {
              if ($dropdown.hasClass('js-filter-submit') && (isIssueIndex || isMRIndex)) {
                selectedLabels = $dropdown.closest('form').find("input:hidden[name='" + $dropdown.data('fieldName') + "']");
                Issuable.filterResults($dropdown.closest('form'));
              } else if ($dropdown.hasClass('js-filter-submit')) {
                $dropdown.closest('form').submit();
              } else {
                if (!$dropdown.hasClass('js-filter-bulk-update')) {
                  saveLabelData();
                }
              }
            }
          },
          multiSelect: $dropdown.hasClass('js-multiselect'),
          vue: $dropdown.hasClass('js-issue-board-sidebar'),
          clicked: function clicked(label, $el, e, isMarking) {
            var isIssueIndex, isMRIndex, page, boardsModel;

            page = $('body').data('page');
            isIssueIndex = page === 'projects:issues:index';
            isMRIndex = page === 'projects:merge_requests:index';

            if ($dropdown.parent().find('.is-active:not(.dropdown-clear-active)').length) {
              $dropdown.parent().find('.dropdown-clear-active').removeClass('is-active');
            }

            if ($dropdown.hasClass('js-issuable-form-dropdown')) {
              return;
            }

            if ($dropdown.hasClass('js-filter-bulk-update')) {
              _this.enableBulkLabelDropdown();
              _this.setDropdownData($dropdown, isMarking, this.id(label));
              return;
            }

            if ($dropdown.closest('.add-issues-modal').length) {
              boardsModel = gl.issueBoards.ModalStore.store.filter;
            }

            if (boardsModel) {
              if (label.isAny) {
                boardsModel['label_name'] = [];
              } else if ($el.hasClass('is-active')) {
                boardsModel['label_name'].push(label.title);
              }

              e.preventDefault();
              return;
            } else if ($dropdown.hasClass('js-filter-submit') && (isIssueIndex || isMRIndex)) {
              if (!$dropdown.hasClass('js-multiselect')) {
                selectedLabel = label.title;
                return Issuable.filterResults($dropdown.closest('form'));
              }
            } else if ($dropdown.hasClass('js-filter-submit')) {
              return $dropdown.closest('form').submit();
            } else if ($dropdown.hasClass('js-issue-board-sidebar')) {
              if ($el.hasClass('is-active')) {
                gl.issueBoards.BoardsStore.detail.issue.labels.push(new ListLabel({
                  id: label.id,
                  title: label.title,
                  color: label.color[0],
                  textColor: '#fff'
                }));
              } else {
                var labels = gl.issueBoards.BoardsStore.detail.issue.labels;
                labels = labels.filter(function (selectedLabel) {
                  return selectedLabel.id !== label.id;
                });
                gl.issueBoards.BoardsStore.detail.issue.labels = labels;
              }

              $loading.fadeIn();

              gl.issueBoards.BoardsStore.detail.issue.update($dropdown.attr('data-issue-update')).then(function () {
                $loading.fadeOut();
              });
            } else {
              if ($dropdown.hasClass('js-multiselect')) {} else {
                return saveLabelData();
              }
            }
          }
        });

        // Set dropdown data
        _this.setOriginalDropdownData($dropdownContainer, $dropdown);
      });
      this.bindEvents();
    }

    LabelsSelect.prototype.bindEvents = function () {
      return $('body').on('change', '.selected_issue', this.onSelectCheckboxIssue);
    };

    LabelsSelect.prototype.onSelectCheckboxIssue = function () {
      if ($('.selected_issue:checked').length) {
        return;
      }
      return $('.issues_bulk_update .labels-filter .dropdown-toggle-text').text('Label');
    };

    LabelsSelect.prototype.enableBulkLabelDropdown = function () {
      var issuableBulkActions;
      if ($('.selected_issue:checked').length) {
        issuableBulkActions = $('.bulk-update').data('bulkActions');
        return issuableBulkActions.willUpdateLabels = true;
      }
    };

    LabelsSelect.prototype.setDropdownData = function ($dropdown, isMarking, value) {
      var i, markedIds, unmarkedIds, indeterminateIds;
      var issuableBulkActions = $('.bulk-update').data('bulkActions');

      markedIds = $dropdown.data('marked') || [];
      unmarkedIds = $dropdown.data('unmarked') || [];
      indeterminateIds = $dropdown.data('indeterminate') || [];

      if (isMarking) {
        markedIds.push(value);

        i = indeterminateIds.indexOf(value);
        if (i > -1) {
          indeterminateIds.splice(i, 1);
        }

        i = unmarkedIds.indexOf(value);
        if (i > -1) {
          unmarkedIds.splice(i, 1);
        }
      } else {
        // If marked item (not common) is unmarked
        i = markedIds.indexOf(value);
        if (i > -1) {
          markedIds.splice(i, 1);
        }

        // If an indeterminate item is being unmarked
        if (issuableBulkActions.getOriginalIndeterminateIds().indexOf(value) > -1) {
          unmarkedIds.push(value);
        }

        // If a marked item is being unmarked
        // (a marked item could also be a label that is present in all selection)
        if (issuableBulkActions.getOriginalCommonIds().indexOf(value) > -1) {
          unmarkedIds.push(value);
        }
      }

      $dropdown.data('marked', markedIds);
      $dropdown.data('unmarked', unmarkedIds);
      $dropdown.data('indeterminate', indeterminateIds);
    };

    LabelsSelect.prototype.setOriginalDropdownData = function ($container, $dropdown) {
      var labels = [];
      $container.find('[name="label_name[]"]').map(function () {
        return labels.push(this.value);
      });
      $dropdown.data('marked', labels);
    };

    return LabelsSelect;
  }();
}).call(window);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "nIl8":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, no-var, prefer-rest-params, wrap-iife, quotes, no-underscore-dangle, one-var, one-var-declaration-per-line, consistent-return, dot-notation, quote-props, comma-dangle, object-shorthand, max-len, prefer-arrow-callback */
/* global MergeRequestTabs */

__webpack_require__("5IIL");
__webpack_require__("3uF6");
__webpack_require__("Yr+x");

(function () {
  var bind = function bind(fn, me) {
    return function () {
      return fn.apply(me, arguments);
    };
  };

  this.MergeRequest = function () {
    function MergeRequest(opts) {
      // Initialize MergeRequest behavior
      //
      // Options:
      //   action - String, current controller action
      //
      this.opts = opts != null ? opts : {};
      this.submitNoteForm = bind(this.submitNoteForm, this);
      this.$el = $('.merge-request');
      this.$('.show-all-commits').on('click', function (_this) {
        return function () {
          return _this.showAllCommits();
        };
      }(this));
      this.initTabs();
      this.initMRBtnListeners();
      this.initCommitMessageListeners();
      if ($("a.btn-close").length) {
        this.taskList = new gl.TaskList({
          dataType: 'merge_request',
          fieldName: 'description',
          selector: '.detail-page-description',
          onSuccess: function onSuccess(result) {
            document.querySelector('#task_status').innerText = result.task_status;
            document.querySelector('#task_status_short').innerText = result.task_status_short;
          }
        });
      }
    }

    // Local jQuery finder
    MergeRequest.prototype.$ = function (selector) {
      return this.$el.find(selector);
    };

    MergeRequest.prototype.initTabs = function () {
      if (window.mrTabs) {
        window.mrTabs.unbindEvents();
      }
      window.mrTabs = new gl.MergeRequestTabs(this.opts);
    };

    MergeRequest.prototype.showAllCommits = function () {
      this.$('.first-commits').remove();
      return this.$('.all-commits').removeClass('hide');
    };

    MergeRequest.prototype.initMRBtnListeners = function () {
      var _this;
      _this = this;
      return $('a.btn-close, a.btn-reopen').on('click', function (e) {
        var $this, shouldSubmit;
        $this = $(this);
        shouldSubmit = $this.hasClass('btn-comment');
        if (shouldSubmit && $this.data('submitted')) {
          return;
        }
        if (shouldSubmit) {
          if ($this.hasClass('btn-comment-and-close') || $this.hasClass('btn-comment-and-reopen')) {
            e.preventDefault();
            e.stopImmediatePropagation();
            return _this.submitNoteForm($this.closest('form'), $this);
          }
        }
      });
    };

    MergeRequest.prototype.submitNoteForm = function (form, $button) {
      var noteText;
      noteText = form.find("textarea.js-note-text").val();
      if (noteText.trim().length > 0) {
        form.submit();
        $button.data('submitted', true);
        return $button.trigger('click');
      }
    };

    MergeRequest.prototype.initCommitMessageListeners = function () {
      $(document).on('click', 'a.js-with-description-link', function (e) {
        var textarea = $('textarea.js-commit-message');
        e.preventDefault();

        textarea.val(textarea.data('messageWithDescription'));
        $('.js-with-description-hint').hide();
        $('.js-without-description-hint').show();
      });

      $(document).on('click', 'a.js-without-description-link', function (e) {
        var textarea = $('textarea.js-commit-message');
        e.preventDefault();

        textarea.val(textarea.data('messageWithoutDescription'));
        $('.js-with-description-hint').show();
        $('.js-without-description-hint').hide();
      });
    };

    return MergeRequest;
  }();
}).call(window);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "nMf0":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, no-var, prefer-rest-params, wrap-iife, max-len */

(function () {
  var bind = function bind(fn, me) {
    return function () {
      return fn.apply(me, arguments);
    };
  };

  this.MergedButtons = function () {
    function MergedButtons() {
      this.removeSourceBranch = bind(this.removeSourceBranch, this);
      this.$removeBranchWidget = $('.remove_source_branch_widget');
      this.$removeBranchProgress = $('.remove_source_branch_in_progress');
      this.$removeBranchFailed = $('.remove_source_branch_widget.failed');
      this.cleanEventListeners();
      this.initEventListeners();
    }

    MergedButtons.prototype.cleanEventListeners = function () {
      $(document).off('click', '.remove_source_branch');
      $(document).off('ajax:success', '.remove_source_branch');
      return $(document).off('ajax:error', '.remove_source_branch');
    };

    MergedButtons.prototype.initEventListeners = function () {
      $(document).on('click', '.remove_source_branch', this.removeSourceBranch);
      $(document).on('ajax:success', '.remove_source_branch', this.removeBranchSuccess);
      return $(document).on('ajax:error', '.remove_source_branch', this.removeBranchError);
    };

    MergedButtons.prototype.removeSourceBranch = function () {
      this.$removeBranchWidget.hide();
      return this.$removeBranchProgress.show();
    };

    MergedButtons.prototype.removeBranchSuccess = function () {
      return location.reload();
    };

    MergedButtons.prototype.removeBranchError = function () {
      this.$removeBranchWidget.hide();
      this.$removeBranchProgress.hide();
      return this.$removeBranchFailed.show();
    };

    return MergedButtons;
  }();
}).call(window);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "nYQN":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, wrap-iife, no-var, one-var, one-var-declaration-per-line, no-param-reassign, quotes, quote-props, prefer-template, comma-dangle, max-len */

window.Flash = function () {
  var hideFlash;

  hideFlash = function hideFlash() {
    return $(this).fadeOut();
  };

  function Flash(message, type, parent) {
    var flash, textDiv;
    if (type == null) {
      type = 'alert';
    }
    if (parent == null) {
      parent = null;
    }
    if (parent) {
      this.flashContainer = parent.find('.flash-container');
    } else {
      this.flashContainer = $('.flash-container-page');
    }
    this.flashContainer.html('');
    flash = $('<div/>', {
      "class": "flash-" + type
    });
    flash.on('click', hideFlash);
    textDiv = $('<div/>', {
      "class": 'flash-text',
      text: message
    });
    textDiv.appendTo(flash);
    if (this.flashContainer.parent().hasClass('content-wrapper')) {
      textDiv.addClass('container-fluid container-limited');
    }
    flash.appendTo(this.flashContainer);
    this.flashContainer.show();
  }

  return Flash;
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "nsGX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils_number_utils__ = __webpack_require__("ZYhW");
/* eslint-disable func-names, wrap-iife, no-use-before-define,
consistent-return, prefer-rest-params */
/* global Breakpoints */



var bind = function bind(fn, me) {
  return function () {
    return fn.apply(me, arguments);
  };
};
var AUTO_SCROLL_OFFSET = 75;
var DOWN_BUILD_TRACE = '#down-build-trace';

window.Build = function () {
  Build.timeout = null;

  Build.state = null;

  function Build(options) {
    this.options = options || $('.js-build-options').data();

    this.pageUrl = this.options.pageUrl;
    this.buildUrl = this.options.buildUrl;
    this.buildStatus = this.options.buildStatus;
    this.state = this.options.logState;
    this.buildStage = this.options.buildStage;
    this.$document = $(document);
    this.logBytes = 0;

    this.updateDropdown = bind(this.updateDropdown, this);

    this.$body = $('body');
    this.$buildTrace = $('#build-trace');
    this.$autoScrollContainer = $('.autoscroll-container');
    this.$autoScrollStatus = $('#autoscroll-status');
    this.$autoScrollStatusText = this.$autoScrollStatus.find('.status-text');
    this.$upBuildTrace = $('#up-build-trace');
    this.$downBuildTrace = $(DOWN_BUILD_TRACE);
    this.$scrollTopBtn = $('#scroll-top');
    this.$scrollBottomBtn = $('#scroll-bottom');
    this.$buildRefreshAnimation = $('.js-build-refresh');
    this.$buildScroll = $('#js-build-scroll');
    this.$truncatedInfo = $('.js-truncated-info');

    clearTimeout(Build.timeout);
    // Init breakpoint checker
    this.bp = Breakpoints.get();

    this.initSidebar();
    this.populateJobs(this.buildStage);
    this.updateStageDropdownText(this.buildStage);
    this.sidebarOnResize();

    this.$document.off('click', '.js-sidebar-build-toggle').on('click', '.js-sidebar-build-toggle', this.sidebarOnClick.bind(this));

    this.$document.off('click', '.stage-item').on('click', '.stage-item', this.updateDropdown);

    this.$document.on('scroll', this.initScrollMonitor.bind(this));

    $(window).off('resize.build').on('resize.build', this.sidebarOnResize.bind(this));

    $('a', this.$buildScroll).off('click.stepTrace').on('click.stepTrace', this.stepTrace);

    this.updateArtifactRemoveDate();
    this.initScrollButtonAffix();
    this.invokeBuildTrace();
  }

  Build.prototype.initSidebar = function () {
    this.$sidebar = $('.js-build-sidebar');
    this.$sidebar.niceScroll();
    this.$document.off('click', '.js-sidebar-build-toggle').on('click', '.js-sidebar-build-toggle', this.toggleSidebar);
  };

  Build.prototype.invokeBuildTrace = function () {
    return this.getBuildTrace();
  };

  Build.prototype.getBuildTrace = function () {
    var _this = this;

    return $.ajax({
      url: this.pageUrl + '/trace.json',
      dataType: 'json',
      data: {
        state: this.state
      },
      success: function success(log) {
        var $buildContainer = $('.js-build-output');

        gl.utils.setCiStatusFavicon(_this.pageUrl + '/status.json');

        if (log.state) {
          _this.state = log.state;
        }

        if (log.append) {
          $buildContainer.append(log.html);
          _this.logBytes += log.size;
        } else {
          $buildContainer.html(log.html);
          _this.logBytes = log.size;
        }

        // if the incremental sum of logBytes we received is less than the total
        // we need to show a message warning the user about that.
        if (_this.logBytes < log.total) {
          // size is in bytes, we need to calculate KiB
          var size = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lib_utils_number_utils__["b" /* bytesToKiB */])(_this.logBytes);
          $('.js-truncated-info-size').html('' + size);
          _this.$truncatedInfo.removeClass('hidden');
          _this.initAffixTruncatedInfo();
        } else {
          _this.$truncatedInfo.addClass('hidden');
        }

        _this.checkAutoscroll();

        if (!log.complete) {
          Build.timeout = setTimeout(function () {
            _this.invokeBuildTrace();
          }, 4000);
        } else {
          _this.$buildRefreshAnimation.remove();
        }

        if (log.status !== _this.buildStatus) {
          var pageUrl = _this.pageUrl;

          if (_this.$autoScrollStatus.data('state') === 'enabled') {
            pageUrl += DOWN_BUILD_TRACE;
          }

          gl.utils.visitUrl(pageUrl);
        }
      },
      error: function error() {
        _this.$buildRefreshAnimation.remove();
        return _this.initScrollMonitor();
      }
    });
  };

  Build.prototype.checkAutoscroll = function () {
    if (this.$autoScrollStatus.data('state') === 'enabled') {
      return $('html,body').scrollTop(this.$buildTrace.height());
    }

    // Handle a situation where user started new build
    // but never scrolled a page
    if (!this.$scrollTopBtn.is(':visible') && !this.$scrollBottomBtn.is(':visible') && !gl.utils.isInViewport(this.$downBuildTrace.get(0))) {
      this.$scrollBottomBtn.show();
    }
  };

  Build.prototype.initScrollButtonAffix = function () {
    // Hide everything initially
    this.$scrollTopBtn.hide();
    this.$scrollBottomBtn.hide();
    this.$autoScrollContainer.hide();
  };

  // Page scroll listener to detect if user has scrolling page
  // and handle following cases
  // 1) User is at Top of Build Log;
  //      - Hide Top Arrow button
  //      - Show Bottom Arrow button
  //      - Disable Autoscroll and hide indicator (when build is running)
  // 2) User is at Bottom of Build Log;
  //      - Show Top Arrow button
  //      - Hide Bottom Arrow button
  //      - Enable Autoscroll and show indicator (when build is running)
  // 3) User is somewhere in middle of Build Log;
  //      - Show Top Arrow button
  //      - Show Bottom Arrow button
  //      - Disable Autoscroll and hide indicator (when build is running)
  Build.prototype.initScrollMonitor = function () {
    if (!gl.utils.isInViewport(this.$upBuildTrace.get(0)) && !gl.utils.isInViewport(this.$downBuildTrace.get(0))) {
      // User is somewhere in middle of Build Log

      this.$scrollTopBtn.show();

      if (this.buildStatus === 'success' || this.buildStatus === 'failed') {
        // Check if Build is completed
        this.$scrollBottomBtn.show();
      } else if (this.$buildRefreshAnimation.is(':visible') && !gl.utils.isInViewport(this.$buildRefreshAnimation.get(0))) {
        this.$scrollBottomBtn.show();
      } else {
        this.$scrollBottomBtn.hide();
      }

      // Hide Autoscroll Status Indicator
      if (this.$scrollBottomBtn.is(':visible')) {
        this.$autoScrollContainer.hide();
        this.$autoScrollStatusText.removeClass('animate');
      } else {
        this.$autoScrollContainer.css({
          top: this.$body.outerHeight() - AUTO_SCROLL_OFFSET
        }).show();
        this.$autoScrollStatusText.addClass('animate');
      }
    } else if (gl.utils.isInViewport(this.$upBuildTrace.get(0)) && !gl.utils.isInViewport(this.$downBuildTrace.get(0))) {
      // User is at Top of Build Log

      this.$scrollTopBtn.hide();
      this.$scrollBottomBtn.show();

      this.$autoScrollContainer.hide();
      this.$autoScrollStatusText.removeClass('animate');
    } else if (!gl.utils.isInViewport(this.$upBuildTrace.get(0)) && gl.utils.isInViewport(this.$downBuildTrace.get(0)) || this.$buildRefreshAnimation.is(':visible') && gl.utils.isInViewport(this.$buildRefreshAnimation.get(0))) {
      // User is at Bottom of Build Log

      this.$scrollTopBtn.show();
      this.$scrollBottomBtn.hide();

      // Show and Reposition Autoscroll Status Indicator
      this.$autoScrollContainer.css({
        top: this.$body.outerHeight() - AUTO_SCROLL_OFFSET
      }).show();
      this.$autoScrollStatusText.addClass('animate');
    } else if (gl.utils.isInViewport(this.$upBuildTrace.get(0)) && gl.utils.isInViewport(this.$downBuildTrace.get(0))) {
      // Build Log height is small

      this.$scrollTopBtn.hide();
      this.$scrollBottomBtn.hide();

      // Hide Autoscroll Status Indicator
      this.$autoScrollContainer.hide();
      this.$autoScrollStatusText.removeClass('animate');
    }

    if (this.buildStatus === 'running' || this.buildStatus === 'pending') {
      // Check if Refresh Animation is in Viewport and enable Autoscroll, disable otherwise.
      this.$autoScrollStatus.data('state', gl.utils.isInViewport(this.$buildRefreshAnimation.get(0)) ? 'enabled' : 'disabled');
    }
  };

  Build.prototype.shouldHideSidebarForViewport = function () {
    var bootstrapBreakpoint = this.bp.getBreakpointSize();
    return bootstrapBreakpoint === 'xs' || bootstrapBreakpoint === 'sm';
  };

  Build.prototype.toggleSidebar = function (shouldHide) {
    var shouldShow = typeof shouldHide === 'boolean' ? !shouldHide : undefined;

    this.$buildScroll.toggleClass('sidebar-expanded', shouldShow).toggleClass('sidebar-collapsed', shouldHide);
    this.$truncatedInfo.toggleClass('sidebar-expanded', shouldShow).toggleClass('sidebar-collapsed', shouldHide);
    this.$sidebar.toggleClass('right-sidebar-expanded', shouldShow).toggleClass('right-sidebar-collapsed', shouldHide);
  };

  Build.prototype.sidebarOnResize = function () {
    this.toggleSidebar(this.shouldHideSidebarForViewport());
  };

  Build.prototype.sidebarOnClick = function () {
    if (this.shouldHideSidebarForViewport()) this.toggleSidebar();
  };

  Build.prototype.updateArtifactRemoveDate = function () {
    var $date = $('.js-artifacts-remove');
    if ($date.length) {
      var date = $date.text();
      return $date.text(gl.utils.timeFor(new Date(date.replace(/([0-9]+)-([0-9]+)-([0-9]+)/g, '$1/$2/$3')), ' '));
    }
  };

  Build.prototype.populateJobs = function (stage) {
    $('.build-job').hide();
    $('.build-job[data-stage="' + stage + '"]').show();
  };

  Build.prototype.updateStageDropdownText = function (stage) {
    $('.stage-selection').text(stage);
  };

  Build.prototype.updateDropdown = function (e) {
    e.preventDefault();
    var stage = e.currentTarget.text;
    this.updateStageDropdownText(stage);
    this.populateJobs(stage);
  };

  Build.prototype.stepTrace = function (e) {
    e.preventDefault();

    var $currentTarget = $(e.currentTarget);
    $.scrollTo($currentTarget.attr('href'), {
      offset: 0
    });
  };

  Build.prototype.initAffixTruncatedInfo = function () {
    var offsetTop = this.$buildTrace.offset().top;

    this.$truncatedInfo.affix({
      offset: {
        top: offsetTop
      }
    });
  };

  return Build;
}();
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("lwLq")))

/***/ }),

/***/ "o4Ji":
/***/ (function(module, exports, __webpack_require__) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable no-new, guard-for-in, no-restricted-syntax, no-continue, no-param-reassign, max-len */

__webpack_require__("ZORs");

(function (global) {
  var Pipelines = function () {
    function Pipelines() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      _classCallCheck(this, Pipelines);

      if (options.initTabs && options.tabsOptions) {
        new global.LinkedTabs(options.tabsOptions);
      }

      if (options.pipelineStatusUrl) {
        gl.utils.setCiStatusFavicon(options.pipelineStatusUrl);
      }

      this.addMarginToBuildColumns();
    }

    _createClass(Pipelines, [{
      key: 'addMarginToBuildColumns',
      value: function addMarginToBuildColumns() {
        this.pipelineGraph = document.querySelector('.js-pipeline-graph');

        var secondChildBuildNodes = this.pipelineGraph.querySelectorAll('.build:nth-child(2)');

        for (var buildNodeIndex in secondChildBuildNodes) {
          var buildNode = secondChildBuildNodes[buildNodeIndex];
          var firstChildBuildNode = buildNode.previousElementSibling;
          if (!firstChildBuildNode || !firstChildBuildNode.matches('.build')) continue;
          var multiBuildColumn = buildNode.closest('.stage-column');
          var previousColumn = multiBuildColumn.previousElementSibling;
          if (!previousColumn || !previousColumn.matches('.stage-column')) continue;
          multiBuildColumn.classList.add('left-margin');
          firstChildBuildNode.classList.add('left-connector');
          var columnBuilds = previousColumn.querySelectorAll('.build');
          if (columnBuilds.length === 1) previousColumn.classList.add('no-margin');
        }

        this.pipelineGraph.classList.remove('hidden');
      }
    }]);

    return Pipelines;
  }();

  global.Pipelines = Pipelines;
})(window.gl || (window.gl = {}));

/***/ }),

/***/ "o5lJ":
/***/ (function(module, exports) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var VersionCheckImage = function () {
  function VersionCheckImage() {
    _classCallCheck(this, VersionCheckImage);
  }

  _createClass(VersionCheckImage, null, [{
    key: 'bindErrorEvent',
    value: function bindErrorEvent(imageElement) {
      imageElement.off('error').on('error', function () {
        return imageElement.hide();
      });
    }
  }]);

  return VersionCheckImage;
}();

window.gl = window.gl || {};
gl.VersionCheckImage = VersionCheckImage;

module.exports = VersionCheckImage;

/***/ }),

/***/ "owyH":
/***/ (function(module, exports) {

module.exports = {
	"small_airplane": "airplane_small",
	"right_anger_bubble": "anger_right",
	"keycap_asterisk": "asterisk",
	"atom_symbol": "atom",
	"ballot_box_with_ballot": "ballot_box",
	"person_with_ball": "basketball_player",
	"person_with_ball_tone1": "basketball_player_tone1",
	"person_with_ball_tone2": "basketball_player_tone2",
	"person_with_ball_tone3": "basketball_player_tone3",
	"person_with_ball_tone4": "basketball_player_tone4",
	"person_with_ball_tone5": "basketball_player_tone5",
	"beach_with_umbrella": "beach",
	"umbrella_on_ground": "beach_umbrella",
	"bellhop_bell": "bellhop",
	"biohazard_sign": "biohazard",
	"archery": "bow_and_arrow",
	"boxing_gloves": "boxing_glove",
	"spiral_calendar_pad": "calendar_spiral",
	"call_me_hand": "call_me",
	"call_me_hand_tone1": "call_me_tone1",
	"call_me_hand_tone2": "call_me_tone2",
	"call_me_hand_tone3": "call_me_tone3",
	"call_me_hand_tone4": "call_me_tone4",
	"call_me_hand_tone5": "call_me_tone5",
	"kayak": "canoe",
	"card_file_box": "card_box",
	"person_doing_cartwheel": "cartwheel",
	"person_doing_cartwheel_tone1": "cartwheel_tone1",
	"person_doing_cartwheel_tone2": "cartwheel_tone2",
	"person_doing_cartwheel_tone3": "cartwheel_tone3",
	"person_doing_cartwheel_tone4": "cartwheel_tone4",
	"person_doing_cartwheel_tone5": "cartwheel_tone5",
	"bottle_with_popping_cork": "champagne",
	"clinking_glass": "champagne_glass",
	"cheese_wedge": "cheese",
	"city_sunrise": "city_sunset",
	"mantlepiece_clock": "clock",
	"cloud_with_lightning": "cloud_lightning",
	"cloud_with_rain": "cloud_rain",
	"cloud_with_snow": "cloud_snow",
	"cloud_with_tornado": "cloud_tornado",
	"clown_face": "clown",
	"building_construction": "construction_site",
	"couch_and_lamp": "couch",
	"couple_with_heart_mm": "couple_mm",
	"couple_with_heart_ww": "couple_ww",
	"face_with_cowboy_hat": "cowboy",
	"lower_left_crayon": "crayon",
	"cricket_bat_ball": "cricket",
	"latin_cross": "cross",
	"passenger_ship": "cruise_ship",
	"dagger_knife": "dagger",
	"desktop_computer": "desktop",
	"card_index_dividers": "dividers",
	"dove_of_peace": "dove",
	"drool": "drooling_face",
	"drum_with_drumsticks": "drum",
	"email": "e-mail",
	"eject_symbol": "eject",
	"facepalm": "face_palm",
	"facepalm_tone1": "face_palm_tone1",
	"facepalm_tone2": "face_palm_tone2",
	"facepalm_tone3": "face_palm_tone3",
	"facepalm_tone4": "face_palm_tone4",
	"facepalm_tone5": "face_palm_tone5",
	"fencing": "fencer",
	"hand_with_index_and_middle_finger_crossed": "fingers_crossed",
	"hand_with_index_and_middle_fingers_crossed_tone1": "fingers_crossed_tone1",
	"hand_with_index_and_middle_fingers_crossed_tone2": "fingers_crossed_tone2",
	"hand_with_index_and_middle_fingers_crossed_tone3": "fingers_crossed_tone3",
	"hand_with_index_and_middle_fingers_crossed_tone4": "fingers_crossed_tone4",
	"hand_with_index_and_middle_fingers_crossed_tone5": "fingers_crossed_tone5",
	"flame": "fire",
	"first_place_medal": "first_place",
	"ac": "flag_ac",
	"ad": "flag_ad",
	"ae": "flag_ae",
	"af": "flag_af",
	"ag": "flag_ag",
	"ai": "flag_ai",
	"al": "flag_al",
	"am": "flag_am",
	"ao": "flag_ao",
	"aq": "flag_aq",
	"ar": "flag_ar",
	"as": "flag_as",
	"at": "flag_at",
	"au": "flag_au",
	"aw": "flag_aw",
	"ax": "flag_ax",
	"az": "flag_az",
	"ba": "flag_ba",
	"bb": "flag_bb",
	"bd": "flag_bd",
	"be": "flag_be",
	"bf": "flag_bf",
	"bg": "flag_bg",
	"bh": "flag_bh",
	"bi": "flag_bi",
	"bj": "flag_bj",
	"bl": "flag_bl",
	"waving_black_flag": "flag_black",
	"bm": "flag_bm",
	"bn": "flag_bn",
	"bo": "flag_bo",
	"bq": "flag_bq",
	"br": "flag_br",
	"bs": "flag_bs",
	"bt": "flag_bt",
	"bv": "flag_bv",
	"bw": "flag_bw",
	"by": "flag_by",
	"bz": "flag_bz",
	"ca": "flag_ca",
	"cc": "flag_cc",
	"congo": "flag_cd",
	"cf": "flag_cf",
	"cg": "flag_cg",
	"ch": "flag_ch",
	"ci": "flag_ci",
	"ck": "flag_ck",
	"chile": "flag_cl",
	"cm": "flag_cm",
	"cn": "flag_cn",
	"co": "flag_co",
	"cp": "flag_cp",
	"cr": "flag_cr",
	"cu": "flag_cu",
	"cv": "flag_cv",
	"cw": "flag_cw",
	"cx": "flag_cx",
	"cy": "flag_cy",
	"cz": "flag_cz",
	"de": "flag_de",
	"dg": "flag_dg",
	"dj": "flag_dj",
	"dk": "flag_dk",
	"dm": "flag_dm",
	"do": "flag_do",
	"dz": "flag_dz",
	"ea": "flag_ea",
	"ec": "flag_ec",
	"ee": "flag_ee",
	"eg": "flag_eg",
	"eh": "flag_eh",
	"er": "flag_er",
	"es": "flag_es",
	"et": "flag_et",
	"eu": "flag_eu",
	"fi": "flag_fi",
	"fj": "flag_fj",
	"fk": "flag_fk",
	"fm": "flag_fm",
	"fo": "flag_fo",
	"fr": "flag_fr",
	"ga": "flag_ga",
	"gb": "flag_gb",
	"gd": "flag_gd",
	"ge": "flag_ge",
	"gf": "flag_gf",
	"gg": "flag_gg",
	"gh": "flag_gh",
	"gi": "flag_gi",
	"gl": "flag_gl",
	"gm": "flag_gm",
	"gn": "flag_gn",
	"gp": "flag_gp",
	"gq": "flag_gq",
	"gr": "flag_gr",
	"gs": "flag_gs",
	"gt": "flag_gt",
	"gu": "flag_gu",
	"gw": "flag_gw",
	"gy": "flag_gy",
	"hk": "flag_hk",
	"hm": "flag_hm",
	"hn": "flag_hn",
	"hr": "flag_hr",
	"ht": "flag_ht",
	"hu": "flag_hu",
	"ic": "flag_ic",
	"indonesia": "flag_id",
	"ie": "flag_ie",
	"il": "flag_il",
	"im": "flag_im",
	"in": "flag_in",
	"io": "flag_io",
	"iq": "flag_iq",
	"ir": "flag_ir",
	"is": "flag_is",
	"it": "flag_it",
	"je": "flag_je",
	"jm": "flag_jm",
	"jo": "flag_jo",
	"jp": "flag_jp",
	"ke": "flag_ke",
	"kg": "flag_kg",
	"kh": "flag_kh",
	"ki": "flag_ki",
	"km": "flag_km",
	"kn": "flag_kn",
	"kp": "flag_kp",
	"kr": "flag_kr",
	"kw": "flag_kw",
	"ky": "flag_ky",
	"kz": "flag_kz",
	"la": "flag_la",
	"lb": "flag_lb",
	"lc": "flag_lc",
	"li": "flag_li",
	"lk": "flag_lk",
	"lr": "flag_lr",
	"ls": "flag_ls",
	"lt": "flag_lt",
	"lu": "flag_lu",
	"lv": "flag_lv",
	"ly": "flag_ly",
	"ma": "flag_ma",
	"mc": "flag_mc",
	"md": "flag_md",
	"me": "flag_me",
	"mf": "flag_mf",
	"mg": "flag_mg",
	"mh": "flag_mh",
	"mk": "flag_mk",
	"ml": "flag_ml",
	"mm": "flag_mm",
	"mn": "flag_mn",
	"mo": "flag_mo",
	"mp": "flag_mp",
	"mq": "flag_mq",
	"mr": "flag_mr",
	"ms": "flag_ms",
	"mt": "flag_mt",
	"mu": "flag_mu",
	"mv": "flag_mv",
	"mw": "flag_mw",
	"mx": "flag_mx",
	"my": "flag_my",
	"mz": "flag_mz",
	"na": "flag_na",
	"nc": "flag_nc",
	"ne": "flag_ne",
	"nf": "flag_nf",
	"nigeria": "flag_ng",
	"ni": "flag_ni",
	"nl": "flag_nl",
	"no": "flag_no",
	"np": "flag_np",
	"nr": "flag_nr",
	"nu": "flag_nu",
	"nz": "flag_nz",
	"om": "flag_om",
	"pa": "flag_pa",
	"pe": "flag_pe",
	"pf": "flag_pf",
	"pg": "flag_pg",
	"ph": "flag_ph",
	"pk": "flag_pk",
	"pl": "flag_pl",
	"pm": "flag_pm",
	"pn": "flag_pn",
	"pr": "flag_pr",
	"ps": "flag_ps",
	"pt": "flag_pt",
	"pw": "flag_pw",
	"py": "flag_py",
	"qa": "flag_qa",
	"re": "flag_re",
	"ro": "flag_ro",
	"rs": "flag_rs",
	"ru": "flag_ru",
	"rw": "flag_rw",
	"saudiarabia": "flag_sa",
	"saudi": "flag_sa",
	"sb": "flag_sb",
	"sc": "flag_sc",
	"sd": "flag_sd",
	"se": "flag_se",
	"sg": "flag_sg",
	"sh": "flag_sh",
	"si": "flag_si",
	"sj": "flag_sj",
	"sk": "flag_sk",
	"sl": "flag_sl",
	"sm": "flag_sm",
	"sn": "flag_sn",
	"so": "flag_so",
	"sr": "flag_sr",
	"ss": "flag_ss",
	"st": "flag_st",
	"sv": "flag_sv",
	"sx": "flag_sx",
	"sy": "flag_sy",
	"sz": "flag_sz",
	"ta": "flag_ta",
	"tc": "flag_tc",
	"td": "flag_td",
	"tf": "flag_tf",
	"tg": "flag_tg",
	"th": "flag_th",
	"tj": "flag_tj",
	"tk": "flag_tk",
	"tl": "flag_tl",
	"turkmenistan": "flag_tm",
	"tn": "flag_tn",
	"to": "flag_to",
	"tr": "flag_tr",
	"tt": "flag_tt",
	"tuvalu": "flag_tv",
	"tw": "flag_tw",
	"tz": "flag_tz",
	"ua": "flag_ua",
	"ug": "flag_ug",
	"um": "flag_um",
	"us": "flag_us",
	"uy": "flag_uy",
	"uz": "flag_uz",
	"va": "flag_va",
	"vc": "flag_vc",
	"ve": "flag_ve",
	"vg": "flag_vg",
	"vi": "flag_vi",
	"vn": "flag_vn",
	"vu": "flag_vu",
	"wf": "flag_wf",
	"waving_white_flag": "flag_white",
	"ws": "flag_ws",
	"xk": "flag_xk",
	"ye": "flag_ye",
	"yt": "flag_yt",
	"za": "flag_za",
	"zm": "flag_zm",
	"zw": "flag_zw",
	"fork_and_knife_with_plate": "fork_knife_plate",
	"fox_face": "fox",
	"frame_with_picture": "frame_photo",
	"baguette_bread": "french_bread",
	"anguished": "frowning",
	"white_frowning_face": "frowning2",
	"goal_net": "goal",
	"hammer_and_pick": "hammer_pick",
	"raised_hand_with_fingers_splayed": "hand_splayed",
	"raised_hand_with_fingers_splayed_tone1": "hand_splayed_tone1",
	"raised_hand_with_fingers_splayed_tone2": "hand_splayed_tone2",
	"raised_hand_with_fingers_splayed_tone3": "hand_splayed_tone3",
	"raised_hand_with_fingers_splayed_tone4": "hand_splayed_tone4",
	"raised_hand_with_fingers_splayed_tone5": "hand_splayed_tone5",
	"shaking_hands": "handshake",
	"shaking_hands_tone1": "handshake_tone1",
	"shaking_hands_tone2": "handshake_tone2",
	"shaking_hands_tone3": "handshake_tone3",
	"shaking_hands_tone4": "handshake_tone4",
	"shaking_hands_tone5": "handshake_tone5",
	"face_with_head_bandage": "head_bandage",
	"heavy_heart_exclamation_mark_ornament": "heart_exclamation",
	"helmet_with_white_cross": "helmet_with_cross",
	"house_buildings": "homes",
	"hot_dog": "hotdog",
	"derelict_house_building": "house_abandoned",
	"hugging_face": "hugging",
	"desert_island": "island",
	"juggler": "juggling",
	"juggler_tone1": "juggling_tone1",
	"juggler_tone2": "juggling_tone2",
	"juggler_tone3": "juggling_tone3",
	"juggler_tone4": "juggling_tone4",
	"juggler_tone5": "juggling_tone5",
	"old_key": "key2",
	"couplekiss_mm": "kiss_mm",
	"couplekiss_ww": "kiss_ww",
	"kiwifruit": "kiwi",
	"satisfied": "laughing",
	"left_fist": "left_facing_fist",
	"left_fist_tone1": "left_facing_fist_tone1",
	"left_fist_tone2": "left_facing_fist_tone2",
	"left_fist_tone3": "left_facing_fist_tone3",
	"left_fist_tone4": "left_facing_fist_tone4",
	"left_fist_tone5": "left_facing_fist_tone5",
	"man_in_business_suit_levitating": "levitate",
	"weight_lifter": "lifter",
	"weight_lifter_tone1": "lifter_tone1",
	"weight_lifter_tone2": "lifter_tone2",
	"weight_lifter_tone3": "lifter_tone3",
	"weight_lifter_tone4": "lifter_tone4",
	"weight_lifter_tone5": "lifter_tone5",
	"lion": "lion_face",
	"liar": "lying_face",
	"male_dancer": "man_dancing",
	"male_dancer_tone1": "man_dancing_tone1",
	"male_dancer_tone2": "man_dancing_tone2",
	"male_dancer_tone3": "man_dancing_tone3",
	"male_dancer_tone4": "man_dancing_tone4",
	"male_dancer_tone5": "man_dancing_tone5",
	"tuxedo_tone1": "man_in_tuxedo_tone1",
	"tuxedo_tone2": "man_in_tuxedo_tone2",
	"tuxedo_tone3": "man_in_tuxedo_tone3",
	"tuxedo_tone4": "man_in_tuxedo_tone4",
	"tuxedo_tone5": "man_in_tuxedo_tone5",
	"world_map": "map",
	"karate_uniform": "martial_arts_uniform",
	"sports_medal": "medal",
	"sign_of_the_horns": "metal",
	"sign_of_the_horns_tone1": "metal_tone1",
	"sign_of_the_horns_tone2": "metal_tone2",
	"sign_of_the_horns_tone3": "metal_tone3",
	"sign_of_the_horns_tone4": "metal_tone4",
	"sign_of_the_horns_tone5": "metal_tone5",
	"studio_microphone": "microphone2",
	"reversed_hand_with_middle_finger_extended": "middle_finger",
	"reversed_hand_with_middle_finger_extended_tone1": "middle_finger_tone1",
	"reversed_hand_with_middle_finger_extended_tone2": "middle_finger_tone2",
	"reversed_hand_with_middle_finger_extended_tone3": "middle_finger_tone3",
	"reversed_hand_with_middle_finger_extended_tone4": "middle_finger_tone4",
	"reversed_hand_with_middle_finger_extended_tone5": "middle_finger_tone5",
	"glass_of_milk": "milk",
	"money_mouth_face": "money_mouth",
	"motorbike": "motor_scooter",
	"racing_motorcycle": "motorcycle",
	"snow_capped_mountain": "mountain_snow",
	"three_button_mouse": "mouse_three_button",
	"mother_christmas": "mrs_claus",
	"mother_christmas_tone1": "mrs_claus_tone1",
	"mother_christmas_tone2": "mrs_claus_tone2",
	"mother_christmas_tone3": "mrs_claus_tone3",
	"mother_christmas_tone4": "mrs_claus_tone4",
	"mother_christmas_tone5": "mrs_claus_tone5",
	"sick": "nauseated_face",
	"nerd_face": "nerd",
	"rolled_up_newspaper": "newspaper2",
	"spiral_note_pad": "notepad_spiral",
	"stop_sign": "octagonal_sign",
	"oil_drum": "oil",
	"grandma": "older_woman",
	"grandma_tone1": "older_woman_tone1",
	"grandma_tone2": "older_woman_tone2",
	"grandma_tone3": "older_woman_tone3",
	"grandma_tone4": "older_woman_tone4",
	"grandma_tone5": "older_woman_tone5",
	"lower_left_paintbrush": "paintbrush",
	"linked_paperclips": "paperclips",
	"national_park": "park",
	"double_vertical_bar": "pause_button",
	"peace_symbol": "peace",
	"shelled_peanut": "peanuts",
	"lower_left_ballpoint_pen": "pen_ballpoint",
	"lower_left_fountain_pen": "pen_fountain",
	"memo": "pencil",
	"table_tennis": "ping_pong",
	"worship_symbol": "place_of_worship",
	"shit": "poop",
	"hankey": "poop",
	"poo": "poop",
	"expecting_woman": "pregnant_woman",
	"expecting_woman_tone1": "pregnant_woman_tone1",
	"expecting_woman_tone2": "pregnant_woman_tone2",
	"expecting_woman_tone3": "pregnant_woman_tone3",
	"expecting_woman_tone4": "pregnant_woman_tone4",
	"expecting_woman_tone5": "pregnant_woman_tone5",
	"film_projector": "projector",
	"racing_car": "race_car",
	"radioactive_sign": "radioactive",
	"railroad_track": "railway_track",
	"back_of_hand": "raised_back_of_hand",
	"back_of_hand_tone1": "raised_back_of_hand_tone1",
	"back_of_hand_tone2": "raised_back_of_hand_tone2",
	"back_of_hand_tone3": "raised_back_of_hand_tone3",
	"back_of_hand_tone4": "raised_back_of_hand_tone4",
	"back_of_hand_tone5": "raised_back_of_hand_tone5",
	"rhinoceros": "rhino",
	"right_fist": "right_facing_fist",
	"right_fist_tone1": "right_facing_fist_tone1",
	"right_fist_tone2": "right_facing_fist_tone2",
	"right_fist_tone3": "right_facing_fist_tone3",
	"right_fist_tone4": "right_facing_fist_tone4",
	"right_fist_tone5": "right_facing_fist_tone5",
	"robot_face": "robot",
	"rolling_on_the_floor_laughing": "rofl",
	"face_with_rolling_eyes": "rolling_eyes",
	"green_salad": "salad",
	"second_place_medal": "second_place",
	"paella": "shallow_pan_of_food",
	"shopping_trolley": "shopping_cart",
	"skeleton": "skull",
	"skull_and_crossbones": "skull_crossbones",
	"slightly_frowning_face": "slight_frown",
	"slightly_smiling_face": "slight_smile",
	"sneeze": "sneezing_face",
	"speaking_head_in_silhouette": "speaking_head",
	"sleuth_or_spy": "spy",
	"sleuth_or_spy_tone1": "spy_tone1",
	"sleuth_or_spy_tone2": "spy_tone2",
	"sleuth_or_spy_tone3": "spy_tone3",
	"sleuth_or_spy_tone4": "spy_tone4",
	"sleuth_or_spy_tone5": "spy_tone5",
	"stuffed_pita": "stuffed_flatbread",
	"face_with_thermometer": "thermometer_face",
	"thinking_face": "thinking",
	"third_place_medal": "third_place",
	"-1": "thumbsdown",
	"-1_tone1": "thumbsdown_tone1",
	"-1_tone2": "thumbsdown_tone2",
	"-1_tone3": "thumbsdown_tone3",
	"-1_tone4": "thumbsdown_tone4",
	"-1_tone5": "thumbsdown_tone5",
	"+1": "thumbsup",
	"+1_tone1": "thumbsup_tone1",
	"+1_tone2": "thumbsup_tone2",
	"+1_tone3": "thumbsup_tone3",
	"+1_tone4": "thumbsup_tone4",
	"+1_tone5": "thumbsup_tone5",
	"thunder_cloud_and_rain": "thunder_cloud_rain",
	"admission_tickets": "tickets",
	"timer_clock": "timer",
	"hammer_and_wrench": "tools",
	"next_track": "track_next",
	"previous_track": "track_previous",
	"whisky": "tumbler_glass",
	"unicorn_face": "unicorn",
	"upside_down_face": "upside_down",
	"funeral_urn": "urn",
	"raised_hand_with_part_between_middle_and_ring_fingers": "vulcan",
	"raised_hand_with_part_between_middle_and_ring_fingers_tone1": "vulcan_tone1",
	"raised_hand_with_part_between_middle_and_ring_fingers_tone2": "vulcan_tone2",
	"raised_hand_with_part_between_middle_and_ring_fingers_tone3": "vulcan_tone3",
	"raised_hand_with_part_between_middle_and_ring_fingers_tone4": "vulcan_tone4",
	"raised_hand_with_part_between_middle_and_ring_fingers_tone5": "vulcan_tone5",
	"white_sun_behind_cloud": "white_sun_cloud",
	"white_sun_behind_cloud_with_rain": "white_sun_rain_cloud",
	"white_sun_with_small_cloud": "white_sun_small_cloud",
	"wilted_flower": "wilted_rose",
	"wrestling": "wrestlers",
	"wrestling_tone1": "wrestlers_tone1",
	"wrestling_tone2": "wrestlers_tone2",
	"wrestling_tone3": "wrestlers_tone3",
	"wrestling_tone4": "wrestlers_tone4",
	"wrestling_tone5": "wrestlers_tone5",
	"zipper_mouth_face": "zipper_mouth"
};

/***/ }),

/***/ "pJ4l":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable class-methods-use-this */
var SELECT_ITEM_MSG = 'Select';

var TargetBranchDropDown = function () {
  function TargetBranchDropDown(dropdown) {
    _classCallCheck(this, TargetBranchDropDown);

    this.dropdown = dropdown;
    this.$dropdown = $(dropdown);
    this.fieldName = this.dropdown.getAttribute('data-field-name');
    this.form = this.dropdown.closest('form');
    this.createDropdown();
  }

  _createClass(TargetBranchDropDown, [{
    key: 'createDropdown',
    value: function createDropdown() {
      var self = this;
      this.$dropdown.glDropdown({
        selectable: true,
        filterable: true,
        search: {
          fields: ['title']
        },
        data: function data(term, callback) {
          return $.ajax({
            url: self.dropdown.getAttribute('data-refs-url'),
            data: {
              ref: self.dropdown.getAttribute('data-ref'),
              show_all: true
            },
            dataType: 'json'
          }).done(function (refs) {
            return callback(self.dropdownData(refs));
          });
        },
        toggleLabel: function toggleLabel(item, el) {
          if (el.is('.is-active')) {
            return item.text;
          }
          return SELECT_ITEM_MSG;
        },
        clicked: function clicked(item, el, e) {
          e.preventDefault();
          self.onClick.call(self);
        },

        fieldName: self.fieldName
      });
      return new gl.CreateBranchDropdown(this.form.querySelector('.dropdown-new-branch'), this);
    }
  }, {
    key: 'onClick',
    value: function onClick() {
      this.enableSubmit();
      this.$dropdown.trigger('change.branch');
    }
  }, {
    key: 'enableSubmit',
    value: function enableSubmit() {
      var submitBtn = this.form.querySelector('[type="submit"]');
      if (this.branchInput && this.branchInput.value) {
        submitBtn.removeAttribute('disabled');
      } else {
        submitBtn.setAttribute('disabled', '');
      }
    }
  }, {
    key: 'dropdownData',
    value: function dropdownData(refs) {
      var branchList = this.dropdownItems(refs);
      this.cachedRefs = refs;
      this.addDefaultBranch(branchList);
      this.addNewBranch(branchList);
      return { Branches: branchList };
    }
  }, {
    key: 'dropdownItems',
    value: function dropdownItems(refs) {
      return refs.map(this.dropdownItem);
    }
  }, {
    key: 'dropdownItem',
    value: function dropdownItem(ref) {
      return { id: ref, text: ref, title: ref };
    }
  }, {
    key: 'addDefaultBranch',
    value: function addDefaultBranch(branchList) {
      // when no branch is selected do nothing
      if (!this.branchInput) {
        return;
      }

      var branchInputVal = this.branchInput.value;
      var currentBranchIndex = this.searchBranch(branchList, branchInputVal);

      if (currentBranchIndex === -1) {
        this.unshiftBranch(branchList, this.dropdownItem(branchInputVal));
      }
    }
  }, {
    key: 'addNewBranch',
    value: function addNewBranch(branchList) {
      if (this.newBranch) {
        this.unshiftBranch(branchList, this.newBranch);
      }
    }
  }, {
    key: 'searchBranch',
    value: function searchBranch(branchList, branchName) {
      return _.findIndex(branchList, function (el) {
        return branchName === el.id;
      });
    }
  }, {
    key: 'unshiftBranch',
    value: function unshiftBranch(branchList, branch) {
      var branchIndex = this.searchBranch(branchList, branch.id);

      if (branchIndex === -1) {
        branchList.unshift(branch);
      }
    }
  }, {
    key: 'setNewBranch',
    value: function setNewBranch(newBranchName) {
      this.newBranch = this.dropdownItem(newBranchName);
      this.refreshData();
      this.selectBranch(this.searchBranch(this.glDropdown.fullData.Branches, newBranchName));
    }
  }, {
    key: 'refreshData',
    value: function refreshData() {
      this.glDropdown.fullData = this.dropdownData(this.cachedRefs);
      this.clearFilter();
    }
  }, {
    key: 'clearFilter',
    value: function clearFilter() {
      // apply an empty filter in order to refresh the data
      this.glDropdown.filter.filter('');
      this.dropdown.closest('.dropdown').querySelector('.dropdown-page-one .dropdown-input-field').value = '';
    }
  }, {
    key: 'selectBranch',
    value: function selectBranch(index) {
      var branch = this.dropdown.closest('.dropdown').querySelectorAll('li a')[index];

      if (!branch.classList.contains('is-active')) {
        branch.click();
      } else {
        this.closeDropdown();
      }
    }
  }, {
    key: 'closeDropdown',
    value: function closeDropdown() {
      this.dropdown.closest('.dropdown').querySelector('.dropdown-menu-close').click();
    }
  }, {
    key: 'branchInput',
    get: function get() {
      return this.form.querySelector('input[name="' + this.fieldName + '"]');
    }
  }, {
    key: 'glDropdown',
    get: function get() {
      return this.$dropdown.data('glDropdown');
    }
  }], [{
    key: 'bootstrap',
    value: function bootstrap() {
      var dropdowns = document.querySelectorAll('.js-project-branches-dropdown');
      [].forEach.call(dropdowns, function (dropdown) {
        return new TargetBranchDropDown(dropdown);
      });
    }
  }]);

  return TargetBranchDropDown;
}();

window.gl = window.gl || {};
gl.TargetBranchDropDown = TargetBranchDropDown;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "pRPh":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, wrap-iife, no-var, no-param-reassign, no-cond-assign, comma-dangle, no-unused-expressions, prefer-template, max-len */
/* global timeago */
/* global dateFormat */

window.timeago = __webpack_require__("j4Jp");
window.dateFormat = __webpack_require__("iHtO");

(function () {
  (function (w) {
    var base;
    var timeagoInstance;

    if (w.gl == null) {
      w.gl = {};
    }
    if ((base = w.gl).utils == null) {
      base.utils = {};
    }
    w.gl.utils.days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

    w.gl.utils.formatDate = function (datetime) {
      return dateFormat(datetime, 'mmm d, yyyy h:MMtt Z');
    };

    w.gl.utils.getDayName = function (date) {
      return this.days[date.getDay()];
    };

    w.gl.utils.localTimeAgo = function ($timeagoEls) {
      var setTimeago = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      $timeagoEls.each(function (i, el) {
        el.setAttribute('title', gl.utils.formatDate(el.getAttribute('datetime')));

        if (setTimeago) {
          // Recreate with custom template
          $(el).tooltip({
            template: '<div class="tooltip local-timeago" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>'
          });
        }

        el.classList.add('js-timeago-render');
      });

      gl.utils.renderTimeago($timeagoEls);
    };

    w.gl.utils.getTimeago = function () {
      var locale;

      if (!timeagoInstance) {
        locale = function locale(number, index) {
          return [['less than a minute ago', 'a while'], ['less than a minute ago', 'in %s seconds'], ['about a minute ago', 'in 1 minute'], ['%s minutes ago', 'in %s minutes'], ['about an hour ago', 'in 1 hour'], ['about %s hours ago', 'in %s hours'], ['a day ago', 'in 1 day'], ['%s days ago', 'in %s days'], ['a week ago', 'in 1 week'], ['%s weeks ago', 'in %s weeks'], ['a month ago', 'in 1 month'], ['%s months ago', 'in %s months'], ['a year ago', 'in 1 year'], ['%s years ago', 'in %s years']][index];
        };

        timeago.register('gl_en', locale);
        timeagoInstance = timeago();
      }

      return timeagoInstance;
    };

    w.gl.utils.timeFor = function (time, suffix, expiredLabel) {
      var timefor;
      if (!time) {
        return '';
      }
      suffix || (suffix = 'remaining');
      expiredLabel || (expiredLabel = 'Past due');
      timefor = gl.utils.getTimeago().format(time).replace('in', '');
      if (timefor.indexOf('ago') > -1) {
        timefor = expiredLabel;
      } else {
        timefor = timefor.trim() + ' ' + suffix;
      }
      return timefor;
    };

    w.gl.utils.cachedTimeagoElements = [];
    w.gl.utils.renderTimeago = function ($els) {
      if (!$els && !w.gl.utils.cachedTimeagoElements.length) {
        w.gl.utils.cachedTimeagoElements = [].slice.call(document.querySelectorAll('.js-timeago-render'));
      } else if ($els) {
        w.gl.utils.cachedTimeagoElements = w.gl.utils.cachedTimeagoElements.concat($els.toArray());
      }

      w.gl.utils.cachedTimeagoElements.forEach(gl.utils.updateTimeagoText);
    };

    w.gl.utils.updateTimeagoText = function (el) {
      var timeago = gl.utils.getTimeago();
      var formattedDate = timeago.format(el.getAttribute('datetime'), 'gl_en');

      if (el.textContent !== formattedDate) {
        el.textContent = formattedDate;
      }
    };

    w.gl.utils.initTimeagoTimeout = function () {
      gl.utils.renderTimeago();

      gl.utils.timeagoTimeout = setTimeout(gl.utils.initTimeagoTimeout, 1000);
    };

    w.gl.utils.getDayDifference = function (a, b) {
      var millisecondsPerDay = 1000 * 60 * 60 * 24;
      var date1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
      var date2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

      return Math.floor((date2 - date1) / millisecondsPerDay);
    };
  })(window);
}).call(window);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "pVjb":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, wrap-iife, no-var, no-new, max-len */
/* global GitLab */
/* global DropzoneInput */
/* global autosize */

window.gl = window.gl || {};

function GLForm(form) {
  this.form = form;
  this.textarea = this.form.find('textarea.js-gfm-input');
  // Before we start, we should clean up any previous data for this form
  this.destroy();
  // Setup the form
  this.setupForm();
  this.form.data('gl-form', this);
}

GLForm.prototype.destroy = function () {
  // Clean form listeners
  this.clearEventListeners();
  return this.form.data('gl-form', null);
};

GLForm.prototype.setupForm = function () {
  var isNewForm;
  isNewForm = this.form.is(':not(.gfm-form)');
  this.form.removeClass('js-new-note-form');
  if (isNewForm) {
    this.form.find('.div-dropzone').remove();
    this.form.addClass('gfm-form');
    // remove notify commit author checkbox for non-commit notes
    gl.utils.disableButtonIfEmptyField(this.form.find('.js-note-text'), this.form.find('.js-comment-button, .js-note-new-discussion'));

    gl.GfmAutoComplete.setup(this.form.find('.js-gfm-input'));
    new DropzoneInput(this.form);
    autosize(this.textarea);
    // form and textarea event listeners
    this.addEventListeners();
  }
  gl.text.init(this.form);
  // hide discard button
  this.form.find('.js-note-discard').hide();
  this.form.show();
  if (this.isAutosizeable) this.setupAutosize();
};

GLForm.prototype.setupAutosize = function () {
  var _this = this;

  this.textarea.off('autosize:resized').on('autosize:resized', this.setHeightData.bind(this));

  this.textarea.off('mouseup.autosize').on('mouseup.autosize', this.destroyAutosize.bind(this));

  setTimeout(function () {
    autosize(_this.textarea);
    _this.textarea.css('resize', 'vertical');
  }, 0);
};

GLForm.prototype.setHeightData = function () {
  this.textarea.data('height', this.textarea.outerHeight());
};

GLForm.prototype.destroyAutosize = function () {
  var outerHeight = this.textarea.outerHeight();

  if (this.textarea.data('height') === outerHeight) return;

  autosize.destroy(this.textarea);

  this.textarea.data('height', outerHeight);
  this.textarea.outerHeight(outerHeight);
  this.textarea.css('max-height', window.outerHeight);
};

GLForm.prototype.clearEventListeners = function () {
  this.textarea.off('focus');
  this.textarea.off('blur');
  return gl.text.removeListeners(this.form);
};

GLForm.prototype.addEventListeners = function () {
  this.textarea.on('focus', function () {
    return $(this).closest('.md-area').addClass('is-focused');
  });
  return this.textarea.on('blur', function () {
    return $(this).closest('.md-area').removeClass('is-focused');
  });
};

window.gl.GLForm = GLForm;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "pynW":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, consistent-return, no-var, no-else-return, prefer-arrow-callback, max-len, no-console */
/* global katex */

// Renders math using KaTeX in any element with the
// `js-render-math` class
//
// ### Example Markup
//
//   <code class="js-render-math"></div>
//
(function () {
  // Only load once
  var katexLoaded = false;

  // Loop over all math elements and render math
  var renderWithKaTeX = function renderWithKaTeX(elements) {
    elements.each(function () {
      var mathNode = $('<span></span>');
      var $this = $(this);

      var display = $this.attr('data-math-style') === 'display';
      try {
        katex.render($this.text(), mathNode.get(0), { displayMode: display });
        mathNode.insertAfter($this);
        $this.remove();
      } catch (err) {
        // What can we do??
        console.log(err.message);
      }
    });
  };

  $.fn.renderMath = function () {
    var $this = this;
    if ($this.length === 0) return;

    if (katexLoaded) renderWithKaTeX($this);else {
      // Request CSS file so it is in the cache
      $.get(gon.katex_css_url, function () {
        var css = $('<link>', { rel: 'stylesheet',
          type: 'text/css',
          href: gon.katex_css_url
        });
        css.appendTo('head');

        // Load KaTeX js
        $.getScript(gon.katex_js_url, function () {
          katexLoaded = true;
          renderWithKaTeX($this); // Run KaTeX
        });
      });
    }
  };
}).call(window);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "qmzy":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**!
 * Sortable
 * @author	RubaXa   <trash@rubaxa.org>
 * @license MIT
 */

(function sortableModule(factory) {
	"use strict";

	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	else if (typeof module != "undefined" && typeof module.exports != "undefined") {
		module.exports = factory();
	}
	else if (typeof Package !== "undefined") {
		//noinspection JSUnresolvedVariable
		Sortable = factory();  // export for Meteor.js
	}
	else {
		/* jshint sub:true */
		window["Sortable"] = factory();
	}
})(function sortableFactory() {
	"use strict";

	if (typeof window == "undefined" || !window.document) {
		return function sortableError() {
			throw new Error("Sortable.js requires a window with a document");
		};
	}

	var dragEl,
		parentEl,
		ghostEl,
		cloneEl,
		rootEl,
		nextEl,

		scrollEl,
		scrollParentEl,
		scrollCustomFn,

		lastEl,
		lastCSS,
		lastParentCSS,

		oldIndex,
		newIndex,

		activeGroup,
		putSortable,

		autoScroll = {},

		tapEvt,
		touchEvt,

		moved,

		/** @const */
		RSPACE = /\s+/g,

		expando = 'Sortable' + (new Date).getTime(),

		win = window,
		document = win.document,
		parseInt = win.parseInt,

		$ = win.jQuery || win.Zepto,
		Polymer = win.Polymer,

		supportDraggable = !!('draggable' in document.createElement('div')),
		supportCssPointerEvents = (function (el) {
			// false when IE11
			if (!!navigator.userAgent.match(/Trident.*rv[ :]?11\./)) {
				return false;
			}
			el = document.createElement('x');
			el.style.cssText = 'pointer-events:auto';
			return el.style.pointerEvents === 'auto';
		})(),

		_silent = false,

		abs = Math.abs,
		min = Math.min,
		slice = [].slice,

		touchDragOverListeners = [],

		_autoScroll = _throttle(function (/**Event*/evt, /**Object*/options, /**HTMLElement*/rootEl) {
			// Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=505521
			if (rootEl && options.scroll) {
				var el,
					rect,
					sens = options.scrollSensitivity,
					speed = options.scrollSpeed,

					x = evt.clientX,
					y = evt.clientY,

					winWidth = window.innerWidth,
					winHeight = window.innerHeight,

					vx,
					vy,

					scrollOffsetX,
					scrollOffsetY
				;

				// Delect scrollEl
				if (scrollParentEl !== rootEl) {
					scrollEl = options.scroll;
					scrollParentEl = rootEl;
					scrollCustomFn = options.scrollFn;

					if (scrollEl === true) {
						scrollEl = rootEl;

						do {
							if ((scrollEl.offsetWidth < scrollEl.scrollWidth) ||
								(scrollEl.offsetHeight < scrollEl.scrollHeight)
							) {
								break;
							}
							/* jshint boss:true */
						} while (scrollEl = scrollEl.parentNode);
					}
				}

				if (scrollEl) {
					el = scrollEl;
					rect = scrollEl.getBoundingClientRect();
					vx = (abs(rect.right - x) <= sens) - (abs(rect.left - x) <= sens);
					vy = (abs(rect.bottom - y) <= sens) - (abs(rect.top - y) <= sens);
				}


				if (!(vx || vy)) {
					vx = (winWidth - x <= sens) - (x <= sens);
					vy = (winHeight - y <= sens) - (y <= sens);

					/* jshint expr:true */
					(vx || vy) && (el = win);
				}


				if (autoScroll.vx !== vx || autoScroll.vy !== vy || autoScroll.el !== el) {
					autoScroll.el = el;
					autoScroll.vx = vx;
					autoScroll.vy = vy;

					clearInterval(autoScroll.pid);

					if (el) {
						autoScroll.pid = setInterval(function () {
							scrollOffsetY = vy ? vy * speed : 0;
							scrollOffsetX = vx ? vx * speed : 0;

							if ('function' === typeof(scrollCustomFn)) {
								return scrollCustomFn.call(_this, scrollOffsetX, scrollOffsetY, evt);
							}

							if (el === win) {
								win.scrollTo(win.pageXOffset + scrollOffsetX, win.pageYOffset + scrollOffsetY);
							} else {
								el.scrollTop += scrollOffsetY;
								el.scrollLeft += scrollOffsetX;
							}
						}, 24);
					}
				}
			}
		}, 30),

		_prepareGroup = function (options) {
			function toFn(value, pull) {
				if (value === void 0 || value === true) {
					value = group.name;
				}

				if (typeof value === 'function') {
					return value;
				} else {
					return function (to, from) {
						var fromGroup = from.options.group.name;

						return pull
							? value
							: value && (value.join
								? value.indexOf(fromGroup) > -1
								: (fromGroup == value)
							);
					};
				}
			}

			var group = {};
			var originalGroup = options.group;

			if (!originalGroup || typeof originalGroup != 'object') {
				originalGroup = {name: originalGroup};
			}

			group.name = originalGroup.name;
			group.checkPull = toFn(originalGroup.pull, true);
			group.checkPut = toFn(originalGroup.put);

			options.group = group;
		}
	;



	/**
	 * @class  Sortable
	 * @param  {HTMLElement}  el
	 * @param  {Object}       [options]
	 */
	function Sortable(el, options) {
		if (!(el && el.nodeType && el.nodeType === 1)) {
			throw 'Sortable: `el` must be HTMLElement, and not ' + {}.toString.call(el);
		}

		this.el = el; // root element
		this.options = options = _extend({}, options);


		// Export instance
		el[expando] = this;


		// Default options
		var defaults = {
			group: Math.random(),
			sort: true,
			disabled: false,
			store: null,
			handle: null,
			scroll: true,
			scrollSensitivity: 30,
			scrollSpeed: 10,
			draggable: /[uo]l/i.test(el.nodeName) ? 'li' : '>*',
			ghostClass: 'sortable-ghost',
			chosenClass: 'sortable-chosen',
			dragClass: 'sortable-drag',
			ignore: 'a, img',
			filter: null,
			animation: 0,
			setData: function (dataTransfer, dragEl) {
				dataTransfer.setData('Text', dragEl.textContent);
			},
			dropBubble: false,
			dragoverBubble: false,
			dataIdAttr: 'data-id',
			delay: 0,
			forceFallback: false,
			fallbackClass: 'sortable-fallback',
			fallbackOnBody: false,
			fallbackTolerance: 0,
			fallbackOffset: {x: 0, y: 0}
		};


		// Set default options
		for (var name in defaults) {
			!(name in options) && (options[name] = defaults[name]);
		}

		_prepareGroup(options);

		// Bind all private methods
		for (var fn in this) {
			if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
				this[fn] = this[fn].bind(this);
			}
		}

		// Setup drag mode
		this.nativeDraggable = options.forceFallback ? false : supportDraggable;

		// Bind events
		_on(el, 'mousedown', this._onTapStart);
		_on(el, 'touchstart', this._onTapStart);

		if (this.nativeDraggable) {
			_on(el, 'dragover', this);
			_on(el, 'dragenter', this);
		}

		touchDragOverListeners.push(this._onDragOver);

		// Restore sorting
		options.store && this.sort(options.store.get(this));
	}


	Sortable.prototype = /** @lends Sortable.prototype */ {
		constructor: Sortable,

		_onTapStart: function (/** Event|TouchEvent */evt) {
			var _this = this,
				el = this.el,
				options = this.options,
				type = evt.type,
				touch = evt.touches && evt.touches[0],
				target = (touch || evt).target,
				originalTarget = evt.target.shadowRoot && evt.path[0] || target,
				filter = options.filter,
				startIndex;

			// Don't trigger start event when an element is been dragged, otherwise the evt.oldindex always wrong when set option.group.
			if (dragEl) {
				return;
			}

			if (type === 'mousedown' && evt.button !== 0 || options.disabled) {
				return; // only left button or enabled
			}

			if (options.handle && !_closest(originalTarget, options.handle, el)) {
				return;
			}

			target = _closest(target, options.draggable, el);

			if (!target) {
				return;
			}

			// Get the index of the dragged element within its parent
			startIndex = _index(target, options.draggable);

			// Check filter
			if (typeof filter === 'function') {
				if (filter.call(this, evt, target, this)) {
					_dispatchEvent(_this, originalTarget, 'filter', target, el, startIndex);
					evt.preventDefault();
					return; // cancel dnd
				}
			}
			else if (filter) {
				filter = filter.split(',').some(function (criteria) {
					criteria = _closest(originalTarget, criteria.trim(), el);

					if (criteria) {
						_dispatchEvent(_this, criteria, 'filter', target, el, startIndex);
						return true;
					}
				});

				if (filter) {
					evt.preventDefault();
					return; // cancel dnd
				}
			}

			// Prepare `dragstart`
			this._prepareDragStart(evt, touch, target, startIndex);
		},

		_prepareDragStart: function (/** Event */evt, /** Touch */touch, /** HTMLElement */target, /** Number */startIndex) {
			var _this = this,
				el = _this.el,
				options = _this.options,
				ownerDocument = el.ownerDocument,
				dragStartFn;

			if (target && !dragEl && (target.parentNode === el)) {
				tapEvt = evt;

				rootEl = el;
				dragEl = target;
				parentEl = dragEl.parentNode;
				nextEl = dragEl.nextSibling;
				activeGroup = options.group;
				oldIndex = startIndex;

				this._lastX = (touch || evt).clientX;
				this._lastY = (touch || evt).clientY;

				dragEl.style['will-change'] = 'transform';

				dragStartFn = function () {
					// Delayed drag has been triggered
					// we can re-enable the events: touchmove/mousemove
					_this._disableDelayedDrag();

					// Make the element draggable
					dragEl.draggable = _this.nativeDraggable;

					// Chosen item
					_toggleClass(dragEl, options.chosenClass, true);

					// Bind the events: dragstart/dragend
					_this._triggerDragStart(touch);

					// Drag start event
					_dispatchEvent(_this, rootEl, 'choose', dragEl, rootEl, oldIndex);
				};

				// Disable "draggable"
				options.ignore.split(',').forEach(function (criteria) {
					_find(dragEl, criteria.trim(), _disableDraggable);
				});

				_on(ownerDocument, 'mouseup', _this._onDrop);
				_on(ownerDocument, 'touchend', _this._onDrop);
				_on(ownerDocument, 'touchcancel', _this._onDrop);

				if (options.delay) {
					// If the user moves the pointer or let go the click or touch
					// before the delay has been reached:
					// disable the delayed drag
					_on(ownerDocument, 'mouseup', _this._disableDelayedDrag);
					_on(ownerDocument, 'touchend', _this._disableDelayedDrag);
					_on(ownerDocument, 'touchcancel', _this._disableDelayedDrag);
					_on(ownerDocument, 'mousemove', _this._disableDelayedDrag);
					_on(ownerDocument, 'touchmove', _this._disableDelayedDrag);

					_this._dragStartTimer = setTimeout(dragStartFn, options.delay);
				} else {
					dragStartFn();
				}
			}
		},

		_disableDelayedDrag: function () {
			var ownerDocument = this.el.ownerDocument;

			clearTimeout(this._dragStartTimer);
			_off(ownerDocument, 'mouseup', this._disableDelayedDrag);
			_off(ownerDocument, 'touchend', this._disableDelayedDrag);
			_off(ownerDocument, 'touchcancel', this._disableDelayedDrag);
			_off(ownerDocument, 'mousemove', this._disableDelayedDrag);
			_off(ownerDocument, 'touchmove', this._disableDelayedDrag);
		},

		_triggerDragStart: function (/** Touch */touch) {
			if (touch) {
				// Touch device support
				tapEvt = {
					target: dragEl,
					clientX: touch.clientX,
					clientY: touch.clientY
				};

				this._onDragStart(tapEvt, 'touch');
			}
			else if (!this.nativeDraggable) {
				this._onDragStart(tapEvt, true);
			}
			else {
				_on(dragEl, 'dragend', this);
				_on(rootEl, 'dragstart', this._onDragStart);
			}

			try {
				if (document.selection) {
					// Timeout neccessary for IE9
					setTimeout(function () {
						document.selection.empty();
					});
				} else {
					window.getSelection().removeAllRanges();
				}
			} catch (err) {
			}
		},

		_dragStarted: function () {
			if (rootEl && dragEl) {
				var options = this.options;

				// Apply effect
				_toggleClass(dragEl, options.ghostClass, true);
				_toggleClass(dragEl, options.dragClass, false);

				Sortable.active = this;

				// Drag start event
				_dispatchEvent(this, rootEl, 'start', dragEl, rootEl, oldIndex);
			}
		},

		_emulateDragOver: function () {
			if (touchEvt) {
				if (this._lastX === touchEvt.clientX && this._lastY === touchEvt.clientY) {
					return;
				}

				this._lastX = touchEvt.clientX;
				this._lastY = touchEvt.clientY;

				if (!supportCssPointerEvents) {
					_css(ghostEl, 'display', 'none');
				}

				var target = document.elementFromPoint(touchEvt.clientX, touchEvt.clientY),
					parent = target,
					i = touchDragOverListeners.length;

				if (parent) {
					do {
						if (parent[expando]) {
							while (i--) {
								touchDragOverListeners[i]({
									clientX: touchEvt.clientX,
									clientY: touchEvt.clientY,
									target: target,
									rootEl: parent
								});
							}

							break;
						}

						target = parent; // store last element
					}
					/* jshint boss:true */
					while (parent = parent.parentNode);
				}

				if (!supportCssPointerEvents) {
					_css(ghostEl, 'display', '');
				}
			}
		},


		_onTouchMove: function (/**TouchEvent*/evt) {
			if (tapEvt) {
				var	options = this.options,
					fallbackTolerance = options.fallbackTolerance,
					fallbackOffset = options.fallbackOffset,
					touch = evt.touches ? evt.touches[0] : evt,
					dx = (touch.clientX - tapEvt.clientX) + fallbackOffset.x,
					dy = (touch.clientY - tapEvt.clientY) + fallbackOffset.y,
					translate3d = evt.touches ? 'translate3d(' + dx + 'px,' + dy + 'px,0)' : 'translate(' + dx + 'px,' + dy + 'px)';

				// only set the status to dragging, when we are actually dragging
				if (!Sortable.active) {
					if (fallbackTolerance &&
						min(abs(touch.clientX - this._lastX), abs(touch.clientY - this._lastY)) < fallbackTolerance
					) {
						return;
					}

					this._dragStarted();
				}

				// as well as creating the ghost element on the document body
				this._appendGhost();

				moved = true;
				touchEvt = touch;

				_css(ghostEl, 'webkitTransform', translate3d);
				_css(ghostEl, 'mozTransform', translate3d);
				_css(ghostEl, 'msTransform', translate3d);
				_css(ghostEl, 'transform', translate3d);

				evt.preventDefault();
			}
		},

		_appendGhost: function () {
			if (!ghostEl) {
				var rect = dragEl.getBoundingClientRect(),
					css = _css(dragEl),
					options = this.options,
					ghostRect;

				ghostEl = dragEl.cloneNode(true);

				_toggleClass(ghostEl, options.ghostClass, false);
				_toggleClass(ghostEl, options.fallbackClass, true);
				_toggleClass(ghostEl, options.dragClass, true);

				_css(ghostEl, 'top', rect.top - parseInt(css.marginTop, 10));
				_css(ghostEl, 'left', rect.left - parseInt(css.marginLeft, 10));
				_css(ghostEl, 'width', rect.width);
				_css(ghostEl, 'height', rect.height);
				_css(ghostEl, 'opacity', '0.8');
				_css(ghostEl, 'position', 'fixed');
				_css(ghostEl, 'zIndex', '100000');
				_css(ghostEl, 'pointerEvents', 'none');

				options.fallbackOnBody && document.body.appendChild(ghostEl) || rootEl.appendChild(ghostEl);

				// Fixing dimensions.
				ghostRect = ghostEl.getBoundingClientRect();
				_css(ghostEl, 'width', rect.width * 2 - ghostRect.width);
				_css(ghostEl, 'height', rect.height * 2 - ghostRect.height);
			}
		},

		_onDragStart: function (/**Event*/evt, /**boolean*/useFallback) {
			var dataTransfer = evt.dataTransfer,
				options = this.options;

			this._offUpEvents();

			if (activeGroup.checkPull(this, this, dragEl, evt) == 'clone') {
				cloneEl = _clone(dragEl);
				_css(cloneEl, 'display', 'none');
				rootEl.insertBefore(cloneEl, dragEl);
				_dispatchEvent(this, rootEl, 'clone', dragEl);
			}

			_toggleClass(dragEl, options.dragClass, true);

			if (useFallback) {
				if (useFallback === 'touch') {
					// Bind touch events
					_on(document, 'touchmove', this._onTouchMove);
					_on(document, 'touchend', this._onDrop);
					_on(document, 'touchcancel', this._onDrop);
				} else {
					// Old brwoser
					_on(document, 'mousemove', this._onTouchMove);
					_on(document, 'mouseup', this._onDrop);
				}

				this._loopId = setInterval(this._emulateDragOver, 50);
			}
			else {
				if (dataTransfer) {
					dataTransfer.effectAllowed = 'move';
					options.setData && options.setData.call(this, dataTransfer, dragEl);
				}

				_on(document, 'drop', this);
				setTimeout(this._dragStarted, 0);
			}
		},

		_onDragOver: function (/**Event*/evt) {
			var el = this.el,
				target,
				dragRect,
				targetRect,
				revert,
				options = this.options,
				group = options.group,
				activeSortable = Sortable.active,
				isOwner = (activeGroup === group),
				canSort = options.sort;

			if (evt.preventDefault !== void 0) {
				evt.preventDefault();
				!options.dragoverBubble && evt.stopPropagation();
			}

			moved = true;

			if (activeGroup && !options.disabled &&
				(isOwner
					? canSort || (revert = !rootEl.contains(dragEl)) // Reverting item into the original list
					: (
						putSortable === this ||
						activeGroup.checkPull(this, activeSortable, dragEl, evt) && group.checkPut(this, activeSortable, dragEl, evt)
					)
				) &&
				(evt.rootEl === void 0 || evt.rootEl === this.el) // touch fallback
			) {
				// Smart auto-scrolling
				_autoScroll(evt, options, this.el);

				if (_silent) {
					return;
				}

				target = _closest(evt.target, options.draggable, el);
				dragRect = dragEl.getBoundingClientRect();
				putSortable = this;

				if (revert) {
					_cloneHide(true);
					parentEl = rootEl; // actualization

					if (cloneEl || nextEl) {
						rootEl.insertBefore(dragEl, cloneEl || nextEl);
					}
					else if (!canSort) {
						rootEl.appendChild(dragEl);
					}

					return;
				}


				if ((el.children.length === 0) || (el.children[0] === ghostEl) ||
					(el === evt.target) && (target = _ghostIsLast(el, evt))
				) {
					if (target) {
						if (target.animated) {
							return;
						}

						targetRect = target.getBoundingClientRect();
					}

					_cloneHide(isOwner);

					if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt) !== false) {
						if (!dragEl.contains(el)) {
							el.appendChild(dragEl);
							parentEl = el; // actualization
						}

						this._animate(dragRect, dragEl);
						target && this._animate(targetRect, target);
					}
				}
				else if (target && !target.animated && target !== dragEl && (target.parentNode[expando] !== void 0)) {
					if (lastEl !== target) {
						lastEl = target;
						lastCSS = _css(target);
						lastParentCSS = _css(target.parentNode);
					}

					targetRect = target.getBoundingClientRect();

					var width = targetRect.right - targetRect.left,
						height = targetRect.bottom - targetRect.top,
						floating = /left|right|inline/.test(lastCSS.cssFloat + lastCSS.display)
							|| (lastParentCSS.display == 'flex' && lastParentCSS['flex-direction'].indexOf('row') === 0),
						isWide = (target.offsetWidth > dragEl.offsetWidth),
						isLong = (target.offsetHeight > dragEl.offsetHeight),
						halfway = (floating ? (evt.clientX - targetRect.left) / width : (evt.clientY - targetRect.top) / height) > 0.5,
						nextSibling = target.nextElementSibling,
						moveVector = _onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt),
						after
					;

					if (moveVector !== false) {
						_silent = true;
						setTimeout(_unsilent, 30);

						_cloneHide(isOwner);

						if (moveVector === 1 || moveVector === -1) {
							after = (moveVector === 1);
						}
						else if (floating) {
							var elTop = dragEl.offsetTop,
								tgTop = target.offsetTop;

							if (elTop === tgTop) {
								after = (target.previousElementSibling === dragEl) && !isWide || halfway && isWide;
							}
							else if (target.previousElementSibling === dragEl || dragEl.previousElementSibling === target) {
								after = (evt.clientY - targetRect.top) / height > 0.5;
							} else {
								after = tgTop > elTop;
							}
						} else {
							after = (nextSibling !== dragEl) && !isLong || halfway && isLong;
						}

						if (!dragEl.contains(el)) {
							if (after && !nextSibling) {
								el.appendChild(dragEl);
							} else {
								target.parentNode.insertBefore(dragEl, after ? nextSibling : target);
							}
						}

						parentEl = dragEl.parentNode; // actualization

						this._animate(dragRect, dragEl);
						this._animate(targetRect, target);
					}
				}
			}
		},

		_animate: function (prevRect, target) {
			var ms = this.options.animation;

			if (ms) {
				var currentRect = target.getBoundingClientRect();

				_css(target, 'transition', 'none');
				_css(target, 'transform', 'translate3d('
					+ (prevRect.left - currentRect.left) + 'px,'
					+ (prevRect.top - currentRect.top) + 'px,0)'
				);

				target.offsetWidth; // repaint

				_css(target, 'transition', 'all ' + ms + 'ms');
				_css(target, 'transform', 'translate3d(0,0,0)');

				clearTimeout(target.animated);
				target.animated = setTimeout(function () {
					_css(target, 'transition', '');
					_css(target, 'transform', '');
					target.animated = false;
				}, ms);
			}
		},

		_offUpEvents: function () {
			var ownerDocument = this.el.ownerDocument;

			_off(document, 'touchmove', this._onTouchMove);
			_off(ownerDocument, 'mouseup', this._onDrop);
			_off(ownerDocument, 'touchend', this._onDrop);
			_off(ownerDocument, 'touchcancel', this._onDrop);
		},

		_onDrop: function (/**Event*/evt) {
			var el = this.el,
				options = this.options;

			clearInterval(this._loopId);
			clearInterval(autoScroll.pid);
			clearTimeout(this._dragStartTimer);

			// Unbind events
			_off(document, 'mousemove', this._onTouchMove);

			if (this.nativeDraggable) {
				_off(document, 'drop', this);
				_off(el, 'dragstart', this._onDragStart);
			}

			this._offUpEvents();

			if (evt) {
				if (moved) {
					evt.preventDefault();
					!options.dropBubble && evt.stopPropagation();
				}

				ghostEl && ghostEl.parentNode.removeChild(ghostEl);

				if (dragEl) {
					if (this.nativeDraggable) {
						_off(dragEl, 'dragend', this);
					}

					_disableDraggable(dragEl);
					dragEl.style['will-change'] = '';

					// Remove class's
					_toggleClass(dragEl, this.options.ghostClass, false);
					_toggleClass(dragEl, this.options.chosenClass, false);

					if (rootEl !== parentEl) {
						newIndex = _index(dragEl, options.draggable);

						if (newIndex >= 0) {

							// Add event
							_dispatchEvent(null, parentEl, 'add', dragEl, rootEl, oldIndex, newIndex);

							// Remove event
							_dispatchEvent(this, rootEl, 'remove', dragEl, rootEl, oldIndex, newIndex);

							// drag from one list and drop into another
							_dispatchEvent(null, parentEl, 'sort', dragEl, rootEl, oldIndex, newIndex);
							_dispatchEvent(this, rootEl, 'sort', dragEl, rootEl, oldIndex, newIndex);
						}
					}
					else {
						// Remove clone
						cloneEl && cloneEl.parentNode.removeChild(cloneEl);

						if (dragEl.nextSibling !== nextEl) {
							// Get the index of the dragged element within its parent
							newIndex = _index(dragEl, options.draggable);

							if (newIndex >= 0) {
								// drag & drop within the same list
								_dispatchEvent(this, rootEl, 'update', dragEl, rootEl, oldIndex, newIndex);
								_dispatchEvent(this, rootEl, 'sort', dragEl, rootEl, oldIndex, newIndex);
							}
						}
					}

					if (Sortable.active) {
						/* jshint eqnull:true */
						if (newIndex == null || newIndex === -1) {
							newIndex = oldIndex;
						}

						_dispatchEvent(this, rootEl, 'end', dragEl, rootEl, oldIndex, newIndex);

						// Save sorting
						this.save();
					}
				}

			}

			this._nulling();
		},

		_nulling: function() {
			rootEl =
			dragEl =
			parentEl =
			ghostEl =
			nextEl =
			cloneEl =

			scrollEl =
			scrollParentEl =

			tapEvt =
			touchEvt =

			moved =
			newIndex =

			lastEl =
			lastCSS =

			putSortable =
			activeGroup =
			Sortable.active = null;
		},

		handleEvent: function (/**Event*/evt) {
			var type = evt.type;

			if (type === 'dragover' || type === 'dragenter') {
				if (dragEl) {
					this._onDragOver(evt);
					_globalDragOver(evt);
				}
			}
			else if (type === 'drop' || type === 'dragend') {
				this._onDrop(evt);
			}
		},


		/**
		 * Serializes the item into an array of string.
		 * @returns {String[]}
		 */
		toArray: function () {
			var order = [],
				el,
				children = this.el.children,
				i = 0,
				n = children.length,
				options = this.options;

			for (; i < n; i++) {
				el = children[i];
				if (_closest(el, options.draggable, this.el)) {
					order.push(el.getAttribute(options.dataIdAttr) || _generateId(el));
				}
			}

			return order;
		},


		/**
		 * Sorts the elements according to the array.
		 * @param  {String[]}  order  order of the items
		 */
		sort: function (order) {
			var items = {}, rootEl = this.el;

			this.toArray().forEach(function (id, i) {
				var el = rootEl.children[i];

				if (_closest(el, this.options.draggable, rootEl)) {
					items[id] = el;
				}
			}, this);

			order.forEach(function (id) {
				if (items[id]) {
					rootEl.removeChild(items[id]);
					rootEl.appendChild(items[id]);
				}
			});
		},


		/**
		 * Save the current sorting
		 */
		save: function () {
			var store = this.options.store;
			store && store.set(this);
		},


		/**
		 * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
		 * @param   {HTMLElement}  el
		 * @param   {String}       [selector]  default: `options.draggable`
		 * @returns {HTMLElement|null}
		 */
		closest: function (el, selector) {
			return _closest(el, selector || this.options.draggable, this.el);
		},


		/**
		 * Set/get option
		 * @param   {string} name
		 * @param   {*}      [value]
		 * @returns {*}
		 */
		option: function (name, value) {
			var options = this.options;

			if (value === void 0) {
				return options[name];
			} else {
				options[name] = value;

				if (name === 'group') {
					_prepareGroup(options);
				}
			}
		},


		/**
		 * Destroy
		 */
		destroy: function () {
			var el = this.el;

			el[expando] = null;

			_off(el, 'mousedown', this._onTapStart);
			_off(el, 'touchstart', this._onTapStart);

			if (this.nativeDraggable) {
				_off(el, 'dragover', this);
				_off(el, 'dragenter', this);
			}

			// Remove draggable attributes
			Array.prototype.forEach.call(el.querySelectorAll('[draggable]'), function (el) {
				el.removeAttribute('draggable');
			});

			touchDragOverListeners.splice(touchDragOverListeners.indexOf(this._onDragOver), 1);

			this._onDrop();

			this.el = el = null;
		}
	};


	function _cloneHide(state) {
		if (cloneEl && (cloneEl.state !== state)) {
			_css(cloneEl, 'display', state ? 'none' : '');
			!state && cloneEl.state && rootEl.insertBefore(cloneEl, dragEl);
			cloneEl.state = state;
		}
	}


	function _closest(/**HTMLElement*/el, /**String*/selector, /**HTMLElement*/ctx) {
		if (el) {
			ctx = ctx || document;

			do {
				if ((selector === '>*' && el.parentNode === ctx) || _matches(el, selector)) {
					return el;
				}
				/* jshint boss:true */
			} while (el = _getParentOrHost(el));
		}

		return null;
	}


	function _getParentOrHost(el) {
		var parent = el.host;

		return (parent && parent.nodeType) ? parent : el.parentNode;
	}


	function _globalDragOver(/**Event*/evt) {
		if (evt.dataTransfer) {
			evt.dataTransfer.dropEffect = 'move';
		}
		evt.preventDefault();
	}


	function _on(el, event, fn) {
		el.addEventListener(event, fn, false);
	}


	function _off(el, event, fn) {
		el.removeEventListener(event, fn, false);
	}


	function _toggleClass(el, name, state) {
		if (el) {
			if (el.classList) {
				el.classList[state ? 'add' : 'remove'](name);
			}
			else {
				var className = (' ' + el.className + ' ').replace(RSPACE, ' ').replace(' ' + name + ' ', ' ');
				el.className = (className + (state ? ' ' + name : '')).replace(RSPACE, ' ');
			}
		}
	}


	function _css(el, prop, val) {
		var style = el && el.style;

		if (style) {
			if (val === void 0) {
				if (document.defaultView && document.defaultView.getComputedStyle) {
					val = document.defaultView.getComputedStyle(el, '');
				}
				else if (el.currentStyle) {
					val = el.currentStyle;
				}

				return prop === void 0 ? val : val[prop];
			}
			else {
				if (!(prop in style)) {
					prop = '-webkit-' + prop;
				}

				style[prop] = val + (typeof val === 'string' ? '' : 'px');
			}
		}
	}


	function _find(ctx, tagName, iterator) {
		if (ctx) {
			var list = ctx.getElementsByTagName(tagName), i = 0, n = list.length;

			if (iterator) {
				for (; i < n; i++) {
					iterator(list[i], i);
				}
			}

			return list;
		}

		return [];
	}



	function _dispatchEvent(sortable, rootEl, name, targetEl, fromEl, startIndex, newIndex) {
		sortable = (sortable || rootEl[expando]);

		var evt = document.createEvent('Event'),
			options = sortable.options,
			onName = 'on' + name.charAt(0).toUpperCase() + name.substr(1);

		evt.initEvent(name, true, true);

		evt.to = rootEl;
		evt.from = fromEl || rootEl;
		evt.item = targetEl || rootEl;
		evt.clone = cloneEl;

		evt.oldIndex = startIndex;
		evt.newIndex = newIndex;

		rootEl.dispatchEvent(evt);

		if (options[onName]) {
			options[onName].call(sortable, evt);
		}
	}


	function _onMove(fromEl, toEl, dragEl, dragRect, targetEl, targetRect, originalEvt) {
		var evt,
			sortable = fromEl[expando],
			onMoveFn = sortable.options.onMove,
			retVal;

		evt = document.createEvent('Event');
		evt.initEvent('move', true, true);

		evt.to = toEl;
		evt.from = fromEl;
		evt.dragged = dragEl;
		evt.draggedRect = dragRect;
		evt.related = targetEl || toEl;
		evt.relatedRect = targetRect || toEl.getBoundingClientRect();

		fromEl.dispatchEvent(evt);

		if (onMoveFn) {
			retVal = onMoveFn.call(sortable, evt, originalEvt);
		}

		return retVal;
	}


	function _disableDraggable(el) {
		el.draggable = false;
	}


	function _unsilent() {
		_silent = false;
	}


	/** @returns {HTMLElement|false} */
	function _ghostIsLast(el, evt) {
		var lastEl = el.lastElementChild,
			rect = lastEl.getBoundingClientRect();

		// 5 — min delta
		// abs — нельзя добавлять, а то глюки при наведении сверху
		return (
			(evt.clientY - (rect.top + rect.height) > 5) ||
			(evt.clientX - (rect.right + rect.width) > 5)
		) && lastEl;
	}


	/**
	 * Generate id
	 * @param   {HTMLElement} el
	 * @returns {String}
	 * @private
	 */
	function _generateId(el) {
		var str = el.tagName + el.className + el.src + el.href + el.textContent,
			i = str.length,
			sum = 0;

		while (i--) {
			sum += str.charCodeAt(i);
		}

		return sum.toString(36);
	}

	/**
	 * Returns the index of an element within its parent for a selected set of
	 * elements
	 * @param  {HTMLElement} el
	 * @param  {selector} selector
	 * @return {number}
	 */
	function _index(el, selector) {
		var index = 0;

		if (!el || !el.parentNode) {
			return -1;
		}

		while (el && (el = el.previousElementSibling)) {
			if ((el.nodeName.toUpperCase() !== 'TEMPLATE') && (selector === '>*' || _matches(el, selector))) {
				index++;
			}
		}

		return index;
	}

	function _matches(/**HTMLElement*/el, /**String*/selector) {
		if (el) {
			selector = selector.split('.');

			var tag = selector.shift().toUpperCase(),
				re = new RegExp('\\s(' + selector.join('|') + ')(?=\\s)', 'g');

			return (
				(tag === '' || el.nodeName.toUpperCase() == tag) &&
				(!selector.length || ((' ' + el.className + ' ').match(re) || []).length == selector.length)
			);
		}

		return false;
	}

	function _throttle(callback, ms) {
		var args, _this;

		return function () {
			if (args === void 0) {
				args = arguments;
				_this = this;

				setTimeout(function () {
					if (args.length === 1) {
						callback.call(_this, args[0]);
					} else {
						callback.apply(_this, args);
					}

					args = void 0;
				}, ms);
			}
		};
	}

	function _extend(dst, src) {
		if (dst && src) {
			for (var key in src) {
				if (src.hasOwnProperty(key)) {
					dst[key] = src[key];
				}
			}
		}

		return dst;
	}

	function _clone(el) {
		return $
			? $(el).clone(true)[0]
			: (Polymer && Polymer.dom
				? Polymer.dom(el).cloneNode(true)
				: el.cloneNode(true)
			);
	}


	// Export utils
	Sortable.utils = {
		on: _on,
		off: _off,
		css: _css,
		find: _find,
		is: function (el, selector) {
			return !!_closest(el, selector, el);
		},
		extend: _extend,
		throttle: _throttle,
		closest: _closest,
		toggleClass: _toggleClass,
		clone: _clone,
		index: _index
	};


	/**
	 * Create sortable instance
	 * @param {HTMLElement}  el
	 * @param {Object}      [options]
	 */
	Sortable.create = function (el, options) {
		return new Sortable(el, options);
	};


	// Export
	Sortable.version = '1.4.2';
	return Sortable;
});


/***/ }),

/***/ "qnTa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__protected_tag_access_dropdown__ = __webpack_require__("XcYM");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable no-new */
/* global Flash */



var ProtectedTagEdit = function () {
  function ProtectedTagEdit(options) {
    _classCallCheck(this, ProtectedTagEdit);

    this.$wrap = options.$wrap;
    this.$allowedToCreateDropdownButton = this.$wrap.find('.js-allowed-to-create');
    this.onSelectCallback = this.onSelect.bind(this);

    this.buildDropdowns();
  }

  _createClass(ProtectedTagEdit, [{
    key: 'buildDropdowns',
    value: function buildDropdowns() {
      // Allowed to create dropdown
      this.protectedTagAccessDropdown = new __WEBPACK_IMPORTED_MODULE_0__protected_tag_access_dropdown__["a" /* default */]({
        $dropdown: this.$allowedToCreateDropdownButton,
        data: gon.create_access_levels,
        onSelect: this.onSelectCallback
      });
    }
  }, {
    key: 'onSelect',
    value: function onSelect() {
      var _this = this;

      var $allowedToCreateInput = this.$wrap.find('input[name="' + this.$allowedToCreateDropdownButton.data('fieldName') + '"]');

      // Do not update if one dropdown has not selected any option
      if (!$allowedToCreateInput.length) return;

      this.$allowedToCreateDropdownButton.disable();

      $.ajax({
        type: 'POST',
        url: this.$wrap.data('url'),
        dataType: 'json',
        data: {
          _method: 'PATCH',
          protected_tag: {
            create_access_levels_attributes: [{
              id: this.$allowedToCreateDropdownButton.data('access-level-id'),
              access_level: $allowedToCreateInput.val()
            }]
          }
        },
        error: function error() {
          new Flash('Failed to update tag!', null, $('.js-protected-tags-list'));
        }
      }).always(function () {
        _this.$allowedToCreateDropdownButton.enable();
      });
    }
  }]);

  return ProtectedTagEdit;
}();

/* harmony default export */ __webpack_exports__["a"] = (ProtectedTagEdit);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("lwLq")))

/***/ }),

/***/ "qr6X":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable class-methods-use-this */

__webpack_require__("2iOG");

var UNFOLD_COUNT = 20;
var isBound = false;

var Diff = function () {
  function Diff() {
    _classCallCheck(this, Diff);

    var $diffFile = $('.files .diff-file');
    $diffFile.singleFileDiff();
    $diffFile.filesCommentButton();

    $diffFile.each(function (index, file) {
      return new gl.ImageFile(file);
    });

    if (!isBound) {
      $(document).on('click', '.js-unfold', this.handleClickUnfold.bind(this)).on('click', '.diff-line-num a', this.handleClickLineNum.bind(this));
      isBound = true;
    }

    if (gl.utils.getLocationHash()) {
      this.highlightSelectedLine();
    }

    this.openAnchoredDiff();
  }

  _createClass(Diff, [{
    key: 'handleClickUnfold',
    value: function handleClickUnfold(e) {
      var $target = $(e.target);

      var _lineNumbers = this.lineNumbers($target.parent()),
          _lineNumbers2 = _slicedToArray(_lineNumbers, 2),
          oldLineNumber = _lineNumbers2[0],
          newLineNumber = _lineNumbers2[1];

      var offset = newLineNumber - oldLineNumber;
      var bottom = $target.hasClass('js-unfold-bottom');
      var since = void 0;
      var to = void 0;
      var unfold = true;

      if (bottom) {
        var lineNumber = newLineNumber + 1;
        since = lineNumber;
        to = lineNumber + UNFOLD_COUNT;
      } else {
        var _lineNumber = newLineNumber - 1;
        since = _lineNumber - UNFOLD_COUNT;
        to = _lineNumber;

        // make sure we aren't loading more than we need
        var prevNewLine = this.lineNumbers($target.parent().prev())[1];
        if (since <= prevNewLine + 1) {
          since = prevNewLine + 1;
          unfold = false;
        }
      }

      var file = $target.parents('.diff-file');
      var link = file.data('blob-diff-path');
      var view = file.data('view');

      var params = { since: since, to: to, bottom: bottom, offset: offset, unfold: unfold, view: view };
      $.get(link, params, function (response) {
        return $target.parent().replaceWith(response);
      });
    }
  }, {
    key: 'openAnchoredDiff',
    value: function openAnchoredDiff(cb) {
      var _this = this;

      var locationHash = gl.utils.getLocationHash();
      var anchoredDiff = locationHash && locationHash.split('_')[0];

      if (!anchoredDiff) return;

      var diffTitle = $('#' + anchoredDiff);
      var diffFile = diffTitle.closest('.diff-file');
      var nothingHereBlock = $('.nothing-here-block:visible', diffFile);
      if (nothingHereBlock.length) {
        var clickTarget = $('.js-file-title, .click-to-expand', diffFile);
        diffFile.data('singleFileDiff').toggleDiff(clickTarget, function () {
          _this.highlightSelectedLine();
          if (cb) cb();
        });
      } else if (cb) {
        cb();
      }
    }
  }, {
    key: 'handleClickLineNum',
    value: function handleClickLineNum(e) {
      var hash = $(e.currentTarget).attr('href');
      e.preventDefault();
      if (window.history.pushState) {
        window.history.pushState(null, null, hash);
      } else {
        window.location.hash = hash;
      }
      this.highlightSelectedLine();
    }
  }, {
    key: 'diffViewType',
    value: function diffViewType() {
      return $('.inline-parallel-buttons a.active').data('view-type');
    }
  }, {
    key: 'lineNumbers',
    value: function lineNumbers(line) {
      var children = line.find('.diff-line-num').toArray();
      if (children.length !== 2) {
        return [0, 0];
      }
      return children.map(function (elm) {
        return parseInt($(elm).data('linenumber'), 10) || 0;
      });
    }
  }, {
    key: 'highlightSelectedLine',
    value: function highlightSelectedLine() {
      var hash = gl.utils.getLocationHash();
      var $diffFiles = $('.diff-file');
      $diffFiles.find('.hll').removeClass('hll');

      if (hash) {
        $diffFiles.find('tr#' + hash + ':not(.match) td, td#' + hash + ', td[data-line-code="' + hash + '"]').addClass('hll');
      }
    }
  }]);

  return Diff;
}();

window.gl = window.gl || {};
window.gl.Diff = Diff;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "qs7a":
/***/ (function(module, exports) {

/* eslint-disable func-names, space-before-function-paren, no-var, prefer-rest-params, wrap-iife, no-return-assign, max-len */
(function () {
  var bind = function bind(fn, me) {
    return function () {
      return fn.apply(me, arguments);
    };
  };

  this.NewCommitForm = function () {
    function NewCommitForm(form) {
      var targetBranchName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'target_branch';

      this.form = form;
      this.targetBranchName = targetBranchName;
      this.renderDestination = bind(this.renderDestination, this);
      this.targetBranchDropdown = form.find('button.js-target-branch');
      this.originalBranch = form.find('.js-original-branch');
      this.createMergeRequest = form.find('.js-create-merge-request');
      this.createMergeRequestContainer = form.find('.js-create-merge-request-container');
      this.targetBranchDropdown.on('change.branch', this.renderDestination);
      this.renderDestination();
    }

    NewCommitForm.prototype.renderDestination = function () {
      var different;
      var targetBranch = this.form.find('input[name="' + this.targetBranchName + '"]');

      different = targetBranch.val() !== this.originalBranch.val();
      if (different) {
        this.createMergeRequestContainer.show();
        if (!this.wasDifferent) {
          this.createMergeRequest.prop('checked', true);
        }
      } else {
        this.createMergeRequestContainer.hide();
        this.createMergeRequest.prop('checked', false);
      }
      return this.wasDifferent = different;
    };

    return NewCommitForm;
  }();
}).call(window);

/***/ }),

/***/ "r2DN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isEmojiUnicodeSupported; });
/* unused harmony export isFlagEmoji */
/* unused harmony export isKeycapEmoji */
/* unused harmony export isSkinToneComboEmoji */
/* unused harmony export isHorceRacingSkinToneComboEmoji */
/* unused harmony export isPersonZwjEmoji */
// On Windows, flags render as two-letter country codes, see http://emojipedia.org/flags/
var flagACodePoint = 127462; // parseInt('1F1E6', 16)
var flagZCodePoint = 127487; // parseInt('1F1FF', 16)
function isFlagEmoji(emojiUnicode) {
  var cp = emojiUnicode.codePointAt(0);
  // Length 4 because flags are made of 2 characters which are surrogate pairs
  return emojiUnicode.length === 4 && cp >= flagACodePoint && cp <= flagZCodePoint;
}

// Chrome <57 renders keycaps oddly
// See https://bugs.chromium.org/p/chromium/issues/detail?id=632294
// Same issue on Windows also fixed in Chrome 57, http://i.imgur.com/rQF7woO.png
function isKeycapEmoji(emojiUnicode) {
  return emojiUnicode.length === 3 && emojiUnicode[2] === '\u20E3';
}

// Check for a skin tone variation emoji which aren't always supported
var tone1 = 127995; // parseInt('1F3FB', 16)
var tone5 = 127999; // parseInt('1F3FF', 16)
function isSkinToneComboEmoji(emojiUnicode) {
  return emojiUnicode.length > 2 && Array.from(emojiUnicode).some(function (char) {
    var cp = char.codePointAt(0);
    return cp >= tone1 && cp <= tone5;
  });
}

// macOS supports most skin tone emoji's but
// doesn't support the skin tone versions of horse racing
var horseRacingCodePoint = 127943; // parseInt('1F3C7', 16)
function isHorceRacingSkinToneComboEmoji(emojiUnicode) {
  return Array.from(emojiUnicode)[0].codePointAt(0) === horseRacingCodePoint && isSkinToneComboEmoji(emojiUnicode);
}

// Check for `family_*`, `kiss_*`, `couple_*`
// For ex. Windows 8.1 Firefox 51.0.1, doesn't support these
var zwj = 8205; // parseInt('200D', 16)
var personStartCodePoint = 128102; // parseInt('1F466', 16)
var personEndCodePoint = 128105; // parseInt('1F469', 16)
function isPersonZwjEmoji(emojiUnicode) {
  var hasPersonEmoji = false;
  var hasZwj = false;
  Array.from(emojiUnicode).forEach(function (character) {
    var cp = character.codePointAt(0);
    if (cp === zwj) {
      hasZwj = true;
    } else if (cp >= personStartCodePoint && cp <= personEndCodePoint) {
      hasPersonEmoji = true;
    }
  });

  return hasPersonEmoji && hasZwj;
}

// Helper so we don't have to run `isFlagEmoji` twice
// in `isEmojiUnicodeSupported` logic
function checkFlagEmojiSupport(unicodeSupportMap, emojiUnicode) {
  var isFlagResult = isFlagEmoji(emojiUnicode);
  return unicodeSupportMap.flag && isFlagResult || !isFlagResult;
}

// Helper so we don't have to run `isSkinToneComboEmoji` twice
// in `isEmojiUnicodeSupported` logic
function checkSkinToneModifierSupport(unicodeSupportMap, emojiUnicode) {
  var isSkinToneResult = isSkinToneComboEmoji(emojiUnicode);
  return unicodeSupportMap.skinToneModifier && isSkinToneResult || !isSkinToneResult;
}

// Helper func so we don't have to run `isHorceRacingSkinToneComboEmoji` twice
// in `isEmojiUnicodeSupported` logic
function checkHorseRacingSkinToneComboEmojiSupport(unicodeSupportMap, emojiUnicode) {
  var isHorseRacingSkinToneResult = isHorceRacingSkinToneComboEmoji(emojiUnicode);
  return unicodeSupportMap.horseRacing && isHorseRacingSkinToneResult || !isHorseRacingSkinToneResult;
}

// Helper so we don't have to run `isPersonZwjEmoji` twice
// in `isEmojiUnicodeSupported` logic
function checkPersonEmojiSupport(unicodeSupportMap, emojiUnicode) {
  var isPersonZwjResult = isPersonZwjEmoji(emojiUnicode);
  return unicodeSupportMap.personZwj && isPersonZwjResult || !isPersonZwjResult;
}

// Takes in a support map and determines whether
// the given unicode emoji is supported on the platform.
//
// Combines all the edge case tests into a one-stop shop method
function isEmojiUnicodeSupported() {
  var unicodeSupportMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var emojiUnicode = arguments[1];
  var unicodeVersion = arguments[2];

  var isOlderThanChrome57 = unicodeSupportMap.meta && unicodeSupportMap.meta.isChrome && unicodeSupportMap.meta.chromeVersion < 57;

  // For comments about each scenario, see the comments above each individual respective function
  return unicodeSupportMap[unicodeVersion] && !(isOlderThanChrome57 && isKeycapEmoji(emojiUnicode)) && checkFlagEmojiSupport(unicodeSupportMap, emojiUnicode) && checkSkinToneModifierSupport(unicodeSupportMap, emojiUnicode) && checkHorseRacingSkinToneComboEmojiSupport(unicodeSupportMap, emojiUnicode) && checkPersonEmojiSupport(unicodeSupportMap, emojiUnicode);
}



/***/ }),

/***/ "r5TZ":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, wrap-iife, max-len, one-var, no-var, one-var-declaration-per-line, no-unused-vars, camelcase, quotes, no-useless-concat, prefer-template, quote-props, comma-dangle, object-shorthand, consistent-return, prefer-arrow-callback */
/* global Dropzone */

__webpack_require__("25vu");

window.DropzoneInput = function () {
  function DropzoneInput(form) {
    var $mdArea, alertAttr, alertClass, appendToTextArea, btnAlert, child, closeAlertMessage, closeSpinner, divAlert, divHover, divSpinner, dropzone, form_dropzone, form_textarea, getFilename, handlePaste, iconPaperclip, iconSpinner, insertToTextArea, isImage, max_file_size, pasteText, project_uploads_path, showError, showSpinner, uploadFile, uploadProgress;
    Dropzone.autoDiscover = false;
    alertClass = "alert alert-danger alert-dismissable div-dropzone-alert";
    alertAttr = "class=\"close\" data-dismiss=\"alert\"" + "aria-hidden=\"true\"";
    divHover = "<div class=\"div-dropzone-hover\"></div>";
    divSpinner = "<div class=\"div-dropzone-spinner\"></div>";
    divAlert = "<div class=\"" + alertClass + "\"></div>";
    iconPaperclip = "<i class=\"fa fa-paperclip div-dropzone-icon\"></i>";
    iconSpinner = "<i class=\"fa fa-spinner fa-spin div-dropzone-icon\"></i>";
    uploadProgress = $("<div class=\"div-dropzone-progress\"></div>");
    btnAlert = "<button type=\"button\"" + alertAttr + ">&times;</button>";
    project_uploads_path = window.project_uploads_path || null;
    max_file_size = gon.max_file_size || 10;
    form_textarea = $(form).find(".js-gfm-input");
    form_textarea.wrap("<div class=\"div-dropzone\"></div>");
    form_textarea.on('paste', function (_this) {
      return function (event) {
        return handlePaste(event);
      };
    }(this));
    $mdArea = $(form_textarea).closest('.md-area');
    $(form).setupMarkdownPreview();
    form_dropzone = $(form).find('.div-dropzone');
    form_dropzone.parent().addClass("div-dropzone-wrapper");
    form_dropzone.append(divHover);
    form_dropzone.find(".div-dropzone-hover").append(iconPaperclip);
    form_dropzone.append(divSpinner);
    form_dropzone.find(".div-dropzone-spinner").append(iconSpinner);
    form_dropzone.find(".div-dropzone-spinner").append(uploadProgress);
    form_dropzone.find(".div-dropzone-spinner").css({
      "opacity": 0,
      "display": "none"
    });

    if (!project_uploads_path) return;

    dropzone = form_dropzone.dropzone({
      url: project_uploads_path,
      dictDefaultMessage: "",
      clickable: true,
      paramName: "file",
      maxFilesize: max_file_size,
      uploadMultiple: false,
      headers: {
        "X-CSRF-Token": $("meta[name=\"csrf-token\"]").attr("content")
      },
      previewContainer: false,
      processing: function processing() {
        return $(".div-dropzone-alert").alert("close");
      },
      dragover: function dragover() {
        $mdArea.addClass('is-dropzone-hover');
        form.find(".div-dropzone-hover").css("opacity", 0.7);
      },
      dragleave: function dragleave() {
        $mdArea.removeClass('is-dropzone-hover');
        form.find(".div-dropzone-hover").css("opacity", 0);
      },
      drop: function drop() {
        $mdArea.removeClass('is-dropzone-hover');
        form.find(".div-dropzone-hover").css("opacity", 0);
        form_textarea.focus();
      },
      success: function success(header, response) {
        pasteText(response.link.markdown);
      },
      error: function error(temp) {
        var checkIfMsgExists, errorAlert;
        errorAlert = $(form).find('.error-alert');
        checkIfMsgExists = errorAlert.children().length;
        if (checkIfMsgExists === 0) {
          errorAlert.append(divAlert);
          $(".div-dropzone-alert").append(btnAlert + "Attaching the file failed.");
        }
      },
      totaluploadprogress: function totaluploadprogress(totalUploadProgress) {
        uploadProgress.text(Math.round(totalUploadProgress) + "%");
      },
      sending: function sending() {
        form_dropzone.find(".div-dropzone-spinner").css({
          "opacity": 0.7,
          "display": "inherit"
        });
      },
      queuecomplete: function queuecomplete() {
        uploadProgress.text("");
        $(".dz-preview").remove();
        $(".markdown-area").trigger("input");
        $(".div-dropzone-spinner").css({
          "opacity": 0,
          "display": "none"
        });
      }
    });
    child = $(dropzone[0]).children("textarea");
    handlePaste = function handlePaste(event) {
      var filename, image, pasteEvent, text;
      pasteEvent = event.originalEvent;
      if (pasteEvent.clipboardData && pasteEvent.clipboardData.items) {
        image = isImage(pasteEvent);
        if (image) {
          event.preventDefault();
          filename = getFilename(pasteEvent) || "image.png";
          text = "{{" + filename + "}}";
          pasteText(text);
          return uploadFile(image.getAsFile(), filename);
        }
      }
    };
    isImage = function isImage(data) {
      var i, item;
      i = 0;
      while (i < data.clipboardData.items.length) {
        item = data.clipboardData.items[i];
        if (item.type.indexOf("image") !== -1) {
          return item;
        }
        i += 1;
      }
      return false;
    };
    pasteText = function pasteText(text) {
      var afterSelection, beforeSelection, caretEnd, caretStart, textEnd;
      var formattedText = text + "\n\n";
      var textarea = child.get(0);
      caretStart = textarea.selectionStart;
      caretEnd = textarea.selectionEnd;
      textEnd = $(child).val().length;
      beforeSelection = $(child).val().substring(0, caretStart);
      afterSelection = $(child).val().substring(caretEnd, textEnd);
      $(child).val(beforeSelection + formattedText + afterSelection);
      textarea.setSelectionRange(caretStart + formattedText.length, caretEnd + formattedText.length);
      textarea.style.height = textarea.scrollHeight + "px";
      return form_textarea.trigger("input");
    };
    getFilename = function getFilename(e) {
      var value;
      if (window.clipboardData && window.clipboardData.getData) {
        value = window.clipboardData.getData("Text");
      } else if (e.clipboardData && e.clipboardData.getData) {
        value = e.clipboardData.getData("text/plain");
      }
      value = value.split("\r");
      return value.first();
    };
    uploadFile = function uploadFile(item, filename) {
      var formData;
      formData = new FormData();
      formData.append("file", item, filename);
      return $.ajax({
        url: project_uploads_path,
        type: "POST",
        data: formData,
        dataType: "json",
        processData: false,
        contentType: false,
        headers: {
          "X-CSRF-Token": $("meta[name=\"csrf-token\"]").attr("content")
        },
        beforeSend: function beforeSend() {
          showSpinner();
          return closeAlertMessage();
        },
        success: function success(e, textStatus, response) {
          return insertToTextArea(filename, response.responseJSON.link.markdown);
        },
        error: function error(response) {
          return showError(response.responseJSON.message);
        },
        complete: function complete() {
          return closeSpinner();
        }
      });
    };
    insertToTextArea = function insertToTextArea(filename, url) {
      return $(child).val(function (index, val) {
        return val.replace("{{" + filename + "}}", url);
      });
    };
    appendToTextArea = function appendToTextArea(url) {
      return $(child).val(function (index, val) {
        return val + url + "\n";
      });
    };
    showSpinner = function showSpinner(e) {
      return form.find(".div-dropzone-spinner").css({
        "opacity": 0.7,
        "display": "inherit"
      });
    };
    closeSpinner = function closeSpinner() {
      return form.find(".div-dropzone-spinner").css({
        "opacity": 0,
        "display": "none"
      });
    };
    showError = function showError(message) {
      var checkIfMsgExists, errorAlert;
      errorAlert = $(form).find('.error-alert');
      checkIfMsgExists = errorAlert.children().length;
      if (checkIfMsgExists === 0) {
        errorAlert.append(divAlert);
        return $(".div-dropzone-alert").append(btnAlert + message);
      }
    };
    closeAlertMessage = function closeAlertMessage() {
      return form.find(".div-dropzone-alert").alert("close");
    };
    form.find(".markdown-selector").click(function (e) {
      e.preventDefault();
      $(this).closest('.gfm-form').find('.div-dropzone').click();
      form_textarea.focus();
    });
  }

  return DropzoneInput;
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "rIn1":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, wrap-iife, max-len, quotes, consistent-return, no-var, one-var, one-var-declaration-per-line, no-else-return, prefer-arrow-callback, max-len */

(function () {
  this.TreeView = function () {
    function TreeView() {
      this.initKeyNav();
      // Code browser tree slider
      // Make the entire tree-item row clickable, but not if clicking another link (like a commit message)
      $(".tree-content-holder .tree-item").on('click', function (e) {
        var $clickedEl, path;
        $clickedEl = $(e.target);
        path = $('.tree-item-file-name a', this).attr('href');
        if (!$clickedEl.is('a') && !$clickedEl.is('.str-truncated')) {
          if (e.metaKey || e.which === 2) {
            e.preventDefault();
            return window.open(path, '_blank');
          } else {
            return gl.utils.visitUrl(path);
          }
        }
      });
      // Show the "Loading commit data" for only the first element
      $('span.log_loading:first').removeClass('hide');
    }

    TreeView.prototype.initKeyNav = function () {
      var li, liSelected;
      li = $("tr.tree-item");
      liSelected = null;
      return $('body').keydown(function (e) {
        var next, path;
        if ($("input:focus").length > 0 && (e.which === 38 || e.which === 40)) {
          return false;
        }
        if (e.which === 40) {
          if (liSelected) {
            next = liSelected.next();
            if (next.length > 0) {
              liSelected.removeClass("selected");
              liSelected = next.addClass("selected");
            }
          } else {
            liSelected = li.eq(0).addClass("selected");
          }
          return $(liSelected).focus();
        } else if (e.which === 38) {
          if (liSelected) {
            next = liSelected.prev();
            if (next.length > 0) {
              liSelected.removeClass("selected");
              liSelected = next.addClass("selected");
            }
          } else {
            liSelected = li.last().addClass("selected");
          }
          return $(liSelected).focus();
        } else if (e.which === 13) {
          path = $('.tree-item.selected .tree-item-file-name a').attr('href');
          if (path) {
            return gl.utils.visitUrl(path);
          }
        }
      });
    };

    return TreeView;
  }();
}).call(window);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "rd/T":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, wrap-iife, no-var, one-var, one-var-declaration-per-line, no-useless-escape, max-len */
(function () {
  this.ProjectAvatar = function () {
    function ProjectAvatar() {
      $('.js-choose-project-avatar-button').bind('click', function () {
        var form;
        form = $(this).closest('form');
        return form.find('.js-project-avatar-input').click();
      });
      $('.js-project-avatar-input').bind('change', function () {
        var filename, form;
        form = $(this).closest('form');
        filename = $(this).val().replace(/^.*[\\\/]/, '');
        return form.find('.js-avatar-filename').text(filename);
      });
    }

    return ProjectAvatar;
  }();
}).call(window);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "rs3V":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, wrap-iife, prefer-arrow-callback, no-var, comma-dangle, object-shorthand, one-var, one-var-declaration-per-line, no-else-return, quotes, max-len */
/* global Api */

(function () {
  this.ProjectSelect = function () {
    function ProjectSelect() {
      $('.js-projects-dropdown-toggle').each(function (i, dropdown) {
        var $dropdown;
        $dropdown = $(dropdown);
        return $dropdown.glDropdown({
          filterable: true,
          filterRemote: true,
          search: {
            fields: ['name_with_namespace']
          },
          data: function data(term, callback) {
            var finalCallback, projectsCallback;
            var orderBy = $dropdown.data('order-by');
            finalCallback = function finalCallback(projects) {
              return callback(projects);
            };
            if (this.includeGroups) {
              projectsCallback = function projectsCallback(projects) {
                var groupsCallback;
                groupsCallback = function groupsCallback(groups) {
                  var data;
                  data = groups.concat(projects);
                  return finalCallback(data);
                };
                return Api.groups(term, {}, groupsCallback);
              };
            } else {
              projectsCallback = finalCallback;
            }
            if (this.groupId) {
              return Api.groupProjects(this.groupId, term, projectsCallback);
            } else {
              return Api.projects(term, { order_by: orderBy }, projectsCallback);
            }
          },
          url: function url(project) {
            return project.web_url;
          },
          text: function text(project) {
            return project.name_with_namespace;
          }
        });
      });
      $('.ajax-project-select').each(function (i, select) {
        var placeholder;
        this.groupId = $(select).data('group-id');
        this.includeGroups = $(select).data('include-groups');
        this.orderBy = $(select).data('order-by') || 'id';
        placeholder = "Search for project";
        if (this.includeGroups) {
          placeholder += " or group";
        }
        return $(select).select2({
          placeholder: placeholder,
          minimumInputLength: 0,
          query: function (_this) {
            return function (query) {
              var finalCallback, projectsCallback;
              finalCallback = function finalCallback(projects) {
                var data;
                data = {
                  results: projects
                };
                return query.callback(data);
              };
              if (_this.includeGroups) {
                projectsCallback = function projectsCallback(projects) {
                  var groupsCallback;
                  groupsCallback = function groupsCallback(groups) {
                    var data;
                    data = groups.concat(projects);
                    return finalCallback(data);
                  };
                  return Api.groups(query.term, {}, groupsCallback);
                };
              } else {
                projectsCallback = finalCallback;
              }
              if (_this.groupId) {
                return Api.groupProjects(_this.groupId, query.term, projectsCallback);
              } else {
                return Api.projects(query.term, { order_by: _this.orderBy }, projectsCallback);
              }
            };
          }(this),
          id: function id(project) {
            return project.web_url;
          },
          text: function text(project) {
            return project.name_with_namespace || project.name;
          },
          dropdownCssClass: "ajax-project-dropdown"
        });
      });
    }

    return ProjectSelect;
  }();
}).call(window);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "sAqb":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable arrow-parens, no-param-reassign, space-before-function-paren, func-names, no-var, max-len */

(function (global) {
  global.gl = global.gl || {};

  gl.SnippetsList = function () {
    var $holder = $('.snippets-list-holder');

    $holder.find('.pagination').on('ajax:success', function (e, data) {
      $holder.replaceWith(data.html);
    });
  };
})(window);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "sv8m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__("yoQO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_emojis_digests_json__ = __webpack_require__("fA9n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_emojis_digests_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_emojis_digests_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_emojis_aliases_json__ = __webpack_require__("owyH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_emojis_aliases_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_emojis_aliases_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__behaviors_gl_emoji__ = __webpack_require__("fSxH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__behaviors_gl_emoji_is_emoji_name_valid__ = __webpack_require__("J6H8");
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }








var animationEndEventString = 'animationend webkitAnimationEnd MSAnimationEnd oAnimationEnd';
var requestAnimationFrame = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.setTimeout;

var FROM_SENTENCE_REGEX = /(?:, and | and |, )/; // For separating lists produced by ruby's Array#toSentence

var categoryMap = null;

var categoryLabelMap = {
  activity: 'Activity',
  people: 'People',
  nature: 'Nature',
  food: 'Food',
  travel: 'Travel',
  objects: 'Objects',
  symbols: 'Symbols',
  flags: 'Flags'
};

function buildCategoryMap() {
  return Object.keys(__WEBPACK_IMPORTED_MODULE_1_emojis_digests_json___default.a).reduce(function (currentCategoryMap, emojiNameKey) {
    var emojiInfo = __WEBPACK_IMPORTED_MODULE_1_emojis_digests_json___default.a[emojiNameKey];
    if (currentCategoryMap[emojiInfo.category]) {
      currentCategoryMap[emojiInfo.category].push(emojiNameKey);
    }

    return currentCategoryMap;
  }, {
    activity: [],
    people: [],
    nature: [],
    food: [],
    travel: [],
    objects: [],
    symbols: [],
    flags: []
  });
}

function renderCategory(name, emojiList) {
  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  return '\n    <h5 class="emoji-menu-title">\n      ' + name + '\n    </h5>\n    <ul class="clearfix emoji-menu-list ' + (opts.menuListClass || '') + '">\n      ' + emojiList.map(function (emojiName) {
    return '\n        <li class="emoji-menu-list-item">\n          <button class="emoji-menu-btn text-center js-emoji-btn" type="button">\n            ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__behaviors_gl_emoji__["a" /* glEmojiTag */])(emojiName, {
      sprite: true
    }) + '\n          </button>\n        </li>\n      ';
  }).join('\n') + '\n    </ul>\n  ';
}

function AwardsHandler() {
  var _this = this;

  this.eventListeners = [];
  this.aliases = __WEBPACK_IMPORTED_MODULE_2_emojis_aliases_json___default.a;
  // If the user shows intent let's pre-build the menu
  this.registerEventListener('one', $(document), 'mouseenter focus', '.js-add-award', 'mouseenter focus', function () {
    var $menu = $('.emoji-menu');
    if ($menu.length === 0) {
      requestAnimationFrame(function () {
        _this.createEmojiMenu();
      });
    }
    // Prebuild the categoryMap
    categoryMap = categoryMap || buildCategoryMap();
  });
  this.registerEventListener('on', $(document), 'click', '.js-add-award', function (e) {
    e.stopPropagation();
    e.preventDefault();
    _this.showEmojiMenu($(e.currentTarget));
  });

  this.registerEventListener('on', $('html'), 'click', function (e) {
    var $target = $(e.target);
    if (!$target.closest('.emoji-menu-content').length) {
      $('.js-awards-block.current').removeClass('current');
    }
    if (!$target.closest('.emoji-menu').length) {
      if ($('.emoji-menu').is(':visible')) {
        $('.js-add-award.is-active').removeClass('is-active');
        $('.emoji-menu').removeClass('is-visible');
      }
    }
  });
  this.registerEventListener('on', $(document), 'click', '.js-emoji-btn', function (e) {
    e.preventDefault();
    var $target = $(e.currentTarget);
    var $glEmojiElement = $target.find('gl-emoji');
    var $spriteIconElement = $target.find('.icon');
    var emoji = ($glEmojiElement.length ? $glEmojiElement : $spriteIconElement).data('name');
    $target.closest('.js-awards-block').addClass('current');
    return _this.addAward(_this.getVotesBlock(), _this.getAwardUrl(), emoji);
  });
}

AwardsHandler.prototype.registerEventListener = function registerEventListener() {
  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var _element$method;

  var method = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'on';
  var element = arguments[1];

  (_element$method = element[method]).call.apply(_element$method, [element].concat(args));
  this.eventListeners.push({
    element: element,
    args: args
  });
};

AwardsHandler.prototype.showEmojiMenu = function showEmojiMenu($addBtn) {
  var _this2 = this;

  if ($addBtn.hasClass('js-note-emoji')) {
    $addBtn.closest('.note').find('.js-awards-block').addClass('current');
  } else {
    $addBtn.closest('.js-awards-block').addClass('current');
  }

  var $menu = $('.emoji-menu');
  if ($menu.length) {
    if ($menu.is('.is-visible')) {
      $addBtn.removeClass('is-active');
      $menu.removeClass('is-visible');
      $('#emoji_search').blur();
    } else {
      $addBtn.addClass('is-active');
      this.positionMenu($menu, $addBtn);
      $menu.addClass('is-visible');
      $('#emoji_search').focus();
    }
  } else {
    $addBtn.addClass('is-loading is-active');
    this.createEmojiMenu(function () {
      var $createdMenu = $('.emoji-menu');
      $addBtn.removeClass('is-loading');
      _this2.positionMenu($createdMenu, $addBtn);
      return setTimeout(function () {
        $createdMenu.addClass('is-visible');
        $('#emoji_search').focus();
      }, 200);
    });
  }
};

// Create the emoji menu with the first category of emojis.
// Then render the remaining categories of emojis one by one to avoid jank.
AwardsHandler.prototype.createEmojiMenu = function createEmojiMenu(callback) {
  if (this.isCreatingEmojiMenu) {
    return;
  }
  this.isCreatingEmojiMenu = true;

  // Render the first category
  categoryMap = categoryMap || buildCategoryMap();
  var categoryNameKey = Object.keys(categoryMap)[0];
  var emojisInCategory = categoryMap[categoryNameKey];
  var firstCategory = renderCategory(categoryLabelMap[categoryNameKey], emojisInCategory);

  // Render the frequently used
  var frequentlyUsedEmojis = this.getFrequentlyUsedEmojis();
  var frequentlyUsedCatgegory = '';
  if (frequentlyUsedEmojis.length > 0) {
    frequentlyUsedCatgegory = renderCategory('Frequently used', frequentlyUsedEmojis, {
      menuListClass: 'frequent-emojis'
    });
  }

  var emojiMenuMarkup = '\n    <div class="emoji-menu">\n      <input type="text" name="emoji_search" id="emoji_search" value="" class="emoji-search search-input form-control" placeholder="Search emoji" />\n\n      <div class="emoji-menu-content">\n        ' + frequentlyUsedCatgegory + '\n        ' + firstCategory + '\n      </div>\n    </div>\n  ';

  document.body.insertAdjacentHTML('beforeend', emojiMenuMarkup);

  this.addRemainingEmojiMenuCategories();
  this.setupSearch();
  if (callback) {
    callback();
  }
};

AwardsHandler.prototype.addRemainingEmojiMenuCategories = function addRemainingEmojiMenuCategories() {
  if (this.isAddingRemainingEmojiMenuCategories) {
    return;
  }
  this.isAddingRemainingEmojiMenuCategories = true;

  categoryMap = categoryMap || buildCategoryMap();

  // Avoid the jank and render the remaining categories separately
  // This will take more time, but makes UI more responsive
  var menu = document.querySelector('.emoji-menu');
  var emojiContentElement = menu.querySelector('.emoji-menu-content');
  var remainingCategories = Object.keys(categoryMap).slice(1);
  var allCategoriesAddedPromise = remainingCategories.reduce(function (promiseChain, categoryNameKey) {
    return promiseChain.then(function () {
      return new Promise(function (resolve) {
        var emojisInCategory = categoryMap[categoryNameKey];
        var categoryMarkup = renderCategory(categoryLabelMap[categoryNameKey], emojisInCategory);
        requestAnimationFrame(function () {
          emojiContentElement.insertAdjacentHTML('beforeend', categoryMarkup);
          resolve();
        });
      });
    });
  }, Promise.resolve());

  allCategoriesAddedPromise.then(function () {
    // Used for tests
    // We check for the menu in case it was destroyed in the meantime
    if (menu) {
      menu.dispatchEvent(new CustomEvent('build-emoji-menu-finish'));
    }
  });
};

AwardsHandler.prototype.positionMenu = function positionMenu($menu, $addBtn) {
  var position = $addBtn.data('position');
  // The menu could potentially be off-screen or in a hidden overflow element
  // So we position the element absolute in the body
  var css = {
    top: $addBtn.offset().top + $addBtn.outerHeight() + 'px'
  };
  if (position === 'right') {
    css.left = $addBtn.offset().left - $menu.outerWidth() + 20 + 'px';
    $menu.addClass('is-aligned-right');
  } else {
    css.left = $addBtn.offset().left + 'px';
    $menu.removeClass('is-aligned-right');
  }
  return $menu.css(css);
};

AwardsHandler.prototype.addAward = function addAward(votesBlock, awardUrl, emoji, checkMutuality, callback) {
  var _this3 = this;

  var normalizedEmoji = this.normalizeEmojiName(emoji);
  this.postEmoji(awardUrl, normalizedEmoji, function () {
    _this3.addAwardToEmojiBar(votesBlock, normalizedEmoji, checkMutuality);
    return typeof callback === 'function' ? callback() : undefined;
  });
  $('.emoji-menu').removeClass('is-visible');
  $('.js-add-award.is-active').removeClass('is-active');
};

AwardsHandler.prototype.addAwardToEmojiBar = function addAwardToEmojiBar(votesBlock, emoji, checkForMutuality) {
  if (checkForMutuality || checkForMutuality === null) {
    this.checkMutuality(votesBlock, emoji);
  }
  this.addEmojiToFrequentlyUsedList(emoji);
  var normalizedEmoji = this.normalizeEmojiName(emoji);
  var $emojiButton = this.findEmojiIcon(votesBlock, normalizedEmoji).parent();
  if ($emojiButton.length > 0) {
    if (this.isActive($emojiButton)) {
      this.decrementCounter($emojiButton, normalizedEmoji);
    } else {
      var counter = $emojiButton.find('.js-counter');
      counter.text(parseInt(counter.text(), 10) + 1);
      $emojiButton.addClass('active');
      this.addYouToUserList(votesBlock, normalizedEmoji);
      this.animateEmoji($emojiButton);
    }
  } else {
    votesBlock.removeClass('hidden');
    this.createEmoji(votesBlock, normalizedEmoji);
  }
};

AwardsHandler.prototype.getVotesBlock = function getVotesBlock() {
  var currentBlock = $('.js-awards-block.current');
  var resultantVotesBlock = currentBlock;
  if (currentBlock.length === 0) {
    resultantVotesBlock = $('.js-awards-block').eq(0);
  }

  return resultantVotesBlock;
};

AwardsHandler.prototype.getAwardUrl = function getAwardUrl() {
  return this.getVotesBlock().data('award-url');
};

AwardsHandler.prototype.checkMutuality = function checkMutuality(votesBlock, emoji) {
  var awardUrl = this.getAwardUrl();
  if (emoji === 'thumbsup' || emoji === 'thumbsdown') {
    var mutualVote = emoji === 'thumbsup' ? 'thumbsdown' : 'thumbsup';
    var $emojiButton = votesBlock.find('[data-name="' + mutualVote + '"]').parent();
    var isAlreadyVoted = $emojiButton.hasClass('active');
    if (isAlreadyVoted) {
      this.addAward(votesBlock, awardUrl, mutualVote, false);
    }
  }
};

AwardsHandler.prototype.isActive = function isActive($emojiButton) {
  return $emojiButton.hasClass('active');
};

AwardsHandler.prototype.decrementCounter = function decrementCounter($emojiButton, emoji) {
  var counter = $('.js-counter', $emojiButton);
  var counterNumber = parseInt(counter.text(), 10);
  if (counterNumber > 1) {
    counter.text(counterNumber - 1);
    this.removeYouFromUserList($emojiButton);
  } else if (emoji === 'thumbsup' || emoji === 'thumbsdown') {
    $emojiButton.tooltip('destroy');
    counter.text('0');
    this.removeYouFromUserList($emojiButton);
    if ($emojiButton.parents('.note').length) {
      this.removeEmoji($emojiButton);
    }
  } else {
    this.removeEmoji($emojiButton);
  }
  return $emojiButton.removeClass('active');
};

AwardsHandler.prototype.removeEmoji = function removeEmoji($emojiButton) {
  $emojiButton.tooltip('destroy');
  $emojiButton.remove();
  var $votesBlock = this.getVotesBlock();
  if ($votesBlock.find('.js-emoji-btn').length === 0) {
    $votesBlock.addClass('hidden');
  }
};

AwardsHandler.prototype.getAwardTooltip = function getAwardTooltip($awardBlock) {
  return $awardBlock.attr('data-original-title') || $awardBlock.attr('data-title') || '';
};

AwardsHandler.prototype.toSentence = function toSentence(list) {
  var sentence = void 0;
  if (list.length <= 2) {
    sentence = list.join(' and ');
  } else {
    sentence = list.slice(0, -1).join(', ') + ', and ' + list[list.length - 1];
  }

  return sentence;
};

AwardsHandler.prototype.removeYouFromUserList = function removeYouFromUserList($emojiButton) {
  var awardBlock = $emojiButton;
  var originalTitle = this.getAwardTooltip(awardBlock);
  var authors = originalTitle.split(FROM_SENTENCE_REGEX);
  authors.splice(authors.indexOf('You'), 1);
  return awardBlock.closest('.js-emoji-btn').removeData('title').removeAttr('data-title').removeAttr('data-original-title').attr('title', this.toSentence(authors)).tooltip('fixTitle');
};

AwardsHandler.prototype.addYouToUserList = function addYouToUserList(votesBlock, emoji) {
  var awardBlock = this.findEmojiIcon(votesBlock, emoji).parent();
  var origTitle = this.getAwardTooltip(awardBlock);
  var users = [];
  if (origTitle) {
    users = origTitle.trim().split(FROM_SENTENCE_REGEX);
  }
  users.unshift('You');
  return awardBlock.attr('title', this.toSentence(users)).tooltip('fixTitle');
};

AwardsHandler.prototype.createAwardButtonForVotesBlock = function createAwardButtonForVotesBlock(votesBlock, emojiName) {
  var buttonHtml = '\n      <button class="btn award-control js-emoji-btn has-tooltip active" title="You" data-placement="bottom">\n        ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__behaviors_gl_emoji__["a" /* glEmojiTag */])(emojiName) + '\n        <span class="award-control-text js-counter">1</span>\n      </button>\n    ';
  var $emojiButton = $(buttonHtml);
  $emojiButton.insertBefore(votesBlock.find('.js-award-holder')).find('.emoji-icon').data('name', emojiName);
  this.animateEmoji($emojiButton);
  $('.award-control').tooltip();
  votesBlock.removeClass('current');
};

AwardsHandler.prototype.animateEmoji = function animateEmoji($emoji) {
  var className = 'pulse animated once short';
  $emoji.addClass(className);

  this.registerEventListener('on', $emoji, animationEndEventString, function (e) {
    $(e.currentTarget).removeClass(className);
  });
};

AwardsHandler.prototype.createEmoji = function createEmoji(votesBlock, emoji) {
  var _this4 = this;

  if ($('.emoji-menu').length) {
    this.createAwardButtonForVotesBlock(votesBlock, emoji);
  }
  this.createEmojiMenu(function () {
    _this4.createAwardButtonForVotesBlock(votesBlock, emoji);
  });
};

AwardsHandler.prototype.postEmoji = function postEmoji(awardUrl, emoji, callback) {
  return $.post(awardUrl, {
    name: emoji
  }, function (data) {
    if (data.ok) {
      callback();
    }
  });
};

AwardsHandler.prototype.findEmojiIcon = function findEmojiIcon(votesBlock, emoji) {
  return votesBlock.find('.js-emoji-btn [data-name="' + emoji + '"]');
};

AwardsHandler.prototype.scrollToAwards = function scrollToAwards() {
  var options = {
    scrollTop: $('.awards').offset().top - 110
  };
  return $('body, html').animate(options, 200);
};

AwardsHandler.prototype.normalizeEmojiName = function normalizeEmojiName(emoji) {
  return Object.prototype.hasOwnProperty.call(this.aliases, emoji) ? this.aliases[emoji] : emoji;
};

AwardsHandler.prototype.addEmojiToFrequentlyUsedList = function addEmojiToFrequentlyUsedList(emoji) {
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__behaviors_gl_emoji_is_emoji_name_valid__["a" /* default */])(emoji)) {
    this.frequentlyUsedEmojis = _.uniq(this.getFrequentlyUsedEmojis().concat(emoji));
    __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set('frequently_used_emojis', this.frequentlyUsedEmojis.join(','), { expires: 365 });
  }
};

AwardsHandler.prototype.getFrequentlyUsedEmojis = function getFrequentlyUsedEmojis() {
  var _this5 = this;

  return this.frequentlyUsedEmojis || function () {
    var frequentlyUsedEmojis = _.uniq((__WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('frequently_used_emojis') || '').split(','));
    _this5.frequentlyUsedEmojis = frequentlyUsedEmojis.filter(function (inputName) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__behaviors_gl_emoji_is_emoji_name_valid__["a" /* default */])(inputName);
    });

    return _this5.frequentlyUsedEmojis;
  }();
};

AwardsHandler.prototype.setupSearch = function setupSearch() {
  var _this6 = this;

  this.registerEventListener('on', $('input.emoji-search'), 'input', function (e) {
    var term = $(e.target).val().trim();
    // Clean previous search results
    $('ul.emoji-menu-search, h5.emoji-search-title').remove();
    if (term.length > 0) {
      // Generate a search result block
      var h5 = $('<h5 class="emoji-search-title"/>').text('Search results');
      var foundEmojis = _this6.searchEmojis(term).show();
      var ul = $('<ul>').addClass('emoji-menu-list emoji-menu-search').append(foundEmojis);
      $('.emoji-menu-content ul, .emoji-menu-content h5').hide();
      $('.emoji-menu-content').append(h5).append(ul);
    } else {
      $('.emoji-menu-content').children().show();
    }
  });
};

AwardsHandler.prototype.searchEmojis = function searchEmojis(term) {
  var safeTerm = term.toLowerCase();

  var namesMatchingAlias = [];
  Object.keys(__WEBPACK_IMPORTED_MODULE_2_emojis_aliases_json___default.a).forEach(function (alias) {
    if (alias.indexOf(safeTerm) >= 0) {
      namesMatchingAlias.push(__WEBPACK_IMPORTED_MODULE_2_emojis_aliases_json___default.a[alias]);
    }
  });
  var $matchingElements = namesMatchingAlias.concat(safeTerm).reduce(function ($result, searchTerm) {
    return $result.add($('.emoji-menu-list:not(.frequent-emojis) [data-name*="' + searchTerm + '"]'));
  }, $([]));
  return $matchingElements.closest('li').clone();
};

AwardsHandler.prototype.destroy = function destroy() {
  this.eventListeners.forEach(function (entry) {
    var _entry$element$off;

    (_entry$element$off = entry.element.off).call.apply(_entry$element$off, [entry.element].concat(_toConsumableArray(entry.args)));
  });
  $('.emoji-menu').remove();
};

/* harmony default export */ __webpack_exports__["a"] = (AwardsHandler);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("lwLq")))

/***/ }),

/***/ "svvi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hook__ = __webpack_require__("7h5G");
/* eslint-disable */



var HookInput = function HookInput(trigger, list, plugins, config) {
  __WEBPACK_IMPORTED_MODULE_0__hook__["a" /* default */].call(this, trigger, list, plugins, config);

  this.type = 'input';
  this.event = 'input';

  this.eventWrapper = {};

  this.addEvents();
  this.addPlugins();
};

Object.assign(HookInput.prototype, {
  addPlugins: function addPlugins() {
    var _this = this;

    this.plugins.forEach(function (plugin) {
      return plugin.init(_this);
    });
  },

  addEvents: function addEvents() {
    this.eventWrapper.mousedown = this.mousedown.bind(this);
    this.eventWrapper.input = this.input.bind(this);
    this.eventWrapper.keyup = this.keyup.bind(this);
    this.eventWrapper.keydown = this.keydown.bind(this);

    this.trigger.addEventListener('mousedown', this.eventWrapper.mousedown);
    this.trigger.addEventListener('input', this.eventWrapper.input);
    this.trigger.addEventListener('keyup', this.eventWrapper.keyup);
    this.trigger.addEventListener('keydown', this.eventWrapper.keydown);
  },

  removeEvents: function removeEvents() {
    this.hasRemovedEvents = true;

    this.trigger.removeEventListener('mousedown', this.eventWrapper.mousedown);
    this.trigger.removeEventListener('input', this.eventWrapper.input);
    this.trigger.removeEventListener('keyup', this.eventWrapper.keyup);
    this.trigger.removeEventListener('keydown', this.eventWrapper.keydown);
  },

  input: function input(e) {
    if (this.hasRemovedEvents) return;

    this.list.show();

    var inputEvent = new CustomEvent('input.dl', {
      detail: {
        hook: this,
        text: e.target.value
      },
      bubbles: true,
      cancelable: true
    });
    e.target.dispatchEvent(inputEvent);
  },

  mousedown: function mousedown(e) {
    if (this.hasRemovedEvents) return;

    var mouseEvent = new CustomEvent('mousedown.dl', {
      detail: {
        hook: this,
        text: e.target.value
      },
      bubbles: true,
      cancelable: true
    });
    e.target.dispatchEvent(mouseEvent);
  },

  keyup: function keyup(e) {
    if (this.hasRemovedEvents) return;

    this.keyEvent(e, 'keyup.dl');
  },

  keydown: function keydown(e) {
    if (this.hasRemovedEvents) return;

    this.keyEvent(e, 'keydown.dl');
  },

  keyEvent: function keyEvent(e, eventName) {
    this.list.show();

    var keyEvent = new CustomEvent(eventName, {
      detail: {
        hook: this,
        text: e.target.value,
        which: e.which,
        key: e.key
      },
      bubbles: true,
      cancelable: true
    });
    e.target.dispatchEvent(keyEvent);
  },

  restoreInitialState: function restoreInitialState() {
    this.list.list.innerHTML = this.list.initialState;
  },

  removePlugins: function removePlugins() {
    this.plugins.forEach(function (plugin) {
      return plugin.destroy();
    });
  },

  destroy: function destroy() {
    this.restoreInitialState();

    this.removeEvents();
    this.removePlugins();

    this.list.destroy();
  }
});

/* harmony default export */ __webpack_exports__["a"] = (HookInput);

/***/ }),

/***/ "tI6A":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, no-var, prefer-rest-params, wrap-iife, no-else-return, quotes, quote-props, comma-dangle, one-var, one-var-declaration-per-line, max-len */
/* global u2f */
/* global U2FError */
/* global U2FUtil */

// Register U2F (universal 2nd factor) devices for users to authenticate with.
//
// State Flow #1: setup -> in_progress -> registered -> POST to server
// State Flow #2: setup -> in_progress -> error -> setup
(function () {
  var bind = function bind(fn, me) {
    return function () {
      return fn.apply(me, arguments);
    };
  };

  this.U2FRegister = function () {
    function U2FRegister(container, u2fParams) {
      this.container = container;
      this.renderNotSupported = bind(this.renderNotSupported, this);
      this.renderRegistered = bind(this.renderRegistered, this);
      this.renderError = bind(this.renderError, this);
      this.renderInProgress = bind(this.renderInProgress, this);
      this.renderSetup = bind(this.renderSetup, this);
      this.renderTemplate = bind(this.renderTemplate, this);
      this.register = bind(this.register, this);
      this.start = bind(this.start, this);
      this.appId = u2fParams.app_id;
      this.registerRequests = u2fParams.register_requests;
      this.signRequests = u2fParams.sign_requests;
    }

    U2FRegister.prototype.start = function () {
      if (U2FUtil.isU2FSupported()) {
        return this.renderSetup();
      } else {
        return this.renderNotSupported();
      }
    };

    U2FRegister.prototype.register = function () {
      return u2f.register(this.appId, this.registerRequests, this.signRequests, function (_this) {
        return function (response) {
          var error;
          if (response.errorCode) {
            error = new U2FError(response.errorCode, 'register');
            return _this.renderError(error);
          } else {
            return _this.renderRegistered(JSON.stringify(response));
          }
        };
      }(this), 10);
    };

    // Rendering #
    U2FRegister.prototype.templates = {
      "notSupported": "#js-register-u2f-not-supported",
      "setup": '#js-register-u2f-setup',
      "inProgress": '#js-register-u2f-in-progress',
      "error": '#js-register-u2f-error',
      "registered": '#js-register-u2f-registered'
    };

    U2FRegister.prototype.renderTemplate = function (name, params) {
      var template, templateString;
      templateString = $(this.templates[name]).html();
      template = _.template(templateString);
      return this.container.html(template(params));
    };

    U2FRegister.prototype.renderSetup = function () {
      this.renderTemplate('setup');
      return this.container.find('#js-setup-u2f-device').on('click', this.renderInProgress);
    };

    U2FRegister.prototype.renderInProgress = function () {
      this.renderTemplate('inProgress');
      return this.register();
    };

    U2FRegister.prototype.renderError = function (error) {
      this.renderTemplate('error', {
        error_message: error.message(),
        error_code: error.errorCode
      });
      return this.container.find('#js-u2f-try-again').on('click', this.renderSetup);
    };

    U2FRegister.prototype.renderRegistered = function (deviceResponse) {
      this.renderTemplate('registered');
      // Prefer to do this instead of interpolating using Underscore templates
      // because of JSON escaping issues.
      return this.container.find("#js-device-response").val(deviceResponse);
    };

    U2FRegister.prototype.renderNotSupported = function () {
      return this.renderTemplate('notSupported');
    };

    return U2FRegister;
  }();
}).call(window);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "tZLB":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, wrap-iife */
/* global CommitFile */

window.Commit = function () {
  function Commit() {
    $('.files .diff-file').each(function () {
      return new CommitFile(this);
    });
  }

  return Commit;
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "u1Ad":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__blob_template_selector__ = __webpack_require__("iv5u");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable comma-dangle, max-len, no-useless-return, no-param-reassign, max-len */
/* global Api */



(function (global) {
  var IssuableTemplateSelector = function (_TemplateSelector) {
    _inherits(IssuableTemplateSelector, _TemplateSelector);

    function IssuableTemplateSelector() {
      var _ref;

      _classCallCheck(this, IssuableTemplateSelector);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var _this = _possibleConstructorReturn(this, (_ref = IssuableTemplateSelector.__proto__ || Object.getPrototypeOf(IssuableTemplateSelector)).call.apply(_ref, [this].concat(args)));

      _this.projectPath = _this.dropdown.data('project-path');
      _this.namespacePath = _this.dropdown.data('namespace-path');
      _this.issuableType = _this.$dropdownContainer.data('issuable-type');
      _this.titleInput = $('#' + _this.issuableType + '_title');

      var initialQuery = {
        name: _this.dropdown.data('selected')
      };

      if (initialQuery.name) _this.requestFile(initialQuery);

      $('.reset-template', _this.dropdown.parent()).on('click', function () {
        _this.setInputValueToTemplateContent();
      });

      $('.no-template', _this.dropdown.parent()).on('click', function () {
        _this.currentTemplate.content = '';
        _this.setInputValueToTemplateContent();
        $('.dropdown-toggle-text', _this.dropdown).text('Choose a template');
      });
      return _this;
    }

    _createClass(IssuableTemplateSelector, [{
      key: 'requestFile',
      value: function requestFile(query) {
        var _this2 = this;

        this.startLoadingSpinner();
        Api.issueTemplate(this.namespacePath, this.projectPath, query.name, this.issuableType, function (err, currentTemplate) {
          _this2.currentTemplate = currentTemplate;
          if (err) return; // Error handled by global AJAX error handler
          _this2.stopLoadingSpinner();
          _this2.setInputValueToTemplateContent();
        });
        return;
      }
    }, {
      key: 'setInputValueToTemplateContent',
      value: function setInputValueToTemplateContent() {
        // `this.setEditorContent` sets the value of the description input field
        // to the content of the template selected.
        if (this.titleInput.val() === '') {
          // If the title has not yet been set, focus the title input and
          // skip focusing the description input by setting `true` as the
          // `skipFocus` option to `setEditorContent`.
          this.setEditorContent(this.currentTemplate, { skipFocus: true });
          this.titleInput.focus();
        } else {
          this.setEditorContent(this.currentTemplate, { skipFocus: false });
        }
        return;
      }
    }]);

    return IssuableTemplateSelector;
  }(__WEBPACK_IMPORTED_MODULE_0__blob_template_selector__["a" /* default */]);

  global.IssuableTemplateSelector = IssuableTemplateSelector;
})(window.gl || (window.gl = {}));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("lwLq")))

/***/ }),

/***/ "ucU0":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable func-names, object-shorthand, comma-dangle, wrap-iife, space-before-function-paren, no-param-reassign, max-len */

var GroupLabelSubscription = function () {
  function GroupLabelSubscription(container) {
    _classCallCheck(this, GroupLabelSubscription);

    var $container = $(container);
    this.$dropdown = $container.find('.dropdown');
    this.$subscribeButtons = $container.find('.js-subscribe-button');
    this.$unsubscribeButtons = $container.find('.js-unsubscribe-button');

    this.$subscribeButtons.on('click', this.subscribe.bind(this));
    this.$unsubscribeButtons.on('click', this.unsubscribe.bind(this));
  }

  _createClass(GroupLabelSubscription, [{
    key: 'unsubscribe',
    value: function unsubscribe(event) {
      var _this = this;

      event.preventDefault();

      var url = this.$unsubscribeButtons.attr('data-url');

      $.ajax({
        type: 'POST',
        url: url
      }).done(function () {
        _this.toggleSubscriptionButtons();
        _this.$unsubscribeButtons.removeAttr('data-url');
      });
    }
  }, {
    key: 'subscribe',
    value: function subscribe(event) {
      var _this2 = this;

      event.preventDefault();

      var $btn = $(event.currentTarget);
      var url = $btn.attr('data-url');

      this.$unsubscribeButtons.attr('data-url', url);

      $.ajax({
        type: 'POST',
        url: url
      }).done(function () {
        _this2.toggleSubscriptionButtons();
      });
    }
  }, {
    key: 'toggleSubscriptionButtons',
    value: function toggleSubscriptionButtons() {
      this.$dropdown.toggleClass('hidden');
      this.$subscribeButtons.toggleClass('hidden');
      this.$unsubscribeButtons.toggleClass('hidden');
    }
  }]);

  return GroupLabelSubscription;
}();

window.gl = window.gl || {};
window.gl.GroupLabelSubscription = GroupLabelSubscription;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "vOe4":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, wrap-iife, one-var, no-var, camelcase, one-var-declaration-per-line, no-else-return, max-len */

window.ConfirmDangerModal = function () {
  function ConfirmDangerModal(form, text) {
    var project_path, submit;
    this.form = form;
    $('.js-confirm-text').text(text || '');
    $('.js-confirm-danger-input').val('');
    $('#modal-confirm-danger').modal('show');
    project_path = $('.js-confirm-danger-match').text();
    submit = $('.js-confirm-danger-submit');
    submit.disable();
    $('.js-confirm-danger-input').off('input');
    $('.js-confirm-danger-input').on('input', function () {
      if (gl.utils.rstrip($(this).val()) === project_path) {
        return submit.enable();
      } else {
        return submit.disable();
      }
    });
    $('.js-confirm-danger-submit').off('click');
    $('.js-confirm-danger-submit').on('click', function (_this) {
      return function () {
        return _this.form.submit();
      };
    }(this));
  }

  return ConfirmDangerModal;
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "vckv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Helper function that finds the href of the fiven selector and updates the location.
 *
 * @param  {String} selector
 */
/* harmony default export */ __webpack_exports__["a"] = (function (selector) {
  var link = document.querySelector(selector).getAttribute('href');

  if (link) {
    window.location = link;
  }
});

/***/ }),

/***/ "vd0+":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, wrap-iife, prefer-arrow-callback, no-unused-vars, consistent-return, camelcase, comma-dangle, max-len */
/* global Dropzone */
/* global Mousetrap */

// Zen Mode (full screen) textarea
//
/*= provides zen_mode:enter */
/*= provides zen_mode:leave */

__webpack_require__("IqsO");
window.Dropzone = __webpack_require__("Qepg");
__webpack_require__("b2AJ");
__webpack_require__("4f1f");

//
// ### Events
//
// `zen_mode:enter`
//
// Fired when the "Edit in fullscreen" link is clicked.
//
// **Synchronicity** Sync
// **Bubbles** Yes
// **Cancelable** No
// **Target** a.js-zen-enter
//
// `zen_mode:leave`
//
// Fired when the "Leave Fullscreen" link is clicked.
//
// **Synchronicity** Sync
// **Bubbles** Yes
// **Cancelable** No
// **Target** a.js-zen-leave
//
(function () {
  this.ZenMode = function () {
    function ZenMode() {
      this.active_backdrop = null;
      this.active_textarea = null;
      $(document).on('click', '.js-zen-enter', function (e) {
        e.preventDefault();
        return $(e.currentTarget).trigger('zen_mode:enter');
      });
      $(document).on('click', '.js-zen-leave', function (e) {
        e.preventDefault();
        return $(e.currentTarget).trigger('zen_mode:leave');
      });
      $(document).on('zen_mode:enter', function (_this) {
        return function (e) {
          return _this.enter($(e.target).closest('.md-area').find('.zen-backdrop'));
        };
      }(this));
      $(document).on('zen_mode:leave', function (_this) {
        return function (e) {
          return _this.exit();
        };
      }(this));
      $(document).on('keydown', function (e) {
        // Esc
        if (e.keyCode === 27) {
          e.preventDefault();
          return $(document).trigger('zen_mode:leave');
        }
      });
    }

    ZenMode.prototype.enter = function (backdrop) {
      Mousetrap.pause();
      this.active_backdrop = $(backdrop);
      this.active_backdrop.addClass('fullscreen');
      this.active_textarea = this.active_backdrop.find('textarea');
      // Prevent a user-resized textarea from persisting to fullscreen
      this.active_textarea.removeAttr('style');
      return this.active_textarea.focus();
    };

    ZenMode.prototype.exit = function () {
      if (this.active_textarea) {
        Mousetrap.unpause();
        this.active_textarea.closest('.zen-backdrop').removeClass('fullscreen');
        this.scrollTo(this.active_textarea);
        this.active_textarea = null;
        this.active_backdrop = null;
        return Dropzone.forElement('.div-dropzone').enable();
      }
    };

    ZenMode.prototype.scrollTo = function (zen_area) {
      return $.scrollTo(zen_area, 0, {
        offset: -150
      });
    };

    return ZenMode;
  }();
}).call(window);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "vfNn":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, no-var, prefer-rest-params, wrap-iife, prefer-arrow-callback, no-else-return, quotes, quote-props, comma-dangle, one-var, one-var-declaration-per-line, max-len */
/* global u2f */
/* global U2FError */
/* global U2FUtil */

// Authenticate U2F (universal 2nd factor) devices for users to authenticate with.
//
// State Flow #1: setup -> in_progress -> authenticated -> POST to server
// State Flow #2: setup -> in_progress -> error -> setup
(function () {
  var global = window.gl || (window.gl = {});

  var bind = function bind(fn, me) {
    return function () {
      return fn.apply(me, arguments);
    };
  };

  global.U2FAuthenticate = function () {
    function U2FAuthenticate(container, form, u2fParams, fallbackButton, fallbackUI) {
      this.container = container;
      this.renderNotSupported = bind(this.renderNotSupported, this);
      this.renderAuthenticated = bind(this.renderAuthenticated, this);
      this.renderError = bind(this.renderError, this);
      this.renderInProgress = bind(this.renderInProgress, this);
      this.renderTemplate = bind(this.renderTemplate, this);
      this.authenticate = bind(this.authenticate, this);
      this.start = bind(this.start, this);
      this.appId = u2fParams.app_id;
      this.challenge = u2fParams.challenge;
      this.form = form;
      this.fallbackButton = fallbackButton;
      this.fallbackUI = fallbackUI;
      if (this.fallbackButton) this.fallbackButton.addEventListener('click', this.switchToFallbackUI.bind(this));
      this.signRequests = u2fParams.sign_requests.map(function (request) {
        // The U2F Javascript API v1.1 requires a single challenge, with
        // _no challenges per-request_. The U2F Javascript API v1.0 requires a
        // challenge per-request, which is done by copying the single challenge
        // into every request.
        //
        // In either case, we don't need the per-request challenges that the server
        // has generated, so we can remove them.
        //
        // Note: The server library fixes this behaviour in (unreleased) version 1.0.0.
        // This can be removed once we upgrade.
        // https://github.com/castle/ruby-u2f/commit/103f428071a81cd3d5f80c2e77d522d5029946a4
        return _(request).omit('challenge');
      });
    }

    U2FAuthenticate.prototype.start = function () {
      if (U2FUtil.isU2FSupported()) {
        return this.renderInProgress();
      } else {
        return this.renderNotSupported();
      }
    };

    U2FAuthenticate.prototype.authenticate = function () {
      return u2f.sign(this.appId, this.challenge, this.signRequests, function (_this) {
        return function (response) {
          var error;
          if (response.errorCode) {
            error = new U2FError(response.errorCode, 'authenticate');
            return _this.renderError(error);
          } else {
            return _this.renderAuthenticated(JSON.stringify(response));
          }
        };
      }(this), 10);
    };

    // Rendering #
    U2FAuthenticate.prototype.templates = {
      "notSupported": "#js-authenticate-u2f-not-supported",
      "setup": '#js-authenticate-u2f-setup',
      "inProgress": '#js-authenticate-u2f-in-progress',
      "error": '#js-authenticate-u2f-error',
      "authenticated": '#js-authenticate-u2f-authenticated'
    };

    U2FAuthenticate.prototype.renderTemplate = function (name, params) {
      var template, templateString;
      templateString = $(this.templates[name]).html();
      template = _.template(templateString);
      return this.container.html(template(params));
    };

    U2FAuthenticate.prototype.renderInProgress = function () {
      this.renderTemplate('inProgress');
      return this.authenticate();
    };

    U2FAuthenticate.prototype.renderError = function (error) {
      this.renderTemplate('error', {
        error_message: error.message(),
        error_code: error.errorCode
      });
      return this.container.find('#js-u2f-try-again').on('click', this.renderInProgress);
    };

    U2FAuthenticate.prototype.renderAuthenticated = function (deviceResponse) {
      this.renderTemplate('authenticated');
      var container = this.container[0];
      container.querySelector('#js-device-response').value = deviceResponse;
      container.querySelector(this.form).submit();
      this.fallbackButton.classList.add('hidden');
    };

    U2FAuthenticate.prototype.renderNotSupported = function () {
      return this.renderTemplate('notSupported');
    };

    U2FAuthenticate.prototype.switchToFallbackUI = function () {
      this.fallbackButton.classList.add('hidden');
      this.container[0].classList.add('hidden');
      this.fallbackUI.classList.remove('hidden');
    };

    return U2FAuthenticate;
  }();
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "vkML":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {
// Toggle button. Show/hide content inside parent container.
// Button does not change visibility. If button has icon - it changes chevron style.
//
// %div.js-toggle-container
//   %button.js-toggle-button
//   %div.js-toggle-content
//

$(function () {
  function toggleContainer(container, toggleState) {
    var $container = $(container);

    $container.find('.js-toggle-button .fa').toggleClass('fa-chevron-up', toggleState).toggleClass('fa-chevron-down', toggleState !== undefined ? !toggleState : undefined);

    $container.find('.js-toggle-content').toggle(toggleState);
  }

  $('body').on('click', '.js-toggle-button', function toggleButton(e) {
    toggleContainer($(this).closest('.js-toggle-container'));

    var targetTag = e.currentTarget.tagName.toLowerCase();
    if (targetTag === 'a' || targetTag === 'button') {
      e.preventDefault();
    }
  });

  // If we're accessing a permalink, ensure it is not inside a
  // closed js-toggle-container!
  var hash = window.gl.utils.getLocationHash();
  var anchor = hash && document.getElementById(hash);
  var container = anchor && $(anchor).closest('.js-toggle-container');

  if (container) {
    toggleContainer(container, true);
    anchor.scrollIntoView();
  }
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "w2Or":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function BlobForkSuggestion(openButton, cancelButton, suggestionSection) {
  if (openButton) {
    openButton.addEventListener('click', function () {
      suggestionSection.classList.remove('hidden');
    });
  }

  if (cancelButton) {
    cancelButton.addEventListener('click', function () {
      suggestionSection.classList.add('hidden');
    });
  }
}

/* harmony default export */ __webpack_exports__["a"] = (BlobForkSuggestion);

/***/ }),

/***/ "whmF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Makes search request for content when user types a value in the search input.
 * Updates the html content of the page with the received one.
 */

var FilterableList = function () {
  function FilterableList(form, filter, holder) {
    _classCallCheck(this, FilterableList);

    this.filterForm = form;
    this.listFilterElement = filter;
    this.listHolderElement = holder;
  }

  _createClass(FilterableList, [{
    key: 'initSearch',
    value: function initSearch() {
      this.debounceFilter = _.debounce(this.filterResults.bind(this), 500);

      this.listFilterElement.removeEventListener('input', this.debounceFilter);
      this.listFilterElement.addEventListener('input', this.debounceFilter);
    }
  }, {
    key: 'filterResults',
    value: function filterResults() {
      var form = this.filterForm;
      var filterUrl = form.getAttribute('action') + '?' + $(form).serialize();

      $(this.listHolderElement).fadeTo(250, 0.5);

      return $.ajax({
        url: form.getAttribute('action'),
        data: $(form).serialize(),
        type: 'GET',
        dataType: 'json',
        context: this,
        complete: function complete() {
          $(this.listHolderElement).fadeTo(250, 1);
        },
        success: function success(data) {
          this.listHolderElement.innerHTML = data.html;

          // Change url so if user reload a page - search results are saved
          return window.history.replaceState({
            page: filterUrl

          }, document.title, filterUrl);
        }
      });
    }
  }]);

  return FilterableList;
}();

/* harmony default export */ __webpack_exports__["a"] = (FilterableList);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("lwLq")))

/***/ }),

/***/ "wmIu":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, no-var, prefer-arrow-callback, no-unused-vars, one-var, one-var-declaration-per-line, vars-on-top, max-len */

(function () {
  var hideEndFade;

  hideEndFade = function hideEndFade($scrollingTabs) {
    return $scrollingTabs.each(function () {
      var $this;
      $this = $(this);
      return $this.siblings('.fade-right').toggleClass('scrolling', $this.width() < $this.prop('scrollWidth'));
    });
  };

  $(document).on('init.scrolling-tabs', function () {
    var $scrollingTabs = $('.scrolling-tabs').not('.is-initialized');
    $scrollingTabs.addClass('is-initialized');

    hideEndFade($scrollingTabs);
    $(window).off('resize.nav').on('resize.nav', function () {
      return hideEndFade($scrollingTabs);
    });
    $scrollingTabs.off('scroll').on('scroll', function (event) {
      var $this, currentPosition, maxPosition;
      $this = $(this);
      currentPosition = $this.scrollLeft();
      maxPosition = $this.prop('scrollWidth') - $this.outerWidth();
      $this.siblings('.fade-left').toggleClass('scrolling', currentPosition > 0);
      return $this.siblings('.fade-right').toggleClass('scrolling', currentPosition < maxPosition - 1);
    });

    $scrollingTabs.each(function () {
      var $this = $(this);
      var scrollingTabWidth = $this.width();
      var $active = $this.find('.active');
      var activeWidth = $active.width();

      if ($active.length) {
        var offset = $active.offset().left + activeWidth;

        if (offset > scrollingTabWidth - 30) {
          var scrollLeft = scrollingTabWidth / 2;
          scrollLeft = offset - scrollLeft - activeWidth / 2;
          $this.scrollLeft(scrollLeft);
        }
      }
    });
  });
}).call(window);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "wqCH":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, no-var, prefer-rest-params, wrap-iife, quotes, consistent-return, one-var, one-var-declaration-per-line, no-cond-assign, max-len, object-shorthand, no-param-reassign, comma-dangle, prefer-template, no-unused-vars, no-return-assign */
/* global fuzzaldrinPlus */

(function () {
  var bind = function bind(fn, me) {
    return function () {
      return fn.apply(me, arguments);
    };
  };

  this.ProjectFindFile = function () {
    var highlighter;

    function ProjectFindFile(element1, options) {
      this.element = element1;
      this.options = options;
      this.goToBlob = bind(this.goToBlob, this);
      this.goToTree = bind(this.goToTree, this);
      this.selectRowDown = bind(this.selectRowDown, this);
      this.selectRowUp = bind(this.selectRowUp, this);
      this.filePaths = {};
      this.inputElement = this.element.find(".file-finder-input");
      // init event
      this.initEvent();
      // focus text input box
      this.inputElement.focus();
      // load file list
      this.load(this.options.url);
    }

    ProjectFindFile.prototype.initEvent = function () {
      this.inputElement.off("keyup");
      this.inputElement.on("keyup", function (_this) {
        return function (event) {
          var oldValue, ref, target, value;
          target = $(event.target);
          value = target.val();
          oldValue = (ref = target.data("oldValue")) != null ? ref : "";
          if (value !== oldValue) {
            target.data("oldValue", value);
            _this.findFile();
            return _this.element.find("tr.tree-item").eq(0).addClass("selected").focus();
          }
        };
      }(this));
    };

    ProjectFindFile.prototype.findFile = function () {
      var result, searchText;
      searchText = this.inputElement.val();
      result = searchText.length > 0 ? fuzzaldrinPlus.filter(this.filePaths, searchText) : this.filePaths;
      return this.renderList(result, searchText);
      // find file
    };

    // files pathes load
    ProjectFindFile.prototype.load = function (url) {
      return $.ajax({
        url: url,
        method: "get",
        dataType: "json",
        success: function (_this) {
          return function (data) {
            _this.element.find(".loading").hide();
            _this.filePaths = data;
            _this.findFile();
            return _this.element.find(".files-slider tr.tree-item").eq(0).addClass("selected").focus();
          };
        }(this)
      });
    };

    // render result
    ProjectFindFile.prototype.renderList = function (filePaths, searchText) {
      var blobItemUrl, filePath, html, i, j, len, matches, results;
      this.element.find(".tree-table > tbody").empty();
      results = [];
      for (i = j = 0, len = filePaths.length; j < len; i = j += 1) {
        filePath = filePaths[i];
        if (i === 20) {
          break;
        }
        if (searchText) {
          matches = fuzzaldrinPlus.match(filePath, searchText);
        }
        blobItemUrl = this.options.blobUrlTemplate + "/" + filePath;
        html = this.makeHtml(filePath, matches, blobItemUrl);
        results.push(this.element.find(".tree-table > tbody").append(html));
      }
      return results;
    };

    // highlight text(awefwbwgtc -> <b>a</b>wefw<b>b</b>wgt<b>c</b> )
    highlighter = function highlighter(element, text, matches) {
      var highlightText, j, lastIndex, len, matchIndex, matchedChars, unmatched;
      lastIndex = 0;
      highlightText = "";
      matchedChars = [];
      for (j = 0, len = matches.length; j < len; j += 1) {
        matchIndex = matches[j];
        unmatched = text.substring(lastIndex, matchIndex);
        if (unmatched) {
          if (matchedChars.length) {
            element.append(matchedChars.join("").bold());
          }
          matchedChars = [];
          element.append(document.createTextNode(unmatched));
        }
        matchedChars.push(text[matchIndex]);
        lastIndex = matchIndex + 1;
      }
      if (matchedChars.length) {
        element.append(matchedChars.join("").bold());
      }
      return element.append(document.createTextNode(text.substring(lastIndex)));
    };

    // make tbody row html
    ProjectFindFile.prototype.makeHtml = function (filePath, matches, blobItemUrl) {
      var $tr;
      $tr = $("<tr class='tree-item'><td class='tree-item-file-name link-container'><a><i class='fa fa-file-text-o fa-fw'></i><span class='str-truncated'></span></a></td></tr>");
      if (matches) {
        $tr.find("a").replaceWith(highlighter($tr.find("a"), filePath, matches).attr("href", blobItemUrl));
      } else {
        $tr.find("a").attr("href", blobItemUrl);
        $tr.find(".str-truncated").text(filePath);
      }
      return $tr;
    };

    ProjectFindFile.prototype.selectRow = function (type) {
      var next, rows, selectedRow;
      rows = this.element.find(".files-slider tr.tree-item");
      selectedRow = this.element.find(".files-slider tr.tree-item.selected");
      if (rows && rows.length > 0) {
        if (selectedRow && selectedRow.length > 0) {
          if (type === "UP") {
            next = selectedRow.prev();
          } else if (type === "DOWN") {
            next = selectedRow.next();
          }
          if (next.length > 0) {
            selectedRow.removeClass("selected");
            selectedRow = next;
          }
        } else {
          selectedRow = rows.eq(0);
        }
        return selectedRow.addClass("selected").focus();
      }
    };

    ProjectFindFile.prototype.selectRowUp = function () {
      return this.selectRow("UP");
    };

    ProjectFindFile.prototype.selectRowDown = function () {
      return this.selectRow("DOWN");
    };

    ProjectFindFile.prototype.goToTree = function () {
      return location.href = this.options.treeUrl;
    };

    ProjectFindFile.prototype.goToBlob = function () {
      var $link = this.element.find(".tree-item.selected .tree-item-file-name a");

      if ($link.length) {
        $link.get(0).click();
      }
    };

    return ProjectFindFile;
  }();
}).call(window);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "wrBJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__("yoQO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* eslint-disable func-names, space-before-function-paren, wrap-iife, no-var, quotes, consistent-return, no-new, prefer-arrow-callback, no-return-assign, one-var, one-var-declaration-per-line, object-shorthand, comma-dangle, no-else-return, newline-per-chained-call, no-shadow, vars-on-top, prefer-template, max-len */
/* global ProjectSelect */



(function () {
  this.Project = function () {
    function Project() {
      $('ul.clone-options-dropdown a').click(function () {
        var url;
        if ($(this).hasClass('active')) {
          return;
        }
        $('.active').not($(this)).removeClass('active');
        $(this).toggleClass('active');
        url = $("#project_clone").val();
        $('#project_clone').val(url);
        return $('.clone').text(url);
        // Git protocol switcher
        // Remove the active class for all buttons (ssh, http, kerberos if shown)
        // Add the active class for the clicked button
        // Update the input field
        // Update the command line instructions
      });
      // Ref switcher
      this.initRefSwitcher();
      $('.project-refs-select').on('change', function () {
        return $(this).parents('form').submit();
      });
      $('.hide-no-ssh-message').on('click', function (e) {
        __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set('hide_no_ssh_message', 'false');
        $(this).parents('.no-ssh-key-message').remove();
        return e.preventDefault();
      });
      $('.hide-no-password-message').on('click', function (e) {
        __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set('hide_no_password_message', 'false');
        $(this).parents('.no-password-message').remove();
        return e.preventDefault();
      });
      this.projectSelectDropdown();
    }

    Project.prototype.projectSelectDropdown = function () {
      new ProjectSelect();
      $('.project-item-select').on('click', function (_this) {
        return function (e) {
          return _this.changeProject($(e.currentTarget).val());
        };
      }(this));
      return $('.js-projects-dropdown-toggle').on('click', function (e) {
        e.preventDefault();
        return $('.js-projects-dropdown').select2('open');
      });
    };

    Project.prototype.changeProject = function (url) {
      return window.location = url;
    };

    Project.prototype.initRefSwitcher = function () {
      var refListItem = document.createElement('li');
      var refLink = document.createElement('a');

      refLink.href = '#';

      return $('.js-project-refs-dropdown').each(function () {
        var $dropdown, selected;
        $dropdown = $(this);
        selected = $dropdown.data('selected');
        return $dropdown.glDropdown({
          data: function data(term, callback) {
            return $.ajax({
              url: $dropdown.data('refs-url'),
              data: {
                ref: $dropdown.data('ref'),
                search: term
              },
              dataType: "json"
            }).done(function (refs) {
              return callback(refs);
            });
          },
          selectable: true,
          filterable: true,
          filterRemote: true,
          filterByText: true,
          fieldName: $dropdown.data('field-name'),
          renderRow: function renderRow(ref) {
            var li = refListItem.cloneNode(false);

            if (ref.header != null) {
              li.className = 'dropdown-header';
              li.textContent = ref.header;
            } else {
              var link = refLink.cloneNode(false);

              if (ref === selected) {
                link.className = 'is-active';
              }

              link.textContent = ref;
              link.dataset.ref = ref;

              li.appendChild(link);
            }

            return li;
          },
          id: function id(obj, $el) {
            return $el.attr('data-ref');
          },
          toggleLabel: function toggleLabel(obj, $el) {
            return $el.text().trim();
          },
          clicked: function clicked(selected, $el, e) {
            e.preventDefault();
            if ($('input[name="ref"]').length) {
              var $form = $dropdown.closest('form');
              var action = $form.attr('action');
              var divider = action.indexOf('?') === -1 ? '?' : '&';
              gl.utils.visitUrl(action + '' + divider + '' + $form.serialize());
            }
          }
        });
      });
    };

    return Project;
  }();
}).call(window);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("lwLq")))

/***/ }),

/***/ "wstl":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {__webpack_require__("RsTm");
__webpack_require__("2iOG");

(function () {
  var ENDLESS_SCROLL_BOTTOM_PX = 400;
  var ENDLESS_SCROLL_FIRE_DELAY_MS = 1000;

  var Pager = {
    init: function init() {
      var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var preload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var disable = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $.noop;

      this.url = $('.content_list').data('href') || gl.utils.removeParams(['limit', 'offset']);
      this.limit = limit;
      this.offset = parseInt(gl.utils.getParameterByName('offset'), 10) || this.limit;
      this.disable = disable;
      this.callback = callback;
      this.loading = $('.loading').first();
      if (preload) {
        this.offset = 0;
        this.getOld();
      }
      this.initLoadMore();
    },
    getOld: function getOld() {
      var _this = this;

      this.loading.show();
      $.ajax({
        type: 'GET',
        url: this.url,
        data: 'limit=' + this.limit + '&offset=' + this.offset,
        dataType: 'json',
        error: function error() {
          return _this.loading.hide();
        },
        success: function success(data) {
          _this.append(data.count, data.html);
          _this.callback();

          // keep loading until we've filled the viewport height
          if (!_this.disable && !_this.isScrollable()) {
            _this.getOld();
          } else {
            _this.loading.hide();
          }
        }
      });
    },
    append: function append(count, html) {
      $('.content_list').append(html);
      if (count > 0) {
        this.offset += count;
      } else {
        this.disable = true;
      }
    },
    isScrollable: function isScrollable() {
      var $w = $(window);
      return $(document).height() > $w.height() + $w.scrollTop() + ENDLESS_SCROLL_BOTTOM_PX;
    },
    initLoadMore: function initLoadMore() {
      var _this2 = this;

      $(document).unbind('scroll');
      $(document).endlessScroll({
        bottomPixels: ENDLESS_SCROLL_BOTTOM_PX,
        fireDelay: ENDLESS_SCROLL_FIRE_DELAY_MS,
        fireOnce: true,
        ceaseFire: function ceaseFire() {
          return _this2.disable === true;
        },
        callback: function callback() {
          if (!_this2.loading.is(':visible')) {
            _this2.loading.show();
            _this2.getOld();
          }
        }
      });
    }
  };

  window.Pager = Pager;
})();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "wtTe":
/***/ (function(module, exports) {

/* eslint-disable func-names, space-before-function-paren, no-var, prefer-rest-params, wrap-iife, no-console, quotes, prefer-template, max-len */
/* global u2f */

(function () {
  var bind = function bind(fn, me) {
    return function () {
      return fn.apply(me, arguments);
    };
  };

  this.U2FError = function () {
    function U2FError(errorCode, u2fFlowType) {
      this.errorCode = errorCode;
      this.message = bind(this.message, this);
      this.httpsDisabled = window.location.protocol !== 'https:';
      this.u2fFlowType = u2fFlowType;
    }

    U2FError.prototype.message = function () {
      if (this.errorCode === u2f.ErrorCodes.BAD_REQUEST && this.httpsDisabled) {
        return 'U2F only works with HTTPS-enabled websites. Contact your administrator for more details.';
      } else if (this.errorCode === u2f.ErrorCodes.DEVICE_INELIGIBLE) {
        if (this.u2fFlowType === 'authenticate') return 'This device has not been registered with us.';
        if (this.u2fFlowType === 'register') return 'This device has already been registered with us.';
      }
      return "There was a problem communicating with your device.";
    };

    return U2FError;
  }();
}).call(window);

/***/ }),

/***/ "xUX4":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, wrap-iife, prefer-arrow-callback, max-len */
(function () {
  this.ProjectFork = function () {
    function ProjectFork() {
      $('.fork-thumbnail a').on('click', function () {
        $('.fork-namespaces').hide();
        return $('.save-project-loader').show();
      });
    }

    return ProjectFork;
  }();
}).call(window);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "xxp0":
/***/ (function(module, exports) {

// Converting text to basic latin (aka removing accents)
//
// Based on: http://semplicewebsites.com/removing-accents-javascript
//
var Latinise = {
  map: {"Á":"A","Ă":"A","Ắ":"A","Ặ":"A","Ằ":"A","Ẳ":"A","Ẵ":"A","Ǎ":"A","Â":"A","Ấ":"A","Ậ":"A","Ầ":"A","Ẩ":"A","Ẫ":"A","Ä":"A","Ǟ":"A","Ȧ":"A","Ǡ":"A","Ạ":"A","Ȁ":"A","À":"A","Ả":"A","Ȃ":"A","Ā":"A","Ą":"A","Å":"A","Ǻ":"A","Ḁ":"A","Ⱥ":"A","Ã":"A","Ꜳ":"AA","Æ":"AE","Ǽ":"AE","Ǣ":"AE","Ꜵ":"AO","Ꜷ":"AU","Ꜹ":"AV","Ꜻ":"AV","Ꜽ":"AY","Ḃ":"B","Ḅ":"B","Ɓ":"B","Ḇ":"B","Ƀ":"B","Ƃ":"B","Ć":"C","Č":"C","Ç":"C","Ḉ":"C","Ĉ":"C","Ċ":"C","Ƈ":"C","Ȼ":"C","Ď":"D","Ḑ":"D","Ḓ":"D","Ḋ":"D","Ḍ":"D","Ɗ":"D","Ḏ":"D","ǲ":"D","ǅ":"D","Đ":"D","Ƌ":"D","Ǳ":"DZ","Ǆ":"DZ","É":"E","Ĕ":"E","Ě":"E","Ȩ":"E","Ḝ":"E","Ê":"E","Ế":"E","Ệ":"E","Ề":"E","Ể":"E","Ễ":"E","Ḙ":"E","Ë":"E","Ė":"E","Ẹ":"E","Ȅ":"E","È":"E","Ẻ":"E","Ȇ":"E","Ē":"E","Ḗ":"E","Ḕ":"E","Ę":"E","Ɇ":"E","Ẽ":"E","Ḛ":"E","Ꝫ":"ET","Ḟ":"F","Ƒ":"F","Ǵ":"G","Ğ":"G","Ǧ":"G","Ģ":"G","Ĝ":"G","Ġ":"G","Ɠ":"G","Ḡ":"G","Ǥ":"G","Ḫ":"H","Ȟ":"H","Ḩ":"H","Ĥ":"H","Ⱨ":"H","Ḧ":"H","Ḣ":"H","Ḥ":"H","Ħ":"H","Í":"I","Ĭ":"I","Ǐ":"I","Î":"I","Ï":"I","Ḯ":"I","İ":"I","Ị":"I","Ȉ":"I","Ì":"I","Ỉ":"I","Ȋ":"I","Ī":"I","Į":"I","Ɨ":"I","Ĩ":"I","Ḭ":"I","Ꝺ":"D","Ꝼ":"F","Ᵹ":"G","Ꞃ":"R","Ꞅ":"S","Ꞇ":"T","Ꝭ":"IS","Ĵ":"J","Ɉ":"J","Ḱ":"K","Ǩ":"K","Ķ":"K","Ⱪ":"K","Ꝃ":"K","Ḳ":"K","Ƙ":"K","Ḵ":"K","Ꝁ":"K","Ꝅ":"K","Ĺ":"L","Ƚ":"L","Ľ":"L","Ļ":"L","Ḽ":"L","Ḷ":"L","Ḹ":"L","Ⱡ":"L","Ꝉ":"L","Ḻ":"L","Ŀ":"L","Ɫ":"L","ǈ":"L","Ł":"L","Ǉ":"LJ","Ḿ":"M","Ṁ":"M","Ṃ":"M","Ɱ":"M","Ń":"N","Ň":"N","Ņ":"N","Ṋ":"N","Ṅ":"N","Ṇ":"N","Ǹ":"N","Ɲ":"N","Ṉ":"N","Ƞ":"N","ǋ":"N","Ñ":"N","Ǌ":"NJ","Ó":"O","Ŏ":"O","Ǒ":"O","Ô":"O","Ố":"O","Ộ":"O","Ồ":"O","Ổ":"O","Ỗ":"O","Ö":"O","Ȫ":"O","Ȯ":"O","Ȱ":"O","Ọ":"O","Ő":"O","Ȍ":"O","Ò":"O","Ỏ":"O","Ơ":"O","Ớ":"O","Ợ":"O","Ờ":"O","Ở":"O","Ỡ":"O","Ȏ":"O","Ꝋ":"O","Ꝍ":"O","Ō":"O","Ṓ":"O","Ṑ":"O","Ɵ":"O","Ǫ":"O","Ǭ":"O","Ø":"O","Ǿ":"O","Õ":"O","Ṍ":"O","Ṏ":"O","Ȭ":"O","Ƣ":"OI","Ꝏ":"OO","Ɛ":"E","Ɔ":"O","Ȣ":"OU","Ṕ":"P","Ṗ":"P","Ꝓ":"P","Ƥ":"P","Ꝕ":"P","Ᵽ":"P","Ꝑ":"P","Ꝙ":"Q","Ꝗ":"Q","Ŕ":"R","Ř":"R","Ŗ":"R","Ṙ":"R","Ṛ":"R","Ṝ":"R","Ȑ":"R","Ȓ":"R","Ṟ":"R","Ɍ":"R","Ɽ":"R","Ꜿ":"C","Ǝ":"E","Ś":"S","Ṥ":"S","Š":"S","Ṧ":"S","Ş":"S","Ŝ":"S","Ș":"S","Ṡ":"S","Ṣ":"S","Ṩ":"S","ẞ":"SS","Ť":"T","Ţ":"T","Ṱ":"T","Ț":"T","Ⱦ":"T","Ṫ":"T","Ṭ":"T","Ƭ":"T","Ṯ":"T","Ʈ":"T","Ŧ":"T","Ɐ":"A","Ꞁ":"L","Ɯ":"M","Ʌ":"V","Ꜩ":"TZ","Ú":"U","Ŭ":"U","Ǔ":"U","Û":"U","Ṷ":"U","Ü":"U","Ǘ":"U","Ǚ":"U","Ǜ":"U","Ǖ":"U","Ṳ":"U","Ụ":"U","Ű":"U","Ȕ":"U","Ù":"U","Ủ":"U","Ư":"U","Ứ":"U","Ự":"U","Ừ":"U","Ử":"U","Ữ":"U","Ȗ":"U","Ū":"U","Ṻ":"U","Ų":"U","Ů":"U","Ũ":"U","Ṹ":"U","Ṵ":"U","Ꝟ":"V","Ṿ":"V","Ʋ":"V","Ṽ":"V","Ꝡ":"VY","Ẃ":"W","Ŵ":"W","Ẅ":"W","Ẇ":"W","Ẉ":"W","Ẁ":"W","Ⱳ":"W","Ẍ":"X","Ẋ":"X","Ý":"Y","Ŷ":"Y","Ÿ":"Y","Ẏ":"Y","Ỵ":"Y","Ỳ":"Y","Ƴ":"Y","Ỷ":"Y","Ỿ":"Y","Ȳ":"Y","Ɏ":"Y","Ỹ":"Y","Ź":"Z","Ž":"Z","Ẑ":"Z","Ⱬ":"Z","Ż":"Z","Ẓ":"Z","Ȥ":"Z","Ẕ":"Z","Ƶ":"Z","Ĳ":"IJ","Œ":"OE","ᴀ":"A","ᴁ":"AE","ʙ":"B","ᴃ":"B","ᴄ":"C","ᴅ":"D","ᴇ":"E","ꜰ":"F","ɢ":"G","ʛ":"G","ʜ":"H","ɪ":"I","ʁ":"R","ᴊ":"J","ᴋ":"K","ʟ":"L","ᴌ":"L","ᴍ":"M","ɴ":"N","ᴏ":"O","ɶ":"OE","ᴐ":"O","ᴕ":"OU","ᴘ":"P","ʀ":"R","ᴎ":"N","ᴙ":"R","ꜱ":"S","ᴛ":"T","ⱻ":"E","ᴚ":"R","ᴜ":"U","ᴠ":"V","ᴡ":"W","ʏ":"Y","ᴢ":"Z","á":"a","ă":"a","ắ":"a","ặ":"a","ằ":"a","ẳ":"a","ẵ":"a","ǎ":"a","â":"a","ấ":"a","ậ":"a","ầ":"a","ẩ":"a","ẫ":"a","ä":"a","ǟ":"a","ȧ":"a","ǡ":"a","ạ":"a","ȁ":"a","à":"a","ả":"a","ȃ":"a","ā":"a","ą":"a","ᶏ":"a","ẚ":"a","å":"a","ǻ":"a","ḁ":"a","ⱥ":"a","ã":"a","ꜳ":"aa","æ":"ae","ǽ":"ae","ǣ":"ae","ꜵ":"ao","ꜷ":"au","ꜹ":"av","ꜻ":"av","ꜽ":"ay","ḃ":"b","ḅ":"b","ɓ":"b","ḇ":"b","ᵬ":"b","ᶀ":"b","ƀ":"b","ƃ":"b","ɵ":"o","ć":"c","č":"c","ç":"c","ḉ":"c","ĉ":"c","ɕ":"c","ċ":"c","ƈ":"c","ȼ":"c","ď":"d","ḑ":"d","ḓ":"d","ȡ":"d","ḋ":"d","ḍ":"d","ɗ":"d","ᶑ":"d","ḏ":"d","ᵭ":"d","ᶁ":"d","đ":"d","ɖ":"d","ƌ":"d","ı":"i","ȷ":"j","ɟ":"j","ʄ":"j","ǳ":"dz","ǆ":"dz","é":"e","ĕ":"e","ě":"e","ȩ":"e","ḝ":"e","ê":"e","ế":"e","ệ":"e","ề":"e","ể":"e","ễ":"e","ḙ":"e","ë":"e","ė":"e","ẹ":"e","ȅ":"e","è":"e","ẻ":"e","ȇ":"e","ē":"e","ḗ":"e","ḕ":"e","ⱸ":"e","ę":"e","ᶒ":"e","ɇ":"e","ẽ":"e","ḛ":"e","ꝫ":"et","ḟ":"f","ƒ":"f","ᵮ":"f","ᶂ":"f","ǵ":"g","ğ":"g","ǧ":"g","ģ":"g","ĝ":"g","ġ":"g","ɠ":"g","ḡ":"g","ᶃ":"g","ǥ":"g","ḫ":"h","ȟ":"h","ḩ":"h","ĥ":"h","ⱨ":"h","ḧ":"h","ḣ":"h","ḥ":"h","ɦ":"h","ẖ":"h","ħ":"h","ƕ":"hv","í":"i","ĭ":"i","ǐ":"i","î":"i","ï":"i","ḯ":"i","ị":"i","ȉ":"i","ì":"i","ỉ":"i","ȋ":"i","ī":"i","į":"i","ᶖ":"i","ɨ":"i","ĩ":"i","ḭ":"i","ꝺ":"d","ꝼ":"f","ᵹ":"g","ꞃ":"r","ꞅ":"s","ꞇ":"t","ꝭ":"is","ǰ":"j","ĵ":"j","ʝ":"j","ɉ":"j","ḱ":"k","ǩ":"k","ķ":"k","ⱪ":"k","ꝃ":"k","ḳ":"k","ƙ":"k","ḵ":"k","ᶄ":"k","ꝁ":"k","ꝅ":"k","ĺ":"l","ƚ":"l","ɬ":"l","ľ":"l","ļ":"l","ḽ":"l","ȴ":"l","ḷ":"l","ḹ":"l","ⱡ":"l","ꝉ":"l","ḻ":"l","ŀ":"l","ɫ":"l","ᶅ":"l","ɭ":"l","ł":"l","ǉ":"lj","ſ":"s","ẜ":"s","ẛ":"s","ẝ":"s","ḿ":"m","ṁ":"m","ṃ":"m","ɱ":"m","ᵯ":"m","ᶆ":"m","ń":"n","ň":"n","ņ":"n","ṋ":"n","ȵ":"n","ṅ":"n","ṇ":"n","ǹ":"n","ɲ":"n","ṉ":"n","ƞ":"n","ᵰ":"n","ᶇ":"n","ɳ":"n","ñ":"n","ǌ":"nj","ó":"o","ŏ":"o","ǒ":"o","ô":"o","ố":"o","ộ":"o","ồ":"o","ổ":"o","ỗ":"o","ö":"o","ȫ":"o","ȯ":"o","ȱ":"o","ọ":"o","ő":"o","ȍ":"o","ò":"o","ỏ":"o","ơ":"o","ớ":"o","ợ":"o","ờ":"o","ở":"o","ỡ":"o","ȏ":"o","ꝋ":"o","ꝍ":"o","ⱺ":"o","ō":"o","ṓ":"o","ṑ":"o","ǫ":"o","ǭ":"o","ø":"o","ǿ":"o","õ":"o","ṍ":"o","ṏ":"o","ȭ":"o","ƣ":"oi","ꝏ":"oo","ɛ":"e","ᶓ":"e","ɔ":"o","ᶗ":"o","ȣ":"ou","ṕ":"p","ṗ":"p","ꝓ":"p","ƥ":"p","ᵱ":"p","ᶈ":"p","ꝕ":"p","ᵽ":"p","ꝑ":"p","ꝙ":"q","ʠ":"q","ɋ":"q","ꝗ":"q","ŕ":"r","ř":"r","ŗ":"r","ṙ":"r","ṛ":"r","ṝ":"r","ȑ":"r","ɾ":"r","ᵳ":"r","ȓ":"r","ṟ":"r","ɼ":"r","ᵲ":"r","ᶉ":"r","ɍ":"r","ɽ":"r","ↄ":"c","ꜿ":"c","ɘ":"e","ɿ":"r","ś":"s","ṥ":"s","š":"s","ṧ":"s","ş":"s","ŝ":"s","ș":"s","ṡ":"s","ṣ":"s","ṩ":"s","ʂ":"s","ᵴ":"s","ᶊ":"s","ȿ":"s","ɡ":"g","ß":"ss","ᴑ":"o","ᴓ":"o","ᴝ":"u","ť":"t","ţ":"t","ṱ":"t","ț":"t","ȶ":"t","ẗ":"t","ⱦ":"t","ṫ":"t","ṭ":"t","ƭ":"t","ṯ":"t","ᵵ":"t","ƫ":"t","ʈ":"t","ŧ":"t","ᵺ":"th","ɐ":"a","ᴂ":"ae","ǝ":"e","ᵷ":"g","ɥ":"h","ʮ":"h","ʯ":"h","ᴉ":"i","ʞ":"k","ꞁ":"l","ɯ":"m","ɰ":"m","ᴔ":"oe","ɹ":"r","ɻ":"r","ɺ":"r","ⱹ":"r","ʇ":"t","ʌ":"v","ʍ":"w","ʎ":"y","ꜩ":"tz","ú":"u","ŭ":"u","ǔ":"u","û":"u","ṷ":"u","ü":"u","ǘ":"u","ǚ":"u","ǜ":"u","ǖ":"u","ṳ":"u","ụ":"u","ű":"u","ȕ":"u","ù":"u","ủ":"u","ư":"u","ứ":"u","ự":"u","ừ":"u","ử":"u","ữ":"u","ȗ":"u","ū":"u","ṻ":"u","ų":"u","ᶙ":"u","ů":"u","ũ":"u","ṹ":"u","ṵ":"u","ᵫ":"ue","ꝸ":"um","ⱴ":"v","ꝟ":"v","ṿ":"v","ʋ":"v","ᶌ":"v","ⱱ":"v","ṽ":"v","ꝡ":"vy","ẃ":"w","ŵ":"w","ẅ":"w","ẇ":"w","ẉ":"w","ẁ":"w","ⱳ":"w","ẘ":"w","ẍ":"x","ẋ":"x","ᶍ":"x","ý":"y","ŷ":"y","ÿ":"y","ẏ":"y","ỵ":"y","ỳ":"y","ƴ":"y","ỷ":"y","ỿ":"y","ȳ":"y","ẙ":"y","ɏ":"y","ỹ":"y","ź":"z","ž":"z","ẑ":"z","ʑ":"z","ⱬ":"z","ż":"z","ẓ":"z","ȥ":"z","ẕ":"z","ᵶ":"z","ᶎ":"z","ʐ":"z","ƶ":"z","ɀ":"z","ﬀ":"ff","ﬃ":"ffi","ﬄ":"ffl","ﬁ":"fi","ﬂ":"fl","ĳ":"ij","œ":"oe","ﬆ":"st","ₐ":"a","ₑ":"e","ᵢ":"i","ⱼ":"j","ₒ":"o","ᵣ":"r","ᵤ":"u","ᵥ":"v","ₓ":"x"}
};

String.prototype.latinise = function() {
  return this.replace(/[^A-Za-z0-9]/g, function(x) { return Latinise.map[x] || x; });
};


/***/ }),

/***/ "y/LJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__protected_tag_edit__ = __webpack_require__("qnTa");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable no-new */



var ProtectedTagEditList = function () {
  function ProtectedTagEditList() {
    _classCallCheck(this, ProtectedTagEditList);

    this.$wrap = $('.protected-tags-list');
    this.initEditForm();
  }

  _createClass(ProtectedTagEditList, [{
    key: 'initEditForm',
    value: function initEditForm() {
      this.$wrap.find('.js-protected-tag-edit-form').each(function (i, el) {
        new __WEBPACK_IMPORTED_MODULE_0__protected_tag_edit__["a" /* default */]({
          $wrap: $(el)
        });
      });
    }
  }]);

  return ProtectedTagEditList;
}();

/* harmony default export */ __webpack_exports__["a"] = (ProtectedTagEditList);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("lwLq")))

/***/ }),

/***/ "yoQO":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.1.3
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader = false;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function init (converter) {
		function api (key, value, attributes) {
			var result;
			if (typeof document === 'undefined') {
				return;
			}

			// Write

			if (arguments.length > 1) {
				attributes = extend({
					path: '/'
				}, api.defaults, attributes);

				if (typeof attributes.expires === 'number') {
					var expires = new Date();
					expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
					attributes.expires = expires;
				}

				try {
					result = JSON.stringify(value);
					if (/^[\{\[]/.test(result)) {
						value = result;
					}
				} catch (e) {}

				if (!converter.write) {
					value = encodeURIComponent(String(value))
						.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
				} else {
					value = converter.write(value, key);
				}

				key = encodeURIComponent(String(key));
				key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
				key = key.replace(/[\(\)]/g, escape);

				return (document.cookie = [
					key, '=', value,
					attributes.expires ? '; expires=' + attributes.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE
					attributes.path ? '; path=' + attributes.path : '',
					attributes.domain ? '; domain=' + attributes.domain : '',
					attributes.secure ? '; secure' : ''
				].join(''));
			}

			// Read

			if (!key) {
				result = {};
			}

			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all. Also prevents odd result when
			// calling "get()"
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var rdecode = /(%[0-9A-Z]{2})+/g;
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = parts[0].replace(rdecode, decodeURIComponent);
					cookie = converter.read ?
						converter.read(cookie, name) : converter(cookie, name) ||
						cookie.replace(rdecode, decodeURIComponent);

					if (this.json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					if (key === name) {
						result = cookie;
						break;
					}

					if (!key) {
						result[name] = cookie;
					}
				} catch (e) {}
			}

			return result;
		}

		api.set = api;
		api.get = function (key) {
			return api.call(api, key);
		};
		api.getJSON = function () {
			return api.apply({
				json: true
			}, [].slice.call(arguments));
		};
		api.defaults = {};

		api.remove = function (key, attributes) {
			api(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),

/***/ "ztjw":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable wrap-iife, func-names, space-before-function-paren, object-shorthand, comma-dangle, one-var, one-var-declaration-per-line, no-restricted-syntax, max-len, no-param-reassign */

(function (global) {
  var ProjectLabelSubscription = function () {
    function ProjectLabelSubscription(container) {
      _classCallCheck(this, ProjectLabelSubscription);

      this.$container = $(container);
      this.$buttons = this.$container.find('.js-subscribe-button');

      this.$buttons.on('click', this.toggleSubscription.bind(this));
    }

    _createClass(ProjectLabelSubscription, [{
      key: 'toggleSubscription',
      value: function toggleSubscription(event) {
        var _this = this;

        event.preventDefault();

        var $btn = $(event.currentTarget);
        var $span = $btn.find('span');
        var url = $btn.attr('data-url');
        var oldStatus = $btn.attr('data-status');

        $btn.addClass('disabled');
        $span.toggleClass('hidden');

        $.ajax({
          type: 'POST',
          url: url
        }).done(function () {
          var newStatus = void 0,
              newAction = void 0;

          if (oldStatus === 'unsubscribed') {
            newStatus = 'subscribed';
            newAction = 'Unsubscribe';
          } else {
            newStatus = 'unsubscribed';
            newAction = 'Subscribe';
          }

          $span.toggleClass('hidden');
          $btn.removeClass('disabled');

          _this.$buttons.attr('data-status', newStatus);
          _this.$buttons.find('> span').text(newAction);

          _this.$buttons.map(function (button) {
            var $button = $(button);

            if ($button.attr('data-original-title')) {
              $button.tooltip('hide').attr('data-original-title', newAction).tooltip('fixTitle');
            }

            return button;
          });
        });
      }
    }]);

    return ProjectLabelSubscription;
  }();

  global.ProjectLabelSubscription = ProjectLabelSubscription;
})(window.gl || (window.gl = {}));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ }),

/***/ "zv24":
/***/ (function(module, exports) {

// TODO: remove this

// eslint-disable-next-line no-extend-native
Array.prototype.first = function first() {
  return this[0];
};

// eslint-disable-next-line no-extend-native
Array.prototype.last = function last() {
  return this[this.length - 1];
};

/***/ }),

/***/ "zzV7":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable func-names, space-before-function-paren, prefer-arrow-callback */

(function () {
  window.addEventListener('beforeunload', function () {
    $('.tanuki-logo').addClass('animate');
  });
}).call(window);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("lwLq")))

/***/ })

},["eitI"]);


// WEBPACK FOOTER //
// main.b567b4eb3cc48cff916c.bundle.js